/* eslint-disable */
import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A (potentially binary) string encoded using base64. */
  Base64String: { input: string; output: string; }
  /**
   * Represents non-fractional signed whole numeric values. Since the value may
   * exceed the size of a 32-bit integer, it's encoded as a string.
   */
  BigInt: { input: string; output: string; }
  /**
   * A custom property value can be either a string or an array of strings. All
   * property types support only a single string value, except for the multi-select
   * type, which supports only a string array.
   */
  CustomPropertyValue: { input: string; output: string; }
  /** An ISO-8601 encoded date string. */
  Date: { input: string; output: string; }
  /** An ISO-8601 encoded UTC date string. */
  DateTime: { input: string; output: string; }
  /** A Git object ID. */
  GitObjectID: { input: string; output: string; }
  /** A fully qualified reference name (e.g. `refs/heads/master`). */
  GitRefname: { input: string; output: string; }
  /** Git SSH string */
  GitSSHRemote: { input: string; output: string; }
  /** An ISO-8601 encoded date string. Unlike the DateTime type, GitTimestamp is not converted in UTC. */
  GitTimestamp: { input: string; output: string; }
  /** A string containing HTML code. */
  HTML: { input: string; output: string; }
  /** An ISO-8601 encoded UTC date string with millisecond precision. */
  PreciseDateTime: { input: string; output: string; }
  /** An RFC 3986, RFC 3987, and RFC 6570 (level 4) compliant URI string. */
  URI: { input: string; output: string; }
  /** A valid x509 certificate string */
  X509Certificate: { input: string; output: string; }
};

/** Autogenerated input type of AbortQueuedMigrations */
export type AbortQueuedMigrationsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the organization that is running the migrations. */
  ownerId: Scalars['ID']['input'];
};

/** Autogenerated return type of AbortQueuedMigrations. */
export type AbortQueuedMigrationsPayload = {
  __typename?: 'AbortQueuedMigrationsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Did the operation succeed? */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of AbortRepositoryMigration */
export type AbortRepositoryMigrationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the migration to be aborted. */
  migrationId: Scalars['ID']['input'];
};

/** Autogenerated return type of AbortRepositoryMigration. */
export type AbortRepositoryMigrationPayload = {
  __typename?: 'AbortRepositoryMigrationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Did the operation succeed? */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of AcceptEnterpriseAdministratorInvitation */
export type AcceptEnterpriseAdministratorInvitationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the invitation being accepted */
  invitationId: Scalars['ID']['input'];
};

/** Autogenerated return type of AcceptEnterpriseAdministratorInvitation. */
export type AcceptEnterpriseAdministratorInvitationPayload = {
  __typename?: 'AcceptEnterpriseAdministratorInvitationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The invitation that was accepted. */
  invitation?: Maybe<EnterpriseAdministratorInvitation>;
  /** A message confirming the result of accepting an administrator invitation. */
  message?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of AcceptEnterpriseMemberInvitation */
export type AcceptEnterpriseMemberInvitationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the invitation being accepted */
  invitationId: Scalars['ID']['input'];
};

/** Autogenerated return type of AcceptEnterpriseMemberInvitation. */
export type AcceptEnterpriseMemberInvitationPayload = {
  __typename?: 'AcceptEnterpriseMemberInvitationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The invitation that was accepted. */
  invitation?: Maybe<EnterpriseMemberInvitation>;
  /** A message confirming the result of accepting an unaffiliated member invitation. */
  message?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of AcceptTopicSuggestion */
export type AcceptTopicSuggestionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * The name of the suggested topic.
   *
   * **Upcoming Change on 2024-04-01 UTC**
   * **Description:** `name` will be removed.
   * **Reason:** Suggested topics are no longer supported
   */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * The Node ID of the repository.
   *
   * **Upcoming Change on 2024-04-01 UTC**
   * **Description:** `repositoryId` will be removed.
   * **Reason:** Suggested topics are no longer supported
   */
  repositoryId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of AcceptTopicSuggestion. */
export type AcceptTopicSuggestionPayload = {
  __typename?: 'AcceptTopicSuggestionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /**
   * The accepted topic.
   * @deprecated Suggested topics are no longer supported Removal on 2024-04-01 UTC.
   */
  topic?: Maybe<Topic>;
};

/** Autogenerated input type of AccessUserNamespaceRepository */
export type AccessUserNamespaceRepositoryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the enterprise owning the user namespace repository. */
  enterpriseId: Scalars['ID']['input'];
  /** The ID of the user namespace repository to access. */
  repositoryId: Scalars['ID']['input'];
};

/** Autogenerated return type of AccessUserNamespaceRepository. */
export type AccessUserNamespaceRepositoryPayload = {
  __typename?: 'AccessUserNamespaceRepositoryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The time that repository access expires at */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** The repository that is temporarily accessible. */
  repository?: Maybe<Repository>;
};

/** Represents an object which can take actions on GitHub. Typically a User or Bot. */
export type Actor = {
  /** A URL pointing to the actor's public avatar. */
  avatarUrl: Scalars['URI']['output'];
  /** The username of the actor. */
  login: Scalars['String']['output'];
  /** The HTTP path for this actor. */
  resourcePath: Scalars['URI']['output'];
  /** The HTTP URL for this actor. */
  url: Scalars['URI']['output'];
};


/** Represents an object which can take actions on GitHub. Typically a User or Bot. */
export type ActorAvatarUrlArgs = {
  size?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for Actor. */
export type ActorConnection = {
  __typename?: 'ActorConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ActorEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Actor>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ActorEdge = {
  __typename?: 'ActorEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Actor>;
};

/** Location information for an actor */
export type ActorLocation = {
  __typename?: 'ActorLocation';
  /** City */
  city?: Maybe<Scalars['String']['output']>;
  /** Country name */
  country?: Maybe<Scalars['String']['output']>;
  /** Country code */
  countryCode?: Maybe<Scalars['String']['output']>;
  /** Region name */
  region?: Maybe<Scalars['String']['output']>;
  /** Region or state code */
  regionCode?: Maybe<Scalars['String']['output']>;
};

/** The actor's type. */
export enum ActorType {
  /** Indicates a team actor. */
  Team = 'TEAM',
  /** Indicates a user actor. */
  User = 'USER'
}

/** Autogenerated input type of AddAssigneesToAssignable */
export type AddAssigneesToAssignableInput = {
  /** Configuration for assigning Copilot to this issue. */
  agentAssignment?: InputMaybe<AgentAssignmentInput>;
  /** The id of the assignable object to add assignees to. */
  assignableId: Scalars['ID']['input'];
  /** The ids of actors (users or bots) to add as assignees. Mutually exclusive with `assignees`. */
  assigneeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * An array of actors to add as assignees, each with optional rationale or
   * suggest flag. Mutually exclusive with `assigneeIds`.
   */
  assignees?: InputMaybe<Array<AssigneeUpdateInput>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AddAssigneesToAssignable. */
export type AddAssigneesToAssignablePayload = {
  __typename?: 'AddAssigneesToAssignablePayload';
  /** The item that was assigned. */
  assignable?: Maybe<Assignable>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of AddBlockedBy */
export type AddBlockedByInput = {
  /** The ID of the issue that blocks the given issue. */
  blockingIssueId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the issue to be blocked. */
  issueId: Scalars['ID']['input'];
};

/** Autogenerated return type of AddBlockedBy. */
export type AddBlockedByPayload = {
  __typename?: 'AddBlockedByPayload';
  /** The issue that is blocking the given issue. */
  blockingIssue?: Maybe<Issue>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The issue that is blocked. */
  issue?: Maybe<Issue>;
};

/** Autogenerated input type of AddCloseIssueReferences */
export type AddCloseIssueReferencesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the issue to add closing references to. */
  issueId: Scalars['ID']['input'];
  /** IDs of the pull requests to link as closing references. Limit: 10. */
  pullRequestIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of AddCloseIssueReferences. */
export type AddCloseIssueReferencesPayload = {
  __typename?: 'AddCloseIssueReferencesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The issue the closing references were added to. */
  issue?: Maybe<Issue>;
};

/** Autogenerated input type of AddComment */
export type AddCommentInput = {
  /** The contents of the comment. */
  body: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Node ID of the subject to modify. */
  subjectId: Scalars['ID']['input'];
};

/** Autogenerated return type of AddComment. */
export type AddCommentPayload = {
  __typename?: 'AddCommentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The edge from the subject's comment connection. */
  commentEdge?: Maybe<IssueCommentEdge>;
  /** The subject */
  subject?: Maybe<Node>;
  /** The edge from the subject's timeline connection. */
  timelineEdge?: Maybe<IssueTimelineItemEdge>;
};

/** Autogenerated input type of AddDiscussionComment */
export type AddDiscussionCommentInput = {
  /** The contents of the comment. */
  body: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Node ID of the discussion to comment on. */
  discussionId: Scalars['ID']['input'];
  /** The Node ID of the discussion comment within this discussion to reply to. */
  replyToId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of AddDiscussionComment. */
export type AddDiscussionCommentPayload = {
  __typename?: 'AddDiscussionCommentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The newly created discussion comment. */
  comment?: Maybe<DiscussionComment>;
};

/** Autogenerated input type of AddDiscussionPollVote */
export type AddDiscussionPollVoteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Node ID of the discussion poll option to vote for. */
  pollOptionId: Scalars['ID']['input'];
};

/** Autogenerated return type of AddDiscussionPollVote. */
export type AddDiscussionPollVotePayload = {
  __typename?: 'AddDiscussionPollVotePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The poll option that a vote was added to. */
  pollOption?: Maybe<DiscussionPollOption>;
};

/** Autogenerated input type of AddEnterpriseOrganizationMember */
export type AddEnterpriseOrganizationMemberInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the enterprise which owns the organization. */
  enterpriseId: Scalars['ID']['input'];
  /** The ID of the organization the users will be added to. */
  organizationId: Scalars['ID']['input'];
  /** The role to assign the users in the organization */
  role?: InputMaybe<OrganizationMemberRole>;
  /** The IDs of the enterprise members to add. */
  userIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of AddEnterpriseOrganizationMember. */
export type AddEnterpriseOrganizationMemberPayload = {
  __typename?: 'AddEnterpriseOrganizationMemberPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The users who were added to the organization. */
  users?: Maybe<Array<User>>;
};

/** Autogenerated input type of AddEnterpriseSupportEntitlement */
export type AddEnterpriseSupportEntitlementInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the Enterprise which the admin belongs to. */
  enterpriseId: Scalars['ID']['input'];
  /** The login of a member who will receive the support entitlement. */
  login: Scalars['String']['input'];
};

/** Autogenerated return type of AddEnterpriseSupportEntitlement. */
export type AddEnterpriseSupportEntitlementPayload = {
  __typename?: 'AddEnterpriseSupportEntitlementPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** A message confirming the result of adding the support entitlement. */
  message?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of AddLabelsToLabelable */
export type AddLabelsToLabelableInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ids of the labels to add. */
  labelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The id of the labelable object to add labels to. */
  labelableId: Scalars['ID']['input'];
  /**
   * The labels to add, each with optional `rationale` or a `suggest` flag that
   * stores the addition as a pending suggestion. Mutually exclusive with `labelIds`.
   */
  labels?: InputMaybe<Array<LabelUpdateInput>>;
};

/** Autogenerated return type of AddLabelsToLabelable. */
export type AddLabelsToLabelablePayload = {
  __typename?: 'AddLabelsToLabelablePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The item that was labeled. */
  labelable?: Maybe<Labelable>;
};

/** Autogenerated input type of AddProjectCard */
export type AddProjectCardInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The content of the card. Must be a member of the ProjectCardItem union */
  contentId?: InputMaybe<Scalars['ID']['input']>;
  /** The note on the card. */
  note?: InputMaybe<Scalars['String']['input']>;
  /** The Node ID of the ProjectColumn. */
  projectColumnId: Scalars['ID']['input'];
};

/** Autogenerated return type of AddProjectCard. */
export type AddProjectCardPayload = {
  __typename?: 'AddProjectCardPayload';
  /** The edge from the ProjectColumn's card connection. */
  cardEdge?: Maybe<ProjectCardEdge>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The ProjectColumn */
  projectColumn?: Maybe<ProjectColumn>;
};

/** Autogenerated input type of AddProjectColumn */
export type AddProjectColumnInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The name of the column. */
  name: Scalars['String']['input'];
  /** The Node ID of the project. */
  projectId: Scalars['ID']['input'];
};

/** Autogenerated return type of AddProjectColumn. */
export type AddProjectColumnPayload = {
  __typename?: 'AddProjectColumnPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The edge from the project's column connection. */
  columnEdge?: Maybe<ProjectColumnEdge>;
  /** The project */
  project?: Maybe<Project>;
};

/** Autogenerated input type of AddProjectV2DraftIssue */
export type AddProjectV2DraftIssueInput = {
  /** The IDs of the assignees of the draft issue. */
  assigneeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The body of the draft issue. */
  body?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the Project to add the draft issue to. */
  projectId: Scalars['ID']['input'];
  /**
   * The title of the draft issue. A project item can also be created by providing
   * the URL of an Issue or Pull Request if you have access.
   */
  title: Scalars['String']['input'];
};

/** Autogenerated return type of AddProjectV2DraftIssue. */
export type AddProjectV2DraftIssuePayload = {
  __typename?: 'AddProjectV2DraftIssuePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The draft issue added to the project. */
  projectItem?: Maybe<ProjectV2Item>;
};

/** Autogenerated input type of AddProjectV2ItemById */
export type AddProjectV2ItemByIdInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the Issue or Pull Request to add. */
  contentId: Scalars['ID']['input'];
  /** The ID of the Project to add the item to. */
  projectId: Scalars['ID']['input'];
};

/** Autogenerated return type of AddProjectV2ItemById. */
export type AddProjectV2ItemByIdPayload = {
  __typename?: 'AddProjectV2ItemByIdPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The item added to the project. */
  item?: Maybe<ProjectV2Item>;
};

/** Autogenerated input type of AddPullRequestCreationCapBypassUsers */
export type AddPullRequestCreationCapBypassUsersInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Node ID of the repository. */
  repositoryId: Scalars['ID']['input'];
  /** The Node IDs of the users to add to the bypass list. */
  userIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of AddPullRequestCreationCapBypassUsers. */
export type AddPullRequestCreationCapBypassUsersPayload = {
  __typename?: 'AddPullRequestCreationCapBypassUsersPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The repository with the updated bypass list. */
  repository?: Maybe<Repository>;
};

/** Autogenerated input type of AddPullRequestReviewComment */
export type AddPullRequestReviewCommentInput = {
  /**
   * The text of the comment. This field is required
   *
   * **Upcoming Change on 2023-10-01 UTC**
   * **Description:** `body` will be removed. use addPullRequestReviewThread or addPullRequestReviewThreadReply instead
   * **Reason:** We are deprecating the addPullRequestReviewComment mutation
   */
  body?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * The SHA of the commit to comment on.
   *
   * **Upcoming Change on 2023-10-01 UTC**
   * **Description:** `commitOID` will be removed. use addPullRequestReviewThread or addPullRequestReviewThreadReply instead
   * **Reason:** We are deprecating the addPullRequestReviewComment mutation
   */
  commitOID?: InputMaybe<Scalars['GitObjectID']['input']>;
  /**
   * The comment id to reply to.
   *
   * **Upcoming Change on 2023-10-01 UTC**
   * **Description:** `inReplyTo` will be removed. use addPullRequestReviewThread or addPullRequestReviewThreadReply instead
   * **Reason:** We are deprecating the addPullRequestReviewComment mutation
   */
  inReplyTo?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The relative path of the file to comment on.
   *
   * **Upcoming Change on 2023-10-01 UTC**
   * **Description:** `path` will be removed. use addPullRequestReviewThread or addPullRequestReviewThreadReply instead
   * **Reason:** We are deprecating the addPullRequestReviewComment mutation
   */
  path?: InputMaybe<Scalars['String']['input']>;
  /**
   * The line index in the diff to comment on.
   *
   * **Upcoming Change on 2023-10-01 UTC**
   * **Description:** `position` will be removed. use addPullRequestReviewThread or addPullRequestReviewThreadReply instead
   * **Reason:** We are deprecating the addPullRequestReviewComment mutation
   */
  position?: InputMaybe<Scalars['Int']['input']>;
  /**
   * The node ID of the pull request reviewing
   *
   * **Upcoming Change on 2023-10-01 UTC**
   * **Description:** `pullRequestId` will be removed. use
   * addPullRequestReviewThread or addPullRequestReviewThreadReply instead
   * **Reason:** We are deprecating the addPullRequestReviewComment mutation
   */
  pullRequestId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The Node ID of the review to modify.
   *
   * **Upcoming Change on 2023-10-01 UTC**
   * **Description:** `pullRequestReviewId` will be removed. use
   * addPullRequestReviewThread or addPullRequestReviewThreadReply instead
   * **Reason:** We are deprecating the addPullRequestReviewComment mutation
   */
  pullRequestReviewId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of AddPullRequestReviewComment. */
export type AddPullRequestReviewCommentPayload = {
  __typename?: 'AddPullRequestReviewCommentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The newly created comment. */
  comment?: Maybe<PullRequestReviewComment>;
  /** The edge from the review's comment connection. */
  commentEdge?: Maybe<PullRequestReviewCommentEdge>;
};

/** Autogenerated input type of AddPullRequestReview */
export type AddPullRequestReviewInput = {
  /** The contents of the review body comment. */
  body?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * The review line comments.
   *
   * **Upcoming Change on 2023-10-01 UTC**
   * **Description:** `comments` will be removed. use the `threads` argument instead
   * **Reason:** We are deprecating comment fields that use diff-relative positioning
   */
  comments?: InputMaybe<Array<InputMaybe<DraftPullRequestReviewComment>>>;
  /** The commit OID the review pertains to. */
  commitOID?: InputMaybe<Scalars['GitObjectID']['input']>;
  /** The event to perform on the pull request review. */
  event?: InputMaybe<PullRequestReviewEvent>;
  /** The Node ID of the pull request to modify. */
  pullRequestId: Scalars['ID']['input'];
  /** The review line comment threads. */
  threads?: InputMaybe<Array<InputMaybe<DraftPullRequestReviewThread>>>;
};

/** Autogenerated return type of AddPullRequestReview. */
export type AddPullRequestReviewPayload = {
  __typename?: 'AddPullRequestReviewPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The newly created pull request review. */
  pullRequestReview?: Maybe<PullRequestReview>;
  /** The edge from the pull request's review connection. */
  reviewEdge?: Maybe<PullRequestReviewEdge>;
};

/** Autogenerated input type of AddPullRequestReviewThread */
export type AddPullRequestReviewThreadInput = {
  /** Body of the thread's first comment. */
  body: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * The line of the blob to which the thread refers, required for line-level
   * threads. The end of the line range for multi-line comments.
   */
  line?: InputMaybe<Scalars['Int']['input']>;
  /** Path to the file being commented on. */
  path?: InputMaybe<Scalars['String']['input']>;
  /** The node ID of the pull request reviewing */
  pullRequestId?: InputMaybe<Scalars['ID']['input']>;
  /** The Node ID of the review to modify. */
  pullRequestReviewId?: InputMaybe<Scalars['ID']['input']>;
  /** The side of the diff on which the line resides. For multi-line comments, this is the side for the end of the line range. */
  side?: InputMaybe<DiffSide>;
  /** The first line of the range to which the comment refers. */
  startLine?: InputMaybe<Scalars['Int']['input']>;
  /** The side of the diff on which the start line resides. */
  startSide?: InputMaybe<DiffSide>;
  /** The level at which the comments in the corresponding thread are targeted, can be a diff line or a file */
  subjectType?: InputMaybe<PullRequestReviewThreadSubjectType>;
};

/** Autogenerated return type of AddPullRequestReviewThread. */
export type AddPullRequestReviewThreadPayload = {
  __typename?: 'AddPullRequestReviewThreadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The newly created thread. */
  thread?: Maybe<PullRequestReviewThread>;
};

/** Autogenerated input type of AddPullRequestReviewThreadReply */
export type AddPullRequestReviewThreadReplyInput = {
  /** The text of the reply. */
  body: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Node ID of the pending review to which the reply will belong. */
  pullRequestReviewId?: InputMaybe<Scalars['ID']['input']>;
  /** The Node ID of the thread to which this reply is being written. */
  pullRequestReviewThreadId: Scalars['ID']['input'];
};

/** Autogenerated return type of AddPullRequestReviewThreadReply. */
export type AddPullRequestReviewThreadReplyPayload = {
  __typename?: 'AddPullRequestReviewThreadReplyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The newly created reply. */
  comment?: Maybe<PullRequestReviewComment>;
};

/** Autogenerated input type of AddReaction */
export type AddReactionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The name of the emoji to react with. */
  content: ReactionContent;
  /** The Node ID of the subject to modify. */
  subjectId: Scalars['ID']['input'];
};

/** Autogenerated return type of AddReaction. */
export type AddReactionPayload = {
  __typename?: 'AddReactionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The reaction object. */
  reaction?: Maybe<Reaction>;
  /** The reaction groups for the subject. */
  reactionGroups?: Maybe<Array<ReactionGroup>>;
  /** The reactable subject. */
  subject?: Maybe<Reactable>;
};

/** Autogenerated input type of AddRelatesTo */
export type AddRelatesToInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the issue. */
  issueId: Scalars['ID']['input'];
  /** The ID of the related issue. */
  relatedIssueId: Scalars['ID']['input'];
};

/** Autogenerated return type of AddRelatesTo. */
export type AddRelatesToPayload = {
  __typename?: 'AddRelatesToPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The source issue. */
  issue?: Maybe<Issue>;
  /** The related issue. */
  relatedIssue?: Maybe<Issue>;
};

/** Autogenerated input type of AddStar */
export type AddStarInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Starrable ID to star. */
  starrableId: Scalars['ID']['input'];
};

/** Autogenerated return type of AddStar. */
export type AddStarPayload = {
  __typename?: 'AddStarPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The starrable. */
  starrable?: Maybe<Starrable>;
};

/** Autogenerated input type of AddSubIssue */
export type AddSubIssueInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the issue. */
  issueId: Scalars['ID']['input'];
  /** Option to replace parent issue if one already exists */
  replaceParent?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the sub-issue. */
  subIssueId?: InputMaybe<Scalars['ID']['input']>;
  /** The url of the sub-issue. */
  subIssueUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of AddSubIssue. */
export type AddSubIssuePayload = {
  __typename?: 'AddSubIssuePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The parent issue that the sub-issue was added to. */
  issue?: Maybe<Issue>;
  /** The sub-issue of the parent. */
  subIssue?: Maybe<Issue>;
};

/** Autogenerated input type of AddUpvote */
export type AddUpvoteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Node ID of the discussion or comment to upvote. */
  subjectId: Scalars['ID']['input'];
};

/** Autogenerated return type of AddUpvote. */
export type AddUpvotePayload = {
  __typename?: 'AddUpvotePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The votable subject. */
  subject?: Maybe<Votable>;
};

/** Autogenerated input type of AddVerifiableDomain */
export type AddVerifiableDomainInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The URL of the domain */
  domain: Scalars['URI']['input'];
  /** The ID of the owner to add the domain to */
  ownerId: Scalars['ID']['input'];
};

/** Autogenerated return type of AddVerifiableDomain. */
export type AddVerifiableDomainPayload = {
  __typename?: 'AddVerifiableDomainPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The verifiable domain that was added. */
  domain?: Maybe<VerifiableDomain>;
};

/** Represents an 'added_to_merge_queue' event on a given pull request. */
export type AddedToMergeQueueEvent = Node & {
  __typename?: 'AddedToMergeQueueEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The user who added this Pull Request to the merge queue */
  enqueuer?: Maybe<User>;
  /** The Node ID of the AddedToMergeQueueEvent object */
  id: Scalars['ID']['output'];
  /** The merge queue where this pull request was added to. */
  mergeQueue?: Maybe<MergeQueue>;
  /** PullRequest referenced by event. */
  pullRequest?: Maybe<PullRequest>;
};

/** Represents a 'added_to_project' event on a given issue or pull request. */
export type AddedToProjectEvent = Node & {
  __typename?: 'AddedToProjectEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /**
   * Identifies the primary key from the database.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** The Node ID of the AddedToProjectEvent object */
  id: Scalars['ID']['output'];
  /**
   * Project referenced by event.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  project?: Maybe<Project>;
  /**
   * Project card referenced by this project event.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  projectCard?: Maybe<ProjectCard>;
  /**
   * Column name referenced by this project event.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  projectColumnName: Scalars['String']['output'];
};

/** Represents a 'added_to_project_v2' event on a given issue or pull request. */
export type AddedToProjectV2Event = Node & ProjectV2Event & {
  __typename?: 'AddedToProjectV2Event';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The Node ID of the AddedToProjectV2Event object */
  id: Scalars['ID']['output'];
  /** Project referenced by event. */
  project?: Maybe<ProjectV2>;
  /** Did this event result from workflow automation? */
  wasAutomated: Scalars['Boolean']['output'];
};

/** Represents an 'added_to_stack' event on a given pull request. */
export type AddedToStackEvent = Node & {
  __typename?: 'AddedToStackEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The Node ID of the AddedToStackEvent object */
  id: Scalars['ID']['output'];
  /** Pull request added to the stack. */
  pullRequest?: Maybe<PullRequest>;
  /** Database ID of the stack. */
  stackId?: Maybe<Scalars['BigInt']['output']>;
  /** Number of the stack in its repository. */
  stackNumber?: Maybe<Scalars['Int']['output']>;
};

/** Represents configuration for assigning Copilot to an issue (public variant) */
export type AgentAssignmentInput = {
  /** The base ref/branch for the repository. Defaults to the default branch if not provided. */
  baseRef?: InputMaybe<Scalars['String']['input']>;
  /** Custom agent for Copilot. */
  customAgent?: InputMaybe<Scalars['String']['input']>;
  /** Custom instructions for Copilot. */
  customInstructions?: InputMaybe<Scalars['String']['input']>;
  /** The Node ID of the target repository where Copilot should work. Defaults to the issue's repository if not provided. */
  targetRepositoryId?: InputMaybe<Scalars['ID']['input']>;
};

/** Copilot Agentic fields in context of the current viewer. */
export type Agentic = {
  /** Channel value for subscribing to live updates for session creations. */
  viewerCopilotAgentCreatesChannel?: Maybe<Scalars['String']['output']>;
  /** Channel value for subscribing to live updates for session log updates. */
  viewerCopilotAgentLogUpdatesChannel?: Maybe<Scalars['String']['output']>;
  /** Channel value for subscribing to live updates for task updates. */
  viewerCopilotAgentTaskUpdatesChannel?: Maybe<Scalars['String']['output']>;
  /** Channel value for subscribing to live updates for session updates. */
  viewerCopilotAgentUpdatesChannel?: Maybe<Scalars['String']['output']>;
};

/** An announcement banner for an enterprise or organization. */
export type AnnouncementBanner = {
  __typename?: 'AnnouncementBanner';
  /** The date the announcement was created */
  createdAt: Scalars['DateTime']['output'];
  /** The expiration date of the announcement, if any */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** Whether the announcement can be dismissed by the user */
  isUserDismissible: Scalars['Boolean']['output'];
  /** The text of the announcement */
  message?: Maybe<Scalars['String']['output']>;
};

/** A GitHub App. */
export type App = Node & {
  __typename?: 'App';
  /** The client ID of the app. */
  clientId?: Maybe<Scalars['String']['output']>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Identifies the primary key from the database. */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** The description of the app. */
  description?: Maybe<Scalars['String']['output']>;
  /** The Node ID of the App object */
  id: Scalars['ID']['output'];
  /** The IP addresses of the app. */
  ipAllowListEntries: IpAllowListEntryConnection;
  /** The hex color code, without the leading '#', for the logo background. */
  logoBackgroundColor: Scalars['String']['output'];
  /** A URL pointing to the app's logo. */
  logoUrl: Scalars['URI']['output'];
  /** The name of the app. */
  name: Scalars['String']['output'];
  /** A slug based on the name of the app for use in URLs. */
  slug: Scalars['String']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The URL to the app's homepage. */
  url: Scalars['URI']['output'];
};


/** A GitHub App. */
export type AppIpAllowListEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<IpAllowListEntryOrder>;
};


/** A GitHub App. */
export type AppLogoUrlArgs = {
  size?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of ApplyPendingIssueSuggestions */
export type ApplyPendingIssueSuggestionsInput = {
  /** The ID of the actor whose suggestions to apply. */
  actorId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the issue the suggestions apply to. */
  issueId: Scalars['ID']['input'];
  /** The pending suggestions to apply. */
  suggestions: Array<PendingIssueSuggestionRef>;
};

/** Autogenerated return type of ApplyPendingIssueSuggestions. */
export type ApplyPendingIssueSuggestionsPayload = {
  __typename?: 'ApplyPendingIssueSuggestionsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated issue. */
  issue?: Maybe<Issue>;
};

/** Autogenerated input type of ApproveDeployments */
export type ApproveDeploymentsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Optional comment for approving deployments */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** The ids of environments to reject deployments */
  environmentIds: Array<Scalars['ID']['input']>;
  /** The node ID of the workflow run containing the pending deployments. */
  workflowRunId: Scalars['ID']['input'];
};

/** Autogenerated return type of ApproveDeployments. */
export type ApproveDeploymentsPayload = {
  __typename?: 'ApproveDeploymentsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The affected deployments. */
  deployments?: Maybe<Array<Deployment>>;
};

/** Autogenerated input type of ApproveVerifiableDomain */
export type ApproveVerifiableDomainInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the verifiable domain to approve. */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of ApproveVerifiableDomain. */
export type ApproveVerifiableDomainPayload = {
  __typename?: 'ApproveVerifiableDomainPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The verifiable domain that was approved. */
  domain?: Maybe<VerifiableDomain>;
};

/** Autogenerated input type of ArchiveProjectV2Item */
export type ArchiveProjectV2ItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the ProjectV2Item to archive. */
  itemId: Scalars['ID']['input'];
  /** The ID of the Project to archive the item from. */
  projectId: Scalars['ID']['input'];
};

/** Autogenerated return type of ArchiveProjectV2Item. */
export type ArchiveProjectV2ItemPayload = {
  __typename?: 'ArchiveProjectV2ItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The item archived from the project. */
  item?: Maybe<ProjectV2Item>;
};

/** Autogenerated input type of ArchivePullRequest */
export type ArchivePullRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Node ID of the pull request to archive. */
  pullRequestId: Scalars['ID']['input'];
};

/** Autogenerated return type of ArchivePullRequest. */
export type ArchivePullRequestPayload = {
  __typename?: 'ArchivePullRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The pull request that was archived. */
  pullRequest?: Maybe<PullRequest>;
};

/** Autogenerated input type of ArchiveRepository */
export type ArchiveRepositoryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the repository to mark as archived. */
  repositoryId: Scalars['ID']['input'];
};

/** Autogenerated return type of ArchiveRepository. */
export type ArchiveRepositoryPayload = {
  __typename?: 'ArchiveRepositoryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The repository that was marked as archived. */
  repository?: Maybe<Repository>;
};

/** An object that can have users assigned to it. */
export type Assignable = {
  /** A list of actors assigned to this object. */
  assignedActors: AssigneeConnection;
  /** A list of Users assigned to this object. */
  assignees: UserConnection;
  /** A list of suggested actors to assign to this object */
  suggestedActors: AssigneeConnection;
  /** Indicates if the viewer can edit assignees for this object. */
  viewerCanAssign: Scalars['Boolean']['output'];
};


/** An object that can have users assigned to it. */
export type AssignableAssignedActorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** An object that can have users assigned to it. */
export type AssignableAssigneesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** An object that can have users assigned to it. */
export type AssignableSuggestedActorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};

/** Represents an 'assigned' event on any assignable object. */
export type AssignedEvent = Node & {
  __typename?: 'AssignedEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the assignable associated with the event. */
  assignable: Assignable;
  /** Identifies the user or mannequin that was assigned. */
  assignee?: Maybe<Assignee>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The Node ID of the AssignedEvent object */
  id: Scalars['ID']['output'];
  /** The intent behind the agent's action, including rationale and confidence. */
  intent?: Maybe<IssueUpdateIntent>;
  /**
   * Identifies the user who was assigned.
   * @deprecated Assignees can now be mannequins. Use the `assignee` field instead. Removal on 2020-01-01 UTC.
   */
  user?: Maybe<User>;
};

/** Types that can be assigned to issues. */
export type Assignee = Bot | Mannequin | Organization | User;

/** The connection type for Assignee. */
export type AssigneeConnection = {
  __typename?: 'AssigneeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<AssigneeEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Assignee>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type AssigneeEdge = {
  __typename?: 'AssigneeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Assignee>;
};

/** Specifies an actor (user or bot) to assign to an issue, with optional metadata such as a rationale. */
export type AssigneeUpdateInput = {
  /** The ID of the actor (user or bot) to assign. */
  actorId: Scalars['ID']['input'];
  /** The confidence level the agent had when selecting this value. */
  confidence?: InputMaybe<IssueEventConfidenceLevel>;
  /** Optional rationale describing why this value was selected. Max 280 characters. */
  rationale?: InputMaybe<Scalars['String']['input']>;
  /** If true, the value is stored as a pending suggestion for human review rather than being applied directly. */
  suggest?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An entry in the audit log. */
export type AuditEntry = {
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
};

/** Types that can initiate an audit log event. */
export type AuditEntryActor = Bot | Organization | User;

/** Ordering options for Audit Log connections. */
export type AuditLogOrder = {
  /** The ordering direction. */
  direction?: InputMaybe<OrderDirection>;
  /** The field to order Audit Logs by. */
  field?: InputMaybe<AuditLogOrderField>;
};

/** Properties by which Audit Log connections can be ordered. */
export enum AuditLogOrderField {
  /** Order audit log entries by timestamp */
  CreatedAt = 'CREATED_AT'
}

/** Represents a 'auto_merge_disabled' event on a given pull request. */
export type AutoMergeDisabledEvent = Node & {
  __typename?: 'AutoMergeDisabledEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The user who disabled auto-merge for this Pull Request */
  disabler?: Maybe<User>;
  /** The Node ID of the AutoMergeDisabledEvent object */
  id: Scalars['ID']['output'];
  /** PullRequest referenced by event */
  pullRequest?: Maybe<PullRequest>;
  /** The reason auto-merge was disabled */
  reason?: Maybe<Scalars['String']['output']>;
  /** The reason_code relating to why auto-merge was disabled */
  reasonCode?: Maybe<Scalars['String']['output']>;
};

/** Represents a 'auto_merge_enabled' event on a given pull request. */
export type AutoMergeEnabledEvent = Node & {
  __typename?: 'AutoMergeEnabledEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The user who enabled auto-merge for this Pull Request */
  enabler?: Maybe<User>;
  /** The Node ID of the AutoMergeEnabledEvent object */
  id: Scalars['ID']['output'];
  /** PullRequest referenced by event. */
  pullRequest?: Maybe<PullRequest>;
};

/** Represents an auto-merge request for a pull request */
export type AutoMergeRequest = {
  __typename?: 'AutoMergeRequest';
  /** The email address of the author of this auto-merge request. */
  authorEmail?: Maybe<Scalars['String']['output']>;
  /**
   * The commit message of the auto-merge request. If a merge queue is required by
   * the base branch, this value will be set by the merge queue when merging.
   */
  commitBody?: Maybe<Scalars['String']['output']>;
  /**
   * The commit title of the auto-merge request. If a merge queue is required by
   * the base branch, this value will be set by the merge queue when merging
   */
  commitHeadline?: Maybe<Scalars['String']['output']>;
  /** When was this auto-merge request was enabled. */
  enabledAt?: Maybe<Scalars['DateTime']['output']>;
  /** The actor who created the auto-merge request. */
  enabledBy?: Maybe<Actor>;
  /**
   * The merge method of the auto-merge request. If a merge queue is required by
   * the base branch, this value will be set by the merge queue when merging.
   */
  mergeMethod: PullRequestMergeMethod;
  /** The pull request that this auto-merge request is set against. */
  pullRequest: PullRequest;
};

/** Represents a 'auto_rebase_enabled' event on a given pull request. */
export type AutoRebaseEnabledEvent = Node & {
  __typename?: 'AutoRebaseEnabledEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The user who enabled auto-merge (rebase) for this Pull Request */
  enabler?: Maybe<User>;
  /** The Node ID of the AutoRebaseEnabledEvent object */
  id: Scalars['ID']['output'];
  /** PullRequest referenced by event. */
  pullRequest?: Maybe<PullRequest>;
};

/** Represents a 'auto_squash_enabled' event on a given pull request. */
export type AutoSquashEnabledEvent = Node & {
  __typename?: 'AutoSquashEnabledEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The user who enabled auto-merge (squash) for this Pull Request */
  enabler?: Maybe<User>;
  /** The Node ID of the AutoSquashEnabledEvent object */
  id: Scalars['ID']['output'];
  /** PullRequest referenced by event. */
  pullRequest?: Maybe<PullRequest>;
};

/** Represents a 'automatic_base_change_failed' event on a given pull request. */
export type AutomaticBaseChangeFailedEvent = Node & {
  __typename?: 'AutomaticBaseChangeFailedEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The Node ID of the AutomaticBaseChangeFailedEvent object */
  id: Scalars['ID']['output'];
  /** The new base for this PR */
  newBase: Scalars['String']['output'];
  /** The old base for this PR */
  oldBase: Scalars['String']['output'];
  /** PullRequest referenced by event. */
  pullRequest: PullRequest;
};

/** Represents a 'automatic_base_change_succeeded' event on a given pull request. */
export type AutomaticBaseChangeSucceededEvent = Node & {
  __typename?: 'AutomaticBaseChangeSucceededEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The Node ID of the AutomaticBaseChangeSucceededEvent object */
  id: Scalars['ID']['output'];
  /** The new base for this PR */
  newBase: Scalars['String']['output'];
  /** The old base for this PR */
  oldBase: Scalars['String']['output'];
  /** PullRequest referenced by event. */
  pullRequest: PullRequest;
};

/** Represents a 'base_ref_changed' event on a given issue or pull request. */
export type BaseRefChangedEvent = Node & {
  __typename?: 'BaseRefChangedEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Identifies the name of the base ref for the pull request after it was changed. */
  currentRefName: Scalars['String']['output'];
  /** Identifies the primary key from the database. */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** The Node ID of the BaseRefChangedEvent object */
  id: Scalars['ID']['output'];
  /** Identifies the name of the base ref for the pull request before it was changed. */
  previousRefName: Scalars['String']['output'];
  /** PullRequest referenced by event. */
  pullRequest: PullRequest;
};

/** Represents a 'base_ref_deleted' event on a given pull request. */
export type BaseRefDeletedEvent = Node & {
  __typename?: 'BaseRefDeletedEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the name of the Ref associated with the `base_ref_deleted` event. */
  baseRefName?: Maybe<Scalars['String']['output']>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The Node ID of the BaseRefDeletedEvent object */
  id: Scalars['ID']['output'];
  /** PullRequest referenced by event. */
  pullRequest?: Maybe<PullRequest>;
};

/** Represents a 'base_ref_force_pushed' event on a given pull request. */
export type BaseRefForcePushedEvent = Node & {
  __typename?: 'BaseRefForcePushedEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the after commit SHA for the 'base_ref_force_pushed' event. */
  afterCommit?: Maybe<Commit>;
  /** Identifies the before commit SHA for the 'base_ref_force_pushed' event. */
  beforeCommit?: Maybe<Commit>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The Node ID of the BaseRefForcePushedEvent object */
  id: Scalars['ID']['output'];
  /** PullRequest referenced by event. */
  pullRequest: PullRequest;
  /** Identifies the fully qualified ref name for the 'base_ref_force_pushed' event. */
  ref?: Maybe<Ref>;
};

/** Represents a Git blame. */
export type Blame = {
  __typename?: 'Blame';
  /** The list of ranges from a Git blame. */
  ranges: Array<BlameRange>;
};

/** Represents a range of information from a Git blame. */
export type BlameRange = {
  __typename?: 'BlameRange';
  /**
   * Identifies the recency of the change, from 1 (new) to 10 (old). This is
   * calculated as a 2-quantile and determines the length of distance between the
   * median age of all the changes in the file and the recency of the current
   * range's change.
   */
  age: Scalars['Int']['output'];
  /** Identifies the line author */
  commit: Commit;
  /** The ending line for the range */
  endingLine: Scalars['Int']['output'];
  /** The starting line for the range */
  startingLine: Scalars['Int']['output'];
};

/** Represents a Git blob. */
export type Blob = GitObject & Node & {
  __typename?: 'Blob';
  /** An abbreviated version of the Git object ID */
  abbreviatedOid: Scalars['String']['output'];
  /** Byte size of Blob object */
  byteSize: Scalars['Int']['output'];
  /** The HTTP path for this Git object */
  commitResourcePath: Scalars['URI']['output'];
  /** The HTTP URL for this Git object */
  commitUrl: Scalars['URI']['output'];
  /** The Node ID of the Blob object */
  id: Scalars['ID']['output'];
  /** Indicates whether the Blob is binary or text. Returns null if unable to determine the encoding. */
  isBinary?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates whether the contents is truncated */
  isTruncated: Scalars['Boolean']['output'];
  /** The Git object ID */
  oid: Scalars['GitObjectID']['output'];
  /** The Repository the Git object belongs to */
  repository: Repository;
  /** UTF8 text data or null if the Blob is binary */
  text?: Maybe<Scalars['String']['output']>;
};

/** Represents a 'blocked_by_added' event on a given issue. */
export type BlockedByAddedEvent = Node & {
  __typename?: 'BlockedByAddedEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** The blocking issue that was added. */
  blockingIssue?: Maybe<Issue>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The Node ID of the BlockedByAddedEvent object */
  id: Scalars['ID']['output'];
};

/** Represents a 'blocked_by_removed' event on a given issue. */
export type BlockedByRemovedEvent = Node & {
  __typename?: 'BlockedByRemovedEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** The blocking issue that was removed. */
  blockingIssue?: Maybe<Issue>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The Node ID of the BlockedByRemovedEvent object */
  id: Scalars['ID']['output'];
};

/** Represents a 'blocking_added' event on a given issue. */
export type BlockingAddedEvent = Node & {
  __typename?: 'BlockingAddedEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** The blocked issue that was added. */
  blockedIssue?: Maybe<Issue>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The Node ID of the BlockingAddedEvent object */
  id: Scalars['ID']['output'];
};

/** Represents a 'blocking_removed' event on a given issue. */
export type BlockingRemovedEvent = Node & {
  __typename?: 'BlockingRemovedEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** The blocked issue that was removed. */
  blockedIssue?: Maybe<Issue>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The Node ID of the BlockingRemovedEvent object */
  id: Scalars['ID']['output'];
};

/** A special type of user which takes actions on behalf of GitHub Apps. */
export type Bot = Actor & Node & UniformResourceLocatable & {
  __typename?: 'Bot';
  /** A URL pointing to the GitHub App's public avatar. */
  avatarUrl: Scalars['URI']['output'];
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Identifies the primary key from the database. */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** The Node ID of the Bot object */
  id: Scalars['ID']['output'];
  /** The username of the actor. */
  login: Scalars['String']['output'];
  /** The HTTP path for this bot */
  resourcePath: Scalars['URI']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The HTTP URL for this bot */
  url: Scalars['URI']['output'];
};


/** A special type of user which takes actions on behalf of GitHub Apps. */
export type BotAvatarUrlArgs = {
  size?: InputMaybe<Scalars['Int']['input']>;
};

/** Types which can be actors for `BranchActorAllowance` objects. */
export type BranchActorAllowanceActor = App | Team | User;

/** Parameters to be used for the branch_name_pattern rule */
export type BranchNamePatternParameters = {
  __typename?: 'BranchNamePatternParameters';
  /** How this rule appears when configuring it. */
  name?: Maybe<Scalars['String']['output']>;
  /** If true, the rule will fail if the pattern matches. */
  negate: Scalars['Boolean']['output'];
  /** The operator to use for matching. */
  operator: Scalars['String']['output'];
  /** The pattern to match with. */
  pattern: Scalars['String']['output'];
};

/** Parameters to be used for the branch_name_pattern rule */
export type BranchNamePatternParametersInput = {
  /** How this rule appears when configuring it. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** If true, the rule will fail if the pattern matches. */
  negate?: InputMaybe<Scalars['Boolean']['input']>;
  /** The operator to use for matching. */
  operator: Scalars['String']['input'];
  /** The pattern to match with. */
  pattern: Scalars['String']['input'];
};

/** A branch protection rule. */
export type BranchProtectionRule = Node & {
  __typename?: 'BranchProtectionRule';
  /** Can this branch be deleted. */
  allowsDeletions: Scalars['Boolean']['output'];
  /** Are force pushes allowed on this branch. */
  allowsForcePushes: Scalars['Boolean']['output'];
  /** Is branch creation a protected operation. */
  blocksCreations: Scalars['Boolean']['output'];
  /** A list of conflicts matching branches protection rule and other branch protection rules */
  branchProtectionRuleConflicts: BranchProtectionRuleConflictConnection;
  /** A list of actors able to force push for this branch protection rule. */
  bypassForcePushAllowances: BypassForcePushAllowanceConnection;
  /** A list of actors able to bypass PRs for this branch protection rule. */
  bypassPullRequestAllowances: BypassPullRequestAllowanceConnection;
  /** The actor who created this branch protection rule. */
  creator?: Maybe<Actor>;
  /** Identifies the primary key from the database. */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** Will new commits pushed to matching branches dismiss pull request review approvals. */
  dismissesStaleReviews: Scalars['Boolean']['output'];
  /** The Node ID of the BranchProtectionRule object */
  id: Scalars['ID']['output'];
  /** Can admins override branch protection. */
  isAdminEnforced: Scalars['Boolean']['output'];
  /**
   * Whether users can pull changes from upstream when the branch is locked. Set to
   * `true` to allow fork syncing. Set to `false` to prevent fork syncing.
   */
  lockAllowsFetchAndMerge: Scalars['Boolean']['output'];
  /** Whether to set the branch as read-only. If this is true, users will not be able to push to the branch. */
  lockBranch: Scalars['Boolean']['output'];
  /** Repository refs that are protected by this rule */
  matchingRefs: RefConnection;
  /** Identifies the protection rule pattern. */
  pattern: Scalars['String']['output'];
  /** A list push allowances for this branch protection rule. */
  pushAllowances: PushAllowanceConnection;
  /** The repository associated with this branch protection rule. */
  repository?: Maybe<Repository>;
  /** Whether the most recent push must be approved by someone other than the person who pushed it */
  requireLastPushApproval: Scalars['Boolean']['output'];
  /** Number of approving reviews required to update matching branches. */
  requiredApprovingReviewCount?: Maybe<Scalars['Int']['output']>;
  /** List of required deployment environments that must be deployed successfully to update matching branches */
  requiredDeploymentEnvironments?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** List of required status check contexts that must pass for commits to be accepted to matching branches. */
  requiredStatusCheckContexts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** List of required status checks that must pass for commits to be accepted to matching branches. */
  requiredStatusChecks?: Maybe<Array<RequiredStatusCheckDescription>>;
  /** Are approving reviews required to update matching branches. */
  requiresApprovingReviews: Scalars['Boolean']['output'];
  /** Are reviews from code owners required to update matching branches. */
  requiresCodeOwnerReviews: Scalars['Boolean']['output'];
  /** Are commits required to be signed. */
  requiresCommitSignatures: Scalars['Boolean']['output'];
  /** Are conversations required to be resolved before merging. */
  requiresConversationResolution: Scalars['Boolean']['output'];
  /** Does this branch require deployment to specific environments before merging */
  requiresDeployments: Scalars['Boolean']['output'];
  /** Are merge commits prohibited from being pushed to this branch. */
  requiresLinearHistory: Scalars['Boolean']['output'];
  /** Are status checks required to update matching branches. */
  requiresStatusChecks: Scalars['Boolean']['output'];
  /** Are branches required to be up to date before merging. */
  requiresStrictStatusChecks: Scalars['Boolean']['output'];
  /** Is pushing to matching branches restricted. */
  restrictsPushes: Scalars['Boolean']['output'];
  /** Is dismissal of pull request reviews restricted. */
  restrictsReviewDismissals: Scalars['Boolean']['output'];
  /** A list review dismissal allowances for this branch protection rule. */
  reviewDismissalAllowances: ReviewDismissalAllowanceConnection;
};


/** A branch protection rule. */
export type BranchProtectionRuleBranchProtectionRuleConflictsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A branch protection rule. */
export type BranchProtectionRuleBypassForcePushAllowancesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A branch protection rule. */
export type BranchProtectionRuleBypassPullRequestAllowancesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A branch protection rule. */
export type BranchProtectionRuleMatchingRefsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


/** A branch protection rule. */
export type BranchProtectionRulePushAllowancesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A branch protection rule. */
export type BranchProtectionRuleReviewDismissalAllowancesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** A conflict between two branch protection rules. */
export type BranchProtectionRuleConflict = {
  __typename?: 'BranchProtectionRuleConflict';
  /** Identifies the branch protection rule. */
  branchProtectionRule?: Maybe<BranchProtectionRule>;
  /** Identifies the conflicting branch protection rule. */
  conflictingBranchProtectionRule?: Maybe<BranchProtectionRule>;
  /** Identifies the branch ref that has conflicting rules */
  ref?: Maybe<Ref>;
};

/** The connection type for BranchProtectionRuleConflict. */
export type BranchProtectionRuleConflictConnection = {
  __typename?: 'BranchProtectionRuleConflictConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<BranchProtectionRuleConflictEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<BranchProtectionRuleConflict>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type BranchProtectionRuleConflictEdge = {
  __typename?: 'BranchProtectionRuleConflictEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<BranchProtectionRuleConflict>;
};

/** The connection type for BranchProtectionRule. */
export type BranchProtectionRuleConnection = {
  __typename?: 'BranchProtectionRuleConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<BranchProtectionRuleEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<BranchProtectionRule>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type BranchProtectionRuleEdge = {
  __typename?: 'BranchProtectionRuleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<BranchProtectionRule>;
};

/**
 * Information about a sponsorship to make for a user or organization with a GitHub
 * Sponsors profile, as part of sponsoring many users or organizations at once.
 */
export type BulkSponsorship = {
  /** The amount to pay to the sponsorable in US dollars. Valid values: 1-12000. */
  amount: Scalars['Int']['input'];
  /** The ID of the user or organization who is receiving the sponsorship. Required if sponsorableLogin is not given. */
  sponsorableId?: InputMaybe<Scalars['ID']['input']>;
  /** The username of the user or organization who is receiving the sponsorship. Required if sponsorableId is not given. */
  sponsorableLogin?: InputMaybe<Scalars['String']['input']>;
};

/** Types that can represent a repository ruleset bypass actor. */
export type BypassActor = App | EnterpriseTeam | Team | User;

/** A user, team, or app who has the ability to bypass a force push requirement on a protected branch. */
export type BypassForcePushAllowance = Node & {
  __typename?: 'BypassForcePushAllowance';
  /** The actor that can force push. */
  actor?: Maybe<BranchActorAllowanceActor>;
  /** Identifies the branch protection rule associated with the allowed user, team, or app. */
  branchProtectionRule?: Maybe<BranchProtectionRule>;
  /** The Node ID of the BypassForcePushAllowance object */
  id: Scalars['ID']['output'];
};

/** The connection type for BypassForcePushAllowance. */
export type BypassForcePushAllowanceConnection = {
  __typename?: 'BypassForcePushAllowanceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<BypassForcePushAllowanceEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<BypassForcePushAllowance>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type BypassForcePushAllowanceEdge = {
  __typename?: 'BypassForcePushAllowanceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<BypassForcePushAllowance>;
};

/** A user, team, or app who has the ability to bypass a pull request requirement on a protected branch. */
export type BypassPullRequestAllowance = Node & {
  __typename?: 'BypassPullRequestAllowance';
  /** The actor that can bypass. */
  actor?: Maybe<BranchActorAllowanceActor>;
  /** Identifies the branch protection rule associated with the allowed user, team, or app. */
  branchProtectionRule?: Maybe<BranchProtectionRule>;
  /** The Node ID of the BypassPullRequestAllowance object */
  id: Scalars['ID']['output'];
};

/** The connection type for BypassPullRequestAllowance. */
export type BypassPullRequestAllowanceConnection = {
  __typename?: 'BypassPullRequestAllowanceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<BypassPullRequestAllowanceEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<BypassPullRequestAllowance>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type BypassPullRequestAllowanceEdge = {
  __typename?: 'BypassPullRequestAllowanceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<BypassPullRequestAllowance>;
};

/** The Common Vulnerability Scoring System */
export type Cvss = {
  __typename?: 'CVSS';
  /** The CVSS score associated with this advisory */
  score: Scalars['Float']['output'];
  /** The CVSS vector string associated with this advisory */
  vectorString?: Maybe<Scalars['String']['output']>;
};

/** A common weakness enumeration */
export type Cwe = Node & {
  __typename?: 'CWE';
  /** The id of the CWE */
  cweId: Scalars['String']['output'];
  /** A detailed description of this CWE */
  description: Scalars['String']['output'];
  /** The Node ID of the CWE object */
  id: Scalars['ID']['output'];
  /** The name of this CWE */
  name: Scalars['String']['output'];
};

/** The connection type for CWE. */
export type CweConnection = {
  __typename?: 'CWEConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CweEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Cwe>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CweEdge = {
  __typename?: 'CWEEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Cwe>;
};

/** Autogenerated input type of CancelEnterpriseAdminInvitation */
export type CancelEnterpriseAdminInvitationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Node ID of the pending enterprise administrator invitation. */
  invitationId: Scalars['ID']['input'];
};

/** Autogenerated return type of CancelEnterpriseAdminInvitation. */
export type CancelEnterpriseAdminInvitationPayload = {
  __typename?: 'CancelEnterpriseAdminInvitationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The invitation that was canceled. */
  invitation?: Maybe<EnterpriseAdministratorInvitation>;
  /** A message confirming the result of canceling an administrator invitation. */
  message?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CancelEnterpriseMemberInvitation */
export type CancelEnterpriseMemberInvitationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Node ID of the pending enterprise member invitation. */
  invitationId: Scalars['ID']['input'];
};

/** Autogenerated return type of CancelEnterpriseMemberInvitation. */
export type CancelEnterpriseMemberInvitationPayload = {
  __typename?: 'CancelEnterpriseMemberInvitationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The invitation that was canceled. */
  invitation?: Maybe<EnterpriseMemberInvitation>;
  /** A message confirming the result of canceling an member invitation. */
  message?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CancelSponsorship */
export type CancelSponsorshipInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * The ID of the user or organization who is acting as the sponsor, paying for
   * the sponsorship. Required if sponsorLogin is not given.
   */
  sponsorId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The username of the user or organization who is acting as the sponsor, paying
   * for the sponsorship. Required if sponsorId is not given.
   */
  sponsorLogin?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the user or organization who is receiving the sponsorship. Required if sponsorableLogin is not given. */
  sponsorableId?: InputMaybe<Scalars['ID']['input']>;
  /** The username of the user or organization who is receiving the sponsorship. Required if sponsorableId is not given. */
  sponsorableLogin?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CancelSponsorship. */
export type CancelSponsorshipPayload = {
  __typename?: 'CancelSponsorshipPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The tier that was being used at the time of cancellation. */
  sponsorsTier?: Maybe<SponsorsTier>;
};

/** Autogenerated input type of ChangeUserStatus */
export type ChangeUserStatusInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The emoji to represent your status. Can either be a native Unicode emoji or an emoji name with colons, e.g., :grinning:. */
  emoji?: InputMaybe<Scalars['String']['input']>;
  /** If set, the user status will not be shown after this date. */
  expiresAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** Whether this status should indicate you are not fully available on GitHub, e.g., you are away. */
  limitedAvailability?: InputMaybe<Scalars['Boolean']['input']>;
  /** A short description of your current status. */
  message?: InputMaybe<Scalars['String']['input']>;
  /**
   * The ID of the organization whose members will be allowed to see the status. If
   * omitted, the status will be publicly visible.
   */
  organizationId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of ChangeUserStatus. */
export type ChangeUserStatusPayload = {
  __typename?: 'ChangeUserStatusPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Your updated status. */
  status?: Maybe<UserStatus>;
};

/** A single check annotation. */
export type CheckAnnotation = {
  __typename?: 'CheckAnnotation';
  /** The annotation's severity level. */
  annotationLevel?: Maybe<CheckAnnotationLevel>;
  /** The path to the file that this annotation was made on. */
  blobUrl: Scalars['URI']['output'];
  /**
   * Identifies the primary key from the database.
   * @deprecated `databaseId` will be removed because it does not support 64-bit signed integer identifiers. Use `fullDatabaseId` instead. Removal on 2027-01-01 UTC.
   */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** Identifies the primary key from the database as a BigInt. */
  fullDatabaseId?: Maybe<Scalars['BigInt']['output']>;
  /** The position of this annotation. */
  location: CheckAnnotationSpan;
  /** The annotation's message. */
  message: Scalars['String']['output'];
  /** The path that this annotation was made on. */
  path: Scalars['String']['output'];
  /** Additional information about the annotation. */
  rawDetails?: Maybe<Scalars['String']['output']>;
  /** The annotation's title */
  title?: Maybe<Scalars['String']['output']>;
};

/** The connection type for CheckAnnotation. */
export type CheckAnnotationConnection = {
  __typename?: 'CheckAnnotationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CheckAnnotationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<CheckAnnotation>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** Information from a check run analysis to specific lines of code. */
export type CheckAnnotationData = {
  /** Represents an annotation's information level */
  annotationLevel: CheckAnnotationLevel;
  /** The location of the annotation */
  location: CheckAnnotationRange;
  /** A short description of the feedback for these lines of code. */
  message: Scalars['String']['input'];
  /** The path of the file to add an annotation to. */
  path: Scalars['String']['input'];
  /** Details about this annotation. */
  rawDetails?: InputMaybe<Scalars['String']['input']>;
  /** The title that represents the annotation. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** An edge in a connection. */
export type CheckAnnotationEdge = {
  __typename?: 'CheckAnnotationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<CheckAnnotation>;
};

/** Represents an annotation's information level. */
export enum CheckAnnotationLevel {
  /** An annotation indicating an inescapable error. */
  Failure = 'FAILURE',
  /** An annotation indicating some information. */
  Notice = 'NOTICE',
  /** An annotation indicating an ignorable error. */
  Warning = 'WARNING'
}

/** A character position in a check annotation. */
export type CheckAnnotationPosition = {
  __typename?: 'CheckAnnotationPosition';
  /** Column number (1 indexed). */
  column?: Maybe<Scalars['Int']['output']>;
  /** Line number (1 indexed). */
  line: Scalars['Int']['output'];
};

/** Information from a check run analysis to specific lines of code. */
export type CheckAnnotationRange = {
  /** The ending column of the range. */
  endColumn?: InputMaybe<Scalars['Int']['input']>;
  /** The ending line of the range. */
  endLine: Scalars['Int']['input'];
  /** The starting column of the range. */
  startColumn?: InputMaybe<Scalars['Int']['input']>;
  /** The starting line of the range. */
  startLine: Scalars['Int']['input'];
};

/** An inclusive pair of positions for a check annotation. */
export type CheckAnnotationSpan = {
  __typename?: 'CheckAnnotationSpan';
  /** End position (inclusive). */
  end: CheckAnnotationPosition;
  /** Start position (inclusive). */
  start: CheckAnnotationPosition;
};

/** The possible states for a check suite or run conclusion. */
export enum CheckConclusionState {
  /** The check suite or run requires action. */
  ActionRequired = 'ACTION_REQUIRED',
  /** The check suite or run has been cancelled. */
  Cancelled = 'CANCELLED',
  /** The check suite or run has failed. */
  Failure = 'FAILURE',
  /** The check suite or run was neutral. */
  Neutral = 'NEUTRAL',
  /** The check suite or run was skipped. */
  Skipped = 'SKIPPED',
  /** The check suite or run was marked stale by GitHub. Only GitHub can use this conclusion. */
  Stale = 'STALE',
  /** The check suite or run has failed at startup. */
  StartupFailure = 'STARTUP_FAILURE',
  /** The check suite or run has succeeded. */
  Success = 'SUCCESS',
  /** The check suite or run has timed out. */
  TimedOut = 'TIMED_OUT'
}

/** A check run. */
export type CheckRun = Node & RequirableByPullRequest & UniformResourceLocatable & {
  __typename?: 'CheckRun';
  /** The check run's annotations */
  annotations?: Maybe<CheckAnnotationConnection>;
  /** The check suite that this run is a part of. */
  checkSuite: CheckSuite;
  /** Identifies the date and time when the check run was completed. */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The conclusion of the check run. */
  conclusion?: Maybe<CheckConclusionState>;
  /** Identifies the primary key from the database. */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** The corresponding deployment for this job, if any */
  deployment?: Maybe<Deployment>;
  /** The URL from which to find full details of the check run on the integrator's site. */
  detailsUrl?: Maybe<Scalars['URI']['output']>;
  /** A reference for the check run on the integrator's system. */
  externalId?: Maybe<Scalars['String']['output']>;
  /** The Node ID of the CheckRun object */
  id: Scalars['ID']['output'];
  /** Whether this is required to pass before merging for a specific pull request. */
  isRequired: Scalars['Boolean']['output'];
  /** The name of the check for this check run. */
  name: Scalars['String']['output'];
  /** Information about a pending deployment, if any, in this check run */
  pendingDeploymentRequest?: Maybe<DeploymentRequest>;
  /** The permalink to the check run summary. */
  permalink: Scalars['URI']['output'];
  /** The repository associated with this check run. */
  repository: Repository;
  /** The HTTP path for this check run. */
  resourcePath: Scalars['URI']['output'];
  /** Identifies the date and time when the check run was started. */
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The current status of the check run. */
  status: CheckStatusState;
  /** The check run's steps */
  steps?: Maybe<CheckStepConnection>;
  /** A string representing the check run's summary */
  summary?: Maybe<Scalars['String']['output']>;
  /** A string representing the check run's text */
  text?: Maybe<Scalars['String']['output']>;
  /** A string representing the check run */
  title?: Maybe<Scalars['String']['output']>;
  /** The HTTP URL for this check run. */
  url: Scalars['URI']['output'];
};


/** A check run. */
export type CheckRunAnnotationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A check run. */
export type CheckRunIsRequiredArgs = {
  pullRequestId?: InputMaybe<Scalars['ID']['input']>;
  pullRequestNumber?: InputMaybe<Scalars['Int']['input']>;
};


/** A check run. */
export type CheckRunStepsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  number?: InputMaybe<Scalars['Int']['input']>;
};

/** Possible further actions the integrator can perform. */
export type CheckRunAction = {
  /** A short explanation of what this action would do. */
  description: Scalars['String']['input'];
  /** A reference for the action on the integrator's system. */
  identifier: Scalars['String']['input'];
  /** The text to be displayed on a button in the web UI. */
  label: Scalars['String']['input'];
};

/** The connection type for CheckRun. */
export type CheckRunConnection = {
  __typename?: 'CheckRunConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CheckRunEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<CheckRun>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CheckRunEdge = {
  __typename?: 'CheckRunEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<CheckRun>;
};

/** The filters that are available when fetching check runs. */
export type CheckRunFilter = {
  /** Filters the check runs created by this application ID. */
  appId?: InputMaybe<Scalars['Int']['input']>;
  /** Filters the check runs by this name. */
  checkName?: InputMaybe<Scalars['String']['input']>;
  /** Filters the check runs by this type. */
  checkType?: InputMaybe<CheckRunType>;
  /** Filters the check runs by these conclusions. */
  conclusions?: InputMaybe<Array<CheckConclusionState>>;
  /** Filters the check runs by this status. Superceded by statuses. */
  status?: InputMaybe<CheckStatusState>;
  /** Filters the check runs by this status. Overrides status. */
  statuses?: InputMaybe<Array<CheckStatusState>>;
};

/** Descriptive details about the check run. */
export type CheckRunOutput = {
  /** The annotations that are made as part of the check run. */
  annotations?: InputMaybe<Array<CheckAnnotationData>>;
  /** Images attached to the check run output displayed in the GitHub pull request UI. */
  images?: InputMaybe<Array<CheckRunOutputImage>>;
  /** The summary of the check run (supports Commonmark). */
  summary: Scalars['String']['input'];
  /** The details of the check run (supports Commonmark). */
  text?: InputMaybe<Scalars['String']['input']>;
  /** A title to provide for this check run. */
  title: Scalars['String']['input'];
};

/** Images attached to the check run output displayed in the GitHub pull request UI. */
export type CheckRunOutputImage = {
  /** The alternative text for the image. */
  alt: Scalars['String']['input'];
  /** A short image description. */
  caption?: InputMaybe<Scalars['String']['input']>;
  /** The full URL of the image. */
  imageUrl: Scalars['URI']['input'];
};

/** The possible states of a check run in a status rollup. */
export enum CheckRunState {
  /** The check run requires action. */
  ActionRequired = 'ACTION_REQUIRED',
  /** The check run has been cancelled. */
  Cancelled = 'CANCELLED',
  /** The check run has been completed. */
  Completed = 'COMPLETED',
  /** The check run has failed. */
  Failure = 'FAILURE',
  /** The check run is in progress. */
  InProgress = 'IN_PROGRESS',
  /** The check run was neutral. */
  Neutral = 'NEUTRAL',
  /** The check run is in pending state. */
  Pending = 'PENDING',
  /** The check run has been queued. */
  Queued = 'QUEUED',
  /** The check run was skipped. */
  Skipped = 'SKIPPED',
  /** The check run was marked stale by GitHub. Only GitHub can use this conclusion. */
  Stale = 'STALE',
  /** The check run has failed at startup. */
  StartupFailure = 'STARTUP_FAILURE',
  /** The check run has succeeded. */
  Success = 'SUCCESS',
  /** The check run has timed out. */
  TimedOut = 'TIMED_OUT',
  /** The check run is in waiting state. */
  Waiting = 'WAITING'
}

/** Represents a count of the state of a check run. */
export type CheckRunStateCount = {
  __typename?: 'CheckRunStateCount';
  /** The number of check runs with this state. */
  count: Scalars['Int']['output'];
  /** The state of a check run. */
  state: CheckRunState;
};

/** The possible types of check runs. */
export enum CheckRunType {
  /** Every check run available. */
  All = 'ALL',
  /** The latest check run. */
  Latest = 'LATEST'
}

/** The possible states for a check suite or run status. */
export enum CheckStatusState {
  /** The check suite or run has been completed. */
  Completed = 'COMPLETED',
  /** The check suite or run is in progress. */
  InProgress = 'IN_PROGRESS',
  /** The check suite or run is in pending state. */
  Pending = 'PENDING',
  /** The check suite or run has been queued. */
  Queued = 'QUEUED',
  /** The check suite or run has been requested. */
  Requested = 'REQUESTED',
  /** The check suite or run is in waiting state. */
  Waiting = 'WAITING'
}

/** A single check step. */
export type CheckStep = {
  __typename?: 'CheckStep';
  /** Identifies the date and time when the check step was completed. */
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The conclusion of the check step. */
  conclusion?: Maybe<CheckConclusionState>;
  /** A reference for the check step on the integrator's system. */
  externalId?: Maybe<Scalars['String']['output']>;
  /** The step's name. */
  name: Scalars['String']['output'];
  /** The index of the step in the list of steps of the parent check run. */
  number: Scalars['Int']['output'];
  /** Number of seconds to completion. */
  secondsToCompletion?: Maybe<Scalars['Int']['output']>;
  /** Identifies the date and time when the check step was started. */
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The current status of the check step. */
  status: CheckStatusState;
};

/** The connection type for CheckStep. */
export type CheckStepConnection = {
  __typename?: 'CheckStepConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CheckStepEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<CheckStep>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CheckStepEdge = {
  __typename?: 'CheckStepEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<CheckStep>;
};

/** A check suite. */
export type CheckSuite = Node & {
  __typename?: 'CheckSuite';
  /** The GitHub App which created this check suite. */
  app?: Maybe<App>;
  /** The name of the branch for this check suite. */
  branch?: Maybe<Ref>;
  /** The check runs associated with a check suite. */
  checkRuns?: Maybe<CheckRunConnection>;
  /** The commit for this check suite */
  commit: Commit;
  /** The conclusion of this check suite. */
  conclusion?: Maybe<CheckConclusionState>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The user who triggered the check suite. */
  creator?: Maybe<User>;
  /** Identifies the primary key from the database. */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** The Node ID of the CheckSuite object */
  id: Scalars['ID']['output'];
  /** A list of open pull requests matching the check suite. */
  matchingPullRequests?: Maybe<PullRequestConnection>;
  /** The push that triggered this check suite. */
  push?: Maybe<Push>;
  /** The repository associated with this check suite. */
  repository: Repository;
  /** The HTTP path for this check suite */
  resourcePath: Scalars['URI']['output'];
  /** The status of this check suite. */
  status: CheckStatusState;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The HTTP URL for this check suite */
  url: Scalars['URI']['output'];
  /** The workflow run associated with this check suite. */
  workflowRun?: Maybe<WorkflowRun>;
};


/** A check suite. */
export type CheckSuiteCheckRunsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<CheckRunFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A check suite. */
export type CheckSuiteMatchingPullRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  baseRefName?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  headRefName?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<IssueOrder>;
  states?: InputMaybe<Array<PullRequestState>>;
};

/** The auto-trigger preferences that are available for check suites. */
export type CheckSuiteAutoTriggerPreference = {
  /** The node ID of the application that owns the check suite. */
  appId: Scalars['ID']['input'];
  /** Set to `true` to enable automatic creation of CheckSuite events upon pushes to the repository. */
  setting: Scalars['Boolean']['input'];
};

/** The connection type for CheckSuite. */
export type CheckSuiteConnection = {
  __typename?: 'CheckSuiteConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CheckSuiteEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<CheckSuite>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CheckSuiteEdge = {
  __typename?: 'CheckSuiteEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<CheckSuite>;
};

/** The filters that are available when fetching check suites. */
export type CheckSuiteFilter = {
  /** Filters the check suites created by this application ID. */
  appId?: InputMaybe<Scalars['Int']['input']>;
  /** Filters the check suites by this name. */
  checkName?: InputMaybe<Scalars['String']['input']>;
};

/** An object which can have its data claimed or claim data from another. */
export type Claimable = Mannequin | User;

/** Autogenerated input type of ClearLabelsFromLabelable */
export type ClearLabelsFromLabelableInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the labelable object to clear the labels from. */
  labelableId: Scalars['ID']['input'];
};

/** Autogenerated return type of ClearLabelsFromLabelable. */
export type ClearLabelsFromLabelablePayload = {
  __typename?: 'ClearLabelsFromLabelablePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The item that was unlabeled. */
  labelable?: Maybe<Labelable>;
};

/** Autogenerated input type of ClearProjectV2ItemFieldValue */
export type ClearProjectV2ItemFieldValueInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the field to be cleared. */
  fieldId: Scalars['ID']['input'];
  /** The ID of the item to be cleared. */
  itemId: Scalars['ID']['input'];
  /** The ID of the Project. */
  projectId: Scalars['ID']['input'];
};

/** Autogenerated return type of ClearProjectV2ItemFieldValue. */
export type ClearProjectV2ItemFieldValuePayload = {
  __typename?: 'ClearProjectV2ItemFieldValuePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated item. */
  projectV2Item?: Maybe<ProjectV2Item>;
};

/** Autogenerated input type of CloneProject */
export type CloneProjectInput = {
  /** The description of the project. */
  body?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Whether or not to clone the source project's workflows. */
  includeWorkflows: Scalars['Boolean']['input'];
  /** The name of the project. */
  name: Scalars['String']['input'];
  /** The visibility of the project, defaults to false (private). */
  public?: InputMaybe<Scalars['Boolean']['input']>;
  /** The source project to clone. */
  sourceId: Scalars['ID']['input'];
  /** The owner ID to create the project under. */
  targetOwnerId: Scalars['ID']['input'];
};

/** Autogenerated return type of CloneProject. */
export type CloneProjectPayload = {
  __typename?: 'CloneProjectPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The id of the JobStatus for populating cloned fields. */
  jobStatusId?: Maybe<Scalars['String']['output']>;
  /** The new cloned project. */
  project?: Maybe<Project>;
};

/** Autogenerated input type of CloneTemplateRepository */
export type CloneTemplateRepositoryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** A short description of the new repository. */
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * Whether to copy all branches from the template to the new repository. Defaults
   * to copying only the default branch of the template.
   */
  includeAllBranches?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the new repository. */
  name: Scalars['String']['input'];
  /** The ID of the owner for the new repository. */
  ownerId: Scalars['ID']['input'];
  /** The Node ID of the template repository. */
  repositoryId: Scalars['ID']['input'];
  /** Indicates the repository's visibility level. */
  visibility: RepositoryVisibility;
};

/** Autogenerated return type of CloneTemplateRepository. */
export type CloneTemplateRepositoryPayload = {
  __typename?: 'CloneTemplateRepositoryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The new repository. */
  repository?: Maybe<Repository>;
};

/** An object that can be closed */
export type Closable = {
  /** Indicates if the object is closed (definition of closed may depend on type) */
  closed: Scalars['Boolean']['output'];
  /** Identifies the date and time when the object was closed. */
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Indicates if the object can be closed by the viewer. */
  viewerCanClose: Scalars['Boolean']['output'];
  /** Indicates if the object can be reopened by the viewer. */
  viewerCanReopen: Scalars['Boolean']['output'];
};

/** Autogenerated input type of CloseDiscussion */
export type CloseDiscussionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the discussion to be closed. */
  discussionId: Scalars['ID']['input'];
  /** The reason why the discussion is being closed. */
  reason?: InputMaybe<DiscussionCloseReason>;
};

/** Autogenerated return type of CloseDiscussion. */
export type CloseDiscussionPayload = {
  __typename?: 'CloseDiscussionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The discussion that was closed. */
  discussion?: Maybe<Discussion>;
};

/** Autogenerated input type of CloseIssue */
export type CloseIssueInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The confidence level the agent had when suggesting this close. Only meaningful when isSuggestion is true. */
  confidence?: InputMaybe<IssueEventConfidenceLevel>;
  /** ID of the issue that this is a duplicate of. */
  duplicateIssueId?: InputMaybe<Scalars['ID']['input']>;
  /** If true, the close action is stored as a pending suggestion for human review rather than being applied directly. */
  isSuggestion?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID of the issue to be closed. */
  issueId: Scalars['ID']['input'];
  /** Optional rationale describing why the issue should be closed. Max 280 characters. */
  rationale?: InputMaybe<Scalars['String']['input']>;
  /** The reason the issue is to be closed. */
  stateReason?: InputMaybe<IssueClosedStateReason>;
};

/** Autogenerated return type of CloseIssue. */
export type CloseIssuePayload = {
  __typename?: 'CloseIssuePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The issue that was closed. */
  issue?: Maybe<Issue>;
};

/** Autogenerated input type of ClosePullRequest */
export type ClosePullRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the pull request to be closed. */
  pullRequestId: Scalars['ID']['input'];
};

/** Autogenerated return type of ClosePullRequest. */
export type ClosePullRequestPayload = {
  __typename?: 'ClosePullRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The pull request that was closed. */
  pullRequest?: Maybe<PullRequest>;
};

/** Represents a 'closed' event on any `Closable`. */
export type ClosedEvent = Node & UniformResourceLocatable & {
  __typename?: 'ClosedEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Object that was closed. */
  closable: Closable;
  /** Object which triggered the creation of this event. */
  closer?: Maybe<Closer>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The issue or pull request that this issue was marked as a duplicate of. */
  duplicateOf?: Maybe<IssueOrPullRequest>;
  /** The Node ID of the ClosedEvent object */
  id: Scalars['ID']['output'];
  /** The intent behind the agent's action, including rationale and confidence. */
  intent?: Maybe<IssueUpdateIntent>;
  /** The HTTP path for this closed event. */
  resourcePath: Scalars['URI']['output'];
  /** The reason the issue state was changed to closed. */
  stateReason?: Maybe<IssueStateReason>;
  /** The HTTP URL for this closed event. */
  url: Scalars['URI']['output'];
};

/** The object which triggered a `ClosedEvent`. */
export type Closer = Commit | ProjectV2 | PullRequest;

/**
 * Enforce minimum line coverage thresholds on pull requests. This rule evaluates
 * uploaded coverage data but does not wait for coverage uploads. To ensure
 * coverage is evaluated before merging, make each status check associated with a
 * coverage upload a required status check.
 */
export type CodeCoverageParameters = {
  __typename?: 'CodeCoverageParameters';
  /**
   * The maximum percentage points that line coverage may drop relative to the
   * default branch. Pull requests that reduce line coverage by more than this
   * amount will be blocked.
   */
  maxCoverageDrop?: Maybe<Scalars['Float']['output']>;
  /**
   * The absolute minimum line coverage percentage required. Pull requests with
   * line coverage below this threshold will be blocked.
   */
  minimumCoverage?: Maybe<Scalars['Float']['output']>;
};

/**
 * Enforce minimum line coverage thresholds on pull requests. This rule evaluates
 * uploaded coverage data but does not wait for coverage uploads. To ensure
 * coverage is evaluated before merging, make each status check associated with a
 * coverage upload a required status check.
 */
export type CodeCoverageParametersInput = {
  /**
   * The maximum percentage points that line coverage may drop relative to the
   * default branch. Pull requests that reduce line coverage by more than this
   * amount will be blocked.
   */
  maxCoverageDrop?: InputMaybe<Scalars['Float']['input']>;
  /**
   * The absolute minimum line coverage percentage required. Pull requests with
   * line coverage below this threshold will be blocked.
   */
  minimumCoverage?: InputMaybe<Scalars['Float']['input']>;
};

/** The Code of Conduct for a repository */
export type CodeOfConduct = Node & {
  __typename?: 'CodeOfConduct';
  /** The body of the Code of Conduct */
  body?: Maybe<Scalars['String']['output']>;
  /** The Node ID of the CodeOfConduct object */
  id: Scalars['ID']['output'];
  /** The key for the Code of Conduct */
  key: Scalars['String']['output'];
  /** The formal name of the Code of Conduct */
  name: Scalars['String']['output'];
  /** The HTTP path for this Code of Conduct */
  resourcePath?: Maybe<Scalars['URI']['output']>;
  /** The HTTP URL for this Code of Conduct */
  url?: Maybe<Scalars['URI']['output']>;
};

/**
 * Choose which severity levels of code quality results should block pull request
 * merges. When configured, a code quality analysis must be done on the pull
 * request before the changes can be merged.
 */
export type CodeQualityParameters = {
  __typename?: 'CodeQualityParameters';
  /** The lowest severity level at which code quality reviews need to be resolved before commits can be merged. */
  severity: CodeQualitySeverity;
};

/**
 * Choose which severity levels of code quality results should block pull request
 * merges. When configured, a code quality analysis must be done on the pull
 * request before the changes can be merged.
 */
export type CodeQualityParametersInput = {
  /** The lowest severity level at which code quality reviews need to be resolved before commits can be merged. */
  severity: CodeQualitySeverity;
};

/** The lowest severity level at which code quality reviews need to be resolved before commits can be merged. */
export enum CodeQualitySeverity {
  /** All */
  All = 'ALL',
  /** Errors */
  Errors = 'ERRORS',
  /** Notes and higher */
  Notes = 'NOTES',
  /** Warnings and higher */
  Warnings = 'WARNINGS'
}

/**
 * Choose which tools must provide code scanning results before the reference is
 * updated. When configured, code scanning must be enabled and have results for
 * both the commit and the reference being updated.
 */
export type CodeScanningParameters = {
  __typename?: 'CodeScanningParameters';
  /** Tools that must provide code scanning results for this rule to pass. */
  codeScanningTools: Array<CodeScanningTool>;
};

/**
 * Choose which tools must provide code scanning results before the reference is
 * updated. When configured, code scanning must be enabled and have results for
 * both the commit and the reference being updated.
 */
export type CodeScanningParametersInput = {
  /** Tools that must provide code scanning results for this rule to pass. */
  codeScanningTools: Array<CodeScanningToolInput>;
};

/** A tool that must provide code scanning results for this rule to pass. */
export type CodeScanningTool = {
  __typename?: 'CodeScanningTool';
  /**
   * The severity level at which code scanning results that raise alerts block a
   * reference update. For more information on alert severity levels, see "[About code scanning alerts](${externalDocsUrl}/code-security/code-scanning/managing-code-scanning-alerts/about-code-scanning-alerts#about-alert-severity-and-security-severity-levels)."
   */
  alertsThreshold: Scalars['String']['output'];
  /**
   * The severity level at which code scanning results that raise security alerts
   * block a reference update. For more information on security severity levels,
   * see "[About code scanning alerts](${externalDocsUrl}/code-security/code-scanning/managing-code-scanning-alerts/about-code-scanning-alerts#about-alert-severity-and-security-severity-levels)."
   */
  securityAlertsThreshold: Scalars['String']['output'];
  /** The name of a code scanning tool */
  tool: Scalars['String']['output'];
};

/** A tool that must provide code scanning results for this rule to pass. */
export type CodeScanningToolInput = {
  /**
   * The severity level at which code scanning results that raise alerts block a
   * reference update. For more information on alert severity levels, see "[About code scanning alerts](${externalDocsUrl}/code-security/code-scanning/managing-code-scanning-alerts/about-code-scanning-alerts#about-alert-severity-and-security-severity-levels)."
   */
  alertsThreshold: Scalars['String']['input'];
  /**
   * The severity level at which code scanning results that raise security alerts
   * block a reference update. For more information on security severity levels,
   * see "[About code scanning alerts](${externalDocsUrl}/code-security/code-scanning/managing-code-scanning-alerts/about-code-scanning-alerts#about-alert-severity-and-security-severity-levels)."
   */
  securityAlertsThreshold: Scalars['String']['input'];
  /** The name of a code scanning tool */
  tool: Scalars['String']['input'];
};

/** Collaborators affiliation level with a subject. */
export enum CollaboratorAffiliation {
  /** All collaborators the authenticated user can see. */
  All = 'ALL',
  /** All collaborators with permissions to an organization-owned subject, regardless of organization membership status. */
  Direct = 'DIRECT',
  /** All outside collaborators of an organization-owned subject. */
  Outside = 'OUTSIDE'
}

/** Represents a comment. */
export type Comment = {
  /** The actor who authored the comment. */
  author?: Maybe<Actor>;
  /** Author's association with the subject of the comment. */
  authorAssociation: CommentAuthorAssociation;
  /** The body as Markdown. */
  body: Scalars['String']['output'];
  /** The body rendered to HTML. */
  bodyHTML: Scalars['HTML']['output'];
  /** The body rendered to text. */
  bodyText: Scalars['String']['output'];
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Check if this comment was created via an email reply. */
  createdViaEmail: Scalars['Boolean']['output'];
  /** The actor who edited the comment. */
  editor?: Maybe<Actor>;
  /** The Node ID of the Comment object */
  id: Scalars['ID']['output'];
  /** Check if this comment was edited and includes an edit with the creation data */
  includesCreatedEdit: Scalars['Boolean']['output'];
  /** The moment the editor made the last edit */
  lastEditedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Identifies when the comment was published at. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** A list of edits to this content. */
  userContentEdits?: Maybe<UserContentEditConnection>;
  /** Did the viewer author this comment. */
  viewerDidAuthor: Scalars['Boolean']['output'];
};


/** Represents a comment. */
export type CommentUserContentEditsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** A comment author association with repository. */
export enum CommentAuthorAssociation {
  /** Author has been invited to collaborate on the repository. */
  Collaborator = 'COLLABORATOR',
  /** Author has previously committed to the repository. */
  Contributor = 'CONTRIBUTOR',
  /** Author has not previously committed to GitHub. */
  FirstTimer = 'FIRST_TIMER',
  /** Author has not previously committed to the repository. */
  FirstTimeContributor = 'FIRST_TIME_CONTRIBUTOR',
  /** Author is a placeholder for an unclaimed user. */
  Mannequin = 'MANNEQUIN',
  /** Author is a member of the organization that owns the repository. */
  Member = 'MEMBER',
  /** Author has no association with the repository. */
  None = 'NONE',
  /** Author is the owner of the repository. */
  Owner = 'OWNER'
}

/** The possible errors that will prevent a user from updating a comment. */
export enum CommentCannotUpdateReason {
  /** Unable to create comment because repository is archived. */
  Archived = 'ARCHIVED',
  /** You cannot update this comment */
  Denied = 'DENIED',
  /** You must be the author or have write access to this repository to update this comment. */
  InsufficientAccess = 'INSUFFICIENT_ACCESS',
  /** Unable to create comment because issue is locked. */
  Locked = 'LOCKED',
  /** You must be logged in to update this comment. */
  LoginRequired = 'LOGIN_REQUIRED',
  /** Repository is under maintenance. */
  Maintenance = 'MAINTENANCE',
  /** At least one email address must be verified to update this comment. */
  VerifiedEmailRequired = 'VERIFIED_EMAIL_REQUIRED'
}

/** Represents a 'comment_deleted' event on a given issue or pull request. */
export type CommentDeletedEvent = Node & {
  __typename?: 'CommentDeletedEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Identifies the primary key from the database. */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** The user who authored the deleted comment. */
  deletedCommentAuthor?: Maybe<Actor>;
  /** The Node ID of the CommentDeletedEvent object */
  id: Scalars['ID']['output'];
};

/** Represents a Git commit. */
export type Commit = GitObject & Node & Subscribable & UniformResourceLocatable & {
  __typename?: 'Commit';
  /** An abbreviated version of the Git object ID */
  abbreviatedOid: Scalars['String']['output'];
  /** The number of additions in this commit. */
  additions: Scalars['Int']['output'];
  /**
   * The merged Pull Request that introduced the commit to the repository. If the
   * commit is not present in the default branch, additionally returns open Pull
   * Requests associated with the commit
   */
  associatedPullRequests?: Maybe<PullRequestConnection>;
  /** Authorship details of the commit. */
  author?: Maybe<GitActor>;
  /** Check if the committer and the author match. */
  authoredByCommitter: Scalars['Boolean']['output'];
  /** The datetime when this commit was authored. */
  authoredDate: Scalars['DateTime']['output'];
  /**
   * The list of authors for this commit based on the git author and the Co-authored-by
   * message trailer. The git author will always be first.
   */
  authors: GitActorConnection;
  /** Fetches `git blame` information. */
  blame: Blame;
  /**
   * We recommend using the `changedFilesIfAvailable` field instead of
   * `changedFiles`, as `changedFiles` will cause your request to return an error
   * if GitHub is unable to calculate the number of changed files.
   * @deprecated `changedFiles` will be removed. Use `changedFilesIfAvailable` instead. Removal on 2023-01-01 UTC.
   */
  changedFiles: Scalars['Int']['output'];
  /**
   * The number of changed files in this commit. If GitHub is unable to calculate
   * the number of changed files (for example due to a timeout), this will return
   * `null`. We recommend using this field instead of `changedFiles`.
   */
  changedFilesIfAvailable?: Maybe<Scalars['Int']['output']>;
  /** The check suites associated with a commit. */
  checkSuites?: Maybe<CheckSuiteConnection>;
  /** Comments made on the commit. */
  comments: CommitCommentConnection;
  /** The HTTP path for this Git object */
  commitResourcePath: Scalars['URI']['output'];
  /** The HTTP URL for this Git object */
  commitUrl: Scalars['URI']['output'];
  /** The datetime when this commit was committed. */
  committedDate: Scalars['DateTime']['output'];
  /** Check if committed via GitHub web UI. */
  committedViaWeb: Scalars['Boolean']['output'];
  /** Committer details of the commit. */
  committer?: Maybe<GitActor>;
  /** The number of deletions in this commit. */
  deletions: Scalars['Int']['output'];
  /** The deployments associated with a commit. */
  deployments?: Maybe<DeploymentConnection>;
  /** The tree entry representing the file located at the given path. */
  file?: Maybe<TreeEntry>;
  /** The linear commit history starting from (and including) this commit, in the same order as `git log`. */
  history: CommitHistoryConnection;
  /** The Node ID of the Commit object */
  id: Scalars['ID']['output'];
  /** The Git commit message */
  message: Scalars['String']['output'];
  /** The Git commit message body */
  messageBody: Scalars['String']['output'];
  /** The commit message body rendered to HTML. */
  messageBodyHTML: Scalars['HTML']['output'];
  /** The Git commit message headline */
  messageHeadline: Scalars['String']['output'];
  /** The commit message headline rendered to HTML. */
  messageHeadlineHTML: Scalars['HTML']['output'];
  /** The Git object ID */
  oid: Scalars['GitObjectID']['output'];
  /** The organization this commit was made on behalf of. */
  onBehalfOf?: Maybe<Organization>;
  /** The parents of a commit. */
  parents: CommitConnection;
  /**
   * The datetime when this commit was pushed.
   * @deprecated `pushedDate` is no longer supported. Removal on 2023-07-01 UTC.
   */
  pushedDate?: Maybe<Scalars['DateTime']['output']>;
  /** The Repository this commit belongs to */
  repository: Repository;
  /** The HTTP path for this commit */
  resourcePath: Scalars['URI']['output'];
  /** Commit signing information, if present. */
  signature?: Maybe<GitSignature>;
  /** Status information for this commit */
  status?: Maybe<Status>;
  /** Check and Status rollup information for this commit. */
  statusCheckRollup?: Maybe<StatusCheckRollup>;
  /** Returns a list of all submodules in this repository as of this Commit parsed from the .gitmodules file. */
  submodules: SubmoduleConnection;
  /**
   * Returns a URL to download a tarball archive for a repository.
   * Note: For private repositories, these links are temporary and expire after five minutes.
   */
  tarballUrl: Scalars['URI']['output'];
  /** Commit's root Tree */
  tree: Tree;
  /** The HTTP path for the tree of this commit */
  treeResourcePath: Scalars['URI']['output'];
  /** The HTTP URL for the tree of this commit */
  treeUrl: Scalars['URI']['output'];
  /** The HTTP URL for this commit */
  url: Scalars['URI']['output'];
  /** Check if the viewer is able to change their subscription status for the repository. */
  viewerCanSubscribe: Scalars['Boolean']['output'];
  /** Identifies if the viewer is watching, not watching, or ignoring the subscribable entity. */
  viewerSubscription?: Maybe<SubscriptionState>;
  /**
   * Returns a URL to download a zipball archive for a repository.
   * Note: For private repositories, these links are temporary and expire after five minutes.
   */
  zipballUrl: Scalars['URI']['output'];
};


/** Represents a Git commit. */
export type CommitAssociatedPullRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PullRequestOrder>;
};


/** Represents a Git commit. */
export type CommitAuthorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents a Git commit. */
export type CommitBlameArgs = {
  path: Scalars['String']['input'];
};


/** Represents a Git commit. */
export type CommitCheckSuitesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<CheckSuiteFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents a Git commit. */
export type CommitCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents a Git commit. */
export type CommitDeploymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  environments?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DeploymentOrder>;
};


/** Represents a Git commit. */
export type CommitFileArgs = {
  path: Scalars['String']['input'];
};


/** Represents a Git commit. */
export type CommitHistoryArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  author?: InputMaybe<CommitAuthor>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  since?: InputMaybe<Scalars['GitTimestamp']['input']>;
  until?: InputMaybe<Scalars['GitTimestamp']['input']>;
};


/** Represents a Git commit. */
export type CommitParentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents a Git commit. */
export type CommitSubmodulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Specifies an author for filtering Git commits. */
export type CommitAuthor = {
  /** Email addresses to filter by. Commits authored by any of the specified email addresses will be returned. */
  emails?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * ID of a User to filter by. If non-null, only commits authored by this user
   * will be returned. This field takes precedence over emails.
   */
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Parameters to be used for the commit_author_email_pattern rule */
export type CommitAuthorEmailPatternParameters = {
  __typename?: 'CommitAuthorEmailPatternParameters';
  /** How this rule appears when configuring it. */
  name?: Maybe<Scalars['String']['output']>;
  /** If true, the rule will fail if the pattern matches. */
  negate: Scalars['Boolean']['output'];
  /** The operator to use for matching. */
  operator: Scalars['String']['output'];
  /** The pattern to match with. */
  pattern: Scalars['String']['output'];
};

/** Parameters to be used for the commit_author_email_pattern rule */
export type CommitAuthorEmailPatternParametersInput = {
  /** How this rule appears when configuring it. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** If true, the rule will fail if the pattern matches. */
  negate?: InputMaybe<Scalars['Boolean']['input']>;
  /** The operator to use for matching. */
  operator: Scalars['String']['input'];
  /** The pattern to match with. */
  pattern: Scalars['String']['input'];
};

/** Represents a comment on a given Commit. */
export type CommitComment = Comment & Deletable & Minimizable & Node & Reactable & RepositoryNode & Updatable & UpdatableComment & {
  __typename?: 'CommitComment';
  /** The actor who authored the comment. */
  author?: Maybe<Actor>;
  /** Author's association with the subject of the comment. */
  authorAssociation: CommentAuthorAssociation;
  /** Identifies the comment body. */
  body: Scalars['String']['output'];
  /** The body rendered to HTML. */
  bodyHTML: Scalars['HTML']['output'];
  /** The body rendered to text. */
  bodyText: Scalars['String']['output'];
  /** Identifies the commit associated with the comment, if the commit exists. */
  commit?: Maybe<Commit>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Check if this comment was created via an email reply. */
  createdViaEmail: Scalars['Boolean']['output'];
  /** Identifies the primary key from the database. */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** The actor who edited the comment. */
  editor?: Maybe<Actor>;
  /** The Node ID of the CommitComment object */
  id: Scalars['ID']['output'];
  /** Check if this comment was edited and includes an edit with the creation data */
  includesCreatedEdit: Scalars['Boolean']['output'];
  /** Returns whether or not a comment has been minimized. */
  isMinimized: Scalars['Boolean']['output'];
  /** The moment the editor made the last edit */
  lastEditedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Returns why the comment was minimized. One of `abuse`, `off-topic`,
   * `outdated`, `resolved`, `duplicate`, `spam`, and `low-quality`. Note that the
   * case and formatting of these values differs from the inputs to the
   * `MinimizeComment` mutation.
   */
  minimizedReason?: Maybe<Scalars['String']['output']>;
  /** Identifies the file path associated with the comment. */
  path?: Maybe<Scalars['String']['output']>;
  /** Identifies the line position associated with the comment. */
  position?: Maybe<Scalars['Int']['output']>;
  /** Identifies when the comment was published at. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** A list of reactions grouped by content left on the subject. */
  reactionGroups?: Maybe<Array<ReactionGroup>>;
  /** A list of Reactions left on the Issue. */
  reactions: ReactionConnection;
  /** The repository associated with this node. */
  repository: Repository;
  /** The HTTP path permalink for this commit comment. */
  resourcePath: Scalars['URI']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The HTTP URL permalink for this commit comment. */
  url: Scalars['URI']['output'];
  /** A list of edits to this content. */
  userContentEdits?: Maybe<UserContentEditConnection>;
  /** Check if the current viewer can delete this object. */
  viewerCanDelete: Scalars['Boolean']['output'];
  /** Check if the current viewer can minimize this object. */
  viewerCanMinimize: Scalars['Boolean']['output'];
  /** Can user react to this subject */
  viewerCanReact: Scalars['Boolean']['output'];
  /** Check if the current viewer can unminimize this object. */
  viewerCanUnminimize: Scalars['Boolean']['output'];
  /** Check if the current viewer can update this object. */
  viewerCanUpdate: Scalars['Boolean']['output'];
  /** Reasons why the current viewer can not update this comment. */
  viewerCannotUpdateReasons: Array<CommentCannotUpdateReason>;
  /** Did the viewer author this comment. */
  viewerDidAuthor: Scalars['Boolean']['output'];
};


/** Represents a comment on a given Commit. */
export type CommitCommentReactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<ReactionContent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ReactionOrder>;
};


/** Represents a comment on a given Commit. */
export type CommitCommentUserContentEditsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for CommitComment. */
export type CommitCommentConnection = {
  __typename?: 'CommitCommentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CommitCommentEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<CommitComment>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CommitCommentEdge = {
  __typename?: 'CommitCommentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<CommitComment>;
};

/** A thread of comments on a commit. */
export type CommitCommentThread = Node & RepositoryNode & {
  __typename?: 'CommitCommentThread';
  /** The comments that exist in this thread. */
  comments: CommitCommentConnection;
  /** The commit the comments were made on. */
  commit?: Maybe<Commit>;
  /** The Node ID of the CommitCommentThread object */
  id: Scalars['ID']['output'];
  /** The file the comments were made on. */
  path?: Maybe<Scalars['String']['output']>;
  /** The position in the diff for the commit that the comment was made on. */
  position?: Maybe<Scalars['Int']['output']>;
  /** The repository associated with this node. */
  repository: Repository;
};


/** A thread of comments on a commit. */
export type CommitCommentThreadCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for Commit. */
export type CommitConnection = {
  __typename?: 'CommitConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CommitEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Commit>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** Ordering options for commit contribution connections. */
export type CommitContributionOrder = {
  /** The ordering direction. */
  direction: OrderDirection;
  /** The field by which to order commit contributions. */
  field: CommitContributionOrderField;
};

/** Properties by which commit contribution connections can be ordered. */
export enum CommitContributionOrderField {
  /** Order commit contributions by how many commits they represent. */
  CommitCount = 'COMMIT_COUNT',
  /** Order commit contributions by when they were made. */
  OccurredAt = 'OCCURRED_AT'
}

/** This aggregates commits made by a user within one repository. */
export type CommitContributionsByRepository = {
  __typename?: 'CommitContributionsByRepository';
  /** The commit contributions, each representing a day. */
  contributions: CreatedCommitContributionConnection;
  /** The repository in which the commits were made. */
  repository: Repository;
  /** The HTTP path for the user's commits to the repository in this time range. */
  resourcePath: Scalars['URI']['output'];
  /** The HTTP URL for the user's commits to the repository in this time range. */
  url: Scalars['URI']['output'];
};


/** This aggregates commits made by a user within one repository. */
export type CommitContributionsByRepositoryContributionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<CommitContributionOrder>;
};

/** An edge in a connection. */
export type CommitEdge = {
  __typename?: 'CommitEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Commit>;
};

/** The connection type for Commit. */
export type CommitHistoryConnection = {
  __typename?: 'CommitHistoryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CommitEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Commit>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A message to include with a new commit */
export type CommitMessage = {
  /** The body of the message. */
  body?: InputMaybe<Scalars['String']['input']>;
  /** The headline of the message. */
  headline: Scalars['String']['input'];
};

/** Parameters to be used for the commit_message_pattern rule */
export type CommitMessagePatternParameters = {
  __typename?: 'CommitMessagePatternParameters';
  /** How this rule appears when configuring it. */
  name?: Maybe<Scalars['String']['output']>;
  /** If true, the rule will fail if the pattern matches. */
  negate: Scalars['Boolean']['output'];
  /** The operator to use for matching. */
  operator: Scalars['String']['output'];
  /** The pattern to match with. */
  pattern: Scalars['String']['output'];
};

/** Parameters to be used for the commit_message_pattern rule */
export type CommitMessagePatternParametersInput = {
  /** How this rule appears when configuring it. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** If true, the rule will fail if the pattern matches. */
  negate?: InputMaybe<Scalars['Boolean']['input']>;
  /** The operator to use for matching. */
  operator: Scalars['String']['input'];
  /** The pattern to match with. */
  pattern: Scalars['String']['input'];
};

/**
 * A git ref for a commit to be appended to.
 *
 * The ref must be a branch, i.e. its fully qualified name must start
 * with `refs/heads/` (although the input is not required to be fully
 * qualified).
 *
 * The Ref may be specified by its global node ID or by the
 * `repositoryNameWithOwner` and `branchName`.
 *
 * ### Examples
 *
 * Specify a branch using a global node ID:
 *
 *     { "id": "MDM6UmVmMTpyZWZzL2hlYWRzL21haW4=" }
 *
 * Specify a branch using `repositoryNameWithOwner` and `branchName`:
 *
 *     {
 *       "repositoryNameWithOwner": "github/graphql-client",
 *       "branchName": "main"
 *     }
 */
export type CommittableBranch = {
  /** The unqualified name of the branch to append the commit to. */
  branchName?: InputMaybe<Scalars['String']['input']>;
  /** The Node ID of the Ref to be updated. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The nameWithOwner of the repository to commit to. */
  repositoryNameWithOwner?: InputMaybe<Scalars['String']['input']>;
};

/** Parameters to be used for the committer_email_pattern rule */
export type CommitterEmailPatternParameters = {
  __typename?: 'CommitterEmailPatternParameters';
  /** How this rule appears when configuring it. */
  name?: Maybe<Scalars['String']['output']>;
  /** If true, the rule will fail if the pattern matches. */
  negate: Scalars['Boolean']['output'];
  /** The operator to use for matching. */
  operator: Scalars['String']['output'];
  /** The pattern to match with. */
  pattern: Scalars['String']['output'];
};

/** Parameters to be used for the committer_email_pattern rule */
export type CommitterEmailPatternParametersInput = {
  /** How this rule appears when configuring it. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** If true, the rule will fail if the pattern matches. */
  negate?: InputMaybe<Scalars['Boolean']['input']>;
  /** The operator to use for matching. */
  operator: Scalars['String']['input'];
  /** The pattern to match with. */
  pattern: Scalars['String']['input'];
};

/** Represents a comparison between two commit revisions. */
export type Comparison = Node & {
  __typename?: 'Comparison';
  /** The number of commits ahead of the base branch. */
  aheadBy: Scalars['Int']['output'];
  /** The base revision of this comparison. */
  baseTarget: GitObject;
  /** The number of commits behind the base branch. */
  behindBy: Scalars['Int']['output'];
  /** The commits which compose this comparison. */
  commits: ComparisonCommitConnection;
  /** The head revision of this comparison. */
  headTarget: GitObject;
  /** The Node ID of the Comparison object */
  id: Scalars['ID']['output'];
  /** The status of this comparison. */
  status: ComparisonStatus;
};


/** Represents a comparison between two commit revisions. */
export type ComparisonCommitsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for Commit. */
export type ComparisonCommitConnection = {
  __typename?: 'ComparisonCommitConnection';
  /** The total count of authors and co-authors across all commits. */
  authorCount: Scalars['Int']['output'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CommitEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Commit>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** The status of a git comparison between two refs. */
export enum ComparisonStatus {
  /** The head ref is ahead of the base ref. */
  Ahead = 'AHEAD',
  /** The head ref is behind the base ref. */
  Behind = 'BEHIND',
  /** The head ref is both ahead and behind of the base ref, indicating git history has diverged. */
  Diverged = 'DIVERGED',
  /** The head ref and base ref are identical. */
  Identical = 'IDENTICAL'
}

/** Represents a 'connected' event on a given issue or pull request. */
export type ConnectedEvent = Node & {
  __typename?: 'ConnectedEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The Node ID of the ConnectedEvent object */
  id: Scalars['ID']['output'];
  /** Reference originated in a different repository. */
  isCrossRepository: Scalars['Boolean']['output'];
  /** Issue or pull request that made the reference. */
  source: ReferencedSubject;
  /** Issue or pull request which was connected. */
  subject: ReferencedSubject;
};

/** The content warning for a repository */
export type ContentWarning = {
  __typename?: 'ContentWarning';
  /** The content warning' category. E.g. 'mis_dis_information' */
  category: Scalars['String']['output'];
  /** The content warning's custom sub category text. E.g. 'dangerous stuff.' */
  customSubCategory?: Maybe<Scalars['String']['output']>;
  /** The content warning's sub category. E.g. 'medical_scientific' */
  subCategory?: Maybe<Scalars['String']['output']>;
  /** The content warning's sub title. E.g. 'The information contained in this page has not been verified.' */
  subTitle?: Maybe<Scalars['String']['output']>;
  /** The content warning's title. E.g. 'This page may contain false or misleading information.' */
  title: Scalars['String']['output'];
  /** The type of content warning. E.g. 'interstitial' */
  type: Scalars['String']['output'];
};

/** The Contributing Guidelines for a repository. */
export type ContributingGuidelines = {
  __typename?: 'ContributingGuidelines';
  /** The body of the Contributing Guidelines. */
  body?: Maybe<Scalars['String']['output']>;
  /** The HTTP path for the Contributing Guidelines. */
  resourcePath?: Maybe<Scalars['URI']['output']>;
  /** The HTTP URL for the Contributing Guidelines. */
  url?: Maybe<Scalars['URI']['output']>;
};

/** Represents a contribution a user made on GitHub, such as opening an issue. */
export type Contribution = {
  /**
   * Whether this contribution is associated with a record you do not have access to. For
   * example, your own 'first issue' contribution may have been made on a repository you can no
   * longer access.
   */
  isRestricted: Scalars['Boolean']['output'];
  /** When this contribution was made. */
  occurredAt: Scalars['DateTime']['output'];
  /** The HTTP path for this contribution. */
  resourcePath: Scalars['URI']['output'];
  /** The HTTP URL for this contribution. */
  url: Scalars['URI']['output'];
  /** The user who made this contribution. */
  user: User;
};

/** A calendar of contributions made on GitHub by a user. */
export type ContributionCalendar = {
  __typename?: 'ContributionCalendar';
  /** A list of hex color codes used in this calendar. The darker the color, the more contributions it represents. */
  colors: Array<Scalars['String']['output']>;
  /** Determine if the color set was chosen because it's currently Halloween. */
  isHalloween: Scalars['Boolean']['output'];
  /** A list of the months of contributions in this calendar. */
  months: Array<ContributionCalendarMonth>;
  /** The count of total contributions in the calendar. */
  totalContributions: Scalars['Int']['output'];
  /** A list of the weeks of contributions in this calendar. */
  weeks: Array<ContributionCalendarWeek>;
};

/** Represents a single day of contributions on GitHub by a user. */
export type ContributionCalendarDay = {
  __typename?: 'ContributionCalendarDay';
  /** The hex color code that represents how many contributions were made on this day compared to others in the calendar. */
  color: Scalars['String']['output'];
  /** How many contributions were made by the user on this day. */
  contributionCount: Scalars['Int']['output'];
  /**
   * Indication of contributions, relative to other days. Can be used to indicate
   * which color to represent this day on a calendar.
   */
  contributionLevel: ContributionLevel;
  /** The day this square represents. */
  date: Scalars['Date']['output'];
  /** A number representing which day of the week this square represents, e.g., 1 is Monday. */
  weekday: Scalars['Int']['output'];
};

/** A month of contributions in a user's contribution graph. */
export type ContributionCalendarMonth = {
  __typename?: 'ContributionCalendarMonth';
  /** The date of the first day of this month. */
  firstDay: Scalars['Date']['output'];
  /** The name of the month. */
  name: Scalars['String']['output'];
  /** How many weeks started in this month. */
  totalWeeks: Scalars['Int']['output'];
  /** The year the month occurred in. */
  year: Scalars['Int']['output'];
};

/** A week of contributions in a user's contribution graph. */
export type ContributionCalendarWeek = {
  __typename?: 'ContributionCalendarWeek';
  /** The days of contributions in this week. */
  contributionDays: Array<ContributionCalendarDay>;
  /** The date of the earliest square in this week. */
  firstDay: Scalars['Date']['output'];
};

/** Varying levels of contributions from none to many. */
export enum ContributionLevel {
  /** Lowest 25% of days of contributions. */
  FirstQuartile = 'FIRST_QUARTILE',
  /** Highest 25% of days of contributions. More contributions than the third quartile. */
  FourthQuartile = 'FOURTH_QUARTILE',
  /** No contributions occurred. */
  None = 'NONE',
  /** Second lowest 25% of days of contributions. More contributions than the first quartile. */
  SecondQuartile = 'SECOND_QUARTILE',
  /** Second highest 25% of days of contributions. More contributions than second quartile, less than the fourth quartile. */
  ThirdQuartile = 'THIRD_QUARTILE'
}

/** Ordering options for contribution connections. */
export type ContributionOrder = {
  /** The ordering direction. */
  direction: OrderDirection;
};

/**
 * A collection of contributions made by a user, including opened issues, commits, and pull requests.
 * Contributions in private and internal repositories are only included with the optional read:user scope.
 */
export type ContributionsCollection = {
  __typename?: 'ContributionsCollection';
  /** Commit contributions made by the user, grouped by repository. */
  commitContributionsByRepository: Array<CommitContributionsByRepository>;
  /** A calendar of this user's contributions on GitHub. */
  contributionCalendar: ContributionCalendar;
  /** The years the user has been making contributions with the most recent year first. */
  contributionYears: Array<Scalars['Int']['output']>;
  /** Determine if this collection's time span ends in the current month. */
  doesEndInCurrentMonth: Scalars['Boolean']['output'];
  /**
   * The date of the first restricted contribution the user made in this time
   * period. Can only be non-null when the user has enabled private contribution counts.
   */
  earliestRestrictedContributionDate?: Maybe<Scalars['Date']['output']>;
  /** The ending date and time of this collection. */
  endedAt: Scalars['DateTime']['output'];
  /**
   * The first issue the user opened on GitHub. This will be null if that issue was
   * opened outside the collection's time range and ignoreTimeRange is false. If
   * the issue is not visible but the user has opted to show private contributions,
   * a RestrictedContribution will be returned.
   */
  firstIssueContribution?: Maybe<CreatedIssueOrRestrictedContribution>;
  /**
   * The first pull request the user opened on GitHub. This will be null if that
   * pull request was opened outside the collection's time range and
   * ignoreTimeRange is not true. If the pull request is not visible but the user
   * has opted to show private contributions, a RestrictedContribution will be returned.
   */
  firstPullRequestContribution?: Maybe<CreatedPullRequestOrRestrictedContribution>;
  /**
   * The first repository the user created on GitHub. This will be null if that
   * first repository was created outside the collection's time range and
   * ignoreTimeRange is false. If the repository is not visible, then a
   * RestrictedContribution is returned.
   */
  firstRepositoryContribution?: Maybe<CreatedRepositoryOrRestrictedContribution>;
  /** Does the user have any more activity in the timeline that occurred prior to the collection's time range? */
  hasActivityInThePast: Scalars['Boolean']['output'];
  /** Determine if there are any contributions in this collection. */
  hasAnyContributions: Scalars['Boolean']['output'];
  /**
   * Determine if the user made any contributions in this time frame whose details
   * are not visible because they were made in a private repository. Can only be
   * true if the user enabled private contribution counts.
   */
  hasAnyRestrictedContributions: Scalars['Boolean']['output'];
  /** Whether or not the collector's time span is all within the same day. */
  isSingleDay: Scalars['Boolean']['output'];
  /** A list of issues the user opened. */
  issueContributions: CreatedIssueContributionConnection;
  /** Issue contributions made by the user, grouped by repository. */
  issueContributionsByRepository: Array<IssueContributionsByRepository>;
  /**
   * When the user signed up for GitHub. This will be null if that sign up date
   * falls outside the collection's time range and ignoreTimeRange is false.
   */
  joinedGitHubContribution?: Maybe<JoinedGitHubContribution>;
  /**
   * The date of the most recent restricted contribution the user made in this time
   * period. Can only be non-null when the user has enabled private contribution counts.
   */
  latestRestrictedContributionDate?: Maybe<Scalars['Date']['output']>;
  /**
   * When this collection's time range does not include any activity from the user, use this
   * to get a different collection from an earlier time range that does have activity.
   */
  mostRecentCollectionWithActivity?: Maybe<ContributionsCollection>;
  /**
   * Returns a different contributions collection from an earlier time range than this one
   * that does not have any contributions.
   */
  mostRecentCollectionWithoutActivity?: Maybe<ContributionsCollection>;
  /**
   * The issue the user opened on GitHub that received the most comments in the specified
   * time frame.
   */
  popularIssueContribution?: Maybe<CreatedIssueContribution>;
  /**
   * The pull request the user opened on GitHub that received the most comments in the
   * specified time frame.
   */
  popularPullRequestContribution?: Maybe<CreatedPullRequestContribution>;
  /** Pull request contributions made by the user. */
  pullRequestContributions: CreatedPullRequestContributionConnection;
  /** Pull request contributions made by the user, grouped by repository. */
  pullRequestContributionsByRepository: Array<PullRequestContributionsByRepository>;
  /**
   * Pull request review contributions made by the user. Returns the most recently
   * submitted review for each PR reviewed by the user.
   */
  pullRequestReviewContributions: CreatedPullRequestReviewContributionConnection;
  /** Pull request review contributions made by the user, grouped by repository. */
  pullRequestReviewContributionsByRepository: Array<PullRequestReviewContributionsByRepository>;
  /** A list of repositories owned by the user that the user created in this time range. */
  repositoryContributions: CreatedRepositoryContributionConnection;
  /**
   * A count of contributions made by the user that the viewer cannot access. Only
   * non-zero when the user has chosen to share their private contribution counts.
   */
  restrictedContributionsCount: Scalars['Int']['output'];
  /** The beginning date and time of this collection. */
  startedAt: Scalars['DateTime']['output'];
  /** How many commits were made by the user in this time span. */
  totalCommitContributions: Scalars['Int']['output'];
  /** How many issues the user opened. */
  totalIssueContributions: Scalars['Int']['output'];
  /** How many pull requests the user opened. */
  totalPullRequestContributions: Scalars['Int']['output'];
  /** How many pull request reviews the user left. */
  totalPullRequestReviewContributions: Scalars['Int']['output'];
  /** How many different repositories the user committed to. */
  totalRepositoriesWithContributedCommits: Scalars['Int']['output'];
  /** How many different repositories the user opened issues in. */
  totalRepositoriesWithContributedIssues: Scalars['Int']['output'];
  /** How many different repositories the user left pull request reviews in. */
  totalRepositoriesWithContributedPullRequestReviews: Scalars['Int']['output'];
  /** How many different repositories the user opened pull requests in. */
  totalRepositoriesWithContributedPullRequests: Scalars['Int']['output'];
  /** How many repositories the user created. */
  totalRepositoryContributions: Scalars['Int']['output'];
  /** The user who made the contributions in this collection. */
  user: User;
};


/**
 * A collection of contributions made by a user, including opened issues, commits, and pull requests.
 * Contributions in private and internal repositories are only included with the optional read:user scope.
 */
export type ContributionsCollectionCommitContributionsByRepositoryArgs = {
  maxRepositories?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * A collection of contributions made by a user, including opened issues, commits, and pull requests.
 * Contributions in private and internal repositories are only included with the optional read:user scope.
 */
export type ContributionsCollectionIssueContributionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  excludeFirst?: InputMaybe<Scalars['Boolean']['input']>;
  excludePopular?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ContributionOrder>;
};


/**
 * A collection of contributions made by a user, including opened issues, commits, and pull requests.
 * Contributions in private and internal repositories are only included with the optional read:user scope.
 */
export type ContributionsCollectionIssueContributionsByRepositoryArgs = {
  excludeFirst?: InputMaybe<Scalars['Boolean']['input']>;
  excludePopular?: InputMaybe<Scalars['Boolean']['input']>;
  maxRepositories?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * A collection of contributions made by a user, including opened issues, commits, and pull requests.
 * Contributions in private and internal repositories are only included with the optional read:user scope.
 */
export type ContributionsCollectionPullRequestContributionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  excludeFirst?: InputMaybe<Scalars['Boolean']['input']>;
  excludePopular?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ContributionOrder>;
};


/**
 * A collection of contributions made by a user, including opened issues, commits, and pull requests.
 * Contributions in private and internal repositories are only included with the optional read:user scope.
 */
export type ContributionsCollectionPullRequestContributionsByRepositoryArgs = {
  excludeFirst?: InputMaybe<Scalars['Boolean']['input']>;
  excludePopular?: InputMaybe<Scalars['Boolean']['input']>;
  maxRepositories?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * A collection of contributions made by a user, including opened issues, commits, and pull requests.
 * Contributions in private and internal repositories are only included with the optional read:user scope.
 */
export type ContributionsCollectionPullRequestReviewContributionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ContributionOrder>;
};


/**
 * A collection of contributions made by a user, including opened issues, commits, and pull requests.
 * Contributions in private and internal repositories are only included with the optional read:user scope.
 */
export type ContributionsCollectionPullRequestReviewContributionsByRepositoryArgs = {
  maxRepositories?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * A collection of contributions made by a user, including opened issues, commits, and pull requests.
 * Contributions in private and internal repositories are only included with the optional read:user scope.
 */
export type ContributionsCollectionRepositoryContributionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  excludeFirst?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ContributionOrder>;
};


/**
 * A collection of contributions made by a user, including opened issues, commits, and pull requests.
 * Contributions in private and internal repositories are only included with the optional read:user scope.
 */
export type ContributionsCollectionTotalIssueContributionsArgs = {
  excludeFirst?: InputMaybe<Scalars['Boolean']['input']>;
  excludePopular?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A collection of contributions made by a user, including opened issues, commits, and pull requests.
 * Contributions in private and internal repositories are only included with the optional read:user scope.
 */
export type ContributionsCollectionTotalPullRequestContributionsArgs = {
  excludeFirst?: InputMaybe<Scalars['Boolean']['input']>;
  excludePopular?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A collection of contributions made by a user, including opened issues, commits, and pull requests.
 * Contributions in private and internal repositories are only included with the optional read:user scope.
 */
export type ContributionsCollectionTotalRepositoriesWithContributedIssuesArgs = {
  excludeFirst?: InputMaybe<Scalars['Boolean']['input']>;
  excludePopular?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A collection of contributions made by a user, including opened issues, commits, and pull requests.
 * Contributions in private and internal repositories are only included with the optional read:user scope.
 */
export type ContributionsCollectionTotalRepositoriesWithContributedPullRequestsArgs = {
  excludeFirst?: InputMaybe<Scalars['Boolean']['input']>;
  excludePopular?: InputMaybe<Scalars['Boolean']['input']>;
};


/**
 * A collection of contributions made by a user, including opened issues, commits, and pull requests.
 * Contributions in private and internal repositories are only included with the optional read:user scope.
 */
export type ContributionsCollectionTotalRepositoryContributionsArgs = {
  excludeFirst?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated input type of ConvertProjectCardNoteToIssue */
export type ConvertProjectCardNoteToIssueInput = {
  /** The body of the newly created issue. */
  body?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ProjectCard ID to convert. */
  projectCardId: Scalars['ID']['input'];
  /** The ID of the repository to create the issue in. */
  repositoryId: Scalars['ID']['input'];
  /** The title of the newly created issue. Defaults to the card's note text. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ConvertProjectCardNoteToIssue. */
export type ConvertProjectCardNoteToIssuePayload = {
  __typename?: 'ConvertProjectCardNoteToIssuePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated ProjectCard. */
  projectCard?: Maybe<ProjectCard>;
};

/** Autogenerated input type of ConvertProjectV2DraftIssueItemToIssue */
export type ConvertProjectV2DraftIssueItemToIssueInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the draft issue ProjectV2Item to convert. */
  itemId: Scalars['ID']['input'];
  /** The ID of the repository to create the issue in. */
  repositoryId: Scalars['ID']['input'];
};

/** Autogenerated return type of ConvertProjectV2DraftIssueItemToIssue. */
export type ConvertProjectV2DraftIssueItemToIssuePayload = {
  __typename?: 'ConvertProjectV2DraftIssueItemToIssuePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated project item. */
  item?: Maybe<ProjectV2Item>;
};

/** Autogenerated input type of ConvertPullRequestToDraft */
export type ConvertPullRequestToDraftInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the pull request to convert to draft */
  pullRequestId: Scalars['ID']['input'];
};

/** Autogenerated return type of ConvertPullRequestToDraft. */
export type ConvertPullRequestToDraftPayload = {
  __typename?: 'ConvertPullRequestToDraftPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The pull request that is now a draft. */
  pullRequest?: Maybe<PullRequest>;
};

/** Represents a 'convert_to_draft' event on a given pull request. */
export type ConvertToDraftEvent = Node & UniformResourceLocatable & {
  __typename?: 'ConvertToDraftEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The Node ID of the ConvertToDraftEvent object */
  id: Scalars['ID']['output'];
  /** PullRequest referenced by event. */
  pullRequest: PullRequest;
  /** The HTTP path for this convert to draft event. */
  resourcePath: Scalars['URI']['output'];
  /** The HTTP URL for this convert to draft event. */
  url: Scalars['URI']['output'];
};

/** Represents a 'converted_from_draft' event on a given issue or pull request. */
export type ConvertedFromDraftEvent = Node & ProjectV2Event & {
  __typename?: 'ConvertedFromDraftEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The Node ID of the ConvertedFromDraftEvent object */
  id: Scalars['ID']['output'];
  /** Project referenced by event. */
  project?: Maybe<ProjectV2>;
  /** Did this event result from workflow automation? */
  wasAutomated: Scalars['Boolean']['output'];
};

/** Represents a 'converted_note_to_issue' event on a given issue or pull request. */
export type ConvertedNoteToIssueEvent = Node & {
  __typename?: 'ConvertedNoteToIssueEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Identifies the primary key from the database. */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** The Node ID of the ConvertedNoteToIssueEvent object */
  id: Scalars['ID']['output'];
  /**
   * Project referenced by event.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  project?: Maybe<Project>;
  /**
   * Project card referenced by this project event.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  projectCard?: Maybe<ProjectCard>;
  /** Column name referenced by this project event. */
  projectColumnName: Scalars['String']['output'];
};

/** Represents a 'converted_to_discussion' event on a given issue. */
export type ConvertedToDiscussionEvent = Node & {
  __typename?: 'ConvertedToDiscussionEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The discussion that the issue was converted into. */
  discussion?: Maybe<Discussion>;
  /** The Node ID of the ConvertedToDiscussionEvent object */
  id: Scalars['ID']['output'];
};

/**
 * Request Copilot code review for new pull requests automatically if the author
 * has access to Copilot code review and AI credits.
 */
export type CopilotCodeReviewParameters = {
  __typename?: 'CopilotCodeReviewParameters';
  /** Copilot automatically reviews draft pull requests before they are marked as ready for review. */
  reviewDraftPullRequests: Scalars['Boolean']['output'];
  /** Copilot automatically reviews each new push to the pull request. */
  reviewOnPush: Scalars['Boolean']['output'];
};

/**
 * Request Copilot code review for new pull requests automatically if the author
 * has access to Copilot code review and AI credits.
 */
export type CopilotCodeReviewParametersInput = {
  /** Copilot automatically reviews draft pull requests before they are marked as ready for review. */
  reviewDraftPullRequests?: InputMaybe<Scalars['Boolean']['input']>;
  /** Copilot automatically reviews each new push to the pull request. */
  reviewOnPush?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Copilot endpoint information */
export type CopilotEndpoints = {
  __typename?: 'CopilotEndpoints';
  /** Copilot API endpoint */
  api: Scalars['String']['output'];
  /** Copilot experimentation (edge TAS) endpoint */
  exp?: Maybe<Scalars['String']['output']>;
  /** Copilot origin tracker endpoint */
  originTracker: Scalars['String']['output'];
  /** Copilot proxy endpoint */
  proxy: Scalars['String']['output'];
  /** Copilot telemetry endpoint */
  telemetry: Scalars['String']['output'];
};

/** Autogenerated input type of CopyProjectV2 */
export type CopyProjectV2Input = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Include draft issues in the new project */
  includeDraftIssues?: InputMaybe<Scalars['Boolean']['input']>;
  /** The owner ID of the new project. */
  ownerId: Scalars['ID']['input'];
  /** The ID of the source Project to copy. */
  projectId: Scalars['ID']['input'];
  /** The title of the project. */
  title: Scalars['String']['input'];
};

/** Autogenerated return type of CopyProjectV2. */
export type CopyProjectV2Payload = {
  __typename?: 'CopyProjectV2Payload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The copied project. */
  projectV2?: Maybe<ProjectV2>;
};

/** Autogenerated input type of CreateAttributionInvitation */
export type CreateAttributionInvitationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Node ID of the owner scoping the reattributable data. */
  ownerId: Scalars['ID']['input'];
  /** The Node ID of the account owning the data to reattribute. */
  sourceId: Scalars['ID']['input'];
  /** The Node ID of the account which may claim the data. */
  targetId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateAttributionInvitation. */
export type CreateAttributionInvitationPayload = {
  __typename?: 'CreateAttributionInvitationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The owner scoping the reattributable data. */
  owner?: Maybe<Organization>;
  /** The account owning the data to reattribute. */
  source?: Maybe<Claimable>;
  /** The account which may claim the data. */
  target?: Maybe<Claimable>;
};

/** Autogenerated input type of CreateBranchProtectionRule */
export type CreateBranchProtectionRuleInput = {
  /** Can this branch be deleted. */
  allowsDeletions?: InputMaybe<Scalars['Boolean']['input']>;
  /** Are force pushes allowed on this branch. */
  allowsForcePushes?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is branch creation a protected operation. */
  blocksCreations?: InputMaybe<Scalars['Boolean']['input']>;
  /** A list of User, Team, or App IDs allowed to bypass force push targeting matching branches. */
  bypassForcePushActorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** A list of User, Team, or App IDs allowed to bypass pull requests targeting matching branches. */
  bypassPullRequestActorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Will new commits pushed to matching branches dismiss pull request review approvals. */
  dismissesStaleReviews?: InputMaybe<Scalars['Boolean']['input']>;
  /** Can admins override branch protection. */
  isAdminEnforced?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Whether users can pull changes from upstream when the branch is locked. Set to
   * `true` to allow fork syncing. Set to `false` to prevent fork syncing.
   */
  lockAllowsFetchAndMerge?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to set the branch as read-only. If this is true, users will not be able to push to the branch. */
  lockBranch?: InputMaybe<Scalars['Boolean']['input']>;
  /** The glob-like pattern used to determine matching branches. */
  pattern: Scalars['String']['input'];
  /** A list of User, Team, or App IDs allowed to push to matching branches. */
  pushActorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The global relay id of the repository in which a new branch protection rule should be created in. */
  repositoryId: Scalars['ID']['input'];
  /** Whether the most recent push must be approved by someone other than the person who pushed it */
  requireLastPushApproval?: InputMaybe<Scalars['Boolean']['input']>;
  /** Number of approving reviews required to update matching branches. */
  requiredApprovingReviewCount?: InputMaybe<Scalars['Int']['input']>;
  /** The list of required deployment environments */
  requiredDeploymentEnvironments?: InputMaybe<Array<Scalars['String']['input']>>;
  /** List of required status check contexts that must pass for commits to be accepted to matching branches. */
  requiredStatusCheckContexts?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The list of required status checks */
  requiredStatusChecks?: InputMaybe<Array<RequiredStatusCheckInput>>;
  /** Are approving reviews required to update matching branches. */
  requiresApprovingReviews?: InputMaybe<Scalars['Boolean']['input']>;
  /** Are reviews from code owners required to update matching branches. */
  requiresCodeOwnerReviews?: InputMaybe<Scalars['Boolean']['input']>;
  /** Are commits required to be signed. */
  requiresCommitSignatures?: InputMaybe<Scalars['Boolean']['input']>;
  /** Are conversations required to be resolved before merging. */
  requiresConversationResolution?: InputMaybe<Scalars['Boolean']['input']>;
  /** Are successful deployments required before merging. */
  requiresDeployments?: InputMaybe<Scalars['Boolean']['input']>;
  /** Are merge commits prohibited from being pushed to this branch. */
  requiresLinearHistory?: InputMaybe<Scalars['Boolean']['input']>;
  /** Are status checks required to update matching branches. */
  requiresStatusChecks?: InputMaybe<Scalars['Boolean']['input']>;
  /** Are branches required to be up to date before merging. */
  requiresStrictStatusChecks?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is pushing to matching branches restricted. */
  restrictsPushes?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is dismissal of pull request reviews restricted. */
  restrictsReviewDismissals?: InputMaybe<Scalars['Boolean']['input']>;
  /** A list of User, Team, or App IDs allowed to dismiss reviews on pull requests targeting matching branches. */
  reviewDismissalActorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Autogenerated return type of CreateBranchProtectionRule. */
export type CreateBranchProtectionRulePayload = {
  __typename?: 'CreateBranchProtectionRulePayload';
  /** The newly created BranchProtectionRule. */
  branchProtectionRule?: Maybe<BranchProtectionRule>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateCheckRun */
export type CreateCheckRunInput = {
  /** Possible further actions the integrator can perform, which a user may trigger. */
  actions?: InputMaybe<Array<CheckRunAction>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The time that the check run finished. */
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The final conclusion of the check. */
  conclusion?: InputMaybe<CheckConclusionState>;
  /** The URL of the integrator's site that has the full details of the check. */
  detailsUrl?: InputMaybe<Scalars['URI']['input']>;
  /** A reference for the run on the integrator's system. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** The SHA of the head commit. */
  headSha: Scalars['GitObjectID']['input'];
  /** The name of the check. */
  name: Scalars['String']['input'];
  /** Descriptive details about the run. */
  output?: InputMaybe<CheckRunOutput>;
  /** The node ID of the repository. */
  repositoryId: Scalars['ID']['input'];
  /** The time that the check run began. */
  startedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The current status. */
  status?: InputMaybe<RequestableCheckStatusState>;
};

/** Autogenerated return type of CreateCheckRun. */
export type CreateCheckRunPayload = {
  __typename?: 'CreateCheckRunPayload';
  /** The newly created check run. */
  checkRun?: Maybe<CheckRun>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateCheckSuite */
export type CreateCheckSuiteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The SHA of the head commit. */
  headSha: Scalars['GitObjectID']['input'];
  /** The Node ID of the repository. */
  repositoryId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateCheckSuite. */
export type CreateCheckSuitePayload = {
  __typename?: 'CreateCheckSuitePayload';
  /** The newly created check suite. */
  checkSuite?: Maybe<CheckSuite>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of CreateCommitOnBranch */
export type CreateCommitOnBranchInput = {
  /** The Ref to be updated.  Must be a branch. */
  branch: CommittableBranch;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The git commit oid expected at the head of the branch prior to the commit */
  expectedHeadOid: Scalars['GitObjectID']['input'];
  /** A description of changes to files in this commit. */
  fileChanges?: InputMaybe<FileChanges>;
  /** The commit message the be included with the commit. */
  message: CommitMessage;
};

/** Autogenerated return type of CreateCommitOnBranch. */
export type CreateCommitOnBranchPayload = {
  __typename?: 'CreateCommitOnBranchPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The new commit. */
  commit?: Maybe<Commit>;
  /** The ref which has been updated to point to the new commit. */
  ref?: Maybe<Ref>;
};

/** Autogenerated input type of CreateDeployment */
export type CreateDeploymentInput = {
  /** Attempt to automatically merge the default branch into the requested ref, defaults to true. */
  autoMerge?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Short description of the deployment. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Name for the target deployment environment. */
  environment?: InputMaybe<Scalars['String']['input']>;
  /** JSON payload with extra information about the deployment. */
  payload?: InputMaybe<Scalars['String']['input']>;
  /** The node ID of the ref to be deployed. */
  refId: Scalars['ID']['input'];
  /** The node ID of the repository. */
  repositoryId: Scalars['ID']['input'];
  /**
   * The status contexts to verify against commit status checks. To bypass required
   * contexts, pass an empty array. Defaults to all unique contexts.
   */
  requiredContexts?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Specifies a task to execute. */
  task?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateDeployment. */
export type CreateDeploymentPayload = {
  __typename?: 'CreateDeploymentPayload';
  /** True if the default branch has been auto-merged into the deployment ref. */
  autoMerged?: Maybe<Scalars['Boolean']['output']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The new deployment. */
  deployment?: Maybe<Deployment>;
};

/** Autogenerated input type of CreateDeploymentStatus */
export type CreateDeploymentStatusInput = {
  /**
   * Adds a new inactive status to all non-transient, non-production environment
   * deployments with the same repository and environment name as the created
   * status's deployment.
   */
  autoInactive?: InputMaybe<Scalars['Boolean']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The node ID of the deployment. */
  deploymentId: Scalars['ID']['input'];
  /** A short description of the status. Maximum length of 140 characters. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** If provided, updates the environment of the deploy. Otherwise, does not modify the environment. */
  environment?: InputMaybe<Scalars['String']['input']>;
  /** Sets the URL for accessing your environment. */
  environmentUrl?: InputMaybe<Scalars['String']['input']>;
  /**
   * The log URL to associate with this status.       This URL should contain
   * output to keep the user updated while the task is running       or serve as
   * historical information for what happened in the deployment.
   */
  logUrl?: InputMaybe<Scalars['String']['input']>;
  /** The state of the deployment. */
  state: DeploymentStatusState;
};

/** Autogenerated return type of CreateDeploymentStatus. */
export type CreateDeploymentStatusPayload = {
  __typename?: 'CreateDeploymentStatusPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The new deployment status. */
  deploymentStatus?: Maybe<DeploymentStatus>;
};

/** Autogenerated input type of CreateDiscussion */
export type CreateDiscussionInput = {
  /** The body of the discussion. */
  body: Scalars['String']['input'];
  /** The id of the discussion category to associate with this discussion. */
  categoryId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the repository on which to create the discussion. */
  repositoryId: Scalars['ID']['input'];
  /** The title of the discussion. */
  title: Scalars['String']['input'];
};

/** Autogenerated return type of CreateDiscussion. */
export type CreateDiscussionPayload = {
  __typename?: 'CreateDiscussionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The discussion that was just created. */
  discussion?: Maybe<Discussion>;
};

/** Autogenerated input type of CreateEnterpriseOrganization */
export type CreateEnterpriseOrganizationInput = {
  /**
   * The logins of additional organization owners. Listed users are invited unless
   * owner invitations are disabled, in which case they are added directly.
   * Installation requests also add existing enterprise members directly.
   */
  adminLogins: Array<Scalars['String']['input']>;
  /** The email used for sending billing receipts. */
  billingEmail: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the enterprise owning the new organization. */
  enterpriseId: Scalars['ID']['input'];
  /** The login of the new organization. */
  login: Scalars['String']['input'];
  /** The profile name of the new organization. */
  profileName: Scalars['String']['input'];
};

/** Autogenerated return type of CreateEnterpriseOrganization. */
export type CreateEnterpriseOrganizationPayload = {
  __typename?: 'CreateEnterpriseOrganizationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The enterprise that owns the created organization. */
  enterprise?: Maybe<Enterprise>;
  /** The organization that was created. */
  organization?: Maybe<Organization>;
};

/** Autogenerated input type of CreateEnvironment */
export type CreateEnvironmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The name of the environment. */
  name: Scalars['String']['input'];
  /** The node ID of the repository. */
  repositoryId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateEnvironment. */
export type CreateEnvironmentPayload = {
  __typename?: 'CreateEnvironmentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The new or existing environment. */
  environment?: Maybe<Environment>;
};

/** Autogenerated input type of CreateIpAllowListEntry */
export type CreateIpAllowListEntryInput = {
  /**
   * An IP address or range of addresses in CIDR notation. Ranges that cover the
   * entire address space, such as `0.0.0.0/0` or `::/0`, are not accepted for
   * organizations or enterprises.
   */
  allowListValue: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Whether the IP allow list entry is active when an IP allow list is enabled. */
  isActive: Scalars['Boolean']['input'];
  /** An optional name for the IP allow list entry. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the owner for which to create the new IP allow list entry. */
  ownerId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateIpAllowListEntry. */
export type CreateIpAllowListEntryPayload = {
  __typename?: 'CreateIpAllowListEntryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The IP allow list entry that was created. */
  ipAllowListEntry?: Maybe<IpAllowListEntry>;
};

/** Autogenerated input type of CreateIssueField */
export type CreateIssueFieldInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The data type of the issue field. */
  dataType: IssueFieldDataType;
  /** A description of the issue field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The name of the issue field. */
  name: Scalars['String']['input'];
  /** The options for the issue field if applicable. */
  options?: InputMaybe<Array<IssueFieldSingleSelectOptionInput>>;
  /** The ID of the organization where the issue field will be created. */
  ownerId: Scalars['ID']['input'];
  /** The visibility of the issue field. */
  visibility?: InputMaybe<IssueFieldVisibility>;
};

/** Autogenerated return type of CreateIssueField. */
export type CreateIssueFieldPayload = {
  __typename?: 'CreateIssueFieldPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The newly created issue field. */
  issueField?: Maybe<IssueFields>;
};

/** Autogenerated input type of CreateIssueFieldValue */
export type CreateIssueFieldValueInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The field value to create. */
  issueField: IssueFieldCreateOrUpdateInput;
  /** The ID of the issue. */
  issueId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateIssueFieldValue. */
export type CreateIssueFieldValuePayload = {
  __typename?: 'CreateIssueFieldValuePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The issue object. */
  issue?: Maybe<Issue>;
  /** The newly created issue field value. */
  issueFieldValue?: Maybe<IssueFieldValue>;
};

/** Autogenerated input type of CreateIssue */
export type CreateIssueInput = {
  /** Configuration for assigning Copilot to this issue. */
  agentAssignment?: InputMaybe<AgentAssignmentInput>;
  /** The Node ID of assignees for this issue. */
  assigneeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The body for the issue description. */
  body?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An array of issue fields to set on the issue during creation */
  issueFields?: InputMaybe<Array<IssueFieldCreateOrUpdateInput>>;
  /** The name of an issue template in the repository, assigns labels and assignees from the template to the issue */
  issueTemplate?: InputMaybe<Scalars['String']['input']>;
  /** The Node ID of the issue type for this issue */
  issueTypeId?: InputMaybe<Scalars['ID']['input']>;
  /** An array of Node IDs of labels for this issue. */
  labelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The Node ID of the milestone for this issue. */
  milestoneId?: InputMaybe<Scalars['ID']['input']>;
  /** The Node ID of the parent issue to add this new issue to */
  parentIssueId?: InputMaybe<Scalars['ID']['input']>;
  /** An array of Node IDs for projects associated with this issue. */
  projectIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** An array of Node IDs for Projects V2 associated with this issue. */
  projectV2Ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The Node ID of the repository. */
  repositoryId: Scalars['ID']['input'];
  /** The title for the issue. */
  title: Scalars['String']['input'];
};

/** Autogenerated return type of CreateIssue. */
export type CreateIssuePayload = {
  __typename?: 'CreateIssuePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The new issue. */
  issue?: Maybe<Issue>;
};

/** Autogenerated input type of CreateIssueType */
export type CreateIssueTypeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Color for the issue type */
  color?: InputMaybe<IssueTypeColor>;
  /** Description of the new issue type */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Whether or not the issue type is enabled on the org level */
  isEnabled: Scalars['Boolean']['input'];
  /** Name of the new issue type */
  name: Scalars['String']['input'];
  /** The ID for the organization on which the issue type is created */
  ownerId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateIssueType. */
export type CreateIssueTypePayload = {
  __typename?: 'CreateIssueTypePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The newly created issue type */
  issueType?: Maybe<IssueType>;
};

/** Autogenerated input type of CreateLabel */
export type CreateLabelInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** A 6 character hex code, without the leading #, identifying the color of the label. */
  color: Scalars['String']['input'];
  /** A brief description of the label, such as its purpose. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The name of the label. */
  name: Scalars['String']['input'];
  /** The Node ID of the repository. */
  repositoryId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateLabel. */
export type CreateLabelPayload = {
  __typename?: 'CreateLabelPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The new label. */
  label?: Maybe<Label>;
};

/** Autogenerated input type of CreateLinkedBranch */
export type CreateLinkedBranchInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the issue to link to. */
  issueId: Scalars['ID']['input'];
  /** The name of the new branch. Defaults to issue number and title. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The commit SHA to base the new branch on. */
  oid: Scalars['GitObjectID']['input'];
  /** ID of the repository to create the branch in. Defaults to the issue repository. */
  repositoryId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateLinkedBranch. */
export type CreateLinkedBranchPayload = {
  __typename?: 'CreateLinkedBranchPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The issue that was linked to. */
  issue?: Maybe<Issue>;
  /** The new branch issue reference. */
  linkedBranch?: Maybe<LinkedBranch>;
};

/** Autogenerated input type of CreateMigrationSource */
export type CreateMigrationSourceInput = {
  /** The migration source access token. */
  accessToken?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The GitHub personal access token of the user importing to the target repository. */
  githubPat?: InputMaybe<Scalars['String']['input']>;
  /** The migration source name. */
  name: Scalars['String']['input'];
  /** The ID of the organization that will own the migration source. */
  ownerId: Scalars['ID']['input'];
  /** The migration source type. */
  type: MigrationSourceType;
  /** The migration source URL, for example `https://github.com` or `https://monalisa.ghe.com`. */
  url?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateMigrationSource. */
export type CreateMigrationSourcePayload = {
  __typename?: 'CreateMigrationSourcePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The created migration source. */
  migrationSource?: Maybe<MigrationSource>;
};

/** Autogenerated input type of CreateProject */
export type CreateProjectInput = {
  /** The description of project. */
  body?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The name of project. */
  name: Scalars['String']['input'];
  /** The owner ID to create the project under. */
  ownerId: Scalars['ID']['input'];
  /** A list of repository IDs to create as linked repositories for the project */
  repositoryIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The name of the GitHub-provided template. */
  template?: InputMaybe<ProjectTemplate>;
};

/** Autogenerated return type of CreateProject. */
export type CreateProjectPayload = {
  __typename?: 'CreateProjectPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The new project. */
  project?: Maybe<Project>;
};

/** Autogenerated input type of CreateProjectV2Field */
export type CreateProjectV2FieldInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The data type of the field. */
  dataType: ProjectV2CustomFieldType;
  /** Configuration for an iteration field. */
  iterationConfiguration?: InputMaybe<ProjectV2IterationFieldConfigurationInput>;
  /** Options for a multi select field. At least one value is required if data_type is MULTI_SELECT */
  multiSelectOptions?: InputMaybe<Array<ProjectV2MultiSelectFieldOptionInput>>;
  /** The name of the field. */
  name: Scalars['String']['input'];
  /** The ID of the Project to create the field in. */
  projectId: Scalars['ID']['input'];
  /** Options for a single select field. At least one value is required if data_type is SINGLE_SELECT */
  singleSelectOptions?: InputMaybe<Array<ProjectV2SingleSelectFieldOptionInput>>;
};

/** Autogenerated return type of CreateProjectV2Field. */
export type CreateProjectV2FieldPayload = {
  __typename?: 'CreateProjectV2FieldPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The new field. */
  projectV2Field?: Maybe<ProjectV2FieldConfiguration>;
};

/** Autogenerated input type of CreateProjectV2 */
export type CreateProjectV2Input = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The owner ID to create the project under. */
  ownerId: Scalars['ID']['input'];
  /** The repository to link the project to. */
  repositoryId?: InputMaybe<Scalars['ID']['input']>;
  /** The team to link the project to. The team will be granted read permissions. */
  teamId?: InputMaybe<Scalars['ID']['input']>;
  /** The title of the project. */
  title: Scalars['String']['input'];
};

/** Autogenerated input type of CreateProjectV2IssueField */
export type CreateProjectV2IssueFieldInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the IssueField to create the field for. */
  issueFieldId: Scalars['ID']['input'];
  /** The ID of the Project to create the field in. */
  projectId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateProjectV2IssueField. */
export type CreateProjectV2IssueFieldPayload = {
  __typename?: 'CreateProjectV2IssueFieldPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The new field. */
  projectV2Field?: Maybe<ProjectV2FieldConfiguration>;
};

/** Autogenerated return type of CreateProjectV2. */
export type CreateProjectV2Payload = {
  __typename?: 'CreateProjectV2Payload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The new project. */
  projectV2?: Maybe<ProjectV2>;
};

/** Autogenerated input type of CreateProjectV2StatusUpdate */
export type CreateProjectV2StatusUpdateInput = {
  /** The body of the status update. */
  body?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the Project to create the status update in. */
  projectId: Scalars['ID']['input'];
  /** The start date of the status update. */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  /** The status of the status update. */
  status?: InputMaybe<ProjectV2StatusUpdateStatus>;
  /** The target date of the status update. */
  targetDate?: InputMaybe<Scalars['Date']['input']>;
};

/** Autogenerated return type of CreateProjectV2StatusUpdate. */
export type CreateProjectV2StatusUpdatePayload = {
  __typename?: 'CreateProjectV2StatusUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The status update updated in the project. */
  statusUpdate?: Maybe<ProjectV2StatusUpdate>;
};

/** Autogenerated input type of CreateProjectV2View */
export type CreateProjectV2ViewInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The configuration for the view. */
  configuration?: InputMaybe<ProjectV2ViewConfigurationInput>;
  /** The layout of the view. */
  layout: ProjectV2ViewLayout;
  /** The name of the view. */
  name: Scalars['String']['input'];
  /** The ID of the project to create a view in. */
  projectId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateProjectV2View. */
export type CreateProjectV2ViewPayload = {
  __typename?: 'CreateProjectV2ViewPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The new view. */
  projectV2View?: Maybe<ProjectV2View>;
};

/** Autogenerated input type of CreatePullRequest */
export type CreatePullRequestInput = {
  /**
   * The name of the branch you want your changes pulled into. This should be an existing branch
   * on the current repository. You cannot update the base branch on a pull request to point
   * to another repository.
   */
  baseRefName: Scalars['String']['input'];
  /** The contents of the pull request. */
  body?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Indicates whether this pull request should be a draft. */
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The name of the branch where your changes are implemented. For cross-repository pull requests
   * in the same network, namespace `head_ref_name` with a user like this: `username:branch`.
   */
  headRefName: Scalars['String']['input'];
  /** The Node ID of the head repository. */
  headRepositoryId?: InputMaybe<Scalars['ID']['input']>;
  /** Indicates whether maintainers can modify the pull request. */
  maintainerCanModify?: InputMaybe<Scalars['Boolean']['input']>;
  /** The Node ID of the repository. */
  repositoryId: Scalars['ID']['input'];
  /** The title of the pull request. */
  title: Scalars['String']['input'];
};

/** Autogenerated return type of CreatePullRequest. */
export type CreatePullRequestPayload = {
  __typename?: 'CreatePullRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The new pull request. */
  pullRequest?: Maybe<PullRequest>;
};

/** Autogenerated input type of CreateRef */
export type CreateRefInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The fully qualified name of the new Ref (ie: `refs/heads/my_new_branch`). */
  name: Scalars['String']['input'];
  /** The GitObjectID that the new Ref shall target. Must point to a commit. */
  oid: Scalars['GitObjectID']['input'];
  /** The Node ID of the Repository to create the Ref in. */
  repositoryId: Scalars['ID']['input'];
};

/** Autogenerated return type of CreateRef. */
export type CreateRefPayload = {
  __typename?: 'CreateRefPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The newly created ref. */
  ref?: Maybe<Ref>;
};

/** Autogenerated input type of CreateRepositoryCustomProperty */
export type CreateRepositoryCustomPropertyInput = {
  /** The allowed values for the custom property. */
  allowedValues?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The default value for the custom property if the property is required. */
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  /** The description of the custom property. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The name of the custom property. */
  propertyName: Scalars['String']['input'];
  /** The regex pattern that the value of the custom property must match, if the `value_type` is `string`. */
  regex?: InputMaybe<Scalars['String']['input']>;
  /** Whether this repository custom property requires explicit values. */
  requireExplicitValues?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the custom property is required. */
  required?: InputMaybe<Scalars['Boolean']['input']>;
  /** The global relay id of the source in which a new custom property should be created in. */
  sourceId: Scalars['ID']['input'];
  /** The value type for the custom property. */
  valueType: CustomPropertyValueType;
  /** The allowed actors who can edit the values of a custom property. */
  valuesEditableBy?: InputMaybe<RepositoryCustomPropertyValuesEditableBy>;
};

/** Autogenerated return type of CreateRepositoryCustomProperty. */
export type CreateRepositoryCustomPropertyPayload = {
  __typename?: 'CreateRepositoryCustomPropertyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The newly created repository custom property. */
  repositoryCustomProperty?: Maybe<RepositoryCustomProperty>;
};

/** Autogenerated input type of CreateRepository */
export type CreateRepositoryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** A short description of the new repository. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Indicates if the repository should have the issues feature enabled. */
  hasIssuesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates if the repository should have the wiki feature enabled. */
  hasWikiEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The URL for a web page about this repository. */
  homepageUrl?: InputMaybe<Scalars['URI']['input']>;
  /** The name of the new repository. */
  name: Scalars['String']['input'];
  /** The ID of the owner for the new repository. */
  ownerId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * When an organization is specified as the owner, this ID identifies the team
   * that should be granted access to the new repository.
   */
  teamId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Whether this repository should be marked as a template such that anyone who
   * can access it can create new repositories with the same files and directory structure.
   */
  template?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates the repository's visibility level. */
  visibility: RepositoryVisibility;
};

/** Autogenerated return type of CreateRepository. */
export type CreateRepositoryPayload = {
  __typename?: 'CreateRepositoryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The new repository. */
  repository?: Maybe<Repository>;
};

/** Autogenerated input type of CreateRepositoryRuleset */
export type CreateRepositoryRulesetInput = {
  /** A list of actors that are allowed to bypass rules in this ruleset. */
  bypassActors?: InputMaybe<Array<RepositoryRulesetBypassActorInput>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The set of conditions for this ruleset */
  conditions: RepositoryRuleConditionsInput;
  /** The enforcement level for this ruleset */
  enforcement: RuleEnforcement;
  /** The name of the ruleset. */
  name: Scalars['String']['input'];
  /** The list of rules for this ruleset */
  rules?: InputMaybe<Array<RepositoryRuleInput>>;
  /** The global relay id of the source in which a new ruleset should be created in. */
  sourceId: Scalars['ID']['input'];
  /** The target of the ruleset. */
  target?: InputMaybe<RepositoryRulesetTarget>;
};

/** Autogenerated return type of CreateRepositoryRuleset. */
export type CreateRepositoryRulesetPayload = {
  __typename?: 'CreateRepositoryRulesetPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The newly created Ruleset. */
  ruleset?: Maybe<RepositoryRuleset>;
};

/** Autogenerated input type of CreateSponsorsListing */
export type CreateSponsorsListingInput = {
  /**
   * The country or region where the sponsorable's bank account is located.
   * Required if fiscalHostLogin is not specified, ignored when fiscalHostLogin is specified.
   */
  billingCountryOrRegionCode?: InputMaybe<SponsorsCountryOrRegionCode>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * The email address we should use to contact you about the GitHub Sponsors
   * profile being created. This will not be shared publicly. Must be a verified
   * email address already on your GitHub account. Only relevant when the
   * sponsorable is yourself. Defaults to your primary email address on file if omitted.
   */
  contactEmail?: InputMaybe<Scalars['String']['input']>;
  /**
   * The username of the supported fiscal host's GitHub organization, if you want
   * to receive sponsorship payouts through a fiscal host rather than directly to a
   * bank account. For example, 'Open-Source-Collective' for Open Source Collective
   * or 'numfocus' for numFOCUS. Case insensitive. See https://docs.github.com/sponsors/receiving-sponsorships-through-github-sponsors/using-a-fiscal-host-to-receive-github-sponsors-payouts
   * for more information.
   */
  fiscalHostLogin?: InputMaybe<Scalars['String']['input']>;
  /**
   * The URL for your profile page on the fiscal host's website, e.g.,
   * https://opencollective.com/babel or https://numfocus.org/project/bokeh.
   * Required if fiscalHostLogin is specified.
   */
  fiscallyHostedProjectProfileUrl?: InputMaybe<Scalars['String']['input']>;
  /**
   * Provide an introduction to serve as the main focus that appears on your GitHub
   * Sponsors profile. It's a great opportunity to help potential sponsors learn
   * more about you, your work, and why their sponsorship is important to you.
   * GitHub-flavored Markdown is supported.
   */
  fullDescription?: InputMaybe<Scalars['String']['input']>;
  /**
   * The country or region where the sponsorable resides. This is for tax purposes.
   * Required if the sponsorable is yourself, ignored when sponsorableLogin
   * specifies an organization.
   */
  residenceCountryOrRegionCode?: InputMaybe<SponsorsCountryOrRegionCode>;
  /**
   * The username of the organization to create a GitHub Sponsors profile for, if
   * desired. Defaults to creating a GitHub Sponsors profile for the authenticated
   * user if omitted.
   */
  sponsorableLogin?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateSponsorsListing. */
export type CreateSponsorsListingPayload = {
  __typename?: 'CreateSponsorsListingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The new GitHub Sponsors profile. */
  sponsorsListing?: Maybe<SponsorsListing>;
};

/** Autogenerated input type of CreateSponsorsTier */
export type CreateSponsorsTierInput = {
  /** The value of the new tier in US dollars. Valid values: 1-12000. */
  amount: Scalars['Int']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** A description of what this tier is, what perks sponsors might receive, what a sponsorship at this tier means for you, etc. */
  description: Scalars['String']['input'];
  /** Whether sponsorships using this tier should happen monthly/yearly or just once. */
  isRecurring?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Whether to make the tier available immediately for sponsors to choose.
   * Defaults to creating a draft tier that will not be publicly visible.
   */
  publish?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Optional ID of the private repository that sponsors at this tier should gain
   * read-only access to. Must be owned by an organization.
   */
  repositoryId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Optional name of the private repository that sponsors at this tier should gain
   * read-only access to. Must be owned by an organization. Necessary if
   * repositoryOwnerLogin is given. Will be ignored if repositoryId is given.
   */
  repositoryName?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optional login of the organization owner of the private repository that
   * sponsors at this tier should gain read-only access to. Necessary if
   * repositoryName is given. Will be ignored if repositoryId is given.
   */
  repositoryOwnerLogin?: InputMaybe<Scalars['String']['input']>;
  /**
   * The ID of the user or organization who owns the GitHub Sponsors profile.
   * Defaults to the current user if omitted and sponsorableLogin is not given.
   */
  sponsorableId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The username of the user or organization who owns the GitHub Sponsors profile.
   * Defaults to the current user if omitted and sponsorableId is not given.
   */
  sponsorableLogin?: InputMaybe<Scalars['String']['input']>;
  /** Optional message new sponsors at this tier will receive. */
  welcomeMessage?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of CreateSponsorsTier. */
export type CreateSponsorsTierPayload = {
  __typename?: 'CreateSponsorsTierPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The new tier. */
  sponsorsTier?: Maybe<SponsorsTier>;
};

/** Autogenerated input type of CreateSponsorship */
export type CreateSponsorshipInput = {
  /** The amount to pay to the sponsorable in US dollars. Required if a tierId is not specified. Valid values: 1-12000. */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Whether the sponsorship should happen monthly/yearly or just this one time. Required if a tierId is not specified. */
  isRecurring?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Specify whether others should be able to see that the sponsor is sponsoring
   * the sponsorable. Public visibility still does not reveal which tier is used.
   */
  privacyLevel?: InputMaybe<SponsorshipPrivacy>;
  /** Whether the sponsor should receive email updates from the sponsorable. */
  receiveEmails?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The ID of the user or organization who is acting as the sponsor, paying for
   * the sponsorship. Required if sponsorLogin is not given.
   */
  sponsorId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The username of the user or organization who is acting as the sponsor, paying
   * for the sponsorship. Required if sponsorId is not given.
   */
  sponsorLogin?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the user or organization who is receiving the sponsorship. Required if sponsorableLogin is not given. */
  sponsorableId?: InputMaybe<Scalars['ID']['input']>;
  /** The username of the user or organization who is receiving the sponsorship. Required if sponsorableId is not given. */
  sponsorableLogin?: InputMaybe<Scalars['String']['input']>;
  /** The ID of one of sponsorable's existing tiers to sponsor at. Required if amount is not specified. */
  tierId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of CreateSponsorship. */
export type CreateSponsorshipPayload = {
  __typename?: 'CreateSponsorshipPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The sponsorship that was started. */
  sponsorship?: Maybe<Sponsorship>;
};

/** Autogenerated input type of CreateSponsorships */
export type CreateSponsorshipsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Specify whether others should be able to see that the sponsor is sponsoring
   * the sponsorables. Public visibility still does not reveal the dollar value of
   * the sponsorship.
   */
  privacyLevel?: InputMaybe<SponsorshipPrivacy>;
  /** Whether the sponsor should receive email updates from the sponsorables. */
  receiveEmails?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Whether the sponsorships created should continue each billing cycle for the
   * sponsor (monthly or annually), versus lasting only a single month. Defaults to
   * one-time sponsorships.
   */
  recurring?: InputMaybe<Scalars['Boolean']['input']>;
  /** The username of the user or organization who is acting as the sponsor, paying for the sponsorships. */
  sponsorLogin: Scalars['String']['input'];
  /** The list of maintainers to sponsor and for how much apiece. */
  sponsorships: Array<BulkSponsorship>;
};

/** Autogenerated return type of CreateSponsorships. */
export type CreateSponsorshipsPayload = {
  __typename?: 'CreateSponsorshipsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The users and organizations who received a sponsorship. */
  sponsorables?: Maybe<Array<Sponsorable>>;
};

/** Autogenerated input type of CreateUserList */
export type CreateUserListInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** A description of the list */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Whether or not the list is private */
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  /** The name of the new list */
  name: Scalars['String']['input'];
};

/** Autogenerated return type of CreateUserList. */
export type CreateUserListPayload = {
  __typename?: 'CreateUserListPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The list that was just created */
  list?: Maybe<UserList>;
  /** The user who created the list */
  viewer?: Maybe<User>;
};

/** Represents the contribution a user made by committing to a repository. */
export type CreatedCommitContribution = Contribution & {
  __typename?: 'CreatedCommitContribution';
  /** How many commits were made on this day to this repository by the user. */
  commitCount: Scalars['Int']['output'];
  /**
   * Whether this contribution is associated with a record you do not have access to. For
   * example, your own 'first issue' contribution may have been made on a repository you can no
   * longer access.
   */
  isRestricted: Scalars['Boolean']['output'];
  /** When this contribution was made. */
  occurredAt: Scalars['DateTime']['output'];
  /** The repository the user made a commit in. */
  repository: Repository;
  /** The HTTP path for this contribution. */
  resourcePath: Scalars['URI']['output'];
  /** The HTTP URL for this contribution. */
  url: Scalars['URI']['output'];
  /** The user who made this contribution. */
  user: User;
};

/** The connection type for CreatedCommitContribution. */
export type CreatedCommitContributionConnection = {
  __typename?: 'CreatedCommitContributionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CreatedCommitContributionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<CreatedCommitContribution>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of commits across days and repositories in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CreatedCommitContributionEdge = {
  __typename?: 'CreatedCommitContributionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<CreatedCommitContribution>;
};

/** Represents the contribution a user made on GitHub by opening an issue. */
export type CreatedIssueContribution = Contribution & {
  __typename?: 'CreatedIssueContribution';
  /**
   * Whether this contribution is associated with a record you do not have access to. For
   * example, your own 'first issue' contribution may have been made on a repository you can no
   * longer access.
   */
  isRestricted: Scalars['Boolean']['output'];
  /** The issue that was opened. */
  issue: Issue;
  /** When this contribution was made. */
  occurredAt: Scalars['DateTime']['output'];
  /** The HTTP path for this contribution. */
  resourcePath: Scalars['URI']['output'];
  /** The HTTP URL for this contribution. */
  url: Scalars['URI']['output'];
  /** The user who made this contribution. */
  user: User;
};

/** The connection type for CreatedIssueContribution. */
export type CreatedIssueContributionConnection = {
  __typename?: 'CreatedIssueContributionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CreatedIssueContributionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<CreatedIssueContribution>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CreatedIssueContributionEdge = {
  __typename?: 'CreatedIssueContributionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<CreatedIssueContribution>;
};

/** Represents either a issue the viewer can access or a restricted contribution. */
export type CreatedIssueOrRestrictedContribution = CreatedIssueContribution | RestrictedContribution;

/** Represents the contribution a user made on GitHub by opening a pull request. */
export type CreatedPullRequestContribution = Contribution & {
  __typename?: 'CreatedPullRequestContribution';
  /**
   * Whether this contribution is associated with a record you do not have access to. For
   * example, your own 'first issue' contribution may have been made on a repository you can no
   * longer access.
   */
  isRestricted: Scalars['Boolean']['output'];
  /** When this contribution was made. */
  occurredAt: Scalars['DateTime']['output'];
  /** The pull request that was opened. */
  pullRequest: PullRequest;
  /** The HTTP path for this contribution. */
  resourcePath: Scalars['URI']['output'];
  /** The HTTP URL for this contribution. */
  url: Scalars['URI']['output'];
  /** The user who made this contribution. */
  user: User;
};

/** The connection type for CreatedPullRequestContribution. */
export type CreatedPullRequestContributionConnection = {
  __typename?: 'CreatedPullRequestContributionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CreatedPullRequestContributionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<CreatedPullRequestContribution>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CreatedPullRequestContributionEdge = {
  __typename?: 'CreatedPullRequestContributionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<CreatedPullRequestContribution>;
};

/** Represents either a pull request the viewer can access or a restricted contribution. */
export type CreatedPullRequestOrRestrictedContribution = CreatedPullRequestContribution | RestrictedContribution;

/** Represents the contribution a user made by leaving a review on a pull request. */
export type CreatedPullRequestReviewContribution = Contribution & {
  __typename?: 'CreatedPullRequestReviewContribution';
  /**
   * Whether this contribution is associated with a record you do not have access to. For
   * example, your own 'first issue' contribution may have been made on a repository you can no
   * longer access.
   */
  isRestricted: Scalars['Boolean']['output'];
  /** When this contribution was made. */
  occurredAt: Scalars['DateTime']['output'];
  /** The pull request the user reviewed. */
  pullRequest: PullRequest;
  /** The review the user left on the pull request. */
  pullRequestReview: PullRequestReview;
  /** The repository containing the pull request that the user reviewed. */
  repository: Repository;
  /** The HTTP path for this contribution. */
  resourcePath: Scalars['URI']['output'];
  /** The HTTP URL for this contribution. */
  url: Scalars['URI']['output'];
  /** The user who made this contribution. */
  user: User;
};

/** The connection type for CreatedPullRequestReviewContribution. */
export type CreatedPullRequestReviewContributionConnection = {
  __typename?: 'CreatedPullRequestReviewContributionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CreatedPullRequestReviewContributionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<CreatedPullRequestReviewContribution>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CreatedPullRequestReviewContributionEdge = {
  __typename?: 'CreatedPullRequestReviewContributionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<CreatedPullRequestReviewContribution>;
};

/** Represents the contribution a user made on GitHub by creating a repository. */
export type CreatedRepositoryContribution = Contribution & {
  __typename?: 'CreatedRepositoryContribution';
  /**
   * Whether this contribution is associated with a record you do not have access to. For
   * example, your own 'first issue' contribution may have been made on a repository you can no
   * longer access.
   */
  isRestricted: Scalars['Boolean']['output'];
  /** When this contribution was made. */
  occurredAt: Scalars['DateTime']['output'];
  /** The repository that was created. */
  repository: Repository;
  /** The HTTP path for this contribution. */
  resourcePath: Scalars['URI']['output'];
  /** The HTTP URL for this contribution. */
  url: Scalars['URI']['output'];
  /** The user who made this contribution. */
  user: User;
};

/** The connection type for CreatedRepositoryContribution. */
export type CreatedRepositoryContributionConnection = {
  __typename?: 'CreatedRepositoryContributionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<CreatedRepositoryContributionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<CreatedRepositoryContribution>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type CreatedRepositoryContributionEdge = {
  __typename?: 'CreatedRepositoryContributionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<CreatedRepositoryContribution>;
};

/** Represents either a repository the viewer can access or a restricted contribution. */
export type CreatedRepositoryOrRestrictedContribution = CreatedRepositoryContribution | RestrictedContribution;

/** Represents a mention made by one issue or pull request to another. */
export type CrossReferencedEvent = Node & UniformResourceLocatable & {
  __typename?: 'CrossReferencedEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The Node ID of the CrossReferencedEvent object */
  id: Scalars['ID']['output'];
  /** Reference originated in a different repository. */
  isCrossRepository: Scalars['Boolean']['output'];
  /** Identifies when the reference was made. */
  referencedAt: Scalars['DateTime']['output'];
  /** The HTTP path for this pull request. */
  resourcePath: Scalars['URI']['output'];
  /** Issue or pull request that made the reference. */
  source: ReferencedSubject;
  /** Issue or pull request to which the reference was made. */
  target: ReferencedSubject;
  /** The HTTP URL for this pull request. */
  url: Scalars['URI']['output'];
  /** Checks if the target will be closed when the source is merged. */
  willCloseTarget: Scalars['Boolean']['output'];
};

/** Sources which can have custom properties defined. */
export type CustomPropertySource = Enterprise | Organization;

/** The custom property name and value to be set. */
export type CustomPropertyValueInput = {
  /** The name of the custom property. */
  propertyName: Scalars['String']['input'];
  /**
   * The value to set for the custom property. Using a value of null will unset the
   * property value, reverting to the default value if the property is required.
   */
  value?: InputMaybe<Scalars['CustomPropertyValue']['input']>;
};

/** The allowed value types for a custom property definition. */
export enum CustomPropertyValueType {
  /** A multi-select value. */
  MultiSelect = 'MULTI_SELECT',
  /** A single-select value. */
  SingleSelect = 'SINGLE_SELECT',
  /** A string value. */
  String = 'STRING',
  /** A true/false value. */
  TrueFalse = 'TRUE_FALSE',
  /** A URL value. */
  Url = 'URL'
}

/** The Common Vulnerability Scoring System */
export type CvssSeverities = {
  __typename?: 'CvssSeverities';
  /** The CVSS v3 severity associated with this advisory */
  cvssV3?: Maybe<Cvss>;
  /** The CVSS v4 severity associated with this advisory */
  cvssV4?: Maybe<Cvss>;
};

/** Autogenerated input type of DeclineTopicSuggestion */
export type DeclineTopicSuggestionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * The name of the suggested topic.
   *
   * **Upcoming Change on 2024-04-01 UTC**
   * **Description:** `name` will be removed.
   * **Reason:** Suggested topics are no longer supported
   */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * The reason why the suggested topic is declined.
   *
   * **Upcoming Change on 2024-04-01 UTC**
   * **Description:** `reason` will be removed.
   * **Reason:** Suggested topics are no longer supported
   */
  reason?: InputMaybe<TopicSuggestionDeclineReason>;
  /**
   * The Node ID of the repository.
   *
   * **Upcoming Change on 2024-04-01 UTC**
   * **Description:** `repositoryId` will be removed.
   * **Reason:** Suggested topics are no longer supported
   */
  repositoryId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of DeclineTopicSuggestion. */
export type DeclineTopicSuggestionPayload = {
  __typename?: 'DeclineTopicSuggestionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /**
   * The declined topic.
   * @deprecated Suggested topics are no longer supported Removal on 2024-04-01 UTC.
   */
  topic?: Maybe<Topic>;
};

/** The possible base permissions for repositories. */
export enum DefaultRepositoryPermissionField {
  /** Can read, write, and administrate repos by default */
  Admin = 'ADMIN',
  /** No access */
  None = 'NONE',
  /** Can read repos by default */
  Read = 'READ',
  /** Can read and write repos by default */
  Write = 'WRITE'
}

/** Entities that can be deleted. */
export type Deletable = {
  /** Check if the current viewer can delete this object. */
  viewerCanDelete: Scalars['Boolean']['output'];
};

/** Autogenerated input type of DeleteBranchProtectionRule */
export type DeleteBranchProtectionRuleInput = {
  /** The global relay id of the branch protection rule to be deleted. */
  branchProtectionRuleId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DeleteBranchProtectionRule. */
export type DeleteBranchProtectionRulePayload = {
  __typename?: 'DeleteBranchProtectionRulePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of DeleteDeployment */
export type DeleteDeploymentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Node ID of the deployment to be deleted. */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteDeployment. */
export type DeleteDeploymentPayload = {
  __typename?: 'DeleteDeploymentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of DeleteDiscussionComment */
export type DeleteDiscussionCommentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Node id of the discussion comment to delete. */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteDiscussionComment. */
export type DeleteDiscussionCommentPayload = {
  __typename?: 'DeleteDiscussionCommentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The discussion comment that was just deleted. */
  comment?: Maybe<DiscussionComment>;
};

/** Autogenerated input type of DeleteDiscussion */
export type DeleteDiscussionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the discussion to delete. */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteDiscussion. */
export type DeleteDiscussionPayload = {
  __typename?: 'DeleteDiscussionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The discussion that was just deleted. */
  discussion?: Maybe<Discussion>;
};

/** Autogenerated input type of DeleteEnvironment */
export type DeleteEnvironmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Node ID of the environment to be deleted. */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteEnvironment. */
export type DeleteEnvironmentPayload = {
  __typename?: 'DeleteEnvironmentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of DeleteIpAllowListEntry */
export type DeleteIpAllowListEntryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the IP allow list entry to delete. */
  ipAllowListEntryId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteIpAllowListEntry. */
export type DeleteIpAllowListEntryPayload = {
  __typename?: 'DeleteIpAllowListEntryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The IP allow list entry that was deleted. */
  ipAllowListEntry?: Maybe<IpAllowListEntry>;
};

/** Autogenerated input type of DeleteIssueComment */
export type DeleteIssueCommentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the comment to delete. */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteIssueComment. */
export type DeleteIssueCommentPayload = {
  __typename?: 'DeleteIssueCommentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of DeleteIssueField */
export type DeleteIssueFieldInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the field to delete. */
  fieldId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteIssueField. */
export type DeleteIssueFieldPayload = {
  __typename?: 'DeleteIssueFieldPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The deleted issue field. */
  issueField?: Maybe<IssueFields>;
};

/** Autogenerated input type of DeleteIssueFieldValue */
export type DeleteIssueFieldValueInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the field to delete. */
  fieldId: Scalars['ID']['input'];
  /** The ID of the issue. */
  issueId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteIssueFieldValue. */
export type DeleteIssueFieldValuePayload = {
  __typename?: 'DeleteIssueFieldValuePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The issue object. */
  issue?: Maybe<Issue>;
  /** Whether the field value was successfully deleted. */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of DeleteIssue */
export type DeleteIssueInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the issue to delete. */
  issueId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteIssue. */
export type DeleteIssuePayload = {
  __typename?: 'DeleteIssuePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The repository the issue belonged to */
  repository?: Maybe<Repository>;
};

/** Autogenerated input type of DeleteIssueType */
export type DeleteIssueTypeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the issue type to delete */
  issueTypeId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteIssueType. */
export type DeleteIssueTypePayload = {
  __typename?: 'DeleteIssueTypePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The ID of the deleted issue type */
  deletedIssueTypeId?: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated input type of DeleteLabel */
export type DeleteLabelInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Node ID of the label to be deleted. */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteLabel. */
export type DeleteLabelPayload = {
  __typename?: 'DeleteLabelPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of DeleteLinkedBranch */
export type DeleteLinkedBranchInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the linked branch */
  linkedBranchId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteLinkedBranch. */
export type DeleteLinkedBranchPayload = {
  __typename?: 'DeleteLinkedBranchPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The issue the linked branch was unlinked from. */
  issue?: Maybe<Issue>;
};

/** Autogenerated input type of DeletePackageVersion */
export type DeletePackageVersionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the package version to be deleted. */
  packageVersionId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeletePackageVersion. */
export type DeletePackageVersionPayload = {
  __typename?: 'DeletePackageVersionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Whether or not the operation succeeded. */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Autogenerated input type of DeleteProjectCard */
export type DeleteProjectCardInput = {
  /** The id of the card to delete. */
  cardId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of DeleteProjectCard. */
export type DeleteProjectCardPayload = {
  __typename?: 'DeleteProjectCardPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The column the deleted card was in. */
  column?: Maybe<ProjectColumn>;
  /** The deleted card ID. */
  deletedCardId?: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated input type of DeleteProjectColumn */
export type DeleteProjectColumnInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the column to delete. */
  columnId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteProjectColumn. */
export type DeleteProjectColumnPayload = {
  __typename?: 'DeleteProjectColumnPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The deleted column ID. */
  deletedColumnId?: Maybe<Scalars['ID']['output']>;
  /** The project the deleted column was in. */
  project?: Maybe<Project>;
};

/** Autogenerated input type of DeleteProject */
export type DeleteProjectInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Project ID to update. */
  projectId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteProject. */
export type DeleteProjectPayload = {
  __typename?: 'DeleteProjectPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The repository or organization the project was removed from. */
  owner?: Maybe<ProjectOwner>;
};

/** Autogenerated input type of DeleteProjectV2Field */
export type DeleteProjectV2FieldInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the field to delete. */
  fieldId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteProjectV2Field. */
export type DeleteProjectV2FieldPayload = {
  __typename?: 'DeleteProjectV2FieldPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The deleted field. */
  projectV2Field?: Maybe<ProjectV2FieldConfiguration>;
};

/** Autogenerated input type of DeleteProjectV2 */
export type DeleteProjectV2Input = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the Project to delete. */
  projectId: Scalars['ID']['input'];
};

/** Autogenerated input type of DeleteProjectV2Item */
export type DeleteProjectV2ItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the item to be removed. */
  itemId: Scalars['ID']['input'];
  /** The ID of the Project from which the item should be removed. */
  projectId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteProjectV2Item. */
export type DeleteProjectV2ItemPayload = {
  __typename?: 'DeleteProjectV2ItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The ID of the deleted item. */
  deletedItemId?: Maybe<Scalars['ID']['output']>;
};

/** Autogenerated return type of DeleteProjectV2. */
export type DeleteProjectV2Payload = {
  __typename?: 'DeleteProjectV2Payload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The deleted Project. */
  projectV2?: Maybe<ProjectV2>;
};

/** Autogenerated input type of DeleteProjectV2StatusUpdate */
export type DeleteProjectV2StatusUpdateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the status update to be removed. */
  statusUpdateId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteProjectV2StatusUpdate. */
export type DeleteProjectV2StatusUpdatePayload = {
  __typename?: 'DeleteProjectV2StatusUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The ID of the deleted status update. */
  deletedStatusUpdateId?: Maybe<Scalars['ID']['output']>;
  /** The project the deleted status update was in. */
  projectV2?: Maybe<ProjectV2>;
};

/** Autogenerated input type of DeleteProjectV2View */
export type DeleteProjectV2ViewInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the view to delete. */
  viewId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteProjectV2View. */
export type DeleteProjectV2ViewPayload = {
  __typename?: 'DeleteProjectV2ViewPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The deleted view. */
  projectV2View?: Maybe<ProjectV2View>;
};

/** Autogenerated input type of DeleteProjectV2Workflow */
export type DeleteProjectV2WorkflowInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the workflow to be removed. */
  workflowId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteProjectV2Workflow. */
export type DeleteProjectV2WorkflowPayload = {
  __typename?: 'DeleteProjectV2WorkflowPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The ID of the deleted workflow. */
  deletedWorkflowId?: Maybe<Scalars['ID']['output']>;
  /** The project the deleted workflow was in. */
  projectV2?: Maybe<ProjectV2>;
};

/** Autogenerated input type of DeletePullRequestReviewComment */
export type DeletePullRequestReviewCommentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the comment to delete. */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeletePullRequestReviewComment. */
export type DeletePullRequestReviewCommentPayload = {
  __typename?: 'DeletePullRequestReviewCommentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The pull request review the deleted comment belonged to. */
  pullRequestReview?: Maybe<PullRequestReview>;
  /** The deleted pull request review comment. */
  pullRequestReviewComment?: Maybe<PullRequestReviewComment>;
};

/** Autogenerated input type of DeletePullRequestReview */
export type DeletePullRequestReviewInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Node ID of the pull request review to delete. */
  pullRequestReviewId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeletePullRequestReview. */
export type DeletePullRequestReviewPayload = {
  __typename?: 'DeletePullRequestReviewPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The deleted pull request review. */
  pullRequestReview?: Maybe<PullRequestReview>;
};

/** Autogenerated input type of DeleteRef */
export type DeleteRefInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Node ID of the Ref to be deleted. */
  refId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteRef. */
export type DeleteRefPayload = {
  __typename?: 'DeleteRefPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of DeleteRepositoryCustomProperty */
export type DeleteRepositoryCustomPropertyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The global relay id of the custom property to be deleted. */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteRepositoryCustomProperty. */
export type DeleteRepositoryCustomPropertyPayload = {
  __typename?: 'DeleteRepositoryCustomPropertyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The deleted custom property. */
  repositoryCustomProperty?: Maybe<RepositoryCustomProperty>;
};

/** Autogenerated input type of DeleteRepositoryRuleset */
export type DeleteRepositoryRulesetInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The global relay id of the repository ruleset to be deleted. */
  repositoryRulesetId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteRepositoryRuleset. */
export type DeleteRepositoryRulesetPayload = {
  __typename?: 'DeleteRepositoryRulesetPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of DeleteUserList */
export type DeleteUserListInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the list to delete. */
  listId: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteUserList. */
export type DeleteUserListPayload = {
  __typename?: 'DeleteUserListPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The owner of the list that will be deleted */
  user?: Maybe<User>;
};

/** Autogenerated input type of DeleteVerifiableDomain */
export type DeleteVerifiableDomainInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the verifiable domain to delete. */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DeleteVerifiableDomain. */
export type DeleteVerifiableDomainPayload = {
  __typename?: 'DeleteVerifiableDomainPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The owning account from which the domain was deleted. */
  owner?: Maybe<VerifiableDomainOwner>;
};

/** Represents a 'demilestoned' event on a given issue or pull request. */
export type DemilestonedEvent = Node & {
  __typename?: 'DemilestonedEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The Node ID of the DemilestonedEvent object */
  id: Scalars['ID']['output'];
  /** Identifies the milestone title associated with the 'demilestoned' event. */
  milestoneTitle: Scalars['String']['output'];
  /** Object referenced by event. */
  subject: MilestoneItem;
};

/** A Dependabot Update for a dependency in a repository */
export type DependabotUpdate = RepositoryNode & {
  __typename?: 'DependabotUpdate';
  /** The error from a dependency update */
  error?: Maybe<DependabotUpdateError>;
  /** The associated pull request */
  pullRequest?: Maybe<PullRequest>;
  /** The repository associated with this node. */
  repository: Repository;
};

/** An error produced from a Dependabot Update */
export type DependabotUpdateError = {
  __typename?: 'DependabotUpdateError';
  /** The body of the error */
  body: Scalars['String']['output'];
  /** The error code */
  errorType: Scalars['String']['output'];
  /** The title of the error */
  title: Scalars['String']['output'];
};

/** A dependency manifest entry */
export type DependencyGraphDependency = {
  __typename?: 'DependencyGraphDependency';
  /** Does the dependency itself have dependencies? */
  hasDependencies: Scalars['Boolean']['output'];
  /**
   * The original name of the package, as it appears in the manifest.
   * @deprecated `packageLabel` will be removed. Use normalized `packageName` field instead. Removal on 2022-10-01 UTC.
   */
  packageLabel: Scalars['String']['output'];
  /** The dependency package manager */
  packageManager?: Maybe<Scalars['String']['output']>;
  /** The name of the package in the canonical form used by the package manager. */
  packageName: Scalars['String']['output'];
  /** Public preview: The dependency package URL */
  packageUrl?: Maybe<Scalars['URI']['output']>;
  /** Public preview: The relationship of the dependency. Can be direct, transitive, or unknown */
  relationship: Scalars['String']['output'];
  /** The repository containing the package */
  repository?: Maybe<Repository>;
  /** The dependency version requirements */
  requirements: Scalars['String']['output'];
};

/** The connection type for DependencyGraphDependency. */
export type DependencyGraphDependencyConnection = {
  __typename?: 'DependencyGraphDependencyConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DependencyGraphDependencyEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<DependencyGraphDependency>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DependencyGraphDependencyEdge = {
  __typename?: 'DependencyGraphDependencyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DependencyGraphDependency>;
};

/** The possible ecosystems of a dependency graph package. */
export enum DependencyGraphEcosystem {
  /** GitHub Actions */
  Actions = 'ACTIONS',
  /** PHP packages hosted at packagist.org */
  Composer = 'COMPOSER',
  /** Go modules */
  Go = 'GO',
  /** Java artifacts hosted at the Maven central repository */
  Maven = 'MAVEN',
  /** JavaScript packages hosted at npmjs.com */
  Npm = 'NPM',
  /** .NET packages hosted at the NuGet Gallery */
  Nuget = 'NUGET',
  /** Python packages hosted at PyPI.org */
  Pip = 'PIP',
  /** Dart packages hosted at pub.dev */
  Pub = 'PUB',
  /** Ruby gems hosted at RubyGems.org */
  Rubygems = 'RUBYGEMS',
  /** Rust crates */
  Rust = 'RUST',
  /** Swift packages */
  Swift = 'SWIFT'
}

/** Dependency manifest for a repository */
export type DependencyGraphManifest = Node & {
  __typename?: 'DependencyGraphManifest';
  /** Path to view the manifest file blob */
  blobPath: Scalars['String']['output'];
  /** A list of manifest dependencies */
  dependencies?: Maybe<DependencyGraphDependencyConnection>;
  /** The number of dependencies listed in the manifest */
  dependenciesCount?: Maybe<Scalars['Int']['output']>;
  /** Is the manifest too big to parse? */
  exceedsMaxSize: Scalars['Boolean']['output'];
  /** Fully qualified manifest filename */
  filename: Scalars['String']['output'];
  /** The Node ID of the DependencyGraphManifest object */
  id: Scalars['ID']['output'];
  /** Were we able to parse the manifest? */
  parseable: Scalars['Boolean']['output'];
  /** The repository containing the manifest */
  repository: Repository;
};


/** Dependency manifest for a repository */
export type DependencyGraphManifestDependenciesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for DependencyGraphManifest. */
export type DependencyGraphManifestConnection = {
  __typename?: 'DependencyGraphManifestConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DependencyGraphManifestEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<DependencyGraphManifest>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DependencyGraphManifestEdge = {
  __typename?: 'DependencyGraphManifestEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DependencyGraphManifest>;
};

/** A repository deploy key. */
export type DeployKey = Node & {
  __typename?: 'DeployKey';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Whether or not the deploy key is enabled by policy at the Enterprise or Organization level. */
  enabled: Scalars['Boolean']['output'];
  /** The Node ID of the DeployKey object */
  id: Scalars['ID']['output'];
  /** The deploy key. */
  key: Scalars['String']['output'];
  /** Whether or not the deploy key is read only. */
  readOnly: Scalars['Boolean']['output'];
  /** The deploy key title. */
  title: Scalars['String']['output'];
  /** Whether or not the deploy key has been verified. */
  verified: Scalars['Boolean']['output'];
};

/** The connection type for DeployKey. */
export type DeployKeyConnection = {
  __typename?: 'DeployKeyConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DeployKeyEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<DeployKey>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeployKeyEdge = {
  __typename?: 'DeployKeyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DeployKey>;
};

/** Represents a 'deployed' event on a given pull request. */
export type DeployedEvent = Node & {
  __typename?: 'DeployedEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Identifies the primary key from the database. */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** The deployment associated with the 'deployed' event. */
  deployment: Deployment;
  /** The Node ID of the DeployedEvent object */
  id: Scalars['ID']['output'];
  /** PullRequest referenced by event. */
  pullRequest: PullRequest;
  /** The ref associated with the 'deployed' event. */
  ref?: Maybe<Ref>;
};

/** Represents triggered deployment instance. */
export type Deployment = Node & {
  __typename?: 'Deployment';
  /** Identifies the commit sha of the deployment. */
  commit?: Maybe<Commit>;
  /** Identifies the oid of the deployment commit, even if the commit has been deleted. */
  commitOid: Scalars['String']['output'];
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Identifies the actor who triggered the deployment. */
  creator: Actor;
  /** Identifies the primary key from the database. */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** The deployment description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The latest environment to which this deployment was made. */
  environment?: Maybe<Scalars['String']['output']>;
  /** The Node ID of the Deployment object */
  id: Scalars['ID']['output'];
  /** The latest environment to which this deployment was made. */
  latestEnvironment?: Maybe<Scalars['String']['output']>;
  /** The latest status of this deployment. */
  latestStatus?: Maybe<DeploymentStatus>;
  /** The original environment to which this deployment was made. */
  originalEnvironment?: Maybe<Scalars['String']['output']>;
  /** Extra information that a deployment system might need. */
  payload?: Maybe<Scalars['String']['output']>;
  /** Identifies the Ref of the deployment, if the deployment was created by ref. */
  ref?: Maybe<Ref>;
  /** Identifies the repository associated with the deployment. */
  repository: Repository;
  /** The current state of the deployment. */
  state?: Maybe<DeploymentState>;
  /** A list of statuses associated with the deployment. */
  statuses?: Maybe<DeploymentStatusConnection>;
  /** The deployment task. */
  task?: Maybe<Scalars['String']['output']>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};


/** Represents triggered deployment instance. */
export type DeploymentStatusesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for Deployment. */
export type DeploymentConnection = {
  __typename?: 'DeploymentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DeploymentEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Deployment>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeploymentEdge = {
  __typename?: 'DeploymentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Deployment>;
};

/** Represents a 'deployment_environment_changed' event on a given pull request. */
export type DeploymentEnvironmentChangedEvent = Node & {
  __typename?: 'DeploymentEnvironmentChangedEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The deployment status that updated the deployment environment. */
  deploymentStatus: DeploymentStatus;
  /** The Node ID of the DeploymentEnvironmentChangedEvent object */
  id: Scalars['ID']['output'];
  /** PullRequest referenced by event. */
  pullRequest: PullRequest;
};

/** Ordering options for deployment connections */
export type DeploymentOrder = {
  /** The ordering direction. */
  direction: OrderDirection;
  /** The field to order deployments by. */
  field: DeploymentOrderField;
};

/** Properties by which deployment connections can be ordered. */
export enum DeploymentOrderField {
  /** Order collection by creation time */
  CreatedAt = 'CREATED_AT'
}

/** A protection rule. */
export type DeploymentProtectionRule = {
  __typename?: 'DeploymentProtectionRule';
  /** Identifies the primary key from the database. */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** Whether deployments to this environment can be approved by the user who created the deployment. */
  preventSelfReview?: Maybe<Scalars['Boolean']['output']>;
  /** The teams or users that can review the deployment */
  reviewers: DeploymentReviewerConnection;
  /** The timeout in minutes for this protection rule. */
  timeout: Scalars['Int']['output'];
  /** The type of protection rule. */
  type: DeploymentProtectionRuleType;
};


/** A protection rule. */
export type DeploymentProtectionRuleReviewersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for DeploymentProtectionRule. */
export type DeploymentProtectionRuleConnection = {
  __typename?: 'DeploymentProtectionRuleConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DeploymentProtectionRuleEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<DeploymentProtectionRule>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeploymentProtectionRuleEdge = {
  __typename?: 'DeploymentProtectionRuleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DeploymentProtectionRule>;
};

/** The possible protection rule types. */
export enum DeploymentProtectionRuleType {
  /** Branch policy */
  BranchPolicy = 'BRANCH_POLICY',
  /** Required reviewers */
  RequiredReviewers = 'REQUIRED_REVIEWERS',
  /** Wait timer */
  WaitTimer = 'WAIT_TIMER'
}

/** A request to deploy a workflow run to an environment. */
export type DeploymentRequest = {
  __typename?: 'DeploymentRequest';
  /** Whether or not the current user can approve the deployment */
  currentUserCanApprove: Scalars['Boolean']['output'];
  /** The target environment of the deployment */
  environment: Environment;
  /** The teams or users that can review the deployment */
  reviewers: DeploymentReviewerConnection;
  /** The wait timer in minutes configured in the environment */
  waitTimer: Scalars['Int']['output'];
  /** The wait timer in minutes configured in the environment */
  waitTimerStartedAt?: Maybe<Scalars['DateTime']['output']>;
};


/** A request to deploy a workflow run to an environment. */
export type DeploymentRequestReviewersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for DeploymentRequest. */
export type DeploymentRequestConnection = {
  __typename?: 'DeploymentRequestConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DeploymentRequestEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<DeploymentRequest>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeploymentRequestEdge = {
  __typename?: 'DeploymentRequestEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DeploymentRequest>;
};

/** A deployment review. */
export type DeploymentReview = Node & {
  __typename?: 'DeploymentReview';
  /** The comment the user left. */
  comment: Scalars['String']['output'];
  /** Identifies the primary key from the database. */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** The environments approved or rejected */
  environments: EnvironmentConnection;
  /** The Node ID of the DeploymentReview object */
  id: Scalars['ID']['output'];
  /** The decision of the user. */
  state: DeploymentReviewState;
  /** The user that reviewed the deployment. */
  user: User;
};


/** A deployment review. */
export type DeploymentReviewEnvironmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for DeploymentReview. */
export type DeploymentReviewConnection = {
  __typename?: 'DeploymentReviewConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DeploymentReviewEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<DeploymentReview>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeploymentReviewEdge = {
  __typename?: 'DeploymentReviewEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DeploymentReview>;
};

/** The possible states for a deployment review. */
export enum DeploymentReviewState {
  /** The deployment was approved. */
  Approved = 'APPROVED',
  /** The deployment was rejected. */
  Rejected = 'REJECTED'
}

/** Users and teams. */
export type DeploymentReviewer = Team | User;

/** The connection type for DeploymentReviewer. */
export type DeploymentReviewerConnection = {
  __typename?: 'DeploymentReviewerConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DeploymentReviewerEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<DeploymentReviewer>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeploymentReviewerEdge = {
  __typename?: 'DeploymentReviewerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DeploymentReviewer>;
};

/** The possible states in which a deployment can be. */
export enum DeploymentState {
  /** The pending deployment was not updated after 30 minutes. */
  Abandoned = 'ABANDONED',
  /** The deployment is currently active. */
  Active = 'ACTIVE',
  /** An inactive transient deployment. */
  Destroyed = 'DESTROYED',
  /** The deployment experienced an error. */
  Error = 'ERROR',
  /** The deployment has failed. */
  Failure = 'FAILURE',
  /** The deployment is inactive. */
  Inactive = 'INACTIVE',
  /** The deployment is in progress. */
  InProgress = 'IN_PROGRESS',
  /** The deployment is pending. */
  Pending = 'PENDING',
  /** The deployment has queued */
  Queued = 'QUEUED',
  /** The deployment was successful. */
  Success = 'SUCCESS',
  /** The deployment is waiting. */
  Waiting = 'WAITING'
}

/** Describes the status of a given deployment attempt. */
export type DeploymentStatus = Node & {
  __typename?: 'DeploymentStatus';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Identifies the actor who triggered the deployment. */
  creator: Actor;
  /** Identifies the deployment associated with status. */
  deployment: Deployment;
  /** Identifies the description of the deployment. */
  description?: Maybe<Scalars['String']['output']>;
  /** Identifies the environment of the deployment at the time of this deployment status */
  environment?: Maybe<Scalars['String']['output']>;
  /** Identifies the environment URL of the deployment. */
  environmentUrl?: Maybe<Scalars['URI']['output']>;
  /** The Node ID of the DeploymentStatus object */
  id: Scalars['ID']['output'];
  /** Identifies the log URL of the deployment. */
  logUrl?: Maybe<Scalars['URI']['output']>;
  /** Identifies the current state of the deployment. */
  state: DeploymentStatusState;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** The connection type for DeploymentStatus. */
export type DeploymentStatusConnection = {
  __typename?: 'DeploymentStatusConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DeploymentStatusEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<DeploymentStatus>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DeploymentStatusEdge = {
  __typename?: 'DeploymentStatusEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DeploymentStatus>;
};

/** The possible states for a deployment status. */
export enum DeploymentStatusState {
  /** The deployment experienced an error. */
  Error = 'ERROR',
  /** The deployment has failed. */
  Failure = 'FAILURE',
  /** The deployment is inactive. */
  Inactive = 'INACTIVE',
  /** The deployment is in progress. */
  InProgress = 'IN_PROGRESS',
  /** The deployment is pending. */
  Pending = 'PENDING',
  /** The deployment is queued */
  Queued = 'QUEUED',
  /** The deployment was successful. */
  Success = 'SUCCESS',
  /** The deployment is waiting. */
  Waiting = 'WAITING'
}

/** Autogenerated input type of DequeuePullRequest */
export type DequeuePullRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the pull request to be dequeued. */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of DequeuePullRequest. */
export type DequeuePullRequestPayload = {
  __typename?: 'DequeuePullRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The merge queue entry of the dequeued pull request. */
  mergeQueueEntry?: Maybe<MergeQueueEntry>;
};

/** The possible sides of a diff. */
export enum DiffSide {
  /** The left side of the diff. */
  Left = 'LEFT',
  /** The right side of the diff. */
  Right = 'RIGHT'
}

/** Autogenerated input type of DisablePullRequestAutoMerge */
export type DisablePullRequestAutoMergeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the pull request to disable auto merge on. */
  pullRequestId: Scalars['ID']['input'];
};

/** Autogenerated return type of DisablePullRequestAutoMerge. */
export type DisablePullRequestAutoMergePayload = {
  __typename?: 'DisablePullRequestAutoMergePayload';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The pull request auto merge was disabled on. */
  pullRequest?: Maybe<PullRequest>;
};

/** Represents a 'disconnected' event on a given issue or pull request. */
export type DisconnectedEvent = Node & {
  __typename?: 'DisconnectedEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The Node ID of the DisconnectedEvent object */
  id: Scalars['ID']['output'];
  /** Reference originated in a different repository. */
  isCrossRepository: Scalars['Boolean']['output'];
  /** Issue or pull request from which the issue was disconnected. */
  source: ReferencedSubject;
  /** Issue or pull request which was disconnected. */
  subject: ReferencedSubject;
};

/** A discussion in a repository. */
export type Discussion = Closable & Comment & Deletable & Labelable & Lockable & Node & Reactable & RepositoryNode & Subscribable & Updatable & Votable & {
  __typename?: 'Discussion';
  /** Reason that the conversation was locked. */
  activeLockReason?: Maybe<LockReason>;
  /** The comment chosen as this discussion's answer, if any. */
  answer?: Maybe<DiscussionComment>;
  /** The time when a user chose this discussion's answer, if answered. */
  answerChosenAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user who chose this discussion's answer, if answered. */
  answerChosenBy?: Maybe<Actor>;
  /** The actor who authored the discussion. */
  author?: Maybe<Actor>;
  /** Author's association with the subject of the comment. */
  authorAssociation: CommentAuthorAssociation;
  /** The main text of the discussion post. */
  body: Scalars['String']['output'];
  /** The body rendered to HTML. */
  bodyHTML: Scalars['HTML']['output'];
  /** The body rendered to text. */
  bodyText: Scalars['String']['output'];
  /** The category for this discussion. */
  category: DiscussionCategory;
  /** Indicates if the object is closed (definition of closed may depend on type) */
  closed: Scalars['Boolean']['output'];
  /** Identifies the date and time when the object was closed. */
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The replies to the discussion. */
  comments: DiscussionCommentConnection;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Check if this comment was created via an email reply. */
  createdViaEmail: Scalars['Boolean']['output'];
  /** Identifies the primary key from the database. */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** The actor who edited the comment. */
  editor?: Maybe<Actor>;
  /** The Node ID of the Discussion object */
  id: Scalars['ID']['output'];
  /** Check if this comment was edited and includes an edit with the creation data */
  includesCreatedEdit: Scalars['Boolean']['output'];
  /** Only return answered/unanswered discussions */
  isAnswered?: Maybe<Scalars['Boolean']['output']>;
  /** A list of labels associated with the object. */
  labels?: Maybe<LabelConnection>;
  /** The moment the editor made the last edit */
  lastEditedAt?: Maybe<Scalars['DateTime']['output']>;
  /** `true` if the object is locked */
  locked: Scalars['Boolean']['output'];
  /** The number identifying this discussion within the repository. */
  number: Scalars['Int']['output'];
  /** The poll associated with this discussion, if one exists. */
  poll?: Maybe<DiscussionPoll>;
  /** Identifies when the comment was published at. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** A list of reactions grouped by content left on the subject. */
  reactionGroups?: Maybe<Array<ReactionGroup>>;
  /** A list of Reactions left on the Issue. */
  reactions: ReactionConnection;
  /** The repository associated with this node. */
  repository: Repository;
  /** The path for this discussion. */
  resourcePath: Scalars['URI']['output'];
  /** Identifies the reason for the discussion's state. */
  stateReason?: Maybe<DiscussionStateReason>;
  /** The title of this discussion. */
  title: Scalars['String']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** Number of upvotes that this subject has received. */
  upvoteCount: Scalars['Int']['output'];
  /** The URL for this discussion. */
  url: Scalars['URI']['output'];
  /** A list of edits to this content. */
  userContentEdits?: Maybe<UserContentEditConnection>;
  /** Indicates if the object can be closed by the viewer. */
  viewerCanClose: Scalars['Boolean']['output'];
  /** Check if the current viewer can delete this object. */
  viewerCanDelete: Scalars['Boolean']['output'];
  /** Indicates if the viewer can edit labels for this object. */
  viewerCanLabel: Scalars['Boolean']['output'];
  /** Can user react to this subject */
  viewerCanReact: Scalars['Boolean']['output'];
  /** Indicates if the object can be reopened by the viewer. */
  viewerCanReopen: Scalars['Boolean']['output'];
  /** Check if the viewer is able to change their subscription status for the repository. */
  viewerCanSubscribe: Scalars['Boolean']['output'];
  /** Check if the current viewer can update this object. */
  viewerCanUpdate: Scalars['Boolean']['output'];
  /** Whether or not the current user can add or remove an upvote on this subject. */
  viewerCanUpvote: Scalars['Boolean']['output'];
  /** Did the viewer author this comment. */
  viewerDidAuthor: Scalars['Boolean']['output'];
  /** Whether or not the current user has already upvoted this subject. */
  viewerHasUpvoted: Scalars['Boolean']['output'];
  /** Identifies if the viewer is watching, not watching, or ignoring the subscribable entity. */
  viewerSubscription?: Maybe<SubscriptionState>;
};


/** A discussion in a repository. */
export type DiscussionCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A discussion in a repository. */
export type DiscussionLabelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LabelOrder>;
};


/** A discussion in a repository. */
export type DiscussionReactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<ReactionContent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ReactionOrder>;
};


/** A discussion in a repository. */
export type DiscussionUserContentEditsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** A category for discussions in a repository. */
export type DiscussionCategory = Node & RepositoryNode & {
  __typename?: 'DiscussionCategory';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** A description of this category. */
  description?: Maybe<Scalars['String']['output']>;
  /** An emoji representing this category. */
  emoji: Scalars['String']['output'];
  /** This category's emoji rendered as HTML. */
  emojiHTML: Scalars['HTML']['output'];
  /** The Node ID of the DiscussionCategory object */
  id: Scalars['ID']['output'];
  /** Whether or not discussions in this category support choosing an answer with the markDiscussionCommentAsAnswer mutation. */
  isAnswerable: Scalars['Boolean']['output'];
  /** The name of this category. */
  name: Scalars['String']['output'];
  /** The repository associated with this node. */
  repository: Repository;
  /** The slug of this category. */
  slug: Scalars['String']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** The connection type for DiscussionCategory. */
export type DiscussionCategoryConnection = {
  __typename?: 'DiscussionCategoryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DiscussionCategoryEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<DiscussionCategory>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DiscussionCategoryEdge = {
  __typename?: 'DiscussionCategoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DiscussionCategory>;
};

/** The possible reasons for closing a discussion. */
export enum DiscussionCloseReason {
  /** The discussion is a duplicate of another */
  Duplicate = 'DUPLICATE',
  /** The discussion is no longer relevant */
  Outdated = 'OUTDATED',
  /** The discussion has been resolved */
  Resolved = 'RESOLVED'
}

/** A comment on a discussion. */
export type DiscussionComment = Comment & Deletable & Minimizable & Node & Reactable & Updatable & UpdatableComment & Votable & {
  __typename?: 'DiscussionComment';
  /** The actor who authored the comment. */
  author?: Maybe<Actor>;
  /** Author's association with the subject of the comment. */
  authorAssociation: CommentAuthorAssociation;
  /** The body as Markdown. */
  body: Scalars['String']['output'];
  /** The body rendered to HTML. */
  bodyHTML: Scalars['HTML']['output'];
  /** The body rendered to text. */
  bodyText: Scalars['String']['output'];
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Check if this comment was created via an email reply. */
  createdViaEmail: Scalars['Boolean']['output'];
  /** Identifies the primary key from the database. */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** The time when this replied-to comment was deleted */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The discussion this comment was created in */
  discussion?: Maybe<Discussion>;
  /** The actor who edited the comment. */
  editor?: Maybe<Actor>;
  /** The Node ID of the DiscussionComment object */
  id: Scalars['ID']['output'];
  /** Check if this comment was edited and includes an edit with the creation data */
  includesCreatedEdit: Scalars['Boolean']['output'];
  /** Has this comment been chosen as the answer of its discussion? */
  isAnswer: Scalars['Boolean']['output'];
  /** Returns whether or not a comment has been minimized. */
  isMinimized: Scalars['Boolean']['output'];
  /** The moment the editor made the last edit */
  lastEditedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Returns why the comment was minimized. One of `abuse`, `off-topic`,
   * `outdated`, `resolved`, `duplicate`, `spam`, and `low-quality`. Note that the
   * case and formatting of these values differs from the inputs to the
   * `MinimizeComment` mutation.
   */
  minimizedReason?: Maybe<Scalars['String']['output']>;
  /** Identifies when the comment was published at. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** A list of reactions grouped by content left on the subject. */
  reactionGroups?: Maybe<Array<ReactionGroup>>;
  /** A list of Reactions left on the Issue. */
  reactions: ReactionConnection;
  /** The threaded replies to this comment. */
  replies: DiscussionCommentConnection;
  /** The discussion comment this comment is a reply to */
  replyTo?: Maybe<DiscussionComment>;
  /** The path for this discussion comment. */
  resourcePath: Scalars['URI']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** Number of upvotes that this subject has received. */
  upvoteCount: Scalars['Int']['output'];
  /** The URL for this discussion comment. */
  url: Scalars['URI']['output'];
  /** A list of edits to this content. */
  userContentEdits?: Maybe<UserContentEditConnection>;
  /** Check if the current viewer can delete this object. */
  viewerCanDelete: Scalars['Boolean']['output'];
  /** Can the current user mark this comment as an answer? */
  viewerCanMarkAsAnswer: Scalars['Boolean']['output'];
  /** Check if the current viewer can minimize this object. */
  viewerCanMinimize: Scalars['Boolean']['output'];
  /** Can user react to this subject */
  viewerCanReact: Scalars['Boolean']['output'];
  /** Can the current user unmark this comment as an answer? */
  viewerCanUnmarkAsAnswer: Scalars['Boolean']['output'];
  /** Check if the current viewer can unminimize this object. */
  viewerCanUnminimize: Scalars['Boolean']['output'];
  /** Check if the current viewer can update this object. */
  viewerCanUpdate: Scalars['Boolean']['output'];
  /** Whether or not the current user can add or remove an upvote on this subject. */
  viewerCanUpvote: Scalars['Boolean']['output'];
  /** Reasons why the current viewer can not update this comment. */
  viewerCannotUpdateReasons: Array<CommentCannotUpdateReason>;
  /** Did the viewer author this comment. */
  viewerDidAuthor: Scalars['Boolean']['output'];
  /** Whether or not the current user has already upvoted this subject. */
  viewerHasUpvoted: Scalars['Boolean']['output'];
};


/** A comment on a discussion. */
export type DiscussionCommentReactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<ReactionContent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ReactionOrder>;
};


/** A comment on a discussion. */
export type DiscussionCommentRepliesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A comment on a discussion. */
export type DiscussionCommentUserContentEditsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for DiscussionComment. */
export type DiscussionCommentConnection = {
  __typename?: 'DiscussionCommentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DiscussionCommentEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<DiscussionComment>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DiscussionCommentEdge = {
  __typename?: 'DiscussionCommentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DiscussionComment>;
};

/** The connection type for Discussion. */
export type DiscussionConnection = {
  __typename?: 'DiscussionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DiscussionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Discussion>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DiscussionEdge = {
  __typename?: 'DiscussionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Discussion>;
};

/** Ways in which lists of discussions can be ordered upon return. */
export type DiscussionOrder = {
  /** The direction in which to order discussions by the specified field. */
  direction: OrderDirection;
  /** The field by which to order discussions. */
  field: DiscussionOrderField;
};

/** Properties by which discussion connections can be ordered. */
export enum DiscussionOrderField {
  /** Order discussions by creation time. */
  CreatedAt = 'CREATED_AT',
  /** Order discussions by most recent modification time. */
  UpdatedAt = 'UPDATED_AT'
}

/** A poll for a discussion. */
export type DiscussionPoll = Node & {
  __typename?: 'DiscussionPoll';
  /** The discussion that this poll belongs to. */
  discussion?: Maybe<Discussion>;
  /** The Node ID of the DiscussionPoll object */
  id: Scalars['ID']['output'];
  /** The options for this poll. */
  options?: Maybe<DiscussionPollOptionConnection>;
  /** The question that is being asked by this poll. */
  question: Scalars['String']['output'];
  /** The total number of votes that have been cast for this poll. */
  totalVoteCount: Scalars['Int']['output'];
  /** Indicates if the viewer has permission to vote in this poll. */
  viewerCanVote: Scalars['Boolean']['output'];
  /** Indicates if the viewer has voted for any option in this poll. */
  viewerHasVoted: Scalars['Boolean']['output'];
};


/** A poll for a discussion. */
export type DiscussionPollOptionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DiscussionPollOptionOrder>;
};

/** An option for a discussion poll. */
export type DiscussionPollOption = Node & {
  __typename?: 'DiscussionPollOption';
  /** The Node ID of the DiscussionPollOption object */
  id: Scalars['ID']['output'];
  /** The text for this option. */
  option: Scalars['String']['output'];
  /** The discussion poll that this option belongs to. */
  poll?: Maybe<DiscussionPoll>;
  /** The total number of votes that have been cast for this option. */
  totalVoteCount: Scalars['Int']['output'];
  /** Indicates if the viewer has voted for this option in the poll. */
  viewerHasVoted: Scalars['Boolean']['output'];
};

/** The connection type for DiscussionPollOption. */
export type DiscussionPollOptionConnection = {
  __typename?: 'DiscussionPollOptionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<DiscussionPollOptionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<DiscussionPollOption>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type DiscussionPollOptionEdge = {
  __typename?: 'DiscussionPollOptionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<DiscussionPollOption>;
};

/** Ordering options for discussion poll option connections. */
export type DiscussionPollOptionOrder = {
  /** The ordering direction. */
  direction: OrderDirection;
  /** The field to order poll options by. */
  field: DiscussionPollOptionOrderField;
};

/** Properties by which discussion poll option connections can be ordered. */
export enum DiscussionPollOptionOrderField {
  /** Order poll options by the order that the poll author specified when creating the poll. */
  AuthoredOrder = 'AUTHORED_ORDER',
  /** Order poll options by the number of votes it has. */
  VoteCount = 'VOTE_COUNT'
}

/** The possible states of a discussion. */
export enum DiscussionState {
  /** A discussion that has been closed */
  Closed = 'CLOSED',
  /** A discussion that is open */
  Open = 'OPEN'
}

/** The possible state reasons of a discussion. */
export enum DiscussionStateReason {
  /** The discussion is a duplicate of another */
  Duplicate = 'DUPLICATE',
  /** The discussion is no longer relevant */
  Outdated = 'OUTDATED',
  /** The discussion was reopened */
  Reopened = 'REOPENED',
  /** The discussion has been resolved */
  Resolved = 'RESOLVED'
}

/** Autogenerated input type of DismissPullRequestReview */
export type DismissPullRequestReviewInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The contents of the pull request review dismissal message. */
  message: Scalars['String']['input'];
  /** The Node ID of the pull request review to modify. */
  pullRequestReviewId: Scalars['ID']['input'];
};

/** Autogenerated return type of DismissPullRequestReview. */
export type DismissPullRequestReviewPayload = {
  __typename?: 'DismissPullRequestReviewPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The dismissed pull request review. */
  pullRequestReview?: Maybe<PullRequestReview>;
};

/** The possible reasons that a Dependabot alert was dismissed. */
export enum DismissReason {
  /** A fix has already been started */
  FixStarted = 'FIX_STARTED',
  /** This alert is inaccurate or incorrect */
  Inaccurate = 'INACCURATE',
  /** Vulnerable code is not actually used */
  NotUsed = 'NOT_USED',
  /** No bandwidth to fix this */
  NoBandwidth = 'NO_BANDWIDTH',
  /** Risk is tolerable to this project */
  TolerableRisk = 'TOLERABLE_RISK'
}

/** Autogenerated input type of DismissRepositoryVulnerabilityAlert */
export type DismissRepositoryVulnerabilityAlertInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The reason the Dependabot alert is being dismissed. */
  dismissReason: DismissReason;
  /** The Dependabot alert ID to dismiss. */
  repositoryVulnerabilityAlertId: Scalars['ID']['input'];
};

/** Autogenerated return type of DismissRepositoryVulnerabilityAlert. */
export type DismissRepositoryVulnerabilityAlertPayload = {
  __typename?: 'DismissRepositoryVulnerabilityAlertPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The Dependabot alert that was dismissed */
  repositoryVulnerabilityAlert?: Maybe<RepositoryVulnerabilityAlert>;
};

/** Specify people, teams, or apps allowed to dismiss pull request reviews. */
export type DismissalRestriction = {
  __typename?: 'DismissalRestriction';
  /** Specify people, teams, or apps allowed to dismiss pull request reviews. */
  allowedActors?: Maybe<Array<Scalars['ID']['output']>>;
  /** Whether to restrict review dismissal to specific actors. */
  enabled: Scalars['Boolean']['output'];
};

/** Specify people, teams, or apps allowed to dismiss pull request reviews. */
export type DismissalRestrictionInput = {
  /** Specify people, teams, or apps allowed to dismiss pull request reviews. */
  allowedActors?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Whether to restrict review dismissal to specific actors. */
  enabled: Scalars['Boolean']['input'];
};

/** A draft issue within a project. */
export type DraftIssue = Node & {
  __typename?: 'DraftIssue';
  /** A list of users to assigned to this draft issue. */
  assignees: UserConnection;
  /** The body of the draft issue. */
  body: Scalars['String']['output'];
  /** The body of the draft issue rendered to HTML. */
  bodyHTML: Scalars['HTML']['output'];
  /** The body of the draft issue rendered to text. */
  bodyText: Scalars['String']['output'];
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The actor who created this draft issue. */
  creator?: Maybe<Actor>;
  /** The Node ID of the DraftIssue object */
  id: Scalars['ID']['output'];
  /** List of items linked with the draft issue (currently draft issue can be linked to only one item). */
  projectV2Items: ProjectV2ItemConnection;
  /** Projects that link to this draft issue (currently draft issue can be linked to only one project). */
  projectsV2: ProjectV2Connection;
  /** The title of the draft issue */
  title: Scalars['String']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};


/** A draft issue within a project. */
export type DraftIssueAssigneesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A draft issue within a project. */
export type DraftIssueProjectV2ItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A draft issue within a project. */
export type DraftIssueProjectsV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Specifies a review comment to be left with a Pull Request Review. */
export type DraftPullRequestReviewComment = {
  /** Body of the comment to leave. */
  body: Scalars['String']['input'];
  /** Path to the file being commented on. */
  path: Scalars['String']['input'];
  /** Position in the file to leave a comment on. */
  position: Scalars['Int']['input'];
};

/** Specifies a review comment thread to be left with a Pull Request Review. */
export type DraftPullRequestReviewThread = {
  /** Body of the comment to leave. */
  body: Scalars['String']['input'];
  /**
   * The line of the blob to which the thread refers. The end of the line range for
   * multi-line comments. Required if not using positioning.
   */
  line?: InputMaybe<Scalars['Int']['input']>;
  /** Path to the file being commented on. Required if not using positioning. */
  path?: InputMaybe<Scalars['String']['input']>;
  /** The side of the diff on which the line resides. For multi-line comments, this is the side for the end of the line range. */
  side?: InputMaybe<DiffSide>;
  /** The first line of the range to which the comment refers. */
  startLine?: InputMaybe<Scalars['Int']['input']>;
  /** The side of the diff on which the start line resides. */
  startSide?: InputMaybe<DiffSide>;
};

/** The Exploit Prediction Scoring System */
export type Epss = {
  __typename?: 'EPSS';
  /** The EPSS percentage represents the likelihood of a CVE being exploited. */
  percentage?: Maybe<Scalars['Float']['output']>;
  /** The EPSS percentile represents the relative rank of the CVE's likelihood of being exploited compared to other CVEs. */
  percentile?: Maybe<Scalars['Float']['output']>;
};

/** Autogenerated input type of EnablePullRequestAutoMerge */
export type EnablePullRequestAutoMergeInput = {
  /** The email address to associate with this merge. */
  authorEmail?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Commit body to use for the commit when the PR is mergable; if omitted, a
   * default message will be used. NOTE: when merging with a merge queue any input
   * value for commit message is ignored.
   */
  commitBody?: InputMaybe<Scalars['String']['input']>;
  /**
   * Commit headline to use for the commit when the PR is mergable; if omitted, a
   * default message will be used. NOTE: when merging with a merge queue any input
   * value for commit headline is ignored.
   */
  commitHeadline?: InputMaybe<Scalars['String']['input']>;
  /** The expected head OID of the pull request. */
  expectedHeadOid?: InputMaybe<Scalars['GitObjectID']['input']>;
  /**
   * The merge method to use. If omitted, defaults to `MERGE`. NOTE: when merging
   * with a merge queue any input value for merge method is ignored.
   */
  mergeMethod?: InputMaybe<PullRequestMergeMethod>;
  /** ID of the pull request to enable auto-merge on. */
  pullRequestId: Scalars['ID']['input'];
};

/** Autogenerated return type of EnablePullRequestAutoMerge. */
export type EnablePullRequestAutoMergePayload = {
  __typename?: 'EnablePullRequestAutoMergePayload';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The pull request auto-merge was enabled on. */
  pullRequest?: Maybe<PullRequest>;
};

/** Autogenerated input type of EnqueuePullRequest */
export type EnqueuePullRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The expected head OID of the pull request. */
  expectedHeadOid?: InputMaybe<Scalars['GitObjectID']['input']>;
  /** Add the pull request to the front of the queue. */
  jump?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the pull request to enqueue. */
  pullRequestId: Scalars['ID']['input'];
};

/** Autogenerated return type of EnqueuePullRequest. */
export type EnqueuePullRequestPayload = {
  __typename?: 'EnqueuePullRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The merge queue entry for the enqueued pull request. */
  mergeQueueEntry?: Maybe<MergeQueueEntry>;
};

/** An account to manage multiple organizations with consolidated policy and billing. */
export type Enterprise = Node & {
  __typename?: 'Enterprise';
  /** The announcement banner set on this enterprise, if any. Only visible to members of the enterprise. */
  announcementBanner?: Maybe<AnnouncementBanner>;
  /** A URL pointing to the enterprise's public avatar. */
  avatarUrl: Scalars['URI']['output'];
  /** The enterprise's billing email. */
  billingEmail?: Maybe<Scalars['String']['output']>;
  /** Enterprise billing information visible to enterprise billing managers. */
  billingInfo?: Maybe<EnterpriseBillingInfo>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Identifies the primary key from the database. */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** The description of the enterprise. */
  description?: Maybe<Scalars['String']['output']>;
  /** The description of the enterprise as HTML. */
  descriptionHTML: Scalars['HTML']['output'];
  /** Find an enterprise team by its slug. */
  enterpriseTeam?: Maybe<EnterpriseTeam>;
  /** A list of enterprise teams in this enterprise. */
  enterpriseTeams: EnterpriseTeamConnection;
  /** The Node ID of the Enterprise object */
  id: Scalars['ID']['output'];
  /** Innersource security vulnerabilities scoped to this enterprise. */
  innersourceVulnerabilities: SecurityVulnerabilityConnection;
  /** The location of the enterprise. */
  location?: Maybe<Scalars['String']['output']>;
  /** A list of users who are members of this enterprise. */
  members: EnterpriseMemberConnection;
  /** The name of the enterprise. */
  name: Scalars['String']['output'];
  /** A list of organizations that belong to this enterprise. */
  organizations: OrganizationConnection;
  /**
   * Enterprise information visible to enterprise owners or enterprise owners'
   * personal access tokens (classic) with read:enterprise or admin:enterprise scope.
   */
  ownerInfo?: Maybe<EnterpriseOwnerInfo>;
  /** The raw content of the enterprise README. */
  readme?: Maybe<Scalars['String']['output']>;
  /** The content of the enterprise README as HTML. */
  readmeHTML: Scalars['HTML']['output'];
  /** A list of repository custom properties for this enterprise. */
  repositoryCustomProperties?: Maybe<RepositoryCustomPropertyConnection>;
  /** Returns a single repository custom property for the current enterprise by name. */
  repositoryCustomProperty?: Maybe<RepositoryCustomProperty>;
  /** The HTTP path for this enterprise. */
  resourcePath: Scalars['URI']['output'];
  /** Returns a single ruleset from the current enterprise by ID. */
  ruleset?: Maybe<RepositoryRuleset>;
  /** A list of rulesets for this enterprise. */
  rulesets?: Maybe<RepositoryRulesetConnection>;
  /** The enterprise's security contact email address. */
  securityContactEmail?: Maybe<Scalars['String']['output']>;
  /** The URL-friendly identifier for the enterprise. */
  slug: Scalars['String']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The HTTP URL for this enterprise. */
  url: Scalars['URI']['output'];
  /** A list of repositories that belong to users. Only available for enterprises with Enterprise Managed Users. */
  userNamespaceRepositories: UserNamespaceRepositoryConnection;
  /** Is the current viewer an admin of this enterprise? */
  viewerIsAdmin: Scalars['Boolean']['output'];
  /** The URL of the enterprise website. */
  websiteUrl?: Maybe<Scalars['URI']['output']>;
};


/** An account to manage multiple organizations with consolidated policy and billing. */
export type EnterpriseAvatarUrlArgs = {
  size?: InputMaybe<Scalars['Int']['input']>;
};


/** An account to manage multiple organizations with consolidated policy and billing. */
export type EnterpriseEnterpriseTeamArgs = {
  slug: Scalars['String']['input'];
};


/** An account to manage multiple organizations with consolidated policy and billing. */
export type EnterpriseEnterpriseTeamsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EnterpriseTeamOrder>;
  query?: InputMaybe<Scalars['String']['input']>;
  userLogins?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** An account to manage multiple organizations with consolidated policy and billing. */
export type EnterpriseInnersourceVulnerabilitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  ecosystem?: InputMaybe<SecurityAdvisoryEcosystem>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SecurityVulnerabilityOrder>;
  package?: InputMaybe<Scalars['String']['input']>;
  severities?: InputMaybe<Array<SecurityAdvisorySeverity>>;
};


/** An account to manage multiple organizations with consolidated policy and billing. */
export type EnterpriseMembersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  deployment?: InputMaybe<EnterpriseUserDeployment>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasTwoFactorEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EnterpriseMemberOrder>;
  organizationLogins?: InputMaybe<Array<Scalars['String']['input']>>;
  query?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<EnterpriseUserAccountMembershipRole>;
  twoFactorMethodSecurity?: InputMaybe<TwoFactorCredentialSecurityType>;
};


/** An account to manage multiple organizations with consolidated policy and billing. */
export type EnterpriseOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrganizationOrder>;
  query?: InputMaybe<Scalars['String']['input']>;
  viewerOrganizationRole?: InputMaybe<RoleInOrganization>;
};


/** An account to manage multiple organizations with consolidated policy and billing. */
export type EnterpriseRepositoryCustomPropertiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** An account to manage multiple organizations with consolidated policy and billing. */
export type EnterpriseRepositoryCustomPropertyArgs = {
  propertyName: Scalars['String']['input'];
};


/** An account to manage multiple organizations with consolidated policy and billing. */
export type EnterpriseRulesetArgs = {
  databaseId: Scalars['Int']['input'];
};


/** An account to manage multiple organizations with consolidated policy and billing. */
export type EnterpriseRulesetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** An account to manage multiple organizations with consolidated policy and billing. */
export type EnterpriseUserNamespaceRepositoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<RepositoryOrder>;
  query?: InputMaybe<Scalars['String']['input']>;
};

/** The connection type for User. */
export type EnterpriseAdministratorConnection = {
  __typename?: 'EnterpriseAdministratorConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EnterpriseAdministratorEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<User>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A User who is an administrator of an enterprise. */
export type EnterpriseAdministratorEdge = {
  __typename?: 'EnterpriseAdministratorEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<User>;
  /** The role of the administrator. */
  role: EnterpriseAdministratorRole;
};

/** An invitation for a user to become an owner or billing manager of an enterprise. */
export type EnterpriseAdministratorInvitation = Node & {
  __typename?: 'EnterpriseAdministratorInvitation';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The email of the person who was invited to the enterprise. */
  email?: Maybe<Scalars['String']['output']>;
  /** The enterprise the invitation is for. */
  enterprise: Enterprise;
  /** The Node ID of the EnterpriseAdministratorInvitation object */
  id: Scalars['ID']['output'];
  /** The user who was invited to the enterprise. */
  invitee?: Maybe<User>;
  /** The user who created the invitation. */
  inviter?: Maybe<User>;
  /** The invitee's pending role in the enterprise (owner or billing_manager). */
  role: EnterpriseAdministratorRole;
};

/** The connection type for EnterpriseAdministratorInvitation. */
export type EnterpriseAdministratorInvitationConnection = {
  __typename?: 'EnterpriseAdministratorInvitationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EnterpriseAdministratorInvitationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<EnterpriseAdministratorInvitation>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EnterpriseAdministratorInvitationEdge = {
  __typename?: 'EnterpriseAdministratorInvitationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EnterpriseAdministratorInvitation>;
};

/** Ordering options for enterprise administrator invitation connections */
export type EnterpriseAdministratorInvitationOrder = {
  /** The ordering direction. */
  direction: OrderDirection;
  /** The field to order enterprise administrator invitations by. */
  field: EnterpriseAdministratorInvitationOrderField;
};

/** Properties by which enterprise administrator invitation connections can be ordered. */
export enum EnterpriseAdministratorInvitationOrderField {
  /** Order enterprise administrator member invitations by creation time */
  CreatedAt = 'CREATED_AT'
}

/** The possible administrator roles in an enterprise account. */
export enum EnterpriseAdministratorRole {
  /** Represents a billing manager of the enterprise account. */
  BillingManager = 'BILLING_MANAGER',
  /** Represents an owner of the enterprise account. */
  Owner = 'OWNER',
  /** Unaffiliated member of the enterprise account without an admin role. */
  Unaffiliated = 'UNAFFILIATED'
}

/** The possible values for the enterprise allow private repository forking policy value. */
export enum EnterpriseAllowPrivateRepositoryForkingPolicyValue {
  /** Members can fork a repository to an organization within this enterprise. */
  EnterpriseOrganizations = 'ENTERPRISE_ORGANIZATIONS',
  /** Members can fork a repository to their enterprise-managed user account or an organization inside this enterprise. */
  EnterpriseOrganizationsUserAccounts = 'ENTERPRISE_ORGANIZATIONS_USER_ACCOUNTS',
  /**
   * Members can fork a repository to their user account or an organization, either
   * inside or outside of this enterprise. Internal repositories can only be forked
   * inside of this enterprise.
   */
  Everywhere = 'EVERYWHERE',
  /** Members can fork a repository only within the same organization (intra-org). */
  SameOrganization = 'SAME_ORGANIZATION',
  /** Members can fork a repository to their user account or within the same organization. */
  SameOrganizationUserAccounts = 'SAME_ORGANIZATION_USER_ACCOUNTS',
  /** Members can fork a repository to their user account. */
  UserAccounts = 'USER_ACCOUNTS'
}

/** Metadata for an audit entry containing enterprise account information. */
export type EnterpriseAuditEntryData = {
  /** The HTTP path for this enterprise. */
  enterpriseResourcePath?: Maybe<Scalars['URI']['output']>;
  /** The slug of the enterprise. */
  enterpriseSlug?: Maybe<Scalars['String']['output']>;
  /** The HTTP URL for this enterprise. */
  enterpriseUrl?: Maybe<Scalars['URI']['output']>;
};

/** Enterprise billing information visible to enterprise billing managers and owners. */
export type EnterpriseBillingInfo = {
  __typename?: 'EnterpriseBillingInfo';
  /** The number of licenseable users/emails across the enterprise. */
  allLicensableUsersCount: Scalars['Int']['output'];
  /**
   * The number of data packs used by all organizations owned by the enterprise. Data packs are deprecated, always returns 0.
   * @deprecated LFS data packs have been removed. Always returns 0.
   */
  assetPacks: Scalars['Int']['output'];
  /** The bandwidth quota in GB for all organizations owned by the enterprise. */
  bandwidthQuota: Scalars['Float']['output'];
  /** The bandwidth usage in GB for all organizations owned by the enterprise. */
  bandwidthUsage: Scalars['Float']['output'];
  /** The bandwidth usage as a percentage of the bandwidth quota. */
  bandwidthUsagePercentage: Scalars['Int']['output'];
  /** The storage quota in GB for all organizations owned by the enterprise. */
  storageQuota: Scalars['Float']['output'];
  /** The storage usage in GB for all organizations owned by the enterprise. */
  storageUsage: Scalars['Float']['output'];
  /** The storage usage as a percentage of the storage quota. */
  storageUsagePercentage: Scalars['Int']['output'];
  /** The number of available licenses across all owned organizations based on the unique number of billable users. */
  totalAvailableLicenses: Scalars['Int']['output'];
  /** The total number of licenses allocated. */
  totalLicenses: Scalars['Int']['output'];
};

/** The connection type for Enterprise. */
export type EnterpriseConnection = {
  __typename?: 'EnterpriseConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EnterpriseEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Enterprise>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** The possible values for the enterprise base repository permission setting. */
export enum EnterpriseDefaultRepositoryPermissionSettingValue {
  /** Organization members will be able to clone, pull, push, and add new collaborators to all organization repositories. */
  Admin = 'ADMIN',
  /** Organization members will only be able to clone and pull public repositories. */
  None = 'NONE',
  /** Organizations in the enterprise choose base repository permissions for their members. */
  NoPolicy = 'NO_POLICY',
  /** Organization members will be able to clone and pull all organization repositories. */
  Read = 'READ',
  /** Organization members will be able to clone, pull, and push all organization repositories. */
  Write = 'WRITE'
}

/** The possible values for an enabled/no policy enterprise setting. */
export enum EnterpriseDisallowedMethodsSettingValue {
  /** The setting prevents insecure 2FA methods from being used by members of the enterprise. */
  Insecure = 'INSECURE',
  /** There is no policy set for preventing insecure 2FA methods from being used by members of the enterprise. */
  NoPolicy = 'NO_POLICY'
}

/** An edge in a connection. */
export type EnterpriseEdge = {
  __typename?: 'EnterpriseEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Enterprise>;
};

/** The possible values for an enabled/disabled enterprise setting. */
export enum EnterpriseEnabledDisabledSettingValue {
  /** The setting is disabled for organizations in the enterprise. */
  Disabled = 'DISABLED',
  /** The setting is enabled for organizations in the enterprise. */
  Enabled = 'ENABLED',
  /** There is no policy set for organizations in the enterprise. */
  NoPolicy = 'NO_POLICY'
}

/** The possible values for an enabled/no policy enterprise setting. */
export enum EnterpriseEnabledSettingValue {
  /** The setting is enabled for organizations in the enterprise. */
  Enabled = 'ENABLED',
  /** There is no policy set for organizations in the enterprise. */
  NoPolicy = 'NO_POLICY'
}

/** The connection type for OrganizationInvitation. */
export type EnterpriseFailedInvitationConnection = {
  __typename?: 'EnterpriseFailedInvitationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EnterpriseFailedInvitationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<OrganizationInvitation>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
  /** Identifies the total count of unique users in the connection. */
  totalUniqueUserCount: Scalars['Int']['output'];
};

/** A failed invitation to be a member in an enterprise organization. */
export type EnterpriseFailedInvitationEdge = {
  __typename?: 'EnterpriseFailedInvitationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<OrganizationInvitation>;
};

/**
 * An identity provider configured to provision identities for an enterprise.
 * Visible to enterprise owners or enterprise owners' personal access tokens
 * (classic) with read:enterprise or admin:enterprise scope.
 */
export type EnterpriseIdentityProvider = Node & {
  __typename?: 'EnterpriseIdentityProvider';
  /** The digest algorithm used to sign SAML requests for the identity provider. */
  digestMethod?: Maybe<SamlDigestAlgorithm>;
  /** The enterprise this identity provider belongs to. */
  enterprise?: Maybe<Enterprise>;
  /** ExternalIdentities provisioned by this identity provider. */
  externalIdentities: ExternalIdentityConnection;
  /** The Node ID of the EnterpriseIdentityProvider object */
  id: Scalars['ID']['output'];
  /** The x509 certificate used by the identity provider to sign assertions and responses. */
  idpCertificate?: Maybe<Scalars['X509Certificate']['output']>;
  /** The Issuer Entity ID for the SAML identity provider. */
  issuer?: Maybe<Scalars['String']['output']>;
  /** Recovery codes that can be used by admins to access the enterprise if the identity provider is unavailable. */
  recoveryCodes?: Maybe<Array<Scalars['String']['output']>>;
  /** The signature algorithm used to sign SAML requests for the identity provider. */
  signatureMethod?: Maybe<SamlSignatureAlgorithm>;
  /** The URL endpoint for the identity provider's SAML SSO. */
  ssoUrl?: Maybe<Scalars['URI']['output']>;
};


/**
 * An identity provider configured to provision identities for an enterprise.
 * Visible to enterprise owners or enterprise owners' personal access tokens
 * (classic) with read:enterprise or admin:enterprise scope.
 */
export type EnterpriseIdentityProviderExternalIdentitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  login?: InputMaybe<Scalars['String']['input']>;
  membersOnly?: InputMaybe<Scalars['Boolean']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

/** An object that is a member of an enterprise. */
export type EnterpriseMember = EnterpriseUserAccount | User;

/** The connection type for EnterpriseMember. */
export type EnterpriseMemberConnection = {
  __typename?: 'EnterpriseMemberConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EnterpriseMemberEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<EnterpriseMember>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A User who is a member of an enterprise through one or more organizations. */
export type EnterpriseMemberEdge = {
  __typename?: 'EnterpriseMemberEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EnterpriseMember>;
};

/** An invitation for a user to become an unaffiliated member of an enterprise. */
export type EnterpriseMemberInvitation = Node & {
  __typename?: 'EnterpriseMemberInvitation';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The email of the person who was invited to the enterprise. */
  email?: Maybe<Scalars['String']['output']>;
  /** The enterprise the invitation is for. */
  enterprise: Enterprise;
  /** The Node ID of the EnterpriseMemberInvitation object */
  id: Scalars['ID']['output'];
  /** The user who was invited to the enterprise. */
  invitee?: Maybe<User>;
  /** The user who created the invitation. */
  inviter?: Maybe<User>;
};

/** The connection type for EnterpriseMemberInvitation. */
export type EnterpriseMemberInvitationConnection = {
  __typename?: 'EnterpriseMemberInvitationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EnterpriseMemberInvitationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<EnterpriseMemberInvitation>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EnterpriseMemberInvitationEdge = {
  __typename?: 'EnterpriseMemberInvitationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EnterpriseMemberInvitation>;
};

/** Ordering options for enterprise administrator invitation connections */
export type EnterpriseMemberInvitationOrder = {
  /** The ordering direction. */
  direction: OrderDirection;
  /** The field to order enterprise member invitations by. */
  field: EnterpriseMemberInvitationOrderField;
};

/** Properties by which enterprise member invitation connections can be ordered. */
export enum EnterpriseMemberInvitationOrderField {
  /** Order enterprise member invitations by creation time */
  CreatedAt = 'CREATED_AT'
}

/** Ordering options for enterprise member connections. */
export type EnterpriseMemberOrder = {
  /** The ordering direction. */
  direction: OrderDirection;
  /** The field to order enterprise members by. */
  field: EnterpriseMemberOrderField;
};

/** Properties by which enterprise member connections can be ordered. */
export enum EnterpriseMemberOrderField {
  /** Order enterprise members by creation time */
  CreatedAt = 'CREATED_AT',
  /** Order enterprise members by login */
  Login = 'LOGIN'
}

/** The possible values for the enterprise members can create repositories setting. */
export enum EnterpriseMembersCanCreateRepositoriesSettingValue {
  /** Members will be able to create public and private repositories. */
  All = 'ALL',
  /** Members will not be able to create public or private repositories. */
  Disabled = 'DISABLED',
  /** Organization owners choose whether to allow members to create repositories. */
  NoPolicy = 'NO_POLICY',
  /** Members will be able to create only private repositories. */
  Private = 'PRIVATE',
  /** Members will be able to create only public repositories. */
  Public = 'PUBLIC'
}

/** The possible values for the members can make purchases setting. */
export enum EnterpriseMembersCanMakePurchasesSettingValue {
  /** The setting is disabled for organizations in the enterprise. */
  Disabled = 'DISABLED',
  /** The setting is enabled for organizations in the enterprise. */
  Enabled = 'ENABLED'
}

/** The possible values we have for filtering Platform::Objects::User#enterprises. */
export enum EnterpriseMembershipType {
  /** Returns all enterprises in which the user is an admin. */
  Admin = 'ADMIN',
  /** Returns all enterprises in which the user is a member, admin, or billing manager. */
  All = 'ALL',
  /** Returns all enterprises in which the user is a billing manager. */
  BillingManager = 'BILLING_MANAGER',
  /** Returns all enterprises in which the user is a member of an org that is owned by the enterprise. */
  OrgMembership = 'ORG_MEMBERSHIP'
}

/** Ordering options for enterprises. */
export type EnterpriseOrder = {
  /** The ordering direction. */
  direction: OrderDirection;
  /** The field to order enterprises by. */
  field: EnterpriseOrderField;
};

/** Properties by which enterprise connections can be ordered. */
export enum EnterpriseOrderField {
  /** Order enterprises by name */
  Name = 'NAME'
}

/** The connection type for Organization. */
export type EnterpriseOrganizationMembershipConnection = {
  __typename?: 'EnterpriseOrganizationMembershipConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EnterpriseOrganizationMembershipEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Organization>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An enterprise organization that a user is a member of. */
export type EnterpriseOrganizationMembershipEdge = {
  __typename?: 'EnterpriseOrganizationMembershipEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Organization>;
  /** The role of the user in the enterprise membership. */
  role: EnterpriseUserAccountMembershipRole;
};

/** The connection type for User. */
export type EnterpriseOutsideCollaboratorConnection = {
  __typename?: 'EnterpriseOutsideCollaboratorConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EnterpriseOutsideCollaboratorEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<User>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A User who is an outside collaborator of an enterprise through one or more organizations. */
export type EnterpriseOutsideCollaboratorEdge = {
  __typename?: 'EnterpriseOutsideCollaboratorEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<User>;
  /** The enterprise organization repositories this user is a member of. */
  repositories: EnterpriseRepositoryInfoConnection;
};


/** A User who is an outside collaborator of an enterprise through one or more organizations. */
export type EnterpriseOutsideCollaboratorEdgeRepositoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<RepositoryOrder>;
};

/**
 * Enterprise information visible to enterprise owners or enterprise owners'
 * personal access tokens (classic) with read:enterprise or admin:enterprise scope.
 */
export type EnterpriseOwnerInfo = {
  __typename?: 'EnterpriseOwnerInfo';
  /** A list of all of the administrators for this enterprise. */
  admins: EnterpriseAdministratorConnection;
  /** A list of users in the enterprise who currently have two-factor authentication disabled. */
  affiliatedUsersWithTwoFactorDisabled: UserConnection;
  /** Whether or not affiliated users with two-factor authentication disabled exist in the enterprise. */
  affiliatedUsersWithTwoFactorDisabledExist: Scalars['Boolean']['output'];
  /** The setting value for whether private repository forking is enabled for repositories in organizations in this enterprise. */
  allowPrivateRepositoryForkingSetting: EnterpriseEnabledDisabledSettingValue;
  /** A list of enterprise organizations configured with the provided private repository forking setting value. */
  allowPrivateRepositoryForkingSettingOrganizations: OrganizationConnection;
  /** The value for the allow private repository forking policy on the enterprise. */
  allowPrivateRepositoryForkingSettingPolicyValue?: Maybe<EnterpriseAllowPrivateRepositoryForkingPolicyValue>;
  /** The setting value for base repository permissions for organizations in this enterprise. */
  defaultRepositoryPermissionSetting: EnterpriseDefaultRepositoryPermissionSettingValue;
  /** A list of enterprise organizations configured with the provided base repository permission. */
  defaultRepositoryPermissionSettingOrganizations: OrganizationConnection;
  /**
   * A list of domains owned by the enterprise. Visible to enterprise owners or
   * enterprise owners' personal access tokens (classic) with admin:enterprise scope.
   */
  domains: VerifiableDomainConnection;
  /** Enterprise Server installations owned by the enterprise. */
  enterpriseServerInstallations: EnterpriseServerInstallationConnection;
  /** A list of failed invitations in the enterprise. */
  failedInvitations: EnterpriseFailedInvitationConnection;
  /** The setting value for whether the enterprise has an IP allow list enabled. */
  ipAllowListEnabledSetting: IpAllowListEnabledSettingValue;
  /**
   * The IP addresses that are allowed to access resources owned by the enterprise.
   * Visible to enterprise owners or enterprise owners' personal access tokens
   * (classic) with admin:enterprise scope.
   */
  ipAllowListEntries: IpAllowListEntryConnection;
  /** The setting value for whether the enterprise has IP allow list configuration for installed GitHub Apps enabled. */
  ipAllowListForInstalledAppsEnabledSetting: IpAllowListForInstalledAppsEnabledSettingValue;
  /** The setting value for whether the enterprise has IP allow list user-level enforcement enabled. */
  ipAllowListUserLevelEnforcementEnabledSetting: IpAllowListUserLevelEnforcementEnabledSettingValue;
  /** Whether or not the base repository permission is currently being updated. */
  isUpdatingDefaultRepositoryPermission: Scalars['Boolean']['output'];
  /** Whether the two-factor authentication requirement is currently being enforced. */
  isUpdatingTwoFactorRequirement: Scalars['Boolean']['output'];
  /**
   * The setting value for whether organization members with admin permissions on a
   * repository can change repository visibility.
   */
  membersCanChangeRepositoryVisibilitySetting: EnterpriseEnabledDisabledSettingValue;
  /** A list of enterprise organizations configured with the provided can change repository visibility setting value. */
  membersCanChangeRepositoryVisibilitySettingOrganizations: OrganizationConnection;
  /** The setting value for whether members of organizations in the enterprise can create internal repositories. */
  membersCanCreateInternalRepositoriesSetting?: Maybe<Scalars['Boolean']['output']>;
  /** The setting value for whether members of organizations in the enterprise can create private repositories. */
  membersCanCreatePrivateRepositoriesSetting?: Maybe<Scalars['Boolean']['output']>;
  /** The setting value for whether members of organizations in the enterprise can create public repositories. */
  membersCanCreatePublicRepositoriesSetting?: Maybe<Scalars['Boolean']['output']>;
  /** The setting value for whether members of organizations in the enterprise can create repositories. */
  membersCanCreateRepositoriesSetting?: Maybe<EnterpriseMembersCanCreateRepositoriesSettingValue>;
  /** A list of enterprise organizations configured with the provided repository creation setting value. */
  membersCanCreateRepositoriesSettingOrganizations: OrganizationConnection;
  /** The setting value for whether members with admin permissions for repositories can delete issues. */
  membersCanDeleteIssuesSetting: EnterpriseEnabledDisabledSettingValue;
  /** A list of enterprise organizations configured with the provided members can delete issues setting value. */
  membersCanDeleteIssuesSettingOrganizations: OrganizationConnection;
  /** The setting value for whether members with admin permissions for repositories can delete or transfer repositories. */
  membersCanDeleteRepositoriesSetting: EnterpriseEnabledDisabledSettingValue;
  /** A list of enterprise organizations configured with the provided members can delete repositories setting value. */
  membersCanDeleteRepositoriesSettingOrganizations: OrganizationConnection;
  /** The setting value for whether members of organizations in the enterprise can invite outside collaborators. */
  membersCanInviteCollaboratorsSetting: EnterpriseEnabledDisabledSettingValue;
  /** A list of enterprise organizations configured with the provided members can invite collaborators setting value. */
  membersCanInviteCollaboratorsSettingOrganizations: OrganizationConnection;
  /** Indicates whether members of this enterprise's organizations can purchase additional services for those organizations. */
  membersCanMakePurchasesSetting: EnterpriseMembersCanMakePurchasesSettingValue;
  /** The setting value for whether members with admin permissions for repositories can update protected branches. */
  membersCanUpdateProtectedBranchesSetting: EnterpriseEnabledDisabledSettingValue;
  /** A list of enterprise organizations configured with the provided members can update protected branches setting value. */
  membersCanUpdateProtectedBranchesSettingOrganizations: OrganizationConnection;
  /** The setting value for whether members can view dependency insights. */
  membersCanViewDependencyInsightsSetting: EnterpriseEnabledDisabledSettingValue;
  /** A list of enterprise organizations configured with the provided members can view dependency insights setting value. */
  membersCanViewDependencyInsightsSettingOrganizations: OrganizationConnection;
  /** Indicates if email notification delivery for this enterprise is restricted to verified or approved domains. */
  notificationDeliveryRestrictionEnabledSetting: NotificationRestrictionSettingValue;
  /** The OIDC Identity Provider for the enterprise. */
  oidcProvider?: Maybe<OidcProvider>;
  /** The setting value for whether organization projects are enabled for organizations in this enterprise. */
  organizationProjectsSetting: EnterpriseEnabledDisabledSettingValue;
  /** A list of enterprise organizations configured with the provided organization projects setting value. */
  organizationProjectsSettingOrganizations: OrganizationConnection;
  /** A list of outside collaborators across the repositories in the enterprise. */
  outsideCollaborators: EnterpriseOutsideCollaboratorConnection;
  /** A list of pending administrator invitations for the enterprise. */
  pendingAdminInvitations: EnterpriseAdministratorInvitationConnection;
  /** A list of pending collaborator invitations across the repositories in the enterprise. */
  pendingCollaboratorInvitations: RepositoryInvitationConnection;
  /** A list of pending member invitations for organizations in the enterprise. */
  pendingMemberInvitations: EnterprisePendingMemberInvitationConnection;
  /** A list of pending unaffiliated member invitations for the enterprise. */
  pendingUnaffiliatedMemberInvitations: EnterpriseMemberInvitationConnection;
  /** The setting value for whether deploy keys are enabled for repositories in organizations in this enterprise. */
  repositoryDeployKeySetting: EnterpriseEnabledDisabledSettingValue;
  /** A list of enterprise organizations configured with the provided deploy keys setting value. */
  repositoryDeployKeySettingOrganizations: OrganizationConnection;
  /** The setting value for whether repository projects are enabled in this enterprise. */
  repositoryProjectsSetting: EnterpriseEnabledDisabledSettingValue;
  /** A list of enterprise organizations configured with the provided repository projects setting value. */
  repositoryProjectsSettingOrganizations: OrganizationConnection;
  /** The SAML Identity Provider for the enterprise. */
  samlIdentityProvider?: Maybe<EnterpriseIdentityProvider>;
  /** A list of enterprise organizations configured with the SAML single sign-on setting value. */
  samlIdentityProviderSettingOrganizations: OrganizationConnection;
  /** A list of members with a support entitlement. */
  supportEntitlements: EnterpriseMemberConnection;
  /**
   * The setting value for whether team discussions are enabled for organizations in this enterprise.
   * @deprecated The Team Discussions feature is deprecated in favor of Organization Discussions. Follow the guide at https://github.blog/changelog/2023-02-08-sunset-notice-team-discussions/ to find a suitable replacement. Removal on 2024-07-01 UTC.
   */
  teamDiscussionsSetting: EnterpriseEnabledDisabledSettingValue;
  /** The setting value for what methods of two-factor authentication the enterprise prevents its users from having. */
  twoFactorDisallowedMethodsSetting: EnterpriseDisallowedMethodsSettingValue;
  /** The setting value for whether the enterprise requires two-factor authentication for its organizations and users. */
  twoFactorRequiredSetting: EnterpriseEnabledSettingValue;
  /** A list of enterprise organizations configured with the two-factor authentication setting value. */
  twoFactorRequiredSettingOrganizations: OrganizationConnection;
};


/**
 * Enterprise information visible to enterprise owners or enterprise owners'
 * personal access tokens (classic) with read:enterprise or admin:enterprise scope.
 */
export type EnterpriseOwnerInfoAdminsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasTwoFactorEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EnterpriseMemberOrder>;
  organizationLogins?: InputMaybe<Array<Scalars['String']['input']>>;
  query?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<EnterpriseAdministratorRole>;
  twoFactorMethodSecurity?: InputMaybe<TwoFactorCredentialSecurityType>;
};


/**
 * Enterprise information visible to enterprise owners or enterprise owners'
 * personal access tokens (classic) with read:enterprise or admin:enterprise scope.
 */
export type EnterpriseOwnerInfoAffiliatedUsersWithTwoFactorDisabledArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/**
 * Enterprise information visible to enterprise owners or enterprise owners'
 * personal access tokens (classic) with read:enterprise or admin:enterprise scope.
 */
export type EnterpriseOwnerInfoAllowPrivateRepositoryForkingSettingOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrganizationOrder>;
  value: Scalars['Boolean']['input'];
};


/**
 * Enterprise information visible to enterprise owners or enterprise owners'
 * personal access tokens (classic) with read:enterprise or admin:enterprise scope.
 */
export type EnterpriseOwnerInfoDefaultRepositoryPermissionSettingOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrganizationOrder>;
  value: DefaultRepositoryPermissionField;
};


/**
 * Enterprise information visible to enterprise owners or enterprise owners'
 * personal access tokens (classic) with read:enterprise or admin:enterprise scope.
 */
export type EnterpriseOwnerInfoDomainsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isApproved?: InputMaybe<Scalars['Boolean']['input']>;
  isVerified?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<VerifiableDomainOrder>;
};


/**
 * Enterprise information visible to enterprise owners or enterprise owners'
 * personal access tokens (classic) with read:enterprise or admin:enterprise scope.
 */
export type EnterpriseOwnerInfoEnterpriseServerInstallationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  connectedOnly?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EnterpriseServerInstallationOrder>;
};


/**
 * Enterprise information visible to enterprise owners or enterprise owners'
 * personal access tokens (classic) with read:enterprise or admin:enterprise scope.
 */
export type EnterpriseOwnerInfoFailedInvitationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Enterprise information visible to enterprise owners or enterprise owners'
 * personal access tokens (classic) with read:enterprise or admin:enterprise scope.
 */
export type EnterpriseOwnerInfoIpAllowListEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<IpAllowListEntryOrder>;
};


/**
 * Enterprise information visible to enterprise owners or enterprise owners'
 * personal access tokens (classic) with read:enterprise or admin:enterprise scope.
 */
export type EnterpriseOwnerInfoMembersCanChangeRepositoryVisibilitySettingOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrganizationOrder>;
  value: Scalars['Boolean']['input'];
};


/**
 * Enterprise information visible to enterprise owners or enterprise owners'
 * personal access tokens (classic) with read:enterprise or admin:enterprise scope.
 */
export type EnterpriseOwnerInfoMembersCanCreateRepositoriesSettingOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrganizationOrder>;
  value: OrganizationMembersCanCreateRepositoriesSettingValue;
};


/**
 * Enterprise information visible to enterprise owners or enterprise owners'
 * personal access tokens (classic) with read:enterprise or admin:enterprise scope.
 */
export type EnterpriseOwnerInfoMembersCanDeleteIssuesSettingOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrganizationOrder>;
  value: Scalars['Boolean']['input'];
};


/**
 * Enterprise information visible to enterprise owners or enterprise owners'
 * personal access tokens (classic) with read:enterprise or admin:enterprise scope.
 */
export type EnterpriseOwnerInfoMembersCanDeleteRepositoriesSettingOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrganizationOrder>;
  value: Scalars['Boolean']['input'];
};


/**
 * Enterprise information visible to enterprise owners or enterprise owners'
 * personal access tokens (classic) with read:enterprise or admin:enterprise scope.
 */
export type EnterpriseOwnerInfoMembersCanInviteCollaboratorsSettingOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrganizationOrder>;
  value: Scalars['Boolean']['input'];
};


/**
 * Enterprise information visible to enterprise owners or enterprise owners'
 * personal access tokens (classic) with read:enterprise or admin:enterprise scope.
 */
export type EnterpriseOwnerInfoMembersCanUpdateProtectedBranchesSettingOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrganizationOrder>;
  value: Scalars['Boolean']['input'];
};


/**
 * Enterprise information visible to enterprise owners or enterprise owners'
 * personal access tokens (classic) with read:enterprise or admin:enterprise scope.
 */
export type EnterpriseOwnerInfoMembersCanViewDependencyInsightsSettingOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrganizationOrder>;
  value: Scalars['Boolean']['input'];
};


/**
 * Enterprise information visible to enterprise owners or enterprise owners'
 * personal access tokens (classic) with read:enterprise or admin:enterprise scope.
 */
export type EnterpriseOwnerInfoOrganizationProjectsSettingOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrganizationOrder>;
  value: Scalars['Boolean']['input'];
};


/**
 * Enterprise information visible to enterprise owners or enterprise owners'
 * personal access tokens (classic) with read:enterprise or admin:enterprise scope.
 */
export type EnterpriseOwnerInfoOutsideCollaboratorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasTwoFactorEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  login?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<EnterpriseMemberOrder>;
  organizationLogins?: InputMaybe<Array<Scalars['String']['input']>>;
  query?: InputMaybe<Scalars['String']['input']>;
  twoFactorMethodSecurity?: InputMaybe<TwoFactorCredentialSecurityType>;
  visibility?: InputMaybe<RepositoryVisibility>;
};


/**
 * Enterprise information visible to enterprise owners or enterprise owners'
 * personal access tokens (classic) with read:enterprise or admin:enterprise scope.
 */
export type EnterpriseOwnerInfoPendingAdminInvitationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EnterpriseAdministratorInvitationOrder>;
  query?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<EnterpriseAdministratorRole>;
};


/**
 * Enterprise information visible to enterprise owners or enterprise owners'
 * personal access tokens (classic) with read:enterprise or admin:enterprise scope.
 */
export type EnterpriseOwnerInfoPendingCollaboratorInvitationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<RepositoryInvitationOrder>;
  query?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Enterprise information visible to enterprise owners or enterprise owners'
 * personal access tokens (classic) with read:enterprise or admin:enterprise scope.
 */
export type EnterpriseOwnerInfoPendingMemberInvitationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  invitationSource?: InputMaybe<OrganizationInvitationSource>;
  last?: InputMaybe<Scalars['Int']['input']>;
  organizationLogins?: InputMaybe<Array<Scalars['String']['input']>>;
  query?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Enterprise information visible to enterprise owners or enterprise owners'
 * personal access tokens (classic) with read:enterprise or admin:enterprise scope.
 */
export type EnterpriseOwnerInfoPendingUnaffiliatedMemberInvitationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EnterpriseMemberInvitationOrder>;
  query?: InputMaybe<Scalars['String']['input']>;
};


/**
 * Enterprise information visible to enterprise owners or enterprise owners'
 * personal access tokens (classic) with read:enterprise or admin:enterprise scope.
 */
export type EnterpriseOwnerInfoRepositoryDeployKeySettingOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrganizationOrder>;
  value: Scalars['Boolean']['input'];
};


/**
 * Enterprise information visible to enterprise owners or enterprise owners'
 * personal access tokens (classic) with read:enterprise or admin:enterprise scope.
 */
export type EnterpriseOwnerInfoRepositoryProjectsSettingOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrganizationOrder>;
  value: Scalars['Boolean']['input'];
};


/**
 * Enterprise information visible to enterprise owners or enterprise owners'
 * personal access tokens (classic) with read:enterprise or admin:enterprise scope.
 */
export type EnterpriseOwnerInfoSamlIdentityProviderSettingOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrganizationOrder>;
  value: IdentityProviderConfigurationState;
};


/**
 * Enterprise information visible to enterprise owners or enterprise owners'
 * personal access tokens (classic) with read:enterprise or admin:enterprise scope.
 */
export type EnterpriseOwnerInfoSupportEntitlementsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EnterpriseMemberOrder>;
};


/**
 * Enterprise information visible to enterprise owners or enterprise owners'
 * personal access tokens (classic) with read:enterprise or admin:enterprise scope.
 */
export type EnterpriseOwnerInfoTwoFactorRequiredSettingOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrganizationOrder>;
  value: Scalars['Boolean']['input'];
};

/** The connection type for OrganizationInvitation. */
export type EnterprisePendingMemberInvitationConnection = {
  __typename?: 'EnterprisePendingMemberInvitationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EnterprisePendingMemberInvitationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<OrganizationInvitation>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
  /** Identifies the total count of unique users in the connection. */
  totalUniqueUserCount: Scalars['Int']['output'];
};

/** An invitation to be a member in an enterprise organization. */
export type EnterprisePendingMemberInvitationEdge = {
  __typename?: 'EnterprisePendingMemberInvitationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<OrganizationInvitation>;
};

/** A subset of repository information queryable from an enterprise. */
export type EnterpriseRepositoryInfo = Node & {
  __typename?: 'EnterpriseRepositoryInfo';
  /** The Node ID of the EnterpriseRepositoryInfo object */
  id: Scalars['ID']['output'];
  /** Identifies if the repository is private or internal. */
  isPrivate: Scalars['Boolean']['output'];
  /** The repository's name. */
  name: Scalars['String']['output'];
  /** The repository's name with owner. */
  nameWithOwner: Scalars['String']['output'];
};

/** The connection type for EnterpriseRepositoryInfo. */
export type EnterpriseRepositoryInfoConnection = {
  __typename?: 'EnterpriseRepositoryInfoConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EnterpriseRepositoryInfoEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<EnterpriseRepositoryInfo>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EnterpriseRepositoryInfoEdge = {
  __typename?: 'EnterpriseRepositoryInfoEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EnterpriseRepositoryInfo>;
};

/** An Enterprise Server installation. */
export type EnterpriseServerInstallation = Node & {
  __typename?: 'EnterpriseServerInstallation';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The customer name to which the Enterprise Server installation belongs. */
  customerName: Scalars['String']['output'];
  /** The host name of the Enterprise Server installation. */
  hostName: Scalars['String']['output'];
  /** The Node ID of the EnterpriseServerInstallation object */
  id: Scalars['ID']['output'];
  /** Whether or not the installation is connected to an Enterprise Server installation via GitHub Connect. */
  isConnected: Scalars['Boolean']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** User accounts on this Enterprise Server installation. */
  userAccounts: EnterpriseServerUserAccountConnection;
  /** User accounts uploads for the Enterprise Server installation. */
  userAccountsUploads: EnterpriseServerUserAccountsUploadConnection;
};


/** An Enterprise Server installation. */
export type EnterpriseServerInstallationUserAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EnterpriseServerUserAccountOrder>;
};


/** An Enterprise Server installation. */
export type EnterpriseServerInstallationUserAccountsUploadsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EnterpriseServerUserAccountsUploadOrder>;
};

/** The connection type for EnterpriseServerInstallation. */
export type EnterpriseServerInstallationConnection = {
  __typename?: 'EnterpriseServerInstallationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EnterpriseServerInstallationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<EnterpriseServerInstallation>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EnterpriseServerInstallationEdge = {
  __typename?: 'EnterpriseServerInstallationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EnterpriseServerInstallation>;
};

/** The connection type for EnterpriseServerInstallation. */
export type EnterpriseServerInstallationMembershipConnection = {
  __typename?: 'EnterpriseServerInstallationMembershipConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EnterpriseServerInstallationMembershipEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<EnterpriseServerInstallation>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An Enterprise Server installation that a user is a member of. */
export type EnterpriseServerInstallationMembershipEdge = {
  __typename?: 'EnterpriseServerInstallationMembershipEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EnterpriseServerInstallation>;
  /** The role of the user in the enterprise membership. */
  role: EnterpriseUserAccountMembershipRole;
};

/** Ordering options for Enterprise Server installation connections. */
export type EnterpriseServerInstallationOrder = {
  /** The ordering direction. */
  direction: OrderDirection;
  /** The field to order Enterprise Server installations by. */
  field: EnterpriseServerInstallationOrderField;
};

/** Properties by which Enterprise Server installation connections can be ordered. */
export enum EnterpriseServerInstallationOrderField {
  /** Order Enterprise Server installations by creation time */
  CreatedAt = 'CREATED_AT',
  /** Order Enterprise Server installations by customer name */
  CustomerName = 'CUSTOMER_NAME',
  /** Order Enterprise Server installations by host name */
  HostName = 'HOST_NAME'
}

/** A user account on an Enterprise Server installation. */
export type EnterpriseServerUserAccount = Node & {
  __typename?: 'EnterpriseServerUserAccount';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** User emails belonging to this user account. */
  emails: EnterpriseServerUserAccountEmailConnection;
  /** The Enterprise Server installation on which this user account exists. */
  enterpriseServerInstallation: EnterpriseServerInstallation;
  /** The Node ID of the EnterpriseServerUserAccount object */
  id: Scalars['ID']['output'];
  /** Whether the user account is a site administrator on the Enterprise Server installation. */
  isSiteAdmin: Scalars['Boolean']['output'];
  /** The login of the user account on the Enterprise Server installation. */
  login: Scalars['String']['output'];
  /** The profile name of the user account on the Enterprise Server installation. */
  profileName?: Maybe<Scalars['String']['output']>;
  /** The date and time when the user account was created on the Enterprise Server installation. */
  remoteCreatedAt: Scalars['DateTime']['output'];
  /** The ID of the user account on the Enterprise Server installation. */
  remoteUserId: Scalars['Int']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};


/** A user account on an Enterprise Server installation. */
export type EnterpriseServerUserAccountEmailsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EnterpriseServerUserAccountEmailOrder>;
};

/** The connection type for EnterpriseServerUserAccount. */
export type EnterpriseServerUserAccountConnection = {
  __typename?: 'EnterpriseServerUserAccountConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EnterpriseServerUserAccountEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<EnterpriseServerUserAccount>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EnterpriseServerUserAccountEdge = {
  __typename?: 'EnterpriseServerUserAccountEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EnterpriseServerUserAccount>;
};

/** An email belonging to a user account on an Enterprise Server installation. */
export type EnterpriseServerUserAccountEmail = Node & {
  __typename?: 'EnterpriseServerUserAccountEmail';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The email address. */
  email: Scalars['String']['output'];
  /** The Node ID of the EnterpriseServerUserAccountEmail object */
  id: Scalars['ID']['output'];
  /** Indicates whether this is the primary email of the associated user account. */
  isPrimary: Scalars['Boolean']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The user account to which the email belongs. */
  userAccount: EnterpriseServerUserAccount;
};

/** The connection type for EnterpriseServerUserAccountEmail. */
export type EnterpriseServerUserAccountEmailConnection = {
  __typename?: 'EnterpriseServerUserAccountEmailConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EnterpriseServerUserAccountEmailEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<EnterpriseServerUserAccountEmail>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EnterpriseServerUserAccountEmailEdge = {
  __typename?: 'EnterpriseServerUserAccountEmailEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EnterpriseServerUserAccountEmail>;
};

/** Ordering options for Enterprise Server user account email connections. */
export type EnterpriseServerUserAccountEmailOrder = {
  /** The ordering direction. */
  direction: OrderDirection;
  /** The field to order emails by. */
  field: EnterpriseServerUserAccountEmailOrderField;
};

/** Properties by which Enterprise Server user account email connections can be ordered. */
export enum EnterpriseServerUserAccountEmailOrderField {
  /** Order emails by email */
  Email = 'EMAIL'
}

/** Ordering options for Enterprise Server user account connections. */
export type EnterpriseServerUserAccountOrder = {
  /** The ordering direction. */
  direction: OrderDirection;
  /** The field to order user accounts by. */
  field: EnterpriseServerUserAccountOrderField;
};

/** Properties by which Enterprise Server user account connections can be ordered. */
export enum EnterpriseServerUserAccountOrderField {
  /** Order user accounts by login */
  Login = 'LOGIN',
  /** Order user accounts by creation time on the Enterprise Server installation */
  RemoteCreatedAt = 'REMOTE_CREATED_AT'
}

/** A user accounts upload from an Enterprise Server installation. */
export type EnterpriseServerUserAccountsUpload = Node & {
  __typename?: 'EnterpriseServerUserAccountsUpload';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The enterprise to which this upload belongs. */
  enterprise: Enterprise;
  /** The Enterprise Server installation for which this upload was generated. */
  enterpriseServerInstallation: EnterpriseServerInstallation;
  /** The Node ID of the EnterpriseServerUserAccountsUpload object */
  id: Scalars['ID']['output'];
  /** The name of the file uploaded. */
  name: Scalars['String']['output'];
  /** The synchronization state of the upload */
  syncState: EnterpriseServerUserAccountsUploadSyncState;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** The connection type for EnterpriseServerUserAccountsUpload. */
export type EnterpriseServerUserAccountsUploadConnection = {
  __typename?: 'EnterpriseServerUserAccountsUploadConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EnterpriseServerUserAccountsUploadEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<EnterpriseServerUserAccountsUpload>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EnterpriseServerUserAccountsUploadEdge = {
  __typename?: 'EnterpriseServerUserAccountsUploadEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EnterpriseServerUserAccountsUpload>;
};

/** Ordering options for Enterprise Server user accounts upload connections. */
export type EnterpriseServerUserAccountsUploadOrder = {
  /** The ordering direction. */
  direction: OrderDirection;
  /** The field to order user accounts uploads by. */
  field: EnterpriseServerUserAccountsUploadOrderField;
};

/** Properties by which Enterprise Server user accounts upload connections can be ordered. */
export enum EnterpriseServerUserAccountsUploadOrderField {
  /** Order user accounts uploads by creation time */
  CreatedAt = 'CREATED_AT'
}

/** Synchronization state of the Enterprise Server user accounts upload */
export enum EnterpriseServerUserAccountsUploadSyncState {
  /** The synchronization of the upload failed. */
  Failure = 'FAILURE',
  /** The synchronization of the upload is pending. */
  Pending = 'PENDING',
  /** The synchronization of the upload succeeded. */
  Success = 'SUCCESS'
}

/** A team that belongs to an enterprise and can be assigned to multiple organizations. */
export type EnterpriseTeam = Node & TeamReviewRequestable & {
  __typename?: 'EnterpriseTeam';
  /** Organizations this team is assigned to. */
  assignedOrganizations: EnterpriseTeamAssignedOrganizationConnection;
  /** The human-readable, unique identifier for the enterprise and team. */
  combinedSlug: Scalars['String']['output'];
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The description of the team. */
  description?: Maybe<Scalars['String']['output']>;
  /** The enterprise this team belongs to. */
  enterprise?: Maybe<Enterprise>;
  /** A list of users who are members of this enterprise team. */
  enterpriseTeamMembers: EnterpriseTeamMemberConnection;
  /** Identifies the primary key from the database as a BigInt. */
  fullDatabaseId?: Maybe<Scalars['BigInt']['output']>;
  /** The Node ID of the EnterpriseTeam object */
  id: Scalars['ID']['output'];
  /** Whether the viewer is a member of this team. */
  isViewerMember: Scalars['Boolean']['output'];
  /** The name of the team. */
  name: Scalars['String']['output'];
  /** Whether the team will receive notifications when mentioned. */
  notificationSetting: TeamNotificationSetting;
  /** How this team selects its associated organizations. */
  organizationSelectionType: EnterpriseTeamOrganizationSelectionType;
  /** The level of privacy the team has. */
  privacy: TeamPrivacy;
  /** The slug corresponding to the team. */
  slug: Scalars['String']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** Whether the viewer can administer this team. */
  viewerCanAdminister: Scalars['Boolean']['output'];
};


/** A team that belongs to an enterprise and can be assigned to multiple organizations. */
export type EnterpriseTeamAssignedOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EnterpriseTeamOrganizationOrder>;
};


/** A team that belongs to an enterprise and can be assigned to multiple organizations. */
export type EnterpriseTeamEnterpriseTeamMembersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EnterpriseTeamMemberOrder>;
  query?: InputMaybe<Scalars['String']['input']>;
};

/** The connection type for Organization. */
export type EnterpriseTeamAssignedOrganizationConnection = {
  __typename?: 'EnterpriseTeamAssignedOrganizationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EnterpriseTeamAssignedOrganizationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Organization>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** Represents an organization that an enterprise team is assigned to. */
export type EnterpriseTeamAssignedOrganizationEdge = {
  __typename?: 'EnterpriseTeamAssignedOrganizationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  node?: Maybe<Organization>;
};

/** A list of enterprise teams owned by the enterprise. */
export type EnterpriseTeamConnection = {
  __typename?: 'EnterpriseTeamConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EnterpriseTeamEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<EnterpriseTeam>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EnterpriseTeamEdge = {
  __typename?: 'EnterpriseTeamEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<EnterpriseTeam>;
};

/** The connection type for User. */
export type EnterpriseTeamMemberConnection = {
  __typename?: 'EnterpriseTeamMemberConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EnterpriseTeamMemberEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<User>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** Represents a user who is a member of an enterprise team. */
export type EnterpriseTeamMemberEdge = {
  __typename?: 'EnterpriseTeamMemberEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  node?: Maybe<User>;
};

/** Ordering options for enterprise team member connections. */
export type EnterpriseTeamMemberOrder = {
  /** The ordering direction. */
  direction: OrderDirection;
  /** The field to order enterprise team members by. */
  field: EnterpriseTeamMemberOrderField;
};

/** Properties by which enterprise team member connections can be ordered. */
export enum EnterpriseTeamMemberOrderField {
  /** Order enterprise team members by creation time. */
  CreatedAt = 'CREATED_AT',
  /** Order enterprise team members by ID. */
  Id = 'ID',
  /** Order enterprise team members by login. */
  Login = 'LOGIN'
}

/** Ordering options for enterprise team connections. */
export type EnterpriseTeamOrder = {
  /** The ordering direction. */
  direction: OrderDirection;
  /** The field to order enterprise teams by. */
  field: EnterpriseTeamOrderField;
};

/** Properties by which enterprise team connections can be ordered. */
export enum EnterpriseTeamOrderField {
  /** Order enterprise teams by creation time. */
  CreatedAt = 'CREATED_AT',
  /** Order enterprise teams by ID. */
  Id = 'ID',
  /** Order enterprise teams by name. */
  Name = 'NAME'
}

/** Ordering options for enterprise team organization connections. */
export type EnterpriseTeamOrganizationOrder = {
  /** The ordering direction. */
  direction: OrderDirection;
  /** The field to order organizations by. */
  field: EnterpriseTeamOrganizationOrderField;
};

/** Properties by which enterprise team organization connections can be ordered. */
export enum EnterpriseTeamOrganizationOrderField {
  /** Order enterprise team organizations by creation time. */
  CreatedAt = 'CREATED_AT',
  /** Order enterprise team organizations by ID. */
  Id = 'ID',
  /** Order enterprise team organizations by login. */
  Login = 'LOGIN'
}

/** The possible organization selection types for an enterprise team. */
export enum EnterpriseTeamOrganizationSelectionType {
  /** The team is associated with all organizations in the enterprise. */
  All = 'ALL',
  /** The team is not associated with any organizations. */
  Disabled = 'DISABLED',
  /** The team is associated with selected organizations. */
  Selected = 'SELECTED'
}

/** An account for a user who is an admin of an enterprise or a member of an enterprise through one or more organizations. */
export type EnterpriseUserAccount = Actor & Node & {
  __typename?: 'EnterpriseUserAccount';
  /** A URL pointing to the enterprise user account's public avatar. */
  avatarUrl: Scalars['URI']['output'];
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The enterprise in which this user account exists. */
  enterprise: Enterprise;
  /** A list of Enterprise Server installations this user is a member of. */
  enterpriseInstallations: EnterpriseServerInstallationMembershipConnection;
  /** The Node ID of the EnterpriseUserAccount object */
  id: Scalars['ID']['output'];
  /** An identifier for the enterprise user account, a login or email address */
  login: Scalars['String']['output'];
  /** The name of the enterprise user account */
  name?: Maybe<Scalars['String']['output']>;
  /** A list of enterprise organizations this user is a member of. */
  organizations: EnterpriseOrganizationMembershipConnection;
  /** The HTTP path for this user. */
  resourcePath: Scalars['URI']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The HTTP URL for this user. */
  url: Scalars['URI']['output'];
  /** The user within the enterprise. */
  user?: Maybe<User>;
};


/** An account for a user who is an admin of an enterprise or a member of an enterprise through one or more organizations. */
export type EnterpriseUserAccountAvatarUrlArgs = {
  size?: InputMaybe<Scalars['Int']['input']>;
};


/** An account for a user who is an admin of an enterprise or a member of an enterprise through one or more organizations. */
export type EnterpriseUserAccountEnterpriseInstallationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<EnterpriseServerInstallationOrder>;
  query?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<EnterpriseUserAccountMembershipRole>;
};


/** An account for a user who is an admin of an enterprise or a member of an enterprise through one or more organizations. */
export type EnterpriseUserAccountOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrganizationOrder>;
  query?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<EnterpriseUserAccountMembershipRole>;
};

/** The possible roles for enterprise membership. */
export enum EnterpriseUserAccountMembershipRole {
  /** The user is a member of an organization in the enterprise. */
  Member = 'MEMBER',
  /** The user is an owner of an organization in the enterprise. */
  Owner = 'OWNER',
  /**
   * The user is not an owner of the enterprise, and not a member or owner of any
   * organizations in the enterprise; only for EMU-enabled enterprises.
   */
  Unaffiliated = 'UNAFFILIATED'
}

/** The possible GitHub Enterprise deployments where this user can exist. */
export enum EnterpriseUserDeployment {
  /** The user is part of a GitHub Enterprise Cloud deployment. */
  Cloud = 'CLOUD',
  /** The user is part of a GitHub Enterprise Server deployment. */
  Server = 'SERVER'
}

/** An environment. */
export type Environment = Node & {
  __typename?: 'Environment';
  /** Identifies the primary key from the database. */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** The Node ID of the Environment object */
  id: Scalars['ID']['output'];
  /** Indicates whether or not this environment is currently pinned to the repository */
  isPinned?: Maybe<Scalars['Boolean']['output']>;
  /** The latest completed deployment with status success, failure, or error if it exists */
  latestCompletedDeployment?: Maybe<Deployment>;
  /** The name of the environment */
  name: Scalars['String']['output'];
  /** The position of the environment if it is pinned, null if it is not pinned */
  pinnedPosition?: Maybe<Scalars['Int']['output']>;
  /** The protection rules defined for this environment */
  protectionRules: DeploymentProtectionRuleConnection;
};


/** An environment. */
export type EnvironmentProtectionRulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for Environment. */
export type EnvironmentConnection = {
  __typename?: 'EnvironmentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<EnvironmentEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Environment>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type EnvironmentEdge = {
  __typename?: 'EnvironmentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Environment>;
};

/** Properties by which environments connections can be ordered */
export enum EnvironmentOrderField {
  /** Order environments by name. */
  Name = 'NAME'
}

/** Properties by which environments connections can be ordered */
export enum EnvironmentPinnedFilterField {
  /** All environments will be returned. */
  All = 'ALL',
  /** Environments exclude pinned will be returned */
  None = 'NONE',
  /** Only pinned environment will be returned */
  Only = 'ONLY'
}

/** Ordering options for environments */
export type Environments = {
  /** The direction in which to order environments by the specified field. */
  direction: OrderDirection;
  /** The field to order environments by. */
  field: EnvironmentOrderField;
};

/**
 * An external identity provisioned by SAML SSO or SCIM. If SAML is configured on
 * the organization, the external identity is visible to (1) organization owners,
 * (2) organization owners' personal access tokens (classic) with read:org or
 * admin:org scope, (3) GitHub App with an installation token with read or write
 * access to members. If SAML is configured on the enterprise, the external
 * identity is visible to (1) enterprise owners, (2) enterprise owners' personal
 * access tokens (classic) with read:enterprise or admin:enterprise scope.
 */
export type ExternalIdentity = Node & {
  __typename?: 'ExternalIdentity';
  /** The GUID for this identity */
  guid: Scalars['String']['output'];
  /** The Node ID of the ExternalIdentity object */
  id: Scalars['ID']['output'];
  /** Organization invitation for this SCIM-provisioned external identity */
  organizationInvitation?: Maybe<OrganizationInvitation>;
  /** SAML Identity attributes */
  samlIdentity?: Maybe<ExternalIdentitySamlAttributes>;
  /** SCIM Identity attributes */
  scimIdentity?: Maybe<ExternalIdentityScimAttributes>;
  /** User linked to this external identity. Will be NULL if this identity has not been claimed by an organization member. */
  user?: Maybe<User>;
};

/** An attribute for the External Identity attributes collection */
export type ExternalIdentityAttribute = {
  __typename?: 'ExternalIdentityAttribute';
  /** The attribute metadata as JSON */
  metadata?: Maybe<Scalars['String']['output']>;
  /** The attribute name */
  name: Scalars['String']['output'];
  /** The attribute value */
  value: Scalars['String']['output'];
};

/** The connection type for ExternalIdentity. */
export type ExternalIdentityConnection = {
  __typename?: 'ExternalIdentityConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ExternalIdentityEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ExternalIdentity>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ExternalIdentityEdge = {
  __typename?: 'ExternalIdentityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ExternalIdentity>;
};

/** SAML attributes for the External Identity */
export type ExternalIdentitySamlAttributes = {
  __typename?: 'ExternalIdentitySamlAttributes';
  /** SAML Identity attributes */
  attributes: Array<ExternalIdentityAttribute>;
  /** The emails associated with the SAML identity */
  emails?: Maybe<Array<UserEmailMetadata>>;
  /** Family name of the SAML identity */
  familyName?: Maybe<Scalars['String']['output']>;
  /** Given name of the SAML identity */
  givenName?: Maybe<Scalars['String']['output']>;
  /** The groups linked to this identity in IDP */
  groups?: Maybe<Array<Scalars['String']['output']>>;
  /** The NameID of the SAML identity */
  nameId?: Maybe<Scalars['String']['output']>;
  /** The userName of the SAML identity */
  username?: Maybe<Scalars['String']['output']>;
};

/** SCIM attributes for the External Identity */
export type ExternalIdentityScimAttributes = {
  __typename?: 'ExternalIdentityScimAttributes';
  /** The emails associated with the SCIM identity */
  emails?: Maybe<Array<UserEmailMetadata>>;
  /** Family name of the SCIM identity */
  familyName?: Maybe<Scalars['String']['output']>;
  /** Given name of the SCIM identity */
  givenName?: Maybe<Scalars['String']['output']>;
  /** The groups linked to this identity in IDP */
  groups?: Maybe<Array<Scalars['String']['output']>>;
  /** The userName of the SCIM identity */
  username?: Maybe<Scalars['String']['output']>;
};

/**
 * A command to add a file at the given path with the given contents as part of a
 * commit.  Any existing file at that that path will be replaced.
 */
export type FileAddition = {
  /** The base64 encoded contents of the file */
  contents: Scalars['Base64String']['input'];
  /** The path in the repository where the file will be located */
  path: Scalars['String']['input'];
};

/**
 * A description of a set of changes to a file tree to be made as part of
 * a git commit, modeled as zero or more file `additions` and zero or more
 * file `deletions`.
 *
 * Both fields are optional; omitting both will produce a commit with no
 * file changes.
 *
 * `deletions` and `additions` describe changes to files identified
 * by their path in the git tree using unix-style path separators, i.e.
 * `/`.  The root of a git tree is an empty string, so paths are not
 * slash-prefixed.
 *
 * `path` values must be unique across all `additions` and `deletions`
 * provided.  Any duplication will result in a validation error.
 *
 * ### Encoding
 *
 * File contents must be provided in full for each `FileAddition`.
 *
 * The `contents` of a `FileAddition` must be encoded using RFC 4648
 * compliant base64, i.e. correct padding is required and no characters
 * outside the standard alphabet may be used.  Invalid base64
 * encoding will be rejected with a validation error.
 *
 * The encoded contents may be binary.
 *
 * For text files, no assumptions are made about the character encoding of
 * the file contents (after base64 decoding).  No charset transcoding or
 * line-ending normalization will be performed; it is the client's
 * responsibility to manage the character encoding of files they provide.
 * However, for maximum compatibility we recommend using UTF-8 encoding
 * and ensuring that all files in a repository use a consistent
 * line-ending convention (`\n` or `\r\n`), and that all files end
 * with a newline.
 *
 * ### Modeling file changes
 *
 * Each of the the five types of conceptual changes that can be made in a
 * git commit can be described using the `FileChanges` type as follows:
 *
 * 1. New file addition: create file `hello world\n` at path `docs/README.txt`:
 *
 *        {
 *          "additions" [
 *            {
 *              "path": "docs/README.txt",
 *              "contents": base64encode("hello world\n")
 *            }
 *          ]
 *        }
 *
 * 2. Existing file modification: change existing `docs/README.txt` to have new
 *    content `new content here\n`:
 *
 *        {
 *          "additions" [
 *            {
 *              "path": "docs/README.txt",
 *              "contents": base64encode("new content here\n")
 *            }
 *          ]
 *        }
 *
 * 3. Existing file deletion: remove existing file `docs/README.txt`.
 *    Note that the path is required to exist -- specifying a
 *    path that does not exist on the given branch will abort the
 *    commit and return an error.
 *
 *        {
 *          "deletions" [
 *            {
 *              "path": "docs/README.txt"
 *            }
 *          ]
 *        }
 *
 *
 * 4. File rename with no changes: rename `docs/README.txt` with
 *    previous content `hello world\n` to the same content at
 *    `newdocs/README.txt`:
 *
 *        {
 *          "deletions" [
 *            {
 *              "path": "docs/README.txt",
 *            }
 *          ],
 *          "additions" [
 *            {
 *              "path": "newdocs/README.txt",
 *              "contents": base64encode("hello world\n")
 *            }
 *          ]
 *        }
 *
 *
 * 5. File rename with changes: rename `docs/README.txt` with
 *    previous content `hello world\n` to a file at path
 *    `newdocs/README.txt` with content `new contents\n`:
 *
 *        {
 *          "deletions" [
 *            {
 *              "path": "docs/README.txt",
 *            }
 *          ],
 *          "additions" [
 *            {
 *              "path": "newdocs/README.txt",
 *              "contents": base64encode("new contents\n")
 *            }
 *          ]
 *        }
 */
export type FileChanges = {
  /** File to add or change. */
  additions?: InputMaybe<Array<FileAddition>>;
  /** Files to delete. */
  deletions?: InputMaybe<Array<FileDeletion>>;
};

/** A command to delete the file at the given path as part of a commit. */
export type FileDeletion = {
  /** The path to delete */
  path: Scalars['String']['input'];
};

/** Prevent commits that include files with specified file extensions from being pushed to the commit graph. */
export type FileExtensionRestrictionParameters = {
  __typename?: 'FileExtensionRestrictionParameters';
  /** The file extensions that are restricted from being pushed to the commit graph. */
  restrictedFileExtensions: Array<Scalars['String']['output']>;
};

/** Prevent commits that include files with specified file extensions from being pushed to the commit graph. */
export type FileExtensionRestrictionParametersInput = {
  /** The file extensions that are restricted from being pushed to the commit graph. */
  restrictedFileExtensions: Array<Scalars['String']['input']>;
};

/**
 * Prevent commits that include changes in specified file and folder paths from
 * being pushed to the commit graph. This includes absolute paths that contain file names.
 */
export type FilePathRestrictionParameters = {
  __typename?: 'FilePathRestrictionParameters';
  /** The file paths that are restricted from being pushed to the commit graph. */
  restrictedFilePaths: Array<Scalars['String']['output']>;
};

/**
 * Prevent commits that include changes in specified file and folder paths from
 * being pushed to the commit graph. This includes absolute paths that contain file names.
 */
export type FilePathRestrictionParametersInput = {
  /** The file paths that are restricted from being pushed to the commit graph. */
  restrictedFilePaths: Array<Scalars['String']['input']>;
};

/** The possible viewed states of a file . */
export enum FileViewedState {
  /** The file has new changes since last viewed. */
  Dismissed = 'DISMISSED',
  /** The file has not been marked as viewed. */
  Unviewed = 'UNVIEWED',
  /** The file has been marked as viewed. */
  Viewed = 'VIEWED'
}

/** Autogenerated input type of FollowOrganization */
export type FollowOrganizationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the organization to follow. */
  organizationId: Scalars['ID']['input'];
};

/** Autogenerated return type of FollowOrganization. */
export type FollowOrganizationPayload = {
  __typename?: 'FollowOrganizationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The organization that was followed. */
  organization?: Maybe<Organization>;
};

/** Autogenerated input type of FollowUser */
export type FollowUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the user to follow. */
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of FollowUser. */
export type FollowUserPayload = {
  __typename?: 'FollowUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The user that was followed. */
  user?: Maybe<User>;
};

/** The connection type for User. */
export type FollowerConnection = {
  __typename?: 'FollowerConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<User>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** The connection type for User. */
export type FollowingConnection = {
  __typename?: 'FollowingConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<User>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** A funding platform link for a repository. */
export type FundingLink = {
  __typename?: 'FundingLink';
  /** The funding platform this link is for. */
  platform: FundingPlatform;
  /** The configured URL for this funding link. */
  url: Scalars['URI']['output'];
};

/** The possible funding platforms for repository funding links. */
export enum FundingPlatform {
  /** Buy Me a Coffee funding platform. */
  BuyMeACoffee = 'BUY_ME_A_COFFEE',
  /** Community Bridge funding platform. */
  CommunityBridge = 'COMMUNITY_BRIDGE',
  /** Custom funding platform. */
  Custom = 'CUSTOM',
  /** GitHub funding platform. */
  Github = 'GITHUB',
  /** IssueHunt funding platform. */
  Issuehunt = 'ISSUEHUNT',
  /** Ko-fi funding platform. */
  KoFi = 'KO_FI',
  /** LFX Crowdfunding funding platform. */
  LfxCrowdfunding = 'LFX_CROWDFUNDING',
  /** Liberapay funding platform. */
  Liberapay = 'LIBERAPAY',
  /** Open Collective funding platform. */
  OpenCollective = 'OPEN_COLLECTIVE',
  /** Patreon funding platform. */
  Patreon = 'PATREON',
  /** Polar funding platform. */
  Polar = 'POLAR',
  /** thanks.dev funding platform. */
  ThanksDev = 'THANKS_DEV',
  /** Tidelift funding platform. */
  Tidelift = 'TIDELIFT'
}

/** A generic hovercard context with a message and icon */
export type GenericHovercardContext = HovercardContext & {
  __typename?: 'GenericHovercardContext';
  /** A string describing this context */
  message: Scalars['String']['output'];
  /** An octicon to accompany this context */
  octicon: Scalars['String']['output'];
};

/** A Gist. */
export type Gist = Node & Starrable & UniformResourceLocatable & {
  __typename?: 'Gist';
  /** A list of comments associated with the gist */
  comments: GistCommentConnection;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The gist description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The files in this gist. */
  files?: Maybe<Array<Maybe<GistFile>>>;
  /** A list of forks associated with the gist */
  forks: GistConnection;
  /** The Node ID of the Gist object */
  id: Scalars['ID']['output'];
  /** Identifies if the gist is a fork. */
  isFork: Scalars['Boolean']['output'];
  /** Whether the gist is public or not. */
  isPublic: Scalars['Boolean']['output'];
  /** The gist name. */
  name: Scalars['String']['output'];
  /** The gist owner. */
  owner?: Maybe<RepositoryOwner>;
  /** Identifies when the gist was last pushed to. */
  pushedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The HTML path to this resource. */
  resourcePath: Scalars['URI']['output'];
  /** Returns a count of how many stargazers there are on this object */
  stargazerCount: Scalars['Int']['output'];
  /** A list of users who have starred this starrable. */
  stargazers: StargazerConnection;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The HTTP URL for this Gist. */
  url: Scalars['URI']['output'];
  /** Returns a boolean indicating whether the viewing user has starred this starrable. */
  viewerHasStarred: Scalars['Boolean']['output'];
};


/** A Gist. */
export type GistCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A Gist. */
export type GistFilesArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  oid?: InputMaybe<Scalars['GitObjectID']['input']>;
};


/** A Gist. */
export type GistForksArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<GistOrder>;
};


/** A Gist. */
export type GistStargazersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<StarOrder>;
};

/** Represents a comment on an Gist. */
export type GistComment = Comment & Deletable & Minimizable & Node & Updatable & UpdatableComment & {
  __typename?: 'GistComment';
  /** The actor who authored the comment. */
  author?: Maybe<Actor>;
  /** Author's association with the gist. */
  authorAssociation: CommentAuthorAssociation;
  /** Identifies the comment body. */
  body: Scalars['String']['output'];
  /** The body rendered to HTML. */
  bodyHTML: Scalars['HTML']['output'];
  /** The body rendered to text. */
  bodyText: Scalars['String']['output'];
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Check if this comment was created via an email reply. */
  createdViaEmail: Scalars['Boolean']['output'];
  /** Identifies the primary key from the database. */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** The actor who edited the comment. */
  editor?: Maybe<Actor>;
  /** The associated gist. */
  gist: Gist;
  /** The Node ID of the GistComment object */
  id: Scalars['ID']['output'];
  /** Check if this comment was edited and includes an edit with the creation data */
  includesCreatedEdit: Scalars['Boolean']['output'];
  /** Returns whether or not a comment has been minimized. */
  isMinimized: Scalars['Boolean']['output'];
  /** The moment the editor made the last edit */
  lastEditedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Returns why the comment was minimized. One of `abuse`, `off-topic`,
   * `outdated`, `resolved`, `duplicate`, `spam`, and `low-quality`. Note that the
   * case and formatting of these values differs from the inputs to the
   * `MinimizeComment` mutation.
   */
  minimizedReason?: Maybe<Scalars['String']['output']>;
  /** Identifies when the comment was published at. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** A list of edits to this content. */
  userContentEdits?: Maybe<UserContentEditConnection>;
  /** Check if the current viewer can delete this object. */
  viewerCanDelete: Scalars['Boolean']['output'];
  /** Check if the current viewer can minimize this object. */
  viewerCanMinimize: Scalars['Boolean']['output'];
  /** Check if the current viewer can unminimize this object. */
  viewerCanUnminimize: Scalars['Boolean']['output'];
  /** Check if the current viewer can update this object. */
  viewerCanUpdate: Scalars['Boolean']['output'];
  /** Reasons why the current viewer can not update this comment. */
  viewerCannotUpdateReasons: Array<CommentCannotUpdateReason>;
  /** Did the viewer author this comment. */
  viewerDidAuthor: Scalars['Boolean']['output'];
};


/** Represents a comment on an Gist. */
export type GistCommentUserContentEditsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for GistComment. */
export type GistCommentConnection = {
  __typename?: 'GistCommentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GistCommentEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GistComment>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type GistCommentEdge = {
  __typename?: 'GistCommentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<GistComment>;
};

/** The connection type for Gist. */
export type GistConnection = {
  __typename?: 'GistConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GistEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Gist>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type GistEdge = {
  __typename?: 'GistEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Gist>;
};

/** A file in a gist. */
export type GistFile = {
  __typename?: 'GistFile';
  /** The file name encoded to remove characters that are invalid in URL paths. */
  encodedName?: Maybe<Scalars['String']['output']>;
  /** The gist file encoding. */
  encoding?: Maybe<Scalars['String']['output']>;
  /** The file extension from the file name. */
  extension?: Maybe<Scalars['String']['output']>;
  /** Indicates if this file is an image. */
  isImage: Scalars['Boolean']['output'];
  /** Whether the file's contents were truncated. */
  isTruncated: Scalars['Boolean']['output'];
  /** The programming language this file is written in. */
  language?: Maybe<Language>;
  /** The gist file name. */
  name?: Maybe<Scalars['String']['output']>;
  /** The gist file size in bytes. */
  size?: Maybe<Scalars['Int']['output']>;
  /** UTF8 text data or null if the file is binary */
  text?: Maybe<Scalars['String']['output']>;
};


/** A file in a gist. */
export type GistFileTextArgs = {
  truncate?: InputMaybe<Scalars['Int']['input']>;
};

/** Ordering options for gist connections */
export type GistOrder = {
  /** The ordering direction. */
  direction: OrderDirection;
  /** The field to order repositories by. */
  field: GistOrderField;
};

/** Properties by which gist connections can be ordered. */
export enum GistOrderField {
  /** Order gists by creation time */
  CreatedAt = 'CREATED_AT',
  /** Order gists by push time */
  PushedAt = 'PUSHED_AT',
  /** Order gists by update time */
  UpdatedAt = 'UPDATED_AT'
}

/** The privacy of a Gist */
export enum GistPrivacy {
  /** Gists that are public and secret */
  All = 'ALL',
  /** Public */
  Public = 'PUBLIC',
  /** Secret */
  Secret = 'SECRET'
}

/** Represents an actor in a Git commit (ie. an author or committer). */
export type GitActor = {
  __typename?: 'GitActor';
  /** A URL pointing to the author's public avatar. */
  avatarUrl: Scalars['URI']['output'];
  /** The timestamp of the Git action (authoring or committing). */
  date?: Maybe<Scalars['GitTimestamp']['output']>;
  /** The email in the Git commit. */
  email?: Maybe<Scalars['String']['output']>;
  /** The name in the Git commit. */
  name?: Maybe<Scalars['String']['output']>;
  /** The GitHub user corresponding to the email field. Null if no such user exists. */
  user?: Maybe<User>;
};


/** Represents an actor in a Git commit (ie. an author or committer). */
export type GitActorAvatarUrlArgs = {
  size?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for GitActor. */
export type GitActorConnection = {
  __typename?: 'GitActorConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<GitActorEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<GitActor>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type GitActorEdge = {
  __typename?: 'GitActorEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<GitActor>;
};

/** Represents information about the GitHub instance. */
export type GitHubMetadata = {
  __typename?: 'GitHubMetadata';
  /** Returns a String that's a SHA of `github-services` */
  gitHubServicesSha: Scalars['GitObjectID']['output'];
  /** IP addresses that users connect to for git operations */
  gitIpAddresses?: Maybe<Array<Scalars['String']['output']>>;
  /** IP addresses that GitHub Enterprise Importer uses for outbound connections */
  githubEnterpriseImporterIpAddresses?: Maybe<Array<Scalars['String']['output']>>;
  /** IP addresses that service hooks are sent from */
  hookIpAddresses?: Maybe<Array<Scalars['String']['output']>>;
  /** IP addresses that the importer connects from */
  importerIpAddresses?: Maybe<Array<Scalars['String']['output']>>;
  /** Whether or not users are verified */
  isPasswordAuthenticationVerifiable: Scalars['Boolean']['output'];
  /** IP addresses for GitHub Pages' A records */
  pagesIpAddresses?: Maybe<Array<Scalars['String']['output']>>;
};

/** Represents a Git object. */
export type GitObject = {
  /** An abbreviated version of the Git object ID */
  abbreviatedOid: Scalars['String']['output'];
  /** The HTTP path for this Git object */
  commitResourcePath: Scalars['URI']['output'];
  /** The HTTP URL for this Git object */
  commitUrl: Scalars['URI']['output'];
  /** The Node ID of the GitObject object */
  id: Scalars['ID']['output'];
  /** The Git object ID */
  oid: Scalars['GitObjectID']['output'];
  /** The Repository the Git object belongs to */
  repository: Repository;
};

/** Information about a signature (GPG or S/MIME) on a Commit or Tag. */
export type GitSignature = {
  /** Email used to sign this object. */
  email: Scalars['String']['output'];
  /** True if the signature is valid and verified by GitHub. */
  isValid: Scalars['Boolean']['output'];
  /** Payload for GPG signing object. Raw ODB object without the signature header. */
  payload: Scalars['String']['output'];
  /** ASCII-armored signature header from object. */
  signature: Scalars['String']['output'];
  /** GitHub user corresponding to the email signing this commit. */
  signer?: Maybe<User>;
  /**
   * The state of this signature. `VALID` if signature is valid and verified by
   * GitHub, otherwise represents reason why signature is considered invalid.
   */
  state: GitSignatureState;
  /** The date the signature was verified, if valid */
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
  /** True if the signature was made with GitHub's signing key. */
  wasSignedByGitHub: Scalars['Boolean']['output'];
};

/** The state of a Git signature. */
export enum GitSignatureState {
  /** The signing certificate or its chain could not be verified */
  BadCert = 'BAD_CERT',
  /** Invalid email used for signing */
  BadEmail = 'BAD_EMAIL',
  /** Signing key expired */
  ExpiredKey = 'EXPIRED_KEY',
  /** Internal error - the GPG verification service misbehaved */
  GpgverifyError = 'GPGVERIFY_ERROR',
  /** Internal error - the GPG verification service is unavailable at the moment */
  GpgverifyUnavailable = 'GPGVERIFY_UNAVAILABLE',
  /** Invalid signature */
  Invalid = 'INVALID',
  /** Malformed signature */
  MalformedSig = 'MALFORMED_SIG',
  /** The usage flags for the key that signed this don't allow signing */
  NotSigningKey = 'NOT_SIGNING_KEY',
  /** Email used for signing not known to GitHub */
  NoUser = 'NO_USER',
  /** Valid signature, though certificate revocation check failed */
  OcspError = 'OCSP_ERROR',
  /** Valid signature, pending certificate revocation checking */
  OcspPending = 'OCSP_PENDING',
  /** One or more certificates in chain has been revoked */
  OcspRevoked = 'OCSP_REVOKED',
  /** Key used for signing not known to GitHub */
  UnknownKey = 'UNKNOWN_KEY',
  /** Unknown signature type */
  UnknownSigType = 'UNKNOWN_SIG_TYPE',
  /** Unsigned */
  Unsigned = 'UNSIGNED',
  /** Email used for signing unverified on GitHub */
  UnverifiedEmail = 'UNVERIFIED_EMAIL',
  /** Valid signature and verified by GitHub */
  Valid = 'VALID'
}

/** Represents a GPG signature on a Commit or Tag. */
export type GpgSignature = GitSignature & {
  __typename?: 'GpgSignature';
  /** Email used to sign this object. */
  email: Scalars['String']['output'];
  /** True if the signature is valid and verified by GitHub. */
  isValid: Scalars['Boolean']['output'];
  /** Hex-encoded ID of the key that signed this object. */
  keyId?: Maybe<Scalars['String']['output']>;
  /** Payload for GPG signing object. Raw ODB object without the signature header. */
  payload: Scalars['String']['output'];
  /** ASCII-armored signature header from object. */
  signature: Scalars['String']['output'];
  /** GitHub user corresponding to the email signing this commit. */
  signer?: Maybe<User>;
  /**
   * The state of this signature. `VALID` if signature is valid and verified by
   * GitHub, otherwise represents reason why signature is considered invalid.
   */
  state: GitSignatureState;
  /** The date the signature was verified, if valid */
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
  /** True if the signature was made with GitHub's signing key. */
  wasSignedByGitHub: Scalars['Boolean']['output'];
};

/** Autogenerated input type of GrantEnterpriseOrganizationsMigratorRole */
export type GrantEnterpriseOrganizationsMigratorRoleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the enterprise to which all organizations managed by it will be granted the migrator role. */
  enterpriseId: Scalars['ID']['input'];
  /** The login of the user to grant the migrator role */
  login: Scalars['String']['input'];
};

/** Autogenerated return type of GrantEnterpriseOrganizationsMigratorRole. */
export type GrantEnterpriseOrganizationsMigratorRolePayload = {
  __typename?: 'GrantEnterpriseOrganizationsMigratorRolePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The organizations that had the migrator role applied to for the given user. */
  organizations?: Maybe<OrganizationConnection>;
};


/** Autogenerated return type of GrantEnterpriseOrganizationsMigratorRole. */
export type GrantEnterpriseOrganizationsMigratorRolePayloadOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of GrantMigratorRole */
export type GrantMigratorRoleInput = {
  /** The user login or Team slug to grant the migrator role. */
  actor: Scalars['String']['input'];
  /** Specifies the type of the actor, can be either USER or TEAM. */
  actorType: ActorType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the organization that the user/team belongs to. */
  organizationId: Scalars['ID']['input'];
};

/** Autogenerated return type of GrantMigratorRole. */
export type GrantMigratorRolePayload = {
  __typename?: 'GrantMigratorRolePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Did the operation succeed? */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Represents a 'head_ref_deleted' event on a given pull request. */
export type HeadRefDeletedEvent = Node & {
  __typename?: 'HeadRefDeletedEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Identifies the Ref associated with the `head_ref_deleted` event. */
  headRef?: Maybe<Ref>;
  /** Identifies the name of the Ref associated with the `head_ref_deleted` event. */
  headRefName: Scalars['String']['output'];
  /** The Node ID of the HeadRefDeletedEvent object */
  id: Scalars['ID']['output'];
  /** PullRequest referenced by event. */
  pullRequest: PullRequest;
};

/** Represents a 'head_ref_force_pushed' event on a given pull request. */
export type HeadRefForcePushedEvent = Node & {
  __typename?: 'HeadRefForcePushedEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the after commit SHA for the 'head_ref_force_pushed' event. */
  afterCommit?: Maybe<Commit>;
  /** Identifies the before commit SHA for the 'head_ref_force_pushed' event. */
  beforeCommit?: Maybe<Commit>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The Node ID of the HeadRefForcePushedEvent object */
  id: Scalars['ID']['output'];
  /** PullRequest referenced by event. */
  pullRequest: PullRequest;
  /** Identifies the fully qualified ref name for the 'head_ref_force_pushed' event. */
  ref?: Maybe<Ref>;
};

/** Represents a 'head_ref_restored' event on a given pull request. */
export type HeadRefRestoredEvent = Node & {
  __typename?: 'HeadRefRestoredEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The Node ID of the HeadRefRestoredEvent object */
  id: Scalars['ID']['output'];
  /** PullRequest referenced by event. */
  pullRequest: PullRequest;
};

/** Detail needed to display a hovercard for a user */
export type Hovercard = {
  __typename?: 'Hovercard';
  /** Each of the contexts for this hovercard */
  contexts: Array<HovercardContext>;
};

/** An individual line of a hovercard */
export type HovercardContext = {
  /** A string describing this context */
  message: Scalars['String']['output'];
  /** An octicon to accompany this context */
  octicon: Scalars['String']['output'];
};

/** The possible states in which authentication can be configured with an identity provider. */
export enum IdentityProviderConfigurationState {
  /** Authentication with an identity provider is configured but not enforced. */
  Configured = 'CONFIGURED',
  /** Authentication with an identity provider is configured and enforced. */
  Enforced = 'ENFORCED',
  /** Authentication with an identity provider is not configured. */
  Unconfigured = 'UNCONFIGURED'
}

/** Autogenerated input type of ImportProject */
export type ImportProjectInput = {
  /** The description of Project. */
  body?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** A list of columns containing issues and pull requests. */
  columnImports: Array<ProjectColumnImport>;
  /** The name of Project. */
  name: Scalars['String']['input'];
  /** The name of the Organization or User to create the Project under. */
  ownerName: Scalars['String']['input'];
  /** Whether the Project is public or not. */
  public?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of ImportProject. */
export type ImportProjectPayload = {
  __typename?: 'ImportProjectPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The new Project! */
  project?: Maybe<Project>;
};

/** Autogenerated input type of InviteEnterpriseAdmin */
export type InviteEnterpriseAdminInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The email of the person to invite as an administrator. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the enterprise to which you want to invite an administrator. */
  enterpriseId: Scalars['ID']['input'];
  /** The login of a user to invite as an administrator. */
  invitee?: InputMaybe<Scalars['String']['input']>;
  /** The role of the administrator. */
  role?: InputMaybe<EnterpriseAdministratorRole>;
};

/** Autogenerated return type of InviteEnterpriseAdmin. */
export type InviteEnterpriseAdminPayload = {
  __typename?: 'InviteEnterpriseAdminPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The created enterprise administrator invitation. */
  invitation?: Maybe<EnterpriseAdministratorInvitation>;
};

/** Autogenerated input type of InviteEnterpriseMember */
export type InviteEnterpriseMemberInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The email of the person to invite as an unaffiliated member. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the enterprise to which you want to invite an unaffiliated member. */
  enterpriseId: Scalars['ID']['input'];
  /** The login of a user to invite as an unaffiliated member. */
  invitee?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of InviteEnterpriseMember. */
export type InviteEnterpriseMemberPayload = {
  __typename?: 'InviteEnterpriseMemberPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The created enterprise member invitation. */
  invitation?: Maybe<EnterpriseMemberInvitation>;
};

/** The possible values for the IP allow list enabled setting. */
export enum IpAllowListEnabledSettingValue {
  /** The setting is disabled for the owner. */
  Disabled = 'DISABLED',
  /** The setting is enabled for the owner. */
  Enabled = 'ENABLED'
}

/** An IP address or range of addresses that is allowed to access an owner's resources. */
export type IpAllowListEntry = Node & {
  __typename?: 'IpAllowListEntry';
  /** A single IP address or range of IP addresses in CIDR notation. */
  allowListValue: Scalars['String']['output'];
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The Node ID of the IpAllowListEntry object */
  id: Scalars['ID']['output'];
  /** Whether the entry is currently active. */
  isActive: Scalars['Boolean']['output'];
  /** The name of the IP allow list entry. */
  name?: Maybe<Scalars['String']['output']>;
  /** The owner of the IP allow list entry. */
  owner: IpAllowListOwner;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** The connection type for IpAllowListEntry. */
export type IpAllowListEntryConnection = {
  __typename?: 'IpAllowListEntryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IpAllowListEntryEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<IpAllowListEntry>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type IpAllowListEntryEdge = {
  __typename?: 'IpAllowListEntryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<IpAllowListEntry>;
};

/** Ordering options for IP allow list entry connections. */
export type IpAllowListEntryOrder = {
  /** The ordering direction. */
  direction: OrderDirection;
  /** The field to order IP allow list entries by. */
  field: IpAllowListEntryOrderField;
};

/** Properties by which IP allow list entry connections can be ordered. */
export enum IpAllowListEntryOrderField {
  /** Order IP allow list entries by the allow list value. */
  AllowListValue = 'ALLOW_LIST_VALUE',
  /** Order IP allow list entries by creation time. */
  CreatedAt = 'CREATED_AT'
}

/** The possible values for the IP allow list configuration for installed GitHub Apps setting. */
export enum IpAllowListForInstalledAppsEnabledSettingValue {
  /** The setting is disabled for the owner. */
  Disabled = 'DISABLED',
  /** The setting is enabled for the owner. */
  Enabled = 'ENABLED'
}

/** Types that can own an IP allow list. */
export type IpAllowListOwner = App | Enterprise | Organization;

/** The possible values for the IP allow list user-level enforcement enabled setting. */
export enum IpAllowListUserLevelEnforcementEnabledSettingValue {
  /** The setting is disabled for the owner. */
  Disabled = 'DISABLED',
  /** The setting is enabled for the owner. */
  Enabled = 'ENABLED'
}

/** An Issue is a place to discuss ideas, enhancements, tasks, and bugs for a project. */
export type Issue = Assignable & Closable & Comment & Deletable & Labelable & Lockable & Node & ProjectV2Owner & Reactable & RepositoryNode & Subscribable & SubscribableThread & UniformResourceLocatable & Updatable & UpdatableComment & {
  __typename?: 'Issue';
  /** Reason that the conversation was locked. */
  activeLockReason?: Maybe<LockReason>;
  /** A list of actors assigned to this object. */
  assignedActors: AssigneeConnection;
  /** A list of Users assigned to this object. */
  assignees: UserConnection;
  /** The actor who authored the comment. */
  author?: Maybe<Actor>;
  /** Author's association with the subject of the comment. */
  authorAssociation: CommentAuthorAssociation;
  /** A list of issues that are blocking this issue. */
  blockedBy: IssueConnection;
  /** A list of issues that this issue is blocking. */
  blocking: IssueConnection;
  /** Identifies the body of the issue. */
  body: Scalars['String']['output'];
  /** The body rendered to HTML. */
  bodyHTML: Scalars['HTML']['output'];
  /** The http path for this issue body */
  bodyResourcePath: Scalars['URI']['output'];
  /** Identifies the body of the issue rendered to text. */
  bodyText: Scalars['String']['output'];
  /** The http URL for this issue body */
  bodyUrl: Scalars['URI']['output'];
  /** Indicates if the object is closed (definition of closed may depend on type) */
  closed: Scalars['Boolean']['output'];
  /** Identifies the date and time when the object was closed. */
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  /** List of open pull requests referenced from this issue */
  closedByPullRequestsReferences?: Maybe<PullRequestConnection>;
  /** A list of comments associated with the Issue. */
  comments: IssueCommentConnection;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Check if this comment was created via an email reply. */
  createdViaEmail: Scalars['Boolean']['output'];
  /** Identifies the primary key from the database. */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** A reference to the original issue that this issue has been marked as a duplicate of. */
  duplicateOf?: Maybe<Issue>;
  /** The actor who edited the comment. */
  editor?: Maybe<Actor>;
  /** Identifies the primary key from the database as a BigInt. */
  fullDatabaseId?: Maybe<Scalars['BigInt']['output']>;
  /** The hovercard information for this issue */
  hovercard: Hovercard;
  /** The Node ID of the Issue object */
  id: Scalars['ID']['output'];
  /** Check if this comment was edited and includes an edit with the creation data */
  includesCreatedEdit: Scalars['Boolean']['output'];
  /** Indicates whether or not this issue is currently pinned to the repository issues list */
  isPinned?: Maybe<Scalars['Boolean']['output']>;
  /** Is this issue read by the viewer */
  isReadByViewer?: Maybe<Scalars['Boolean']['output']>;
  /** Summary of the state of an issue's dependencies */
  issueDependenciesSummary: IssueDependenciesSummary;
  /** Fields that are set on this issue */
  issueFieldValues?: Maybe<IssueFieldValueConnection>;
  /** The issue type for this Issue */
  issueType?: Maybe<IssueType>;
  /** A list of labels associated with the object. */
  labels?: Maybe<LabelConnection>;
  /** The moment the editor made the last edit */
  lastEditedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Branches linked to this issue. */
  linkedBranches: LinkedBranchConnection;
  /** `true` if the object is locked */
  locked: Scalars['Boolean']['output'];
  /** Identifies the milestone associated with the issue. */
  milestone?: Maybe<Milestone>;
  /** Identifies the issue number. */
  number: Scalars['Int']['output'];
  /** The parent entity of the issue. */
  parent?: Maybe<Issue>;
  /** A list of Users that are participating in the Issue conversation. */
  participants: UserConnection;
  /** All pending suggestions on this issue. */
  pendingSuggestions?: Maybe<Array<PendingIssueSuggestion>>;
  /** The pinned comment for this issue. */
  pinnedIssueComment?: Maybe<PinnedIssueComment>;
  /**
   * List of project cards associated with this issue.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  projectCards: ProjectCardConnection;
  /** List of project items associated with this issue. */
  projectItems?: Maybe<ProjectV2ItemConnection>;
  /** Find a project by number. */
  projectV2?: Maybe<ProjectV2>;
  /** A list of projects under the owner. */
  projectsV2: ProjectV2Connection;
  /** Identifies when the comment was published at. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** A list of reactions grouped by content left on the subject. */
  reactionGroups?: Maybe<Array<ReactionGroup>>;
  /** A list of Reactions left on the Issue. */
  reactions: ReactionConnection;
  /** A list of issues related to this issue. */
  relatesTo: IssueConnection;
  /** The repository associated with this node. */
  repository: Repository;
  /** The HTTP path for this issue */
  resourcePath: Scalars['URI']['output'];
  /** Identifies the state of the issue. */
  state: IssueState;
  /** Identifies the reason for the issue state. */
  stateReason?: Maybe<IssueStateReason>;
  /** A list of sub-issues associated with the Issue. */
  subIssues: IssueConnection;
  /** Summary of the state of an issue's sub-issues */
  subIssuesSummary: SubIssuesSummary;
  /** A list of suggested actors to assign to this object */
  suggestedActors: AssigneeConnection;
  /**
   * A list of events, comments, commits, etc. associated with the issue.
   * @deprecated `timeline` will be removed Use Issue.timelineItems instead. Removal on 2020-10-01 UTC.
   */
  timeline: IssueTimelineConnection;
  /** A list of events, comments, commits, etc. associated with the issue. */
  timelineItems: IssueTimelineItemsConnection;
  /** Identifies the issue title. */
  title: Scalars['String']['output'];
  /** Identifies the issue title rendered to HTML. */
  titleHTML: Scalars['String']['output'];
  /** A list of issues that track this issue */
  trackedInIssues: IssueConnection;
  /** A list of issues tracked inside the current issue */
  trackedIssues: IssueConnection;
  /** The number of tracked issues for this issue */
  trackedIssuesCount: Scalars['Int']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The HTTP URL for this issue */
  url: Scalars['URI']['output'];
  /** A list of edits to this content. */
  userContentEdits?: Maybe<UserContentEditConnection>;
  /** Indicates if the viewer can edit assignees for this object. */
  viewerCanAssign: Scalars['Boolean']['output'];
  /** Indicates if the object can be closed by the viewer. */
  viewerCanClose: Scalars['Boolean']['output'];
  /** Check if the current viewer can delete this object. */
  viewerCanDelete: Scalars['Boolean']['output'];
  /** Indicates if the viewer can edit labels for this object. */
  viewerCanLabel: Scalars['Boolean']['output'];
  /** Can user react to this subject */
  viewerCanReact: Scalars['Boolean']['output'];
  /** Indicates if the object can be reopened by the viewer. */
  viewerCanReopen: Scalars['Boolean']['output'];
  /** Check if the current viewer can set fields on the issue. */
  viewerCanSetFields?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if the viewer can edit the milestone of the issue. */
  viewerCanSetMilestone: Scalars['Boolean']['output'];
  /** Check if the viewer is able to change their subscription status for the repository. */
  viewerCanSubscribe: Scalars['Boolean']['output'];
  /** Check if the current viewer can set the issue type of this issue. */
  viewerCanType?: Maybe<Scalars['Boolean']['output']>;
  /** Check if the current viewer can update this object. */
  viewerCanUpdate: Scalars['Boolean']['output'];
  /**
   * Check if the viewer has triage-level (or higher) access to update this issue's
   * metadata. Note: this reflects the viewer's base repository role and does not
   * account for individual fine-grained permissions granted via custom repository roles.
   */
  viewerCanUpdateMetadata?: Maybe<Scalars['Boolean']['output']>;
  /** Reasons why the current viewer can not update this comment. */
  viewerCannotUpdateReasons: Array<CommentCannotUpdateReason>;
  /** Did the viewer author this comment. */
  viewerDidAuthor: Scalars['Boolean']['output'];
  /** Identifies if the viewer is watching, not watching, or ignoring the subscribable entity. */
  viewerSubscription?: Maybe<SubscriptionState>;
  /** Identifies the viewer's thread subscription form action. */
  viewerThreadSubscriptionFormAction?: Maybe<ThreadSubscriptionFormAction>;
  /** Identifies the viewer's thread subscription status. */
  viewerThreadSubscriptionStatus?: Maybe<ThreadSubscriptionState>;
};


/** An Issue is a place to discuss ideas, enhancements, tasks, and bugs for a project. */
export type IssueAssignedActorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** An Issue is a place to discuss ideas, enhancements, tasks, and bugs for a project. */
export type IssueAssigneesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** An Issue is a place to discuss ideas, enhancements, tasks, and bugs for a project. */
export type IssueBlockedByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<IssueDependencyOrder>;
};


/** An Issue is a place to discuss ideas, enhancements, tasks, and bugs for a project. */
export type IssueBlockingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<IssueDependencyOrder>;
};


/** An Issue is a place to discuss ideas, enhancements, tasks, and bugs for a project. */
export type IssueClosedByPullRequestsReferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  excludeUserLinked?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeClosedPrs?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderByState?: InputMaybe<Scalars['Boolean']['input']>;
  userLinkedOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


/** An Issue is a place to discuss ideas, enhancements, tasks, and bugs for a project. */
export type IssueCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<IssueCommentOrder>;
};


/** An Issue is a place to discuss ideas, enhancements, tasks, and bugs for a project. */
export type IssueHovercardArgs = {
  includeNotificationContexts?: InputMaybe<Scalars['Boolean']['input']>;
};


/** An Issue is a place to discuss ideas, enhancements, tasks, and bugs for a project. */
export type IssueIssueFieldValuesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** An Issue is a place to discuss ideas, enhancements, tasks, and bugs for a project. */
export type IssueLabelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LabelOrder>;
};


/** An Issue is a place to discuss ideas, enhancements, tasks, and bugs for a project. */
export type IssueLinkedBranchesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** An Issue is a place to discuss ideas, enhancements, tasks, and bugs for a project. */
export type IssueParticipantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** An Issue is a place to discuss ideas, enhancements, tasks, and bugs for a project. */
export type IssueProjectCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  archivedStates?: InputMaybe<Array<InputMaybe<ProjectCardArchivedState>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** An Issue is a place to discuss ideas, enhancements, tasks, and bugs for a project. */
export type IssueProjectItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** An Issue is a place to discuss ideas, enhancements, tasks, and bugs for a project. */
export type IssueProjectV2Args = {
  number: Scalars['Int']['input'];
};


/** An Issue is a place to discuss ideas, enhancements, tasks, and bugs for a project. */
export type IssueProjectsV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  minPermissionLevel?: InputMaybe<ProjectV2PermissionLevel>;
  orderBy?: InputMaybe<ProjectV2Order>;
  query?: InputMaybe<Scalars['String']['input']>;
};


/** An Issue is a place to discuss ideas, enhancements, tasks, and bugs for a project. */
export type IssueReactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<ReactionContent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ReactionOrder>;
};


/** An Issue is a place to discuss ideas, enhancements, tasks, and bugs for a project. */
export type IssueRelatesToArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<IssueRelatesToOrder>;
};


/** An Issue is a place to discuss ideas, enhancements, tasks, and bugs for a project. */
export type IssueStateReasonArgs = {
  enableDuplicate?: InputMaybe<Scalars['Boolean']['input']>;
};


/** An Issue is a place to discuss ideas, enhancements, tasks, and bugs for a project. */
export type IssueSubIssuesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** An Issue is a place to discuss ideas, enhancements, tasks, and bugs for a project. */
export type IssueSuggestedActorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


/** An Issue is a place to discuss ideas, enhancements, tasks, and bugs for a project. */
export type IssueTimelineArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  since?: InputMaybe<Scalars['DateTime']['input']>;
};


/** An Issue is a place to discuss ideas, enhancements, tasks, and bugs for a project. */
export type IssueTimelineItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  itemTypes?: InputMaybe<Array<IssueTimelineItemsItemType>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  since?: InputMaybe<Scalars['DateTime']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


/** An Issue is a place to discuss ideas, enhancements, tasks, and bugs for a project. */
export type IssueTrackedInIssuesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** An Issue is a place to discuss ideas, enhancements, tasks, and bugs for a project. */
export type IssueTrackedIssuesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** An Issue is a place to discuss ideas, enhancements, tasks, and bugs for a project. */
export type IssueTrackedIssuesCountArgs = {
  states?: InputMaybe<Array<InputMaybe<TrackedIssueStates>>>;
};


/** An Issue is a place to discuss ideas, enhancements, tasks, and bugs for a project. */
export type IssueUserContentEditsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The possible state reasons of a closed issue. */
export enum IssueClosedStateReason {
  /** An issue that has been closed as completed */
  Completed = 'COMPLETED',
  /** An issue that has been closed as a duplicate */
  Duplicate = 'DUPLICATE',
  /** An issue that has been closed as not planned */
  NotPlanned = 'NOT_PLANNED'
}

/** Represents a comment on an Issue. */
export type IssueComment = Comment & Deletable & Minimizable & Node & Pinnable & Reactable & RepositoryNode & Updatable & UpdatableComment & {
  __typename?: 'IssueComment';
  /** The actor who authored the comment. */
  author?: Maybe<Actor>;
  /** Author's association with the subject of the comment. */
  authorAssociation: CommentAuthorAssociation;
  /** The body as Markdown. */
  body: Scalars['String']['output'];
  /** The body rendered to HTML. */
  bodyHTML: Scalars['HTML']['output'];
  /** The body rendered to text. */
  bodyText: Scalars['String']['output'];
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Check if this comment was created via an email reply. */
  createdViaEmail: Scalars['Boolean']['output'];
  /** Identifies the primary key from the database. */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** The actor who edited the comment. */
  editor?: Maybe<Actor>;
  /** Identifies the primary key from the database as a BigInt. */
  fullDatabaseId?: Maybe<Scalars['BigInt']['output']>;
  /** The Node ID of the IssueComment object */
  id: Scalars['ID']['output'];
  /** Check if this comment was edited and includes an edit with the creation data */
  includesCreatedEdit: Scalars['Boolean']['output'];
  /** Returns whether or not a comment has been minimized. */
  isMinimized: Scalars['Boolean']['output'];
  /** Indicates whether or not this entity is currently pinned. */
  isPinned?: Maybe<Scalars['Boolean']['output']>;
  /** Identifies the issue associated with the comment. */
  issue: Issue;
  /** The moment the editor made the last edit */
  lastEditedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Returns why the comment was minimized. One of `abuse`, `off-topic`,
   * `outdated`, `resolved`, `duplicate`, `spam`, and `low-quality`. Note that the
   * case and formatting of these values differs from the inputs to the
   * `MinimizeComment` mutation.
   */
  minimizedReason?: Maybe<Scalars['String']['output']>;
  /** Identifies the date and time when this entity was pinned. */
  pinnedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user who pinned this entity. */
  pinnedBy?: Maybe<User>;
  /** Identifies when the comment was published at. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Returns the pull request associated with the comment, if this comment was made on a
   * pull request.
   */
  pullRequest?: Maybe<PullRequest>;
  /** A list of reactions grouped by content left on the subject. */
  reactionGroups?: Maybe<Array<ReactionGroup>>;
  /** A list of Reactions left on the Issue. */
  reactions: ReactionConnection;
  /** The repository associated with this node. */
  repository: Repository;
  /** The HTTP path for this issue comment */
  resourcePath: Scalars['URI']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The HTTP URL for this issue comment */
  url: Scalars['URI']['output'];
  /** A list of edits to this content. */
  userContentEdits?: Maybe<UserContentEditConnection>;
  /** Check if the current viewer can delete this object. */
  viewerCanDelete: Scalars['Boolean']['output'];
  /** Check if the current viewer can minimize this object. */
  viewerCanMinimize: Scalars['Boolean']['output'];
  /** Check if the current viewer can pin this entity. */
  viewerCanPin: Scalars['Boolean']['output'];
  /** Can user react to this subject */
  viewerCanReact: Scalars['Boolean']['output'];
  /** Check if the current viewer can unminimize this object. */
  viewerCanUnminimize: Scalars['Boolean']['output'];
  /** Check if the current viewer can unpin this entity. */
  viewerCanUnpin: Scalars['Boolean']['output'];
  /** Check if the current viewer can update this object. */
  viewerCanUpdate: Scalars['Boolean']['output'];
  /** Reasons why the current viewer can not update this comment. */
  viewerCannotUpdateReasons: Array<CommentCannotUpdateReason>;
  /** Did the viewer author this comment. */
  viewerDidAuthor: Scalars['Boolean']['output'];
};


/** Represents a comment on an Issue. */
export type IssueCommentReactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<ReactionContent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ReactionOrder>;
};


/** Represents a comment on an Issue. */
export type IssueCommentUserContentEditsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for IssueComment. */
export type IssueCommentConnection = {
  __typename?: 'IssueCommentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IssueCommentEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<IssueComment>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type IssueCommentEdge = {
  __typename?: 'IssueCommentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<IssueComment>;
};

/** Ways in which lists of issue comments can be ordered upon return. */
export type IssueCommentOrder = {
  /** The direction in which to order issue comments by the specified field. */
  direction: OrderDirection;
  /** The field in which to order issue comments by. */
  field: IssueCommentOrderField;
};

/** Properties by which issue comment connections can be ordered. */
export enum IssueCommentOrderField {
  /** Order issue comments by update time */
  UpdatedAt = 'UPDATED_AT'
}

/** Represents a 'issue_comment_pinned' event on a given issue. */
export type IssueCommentPinnedEvent = Node & {
  __typename?: 'IssueCommentPinnedEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The Node ID of the IssueCommentPinnedEvent object */
  id: Scalars['ID']['output'];
  /** Identifies the issue comment associated with the 'issue_comment_pinned' event. */
  issueComment?: Maybe<IssueComment>;
};

/** Represents a 'issue_comment_unpinned' event on a given issue. */
export type IssueCommentUnpinnedEvent = Node & {
  __typename?: 'IssueCommentUnpinnedEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The Node ID of the IssueCommentUnpinnedEvent object */
  id: Scalars['ID']['output'];
  /** Identifies the issue comment associated with the 'issue_comment_unpinned' event. */
  issueComment?: Maybe<IssueComment>;
};

/** The connection type for Issue. */
export type IssueConnection = {
  __typename?: 'IssueConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IssueEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Issue>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** This aggregates issues opened by a user within one repository. */
export type IssueContributionsByRepository = {
  __typename?: 'IssueContributionsByRepository';
  /** The issue contributions. */
  contributions: CreatedIssueContributionConnection;
  /** The repository in which the issues were opened. */
  repository: Repository;
};


/** This aggregates issues opened by a user within one repository. */
export type IssueContributionsByRepositoryContributionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ContributionOrder>;
};

/** The policy controlling who can create issues in a repository. */
export enum IssueCreationPolicy {
  /** Anyone can create issues. */
  All = 'ALL',
  /** Only collaborators can create issues. */
  CollaboratorsOnly = 'COLLABORATORS_ONLY'
}

/** Summary of the state of an issue's dependencies */
export type IssueDependenciesSummary = {
  __typename?: 'IssueDependenciesSummary';
  /** Count of issues this issue is blocked by */
  blockedBy: Scalars['Int']['output'];
  /** Count of issues this issue is blocking */
  blocking: Scalars['Int']['output'];
  /** Total count of issues this issue is blocked by (open and closed) */
  totalBlockedBy: Scalars['Int']['output'];
  /** Total count of issues this issue is blocking (open and closed) */
  totalBlocking: Scalars['Int']['output'];
};

/** Ordering options issue dependencies */
export type IssueDependencyOrder = {
  /** The ordering direction. */
  direction: OrderDirection;
  /** The field to order issue dependencies by. */
  field: IssueDependencyOrderField;
};

/** Properties by which issue dependencies can be ordered. */
export enum IssueDependencyOrderField {
  /** Order issue dependencies by the creation time of the dependent issue */
  CreatedAt = 'CREATED_AT',
  /** Order issue dependencies by time of when the dependency relationship was added */
  DependencyAddedAt = 'DEPENDENCY_ADDED_AT'
}

/** An edge in a connection. */
export type IssueEdge = {
  __typename?: 'IssueEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Issue>;
};

/** The confidence level associated with an agent's issue event action. */
export enum IssueEventConfidenceLevel {
  /** High confidence. */
  High = 'HIGH',
  /** Low confidence. */
  Low = 'LOW',
  /** Medium confidence. */
  Medium = 'MEDIUM'
}

/** Represents a 'issue_field_added' event on a given issue. */
export type IssueFieldAddedEvent = Node & {
  __typename?: 'IssueFieldAddedEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** The color if it is a single-select field. */
  color?: Maybe<Scalars['String']['output']>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The Node ID of the IssueFieldAddedEvent object */
  id: Scalars['ID']['output'];
  /** The intent behind the agent's action, including rationale and confidence. */
  intent?: Maybe<IssueUpdateIntent>;
  /** The issue field added. */
  issueField?: Maybe<IssueFields>;
  /** The selected options for option-backed fields; single-select returns one option and multi-select returns many. */
  options?: Maybe<Array<IssueFieldTimelineOption>>;
  /** The value of the added field. */
  value?: Maybe<Scalars['String']['output']>;
};

/** Represents a 'issue_field_changed' event on a given issue. */
export type IssueFieldChangedEvent = Node & {
  __typename?: 'IssueFieldChangedEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The Node ID of the IssueFieldChangedEvent object */
  id: Scalars['ID']['output'];
  /** The intent behind the agent's action, including rationale and confidence. */
  intent?: Maybe<IssueUpdateIntent>;
  /** The issue field changed. */
  issueField?: Maybe<IssueFields>;
  /** The new color if it is a single-select field. */
  newColor?: Maybe<Scalars['String']['output']>;
  /** The new options for option-backed fields; single-select returns one option and multi-select returns many. */
  newOptions?: Maybe<Array<IssueFieldTimelineOption>>;
  /** The new value of the field. */
  newValue?: Maybe<Scalars['String']['output']>;
  /** The previous color if it was a single-select field. */
  previousColor?: Maybe<Scalars['String']['output']>;
  /** The previous options for option-backed fields; single-select returns one option and multi-select returns many. */
  previousOptions?: Maybe<Array<IssueFieldTimelineOption>>;
  /** The previous value of the field. */
  previousValue?: Maybe<Scalars['String']['output']>;
};

/** Common fields across different issue field types */
export type IssueFieldCommon = {
  /** The issue field's creation timestamp. */
  createdAt: Scalars['DateTime']['output'];
  /** The issue field's data type. */
  dataType: IssueFieldDataType;
  /** The issue field's description. */
  description?: Maybe<Scalars['String']['output']>;
  /** Identifies the primary key from the database as a BigInt. */
  fullDatabaseId?: Maybe<Scalars['BigInt']['output']>;
  /** The issue field's name. */
  name: Scalars['String']['output'];
  /** The issue field's visibility. */
  visibility: IssueFieldVisibility;
};

/** Represents an issue field value that must be set on an issue during issue creation */
export type IssueFieldCreateOrUpdateInput = {
  /** The confidence level the agent had when selecting this value. */
  confidence?: InputMaybe<IssueEventConfidenceLevel>;
  /** The date value, for a date field */
  dateValue?: InputMaybe<Scalars['String']['input']>;
  /** Set to true to delete the field value */
  delete?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the issue field */
  fieldId: Scalars['ID']['input'];
  /** The IDs of the selected options, for a multi select field */
  multiSelectOptionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The numeric value, for a number field */
  numberValue?: InputMaybe<Scalars['Float']['input']>;
  /** Optional rationale describing why this value was selected. Max 280 characters. */
  rationale?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the selected option, for a single select field */
  singleSelectOptionId?: InputMaybe<Scalars['ID']['input']>;
  /** If true, the value is stored as a pending suggestion for human review rather than being applied directly. */
  suggest?: InputMaybe<Scalars['Boolean']['input']>;
  /** The text value, for a text field */
  textValue?: InputMaybe<Scalars['String']['input']>;
};

/** The type of an issue field. */
export enum IssueFieldDataType {
  /** Date */
  Date = 'DATE',
  /** Multi Select */
  MultiSelect = 'MULTI_SELECT',
  /** Number */
  Number = 'NUMBER',
  /** Single Select */
  SingleSelect = 'SINGLE_SELECT',
  /** Text */
  Text = 'TEXT'
}

/** Represents a date issue field. */
export type IssueFieldDate = IssueFieldCommon & Node & {
  __typename?: 'IssueFieldDate';
  /** The issue field's creation timestamp. */
  createdAt: Scalars['DateTime']['output'];
  /** The issue field's data type. */
  dataType: IssueFieldDataType;
  /** The issue field's description. */
  description?: Maybe<Scalars['String']['output']>;
  /** Identifies the primary key from the database as a BigInt. */
  fullDatabaseId?: Maybe<Scalars['BigInt']['output']>;
  /** The Node ID of the IssueFieldDate object */
  id: Scalars['ID']['output'];
  /** The issue field's name. */
  name: Scalars['String']['output'];
  /** The issue field's visibility. */
  visibility: IssueFieldVisibility;
};

/** The value of a date field in an Issue item. */
export type IssueFieldDateValue = IssueFieldValueCommon & Node & {
  __typename?: 'IssueFieldDateValue';
  /** The issue field that contains this value. */
  field?: Maybe<IssueFields>;
  /** The Node ID of the IssueFieldDateValue object */
  id: Scalars['ID']['output'];
  /** Value of the field. */
  value: Scalars['String']['output'];
};

/** Represents a multi select issue field. */
export type IssueFieldMultiSelect = IssueFieldCommon & Node & {
  __typename?: 'IssueFieldMultiSelect';
  /** The issue field's creation timestamp. */
  createdAt: Scalars['DateTime']['output'];
  /** The issue field's data type. */
  dataType: IssueFieldDataType;
  /** The issue field's description. */
  description?: Maybe<Scalars['String']['output']>;
  /** Identifies the primary key from the database as a BigInt. */
  fullDatabaseId?: Maybe<Scalars['BigInt']['output']>;
  /** The Node ID of the IssueFieldMultiSelect object */
  id: Scalars['ID']['output'];
  /** The issue field's name. */
  name: Scalars['String']['output'];
  /** Options for the multi select field */
  options: Array<IssueFieldSingleSelectOption>;
  /** The issue field's visibility. */
  visibility: IssueFieldVisibility;
};

/** The value of a multi select field in an Issue item. */
export type IssueFieldMultiSelectValue = IssueFieldValueCommon & Node & {
  __typename?: 'IssueFieldMultiSelectValue';
  /** The issue field that contains this value. */
  field?: Maybe<IssueFields>;
  /** The Node ID of the IssueFieldMultiSelectValue object */
  id: Scalars['ID']['output'];
  /** The selected options. */
  options: Array<IssueFieldSingleSelectOption>;
  /** Comma-separated names of the selected options. */
  value?: Maybe<Scalars['String']['output']>;
};

/** Represents a number issue field. */
export type IssueFieldNumber = IssueFieldCommon & Node & {
  __typename?: 'IssueFieldNumber';
  /** The issue field's creation timestamp. */
  createdAt: Scalars['DateTime']['output'];
  /** The issue field's data type. */
  dataType: IssueFieldDataType;
  /** The issue field's description. */
  description?: Maybe<Scalars['String']['output']>;
  /** Identifies the primary key from the database as a BigInt. */
  fullDatabaseId?: Maybe<Scalars['BigInt']['output']>;
  /** The Node ID of the IssueFieldNumber object */
  id: Scalars['ID']['output'];
  /** The issue field's name. */
  name: Scalars['String']['output'];
  /** The issue field's visibility. */
  visibility: IssueFieldVisibility;
};

/** The value of a number field in an Issue item. */
export type IssueFieldNumberValue = IssueFieldValueCommon & Node & {
  __typename?: 'IssueFieldNumberValue';
  /** The issue field that contains this value. */
  field?: Maybe<IssueFields>;
  /** The Node ID of the IssueFieldNumberValue object */
  id: Scalars['ID']['output'];
  /** Value of the field. */
  value: Scalars['Float']['output'];
};

/** Ordering options for issue field connections */
export type IssueFieldOrder = {
  /** The ordering direction. */
  direction: OrderDirection;
  /** The field to order issue fields by. */
  field: IssueFieldOrderField;
};

/** Properties by which issue field connections can be ordered. */
export enum IssueFieldOrderField {
  /** Order issue fields by creation time */
  CreatedAt = 'CREATED_AT',
  /** Order issue fields by name */
  Name = 'NAME'
}

/** Represents a 'issue_field_removed' event on a given issue. */
export type IssueFieldRemovedEvent = Node & {
  __typename?: 'IssueFieldRemovedEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The Node ID of the IssueFieldRemovedEvent object */
  id: Scalars['ID']['output'];
  /** The intent behind the agent's action, including rationale and confidence. */
  intent?: Maybe<IssueUpdateIntent>;
  /** The issue field removed. */
  issueField?: Maybe<IssueFields>;
  /** The removed options for option-backed fields; single-select returns one option and multi-select returns many. */
  options?: Maybe<Array<IssueFieldTimelineOption>>;
};

/** Represents a single select issue field. */
export type IssueFieldSingleSelect = IssueFieldCommon & Node & {
  __typename?: 'IssueFieldSingleSelect';
  /** The issue field's creation timestamp. */
  createdAt: Scalars['DateTime']['output'];
  /** The issue field's data type. */
  dataType: IssueFieldDataType;
  /** The issue field's description. */
  description?: Maybe<Scalars['String']['output']>;
  /** Identifies the primary key from the database as a BigInt. */
  fullDatabaseId?: Maybe<Scalars['BigInt']['output']>;
  /** The Node ID of the IssueFieldSingleSelect object */
  id: Scalars['ID']['output'];
  /** The issue field's name. */
  name: Scalars['String']['output'];
  /** Options for the single select field */
  options: Array<IssueFieldSingleSelectOption>;
  /** The issue field's visibility. */
  visibility: IssueFieldVisibility;
};

/** Represents an option in a single-select issue field. */
export type IssueFieldSingleSelectOption = Node & {
  __typename?: 'IssueFieldSingleSelectOption';
  /** The option's display color. */
  color: IssueFieldSingleSelectOptionColor;
  /** Identifies the primary key from the database. */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** The option's plain-text description. */
  description?: Maybe<Scalars['String']['output']>;
  /** Identifies the primary key from the database as a BigInt. */
  fullDatabaseId?: Maybe<Scalars['BigInt']['output']>;
  /** The Node ID of the IssueFieldSingleSelectOption object */
  id: Scalars['ID']['output'];
  /** The option's name. */
  name: Scalars['String']['output'];
  /** The option's priority order. */
  priority?: Maybe<Scalars['Int']['output']>;
};

/** The display color of a single-select field option. */
export enum IssueFieldSingleSelectOptionColor {
  /** blue */
  Blue = 'BLUE',
  /** gray */
  Gray = 'GRAY',
  /** green */
  Green = 'GREEN',
  /** orange */
  Orange = 'ORANGE',
  /** pink */
  Pink = 'PINK',
  /** purple */
  Purple = 'PURPLE',
  /** red */
  Red = 'RED',
  /** yellow */
  Yellow = 'YELLOW'
}

/** A single selection option for an issue field. */
export type IssueFieldSingleSelectOptionInput = {
  /** The color associated with the option. */
  color: IssueFieldSingleSelectOptionColor;
  /** A description of the option. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The name of the option. */
  name: Scalars['String']['input'];
  /** The priority of the option in the list. */
  priority: Scalars['Int']['input'];
};

/** The value of a single select field in an Issue item. */
export type IssueFieldSingleSelectValue = IssueFieldValueCommon & Node & {
  __typename?: 'IssueFieldSingleSelectValue';
  /** The option's display color. */
  color: IssueFieldSingleSelectOptionColor;
  /** The option's plain-text description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The issue field that contains this value. */
  field?: Maybe<IssueFields>;
  /** The Node ID of the IssueFieldSingleSelectValue object */
  id: Scalars['ID']['output'];
  /** The option's name. */
  name: Scalars['String']['output'];
  /** The selected option's global relay ID. */
  optionId?: Maybe<Scalars['String']['output']>;
  /** The option's name text (alias for `name`, for consistency with other field value types). */
  value: Scalars['String']['output'];
};

/** Represents a text issue field. */
export type IssueFieldText = IssueFieldCommon & Node & {
  __typename?: 'IssueFieldText';
  /** The issue field's creation timestamp. */
  createdAt: Scalars['DateTime']['output'];
  /** The issue field's data type. */
  dataType: IssueFieldDataType;
  /** The issue field's description. */
  description?: Maybe<Scalars['String']['output']>;
  /** Identifies the primary key from the database as a BigInt. */
  fullDatabaseId?: Maybe<Scalars['BigInt']['output']>;
  /** The Node ID of the IssueFieldText object */
  id: Scalars['ID']['output'];
  /** The issue field's name. */
  name: Scalars['String']['output'];
  /** The issue field's visibility. */
  visibility: IssueFieldVisibility;
};

/** The value of a text field in an Issue item. */
export type IssueFieldTextValue = IssueFieldValueCommon & Node & {
  __typename?: 'IssueFieldTextValue';
  /** The issue field that contains this value. */
  field?: Maybe<IssueFields>;
  /** The Node ID of the IssueFieldTextValue object */
  id: Scalars['ID']['output'];
  /** Value of the field. */
  value: Scalars['String']['output'];
};

/** Represents a selected option for a timeline issue field event. */
export type IssueFieldTimelineOption = {
  __typename?: 'IssueFieldTimelineOption';
  /** The option color. */
  color?: Maybe<Scalars['String']['output']>;
  /** The option name. */
  name: Scalars['String']['output'];
};

/** Updates an issue field using its user-facing name. */
export type IssueFieldUpdateInput = {
  /** The name of the issue field. */
  fieldName: Scalars['String']['input'];
  /** The operation to perform. */
  operation: IssueFieldUpdateOperation;
  /** The value or comma-separated option names for the operation. */
  value?: InputMaybe<Scalars['String']['input']>;
};

/** The operation to perform on an issue field value. */
export enum IssueFieldUpdateOperation {
  /** Sets a scalar field or adds options to a multi-select field. */
  Add = 'ADD',
  /** Clears the field value. */
  Clear = 'CLEAR',
  /** Removes options from a multi-select field. */
  Remove = 'REMOVE',
  /** Replaces the field value. */
  Set = 'SET'
}

/** Issue field values */
export type IssueFieldValue = IssueFieldDateValue | IssueFieldMultiSelectValue | IssueFieldNumberValue | IssueFieldSingleSelectValue | IssueFieldTextValue;

/** Common fields across different issue field value types */
export type IssueFieldValueCommon = {
  /** The issue field that contains this value. */
  field?: Maybe<IssueFields>;
};

/** The connection type for IssueFieldValue. */
export type IssueFieldValueConnection = {
  __typename?: 'IssueFieldValueConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IssueFieldValueEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<IssueFieldValue>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type IssueFieldValueEdge = {
  __typename?: 'IssueFieldValueEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<IssueFieldValue>;
};

/** A filter for matching an issue field value. Exactly one value argument should be provided. */
export type IssueFieldValueFilter = {
  /** Matches a date issue field value (YYYY-MM-DD). */
  dateValue?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the issue field to filter by. Exactly one of `fieldId` or `fieldName` must be provided. */
  fieldId?: InputMaybe<Scalars['ID']['input']>;
  /** The name of the issue field to filter by. Exactly one of `fieldId` or `fieldName` must be provided. */
  fieldName?: InputMaybe<Scalars['String']['input']>;
  /** Matches issues containing all of the multi-select issue field option IDs. */
  multiSelectOptionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Matches issues containing all of the multi-select issue field option names. */
  multiSelectOptionValues?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Matches a numeric issue field value. */
  numberValue?: InputMaybe<Scalars['Float']['input']>;
  /** Matches a single-select issue field option by ID. */
  singleSelectOptionId?: InputMaybe<Scalars['ID']['input']>;
  /** Matches a single-select issue field option by name. */
  singleSelectOptionValue?: InputMaybe<Scalars['String']['input']>;
  /** Matches a text issue field value. */
  textValue?: InputMaybe<Scalars['String']['input']>;
};

/** The visibility of an issue field. */
export enum IssueFieldVisibility {
  /** All */
  All = 'ALL',
  /** Org Only */
  OrgOnly = 'ORG_ONLY'
}

/** Possible issue fields. */
export type IssueFields = IssueFieldDate | IssueFieldMultiSelect | IssueFieldNumber | IssueFieldSingleSelect | IssueFieldText;

/** The connection type for IssueFields. */
export type IssueFieldsConnection = {
  __typename?: 'IssueFieldsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IssueFieldsEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<IssueFields>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type IssueFieldsEdge = {
  __typename?: 'IssueFieldsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<IssueFields>;
};

/** Ways in which to filter lists of issues. */
export type IssueFilters = {
  /**
   * List issues assigned to given name. Pass in `null` for issues with no assigned
   * user, and `*` for issues assigned to any user.
   */
  assignee?: InputMaybe<Scalars['String']['input']>;
  /** List issues created by given name. */
  createdBy?: InputMaybe<Scalars['String']['input']>;
  /** List issues where each supplied issue field value filter matches. */
  issueFieldValues?: InputMaybe<Array<IssueFieldValueFilter>>;
  /** List issues where the list of label names exist on the issue. */
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  /** List issues where the given name is mentioned in the issue. */
  mentioned?: InputMaybe<Scalars['String']['input']>;
  /**
   * List issues by given milestone argument. If an string representation of an
   * integer is passed, it should refer to a milestone by its database ID. Pass in
   * `null` for issues with no milestone, and `*` for issues that are assigned to any milestone.
   */
  milestone?: InputMaybe<Scalars['String']['input']>;
  /**
   * List issues by given milestone argument. If an string representation of an
   * integer is passed, it should refer to a milestone by its number field. Pass in
   * `null` for issues with no milestone, and `*` for issues that are assigned to any milestone.
   */
  milestoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** List issues that have been updated at or after the given date. */
  since?: InputMaybe<Scalars['DateTime']['input']>;
  /** List issues filtered by the list of states given. */
  states?: InputMaybe<Array<IssueState>>;
  /** List issues filtered by the type given, only supported by searches on repositories. */
  type?: InputMaybe<Scalars['String']['input']>;
  /** List issues subscribed to by viewer. */
  viewerSubscribed?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Used for return value of Repository.issueOrPullRequest. */
export type IssueOrPullRequest = Issue | PullRequest;

/** Ways in which lists of issues can be ordered upon return. */
export type IssueOrder = {
  /** The direction in which to order issues by the specified field. */
  direction: OrderDirection;
  /** The field in which to order issues by. */
  field: IssueOrderField;
};

/** Properties by which issue connections can be ordered. */
export enum IssueOrderField {
  /** Order issues by comment count */
  Comments = 'COMMENTS',
  /** Order issues by creation time */
  CreatedAt = 'CREATED_AT',
  /** Order issues by update time */
  UpdatedAt = 'UPDATED_AT'
}

/** Ordering options for related issues */
export type IssueRelatesToOrder = {
  /** The ordering direction. */
  direction: OrderDirection;
  /** The field to order related issues by. */
  field: IssueRelatesToOrderField;
};

/** Properties by which related issues can be ordered. */
export enum IssueRelatesToOrderField {
  /** Order related issues by the creation time of the related issue */
  CreatedAt = 'CREATED_AT',
  /** Order related issues by time of when the relates-to relationship was added */
  RelatesToAddedAt = 'RELATES_TO_ADDED_AT'
}

/** Type of issue search performed */
export enum IssueSearchType {
  /** Hybrid search combining lexical and semantic approaches */
  Hybrid = 'HYBRID',
  /** Lexical (keyword-based) search */
  Lexical = 'LEXICAL',
  /** Semantic (meaning-based) search using embeddings */
  Semantic = 'SEMANTIC'
}

/** The possible states of an issue. */
export enum IssueState {
  /** An issue that has been closed */
  Closed = 'CLOSED',
  /** An issue that is still open */
  Open = 'OPEN'
}

/** The possible state reasons of an issue. */
export enum IssueStateReason {
  /** An issue that has been closed as completed */
  Completed = 'COMPLETED',
  /** An issue that has been closed as a duplicate. */
  Duplicate = 'DUPLICATE',
  /** An issue that has been closed as not planned */
  NotPlanned = 'NOT_PLANNED',
  /** An issue that has been reopened */
  Reopened = 'REOPENED'
}

/**
 * Specifies a target state for an issue, with optional metadata such as a
 * rationale, close reason, or duplicate reference. Suggestion metadata
 * (`rationale`, `confidence`, `suggest`) is only meaningful when `value` is
 * `CLOSED`; it is silently ignored otherwise.
 */
export type IssueStateUpdateInput = {
  /** The confidence level the agent had when suggesting this close. Only meaningful when `value` is `CLOSED`. */
  confidence?: InputMaybe<IssueEventConfidenceLevel>;
  /**
   * The ID of the issue that this is a duplicate of. Only meaningful when `value`
   * is `CLOSED` and `stateReason` is `DUPLICATE`.
   */
  duplicateIssueId?: InputMaybe<Scalars['ID']['input']>;
  /** Optional rationale describing why the issue is being closed. Only meaningful when `value` is `CLOSED`. Max 280 characters. */
  rationale?: InputMaybe<Scalars['String']['input']>;
  /** The reason for closing the issue. Only meaningful when `value` is `CLOSED`. */
  stateReason?: InputMaybe<IssueClosedStateReason>;
  /**
   * If true, the close is stored as a pending suggestion for human review rather
   * than being applied directly. Only meaningful when `value` is `CLOSED`;
   * silently ignored otherwise.
   */
  suggest?: InputMaybe<Scalars['Boolean']['input']>;
  /** The target state. */
  value: IssueState;
};

/** A repository issue template. */
export type IssueTemplate = {
  __typename?: 'IssueTemplate';
  /** The template purpose. */
  about?: Maybe<Scalars['String']['output']>;
  /** The suggested assignees. */
  assignees: UserConnection;
  /** The suggested issue body. */
  body?: Maybe<Scalars['String']['output']>;
  /** The template filename. */
  filename: Scalars['String']['output'];
  /** The suggested issue labels */
  labels?: Maybe<LabelConnection>;
  /** The template name. */
  name: Scalars['String']['output'];
  /** The suggested issue title. */
  title?: Maybe<Scalars['String']['output']>;
  /** The suggested issue type */
  type?: Maybe<IssueType>;
};


/** A repository issue template. */
export type IssueTemplateAssigneesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A repository issue template. */
export type IssueTemplateLabelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LabelOrder>;
};

/** The connection type for IssueTimelineItem. */
export type IssueTimelineConnection = {
  __typename?: 'IssueTimelineConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IssueTimelineItemEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<IssueTimelineItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An item in an issue timeline */
export type IssueTimelineItem = AssignedEvent | ClosedEvent | Commit | CrossReferencedEvent | DemilestonedEvent | IssueComment | LabeledEvent | LockedEvent | MilestonedEvent | ReferencedEvent | RenamedTitleEvent | ReopenedEvent | SubscribedEvent | TransferredEvent | UnassignedEvent | UnlabeledEvent | UnlockedEvent | UnsubscribedEvent | UserBlockedEvent;

/** An edge in a connection. */
export type IssueTimelineItemEdge = {
  __typename?: 'IssueTimelineItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<IssueTimelineItem>;
};

/** An item in an issue timeline */
export type IssueTimelineItems = AddedToProjectEvent | AddedToProjectV2Event | AssignedEvent | BlockedByAddedEvent | BlockedByRemovedEvent | BlockingAddedEvent | BlockingRemovedEvent | ClosedEvent | CommentDeletedEvent | ConnectedEvent | ConvertedFromDraftEvent | ConvertedNoteToIssueEvent | ConvertedToDiscussionEvent | CrossReferencedEvent | DemilestonedEvent | DisconnectedEvent | IssueComment | IssueCommentPinnedEvent | IssueCommentUnpinnedEvent | IssueFieldAddedEvent | IssueFieldChangedEvent | IssueFieldRemovedEvent | IssueTypeAddedEvent | IssueTypeChangedEvent | IssueTypeRemovedEvent | LabeledEvent | LockedEvent | MarkedAsDuplicateEvent | MentionedEvent | MilestonedEvent | MovedColumnsInProjectEvent | ParentIssueAddedEvent | ParentIssueRemovedEvent | PinnedEvent | ProjectV2ItemStatusChangedEvent | ReferencedEvent | RemovedFromProjectEvent | RemovedFromProjectV2Event | RenamedTitleEvent | ReopenedEvent | SubIssueAddedEvent | SubIssueRemovedEvent | SubscribedEvent | TransferredEvent | UnassignedEvent | UnlabeledEvent | UnlockedEvent | UnmarkedAsDuplicateEvent | UnpinnedEvent | UnsubscribedEvent | UserBlockedEvent;

/** The connection type for IssueTimelineItems. */
export type IssueTimelineItemsConnection = {
  __typename?: 'IssueTimelineItemsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IssueTimelineItemsEdge>>>;
  /** Identifies the count of items after applying `before` and `after` filters. */
  filteredCount: Scalars['Int']['output'];
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<IssueTimelineItems>>>;
  /** Identifies the count of items after applying `before`/`after` filters and `first`/`last`/`skip` slicing. */
  pageCount: Scalars['Int']['output'];
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
  /** Identifies the date and time when the timeline was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** An edge in a connection. */
export type IssueTimelineItemsEdge = {
  __typename?: 'IssueTimelineItemsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<IssueTimelineItems>;
};

/** The possible item types found in a timeline. */
export enum IssueTimelineItemsItemType {
  /** Represents a 'added_to_project' event on a given issue or pull request. */
  AddedToProjectEvent = 'ADDED_TO_PROJECT_EVENT',
  /** Represents a 'added_to_project_v2' event on a given issue or pull request. */
  AddedToProjectV2Event = 'ADDED_TO_PROJECT_V2_EVENT',
  /** Represents an 'assigned' event on any assignable object. */
  AssignedEvent = 'ASSIGNED_EVENT',
  /** Represents a 'blocked_by_added' event on a given issue. */
  BlockedByAddedEvent = 'BLOCKED_BY_ADDED_EVENT',
  /** Represents a 'blocked_by_removed' event on a given issue. */
  BlockedByRemovedEvent = 'BLOCKED_BY_REMOVED_EVENT',
  /** Represents a 'blocking_added' event on a given issue. */
  BlockingAddedEvent = 'BLOCKING_ADDED_EVENT',
  /** Represents a 'blocking_removed' event on a given issue. */
  BlockingRemovedEvent = 'BLOCKING_REMOVED_EVENT',
  /** Represents a 'closed' event on any `Closable`. */
  ClosedEvent = 'CLOSED_EVENT',
  /** Represents a 'comment_deleted' event on a given issue or pull request. */
  CommentDeletedEvent = 'COMMENT_DELETED_EVENT',
  /** Represents a 'connected' event on a given issue or pull request. */
  ConnectedEvent = 'CONNECTED_EVENT',
  /** Represents a 'converted_from_draft' event on a given issue or pull request. */
  ConvertedFromDraftEvent = 'CONVERTED_FROM_DRAFT_EVENT',
  /** Represents a 'converted_note_to_issue' event on a given issue or pull request. */
  ConvertedNoteToIssueEvent = 'CONVERTED_NOTE_TO_ISSUE_EVENT',
  /** Represents a 'converted_to_discussion' event on a given issue. */
  ConvertedToDiscussionEvent = 'CONVERTED_TO_DISCUSSION_EVENT',
  /** Represents a mention made by one issue or pull request to another. */
  CrossReferencedEvent = 'CROSS_REFERENCED_EVENT',
  /** Represents a 'demilestoned' event on a given issue or pull request. */
  DemilestonedEvent = 'DEMILESTONED_EVENT',
  /** Represents a 'disconnected' event on a given issue or pull request. */
  DisconnectedEvent = 'DISCONNECTED_EVENT',
  /** Represents a comment on an Issue. */
  IssueComment = 'ISSUE_COMMENT',
  /** Represents a 'issue_comment_pinned' event on a given issue. */
  IssueCommentPinnedEvent = 'ISSUE_COMMENT_PINNED_EVENT',
  /** Represents a 'issue_comment_unpinned' event on a given issue. */
  IssueCommentUnpinnedEvent = 'ISSUE_COMMENT_UNPINNED_EVENT',
  /** Represents a 'issue_field_added' event on a given issue. */
  IssueFieldAddedEvent = 'ISSUE_FIELD_ADDED_EVENT',
  /** Represents a 'issue_field_changed' event on a given issue. */
  IssueFieldChangedEvent = 'ISSUE_FIELD_CHANGED_EVENT',
  /** Represents a 'issue_field_removed' event on a given issue. */
  IssueFieldRemovedEvent = 'ISSUE_FIELD_REMOVED_EVENT',
  /** Represents a 'issue_type_added' event on a given issue. */
  IssueTypeAddedEvent = 'ISSUE_TYPE_ADDED_EVENT',
  /** Represents a 'issue_type_changed' event on a given issue. */
  IssueTypeChangedEvent = 'ISSUE_TYPE_CHANGED_EVENT',
  /** Represents a 'issue_type_removed' event on a given issue. */
  IssueTypeRemovedEvent = 'ISSUE_TYPE_REMOVED_EVENT',
  /** Represents a 'labeled' event on a given issue or pull request. */
  LabeledEvent = 'LABELED_EVENT',
  /** Represents a 'locked' event on a given issue or pull request. */
  LockedEvent = 'LOCKED_EVENT',
  /** Represents a 'marked_as_duplicate' event on a given issue or pull request. */
  MarkedAsDuplicateEvent = 'MARKED_AS_DUPLICATE_EVENT',
  /** Represents a 'mentioned' event on a given issue or pull request. */
  MentionedEvent = 'MENTIONED_EVENT',
  /** Represents a 'milestoned' event on a given issue or pull request. */
  MilestonedEvent = 'MILESTONED_EVENT',
  /** Represents a 'moved_columns_in_project' event on a given issue or pull request. */
  MovedColumnsInProjectEvent = 'MOVED_COLUMNS_IN_PROJECT_EVENT',
  /** Represents a 'parent_issue_added' event on a given issue. */
  ParentIssueAddedEvent = 'PARENT_ISSUE_ADDED_EVENT',
  /** Represents a 'parent_issue_removed' event on a given issue. */
  ParentIssueRemovedEvent = 'PARENT_ISSUE_REMOVED_EVENT',
  /** Represents a 'pinned' event on a given issue or pull request. */
  PinnedEvent = 'PINNED_EVENT',
  /** Represents a 'project_v2_item_status_changed' event on a given issue or pull request. */
  ProjectV2ItemStatusChangedEvent = 'PROJECT_V2_ITEM_STATUS_CHANGED_EVENT',
  /** Represents a 'referenced' event on a given `ReferencedSubject`. */
  ReferencedEvent = 'REFERENCED_EVENT',
  /** Represents a 'removed_from_project' event on a given issue or pull request. */
  RemovedFromProjectEvent = 'REMOVED_FROM_PROJECT_EVENT',
  /** Represents a 'removed_from_project_v2' event on a given issue or pull request. */
  RemovedFromProjectV2Event = 'REMOVED_FROM_PROJECT_V2_EVENT',
  /** Represents a 'renamed' event on a given issue or pull request */
  RenamedTitleEvent = 'RENAMED_TITLE_EVENT',
  /** Represents a 'reopened' event on any `Closable`. */
  ReopenedEvent = 'REOPENED_EVENT',
  /** Represents a 'subscribed' event on a given `Subscribable`. */
  SubscribedEvent = 'SUBSCRIBED_EVENT',
  /** Represents a 'sub_issue_added' event on a given issue. */
  SubIssueAddedEvent = 'SUB_ISSUE_ADDED_EVENT',
  /** Represents a 'sub_issue_removed' event on a given issue. */
  SubIssueRemovedEvent = 'SUB_ISSUE_REMOVED_EVENT',
  /** Represents a 'transferred' event on a given issue or pull request. */
  TransferredEvent = 'TRANSFERRED_EVENT',
  /** Represents an 'unassigned' event on any assignable object. */
  UnassignedEvent = 'UNASSIGNED_EVENT',
  /** Represents an 'unlabeled' event on a given issue or pull request. */
  UnlabeledEvent = 'UNLABELED_EVENT',
  /** Represents an 'unlocked' event on a given issue or pull request. */
  UnlockedEvent = 'UNLOCKED_EVENT',
  /** Represents an 'unmarked_as_duplicate' event on a given issue or pull request. */
  UnmarkedAsDuplicateEvent = 'UNMARKED_AS_DUPLICATE_EVENT',
  /** Represents an 'unpinned' event on a given issue or pull request. */
  UnpinnedEvent = 'UNPINNED_EVENT',
  /** Represents an 'unsubscribed' event on a given `Subscribable`. */
  UnsubscribedEvent = 'UNSUBSCRIBED_EVENT',
  /** Represents a 'user_blocked' event on a given user. */
  UserBlockedEvent = 'USER_BLOCKED_EVENT'
}

/** Represents the type of Issue. */
export type IssueType = Node & {
  __typename?: 'IssueType';
  /** The issue type's color. */
  color: IssueTypeColor;
  /** The issue type's description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The Node ID of the IssueType object */
  id: Scalars['ID']['output'];
  /** The issue type's enabled state. */
  isEnabled: Scalars['Boolean']['output'];
  /**
   * Whether the issue type is publicly visible.
   * @deprecated Private issue types are being deprecated and can no longer be created. Removal on 2025-04-01 UTC.
   */
  isPrivate: Scalars['Boolean']['output'];
  /** The issues with this issue type in the given repository. */
  issues: IssueConnection;
  /** The issue type's name. */
  name: Scalars['String']['output'];
  /** An ordered list of issue fields pinned to this type. */
  pinnedFields?: Maybe<Array<IssueFields>>;
};


/** Represents the type of Issue. */
export type IssueTypeIssuesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<IssueFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<IssueOrder>;
  repositoryId: Scalars['ID']['input'];
  states?: InputMaybe<Array<IssueState>>;
};

/** Represents a 'issue_type_added' event on a given issue. */
export type IssueTypeAddedEvent = Node & {
  __typename?: 'IssueTypeAddedEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The Node ID of the IssueTypeAddedEvent object */
  id: Scalars['ID']['output'];
  /** The intent behind the agent's action, including rationale and confidence. */
  intent?: Maybe<IssueUpdateIntent>;
  /** The issue type added. */
  issueType?: Maybe<IssueType>;
};

/** Represents a 'issue_type_changed' event on a given issue. */
export type IssueTypeChangedEvent = Node & {
  __typename?: 'IssueTypeChangedEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The Node ID of the IssueTypeChangedEvent object */
  id: Scalars['ID']['output'];
  /** The intent behind the agent's action, including rationale and confidence. */
  intent?: Maybe<IssueUpdateIntent>;
  /** The issue type added. */
  issueType?: Maybe<IssueType>;
  /** The issue type removed. */
  prevIssueType?: Maybe<IssueType>;
};

/** The possible color for an issue type */
export enum IssueTypeColor {
  /** blue */
  Blue = 'BLUE',
  /** gray */
  Gray = 'GRAY',
  /** green */
  Green = 'GREEN',
  /** orange */
  Orange = 'ORANGE',
  /** pink */
  Pink = 'PINK',
  /** purple */
  Purple = 'PURPLE',
  /** red */
  Red = 'RED',
  /** yellow */
  Yellow = 'YELLOW'
}

/** The connection type for IssueType. */
export type IssueTypeConnection = {
  __typename?: 'IssueTypeConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<IssueTypeEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<IssueType>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type IssueTypeEdge = {
  __typename?: 'IssueTypeEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<IssueType>;
};

/** Ordering options for issue types connections */
export type IssueTypeOrder = {
  /** The ordering direction. */
  direction: OrderDirection;
  /** The field to order issue types by. */
  field: IssueTypeOrderField;
};

/** Properties by which issue type connections can be ordered. */
export enum IssueTypeOrderField {
  /** Order issue types by creation time */
  CreatedAt = 'CREATED_AT',
  /** Order issue types by name */
  Name = 'NAME'
}

/** Represents a 'issue_type_removed' event on a given issue. */
export type IssueTypeRemovedEvent = Node & {
  __typename?: 'IssueTypeRemovedEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The Node ID of the IssueTypeRemovedEvent object */
  id: Scalars['ID']['output'];
  /** The intent behind the agent's action, including rationale and confidence. */
  intent?: Maybe<IssueUpdateIntent>;
  /** The issue type removed. */
  issueType?: Maybe<IssueType>;
};

/** Specifies an Issue Type to set on an issue, with optional metadata such as a rationale. */
export type IssueTypeUpdateInput = {
  /** The confidence level the agent had when selecting this value. */
  confidence?: InputMaybe<IssueEventConfidenceLevel>;
  /** The ID of the Issue Type to set on this issue. Pass null to clear the issue type. */
  issueTypeId?: InputMaybe<Scalars['ID']['input']>;
  /** Optional rationale describing why this value was selected. Max 280 characters. */
  rationale?: InputMaybe<Scalars['String']['input']>;
  /** If true, the value is stored as a pending suggestion for human review rather than being applied directly. */
  suggest?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The intent behind an agent's issue event action, including rationale and confidence. */
export type IssueUpdateIntent = {
  __typename?: 'IssueUpdateIntent';
  /** The confidence level the agent had when performing this action. */
  confidence?: Maybe<IssueEventConfidenceLevel>;
  /** Identifies the primary key from the database. */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** Opaque identifier for the underlying intent. Carries the DB bigint as a String. */
  intentId?: Maybe<Scalars['String']['output']>;
  /** The reasoning or explanation text for the event. */
  rationale?: Maybe<Scalars['String']['output']>;
};

/** Represents a user signing up for a GitHub account. */
export type JoinedGitHubContribution = Contribution & {
  __typename?: 'JoinedGitHubContribution';
  /**
   * Whether this contribution is associated with a record you do not have access to. For
   * example, your own 'first issue' contribution may have been made on a repository you can no
   * longer access.
   */
  isRestricted: Scalars['Boolean']['output'];
  /** When this contribution was made. */
  occurredAt: Scalars['DateTime']['output'];
  /** The HTTP path for this contribution. */
  resourcePath: Scalars['URI']['output'];
  /** The HTTP URL for this contribution. */
  url: Scalars['URI']['output'];
  /** The user who made this contribution. */
  user: User;
};

/** A label for categorizing Issues, Pull Requests, Milestones, or Discussions with a given Repository. */
export type Label = Node & {
  __typename?: 'Label';
  /** Identifies the label color. */
  color: Scalars['String']['output'];
  /** Identifies the date and time when the label was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** A brief description of this label. */
  description?: Maybe<Scalars['String']['output']>;
  /** The Node ID of the Label object */
  id: Scalars['ID']['output'];
  /** Indicates whether or not this is a default label. */
  isDefault: Scalars['Boolean']['output'];
  /** A list of issues associated with this label. */
  issues: IssueConnection;
  /** Identifies the label name. */
  name: Scalars['String']['output'];
  /** A list of pull requests associated with this label. */
  pullRequests: PullRequestConnection;
  /** The repository associated with this label. */
  repository: Repository;
  /** The HTTP path for this label. */
  resourcePath: Scalars['URI']['output'];
  /** Identifies the date and time when the label was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The HTTP URL for this label. */
  url: Scalars['URI']['output'];
};


/** A label for categorizing Issues, Pull Requests, Milestones, or Discussions with a given Repository. */
export type LabelIssuesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<IssueFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<IssueOrder>;
  states?: InputMaybe<Array<IssueState>>;
};


/** A label for categorizing Issues, Pull Requests, Milestones, or Discussions with a given Repository. */
export type LabelPullRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  baseRefName?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  headRefName?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<IssueOrder>;
  states?: InputMaybe<Array<PullRequestState>>;
};

/** The connection type for Label. */
export type LabelConnection = {
  __typename?: 'LabelConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LabelEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Label>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LabelEdge = {
  __typename?: 'LabelEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Label>;
};

/** Ways in which lists of labels can be ordered upon return. */
export type LabelOrder = {
  /** The direction in which to order labels by the specified field. */
  direction: OrderDirection;
  /** The field in which to order labels by. */
  field: LabelOrderField;
};

/** Properties by which label connections can be ordered. */
export enum LabelOrderField {
  /** Order labels by creation time */
  CreatedAt = 'CREATED_AT',
  /** Order labels by issue count */
  IssueCount = 'ISSUE_COUNT',
  /** Order labels by name */
  Name = 'NAME'
}

/** Specifies a Label to set on an issue, with optional metadata such as a rationale. */
export type LabelUpdateInput = {
  /** The confidence level the agent had when selecting this value. */
  confidence?: InputMaybe<IssueEventConfidenceLevel>;
  /** The ID of the Label. */
  labelId: Scalars['ID']['input'];
  /** Optional rationale describing why this value was selected. Max 280 characters. */
  rationale?: InputMaybe<Scalars['String']['input']>;
  /** If true, the value is stored as a pending suggestion for human review rather than being applied directly. */
  suggest?: InputMaybe<Scalars['Boolean']['input']>;
};

/** An object that can have labels assigned to it. */
export type Labelable = {
  /** A list of labels associated with the object. */
  labels?: Maybe<LabelConnection>;
  /** Indicates if the viewer can edit labels for this object. */
  viewerCanLabel: Scalars['Boolean']['output'];
};


/** An object that can have labels assigned to it. */
export type LabelableLabelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LabelOrder>;
};

/** Represents a 'labeled' event on a given issue or pull request. */
export type LabeledEvent = Node & {
  __typename?: 'LabeledEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The Node ID of the LabeledEvent object */
  id: Scalars['ID']['output'];
  /** The intent behind the agent's action, including rationale and confidence. */
  intent?: Maybe<IssueUpdateIntent>;
  /** Identifies the label associated with the 'labeled' event. */
  label: Label;
  /** Identifies the `Labelable` associated with the event. */
  labelable: Labelable;
};

/** Represents a given language found in repositories. */
export type Language = Node & {
  __typename?: 'Language';
  /** The color defined for the current language. */
  color?: Maybe<Scalars['String']['output']>;
  /** The Node ID of the Language object */
  id: Scalars['ID']['output'];
  /** The name of the current language. */
  name: Scalars['String']['output'];
};

/** A list of languages associated with the parent. */
export type LanguageConnection = {
  __typename?: 'LanguageConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LanguageEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Language>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
  /** The total size in bytes of files written in that language. */
  totalSize: Scalars['Int']['output'];
};

/** Represents the language of a repository. */
export type LanguageEdge = {
  __typename?: 'LanguageEdge';
  cursor: Scalars['String']['output'];
  node: Language;
  /** The number of bytes of code written in the language. */
  size: Scalars['Int']['output'];
};

/** Ordering options for language connections. */
export type LanguageOrder = {
  /** The ordering direction. */
  direction: OrderDirection;
  /** The field to order languages by. */
  field: LanguageOrderField;
};

/** Properties by which language connections can be ordered. */
export enum LanguageOrderField {
  /** Order languages by the size of all files containing the language */
  Size = 'SIZE'
}

/** Reason why a semantic or hybrid issue search fell back to lexical search */
export enum LexicalFallbackReason {
  /** Query targets non-issue types (e.g., pull requests) */
  NonIssueTarget = 'NON_ISSUE_TARGET',
  /** Scoped query resolved to zero accessible repositories */
  NoAccessibleRepos = 'NO_ACCESSIBLE_REPOS',
  /** Query has only qualifiers and no free text terms */
  NoTextTerms = 'NO_TEXT_TERMS',
  /** Query uses an in: qualifier targeting non-semantic fields */
  OnlyNonSemanticFieldsRequested = 'ONLY_NON_SEMANTIC_FIELDS_REQUESTED',
  /** Query contains OR operators (nested boolean qualifiers) */
  OrBooleanNotSupported = 'OR_BOOLEAN_NOT_SUPPORTED',
  /** Query contains quoted text requiring exact matches */
  QuotedText = 'QUOTED_TEXT',
  /** Embedding generation failed or timed out */
  ServerError = 'SERVER_ERROR'
}

/** A repository's open source license */
export type License = Node & {
  __typename?: 'License';
  /** The full text of the license */
  body: Scalars['String']['output'];
  /** The conditions set by the license */
  conditions: Array<Maybe<LicenseRule>>;
  /** A human-readable description of the license */
  description?: Maybe<Scalars['String']['output']>;
  /** Whether the license should be featured */
  featured: Scalars['Boolean']['output'];
  /** Whether the license should be displayed in license pickers */
  hidden: Scalars['Boolean']['output'];
  /** The Node ID of the License object */
  id: Scalars['ID']['output'];
  /** Instructions on how to implement the license */
  implementation?: Maybe<Scalars['String']['output']>;
  /** The lowercased SPDX ID of the license */
  key: Scalars['String']['output'];
  /** The limitations set by the license */
  limitations: Array<Maybe<LicenseRule>>;
  /** The license full name specified by <https://spdx.org/licenses> */
  name: Scalars['String']['output'];
  /** Customary short name if applicable (e.g, GPLv3) */
  nickname?: Maybe<Scalars['String']['output']>;
  /** The permissions set by the license */
  permissions: Array<Maybe<LicenseRule>>;
  /** Whether the license is a pseudo-license placeholder (e.g., other, no-license) */
  pseudoLicense: Scalars['Boolean']['output'];
  /** Short identifier specified by <https://spdx.org/licenses> */
  spdxId?: Maybe<Scalars['String']['output']>;
  /** URL to the license on <https://choosealicense.com> */
  url?: Maybe<Scalars['URI']['output']>;
};

/** Describes a License's conditions, permissions, and limitations */
export type LicenseRule = {
  __typename?: 'LicenseRule';
  /** A description of the rule */
  description: Scalars['String']['output'];
  /** The machine-readable rule key */
  key: Scalars['String']['output'];
  /** The human-readable rule label */
  label: Scalars['String']['output'];
};

/** Autogenerated input type of LinkProjectV2ToRepository */
export type LinkProjectV2ToRepositoryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the project to link to the repository. */
  projectId: Scalars['ID']['input'];
  /** The ID of the repository to link to the project. */
  repositoryId: Scalars['ID']['input'];
};

/** Autogenerated return type of LinkProjectV2ToRepository. */
export type LinkProjectV2ToRepositoryPayload = {
  __typename?: 'LinkProjectV2ToRepositoryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The repository the project is linked to. */
  repository?: Maybe<Repository>;
};

/** Autogenerated input type of LinkProjectV2ToTeam */
export type LinkProjectV2ToTeamInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the project to link to the team. */
  projectId: Scalars['ID']['input'];
  /** The ID of the team to link to the project. */
  teamId: Scalars['ID']['input'];
};

/** Autogenerated return type of LinkProjectV2ToTeam. */
export type LinkProjectV2ToTeamPayload = {
  __typename?: 'LinkProjectV2ToTeamPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The team the project is linked to */
  team?: Maybe<Team>;
};

/** Autogenerated input type of LinkRepositoryToProject */
export type LinkRepositoryToProjectInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the Project to link to a Repository */
  projectId: Scalars['ID']['input'];
  /** The ID of the Repository to link to a Project. */
  repositoryId: Scalars['ID']['input'];
};

/** Autogenerated return type of LinkRepositoryToProject. */
export type LinkRepositoryToProjectPayload = {
  __typename?: 'LinkRepositoryToProjectPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The linked Project. */
  project?: Maybe<Project>;
  /** The linked Repository. */
  repository?: Maybe<Repository>;
};

/** A branch linked to an issue. */
export type LinkedBranch = Node & {
  __typename?: 'LinkedBranch';
  /** The Node ID of the LinkedBranch object */
  id: Scalars['ID']['output'];
  /** The branch's ref. */
  ref?: Maybe<Ref>;
};

/** A list of branches linked to an issue. */
export type LinkedBranchConnection = {
  __typename?: 'LinkedBranchConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<LinkedBranchEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<LinkedBranch>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type LinkedBranchEdge = {
  __typename?: 'LinkedBranchEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<LinkedBranch>;
};

/** Autogenerated input type of LockLockable */
export type LockLockableInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** A reason for why the item will be locked. */
  lockReason?: InputMaybe<LockReason>;
  /** ID of the item to be locked. */
  lockableId: Scalars['ID']['input'];
};

/** Autogenerated return type of LockLockable. */
export type LockLockablePayload = {
  __typename?: 'LockLockablePayload';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The item that was locked. */
  lockedRecord?: Maybe<Lockable>;
};

/** The possible reasons that an issue or pull request was locked. */
export enum LockReason {
  /** The issue or pull request was locked because the conversation was off-topic. */
  OffTopic = 'OFF_TOPIC',
  /** The issue or pull request was locked because the conversation was resolved. */
  Resolved = 'RESOLVED',
  /** The issue or pull request was locked because the conversation was spam. */
  Spam = 'SPAM',
  /** The issue or pull request was locked because the conversation was too heated. */
  TooHeated = 'TOO_HEATED'
}

/** An object that can be locked. */
export type Lockable = {
  /** Reason that the conversation was locked. */
  activeLockReason?: Maybe<LockReason>;
  /** `true` if the object is locked */
  locked: Scalars['Boolean']['output'];
};

/** Represents a 'locked' event on a given issue or pull request. */
export type LockedEvent = Node & {
  __typename?: 'LockedEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The Node ID of the LockedEvent object */
  id: Scalars['ID']['output'];
  /** Reason that the conversation was locked (optional). */
  lockReason?: Maybe<LockReason>;
  /** Object that was locked. */
  lockable: Lockable;
};

/** A placeholder user for attribution of imported data on GitHub. */
export type Mannequin = Actor & Node & UniformResourceLocatable & {
  __typename?: 'Mannequin';
  /** A URL pointing to the GitHub App's public avatar. */
  avatarUrl: Scalars['URI']['output'];
  /** The user that has claimed the data attributed to this mannequin. */
  claimant?: Maybe<User>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Identifies the primary key from the database. */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** The mannequin's email on the source instance. */
  email?: Maybe<Scalars['String']['output']>;
  /** The Node ID of the Mannequin object */
  id: Scalars['ID']['output'];
  /** The username of the actor. */
  login: Scalars['String']['output'];
  /** The display name of the imported mannequin. */
  name?: Maybe<Scalars['String']['output']>;
  /** The HTML path to this resource. */
  resourcePath: Scalars['URI']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The URL to this resource. */
  url: Scalars['URI']['output'];
};


/** A placeholder user for attribution of imported data on GitHub. */
export type MannequinAvatarUrlArgs = {
  size?: InputMaybe<Scalars['Int']['input']>;
};

/** A list of mannequins. */
export type MannequinConnection = {
  __typename?: 'MannequinConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<MannequinEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Mannequin>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** Represents a mannequin. */
export type MannequinEdge = {
  __typename?: 'MannequinEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Mannequin>;
};

/** Ordering options for mannequins. */
export type MannequinOrder = {
  /** The ordering direction. */
  direction: OrderDirection;
  /** The field to order mannequins by. */
  field: MannequinOrderField;
};

/** Properties by which mannequins can be ordered. */
export enum MannequinOrderField {
  /** Order mannequins why when they were created. */
  CreatedAt = 'CREATED_AT',
  /** Order mannequins alphabetically by their source login. */
  Login = 'LOGIN'
}

/** Autogenerated input type of MarkDiscussionCommentAsAnswer */
export type MarkDiscussionCommentAsAnswerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Node ID of the discussion comment to mark as an answer. */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of MarkDiscussionCommentAsAnswer. */
export type MarkDiscussionCommentAsAnswerPayload = {
  __typename?: 'MarkDiscussionCommentAsAnswerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The discussion that includes the chosen comment. */
  discussion?: Maybe<Discussion>;
};

/** Autogenerated input type of MarkFileAsViewed */
export type MarkFileAsViewedInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The path of the file to mark as viewed */
  path: Scalars['String']['input'];
  /** The Node ID of the pull request. */
  pullRequestId: Scalars['ID']['input'];
};

/** Autogenerated return type of MarkFileAsViewed. */
export type MarkFileAsViewedPayload = {
  __typename?: 'MarkFileAsViewedPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated pull request. */
  pullRequest?: Maybe<PullRequest>;
};

/** Autogenerated input type of MarkProjectV2AsTemplate */
export type MarkProjectV2AsTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the Project to mark as a template. */
  projectId: Scalars['ID']['input'];
};

/** Autogenerated return type of MarkProjectV2AsTemplate. */
export type MarkProjectV2AsTemplatePayload = {
  __typename?: 'MarkProjectV2AsTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The project. */
  projectV2?: Maybe<ProjectV2>;
};

/** Autogenerated input type of MarkPullRequestReadyForReview */
export type MarkPullRequestReadyForReviewInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the pull request to be marked as ready for review. */
  pullRequestId: Scalars['ID']['input'];
};

/** Autogenerated return type of MarkPullRequestReadyForReview. */
export type MarkPullRequestReadyForReviewPayload = {
  __typename?: 'MarkPullRequestReadyForReviewPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The pull request that is ready for review. */
  pullRequest?: Maybe<PullRequest>;
};

/** Represents a 'marked_as_duplicate' event on a given issue or pull request. */
export type MarkedAsDuplicateEvent = Node & {
  __typename?: 'MarkedAsDuplicateEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** The authoritative issue or pull request which has been duplicated by another. */
  canonical?: Maybe<IssueOrPullRequest>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The issue or pull request which has been marked as a duplicate of another. */
  duplicate?: Maybe<IssueOrPullRequest>;
  /** The Node ID of the MarkedAsDuplicateEvent object */
  id: Scalars['ID']['output'];
  /** Canonical and duplicate belong to different repositories. */
  isCrossRepository: Scalars['Boolean']['output'];
};

/** A public description of a Marketplace category. */
export type MarketplaceCategory = Node & {
  __typename?: 'MarketplaceCategory';
  /** The category's description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The technical description of how apps listed in this category work with GitHub. */
  howItWorks?: Maybe<Scalars['String']['output']>;
  /** The Node ID of the MarketplaceCategory object */
  id: Scalars['ID']['output'];
  /** The category's name. */
  name: Scalars['String']['output'];
  /** How many Marketplace listings have this as their primary category. */
  primaryListingCount: Scalars['Int']['output'];
  /** The HTTP path for this Marketplace category. */
  resourcePath: Scalars['URI']['output'];
  /** How many Marketplace listings have this as their secondary category. */
  secondaryListingCount: Scalars['Int']['output'];
  /** The short name of the category used in its URL. */
  slug: Scalars['String']['output'];
  /** The HTTP URL for this Marketplace category. */
  url: Scalars['URI']['output'];
};

/** A listing in the GitHub integration marketplace. */
export type MarketplaceListing = Node & {
  __typename?: 'MarketplaceListing';
  /** The GitHub App this listing represents. */
  app?: Maybe<App>;
  /** URL to the listing owner's company site. */
  companyUrl?: Maybe<Scalars['URI']['output']>;
  /** The HTTP path for configuring access to the listing's integration or OAuth app */
  configurationResourcePath: Scalars['URI']['output'];
  /** The HTTP URL for configuring access to the listing's integration or OAuth app */
  configurationUrl: Scalars['URI']['output'];
  /** URL to the listing's documentation. */
  documentationUrl?: Maybe<Scalars['URI']['output']>;
  /** The listing's detailed description. */
  extendedDescription?: Maybe<Scalars['String']['output']>;
  /** The listing's detailed description rendered to HTML. */
  extendedDescriptionHTML: Scalars['HTML']['output'];
  /** The listing's introductory description. */
  fullDescription: Scalars['String']['output'];
  /** The listing's introductory description rendered to HTML. */
  fullDescriptionHTML: Scalars['HTML']['output'];
  /** Does this listing have any plans with a free trial? */
  hasPublishedFreeTrialPlans: Scalars['Boolean']['output'];
  /** Does this listing have a terms of service link? */
  hasTermsOfService: Scalars['Boolean']['output'];
  /** Whether the creator of the app is a verified org */
  hasVerifiedOwner: Scalars['Boolean']['output'];
  /** A technical description of how this app works with GitHub. */
  howItWorks?: Maybe<Scalars['String']['output']>;
  /** The listing's technical description rendered to HTML. */
  howItWorksHTML: Scalars['HTML']['output'];
  /** The Node ID of the MarketplaceListing object */
  id: Scalars['ID']['output'];
  /** URL to install the product to the viewer's account or organization. */
  installationUrl?: Maybe<Scalars['URI']['output']>;
  /** Whether this listing's app has been installed for the current viewer */
  installedForViewer: Scalars['Boolean']['output'];
  /** Whether this listing has been removed from the Marketplace. */
  isArchived: Scalars['Boolean']['output'];
  /**
   * Whether this listing is still an editable draft that has not been submitted
   * for review and is not publicly visible in the Marketplace.
   */
  isDraft: Scalars['Boolean']['output'];
  /** Whether the product this listing represents is available as part of a paid plan. */
  isPaid: Scalars['Boolean']['output'];
  /** Whether this listing has been approved for display in the Marketplace. */
  isPublic: Scalars['Boolean']['output'];
  /** Whether this listing has been rejected by GitHub for display in the Marketplace. */
  isRejected: Scalars['Boolean']['output'];
  /** Whether this listing has been approved for unverified display in the Marketplace. */
  isUnverified: Scalars['Boolean']['output'];
  /** Whether this draft listing has been submitted for review for approval to be unverified in the Marketplace. */
  isUnverifiedPending: Scalars['Boolean']['output'];
  /** Whether this draft listing has been submitted for review from GitHub for approval to be verified in the Marketplace. */
  isVerificationPendingFromDraft: Scalars['Boolean']['output'];
  /** Whether this unverified listing has been submitted for review from GitHub for approval to be verified in the Marketplace. */
  isVerificationPendingFromUnverified: Scalars['Boolean']['output'];
  /** Whether this listing has been approved for verified display in the Marketplace. */
  isVerified: Scalars['Boolean']['output'];
  /** The hex color code, without the leading '#', for the logo background. */
  logoBackgroundColor: Scalars['String']['output'];
  /** URL for the listing's logo image. */
  logoUrl?: Maybe<Scalars['URI']['output']>;
  /** The listing's full name. */
  name: Scalars['String']['output'];
  /** The listing's very short description without a trailing period or ampersands. */
  normalizedShortDescription: Scalars['String']['output'];
  /** URL to the listing's detailed pricing. */
  pricingUrl?: Maybe<Scalars['URI']['output']>;
  /** The category that best describes the listing. */
  primaryCategory: MarketplaceCategory;
  /** URL to the listing's privacy policy, may return an empty string for listings that do not require a privacy policy URL. */
  privacyPolicyUrl: Scalars['URI']['output'];
  /** The HTTP path for the Marketplace listing. */
  resourcePath: Scalars['URI']['output'];
  /** The URLs for the listing's screenshots. */
  screenshotUrls: Array<Maybe<Scalars['String']['output']>>;
  /** An alternate category that describes the listing. */
  secondaryCategory?: Maybe<MarketplaceCategory>;
  /** The listing's very short description. */
  shortDescription: Scalars['String']['output'];
  /** The short name of the listing used in its URL. */
  slug: Scalars['String']['output'];
  /** URL to the listing's status page. */
  statusUrl?: Maybe<Scalars['URI']['output']>;
  /** An email address for support for this listing's app. */
  supportEmail?: Maybe<Scalars['String']['output']>;
  /**
   * Either a URL or an email address for support for this listing's app, may
   * return an empty string for listings that do not require a support URL.
   */
  supportUrl: Scalars['URI']['output'];
  /** URL to the listing's terms of service. */
  termsOfServiceUrl?: Maybe<Scalars['URI']['output']>;
  /** The HTTP URL for the Marketplace listing. */
  url: Scalars['URI']['output'];
  /** Can the current viewer add plans for this Marketplace listing. */
  viewerCanAddPlans: Scalars['Boolean']['output'];
  /** Can the current viewer approve this Marketplace listing. */
  viewerCanApprove: Scalars['Boolean']['output'];
  /** Can the current viewer delist this Marketplace listing. */
  viewerCanDelist: Scalars['Boolean']['output'];
  /** Can the current viewer edit this Marketplace listing. */
  viewerCanEdit: Scalars['Boolean']['output'];
  /**
   * Can the current viewer edit the primary and secondary category of this
   * Marketplace listing.
   */
  viewerCanEditCategories: Scalars['Boolean']['output'];
  /** Can the current viewer edit the plans for this Marketplace listing. */
  viewerCanEditPlans: Scalars['Boolean']['output'];
  /**
   * Can the current viewer return this Marketplace listing to draft state
   * so it becomes editable again.
   */
  viewerCanRedraft: Scalars['Boolean']['output'];
  /**
   * Can the current viewer reject this Marketplace listing by returning it to
   * an editable draft state or rejecting it entirely.
   */
  viewerCanReject: Scalars['Boolean']['output'];
  /**
   * Can the current viewer request this listing be reviewed for display in
   * the Marketplace as verified.
   */
  viewerCanRequestApproval: Scalars['Boolean']['output'];
  /** Indicates whether the current user has an active subscription to this Marketplace listing. */
  viewerHasPurchased: Scalars['Boolean']['output'];
  /**
   * Indicates if the current user has purchased a subscription to this Marketplace listing
   * for all of the organizations the user owns.
   */
  viewerHasPurchasedForAllOrganizations: Scalars['Boolean']['output'];
  /** Does the current viewer role allow them to administer this Marketplace listing. */
  viewerIsListingAdmin: Scalars['Boolean']['output'];
};


/** A listing in the GitHub integration marketplace. */
export type MarketplaceListingLogoUrlArgs = {
  size?: InputMaybe<Scalars['Int']['input']>;
};

/** Look up Marketplace Listings */
export type MarketplaceListingConnection = {
  __typename?: 'MarketplaceListingConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<MarketplaceListingEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<MarketplaceListing>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MarketplaceListingEdge = {
  __typename?: 'MarketplaceListingEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<MarketplaceListing>;
};

/** Prevent commits that include file paths that exceed the specified character limit from being pushed to the commit graph. */
export type MaxFilePathLengthParameters = {
  __typename?: 'MaxFilePathLengthParameters';
  /** The maximum amount of characters allowed in file paths. */
  maxFilePathLength: Scalars['Int']['output'];
};

/** Prevent commits that include file paths that exceed the specified character limit from being pushed to the commit graph. */
export type MaxFilePathLengthParametersInput = {
  /** The maximum amount of characters allowed in file paths. */
  maxFilePathLength: Scalars['Int']['input'];
};

/** Prevent commits with individual files that exceed the specified limit from being pushed to the commit graph. */
export type MaxFileSizeParameters = {
  __typename?: 'MaxFileSizeParameters';
  /** The maximum file size allowed in megabytes. This limit does not apply to Git Large File Storage (Git LFS). */
  maxFileSize: Scalars['Int']['output'];
};

/** Prevent commits with individual files that exceed the specified limit from being pushed to the commit graph. */
export type MaxFileSizeParametersInput = {
  /** The maximum file size allowed in megabytes. This limit does not apply to Git Large File Storage (Git LFS). */
  maxFileSize: Scalars['Int']['input'];
};

/** Represents a member feature request notification */
export type MemberFeatureRequestNotification = Node & {
  __typename?: 'MemberFeatureRequestNotification';
  /** Represents member feature request body containing entity name and the number of feature requests */
  body: Scalars['String']['output'];
  /** The Node ID of the MemberFeatureRequestNotification object */
  id: Scalars['ID']['output'];
  /** Represents member feature request notification title */
  title: Scalars['String']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Entities that have members who can set status messages. */
export type MemberStatusable = {
  /** Get the status messages members of this entity have set that are either public or visible only to the organization. */
  memberStatuses: UserStatusConnection;
};


/** Entities that have members who can set status messages. */
export type MemberStatusableMemberStatusesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UserStatusOrder>;
};

/** Audit log entry for a members_can_delete_repos.clear event. */
export type MembersCanDeleteReposClearAuditEntry = AuditEntry & EnterpriseAuditEntryData & Node & OrganizationAuditEntryData & {
  __typename?: 'MembersCanDeleteReposClearAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /** The HTTP path for this enterprise. */
  enterpriseResourcePath?: Maybe<Scalars['URI']['output']>;
  /** The slug of the enterprise. */
  enterpriseSlug?: Maybe<Scalars['String']['output']>;
  /** The HTTP URL for this enterprise. */
  enterpriseUrl?: Maybe<Scalars['URI']['output']>;
  /** The Node ID of the MembersCanDeleteReposClearAuditEntry object */
  id: Scalars['ID']['output'];
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
};

/** Audit log entry for a members_can_delete_repos.disable event. */
export type MembersCanDeleteReposDisableAuditEntry = AuditEntry & EnterpriseAuditEntryData & Node & OrganizationAuditEntryData & {
  __typename?: 'MembersCanDeleteReposDisableAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /** The HTTP path for this enterprise. */
  enterpriseResourcePath?: Maybe<Scalars['URI']['output']>;
  /** The slug of the enterprise. */
  enterpriseSlug?: Maybe<Scalars['String']['output']>;
  /** The HTTP URL for this enterprise. */
  enterpriseUrl?: Maybe<Scalars['URI']['output']>;
  /** The Node ID of the MembersCanDeleteReposDisableAuditEntry object */
  id: Scalars['ID']['output'];
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
};

/** Audit log entry for a members_can_delete_repos.enable event. */
export type MembersCanDeleteReposEnableAuditEntry = AuditEntry & EnterpriseAuditEntryData & Node & OrganizationAuditEntryData & {
  __typename?: 'MembersCanDeleteReposEnableAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /** The HTTP path for this enterprise. */
  enterpriseResourcePath?: Maybe<Scalars['URI']['output']>;
  /** The slug of the enterprise. */
  enterpriseSlug?: Maybe<Scalars['String']['output']>;
  /** The HTTP URL for this enterprise. */
  enterpriseUrl?: Maybe<Scalars['URI']['output']>;
  /** The Node ID of the MembersCanDeleteReposEnableAuditEntry object */
  id: Scalars['ID']['output'];
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
};

/** Represents a 'mentioned' event on a given issue or pull request. */
export type MentionedEvent = Node & {
  __typename?: 'MentionedEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Identifies the primary key from the database. */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** The Node ID of the MentionedEvent object */
  id: Scalars['ID']['output'];
};

/** Autogenerated input type of MergeBranch */
export type MergeBranchInput = {
  /** The email address to associate with this commit. */
  authorEmail?: InputMaybe<Scalars['String']['input']>;
  /** The name of the base branch that the provided head will be merged into. */
  base: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Message to use for the merge commit. If omitted, a default will be used. */
  commitMessage?: InputMaybe<Scalars['String']['input']>;
  /** The head to merge into the base branch. This can be a branch name or a commit GitObjectID. */
  head: Scalars['String']['input'];
  /** The Node ID of the Repository containing the base branch that will be modified. */
  repositoryId: Scalars['ID']['input'];
};

/** Autogenerated return type of MergeBranch. */
export type MergeBranchPayload = {
  __typename?: 'MergeBranchPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The resulting merge Commit. */
  mergeCommit?: Maybe<Commit>;
};

/** The possible default commit messages for merges. */
export enum MergeCommitMessage {
  /** Default to a blank commit message. */
  Blank = 'BLANK',
  /** Default to the pull request's body. */
  PrBody = 'PR_BODY',
  /** Default to the pull request's title. */
  PrTitle = 'PR_TITLE'
}

/** The possible default commit titles for merges. */
export enum MergeCommitTitle {
  /** Default to the classic title for a merge message (e.g., Merge pull request #123 from branch-name). */
  MergeMessage = 'MERGE_MESSAGE',
  /** Default to the pull request's title. */
  PrTitle = 'PR_TITLE'
}

/** Autogenerated input type of MergePullRequest */
export type MergePullRequestInput = {
  /** The email address to associate with this merge. */
  authorEmail?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Commit body to use for the merge commit; if omitted, a default message will be used */
  commitBody?: InputMaybe<Scalars['String']['input']>;
  /** Commit headline to use for the merge commit; if omitted, a default message will be used. */
  commitHeadline?: InputMaybe<Scalars['String']['input']>;
  /** OID that the pull request head ref must match to allow merge; if omitted, no check is performed. */
  expectedHeadOid?: InputMaybe<Scalars['GitObjectID']['input']>;
  /** The merge method to use. If omitted, defaults to 'MERGE' */
  mergeMethod?: InputMaybe<PullRequestMergeMethod>;
  /** ID of the pull request to be merged. */
  pullRequestId: Scalars['ID']['input'];
};

/** Autogenerated return type of MergePullRequest. */
export type MergePullRequestPayload = {
  __typename?: 'MergePullRequestPayload';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The pull request that was merged. */
  pullRequest?: Maybe<PullRequest>;
};

/** The queue of pull request entries to be merged into a protected branch in a repository. */
export type MergeQueue = Node & {
  __typename?: 'MergeQueue';
  /** The configuration for this merge queue */
  configuration?: Maybe<MergeQueueConfiguration>;
  /** The entries in the queue */
  entries?: Maybe<MergeQueueEntryConnection>;
  /** The Node ID of the MergeQueue object */
  id: Scalars['ID']['output'];
  /** The estimated time in seconds until a newly added entry would be merged */
  nextEntryEstimatedTimeToMerge?: Maybe<Scalars['Int']['output']>;
  /** The repository this merge queue belongs to */
  repository?: Maybe<Repository>;
  /** The HTTP path for this merge queue */
  resourcePath: Scalars['URI']['output'];
  /** The HTTP URL for this merge queue */
  url: Scalars['URI']['output'];
};


/** The queue of pull request entries to be merged into a protected branch in a repository. */
export type MergeQueueEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Configuration for a MergeQueue */
export type MergeQueueConfiguration = {
  __typename?: 'MergeQueueConfiguration';
  /** The amount of time in minutes to wait for a check response before considering it a failure. */
  checkResponseTimeout?: Maybe<Scalars['Int']['output']>;
  /** The maximum number of entries to build at once. */
  maximumEntriesToBuild?: Maybe<Scalars['Int']['output']>;
  /** The maximum number of entries to merge at once. */
  maximumEntriesToMerge?: Maybe<Scalars['Int']['output']>;
  /** The merge method to use for this queue. */
  mergeMethod?: Maybe<PullRequestMergeMethod>;
  /** The strategy to use when merging entries. */
  mergingStrategy?: Maybe<MergeQueueMergingStrategy>;
  /** The minimum number of entries required to merge at once. */
  minimumEntriesToMerge?: Maybe<Scalars['Int']['output']>;
  /**
   * The amount of time in minutes to wait before ignoring the minumum number of
   * entries in the queue requirement and merging a collection of entries
   */
  minimumEntriesToMergeWaitTime?: Maybe<Scalars['Int']['output']>;
};

/** Entries in a MergeQueue */
export type MergeQueueEntry = Node & {
  __typename?: 'MergeQueueEntry';
  /** The base commit for this entry */
  baseCommit?: Maybe<Commit>;
  /** The date and time this entry was added to the merge queue */
  enqueuedAt: Scalars['DateTime']['output'];
  /** The actor that enqueued this entry */
  enqueuer: Actor;
  /** The estimated time in seconds until this entry will be merged */
  estimatedTimeToMerge?: Maybe<Scalars['Int']['output']>;
  /** The head commit for this entry */
  headCommit?: Maybe<Commit>;
  /** The Node ID of the MergeQueueEntry object */
  id: Scalars['ID']['output'];
  /** Whether this pull request should jump the queue */
  jump: Scalars['Boolean']['output'];
  /** The merge queue that this entry belongs to */
  mergeQueue?: Maybe<MergeQueue>;
  /** The position of this entry in the queue */
  position: Scalars['Int']['output'];
  /** The pull request that will be added to a merge group */
  pullRequest?: Maybe<PullRequest>;
  /** Does this pull request need to be deployed on its own */
  solo: Scalars['Boolean']['output'];
  /** The state of this entry in the queue */
  state: MergeQueueEntryState;
};

/** The connection type for MergeQueueEntry. */
export type MergeQueueEntryConnection = {
  __typename?: 'MergeQueueEntryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<MergeQueueEntryEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<MergeQueueEntry>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MergeQueueEntryEdge = {
  __typename?: 'MergeQueueEntryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<MergeQueueEntry>;
};

/** The possible states for a merge queue entry. */
export enum MergeQueueEntryState {
  /** The entry is currently waiting for checks to pass. */
  AwaitingChecks = 'AWAITING_CHECKS',
  /** The entry is currently locked. */
  Locked = 'LOCKED',
  /** The entry is currently mergeable. */
  Mergeable = 'MERGEABLE',
  /** The entry is currently queued. */
  Queued = 'QUEUED',
  /** The entry is currently unmergeable. */
  Unmergeable = 'UNMERGEABLE'
}

/**
 * When set to ALLGREEN, the merge commit created by merge queue for each PR in the
 * group must pass all required checks to merge. When set to HEADGREEN, only the
 * commit at the head of the merge group, i.e. the commit containing changes from
 * all of the PRs in the group, must pass its required checks to merge.
 */
export enum MergeQueueGroupingStrategy {
  /** The merge commit created by merge queue for each PR in the group must pass all required checks to merge */
  Allgreen = 'ALLGREEN',
  /** Only the commit at the head of the merge group must pass its required checks to merge. */
  Headgreen = 'HEADGREEN'
}

/** Method to use when merging changes from queued pull requests. */
export enum MergeQueueMergeMethod {
  /** Merge commit */
  Merge = 'MERGE',
  /** Rebase and merge */
  Rebase = 'REBASE',
  /** Squash and merge */
  Squash = 'SQUASH'
}

/** The possible merging strategies for a merge queue. */
export enum MergeQueueMergingStrategy {
  /** Entries only allowed to merge if they are passing. */
  Allgreen = 'ALLGREEN',
  /** Failing Entires are allowed to merge if they are with a passing entry. */
  Headgreen = 'HEADGREEN'
}

/** Merges must be performed via a merge queue. */
export type MergeQueueParameters = {
  __typename?: 'MergeQueueParameters';
  /**
   * Maximum time for a required status check to report a conclusion. After this
   * much time has elapsed, checks that have not reported a conclusion will be
   * assumed to have failed
   */
  checkResponseTimeoutMinutes: Scalars['Int']['output'];
  /**
   * When set to ALLGREEN, the merge commit created by merge queue for each PR in
   * the group must pass all required checks to merge. When set to HEADGREEN, only
   * the commit at the head of the merge group, i.e. the commit containing changes
   * from all of the PRs in the group, must pass its required checks to merge.
   */
  groupingStrategy: MergeQueueGroupingStrategy;
  /** Limit the number of queued pull requests requesting checks and workflow runs at the same time. */
  maxEntriesToBuild: Scalars['Int']['output'];
  /** The maximum number of PRs that will be merged together in a group. */
  maxEntriesToMerge: Scalars['Int']['output'];
  /** Method to use when merging changes from queued pull requests. */
  mergeMethod: MergeQueueMergeMethod;
  /** The minimum number of PRs that will be merged together in a group. */
  minEntriesToMerge: Scalars['Int']['output'];
  /**
   * The time merge queue should wait after the first PR is added to the queue for
   * the minimum group size to be met. After this time has elapsed, the minimum
   * group size will be ignored and a smaller group will be merged.
   */
  minEntriesToMergeWaitMinutes: Scalars['Int']['output'];
};

/** Merges must be performed via a merge queue. */
export type MergeQueueParametersInput = {
  /**
   * Maximum time for a required status check to report a conclusion. After this
   * much time has elapsed, checks that have not reported a conclusion will be
   * assumed to have failed
   */
  checkResponseTimeoutMinutes: Scalars['Int']['input'];
  /**
   * When set to ALLGREEN, the merge commit created by merge queue for each PR in
   * the group must pass all required checks to merge. When set to HEADGREEN, only
   * the commit at the head of the merge group, i.e. the commit containing changes
   * from all of the PRs in the group, must pass its required checks to merge.
   */
  groupingStrategy: MergeQueueGroupingStrategy;
  /** Limit the number of queued pull requests requesting checks and workflow runs at the same time. */
  maxEntriesToBuild: Scalars['Int']['input'];
  /** The maximum number of PRs that will be merged together in a group. */
  maxEntriesToMerge: Scalars['Int']['input'];
  /** Method to use when merging changes from queued pull requests. */
  mergeMethod: MergeQueueMergeMethod;
  /** The minimum number of PRs that will be merged together in a group. */
  minEntriesToMerge: Scalars['Int']['input'];
  /**
   * The time merge queue should wait after the first PR is added to the queue for
   * the minimum group size to be met. After this time has elapsed, the minimum
   * group size will be ignored and a smaller group will be merged.
   */
  minEntriesToMergeWaitMinutes: Scalars['Int']['input'];
};

/** Detailed status information about a pull request merge. */
export enum MergeStateStatus {
  /** The head ref is out of date. */
  Behind = 'BEHIND',
  /** The merge is blocked. */
  Blocked = 'BLOCKED',
  /** Mergeable and passing commit status. */
  Clean = 'CLEAN',
  /** The merge commit cannot be cleanly created. */
  Dirty = 'DIRTY',
  /**
   * The merge is blocked due to the pull request being a draft.
   * @deprecated DRAFT state will be removed from this enum and `isDraft` should be used instead Use PullRequest.isDraft instead. Removal on 2021-01-01 UTC.
   */
  Draft = 'DRAFT',
  /** Mergeable with passing commit status and pre-receive hooks. */
  HasHooks = 'HAS_HOOKS',
  /** The state cannot currently be determined. */
  Unknown = 'UNKNOWN',
  /** Mergeable with non-passing commit status. */
  Unstable = 'UNSTABLE'
}

/** Whether or not a PullRequest can be merged. */
export enum MergeableState {
  /** The pull request cannot be merged due to merge conflicts. */
  Conflicting = 'CONFLICTING',
  /** The pull request can be merged. */
  Mergeable = 'MERGEABLE',
  /** The mergeability of the pull request is still being calculated. */
  Unknown = 'UNKNOWN'
}

/** Represents a 'merged' event on a given pull request. */
export type MergedEvent = Node & UniformResourceLocatable & {
  __typename?: 'MergedEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the commit associated with the `merge` event. */
  commit?: Maybe<Commit>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The Node ID of the MergedEvent object */
  id: Scalars['ID']['output'];
  /** Identifies the Ref associated with the `merge` event. */
  mergeRef?: Maybe<Ref>;
  /** Identifies the name of the Ref associated with the `merge` event. */
  mergeRefName: Scalars['String']['output'];
  /** PullRequest referenced by event. */
  pullRequest: PullRequest;
  /** The HTTP path for this merged event. */
  resourcePath: Scalars['URI']['output'];
  /** The HTTP URL for this merged event. */
  url: Scalars['URI']['output'];
};

/** Represents a GitHub Enterprise Importer (GEI) migration. */
export type Migration = {
  /** The migration flag to continue on error. */
  continueOnError: Scalars['Boolean']['output'];
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Identifies the primary key from the database. */
  databaseId?: Maybe<Scalars['String']['output']>;
  /** The reason the migration failed. */
  failureReason?: Maybe<Scalars['String']['output']>;
  /** The Node ID of the Migration object */
  id: Scalars['ID']['output'];
  /** The URL for the migration log (expires 1 day after migration completes). */
  migrationLogUrl?: Maybe<Scalars['URI']['output']>;
  /** The migration source. */
  migrationSource: MigrationSource;
  /** The target repository name. */
  repositoryName: Scalars['String']['output'];
  /** The migration source URL, for example `https://github.com` or `https://monalisa.ghe.com`. */
  sourceUrl: Scalars['URI']['output'];
  /** The migration state. */
  state: MigrationState;
  /**
   * The number of warnings encountered for this migration. To review the warnings,
   * check the [Migration Log](https://docs.github.com/migrations/using-github-enterprise-importer/completing-your-migration-with-github-enterprise-importer/accessing-your-migration-logs-for-github-enterprise-importer).
   */
  warningsCount: Scalars['Int']['output'];
};

/** A GitHub Enterprise Importer (GEI) migration source. */
export type MigrationSource = Node & {
  __typename?: 'MigrationSource';
  /** The Node ID of the MigrationSource object */
  id: Scalars['ID']['output'];
  /** The migration source name. */
  name: Scalars['String']['output'];
  /** The migration source type. */
  type: MigrationSourceType;
  /** The migration source URL, for example `https://github.com` or `https://monalisa.ghe.com`. */
  url: Scalars['URI']['output'];
};

/** Represents the different GitHub Enterprise Importer (GEI) migration sources. */
export enum MigrationSourceType {
  /** An Azure DevOps migration source. */
  AzureDevops = 'AZURE_DEVOPS',
  /** A Bitbucket Server migration source. */
  BitbucketServer = 'BITBUCKET_SERVER',
  /** A GitHub Migration API source. */
  GithubArchive = 'GITHUB_ARCHIVE',
  /** A GitLab migration source. */
  Gitlab = 'GITLAB'
}

/** The GitHub Enterprise Importer (GEI) migration state. */
export enum MigrationState {
  /** The migration has failed. */
  Failed = 'FAILED',
  /** The migration has invalid credentials. */
  FailedValidation = 'FAILED_VALIDATION',
  /** The migration is in progress. */
  InProgress = 'IN_PROGRESS',
  /** The migration has not started. */
  NotStarted = 'NOT_STARTED',
  /** The migration needs to have its credentials validated. */
  PendingValidation = 'PENDING_VALIDATION',
  /** The migration has been queued. */
  Queued = 'QUEUED',
  /** The migration has succeeded. */
  Succeeded = 'SUCCEEDED'
}

/** Represents a Milestone object on a given repository. */
export type Milestone = Closable & Node & UniformResourceLocatable & {
  __typename?: 'Milestone';
  /** Indicates if the object is closed (definition of closed may depend on type) */
  closed: Scalars['Boolean']['output'];
  /** Identifies the date and time when the object was closed. */
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Identifies the number of closed issues associated with the milestone. */
  closedIssueCount: Scalars['Int']['output'];
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Identifies the actor who created the milestone. */
  creator?: Maybe<Actor>;
  /** Identifies the description of the milestone. */
  description?: Maybe<Scalars['String']['output']>;
  /** The HTML rendered description of the milestone using GitHub Flavored Markdown. */
  descriptionHTML?: Maybe<Scalars['String']['output']>;
  /** Identifies the due date of the milestone. */
  dueOn?: Maybe<Scalars['DateTime']['output']>;
  /** The Node ID of the Milestone object */
  id: Scalars['ID']['output'];
  /** A list of issues associated with the milestone. */
  issues: IssueConnection;
  /** Identifies the number of the milestone. */
  number: Scalars['Int']['output'];
  /** Identifies the number of open issues associated with the milestone. */
  openIssueCount: Scalars['Int']['output'];
  /** Identifies the percentage complete for the milestone */
  progressPercentage: Scalars['Float']['output'];
  /** A list of pull requests associated with the milestone. */
  pullRequests: PullRequestConnection;
  /** The repository associated with this milestone. */
  repository: Repository;
  /** The HTTP path for this milestone */
  resourcePath: Scalars['URI']['output'];
  /** Identifies the state of the milestone. */
  state: MilestoneState;
  /** Identifies the title of the milestone. */
  title: Scalars['String']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The HTTP URL for this milestone */
  url: Scalars['URI']['output'];
  /** Indicates if the object can be closed by the viewer. */
  viewerCanClose: Scalars['Boolean']['output'];
  /** Indicates if the object can be reopened by the viewer. */
  viewerCanReopen: Scalars['Boolean']['output'];
};


/** Represents a Milestone object on a given repository. */
export type MilestoneIssuesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<IssueFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<IssueOrder>;
  states?: InputMaybe<Array<IssueState>>;
};


/** Represents a Milestone object on a given repository. */
export type MilestonePullRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  baseRefName?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  headRefName?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<IssueOrder>;
  states?: InputMaybe<Array<PullRequestState>>;
};

/** The connection type for Milestone. */
export type MilestoneConnection = {
  __typename?: 'MilestoneConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<MilestoneEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Milestone>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type MilestoneEdge = {
  __typename?: 'MilestoneEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Milestone>;
};

/** Types that can be inside a Milestone. */
export type MilestoneItem = Issue | PullRequest;

/** Ordering options for milestone connections. */
export type MilestoneOrder = {
  /** The ordering direction. */
  direction: OrderDirection;
  /** The field to order milestones by. */
  field: MilestoneOrderField;
};

/** Properties by which milestone connections can be ordered. */
export enum MilestoneOrderField {
  /** Order milestones by when they were created. */
  CreatedAt = 'CREATED_AT',
  /** Order milestones by when they are due. */
  DueDate = 'DUE_DATE',
  /** Order milestones by their number. */
  Number = 'NUMBER',
  /** Order milestones by when they were last updated. */
  UpdatedAt = 'UPDATED_AT'
}

/** The possible states of a milestone. */
export enum MilestoneState {
  /** A milestone that has been closed. */
  Closed = 'CLOSED',
  /** A milestone that is still open. */
  Open = 'OPEN'
}

/** Represents a 'milestoned' event on a given issue or pull request. */
export type MilestonedEvent = Node & {
  __typename?: 'MilestonedEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The Node ID of the MilestonedEvent object */
  id: Scalars['ID']['output'];
  /** Identifies the milestone title associated with the 'milestoned' event. */
  milestoneTitle: Scalars['String']['output'];
  /** Object referenced by event. */
  subject: MilestoneItem;
};

/** Entities that can be minimized. */
export type Minimizable = {
  /** Returns whether or not a comment has been minimized. */
  isMinimized: Scalars['Boolean']['output'];
  /**
   * Returns why the comment was minimized. One of `abuse`, `off-topic`,
   * `outdated`, `resolved`, `duplicate`, `spam`, and `low-quality`. Note that the
   * case and formatting of these values differs from the inputs to the
   * `MinimizeComment` mutation.
   */
  minimizedReason?: Maybe<Scalars['String']['output']>;
  /** Check if the current viewer can minimize this object. */
  viewerCanMinimize: Scalars['Boolean']['output'];
  /** Check if the current viewer can unminimize this object. */
  viewerCanUnminimize: Scalars['Boolean']['output'];
};

/** Autogenerated input type of MinimizeComment */
export type MinimizeCommentInput = {
  /** The classification of comment */
  classifier: ReportedContentClassifiers;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Node ID of the subject to modify. */
  subjectId: Scalars['ID']['input'];
};

/** Autogenerated return type of MinimizeComment. */
export type MinimizeCommentPayload = {
  __typename?: 'MinimizeCommentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The comment that was minimized. */
  minimizedComment?: Maybe<Minimizable>;
};

/** Autogenerated input type of MoveProjectCard */
export type MoveProjectCardInput = {
  /** Place the new card after the card with this id. Pass null to place it at the top. */
  afterCardId?: InputMaybe<Scalars['ID']['input']>;
  /** The id of the card to move. */
  cardId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the column to move it into. */
  columnId: Scalars['ID']['input'];
};

/** Autogenerated return type of MoveProjectCard. */
export type MoveProjectCardPayload = {
  __typename?: 'MoveProjectCardPayload';
  /** The new edge of the moved card. */
  cardEdge?: Maybe<ProjectCardEdge>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of MoveProjectColumn */
export type MoveProjectColumnInput = {
  /** Place the new column after the column with this id. Pass null to place it at the front. */
  afterColumnId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the column to move. */
  columnId: Scalars['ID']['input'];
};

/** Autogenerated return type of MoveProjectColumn. */
export type MoveProjectColumnPayload = {
  __typename?: 'MoveProjectColumnPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The new edge of the moved column. */
  columnEdge?: Maybe<ProjectColumnEdge>;
};

/** Represents a 'moved_columns_in_project' event on a given issue or pull request. */
export type MovedColumnsInProjectEvent = Node & {
  __typename?: 'MovedColumnsInProjectEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /**
   * Identifies the primary key from the database.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** The Node ID of the MovedColumnsInProjectEvent object */
  id: Scalars['ID']['output'];
  /**
   * Column name the issue or pull request was moved from.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  previousProjectColumnName: Scalars['String']['output'];
  /**
   * Project referenced by event.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  project?: Maybe<Project>;
  /**
   * Project card referenced by this project event.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  projectCard?: Maybe<ProjectCard>;
  /**
   * Column name the issue or pull request was moved to.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  projectColumnName: Scalars['String']['output'];
};

/** The root query for implementing GraphQL mutations. */
export type Mutation = {
  __typename?: 'Mutation';
  /** Clear all of a customer's queued migrations */
  abortQueuedMigrations?: Maybe<AbortQueuedMigrationsPayload>;
  /** Abort a repository migration queued or in progress. */
  abortRepositoryMigration?: Maybe<AbortRepositoryMigrationPayload>;
  /** Accepts a pending invitation for a user to become an administrator of an enterprise. */
  acceptEnterpriseAdministratorInvitation?: Maybe<AcceptEnterpriseAdministratorInvitationPayload>;
  /** Accepts a pending invitation for a user to become an unaffiliated member of an enterprise. */
  acceptEnterpriseMemberInvitation?: Maybe<AcceptEnterpriseMemberInvitationPayload>;
  /** Applies a suggested topic to the repository. */
  acceptTopicSuggestion?: Maybe<AcceptTopicSuggestionPayload>;
  /** Access user namespace repository for a temporary duration. */
  accessUserNamespaceRepository?: Maybe<AccessUserNamespaceRepositoryPayload>;
  /** Adds assignees to an assignable object. */
  addAssigneesToAssignable?: Maybe<AddAssigneesToAssignablePayload>;
  /** Adds a 'blocked by' relationship to an issue. */
  addBlockedBy?: Maybe<AddBlockedByPayload>;
  /**
   * Adds one or more pull requests as manually linked closing references on an
   * issue. The target must be an issue, not a pull request.
   */
  addCloseIssueReferences?: Maybe<AddCloseIssueReferencesPayload>;
  /** Adds a comment to an Issue or Pull Request. */
  addComment?: Maybe<AddCommentPayload>;
  /** Adds a comment to a Discussion, possibly as a reply to another comment. */
  addDiscussionComment?: Maybe<AddDiscussionCommentPayload>;
  /** Vote for an option in a discussion poll. */
  addDiscussionPollVote?: Maybe<AddDiscussionPollVotePayload>;
  /** Adds enterprise members to an organization within the enterprise. */
  addEnterpriseOrganizationMember?: Maybe<AddEnterpriseOrganizationMemberPayload>;
  /** Adds a support entitlement to an enterprise member. */
  addEnterpriseSupportEntitlement?: Maybe<AddEnterpriseSupportEntitlementPayload>;
  /** Adds labels to a labelable object. */
  addLabelsToLabelable?: Maybe<AddLabelsToLabelablePayload>;
  /**
   * Adds a card to a ProjectColumn. Either `contentId` or `note` must be provided but **not** both.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  addProjectCard?: Maybe<AddProjectCardPayload>;
  /**
   * Adds a column to a Project.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  addProjectColumn?: Maybe<AddProjectColumnPayload>;
  /** Creates a new draft issue and add it to a Project. */
  addProjectV2DraftIssue?: Maybe<AddProjectV2DraftIssuePayload>;
  /** Links an existing content instance to a Project. */
  addProjectV2ItemById?: Maybe<AddProjectV2ItemByIdPayload>;
  /**
   * Add users to the pull request creation cap bypass list. Bypassed users can
   * create pull requests regardless of the configured cap. Only users with
   * maintainer permissions can manage the bypass list. You can add a maximum of
   * 100 users per request. The bypass list can only hold a maximum of 100 users.
   */
  addPullRequestCreationCapBypassUsers?: Maybe<AddPullRequestCreationCapBypassUsersPayload>;
  /** Adds a review to a Pull Request. */
  addPullRequestReview?: Maybe<AddPullRequestReviewPayload>;
  /** Adds a comment to a review. */
  addPullRequestReviewComment?: Maybe<AddPullRequestReviewCommentPayload>;
  /** Adds a new thread to a pending Pull Request Review. */
  addPullRequestReviewThread?: Maybe<AddPullRequestReviewThreadPayload>;
  /** Adds a reply to an existing Pull Request Review Thread. */
  addPullRequestReviewThreadReply?: Maybe<AddPullRequestReviewThreadReplyPayload>;
  /** Adds a reaction to a subject. */
  addReaction?: Maybe<AddReactionPayload>;
  /** Adds a 'relates to' relationship between two issues. */
  addRelatesTo?: Maybe<AddRelatesToPayload>;
  /** Adds a star to a Starrable. */
  addStar?: Maybe<AddStarPayload>;
  /** Adds a sub-issue to a given issue */
  addSubIssue?: Maybe<AddSubIssuePayload>;
  /** Add an upvote to a discussion or discussion comment. */
  addUpvote?: Maybe<AddUpvotePayload>;
  /** Adds a verifiable domain to an owning account. */
  addVerifiableDomain?: Maybe<AddVerifiableDomainPayload>;
  /** Applies a batch of pending issue suggestions to an issue. */
  applyPendingIssueSuggestions?: Maybe<ApplyPendingIssueSuggestionsPayload>;
  /** Approve all pending deployments under one or more environments */
  approveDeployments?: Maybe<ApproveDeploymentsPayload>;
  /** Approve a verifiable domain for notification delivery. */
  approveVerifiableDomain?: Maybe<ApproveVerifiableDomainPayload>;
  /** Archives a ProjectV2Item */
  archiveProjectV2Item?: Maybe<ArchiveProjectV2ItemPayload>;
  /**
   * Archive a pull request. Closes and marks the pull request as archived. Users
   * with the triage role or higher can archive pull requests.
   */
  archivePullRequest?: Maybe<ArchivePullRequestPayload>;
  /** Marks a repository as archived. */
  archiveRepository?: Maybe<ArchiveRepositoryPayload>;
  /** Cancels a pending invitation for an administrator to join an enterprise. */
  cancelEnterpriseAdminInvitation?: Maybe<CancelEnterpriseAdminInvitationPayload>;
  /** Cancels a pending invitation for an unaffiliated member to join an enterprise. */
  cancelEnterpriseMemberInvitation?: Maybe<CancelEnterpriseMemberInvitationPayload>;
  /** Cancel an active sponsorship. */
  cancelSponsorship?: Maybe<CancelSponsorshipPayload>;
  /** Update your status on GitHub. */
  changeUserStatus?: Maybe<ChangeUserStatusPayload>;
  /** Clears all labels from a labelable object. */
  clearLabelsFromLabelable?: Maybe<ClearLabelsFromLabelablePayload>;
  /**
   * This mutation clears the value of a field for an item in a Project. Currently
   * only text, number, date, assignees, labels, single-select, multi-select,
   * iteration and milestone fields are supported.
   */
  clearProjectV2ItemFieldValue?: Maybe<ClearProjectV2ItemFieldValuePayload>;
  /**
   * Creates a new project by cloning configuration from an existing project.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  cloneProject?: Maybe<CloneProjectPayload>;
  /** Create a new repository with the same files and directory structure as a template repository. */
  cloneTemplateRepository?: Maybe<CloneTemplateRepositoryPayload>;
  /** Close a discussion. */
  closeDiscussion?: Maybe<CloseDiscussionPayload>;
  /** Close an issue. */
  closeIssue?: Maybe<CloseIssuePayload>;
  /** Close a pull request. */
  closePullRequest?: Maybe<ClosePullRequestPayload>;
  /**
   * Convert a project note card to one associated with a newly created issue.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  convertProjectCardNoteToIssue?: Maybe<ConvertProjectCardNoteToIssuePayload>;
  /** Converts a projectV2 draft issue item to an issue. */
  convertProjectV2DraftIssueItemToIssue?: Maybe<ConvertProjectV2DraftIssueItemToIssuePayload>;
  /** Converts a pull request to draft */
  convertPullRequestToDraft?: Maybe<ConvertPullRequestToDraftPayload>;
  /** Copy a project. */
  copyProjectV2?: Maybe<CopyProjectV2Payload>;
  /** Invites a user to claim reattributable data */
  createAttributionInvitation?: Maybe<CreateAttributionInvitationPayload>;
  /** Create a new branch protection rule */
  createBranchProtectionRule?: Maybe<CreateBranchProtectionRulePayload>;
  /** Create a check run. */
  createCheckRun?: Maybe<CreateCheckRunPayload>;
  /** Create a check suite */
  createCheckSuite?: Maybe<CreateCheckSuitePayload>;
  /**
   * Appends a commit to the given branch as the authenticated user.
   *
   * This mutation creates a commit whose parent is the HEAD of the provided
   * branch and also updates that branch to point to the new commit.
   * It can be thought of as similar to `git commit`.
   *
   * ### Locating a Branch
   *
   * Commits are appended to a `branch` of type `Ref`.
   * This must refer to a git branch (i.e.  the fully qualified path must
   * begin with `refs/heads/`, although including this prefix is optional.
   *
   * Callers may specify the `branch` to commit to either by its global node
   * ID or by passing both of `repositoryNameWithOwner` and `refName`.  For
   * more details see the documentation for `CommittableBranch`.
   *
   * ### Describing Changes
   *
   * `fileChanges` are specified as a `FilesChanges` object describing
   * `FileAdditions` and `FileDeletions`.
   *
   * Please see the documentation for `FileChanges` for more information on
   * how to use this argument to describe any set of file changes.
   *
   * ### Authorship
   *
   * Similar to the web commit interface, this mutation does not support
   * specifying the author or committer of the commit and will not add
   * support for this in the future.
   *
   * A commit created by a successful execution of this mutation will be
   * authored by the owner of the credential which authenticates the API
   * request.  The committer will be identical to that of commits authored
   * using the web interface.
   *
   * If you need full control over author and committer information, please
   * use the Git Database REST API instead.
   *
   * ### Commit Signing
   *
   * Commits made using this mutation are automatically signed by GitHub if
   * supported and will be marked as verified in the user interface.
   */
  createCommitOnBranch?: Maybe<CreateCommitOnBranchPayload>;
  /** Creates a new deployment event. */
  createDeployment?: Maybe<CreateDeploymentPayload>;
  /** Create a deployment status. */
  createDeploymentStatus?: Maybe<CreateDeploymentStatusPayload>;
  /** Create a discussion. */
  createDiscussion?: Maybe<CreateDiscussionPayload>;
  /**
   * Creates an organization as part of an enterprise account. User-authenticated
   * requests make the viewer an owner. Users listed in `adminLogins` are invited
   * as owners unless owner invitations are disabled, in which case they are added
   * directly. Installation requests also add existing enterprise members directly.
   * Invitation failures do not roll back organization creation. A personal access
   * token used to create an organization is implicitly permitted to update the
   * organization it created, if the organization is part of an enterprise that has
   * SAML enabled or uses Enterprise Managed Users. If the organization is not part
   * of such an enterprise, and instead has SAML enabled for it individually, the
   * token will then require SAML authorization to continue working against that organization.
   */
  createEnterpriseOrganization?: Maybe<CreateEnterpriseOrganizationPayload>;
  /** Creates an environment or simply returns it if already exists. */
  createEnvironment?: Maybe<CreateEnvironmentPayload>;
  /** Creates a new IP allow list entry. */
  createIpAllowListEntry?: Maybe<CreateIpAllowListEntryPayload>;
  /** Creates a new issue. */
  createIssue?: Maybe<CreateIssuePayload>;
  /** Creates a new issue field. */
  createIssueField?: Maybe<CreateIssueFieldPayload>;
  /** Creates a new issue field value for an issue. */
  createIssueFieldValue?: Maybe<CreateIssueFieldValuePayload>;
  /** Creates a new issue type */
  createIssueType?: Maybe<CreateIssueTypePayload>;
  /** Creates a new label. */
  createLabel?: Maybe<CreateLabelPayload>;
  /** Create a branch linked to an issue. */
  createLinkedBranch?: Maybe<CreateLinkedBranchPayload>;
  /** Creates a GitHub Enterprise Importer (GEI) migration source. */
  createMigrationSource?: Maybe<CreateMigrationSourcePayload>;
  /**
   * Creates a new project.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  createProject?: Maybe<CreateProjectPayload>;
  /** Creates a new project. */
  createProjectV2?: Maybe<CreateProjectV2Payload>;
  /** Create a new project field. */
  createProjectV2Field?: Maybe<CreateProjectV2FieldPayload>;
  /** Create a new project issue field. */
  createProjectV2IssueField?: Maybe<CreateProjectV2IssueFieldPayload>;
  /** Creates a status update within a Project. */
  createProjectV2StatusUpdate?: Maybe<CreateProjectV2StatusUpdatePayload>;
  /** Creates a new view in a project. */
  createProjectV2View?: Maybe<CreateProjectV2ViewPayload>;
  /** Create a new pull request */
  createPullRequest?: Maybe<CreatePullRequestPayload>;
  /** Create a new Git Ref. */
  createRef?: Maybe<CreateRefPayload>;
  /** Create a new repository. */
  createRepository?: Maybe<CreateRepositoryPayload>;
  /** Create a repository custom property. */
  createRepositoryCustomProperty?: Maybe<CreateRepositoryCustomPropertyPayload>;
  /** Create a repository ruleset */
  createRepositoryRuleset?: Maybe<CreateRepositoryRulesetPayload>;
  /** Create a GitHub Sponsors profile to allow others to sponsor you or your organization. */
  createSponsorsListing?: Maybe<CreateSponsorsListingPayload>;
  /** Create a new payment tier for your GitHub Sponsors profile. */
  createSponsorsTier?: Maybe<CreateSponsorsTierPayload>;
  /** Start a new sponsorship of a maintainer in GitHub Sponsors, or reactivate a past sponsorship. */
  createSponsorship?: Maybe<CreateSponsorshipPayload>;
  /**
   * Make many sponsorships for different sponsorable users or organizations at
   * once. Can only sponsor those who have a public GitHub Sponsors profile.
   */
  createSponsorships?: Maybe<CreateSponsorshipsPayload>;
  /** Creates a new user list. */
  createUserList?: Maybe<CreateUserListPayload>;
  /** Rejects a suggested topic for the repository. */
  declineTopicSuggestion?: Maybe<DeclineTopicSuggestionPayload>;
  /** Delete a branch protection rule */
  deleteBranchProtectionRule?: Maybe<DeleteBranchProtectionRulePayload>;
  /** Deletes a deployment. */
  deleteDeployment?: Maybe<DeleteDeploymentPayload>;
  /** Delete a discussion and all of its replies. */
  deleteDiscussion?: Maybe<DeleteDiscussionPayload>;
  /** Delete a discussion comment. If it has replies, wipe it instead. */
  deleteDiscussionComment?: Maybe<DeleteDiscussionCommentPayload>;
  /** Deletes an environment */
  deleteEnvironment?: Maybe<DeleteEnvironmentPayload>;
  /** Deletes an IP allow list entry. */
  deleteIpAllowListEntry?: Maybe<DeleteIpAllowListEntryPayload>;
  /** Deletes an Issue object. */
  deleteIssue?: Maybe<DeleteIssuePayload>;
  /** Deletes an IssueComment object. */
  deleteIssueComment?: Maybe<DeleteIssueCommentPayload>;
  /** Deletes an issue field. */
  deleteIssueField?: Maybe<DeleteIssueFieldPayload>;
  /** Deletes an issue field value from an issue. */
  deleteIssueFieldValue?: Maybe<DeleteIssueFieldValuePayload>;
  /** Delete an issue type */
  deleteIssueType?: Maybe<DeleteIssueTypePayload>;
  /** Deletes a label. */
  deleteLabel?: Maybe<DeleteLabelPayload>;
  /** Unlink a branch from an issue. */
  deleteLinkedBranch?: Maybe<DeleteLinkedBranchPayload>;
  /** Delete a package version. */
  deletePackageVersion?: Maybe<DeletePackageVersionPayload>;
  /**
   * Deletes a project.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  deleteProject?: Maybe<DeleteProjectPayload>;
  /**
   * Deletes a project card.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  deleteProjectCard?: Maybe<DeleteProjectCardPayload>;
  /**
   * Deletes a project column.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  deleteProjectColumn?: Maybe<DeleteProjectColumnPayload>;
  /** Delete a project. */
  deleteProjectV2?: Maybe<DeleteProjectV2Payload>;
  /** Delete a project field. */
  deleteProjectV2Field?: Maybe<DeleteProjectV2FieldPayload>;
  /** Deletes an item from a Project. */
  deleteProjectV2Item?: Maybe<DeleteProjectV2ItemPayload>;
  /** Deletes a project status update. */
  deleteProjectV2StatusUpdate?: Maybe<DeleteProjectV2StatusUpdatePayload>;
  /** Deletes a view from a project. */
  deleteProjectV2View?: Maybe<DeleteProjectV2ViewPayload>;
  /** Deletes a project workflow. */
  deleteProjectV2Workflow?: Maybe<DeleteProjectV2WorkflowPayload>;
  /** Deletes a pull request review. */
  deletePullRequestReview?: Maybe<DeletePullRequestReviewPayload>;
  /** Deletes a pull request review comment. */
  deletePullRequestReviewComment?: Maybe<DeletePullRequestReviewCommentPayload>;
  /** Delete a Git Ref. */
  deleteRef?: Maybe<DeleteRefPayload>;
  /** Delete a repository custom property. */
  deleteRepositoryCustomProperty?: Maybe<DeleteRepositoryCustomPropertyPayload>;
  /** Delete a repository ruleset */
  deleteRepositoryRuleset?: Maybe<DeleteRepositoryRulesetPayload>;
  /** Deletes a user list. */
  deleteUserList?: Maybe<DeleteUserListPayload>;
  /** Deletes a verifiable domain. */
  deleteVerifiableDomain?: Maybe<DeleteVerifiableDomainPayload>;
  /** Remove a pull request from the merge queue. */
  dequeuePullRequest?: Maybe<DequeuePullRequestPayload>;
  /** Disable auto merge on the given pull request */
  disablePullRequestAutoMerge?: Maybe<DisablePullRequestAutoMergePayload>;
  /** Dismisses an approved or rejected pull request review. */
  dismissPullRequestReview?: Maybe<DismissPullRequestReviewPayload>;
  /** Dismisses the Dependabot alert. */
  dismissRepositoryVulnerabilityAlert?: Maybe<DismissRepositoryVulnerabilityAlertPayload>;
  /** Enable the default auto-merge on a pull request. */
  enablePullRequestAutoMerge?: Maybe<EnablePullRequestAutoMergePayload>;
  /** Add a pull request to the merge queue. */
  enqueuePullRequest?: Maybe<EnqueuePullRequestPayload>;
  /** Follow an organization. */
  followOrganization?: Maybe<FollowOrganizationPayload>;
  /** Follow a user. */
  followUser?: Maybe<FollowUserPayload>;
  /** Grant the migrator role to a user for all organizations under an enterprise account. */
  grantEnterpriseOrganizationsMigratorRole?: Maybe<GrantEnterpriseOrganizationsMigratorRolePayload>;
  /** Grant the migrator role to a user or a team. */
  grantMigratorRole?: Maybe<GrantMigratorRolePayload>;
  /**
   * Creates a new project by importing columns and a list of issues/PRs.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  importProject?: Maybe<ImportProjectPayload>;
  /** Invite someone to become an administrator of the enterprise. */
  inviteEnterpriseAdmin?: Maybe<InviteEnterpriseAdminPayload>;
  /** Invite someone to become an unaffiliated member of the enterprise. */
  inviteEnterpriseMember?: Maybe<InviteEnterpriseMemberPayload>;
  /** Links a project to a repository. */
  linkProjectV2ToRepository?: Maybe<LinkProjectV2ToRepositoryPayload>;
  /** Links a project to a team. */
  linkProjectV2ToTeam?: Maybe<LinkProjectV2ToTeamPayload>;
  /**
   * Creates a repository link for a project.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  linkRepositoryToProject?: Maybe<LinkRepositoryToProjectPayload>;
  /** Lock a lockable object */
  lockLockable?: Maybe<LockLockablePayload>;
  /** Mark a discussion comment as the chosen answer for discussions in an answerable category. */
  markDiscussionCommentAsAnswer?: Maybe<MarkDiscussionCommentAsAnswerPayload>;
  /** Mark a pull request file as viewed */
  markFileAsViewed?: Maybe<MarkFileAsViewedPayload>;
  /** Mark a project as a template. Note that only projects which are owned by an Organization can be marked as a template. */
  markProjectV2AsTemplate?: Maybe<MarkProjectV2AsTemplatePayload>;
  /** Marks a pull request ready for review. */
  markPullRequestReadyForReview?: Maybe<MarkPullRequestReadyForReviewPayload>;
  /** Merge a head into a branch. */
  mergeBranch?: Maybe<MergeBranchPayload>;
  /**
   * Merge a pull request.
   *
   * > [!NOTE]
   * > We recommend using the [asynchronous merge REST
   * API](${externalDocsUrl}/rest/pulls/pulls#merge-a-pull-request-asynchronously) instead.
   * > This mutation does not support stacked pull requests.
   */
  mergePullRequest?: Maybe<MergePullRequestPayload>;
  /** Minimizes a comment on an Issue, Commit, Pull Request, or Gist */
  minimizeComment?: Maybe<MinimizeCommentPayload>;
  /**
   * Moves a project card to another place.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  moveProjectCard?: Maybe<MoveProjectCardPayload>;
  /**
   * Moves a project column to another place.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  moveProjectColumn?: Maybe<MoveProjectColumnPayload>;
  /** Pin an environment to a repository */
  pinEnvironment?: Maybe<PinEnvironmentPayload>;
  /** Pin an issue to a repository */
  pinIssue?: Maybe<PinIssuePayload>;
  /** Pins an Issue Comment. */
  pinIssueComment?: Maybe<PinIssueCommentPayload>;
  /** Promote a repository custom property to the enterprise level. */
  promoteRepositoryCustomProperty?: Maybe<PromoteRepositoryCustomPropertyPayload>;
  /** Publish an existing sponsorship tier that is currently still a draft to a GitHub Sponsors profile. */
  publishSponsorsTier?: Maybe<PublishSponsorsTierPayload>;
  /** Regenerates the identity provider recovery codes for an enterprise */
  regenerateEnterpriseIdentityProviderRecoveryCodes?: Maybe<RegenerateEnterpriseIdentityProviderRecoveryCodesPayload>;
  /** Regenerates a verifiable domain's verification token. */
  regenerateVerifiableDomainToken?: Maybe<RegenerateVerifiableDomainTokenPayload>;
  /** Reject all pending deployments under one or more environments */
  rejectDeployments?: Maybe<RejectDeploymentsPayload>;
  /** Rejects a batch of pending issue suggestions on an issue atomically. */
  rejectPendingIssueSuggestions?: Maybe<RejectPendingIssueSuggestionsPayload>;
  /** Removes assignees from an assignable object. */
  removeAssigneesFromAssignable?: Maybe<RemoveAssigneesFromAssignablePayload>;
  /** Removes a 'blocked by' relationship from an issue. */
  removeBlockedBy?: Maybe<RemoveBlockedByPayload>;
  /**
   * Removes one or more manually linked pull requests from an issue. Auto-detected
   * closing references from pull request body keywords are not removed; edit the
   * pull request body instead.
   */
  removeCloseIssueReferences?: Maybe<RemoveCloseIssueReferencesPayload>;
  /** Removes an administrator from the enterprise. */
  removeEnterpriseAdmin?: Maybe<RemoveEnterpriseAdminPayload>;
  /**
   * Removes the identity provider from an enterprise. Owners of enterprises both
   * with and without Enterprise Managed Users may use this mutation.
   */
  removeEnterpriseIdentityProvider?: Maybe<RemoveEnterpriseIdentityProviderPayload>;
  /** Completely removes a user from the enterprise asynchronously. */
  removeEnterpriseMember?: Maybe<RemoveEnterpriseMemberPayload>;
  /** Removes an organization from the enterprise */
  removeEnterpriseOrganization?: Maybe<RemoveEnterpriseOrganizationPayload>;
  /** Removes a support entitlement from an enterprise member. */
  removeEnterpriseSupportEntitlement?: Maybe<RemoveEnterpriseSupportEntitlementPayload>;
  /** Removes labels from a Labelable object. */
  removeLabelsFromLabelable?: Maybe<RemoveLabelsFromLabelablePayload>;
  /** Removes outside collaborator from all repositories in an organization. */
  removeOutsideCollaborator?: Maybe<RemoveOutsideCollaboratorPayload>;
  /**
   * Remove users from the pull request creation cap bypass list. Only users with
   * maintainer permissions can manage the bypass list.
   */
  removePullRequestCreationCapBypassUsers?: Maybe<RemovePullRequestCreationCapBypassUsersPayload>;
  /** Removes a reaction from a subject. */
  removeReaction?: Maybe<RemoveReactionPayload>;
  /** Removes a 'relates to' relationship between two issues. */
  removeRelatesTo?: Maybe<RemoveRelatesToPayload>;
  /** Removes a star from a Starrable. */
  removeStar?: Maybe<RemoveStarPayload>;
  /** Removes a sub-issue from a given issue */
  removeSubIssue?: Maybe<RemoveSubIssuePayload>;
  /** Remove an upvote to a discussion or discussion comment. */
  removeUpvote?: Maybe<RemoveUpvotePayload>;
  /** Reopen a discussion. */
  reopenDiscussion?: Maybe<ReopenDiscussionPayload>;
  /** Reopen a issue. */
  reopenIssue?: Maybe<ReopenIssuePayload>;
  /** Reopen a pull request. */
  reopenPullRequest?: Maybe<ReopenPullRequestPayload>;
  /** Reorder a pinned repository environment */
  reorderEnvironment?: Maybe<ReorderEnvironmentPayload>;
  /** Replaces all actors for assignable object. */
  replaceActorsForAssignable?: Maybe<ReplaceActorsForAssignablePayload>;
  /** Reprioritizes a sub-issue to a different position in the parent list. */
  reprioritizeSubIssue?: Maybe<ReprioritizeSubIssuePayload>;
  /** Set review requests on a pull request. */
  requestReviews?: Maybe<RequestReviewsPayload>;
  /** Set review requests on a pull request using login strings instead of IDs. */
  requestReviewsByLogin?: Maybe<RequestReviewsByLoginPayload>;
  /** Rerequests an existing check suite. */
  rerequestCheckSuite?: Maybe<RerequestCheckSuitePayload>;
  /** Rerequest reviews on a pull request. */
  rerequestReviews?: Maybe<RerequestReviewsPayload>;
  /** Marks a review thread as resolved. */
  resolveReviewThread?: Maybe<ResolveReviewThreadPayload>;
  /** Retire a published payment tier from your GitHub Sponsors profile so it cannot be used to start new sponsorships. */
  retireSponsorsTier?: Maybe<RetireSponsorsTierPayload>;
  /** Create a pull request that reverts the changes from a merged pull request. */
  revertPullRequest?: Maybe<RevertPullRequestPayload>;
  /** Revoke the migrator role to a user for all organizations under an enterprise account. */
  revokeEnterpriseOrganizationsMigratorRole?: Maybe<RevokeEnterpriseOrganizationsMigratorRolePayload>;
  /** Revoke the migrator role from a user or a team. */
  revokeMigratorRole?: Maybe<RevokeMigratorRolePayload>;
  /** Creates or updates the identity provider for an enterprise. */
  setEnterpriseIdentityProvider?: Maybe<SetEnterpriseIdentityProviderPayload>;
  /** Sets the value of an IssueFieldValue. */
  setIssueFieldValue?: Maybe<SetIssueFieldValuePayload>;
  /** Set an organization level interaction limit for an organization's public repositories. */
  setOrganizationInteractionLimit?: Maybe<SetOrganizationInteractionLimitPayload>;
  /** Set repository custom property values for a repository. */
  setRepositoryCustomPropertyValues?: Maybe<SetRepositoryCustomPropertyValuesPayload>;
  /** Sets an interaction limit setting for a repository. */
  setRepositoryInteractionLimit?: Maybe<SetRepositoryInteractionLimitPayload>;
  /** Set a user level interaction limit for an user's public repositories. */
  setUserInteractionLimit?: Maybe<SetUserInteractionLimitPayload>;
  /** Starts a GitHub Enterprise Importer organization migration. */
  startOrganizationMigration?: Maybe<StartOrganizationMigrationPayload>;
  /** Starts a GitHub Enterprise Importer (GEI) repository migration. */
  startRepositoryMigration?: Maybe<StartRepositoryMigrationPayload>;
  /** Submits a pending pull request review. */
  submitPullRequestReview?: Maybe<SubmitPullRequestReviewPayload>;
  /** Transfer an organization from one enterprise to another enterprise. */
  transferEnterpriseOrganization?: Maybe<TransferEnterpriseOrganizationPayload>;
  /** Transfer an issue to a different repository */
  transferIssue?: Maybe<TransferIssuePayload>;
  /** Unarchives a ProjectV2Item */
  unarchiveProjectV2Item?: Maybe<UnarchiveProjectV2ItemPayload>;
  /**
   * Unarchive a pull request. Removes the archived flag from the pull request.
   * Does not automatically reopen or unlock the pull request. Users with the
   * triage role or higher can unarchive pull requests.
   */
  unarchivePullRequest?: Maybe<UnarchivePullRequestPayload>;
  /** Unarchives a repository. */
  unarchiveRepository?: Maybe<UnarchiveRepositoryPayload>;
  /** Unfollow an organization. */
  unfollowOrganization?: Maybe<UnfollowOrganizationPayload>;
  /** Unfollow a user. */
  unfollowUser?: Maybe<UnfollowUserPayload>;
  /** Unlinks a project from a repository. */
  unlinkProjectV2FromRepository?: Maybe<UnlinkProjectV2FromRepositoryPayload>;
  /** Unlinks a project to a team. */
  unlinkProjectV2FromTeam?: Maybe<UnlinkProjectV2FromTeamPayload>;
  /**
   * Deletes a repository link from a project.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  unlinkRepositoryFromProject?: Maybe<UnlinkRepositoryFromProjectPayload>;
  /** Unlock a lockable object */
  unlockLockable?: Maybe<UnlockLockablePayload>;
  /** Unmark a discussion comment as the chosen answer for discussions in an answerable category. */
  unmarkDiscussionCommentAsAnswer?: Maybe<UnmarkDiscussionCommentAsAnswerPayload>;
  /** Unmark a pull request file as viewed */
  unmarkFileAsViewed?: Maybe<UnmarkFileAsViewedPayload>;
  /** Unmark an issue as a duplicate of another issue. */
  unmarkIssueAsDuplicate?: Maybe<UnmarkIssueAsDuplicatePayload>;
  /** Unmark a project as a template. */
  unmarkProjectV2AsTemplate?: Maybe<UnmarkProjectV2AsTemplatePayload>;
  /** Unminimizes a comment on an Issue, Commit, Pull Request, or Gist */
  unminimizeComment?: Maybe<UnminimizeCommentPayload>;
  /** Unpin a pinned issue from a repository */
  unpinIssue?: Maybe<UnpinIssuePayload>;
  /** Unpins an Issue Comment. */
  unpinIssueComment?: Maybe<UnpinIssueCommentPayload>;
  /** Marks a review thread as unresolved. */
  unresolveReviewThread?: Maybe<UnresolveReviewThreadPayload>;
  /** Update a branch protection rule */
  updateBranchProtectionRule?: Maybe<UpdateBranchProtectionRulePayload>;
  /** Update a check run */
  updateCheckRun?: Maybe<UpdateCheckRunPayload>;
  /** Modifies the settings of an existing check suite */
  updateCheckSuitePreferences?: Maybe<UpdateCheckSuitePreferencesPayload>;
  /** Update a discussion */
  updateDiscussion?: Maybe<UpdateDiscussionPayload>;
  /** Update the contents of a comment on a Discussion */
  updateDiscussionComment?: Maybe<UpdateDiscussionCommentPayload>;
  /** Updates the role of an enterprise administrator. */
  updateEnterpriseAdministratorRole?: Maybe<UpdateEnterpriseAdministratorRolePayload>;
  /** Sets whether private repository forks are enabled for an enterprise. */
  updateEnterpriseAllowPrivateRepositoryForkingSetting?: Maybe<UpdateEnterpriseAllowPrivateRepositoryForkingSettingPayload>;
  /** Sets the base repository permission for organizations in an enterprise. */
  updateEnterpriseDefaultRepositoryPermissionSetting?: Maybe<UpdateEnterpriseDefaultRepositoryPermissionSettingPayload>;
  /** Sets whether deploy keys are allowed to be created and used for an enterprise. */
  updateEnterpriseDeployKeySetting?: Maybe<UpdateEnterpriseDeployKeySettingPayload>;
  /** Sets whether organization members with admin permissions on a repository can change repository visibility. */
  updateEnterpriseMembersCanChangeRepositoryVisibilitySetting?: Maybe<UpdateEnterpriseMembersCanChangeRepositoryVisibilitySettingPayload>;
  /** Sets the members can create repositories setting for an enterprise. */
  updateEnterpriseMembersCanCreateRepositoriesSetting?: Maybe<UpdateEnterpriseMembersCanCreateRepositoriesSettingPayload>;
  /** Sets the members can delete issues setting for an enterprise. */
  updateEnterpriseMembersCanDeleteIssuesSetting?: Maybe<UpdateEnterpriseMembersCanDeleteIssuesSettingPayload>;
  /** Sets the members can delete repositories setting for an enterprise. */
  updateEnterpriseMembersCanDeleteRepositoriesSetting?: Maybe<UpdateEnterpriseMembersCanDeleteRepositoriesSettingPayload>;
  /** Sets whether members can invite collaborators are enabled for an enterprise. */
  updateEnterpriseMembersCanInviteCollaboratorsSetting?: Maybe<UpdateEnterpriseMembersCanInviteCollaboratorsSettingPayload>;
  /** Sets whether or not an organization owner can make purchases. */
  updateEnterpriseMembersCanMakePurchasesSetting?: Maybe<UpdateEnterpriseMembersCanMakePurchasesSettingPayload>;
  /** Sets the members can update protected branches setting for an enterprise. */
  updateEnterpriseMembersCanUpdateProtectedBranchesSetting?: Maybe<UpdateEnterpriseMembersCanUpdateProtectedBranchesSettingPayload>;
  /** Sets the members can view dependency insights for an enterprise. */
  updateEnterpriseMembersCanViewDependencyInsightsSetting?: Maybe<UpdateEnterpriseMembersCanViewDependencyInsightsSettingPayload>;
  /** Sets whether organization projects are enabled for an enterprise. */
  updateEnterpriseOrganizationProjectsSetting?: Maybe<UpdateEnterpriseOrganizationProjectsSettingPayload>;
  /** Updates the role of an enterprise owner with an organization. */
  updateEnterpriseOwnerOrganizationRole?: Maybe<UpdateEnterpriseOwnerOrganizationRolePayload>;
  /** Updates an enterprise's profile. */
  updateEnterpriseProfile?: Maybe<UpdateEnterpriseProfilePayload>;
  /** Sets whether repository projects are enabled for a enterprise. */
  updateEnterpriseRepositoryProjectsSetting?: Maybe<UpdateEnterpriseRepositoryProjectsSettingPayload>;
  /** Sets the two-factor authentication methods that users of an enterprise may not use. */
  updateEnterpriseTwoFactorAuthenticationDisallowedMethodsSetting?: Maybe<UpdateEnterpriseTwoFactorAuthenticationDisallowedMethodsSettingPayload>;
  /** Sets whether two factor authentication is required for all users in an enterprise. */
  updateEnterpriseTwoFactorAuthenticationRequiredSetting?: Maybe<UpdateEnterpriseTwoFactorAuthenticationRequiredSettingPayload>;
  /** Updates an environment. */
  updateEnvironment?: Maybe<UpdateEnvironmentPayload>;
  /** Sets whether an IP allow list is enabled on an owner. */
  updateIpAllowListEnabledSetting?: Maybe<UpdateIpAllowListEnabledSettingPayload>;
  /** Updates an IP allow list entry. */
  updateIpAllowListEntry?: Maybe<UpdateIpAllowListEntryPayload>;
  /** Sets whether IP allow list configuration for installed GitHub Apps is enabled on an owner. */
  updateIpAllowListForInstalledAppsEnabledSetting?: Maybe<UpdateIpAllowListForInstalledAppsEnabledSettingPayload>;
  /** Sets whether IP allow list user-level enforcement is enabled on an enterprise. */
  updateIpAllowListUserLevelEnforcementEnabledSetting?: Maybe<UpdateIpAllowListUserLevelEnforcementEnabledSettingPayload>;
  /** Updates an Issue. */
  updateIssue?: Maybe<UpdateIssuePayload>;
  /** Updates an IssueComment object. */
  updateIssueComment?: Maybe<UpdateIssueCommentPayload>;
  /** Updates an issue field. */
  updateIssueField?: Maybe<UpdateIssueFieldPayload>;
  /** Updates an existing issue field value for an issue. */
  updateIssueFieldValue?: Maybe<UpdateIssueFieldValuePayload>;
  /** Updates the issue type on an issue */
  updateIssueIssueType?: Maybe<UpdateIssueIssueTypePayload>;
  /** Update an issue type */
  updateIssueType?: Maybe<UpdateIssueTypePayload>;
  /** Updates an existing label. */
  updateLabel?: Maybe<UpdateLabelPayload>;
  /** Update the setting to restrict notifications to only verified or approved domains available to an owner. */
  updateNotificationRestrictionSetting?: Maybe<UpdateNotificationRestrictionSettingPayload>;
  /** Sets whether private repository forks are enabled for an organization. */
  updateOrganizationAllowPrivateRepositoryForkingSetting?: Maybe<UpdateOrganizationAllowPrivateRepositoryForkingSettingPayload>;
  /** Sets whether contributors are required to sign off on web-based commits for repositories in an organization. */
  updateOrganizationWebCommitSignoffSetting?: Maybe<UpdateOrganizationWebCommitSignoffSettingPayload>;
  /**
   * Toggle the setting for your GitHub Sponsors profile that allows other GitHub
   * accounts to sponsor you on GitHub while paying for the sponsorship on Patreon.
   * Only applicable when you have a GitHub Sponsors profile and have connected
   * your GitHub account with Patreon.
   */
  updatePatreonSponsorability?: Maybe<UpdatePatreonSponsorabilityPayload>;
  /**
   * Updates an existing project.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  updateProject?: Maybe<UpdateProjectPayload>;
  /**
   * Updates an existing project card.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  updateProjectCard?: Maybe<UpdateProjectCardPayload>;
  /**
   * Updates an existing project column.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  updateProjectColumn?: Maybe<UpdateProjectColumnPayload>;
  /** Updates an existing project. */
  updateProjectV2?: Maybe<UpdateProjectV2Payload>;
  /** Update the collaborators on a team or a project */
  updateProjectV2Collaborators?: Maybe<UpdateProjectV2CollaboratorsPayload>;
  /** Updates a draft issue within a Project. */
  updateProjectV2DraftIssue?: Maybe<UpdateProjectV2DraftIssuePayload>;
  /** Update a project field. */
  updateProjectV2Field?: Maybe<UpdateProjectV2FieldPayload>;
  /**
   * This mutation updates the value of a field for an item in a Project. Currently
   * only single-select, multi-select, text, number, date, and iteration fields are supported.
   */
  updateProjectV2ItemFieldValue?: Maybe<UpdateProjectV2ItemFieldValuePayload>;
  /** This mutation updates the position of the item in the project, where the position represents the priority of an item. */
  updateProjectV2ItemPosition?: Maybe<UpdateProjectV2ItemPositionPayload>;
  /** Updates a status update within a Project. */
  updateProjectV2StatusUpdate?: Maybe<UpdateProjectV2StatusUpdatePayload>;
  /** Updates an existing view in a project. */
  updateProjectV2View?: Maybe<UpdateProjectV2ViewPayload>;
  /** Update a pull request */
  updatePullRequest?: Maybe<UpdatePullRequestPayload>;
  /** Merge or Rebase HEAD from upstream branch into pull request branch */
  updatePullRequestBranch?: Maybe<UpdatePullRequestBranchPayload>;
  /** Updates the body of a pull request review. */
  updatePullRequestReview?: Maybe<UpdatePullRequestReviewPayload>;
  /** Updates a pull request review comment. */
  updatePullRequestReviewComment?: Maybe<UpdatePullRequestReviewCommentPayload>;
  /** Update a Git Ref. */
  updateRef?: Maybe<UpdateRefPayload>;
  /**
   * Creates, updates and/or deletes multiple refs in a repository.
   *
   * This mutation takes a list of `RefUpdate`s and performs these updates
   * on the repository. All updates are performed atomically, meaning that
   * if one of them is rejected, no other ref will be modified.
   *
   * `RefUpdate.beforeOid` specifies that the given reference needs to point
   * to the given value before performing any updates. A value of
   * `0000000000000000000000000000000000000000` can be used to verify that
   * the references should not exist.
   *
   * `RefUpdate.afterOid` specifies the value that the given reference
   * will point to after performing all updates. A value of
   * `0000000000000000000000000000000000000000` can be used to delete a
   * reference.
   *
   * If `RefUpdate.force` is set to `true`, a non-fast-forward updates
   * for the given reference will be allowed.
   */
  updateRefs?: Maybe<UpdateRefsPayload>;
  /** Update information about a repository. */
  updateRepository?: Maybe<UpdateRepositoryPayload>;
  /** Update a repository custom property. */
  updateRepositoryCustomProperty?: Maybe<UpdateRepositoryCustomPropertyPayload>;
  /** Update a repository ruleset */
  updateRepositoryRuleset?: Maybe<UpdateRepositoryRulesetPayload>;
  /** Sets whether contributors are required to sign off on web-based commits for a repository. */
  updateRepositoryWebCommitSignoffSetting?: Maybe<UpdateRepositoryWebCommitSignoffSettingPayload>;
  /** Change visibility of your sponsorship and opt in or out of email updates from the maintainer. */
  updateSponsorshipPreferences?: Maybe<UpdateSponsorshipPreferencesPayload>;
  /** Updates the state for subscribable subjects. */
  updateSubscription?: Maybe<UpdateSubscriptionPayload>;
  /** Updates team review assignment. */
  updateTeamReviewAssignment?: Maybe<UpdateTeamReviewAssignmentPayload>;
  /** Update team repository. */
  updateTeamsRepository?: Maybe<UpdateTeamsRepositoryPayload>;
  /** Replaces the repository's topics with the given topics. */
  updateTopics?: Maybe<UpdateTopicsPayload>;
  /** Updates an existing user list. */
  updateUserList?: Maybe<UpdateUserListPayload>;
  /** Updates which of the viewer's lists an item belongs to */
  updateUserListsForItem?: Maybe<UpdateUserListsForItemPayload>;
  /** Verify that a verifiable domain has the expected DNS record. */
  verifyVerifiableDomain?: Maybe<VerifyVerifiableDomainPayload>;
};


/** The root query for implementing GraphQL mutations. */
export type MutationAbortQueuedMigrationsArgs = {
  input: AbortQueuedMigrationsInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationAbortRepositoryMigrationArgs = {
  input: AbortRepositoryMigrationInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationAcceptEnterpriseAdministratorInvitationArgs = {
  input: AcceptEnterpriseAdministratorInvitationInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationAcceptEnterpriseMemberInvitationArgs = {
  input: AcceptEnterpriseMemberInvitationInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationAcceptTopicSuggestionArgs = {
  input: AcceptTopicSuggestionInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationAccessUserNamespaceRepositoryArgs = {
  input: AccessUserNamespaceRepositoryInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationAddAssigneesToAssignableArgs = {
  input: AddAssigneesToAssignableInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationAddBlockedByArgs = {
  input: AddBlockedByInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationAddCloseIssueReferencesArgs = {
  input: AddCloseIssueReferencesInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationAddCommentArgs = {
  input: AddCommentInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationAddDiscussionCommentArgs = {
  input: AddDiscussionCommentInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationAddDiscussionPollVoteArgs = {
  input: AddDiscussionPollVoteInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationAddEnterpriseOrganizationMemberArgs = {
  input: AddEnterpriseOrganizationMemberInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationAddEnterpriseSupportEntitlementArgs = {
  input: AddEnterpriseSupportEntitlementInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationAddLabelsToLabelableArgs = {
  input: AddLabelsToLabelableInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationAddProjectCardArgs = {
  input: AddProjectCardInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationAddProjectColumnArgs = {
  input: AddProjectColumnInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationAddProjectV2DraftIssueArgs = {
  input: AddProjectV2DraftIssueInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationAddProjectV2ItemByIdArgs = {
  input: AddProjectV2ItemByIdInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationAddPullRequestCreationCapBypassUsersArgs = {
  input: AddPullRequestCreationCapBypassUsersInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationAddPullRequestReviewArgs = {
  input: AddPullRequestReviewInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationAddPullRequestReviewCommentArgs = {
  input: AddPullRequestReviewCommentInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationAddPullRequestReviewThreadArgs = {
  input: AddPullRequestReviewThreadInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationAddPullRequestReviewThreadReplyArgs = {
  input: AddPullRequestReviewThreadReplyInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationAddReactionArgs = {
  input: AddReactionInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationAddRelatesToArgs = {
  input: AddRelatesToInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationAddStarArgs = {
  input: AddStarInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationAddSubIssueArgs = {
  input: AddSubIssueInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationAddUpvoteArgs = {
  input: AddUpvoteInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationAddVerifiableDomainArgs = {
  input: AddVerifiableDomainInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationApplyPendingIssueSuggestionsArgs = {
  input: ApplyPendingIssueSuggestionsInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationApproveDeploymentsArgs = {
  input: ApproveDeploymentsInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationApproveVerifiableDomainArgs = {
  input: ApproveVerifiableDomainInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationArchiveProjectV2ItemArgs = {
  input: ArchiveProjectV2ItemInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationArchivePullRequestArgs = {
  input: ArchivePullRequestInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationArchiveRepositoryArgs = {
  input: ArchiveRepositoryInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCancelEnterpriseAdminInvitationArgs = {
  input: CancelEnterpriseAdminInvitationInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCancelEnterpriseMemberInvitationArgs = {
  input: CancelEnterpriseMemberInvitationInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCancelSponsorshipArgs = {
  input: CancelSponsorshipInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationChangeUserStatusArgs = {
  input: ChangeUserStatusInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationClearLabelsFromLabelableArgs = {
  input: ClearLabelsFromLabelableInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationClearProjectV2ItemFieldValueArgs = {
  input: ClearProjectV2ItemFieldValueInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCloneProjectArgs = {
  input: CloneProjectInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCloneTemplateRepositoryArgs = {
  input: CloneTemplateRepositoryInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCloseDiscussionArgs = {
  input: CloseDiscussionInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCloseIssueArgs = {
  input: CloseIssueInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationClosePullRequestArgs = {
  input: ClosePullRequestInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationConvertProjectCardNoteToIssueArgs = {
  input: ConvertProjectCardNoteToIssueInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationConvertProjectV2DraftIssueItemToIssueArgs = {
  input: ConvertProjectV2DraftIssueItemToIssueInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationConvertPullRequestToDraftArgs = {
  input: ConvertPullRequestToDraftInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCopyProjectV2Args = {
  input: CopyProjectV2Input;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateAttributionInvitationArgs = {
  input: CreateAttributionInvitationInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateBranchProtectionRuleArgs = {
  input: CreateBranchProtectionRuleInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateCheckRunArgs = {
  input: CreateCheckRunInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateCheckSuiteArgs = {
  input: CreateCheckSuiteInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateCommitOnBranchArgs = {
  input: CreateCommitOnBranchInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateDeploymentArgs = {
  input: CreateDeploymentInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateDeploymentStatusArgs = {
  input: CreateDeploymentStatusInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateDiscussionArgs = {
  input: CreateDiscussionInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateEnterpriseOrganizationArgs = {
  input: CreateEnterpriseOrganizationInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateEnvironmentArgs = {
  input: CreateEnvironmentInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateIpAllowListEntryArgs = {
  input: CreateIpAllowListEntryInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateIssueArgs = {
  input: CreateIssueInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateIssueFieldArgs = {
  input: CreateIssueFieldInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateIssueFieldValueArgs = {
  input: CreateIssueFieldValueInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateIssueTypeArgs = {
  input: CreateIssueTypeInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateLabelArgs = {
  input: CreateLabelInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateLinkedBranchArgs = {
  input: CreateLinkedBranchInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateMigrationSourceArgs = {
  input: CreateMigrationSourceInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateProjectArgs = {
  input: CreateProjectInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateProjectV2Args = {
  input: CreateProjectV2Input;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateProjectV2FieldArgs = {
  input: CreateProjectV2FieldInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateProjectV2IssueFieldArgs = {
  input: CreateProjectV2IssueFieldInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateProjectV2StatusUpdateArgs = {
  input: CreateProjectV2StatusUpdateInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateProjectV2ViewArgs = {
  input: CreateProjectV2ViewInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreatePullRequestArgs = {
  input: CreatePullRequestInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateRefArgs = {
  input: CreateRefInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateRepositoryArgs = {
  input: CreateRepositoryInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateRepositoryCustomPropertyArgs = {
  input: CreateRepositoryCustomPropertyInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateRepositoryRulesetArgs = {
  input: CreateRepositoryRulesetInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateSponsorsListingArgs = {
  input: CreateSponsorsListingInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateSponsorsTierArgs = {
  input: CreateSponsorsTierInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateSponsorshipArgs = {
  input: CreateSponsorshipInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateSponsorshipsArgs = {
  input: CreateSponsorshipsInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationCreateUserListArgs = {
  input: CreateUserListInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDeclineTopicSuggestionArgs = {
  input: DeclineTopicSuggestionInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDeleteBranchProtectionRuleArgs = {
  input: DeleteBranchProtectionRuleInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDeleteDeploymentArgs = {
  input: DeleteDeploymentInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDeleteDiscussionArgs = {
  input: DeleteDiscussionInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDeleteDiscussionCommentArgs = {
  input: DeleteDiscussionCommentInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDeleteEnvironmentArgs = {
  input: DeleteEnvironmentInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDeleteIpAllowListEntryArgs = {
  input: DeleteIpAllowListEntryInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDeleteIssueArgs = {
  input: DeleteIssueInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDeleteIssueCommentArgs = {
  input: DeleteIssueCommentInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDeleteIssueFieldArgs = {
  input: DeleteIssueFieldInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDeleteIssueFieldValueArgs = {
  input: DeleteIssueFieldValueInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDeleteIssueTypeArgs = {
  input: DeleteIssueTypeInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDeleteLabelArgs = {
  input: DeleteLabelInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDeleteLinkedBranchArgs = {
  input: DeleteLinkedBranchInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDeletePackageVersionArgs = {
  input: DeletePackageVersionInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDeleteProjectArgs = {
  input: DeleteProjectInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDeleteProjectCardArgs = {
  input: DeleteProjectCardInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDeleteProjectColumnArgs = {
  input: DeleteProjectColumnInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDeleteProjectV2Args = {
  input: DeleteProjectV2Input;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDeleteProjectV2FieldArgs = {
  input: DeleteProjectV2FieldInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDeleteProjectV2ItemArgs = {
  input: DeleteProjectV2ItemInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDeleteProjectV2StatusUpdateArgs = {
  input: DeleteProjectV2StatusUpdateInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDeleteProjectV2ViewArgs = {
  input: DeleteProjectV2ViewInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDeleteProjectV2WorkflowArgs = {
  input: DeleteProjectV2WorkflowInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDeletePullRequestReviewArgs = {
  input: DeletePullRequestReviewInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDeletePullRequestReviewCommentArgs = {
  input: DeletePullRequestReviewCommentInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDeleteRefArgs = {
  input: DeleteRefInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDeleteRepositoryCustomPropertyArgs = {
  input: DeleteRepositoryCustomPropertyInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDeleteRepositoryRulesetArgs = {
  input: DeleteRepositoryRulesetInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDeleteUserListArgs = {
  input: DeleteUserListInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDeleteVerifiableDomainArgs = {
  input: DeleteVerifiableDomainInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDequeuePullRequestArgs = {
  input: DequeuePullRequestInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDisablePullRequestAutoMergeArgs = {
  input: DisablePullRequestAutoMergeInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDismissPullRequestReviewArgs = {
  input: DismissPullRequestReviewInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationDismissRepositoryVulnerabilityAlertArgs = {
  input: DismissRepositoryVulnerabilityAlertInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationEnablePullRequestAutoMergeArgs = {
  input: EnablePullRequestAutoMergeInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationEnqueuePullRequestArgs = {
  input: EnqueuePullRequestInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationFollowOrganizationArgs = {
  input: FollowOrganizationInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationFollowUserArgs = {
  input: FollowUserInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationGrantEnterpriseOrganizationsMigratorRoleArgs = {
  input: GrantEnterpriseOrganizationsMigratorRoleInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationGrantMigratorRoleArgs = {
  input: GrantMigratorRoleInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationImportProjectArgs = {
  input: ImportProjectInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationInviteEnterpriseAdminArgs = {
  input: InviteEnterpriseAdminInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationInviteEnterpriseMemberArgs = {
  input: InviteEnterpriseMemberInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationLinkProjectV2ToRepositoryArgs = {
  input: LinkProjectV2ToRepositoryInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationLinkProjectV2ToTeamArgs = {
  input: LinkProjectV2ToTeamInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationLinkRepositoryToProjectArgs = {
  input: LinkRepositoryToProjectInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationLockLockableArgs = {
  input: LockLockableInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationMarkDiscussionCommentAsAnswerArgs = {
  input: MarkDiscussionCommentAsAnswerInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationMarkFileAsViewedArgs = {
  input: MarkFileAsViewedInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationMarkProjectV2AsTemplateArgs = {
  input: MarkProjectV2AsTemplateInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationMarkPullRequestReadyForReviewArgs = {
  input: MarkPullRequestReadyForReviewInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationMergeBranchArgs = {
  input: MergeBranchInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationMergePullRequestArgs = {
  input: MergePullRequestInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationMinimizeCommentArgs = {
  input: MinimizeCommentInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationMoveProjectCardArgs = {
  input: MoveProjectCardInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationMoveProjectColumnArgs = {
  input: MoveProjectColumnInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationPinEnvironmentArgs = {
  input: PinEnvironmentInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationPinIssueArgs = {
  input: PinIssueInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationPinIssueCommentArgs = {
  input: PinIssueCommentInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationPromoteRepositoryCustomPropertyArgs = {
  input: PromoteRepositoryCustomPropertyInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationPublishSponsorsTierArgs = {
  input: PublishSponsorsTierInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationRegenerateEnterpriseIdentityProviderRecoveryCodesArgs = {
  input: RegenerateEnterpriseIdentityProviderRecoveryCodesInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationRegenerateVerifiableDomainTokenArgs = {
  input: RegenerateVerifiableDomainTokenInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationRejectDeploymentsArgs = {
  input: RejectDeploymentsInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationRejectPendingIssueSuggestionsArgs = {
  input: RejectPendingIssueSuggestionsInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationRemoveAssigneesFromAssignableArgs = {
  input: RemoveAssigneesFromAssignableInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationRemoveBlockedByArgs = {
  input: RemoveBlockedByInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationRemoveCloseIssueReferencesArgs = {
  input: RemoveCloseIssueReferencesInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationRemoveEnterpriseAdminArgs = {
  input: RemoveEnterpriseAdminInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationRemoveEnterpriseIdentityProviderArgs = {
  input: RemoveEnterpriseIdentityProviderInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationRemoveEnterpriseMemberArgs = {
  input: RemoveEnterpriseMemberInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationRemoveEnterpriseOrganizationArgs = {
  input: RemoveEnterpriseOrganizationInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationRemoveEnterpriseSupportEntitlementArgs = {
  input: RemoveEnterpriseSupportEntitlementInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationRemoveLabelsFromLabelableArgs = {
  input: RemoveLabelsFromLabelableInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationRemoveOutsideCollaboratorArgs = {
  input: RemoveOutsideCollaboratorInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationRemovePullRequestCreationCapBypassUsersArgs = {
  input: RemovePullRequestCreationCapBypassUsersInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationRemoveReactionArgs = {
  input: RemoveReactionInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationRemoveRelatesToArgs = {
  input: RemoveRelatesToInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationRemoveStarArgs = {
  input: RemoveStarInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationRemoveSubIssueArgs = {
  input: RemoveSubIssueInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationRemoveUpvoteArgs = {
  input: RemoveUpvoteInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationReopenDiscussionArgs = {
  input: ReopenDiscussionInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationReopenIssueArgs = {
  input: ReopenIssueInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationReopenPullRequestArgs = {
  input: ReopenPullRequestInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationReorderEnvironmentArgs = {
  input: ReorderEnvironmentInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationReplaceActorsForAssignableArgs = {
  input: ReplaceActorsForAssignableInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationReprioritizeSubIssueArgs = {
  input: ReprioritizeSubIssueInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationRequestReviewsArgs = {
  input: RequestReviewsInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationRequestReviewsByLoginArgs = {
  input: RequestReviewsByLoginInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationRerequestCheckSuiteArgs = {
  input: RerequestCheckSuiteInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationRerequestReviewsArgs = {
  input: RerequestReviewsInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationResolveReviewThreadArgs = {
  input: ResolveReviewThreadInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationRetireSponsorsTierArgs = {
  input: RetireSponsorsTierInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationRevertPullRequestArgs = {
  input: RevertPullRequestInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationRevokeEnterpriseOrganizationsMigratorRoleArgs = {
  input: RevokeEnterpriseOrganizationsMigratorRoleInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationRevokeMigratorRoleArgs = {
  input: RevokeMigratorRoleInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationSetEnterpriseIdentityProviderArgs = {
  input: SetEnterpriseIdentityProviderInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationSetIssueFieldValueArgs = {
  input: SetIssueFieldValueInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationSetOrganizationInteractionLimitArgs = {
  input: SetOrganizationInteractionLimitInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationSetRepositoryCustomPropertyValuesArgs = {
  input: SetRepositoryCustomPropertyValuesInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationSetRepositoryInteractionLimitArgs = {
  input: SetRepositoryInteractionLimitInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationSetUserInteractionLimitArgs = {
  input: SetUserInteractionLimitInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationStartOrganizationMigrationArgs = {
  input: StartOrganizationMigrationInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationStartRepositoryMigrationArgs = {
  input: StartRepositoryMigrationInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationSubmitPullRequestReviewArgs = {
  input: SubmitPullRequestReviewInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationTransferEnterpriseOrganizationArgs = {
  input: TransferEnterpriseOrganizationInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationTransferIssueArgs = {
  input: TransferIssueInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUnarchiveProjectV2ItemArgs = {
  input: UnarchiveProjectV2ItemInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUnarchivePullRequestArgs = {
  input: UnarchivePullRequestInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUnarchiveRepositoryArgs = {
  input: UnarchiveRepositoryInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUnfollowOrganizationArgs = {
  input: UnfollowOrganizationInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUnfollowUserArgs = {
  input: UnfollowUserInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUnlinkProjectV2FromRepositoryArgs = {
  input: UnlinkProjectV2FromRepositoryInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUnlinkProjectV2FromTeamArgs = {
  input: UnlinkProjectV2FromTeamInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUnlinkRepositoryFromProjectArgs = {
  input: UnlinkRepositoryFromProjectInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUnlockLockableArgs = {
  input: UnlockLockableInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUnmarkDiscussionCommentAsAnswerArgs = {
  input: UnmarkDiscussionCommentAsAnswerInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUnmarkFileAsViewedArgs = {
  input: UnmarkFileAsViewedInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUnmarkIssueAsDuplicateArgs = {
  input: UnmarkIssueAsDuplicateInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUnmarkProjectV2AsTemplateArgs = {
  input: UnmarkProjectV2AsTemplateInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUnminimizeCommentArgs = {
  input: UnminimizeCommentInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUnpinIssueArgs = {
  input: UnpinIssueInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUnpinIssueCommentArgs = {
  input: UnpinIssueCommentInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUnresolveReviewThreadArgs = {
  input: UnresolveReviewThreadInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateBranchProtectionRuleArgs = {
  input: UpdateBranchProtectionRuleInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateCheckRunArgs = {
  input: UpdateCheckRunInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateCheckSuitePreferencesArgs = {
  input: UpdateCheckSuitePreferencesInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateDiscussionArgs = {
  input: UpdateDiscussionInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateDiscussionCommentArgs = {
  input: UpdateDiscussionCommentInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateEnterpriseAdministratorRoleArgs = {
  input: UpdateEnterpriseAdministratorRoleInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateEnterpriseAllowPrivateRepositoryForkingSettingArgs = {
  input: UpdateEnterpriseAllowPrivateRepositoryForkingSettingInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateEnterpriseDefaultRepositoryPermissionSettingArgs = {
  input: UpdateEnterpriseDefaultRepositoryPermissionSettingInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateEnterpriseDeployKeySettingArgs = {
  input: UpdateEnterpriseDeployKeySettingInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateEnterpriseMembersCanChangeRepositoryVisibilitySettingArgs = {
  input: UpdateEnterpriseMembersCanChangeRepositoryVisibilitySettingInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateEnterpriseMembersCanCreateRepositoriesSettingArgs = {
  input: UpdateEnterpriseMembersCanCreateRepositoriesSettingInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateEnterpriseMembersCanDeleteIssuesSettingArgs = {
  input: UpdateEnterpriseMembersCanDeleteIssuesSettingInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateEnterpriseMembersCanDeleteRepositoriesSettingArgs = {
  input: UpdateEnterpriseMembersCanDeleteRepositoriesSettingInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateEnterpriseMembersCanInviteCollaboratorsSettingArgs = {
  input: UpdateEnterpriseMembersCanInviteCollaboratorsSettingInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateEnterpriseMembersCanMakePurchasesSettingArgs = {
  input: UpdateEnterpriseMembersCanMakePurchasesSettingInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateEnterpriseMembersCanUpdateProtectedBranchesSettingArgs = {
  input: UpdateEnterpriseMembersCanUpdateProtectedBranchesSettingInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateEnterpriseMembersCanViewDependencyInsightsSettingArgs = {
  input: UpdateEnterpriseMembersCanViewDependencyInsightsSettingInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateEnterpriseOrganizationProjectsSettingArgs = {
  input: UpdateEnterpriseOrganizationProjectsSettingInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateEnterpriseOwnerOrganizationRoleArgs = {
  input: UpdateEnterpriseOwnerOrganizationRoleInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateEnterpriseProfileArgs = {
  input: UpdateEnterpriseProfileInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateEnterpriseRepositoryProjectsSettingArgs = {
  input: UpdateEnterpriseRepositoryProjectsSettingInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateEnterpriseTwoFactorAuthenticationDisallowedMethodsSettingArgs = {
  input: UpdateEnterpriseTwoFactorAuthenticationDisallowedMethodsSettingInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateEnterpriseTwoFactorAuthenticationRequiredSettingArgs = {
  input: UpdateEnterpriseTwoFactorAuthenticationRequiredSettingInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateEnvironmentArgs = {
  input: UpdateEnvironmentInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateIpAllowListEnabledSettingArgs = {
  input: UpdateIpAllowListEnabledSettingInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateIpAllowListEntryArgs = {
  input: UpdateIpAllowListEntryInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateIpAllowListForInstalledAppsEnabledSettingArgs = {
  input: UpdateIpAllowListForInstalledAppsEnabledSettingInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateIpAllowListUserLevelEnforcementEnabledSettingArgs = {
  input: UpdateIpAllowListUserLevelEnforcementEnabledSettingInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateIssueArgs = {
  input: UpdateIssueInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateIssueCommentArgs = {
  input: UpdateIssueCommentInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateIssueFieldArgs = {
  input: UpdateIssueFieldInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateIssueFieldValueArgs = {
  input: UpdateIssueFieldValueInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateIssueIssueTypeArgs = {
  input: UpdateIssueIssueTypeInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateIssueTypeArgs = {
  input: UpdateIssueTypeInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateLabelArgs = {
  input: UpdateLabelInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateNotificationRestrictionSettingArgs = {
  input: UpdateNotificationRestrictionSettingInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateOrganizationAllowPrivateRepositoryForkingSettingArgs = {
  input: UpdateOrganizationAllowPrivateRepositoryForkingSettingInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateOrganizationWebCommitSignoffSettingArgs = {
  input: UpdateOrganizationWebCommitSignoffSettingInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdatePatreonSponsorabilityArgs = {
  input: UpdatePatreonSponsorabilityInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateProjectArgs = {
  input: UpdateProjectInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateProjectCardArgs = {
  input: UpdateProjectCardInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateProjectColumnArgs = {
  input: UpdateProjectColumnInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateProjectV2Args = {
  input: UpdateProjectV2Input;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateProjectV2CollaboratorsArgs = {
  input: UpdateProjectV2CollaboratorsInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateProjectV2DraftIssueArgs = {
  input: UpdateProjectV2DraftIssueInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateProjectV2FieldArgs = {
  input: UpdateProjectV2FieldInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateProjectV2ItemFieldValueArgs = {
  input: UpdateProjectV2ItemFieldValueInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateProjectV2ItemPositionArgs = {
  input: UpdateProjectV2ItemPositionInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateProjectV2StatusUpdateArgs = {
  input: UpdateProjectV2StatusUpdateInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateProjectV2ViewArgs = {
  input: UpdateProjectV2ViewInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdatePullRequestArgs = {
  input: UpdatePullRequestInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdatePullRequestBranchArgs = {
  input: UpdatePullRequestBranchInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdatePullRequestReviewArgs = {
  input: UpdatePullRequestReviewInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdatePullRequestReviewCommentArgs = {
  input: UpdatePullRequestReviewCommentInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateRefArgs = {
  input: UpdateRefInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateRefsArgs = {
  input: UpdateRefsInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateRepositoryArgs = {
  input: UpdateRepositoryInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateRepositoryCustomPropertyArgs = {
  input: UpdateRepositoryCustomPropertyInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateRepositoryRulesetArgs = {
  input: UpdateRepositoryRulesetInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateRepositoryWebCommitSignoffSettingArgs = {
  input: UpdateRepositoryWebCommitSignoffSettingInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateSponsorshipPreferencesArgs = {
  input: UpdateSponsorshipPreferencesInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateSubscriptionArgs = {
  input: UpdateSubscriptionInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateTeamReviewAssignmentArgs = {
  input: UpdateTeamReviewAssignmentInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateTeamsRepositoryArgs = {
  input: UpdateTeamsRepositoryInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateTopicsArgs = {
  input: UpdateTopicsInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateUserListArgs = {
  input: UpdateUserListInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationUpdateUserListsForItemArgs = {
  input: UpdateUserListsForItemInput;
};


/** The root query for implementing GraphQL mutations. */
export type MutationVerifyVerifiableDomainArgs = {
  input: VerifyVerifiableDomainInput;
};

/** An object with an ID. */
export type Node = {
  /** ID of the object. */
  id: Scalars['ID']['output'];
};

/** The possible values for the notification restriction setting. */
export enum NotificationRestrictionSettingValue {
  /** The setting is disabled for the owner. */
  Disabled = 'DISABLED',
  /** The setting is enabled for the owner. */
  Enabled = 'ENABLED'
}

/**
 * An OIDC identity provider configured to provision identities for an enterprise.
 * Visible to enterprise owners or enterprise owners' personal access tokens
 * (classic) with read:enterprise or admin:enterprise scope.
 */
export type OidcProvider = Node & {
  __typename?: 'OIDCProvider';
  /** The enterprise this identity provider belongs to. */
  enterprise?: Maybe<Enterprise>;
  /** ExternalIdentities provisioned by this identity provider. */
  externalIdentities: ExternalIdentityConnection;
  /** The Node ID of the OIDCProvider object */
  id: Scalars['ID']['output'];
  /** The OIDC identity provider type */
  providerType: OidcProviderType;
  /** The id of the tenant this provider is attached to */
  tenantId: Scalars['String']['output'];
};


/**
 * An OIDC identity provider configured to provision identities for an enterprise.
 * Visible to enterprise owners or enterprise owners' personal access tokens
 * (classic) with read:enterprise or admin:enterprise scope.
 */
export type OidcProviderExternalIdentitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  login?: InputMaybe<Scalars['String']['input']>;
  membersOnly?: InputMaybe<Scalars['Boolean']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

/** The OIDC identity provider type */
export enum OidcProviderType {
  /** Azure Active Directory */
  Aad = 'AAD'
}

/** Metadata for an audit entry with action oauth_application.* */
export type OauthApplicationAuditEntryData = {
  /** The name of the OAuth application. */
  oauthApplicationName?: Maybe<Scalars['String']['output']>;
  /** The HTTP path for the OAuth application */
  oauthApplicationResourcePath?: Maybe<Scalars['URI']['output']>;
  /** The HTTP URL for the OAuth application */
  oauthApplicationUrl?: Maybe<Scalars['URI']['output']>;
};

/** Audit log entry for a oauth_application.create event. */
export type OauthApplicationCreateAuditEntry = AuditEntry & Node & OauthApplicationAuditEntryData & OrganizationAuditEntryData & {
  __typename?: 'OauthApplicationCreateAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The application URL of the OAuth application.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  applicationUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The callback URL of the OAuth application.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  callbackUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /** The Node ID of the OauthApplicationCreateAuditEntry object */
  id: Scalars['ID']['output'];
  /** The name of the OAuth application. */
  oauthApplicationName?: Maybe<Scalars['String']['output']>;
  /** The HTTP path for the OAuth application */
  oauthApplicationResourcePath?: Maybe<Scalars['URI']['output']>;
  /** The HTTP URL for the OAuth application */
  oauthApplicationUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The rate limit of the OAuth application.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  rateLimit?: Maybe<Scalars['Int']['output']>;
  /**
   * The state of the OAuth application.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  state?: Maybe<OauthApplicationCreateAuditEntryState>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
};

/** The state of an OAuth application when it was created. */
export enum OauthApplicationCreateAuditEntryState {
  /** The OAuth application was active and allowed to have OAuth Accesses. */
  Active = 'ACTIVE',
  /** The OAuth application was in the process of being deleted. */
  PendingDeletion = 'PENDING_DELETION',
  /** The OAuth application was suspended from generating OAuth Accesses due to abuse or security concerns. */
  Suspended = 'SUSPENDED'
}

/** The corresponding operation type for the action */
export enum OperationType {
  /** An existing resource was accessed */
  Access = 'ACCESS',
  /** A resource performed an authentication event */
  Authentication = 'AUTHENTICATION',
  /** A new resource was created */
  Create = 'CREATE',
  /** An existing resource was modified */
  Modify = 'MODIFY',
  /** An existing resource was removed */
  Remove = 'REMOVE',
  /** An existing resource was restored */
  Restore = 'RESTORE',
  /** An existing resource was transferred between multiple resources */
  Transfer = 'TRANSFER'
}

/** Possible directions in which to order a list of items when provided an `orderBy` argument. */
export enum OrderDirection {
  /** Specifies an ascending order for a given `orderBy` argument. */
  Asc = 'ASC',
  /** Specifies a descending order for a given `orderBy` argument. */
  Desc = 'DESC'
}

/** Audit log entry for a org.add_billing_manager */
export type OrgAddBillingManagerAuditEntry = AuditEntry & Node & OrganizationAuditEntryData & {
  __typename?: 'OrgAddBillingManagerAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /** The Node ID of the OrgAddBillingManagerAuditEntry object */
  id: Scalars['ID']['output'];
  /**
   * The email address used to invite a billing manager for the organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  invitationEmail?: Maybe<Scalars['String']['output']>;
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
};

/** Audit log entry for a org.add_member */
export type OrgAddMemberAuditEntry = AuditEntry & Node & OrganizationAuditEntryData & {
  __typename?: 'OrgAddMemberAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /** The Node ID of the OrgAddMemberAuditEntry object */
  id: Scalars['ID']['output'];
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The permission level of the member added to the organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  permission?: Maybe<OrgAddMemberAuditEntryPermission>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
};

/** The permissions available to members on an Organization. */
export enum OrgAddMemberAuditEntryPermission {
  /** Can read, clone, push, and add collaborators to repositories. */
  Admin = 'ADMIN',
  /** Can read and clone repositories. */
  Read = 'READ'
}

/** Audit log entry for a org.block_user */
export type OrgBlockUserAuditEntry = AuditEntry & Node & OrganizationAuditEntryData & {
  __typename?: 'OrgBlockUserAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The blocked user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  blockedUser?: Maybe<User>;
  /**
   * The username of the blocked user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  blockedUserName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the blocked user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  blockedUserResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the blocked user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  blockedUserUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /** The Node ID of the OrgBlockUserAuditEntry object */
  id: Scalars['ID']['output'];
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
};

/** Audit log entry for a org.config.disable_collaborators_only event. */
export type OrgConfigDisableCollaboratorsOnlyAuditEntry = AuditEntry & Node & OrganizationAuditEntryData & {
  __typename?: 'OrgConfigDisableCollaboratorsOnlyAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /** The Node ID of the OrgConfigDisableCollaboratorsOnlyAuditEntry object */
  id: Scalars['ID']['output'];
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
};

/** Audit log entry for a org.config.enable_collaborators_only event. */
export type OrgConfigEnableCollaboratorsOnlyAuditEntry = AuditEntry & Node & OrganizationAuditEntryData & {
  __typename?: 'OrgConfigEnableCollaboratorsOnlyAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /** The Node ID of the OrgConfigEnableCollaboratorsOnlyAuditEntry object */
  id: Scalars['ID']['output'];
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
};

/** Audit log entry for a org.create event. */
export type OrgCreateAuditEntry = AuditEntry & Node & OrganizationAuditEntryData & {
  __typename?: 'OrgCreateAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The billing plan for the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  billingPlan?: Maybe<OrgCreateAuditEntryBillingPlan>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /** The Node ID of the OrgCreateAuditEntry object */
  id: Scalars['ID']['output'];
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
};

/** The billing plans available for organizations. */
export enum OrgCreateAuditEntryBillingPlan {
  /** Team Plan */
  Business = 'BUSINESS',
  /** Enterprise Cloud Plan */
  BusinessPlus = 'BUSINESS_PLUS',
  /** Free Plan */
  Free = 'FREE',
  /** Tiered Per Seat Plan */
  TieredPerSeat = 'TIERED_PER_SEAT',
  /** Legacy Unlimited Plan */
  Unlimited = 'UNLIMITED'
}

/** Audit log entry for a org.disable_oauth_app_restrictions event. */
export type OrgDisableOauthAppRestrictionsAuditEntry = AuditEntry & Node & OrganizationAuditEntryData & {
  __typename?: 'OrgDisableOauthAppRestrictionsAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /** The Node ID of the OrgDisableOauthAppRestrictionsAuditEntry object */
  id: Scalars['ID']['output'];
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
};

/** Audit log entry for a org.disable_saml event. */
export type OrgDisableSamlAuditEntry = AuditEntry & Node & OrganizationAuditEntryData & {
  __typename?: 'OrgDisableSamlAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /**
   * The SAML provider's digest algorithm URL.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  digestMethodUrl?: Maybe<Scalars['URI']['output']>;
  /** The Node ID of the OrgDisableSamlAuditEntry object */
  id: Scalars['ID']['output'];
  /**
   * The SAML provider's issuer URL.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  issuerUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The SAML provider's signature algorithm URL.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  signatureMethodUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The SAML provider's single sign-on URL.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  singleSignOnUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
};

/** Audit log entry for a org.disable_two_factor_requirement event. */
export type OrgDisableTwoFactorRequirementAuditEntry = AuditEntry & Node & OrganizationAuditEntryData & {
  __typename?: 'OrgDisableTwoFactorRequirementAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /** The Node ID of the OrgDisableTwoFactorRequirementAuditEntry object */
  id: Scalars['ID']['output'];
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
};

/** Audit log entry for a org.enable_oauth_app_restrictions event. */
export type OrgEnableOauthAppRestrictionsAuditEntry = AuditEntry & Node & OrganizationAuditEntryData & {
  __typename?: 'OrgEnableOauthAppRestrictionsAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /** The Node ID of the OrgEnableOauthAppRestrictionsAuditEntry object */
  id: Scalars['ID']['output'];
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
};

/** Audit log entry for a org.enable_saml event. */
export type OrgEnableSamlAuditEntry = AuditEntry & Node & OrganizationAuditEntryData & {
  __typename?: 'OrgEnableSamlAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /**
   * The SAML provider's digest algorithm URL.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  digestMethodUrl?: Maybe<Scalars['URI']['output']>;
  /** The Node ID of the OrgEnableSamlAuditEntry object */
  id: Scalars['ID']['output'];
  /**
   * The SAML provider's issuer URL.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  issuerUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The SAML provider's signature algorithm URL.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  signatureMethodUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The SAML provider's single sign-on URL.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  singleSignOnUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
};

/** Audit log entry for a org.enable_two_factor_requirement event. */
export type OrgEnableTwoFactorRequirementAuditEntry = AuditEntry & Node & OrganizationAuditEntryData & {
  __typename?: 'OrgEnableTwoFactorRequirementAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /** The Node ID of the OrgEnableTwoFactorRequirementAuditEntry object */
  id: Scalars['ID']['output'];
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
};

/** Ordering options for an organization's enterprise owner connections. */
export type OrgEnterpriseOwnerOrder = {
  /** The ordering direction. */
  direction: OrderDirection;
  /** The field to order enterprise owners by. */
  field: OrgEnterpriseOwnerOrderField;
};

/** Properties by which enterprise owners can be ordered. */
export enum OrgEnterpriseOwnerOrderField {
  /** Order enterprise owners by login. */
  Login = 'LOGIN'
}

/** Audit log entry for a org.invite_member event. */
export type OrgInviteMemberAuditEntry = AuditEntry & Node & OrganizationAuditEntryData & {
  __typename?: 'OrgInviteMemberAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /**
   * The email address of the organization invitation.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  email?: Maybe<Scalars['String']['output']>;
  /** The Node ID of the OrgInviteMemberAuditEntry object */
  id: Scalars['ID']['output'];
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The organization invitation.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationInvitation?: Maybe<OrganizationInvitation>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
};

/** Audit log entry for a org.invite_to_business event. */
export type OrgInviteToBusinessAuditEntry = AuditEntry & EnterpriseAuditEntryData & Node & OrganizationAuditEntryData & {
  __typename?: 'OrgInviteToBusinessAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /** The HTTP path for this enterprise. */
  enterpriseResourcePath?: Maybe<Scalars['URI']['output']>;
  /** The slug of the enterprise. */
  enterpriseSlug?: Maybe<Scalars['String']['output']>;
  /** The HTTP URL for this enterprise. */
  enterpriseUrl?: Maybe<Scalars['URI']['output']>;
  /** The Node ID of the OrgInviteToBusinessAuditEntry object */
  id: Scalars['ID']['output'];
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
};

/** Audit log entry for a org.oauth_app_access_approved event. */
export type OrgOauthAppAccessApprovedAuditEntry = AuditEntry & Node & OauthApplicationAuditEntryData & OrganizationAuditEntryData & {
  __typename?: 'OrgOauthAppAccessApprovedAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /** The Node ID of the OrgOauthAppAccessApprovedAuditEntry object */
  id: Scalars['ID']['output'];
  /** The name of the OAuth application. */
  oauthApplicationName?: Maybe<Scalars['String']['output']>;
  /** The HTTP path for the OAuth application */
  oauthApplicationResourcePath?: Maybe<Scalars['URI']['output']>;
  /** The HTTP URL for the OAuth application */
  oauthApplicationUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
};

/** Audit log entry for a org.oauth_app_access_blocked event. */
export type OrgOauthAppAccessBlockedAuditEntry = AuditEntry & Node & OauthApplicationAuditEntryData & OrganizationAuditEntryData & {
  __typename?: 'OrgOauthAppAccessBlockedAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /** The Node ID of the OrgOauthAppAccessBlockedAuditEntry object */
  id: Scalars['ID']['output'];
  /** The name of the OAuth application. */
  oauthApplicationName?: Maybe<Scalars['String']['output']>;
  /** The HTTP path for the OAuth application */
  oauthApplicationResourcePath?: Maybe<Scalars['URI']['output']>;
  /** The HTTP URL for the OAuth application */
  oauthApplicationUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
};

/** Audit log entry for a org.oauth_app_access_denied event. */
export type OrgOauthAppAccessDeniedAuditEntry = AuditEntry & Node & OauthApplicationAuditEntryData & OrganizationAuditEntryData & {
  __typename?: 'OrgOauthAppAccessDeniedAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /** The Node ID of the OrgOauthAppAccessDeniedAuditEntry object */
  id: Scalars['ID']['output'];
  /** The name of the OAuth application. */
  oauthApplicationName?: Maybe<Scalars['String']['output']>;
  /** The HTTP path for the OAuth application */
  oauthApplicationResourcePath?: Maybe<Scalars['URI']['output']>;
  /** The HTTP URL for the OAuth application */
  oauthApplicationUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
};

/** Audit log entry for a org.oauth_app_access_requested event. */
export type OrgOauthAppAccessRequestedAuditEntry = AuditEntry & Node & OauthApplicationAuditEntryData & OrganizationAuditEntryData & {
  __typename?: 'OrgOauthAppAccessRequestedAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /** The Node ID of the OrgOauthAppAccessRequestedAuditEntry object */
  id: Scalars['ID']['output'];
  /** The name of the OAuth application. */
  oauthApplicationName?: Maybe<Scalars['String']['output']>;
  /** The HTTP path for the OAuth application */
  oauthApplicationResourcePath?: Maybe<Scalars['URI']['output']>;
  /** The HTTP URL for the OAuth application */
  oauthApplicationUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
};

/** Audit log entry for a org.oauth_app_access_unblocked event. */
export type OrgOauthAppAccessUnblockedAuditEntry = AuditEntry & Node & OauthApplicationAuditEntryData & OrganizationAuditEntryData & {
  __typename?: 'OrgOauthAppAccessUnblockedAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /** The Node ID of the OrgOauthAppAccessUnblockedAuditEntry object */
  id: Scalars['ID']['output'];
  /** The name of the OAuth application. */
  oauthApplicationName?: Maybe<Scalars['String']['output']>;
  /** The HTTP path for the OAuth application */
  oauthApplicationResourcePath?: Maybe<Scalars['URI']['output']>;
  /** The HTTP URL for the OAuth application */
  oauthApplicationUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
};

/** Audit log entry for a org.remove_billing_manager event. */
export type OrgRemoveBillingManagerAuditEntry = AuditEntry & Node & OrganizationAuditEntryData & {
  __typename?: 'OrgRemoveBillingManagerAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /** The Node ID of the OrgRemoveBillingManagerAuditEntry object */
  id: Scalars['ID']['output'];
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The reason for the billing manager being removed.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  reason?: Maybe<OrgRemoveBillingManagerAuditEntryReason>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
};

/** The reason a billing manager was removed from an Organization. */
export enum OrgRemoveBillingManagerAuditEntryReason {
  /** SAML external identity missing */
  SamlExternalIdentityMissing = 'SAML_EXTERNAL_IDENTITY_MISSING',
  /** SAML SSO enforcement requires an external identity */
  SamlSsoEnforcementRequiresExternalIdentity = 'SAML_SSO_ENFORCEMENT_REQUIRES_EXTERNAL_IDENTITY',
  /** The organization required 2FA of its billing managers and this user did not have 2FA enabled. */
  TwoFactorRequirementNonCompliance = 'TWO_FACTOR_REQUIREMENT_NON_COMPLIANCE'
}

/** Audit log entry for a org.remove_member event. */
export type OrgRemoveMemberAuditEntry = AuditEntry & Node & OrganizationAuditEntryData & {
  __typename?: 'OrgRemoveMemberAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /** The Node ID of the OrgRemoveMemberAuditEntry object */
  id: Scalars['ID']['output'];
  /**
   * The types of membership the member has with the organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  membershipTypes?: Maybe<Array<OrgRemoveMemberAuditEntryMembershipType>>;
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The reason for the member being removed.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  reason?: Maybe<OrgRemoveMemberAuditEntryReason>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
};

/** The type of membership a user has with an Organization. */
export enum OrgRemoveMemberAuditEntryMembershipType {
  /**
   * Organization owners have full access and can change several settings,
   * including the names of repositories that belong to the Organization and Owners
   * team membership. In addition, organization owners can delete the organization
   * and all of its repositories.
   */
  Admin = 'ADMIN',
  /** A billing manager is a user who manages the billing settings for the Organization, such as updating payment information. */
  BillingManager = 'BILLING_MANAGER',
  /** A direct member is a user that is a member of the Organization. */
  DirectMember = 'DIRECT_MEMBER',
  /**
   * An outside collaborator is a person who isn't explicitly a member of the
   * Organization, but who has Read, Write, or Admin permissions to one or more
   * repositories in the organization.
   */
  OutsideCollaborator = 'OUTSIDE_COLLABORATOR',
  /** A suspended member. */
  Suspended = 'SUSPENDED',
  /**
   * An unaffiliated collaborator is a person who is not a member of the
   * Organization and does not have access to any repositories in the Organization.
   */
  Unaffiliated = 'UNAFFILIATED'
}

/** The reason a member was removed from an Organization. */
export enum OrgRemoveMemberAuditEntryReason {
  /** SAML external identity missing */
  SamlExternalIdentityMissing = 'SAML_EXTERNAL_IDENTITY_MISSING',
  /** SAML SSO enforcement requires an external identity */
  SamlSsoEnforcementRequiresExternalIdentity = 'SAML_SSO_ENFORCEMENT_REQUIRES_EXTERNAL_IDENTITY',
  /** User was removed from organization during account recovery */
  TwoFactorAccountRecovery = 'TWO_FACTOR_ACCOUNT_RECOVERY',
  /** The organization required 2FA of its billing managers and this user did not have 2FA enabled. */
  TwoFactorRequirementNonCompliance = 'TWO_FACTOR_REQUIREMENT_NON_COMPLIANCE',
  /** User account has been deleted */
  UserAccountDeleted = 'USER_ACCOUNT_DELETED'
}

/** Audit log entry for a org.remove_outside_collaborator event. */
export type OrgRemoveOutsideCollaboratorAuditEntry = AuditEntry & Node & OrganizationAuditEntryData & {
  __typename?: 'OrgRemoveOutsideCollaboratorAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /** The Node ID of the OrgRemoveOutsideCollaboratorAuditEntry object */
  id: Scalars['ID']['output'];
  /**
   * The types of membership the outside collaborator has with the organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  membershipTypes?: Maybe<Array<OrgRemoveOutsideCollaboratorAuditEntryMembershipType>>;
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The reason for the outside collaborator being removed from the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  reason?: Maybe<OrgRemoveOutsideCollaboratorAuditEntryReason>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
};

/** The type of membership a user has with an Organization. */
export enum OrgRemoveOutsideCollaboratorAuditEntryMembershipType {
  /** A billing manager is a user who manages the billing settings for the Organization, such as updating payment information. */
  BillingManager = 'BILLING_MANAGER',
  /**
   * An outside collaborator is a person who isn't explicitly a member of the
   * Organization, but who has Read, Write, or Admin permissions to one or more
   * repositories in the organization.
   */
  OutsideCollaborator = 'OUTSIDE_COLLABORATOR',
  /**
   * An unaffiliated collaborator is a person who is not a member of the
   * Organization and does not have access to any repositories in the organization.
   */
  Unaffiliated = 'UNAFFILIATED'
}

/** The reason an outside collaborator was removed from an Organization. */
export enum OrgRemoveOutsideCollaboratorAuditEntryReason {
  /** SAML external identity missing */
  SamlExternalIdentityMissing = 'SAML_EXTERNAL_IDENTITY_MISSING',
  /** The organization required 2FA of its billing managers and this user did not have 2FA enabled. */
  TwoFactorRequirementNonCompliance = 'TWO_FACTOR_REQUIREMENT_NON_COMPLIANCE'
}

/** Audit log entry for a org.restore_member event. */
export type OrgRestoreMemberAuditEntry = AuditEntry & Node & OrganizationAuditEntryData & {
  __typename?: 'OrgRestoreMemberAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /** The Node ID of the OrgRestoreMemberAuditEntry object */
  id: Scalars['ID']['output'];
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The number of custom email routings for the restored member.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  restoredCustomEmailRoutingsCount?: Maybe<Scalars['Int']['output']>;
  /**
   * The number of issue assignments for the restored member.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  restoredIssueAssignmentsCount?: Maybe<Scalars['Int']['output']>;
  /**
   * Restored organization membership objects.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  restoredMemberships?: Maybe<Array<OrgRestoreMemberAuditEntryMembership>>;
  /**
   * The number of restored memberships.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  restoredMembershipsCount?: Maybe<Scalars['Int']['output']>;
  /**
   * The number of repositories of the restored member.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  restoredRepositoriesCount?: Maybe<Scalars['Int']['output']>;
  /**
   * The number of starred repositories for the restored member.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  restoredRepositoryStarsCount?: Maybe<Scalars['Int']['output']>;
  /**
   * The number of watched repositories for the restored member.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  restoredRepositoryWatchesCount?: Maybe<Scalars['Int']['output']>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
};

/** Types of memberships that can be restored for an Organization member. */
export type OrgRestoreMemberAuditEntryMembership = OrgRestoreMemberMembershipOrganizationAuditEntryData | OrgRestoreMemberMembershipRepositoryAuditEntryData | OrgRestoreMemberMembershipTeamAuditEntryData;

/** Metadata for an organization membership for org.restore_member actions */
export type OrgRestoreMemberMembershipOrganizationAuditEntryData = OrganizationAuditEntryData & {
  __typename?: 'OrgRestoreMemberMembershipOrganizationAuditEntryData';
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
};

/** Metadata for a repository membership for org.restore_member actions */
export type OrgRestoreMemberMembershipRepositoryAuditEntryData = RepositoryAuditEntryData & {
  __typename?: 'OrgRestoreMemberMembershipRepositoryAuditEntryData';
  /** The repository associated with the action */
  repository?: Maybe<Repository>;
  /** The name of the repository */
  repositoryName?: Maybe<Scalars['String']['output']>;
  /** The HTTP path for the repository */
  repositoryResourcePath?: Maybe<Scalars['URI']['output']>;
  /** The HTTP URL for the repository */
  repositoryUrl?: Maybe<Scalars['URI']['output']>;
};

/** Metadata for a team membership for org.restore_member actions */
export type OrgRestoreMemberMembershipTeamAuditEntryData = TeamAuditEntryData & {
  __typename?: 'OrgRestoreMemberMembershipTeamAuditEntryData';
  /** The team associated with the action */
  team?: Maybe<Team>;
  /** The name of the team */
  teamName?: Maybe<Scalars['String']['output']>;
  /** The HTTP path for this team */
  teamResourcePath?: Maybe<Scalars['URI']['output']>;
  /** The HTTP URL for this team */
  teamUrl?: Maybe<Scalars['URI']['output']>;
};

/** Audit log entry for a org.unblock_user */
export type OrgUnblockUserAuditEntry = AuditEntry & Node & OrganizationAuditEntryData & {
  __typename?: 'OrgUnblockUserAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The user being unblocked by the organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  blockedUser?: Maybe<User>;
  /**
   * The username of the blocked user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  blockedUserName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the blocked user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  blockedUserResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the blocked user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  blockedUserUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /** The Node ID of the OrgUnblockUserAuditEntry object */
  id: Scalars['ID']['output'];
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
};

/** Audit log entry for a org.update_default_repository_permission */
export type OrgUpdateDefaultRepositoryPermissionAuditEntry = AuditEntry & Node & OrganizationAuditEntryData & {
  __typename?: 'OrgUpdateDefaultRepositoryPermissionAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /** The Node ID of the OrgUpdateDefaultRepositoryPermissionAuditEntry object */
  id: Scalars['ID']['output'];
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The new base repository permission level for the organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  permission?: Maybe<OrgUpdateDefaultRepositoryPermissionAuditEntryPermission>;
  /**
   * The former base repository permission level for the organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  permissionWas?: Maybe<OrgUpdateDefaultRepositoryPermissionAuditEntryPermission>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
};

/** The default permission a repository can have in an Organization. */
export enum OrgUpdateDefaultRepositoryPermissionAuditEntryPermission {
  /** Can read, clone, push, and add collaborators to repositories. */
  Admin = 'ADMIN',
  /** No default permission value. */
  None = 'NONE',
  /** Can read and clone repositories. */
  Read = 'READ',
  /** Can read, clone and push to repositories. */
  Write = 'WRITE'
}

/** Audit log entry for a org.update_member event. */
export type OrgUpdateMemberAuditEntry = AuditEntry & Node & OrganizationAuditEntryData & {
  __typename?: 'OrgUpdateMemberAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /** The Node ID of the OrgUpdateMemberAuditEntry object */
  id: Scalars['ID']['output'];
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The new member permission level for the organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  permission?: Maybe<OrgUpdateMemberAuditEntryPermission>;
  /**
   * The former member permission level for the organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  permissionWas?: Maybe<OrgUpdateMemberAuditEntryPermission>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
};

/** The permissions available to members on an Organization. */
export enum OrgUpdateMemberAuditEntryPermission {
  /** Can read, clone, push, and add collaborators to repositories. */
  Admin = 'ADMIN',
  /** Can read and clone repositories. */
  Read = 'READ'
}

/** Audit log entry for a org.update_member_repository_creation_permission event. */
export type OrgUpdateMemberRepositoryCreationPermissionAuditEntry = AuditEntry & Node & OrganizationAuditEntryData & {
  __typename?: 'OrgUpdateMemberRepositoryCreationPermissionAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * Can members create repositories in the organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  canCreateRepositories?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /** The Node ID of the OrgUpdateMemberRepositoryCreationPermissionAuditEntry object */
  id: Scalars['ID']['output'];
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The permission for visibility level of repositories for this organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  visibility?: Maybe<OrgUpdateMemberRepositoryCreationPermissionAuditEntryVisibility>;
};

/** The permissions available for repository creation on an Organization. */
export enum OrgUpdateMemberRepositoryCreationPermissionAuditEntryVisibility {
  /** All organization members are restricted from creating any repositories. */
  All = 'ALL',
  /** All organization members are restricted from creating internal repositories. */
  Internal = 'INTERNAL',
  /** All organization members are allowed to create any repositories. */
  None = 'NONE',
  /** All organization members are restricted from creating private repositories. */
  Private = 'PRIVATE',
  /** All organization members are restricted from creating private or internal repositories. */
  PrivateInternal = 'PRIVATE_INTERNAL',
  /** All organization members are restricted from creating public repositories. */
  Public = 'PUBLIC',
  /** All organization members are restricted from creating public or internal repositories. */
  PublicInternal = 'PUBLIC_INTERNAL',
  /** All organization members are restricted from creating public or private repositories. */
  PublicPrivate = 'PUBLIC_PRIVATE'
}

/** Audit log entry for a org.update_member_repository_invitation_permission event. */
export type OrgUpdateMemberRepositoryInvitationPermissionAuditEntry = AuditEntry & Node & OrganizationAuditEntryData & {
  __typename?: 'OrgUpdateMemberRepositoryInvitationPermissionAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * Can outside collaborators be invited to repositories in the organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  canInviteOutsideCollaboratorsToRepositories?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /** The Node ID of the OrgUpdateMemberRepositoryInvitationPermissionAuditEntry object */
  id: Scalars['ID']['output'];
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
};

/** An account on GitHub, with one or more owners, that has repositories, members and teams. */
export type Organization = Actor & MemberStatusable & Node & PackageOwner & ProfileOwner & ProjectOwner & ProjectV2Owner & ProjectV2Recent & RepositoryDiscussionAuthor & RepositoryDiscussionCommentAuthor & RepositoryOwner & Sponsorable & UniformResourceLocatable & {
  __typename?: 'Organization';
  /** The announcement banner set on this organization, if any. Only visible to members of the organization's enterprise. */
  announcementBanner?: Maybe<AnnouncementBanner>;
  /** Determine if this repository owner has any items that can be pinned to their profile. */
  anyPinnableItems: Scalars['Boolean']['output'];
  /** Identifies the date and time when the organization was archived. */
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Audit log entries of the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  auditLog: OrganizationAuditEntryConnection;
  /** A URL pointing to the organization's public avatar. */
  avatarUrl: Scalars['URI']['output'];
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Identifies the primary key from the database. */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** The organization's public profile description. */
  description?: Maybe<Scalars['String']['output']>;
  /** The organization's public profile description rendered to HTML. */
  descriptionHTML?: Maybe<Scalars['String']['output']>;
  /** A list of domains owned by the organization. */
  domains?: Maybe<VerifiableDomainConnection>;
  /** The organization's public email. */
  email?: Maybe<Scalars['String']['output']>;
  /** A list of owners of the organization's enterprise account. */
  enterpriseOwners: OrganizationEnterpriseOwnerConnection;
  /** The estimated next GitHub Sponsors payout for this user/organization in cents (USD). */
  estimatedNextSponsorsPayoutInCents: Scalars['Int']['output'];
  /** True if this user/organization has a GitHub Sponsors listing. */
  hasSponsorsListing: Scalars['Boolean']['output'];
  /** The Node ID of the Organization object */
  id: Scalars['ID']['output'];
  /** Innersource security vulnerabilities scoped to this organization. */
  innersourceVulnerabilities: SecurityVulnerabilityConnection;
  /** The interaction ability settings for this organization. */
  interactionAbility?: Maybe<RepositoryInteractionAbility>;
  /** The setting value for whether the organization has an IP allow list enabled. */
  ipAllowListEnabledSetting: IpAllowListEnabledSettingValue;
  /** The IP addresses that are allowed to access resources owned by the organization. */
  ipAllowListEntries: IpAllowListEntryConnection;
  /** The setting value for whether the organization has IP allow list configuration for installed GitHub Apps enabled. */
  ipAllowListForInstalledAppsEnabledSetting: IpAllowListForInstalledAppsEnabledSettingValue;
  /** Whether the given account is sponsoring this user/organization. */
  isSponsoredBy: Scalars['Boolean']['output'];
  /** True if the viewer is sponsored by this user/organization. */
  isSponsoringViewer: Scalars['Boolean']['output'];
  /** Whether the organization has verified its profile email and website. */
  isVerified: Scalars['Boolean']['output'];
  /** A list of the organization's issue fields */
  issueFields?: Maybe<IssueFieldsConnection>;
  /** A list of the organization's issue types */
  issueTypes?: Maybe<IssueTypeConnection>;
  /**
   * Showcases a selection of repositories and gists that the profile owner has
   * either curated or that have been selected automatically based on popularity.
   */
  itemShowcase: ProfileItemShowcase;
  /**
   * Calculate how much each sponsor has ever paid total to this maintainer via
   * GitHub Sponsors. Does not include sponsorships paid via Patreon.
   */
  lifetimeReceivedSponsorshipValues: SponsorAndLifetimeValueConnection;
  /** The organization's public profile location. */
  location?: Maybe<Scalars['String']['output']>;
  /** The organization's login name. */
  login: Scalars['String']['output'];
  /** A list of all mannequins for this organization. */
  mannequins: MannequinConnection;
  /** Get the status messages members of this entity have set that are either public or visible only to the organization. */
  memberStatuses: UserStatusConnection;
  /** Members can fork private repositories in this organization */
  membersCanForkPrivateRepositories: Scalars['Boolean']['output'];
  /** A list of users who are members of this organization. */
  membersWithRole: OrganizationMemberConnection;
  /** The estimated monthly GitHub Sponsors income for this user/organization in cents (USD). */
  monthlyEstimatedSponsorsIncomeInCents: Scalars['Int']['output'];
  /** The organization's public profile name. */
  name?: Maybe<Scalars['String']['output']>;
  /** The HTTP path creating a new team */
  newTeamResourcePath: Scalars['URI']['output'];
  /** The HTTP URL creating a new team */
  newTeamUrl: Scalars['URI']['output'];
  /** Indicates if email notification delivery for this organization is restricted to verified or approved domains. */
  notificationDeliveryRestrictionEnabledSetting: NotificationRestrictionSettingValue;
  /** The billing email for the organization. */
  organizationBillingEmail?: Maybe<Scalars['String']['output']>;
  /** A list of packages under the owner. */
  packages: PackageConnection;
  /** A list of users who have been invited to join this organization. */
  pendingMembers: UserConnection;
  /** A list of repositories and gists this profile owner can pin to their profile. */
  pinnableItems: PinnableItemConnection;
  /** An ordered list of issue fields pinned to issues when no type is selected. */
  pinnedIssueFields?: Maybe<IssueFieldsConnection>;
  /** A list of repositories and gists this profile owner has pinned to their profile */
  pinnedItems: PinnableItemConnection;
  /** Returns how many more items this profile owner can pin to their profile. */
  pinnedItemsRemaining: Scalars['Int']['output'];
  /**
   * Find project by number.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  project?: Maybe<Project>;
  /** Find a project by number. */
  projectV2?: Maybe<ProjectV2>;
  /**
   * A list of projects under the owner.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  projects: ProjectConnection;
  /** The HTTP path listing organization's projects */
  projectsResourcePath: Scalars['URI']['output'];
  /** The HTTP URL listing organization's projects */
  projectsUrl: Scalars['URI']['output'];
  /** A list of projects under the owner. */
  projectsV2: ProjectV2Connection;
  /** Recent projects that this user has modified in the context of the owner. */
  recentProjects: ProjectV2Connection;
  /** A list of repositories that the user owns. */
  repositories: RepositoryConnection;
  /** Find Repository. */
  repository?: Maybe<Repository>;
  /** A list of custom properties for this organization. */
  repositoryCustomProperties?: Maybe<RepositoryCustomPropertyConnection>;
  /** Returns a single custom property from the current organization by name. */
  repositoryCustomProperty?: Maybe<RepositoryCustomProperty>;
  /** Discussion comments this user has authored. */
  repositoryDiscussionComments: DiscussionCommentConnection;
  /** Discussions this user has started. */
  repositoryDiscussions: DiscussionConnection;
  /** A list of all repository migrations for this organization. */
  repositoryMigrations: RepositoryMigrationConnection;
  /**
   * When true the organization requires all members, billing managers, and outside
   * collaborators to enable two-factor authentication.
   */
  requiresTwoFactorAuthentication?: Maybe<Scalars['Boolean']['output']>;
  /** The HTTP path for this organization. */
  resourcePath: Scalars['URI']['output'];
  /** Returns a single ruleset from the current organization by ID. */
  ruleset?: Maybe<RepositoryRuleset>;
  /** A list of rulesets for this organization. */
  rulesets?: Maybe<RepositoryRulesetConnection>;
  /**
   * The Organization's SAML identity provider. Visible to (1) organization owners,
   * (2) organization owners' personal access tokens (classic) with read:org or
   * admin:org scope, (3) GitHub App with an installation token with read or write
   * access to members.
   */
  samlIdentityProvider?: Maybe<OrganizationIdentityProvider>;
  /** List of users and organizations this entity is sponsoring. */
  sponsoring: SponsorConnection;
  /** List of sponsors for this user or organization. */
  sponsors: SponsorConnection;
  /** Events involving this sponsorable, such as new sponsorships. */
  sponsorsActivities: SponsorsActivityConnection;
  /** The GitHub Sponsors listing for this user or organization. */
  sponsorsListing?: Maybe<SponsorsListing>;
  /** The sponsorship from the viewer to this user/organization; that is, the sponsorship where you're the sponsor. */
  sponsorshipForViewerAsSponsor?: Maybe<Sponsorship>;
  /** The sponsorship from this user/organization to the viewer; that is, the sponsorship you're receiving. */
  sponsorshipForViewerAsSponsorable?: Maybe<Sponsorship>;
  /** List of sponsorship updates sent from this sponsorable to sponsors. */
  sponsorshipNewsletters: SponsorshipNewsletterConnection;
  /** The sponsorships where this user or organization is the maintainer receiving the funds. */
  sponsorshipsAsMaintainer: SponsorshipConnection;
  /** The sponsorships where this user or organization is the funder. */
  sponsorshipsAsSponsor: SponsorshipConnection;
  /** Find an organization's team by its slug. */
  team?: Maybe<Team>;
  /** A list of teams in this organization. */
  teams: TeamConnection;
  /** The HTTP path listing organization's teams */
  teamsResourcePath: Scalars['URI']['output'];
  /** The HTTP URL listing organization's teams */
  teamsUrl: Scalars['URI']['output'];
  /**
   * The amount in United States cents (e.g., 500 = $5.00 USD) that this entity has
   * spent on GitHub to fund sponsorships. Only returns a value when viewed by the
   * user themselves or by a user who can manage sponsorships for the requested organization.
   */
  totalSponsorshipAmountAsSponsorInCents?: Maybe<Scalars['Int']['output']>;
  /** The organization's Twitter username. */
  twitterUsername?: Maybe<Scalars['String']['output']>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The HTTP URL for this organization. */
  url: Scalars['URI']['output'];
  /** Organization is adminable by the viewer. */
  viewerCanAdminister: Scalars['Boolean']['output'];
  /** Can the viewer pin repositories and gists to the profile? */
  viewerCanChangePinnedItems: Scalars['Boolean']['output'];
  /**
   * Can the current viewer create new projects on this owner.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  viewerCanCreateProjects: Scalars['Boolean']['output'];
  /** Viewer can create repositories on this organization */
  viewerCanCreateRepositories: Scalars['Boolean']['output'];
  /** Viewer can create teams on this organization. */
  viewerCanCreateTeams: Scalars['Boolean']['output'];
  /** Whether or not the viewer is able to sponsor this user/organization. */
  viewerCanSponsor: Scalars['Boolean']['output'];
  /** Viewer is an active member of this organization. */
  viewerIsAMember: Scalars['Boolean']['output'];
  /** Whether or not this Organization is followed by the viewer. */
  viewerIsFollowing: Scalars['Boolean']['output'];
  /** True if the viewer is sponsoring this user/organization. */
  viewerIsSponsoring: Scalars['Boolean']['output'];
  /** Whether contributors are required to sign off on web-based commits for repositories in this organization. */
  webCommitSignoffRequired: Scalars['Boolean']['output'];
  /** The organization's public profile URL. */
  websiteUrl?: Maybe<Scalars['URI']['output']>;
};


/** An account on GitHub, with one or more owners, that has repositories, members and teams. */
export type OrganizationAnyPinnableItemsArgs = {
  type?: InputMaybe<PinnableItemType>;
};


/** An account on GitHub, with one or more owners, that has repositories, members and teams. */
export type OrganizationAuditLogArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<AuditLogOrder>;
  query?: InputMaybe<Scalars['String']['input']>;
};


/** An account on GitHub, with one or more owners, that has repositories, members and teams. */
export type OrganizationAvatarUrlArgs = {
  size?: InputMaybe<Scalars['Int']['input']>;
};


/** An account on GitHub, with one or more owners, that has repositories, members and teams. */
export type OrganizationDomainsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  isApproved?: InputMaybe<Scalars['Boolean']['input']>;
  isVerified?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<VerifiableDomainOrder>;
};


/** An account on GitHub, with one or more owners, that has repositories, members and teams. */
export type OrganizationEnterpriseOwnersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrgEnterpriseOwnerOrder>;
  organizationRole?: InputMaybe<RoleInOrganization>;
  query?: InputMaybe<Scalars['String']['input']>;
};


/** An account on GitHub, with one or more owners, that has repositories, members and teams. */
export type OrganizationInnersourceVulnerabilitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  ecosystem?: InputMaybe<SecurityAdvisoryEcosystem>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SecurityVulnerabilityOrder>;
  package?: InputMaybe<Scalars['String']['input']>;
  severities?: InputMaybe<Array<SecurityAdvisorySeverity>>;
};


/** An account on GitHub, with one or more owners, that has repositories, members and teams. */
export type OrganizationIpAllowListEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<IpAllowListEntryOrder>;
};


/** An account on GitHub, with one or more owners, that has repositories, members and teams. */
export type OrganizationIsSponsoredByArgs = {
  accountLogin: Scalars['String']['input'];
};


/** An account on GitHub, with one or more owners, that has repositories, members and teams. */
export type OrganizationIssueFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<IssueFieldOrder>;
};


/** An account on GitHub, with one or more owners, that has repositories, members and teams. */
export type OrganizationIssueTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<IssueTypeOrder>;
};


/** An account on GitHub, with one or more owners, that has repositories, members and teams. */
export type OrganizationLifetimeReceivedSponsorshipValuesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SponsorAndLifetimeValueOrder>;
};


/** An account on GitHub, with one or more owners, that has repositories, members and teams. */
export type OrganizationMannequinsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  login?: InputMaybe<Scalars['String']['input']>;
  orderBy?: InputMaybe<MannequinOrder>;
};


/** An account on GitHub, with one or more owners, that has repositories, members and teams. */
export type OrganizationMemberStatusesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UserStatusOrder>;
};


/** An account on GitHub, with one or more owners, that has repositories, members and teams. */
export type OrganizationMembersWithRoleArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** An account on GitHub, with one or more owners, that has repositories, members and teams. */
export type OrganizationPackagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  names?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  orderBy?: InputMaybe<PackageOrder>;
  packageType?: InputMaybe<PackageType>;
  repositoryId?: InputMaybe<Scalars['ID']['input']>;
};


/** An account on GitHub, with one or more owners, that has repositories, members and teams. */
export type OrganizationPendingMembersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** An account on GitHub, with one or more owners, that has repositories, members and teams. */
export type OrganizationPinnableItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  types?: InputMaybe<Array<PinnableItemType>>;
};


/** An account on GitHub, with one or more owners, that has repositories, members and teams. */
export type OrganizationPinnedIssueFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** An account on GitHub, with one or more owners, that has repositories, members and teams. */
export type OrganizationPinnedItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  types?: InputMaybe<Array<PinnableItemType>>;
};


/** An account on GitHub, with one or more owners, that has repositories, members and teams. */
export type OrganizationProjectArgs = {
  number: Scalars['Int']['input'];
};


/** An account on GitHub, with one or more owners, that has repositories, members and teams. */
export type OrganizationProjectV2Args = {
  number: Scalars['Int']['input'];
};


/** An account on GitHub, with one or more owners, that has repositories, members and teams. */
export type OrganizationProjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProjectOrder>;
  search?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Array<ProjectState>>;
};


/** An account on GitHub, with one or more owners, that has repositories, members and teams. */
export type OrganizationProjectsV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  minPermissionLevel?: InputMaybe<ProjectV2PermissionLevel>;
  orderBy?: InputMaybe<ProjectV2Order>;
  query?: InputMaybe<Scalars['String']['input']>;
};


/** An account on GitHub, with one or more owners, that has repositories, members and teams. */
export type OrganizationRecentProjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** An account on GitHub, with one or more owners, that has repositories, members and teams. */
export type OrganizationRepositoriesArgs = {
  affiliations?: InputMaybe<Array<InputMaybe<RepositoryAffiliation>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasIssuesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isFork?: InputMaybe<Scalars['Boolean']['input']>;
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<RepositoryOrder>;
  ownerAffiliations?: InputMaybe<Array<InputMaybe<RepositoryAffiliation>>>;
  privacy?: InputMaybe<RepositoryPrivacy>;
  visibility?: InputMaybe<RepositoryVisibility>;
};


/** An account on GitHub, with one or more owners, that has repositories, members and teams. */
export type OrganizationRepositoryArgs = {
  followRenames?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};


/** An account on GitHub, with one or more owners, that has repositories, members and teams. */
export type OrganizationRepositoryCustomPropertiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** An account on GitHub, with one or more owners, that has repositories, members and teams. */
export type OrganizationRepositoryCustomPropertyArgs = {
  propertyName: Scalars['String']['input'];
};


/** An account on GitHub, with one or more owners, that has repositories, members and teams. */
export type OrganizationRepositoryDiscussionCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  onlyAnswers?: InputMaybe<Scalars['Boolean']['input']>;
  repositoryId?: InputMaybe<Scalars['ID']['input']>;
};


/** An account on GitHub, with one or more owners, that has repositories, members and teams. */
export type OrganizationRepositoryDiscussionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  answered?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DiscussionOrder>;
  repositoryId?: InputMaybe<Scalars['ID']['input']>;
  states?: InputMaybe<Array<DiscussionState>>;
};


/** An account on GitHub, with one or more owners, that has repositories, members and teams. */
export type OrganizationRepositoryMigrationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<RepositoryMigrationOrder>;
  repositoryName?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<MigrationState>;
};


/** An account on GitHub, with one or more owners, that has repositories, members and teams. */
export type OrganizationRulesetArgs = {
  databaseId: Scalars['Int']['input'];
  includeParents?: InputMaybe<Scalars['Boolean']['input']>;
};


/** An account on GitHub, with one or more owners, that has repositories, members and teams. */
export type OrganizationRulesetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeParents?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  targets?: InputMaybe<Array<RepositoryRulesetTarget>>;
};


/** An account on GitHub, with one or more owners, that has repositories, members and teams. */
export type OrganizationSponsoringArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SponsorOrder>;
};


/** An account on GitHub, with one or more owners, that has repositories, members and teams. */
export type OrganizationSponsorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SponsorOrder>;
  tierId?: InputMaybe<Scalars['ID']['input']>;
};


/** An account on GitHub, with one or more owners, that has repositories, members and teams. */
export type OrganizationSponsorsActivitiesArgs = {
  actions?: InputMaybe<Array<SponsorsActivityAction>>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeAsSponsor?: InputMaybe<Scalars['Boolean']['input']>;
  includePrivate?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SponsorsActivityOrder>;
  period?: InputMaybe<SponsorsActivityPeriod>;
  since?: InputMaybe<Scalars['DateTime']['input']>;
  until?: InputMaybe<Scalars['DateTime']['input']>;
};


/** An account on GitHub, with one or more owners, that has repositories, members and teams. */
export type OrganizationSponsorshipForViewerAsSponsorArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


/** An account on GitHub, with one or more owners, that has repositories, members and teams. */
export type OrganizationSponsorshipForViewerAsSponsorableArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


/** An account on GitHub, with one or more owners, that has repositories, members and teams. */
export type OrganizationSponsorshipNewslettersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SponsorshipNewsletterOrder>;
};


/** An account on GitHub, with one or more owners, that has repositories, members and teams. */
export type OrganizationSponsorshipsAsMaintainerArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includePrivate?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SponsorshipOrder>;
};


/** An account on GitHub, with one or more owners, that has repositories, members and teams. */
export type OrganizationSponsorshipsAsSponsorArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maintainerLogins?: InputMaybe<Array<Scalars['String']['input']>>;
  orderBy?: InputMaybe<SponsorshipOrder>;
};


/** An account on GitHub, with one or more owners, that has repositories, members and teams. */
export type OrganizationTeamArgs = {
  slug: Scalars['String']['input'];
};


/** An account on GitHub, with one or more owners, that has repositories, members and teams. */
export type OrganizationTeamsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  ldapMapped?: InputMaybe<Scalars['Boolean']['input']>;
  notificationSetting?: InputMaybe<TeamNotificationSetting>;
  orderBy?: InputMaybe<TeamOrder>;
  privacy?: InputMaybe<TeamPrivacy>;
  query?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<TeamRole>;
  rootTeamsOnly?: InputMaybe<Scalars['Boolean']['input']>;
  userLogins?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** An account on GitHub, with one or more owners, that has repositories, members and teams. */
export type OrganizationTotalSponsorshipAmountAsSponsorInCentsArgs = {
  since?: InputMaybe<Scalars['DateTime']['input']>;
  sponsorableLogins?: InputMaybe<Array<Scalars['String']['input']>>;
  until?: InputMaybe<Scalars['DateTime']['input']>;
};

/** An audit entry in an organization audit log. */
export type OrganizationAuditEntry = MembersCanDeleteReposClearAuditEntry | MembersCanDeleteReposDisableAuditEntry | MembersCanDeleteReposEnableAuditEntry | OauthApplicationCreateAuditEntry | OrgAddBillingManagerAuditEntry | OrgAddMemberAuditEntry | OrgBlockUserAuditEntry | OrgConfigDisableCollaboratorsOnlyAuditEntry | OrgConfigEnableCollaboratorsOnlyAuditEntry | OrgCreateAuditEntry | OrgDisableOauthAppRestrictionsAuditEntry | OrgDisableSamlAuditEntry | OrgDisableTwoFactorRequirementAuditEntry | OrgEnableOauthAppRestrictionsAuditEntry | OrgEnableSamlAuditEntry | OrgEnableTwoFactorRequirementAuditEntry | OrgInviteMemberAuditEntry | OrgInviteToBusinessAuditEntry | OrgOauthAppAccessApprovedAuditEntry | OrgOauthAppAccessBlockedAuditEntry | OrgOauthAppAccessDeniedAuditEntry | OrgOauthAppAccessRequestedAuditEntry | OrgOauthAppAccessUnblockedAuditEntry | OrgRemoveBillingManagerAuditEntry | OrgRemoveMemberAuditEntry | OrgRemoveOutsideCollaboratorAuditEntry | OrgRestoreMemberAuditEntry | OrgUnblockUserAuditEntry | OrgUpdateDefaultRepositoryPermissionAuditEntry | OrgUpdateMemberAuditEntry | OrgUpdateMemberRepositoryCreationPermissionAuditEntry | OrgUpdateMemberRepositoryInvitationPermissionAuditEntry | PrivateRepositoryForkingDisableAuditEntry | PrivateRepositoryForkingEnableAuditEntry | RepoAccessAuditEntry | RepoAddMemberAuditEntry | RepoAddTopicAuditEntry | RepoArchivedAuditEntry | RepoChangeMergeSettingAuditEntry | RepoConfigDisableAnonymousGitAccessAuditEntry | RepoConfigDisableCollaboratorsOnlyAuditEntry | RepoConfigDisableContributorsOnlyAuditEntry | RepoConfigDisableSockpuppetDisallowedAuditEntry | RepoConfigEnableAnonymousGitAccessAuditEntry | RepoConfigEnableCollaboratorsOnlyAuditEntry | RepoConfigEnableContributorsOnlyAuditEntry | RepoConfigEnableSockpuppetDisallowedAuditEntry | RepoConfigLockAnonymousGitAccessAuditEntry | RepoConfigUnlockAnonymousGitAccessAuditEntry | RepoCreateAuditEntry | RepoDestroyAuditEntry | RepoRemoveMemberAuditEntry | RepoRemoveTopicAuditEntry | RepositoryVisibilityChangeDisableAuditEntry | RepositoryVisibilityChangeEnableAuditEntry | TeamAddMemberAuditEntry | TeamAddRepositoryAuditEntry | TeamChangeParentTeamAuditEntry | TeamRemoveMemberAuditEntry | TeamRemoveRepositoryAuditEntry;

/** The connection type for OrganizationAuditEntry. */
export type OrganizationAuditEntryConnection = {
  __typename?: 'OrganizationAuditEntryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OrganizationAuditEntryEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<OrganizationAuditEntry>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** Metadata for an audit entry with action org.* */
export type OrganizationAuditEntryData = {
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
};

/** An edge in a connection. */
export type OrganizationAuditEntryEdge = {
  __typename?: 'OrganizationAuditEntryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<OrganizationAuditEntry>;
};

/** A list of organizations managed by an enterprise. */
export type OrganizationConnection = {
  __typename?: 'OrganizationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OrganizationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Organization>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OrganizationEdge = {
  __typename?: 'OrganizationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Organization>;
};

/** The connection type for User. */
export type OrganizationEnterpriseOwnerConnection = {
  __typename?: 'OrganizationEnterpriseOwnerConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OrganizationEnterpriseOwnerEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<User>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An enterprise owner in the context of an organization that is part of the enterprise. */
export type OrganizationEnterpriseOwnerEdge = {
  __typename?: 'OrganizationEnterpriseOwnerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<User>;
  /** The role of the owner with respect to the organization. */
  organizationRole: RoleInOrganization;
};

/**
 * An Identity Provider configured to provision SAML and SCIM identities for
 * Organizations. Visible to (1) organization owners, (2) organization owners'
 * personal access tokens (classic) with read:org or admin:org scope, (3) GitHub
 * App with an installation token with read or write access to members.
 */
export type OrganizationIdentityProvider = Node & {
  __typename?: 'OrganizationIdentityProvider';
  /** The digest algorithm used to sign SAML requests for the Identity Provider. */
  digestMethod?: Maybe<Scalars['URI']['output']>;
  /** External Identities provisioned by this Identity Provider */
  externalIdentities: ExternalIdentityConnection;
  /** The Node ID of the OrganizationIdentityProvider object */
  id: Scalars['ID']['output'];
  /** The x509 certificate used by the Identity Provider to sign assertions and responses. */
  idpCertificate?: Maybe<Scalars['X509Certificate']['output']>;
  /** The Issuer Entity ID for the SAML Identity Provider */
  issuer?: Maybe<Scalars['String']['output']>;
  /** Organization this Identity Provider belongs to */
  organization?: Maybe<Organization>;
  /** The signature algorithm used to sign SAML requests for the Identity Provider. */
  signatureMethod?: Maybe<Scalars['URI']['output']>;
  /** The URL endpoint for the Identity Provider's SAML SSO. */
  ssoUrl?: Maybe<Scalars['URI']['output']>;
};


/**
 * An Identity Provider configured to provision SAML and SCIM identities for
 * Organizations. Visible to (1) organization owners, (2) organization owners'
 * personal access tokens (classic) with read:org or admin:org scope, (3) GitHub
 * App with an installation token with read or write access to members.
 */
export type OrganizationIdentityProviderExternalIdentitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  login?: InputMaybe<Scalars['String']['input']>;
  membersOnly?: InputMaybe<Scalars['Boolean']['input']>;
  userName?: InputMaybe<Scalars['String']['input']>;
};

/** An Invitation for a user to an organization. */
export type OrganizationInvitation = Node & {
  __typename?: 'OrganizationInvitation';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The email address of the user invited to the organization. */
  email?: Maybe<Scalars['String']['output']>;
  /** The Node ID of the OrganizationInvitation object */
  id: Scalars['ID']['output'];
  /** The source of the invitation. */
  invitationSource: OrganizationInvitationSource;
  /** The type of invitation that was sent (e.g. email, user). */
  invitationType: OrganizationInvitationType;
  /** The user who was invited to the organization. */
  invitee?: Maybe<User>;
  /**
   * The user who created the invitation.
   * @deprecated `inviter` will be removed. `inviter` will be replaced by `inviterActor`. Removal on 2024-07-01 UTC.
   */
  inviter: User;
  /** The user who created the invitation. */
  inviterActor?: Maybe<User>;
  /** The organization the invite is for */
  organization: Organization;
  /** The user's pending role in the organization (e.g. member, owner). */
  role: OrganizationInvitationRole;
};

/** The connection type for OrganizationInvitation. */
export type OrganizationInvitationConnection = {
  __typename?: 'OrganizationInvitationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OrganizationInvitationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<OrganizationInvitation>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type OrganizationInvitationEdge = {
  __typename?: 'OrganizationInvitationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<OrganizationInvitation>;
};

/** The possible organization invitation roles. */
export enum OrganizationInvitationRole {
  /** The user is invited to be an admin of the organization. */
  Admin = 'ADMIN',
  /** The user is invited to be a billing manager of the organization. */
  BillingManager = 'BILLING_MANAGER',
  /** The user is invited to be a direct member of the organization. */
  DirectMember = 'DIRECT_MEMBER',
  /** The user's previous role will be reinstated. */
  Reinstate = 'REINSTATE'
}

/** The possible organization invitation sources. */
export enum OrganizationInvitationSource {
  /** The invitation was created with an enterprise organization */
  EnterpriseOrganizationCreation = 'ENTERPRISE_ORGANIZATION_CREATION',
  /** The invitation was created from the web interface or from API */
  Member = 'MEMBER',
  /** The invitation was created from SCIM */
  Scim = 'SCIM',
  /** The invitation was sent before this feature was added */
  Unknown = 'UNKNOWN'
}

/** The possible organization invitation types. */
export enum OrganizationInvitationType {
  /** The invitation was to an email address. */
  Email = 'EMAIL',
  /** The invitation was to an existing user. */
  User = 'USER'
}

/** A list of users who belong to the organization. */
export type OrganizationMemberConnection = {
  __typename?: 'OrganizationMemberConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<OrganizationMemberEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<User>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** Represents a user within an organization. */
export type OrganizationMemberEdge = {
  __typename?: 'OrganizationMemberEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** Whether the organization member has two factor enabled or not. Returns null if information is not available to viewer. */
  hasTwoFactorEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** The item at the end of the edge. */
  node?: Maybe<User>;
  /** The role this user has in the organization. */
  role?: Maybe<OrganizationMemberRole>;
};

/** The possible roles within an organization for its members. */
export enum OrganizationMemberRole {
  /** The user is an administrator of the organization. */
  Admin = 'ADMIN',
  /** The user is a member of the organization. */
  Member = 'MEMBER'
}

/** The possible values for the members can create repositories setting on an organization. */
export enum OrganizationMembersCanCreateRepositoriesSettingValue {
  /** Members will be able to create public and private repositories. */
  All = 'ALL',
  /** Members will not be able to create public or private repositories. */
  Disabled = 'DISABLED',
  /** Members will be able to create only internal repositories. */
  Internal = 'INTERNAL',
  /** Members will be able to create only private repositories. */
  Private = 'PRIVATE'
}

/** A GitHub Enterprise Importer (GEI) organization migration. */
export type OrganizationMigration = Node & {
  __typename?: 'OrganizationMigration';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Identifies the primary key from the database. */
  databaseId?: Maybe<Scalars['String']['output']>;
  /** The reason the organization migration failed. */
  failureReason?: Maybe<Scalars['String']['output']>;
  /** The Node ID of the OrganizationMigration object */
  id: Scalars['ID']['output'];
  /** The remaining amount of repos to be migrated. */
  remainingRepositoriesCount?: Maybe<Scalars['Int']['output']>;
  /** The name of the source organization to be migrated. */
  sourceOrgName: Scalars['String']['output'];
  /** The URL of the source organization to migrate. */
  sourceOrgUrl: Scalars['URI']['output'];
  /** The migration state. */
  state: OrganizationMigrationState;
  /** The name of the target organization. */
  targetOrgName: Scalars['String']['output'];
  /** The total amount of repositories to be migrated. */
  totalRepositoriesCount?: Maybe<Scalars['Int']['output']>;
};

/** The Octoshift Organization migration state. */
export enum OrganizationMigrationState {
  /** The Octoshift migration has failed. */
  Failed = 'FAILED',
  /** The Octoshift migration has invalid credentials. */
  FailedValidation = 'FAILED_VALIDATION',
  /** The Octoshift migration is in progress. */
  InProgress = 'IN_PROGRESS',
  /** The Octoshift migration has not started. */
  NotStarted = 'NOT_STARTED',
  /** The Octoshift migration needs to have its credentials validated. */
  PendingValidation = 'PENDING_VALIDATION',
  /** The Octoshift migration is performing post repository migrations. */
  PostRepoMigration = 'POST_REPO_MIGRATION',
  /** The Octoshift migration is performing pre repository migrations. */
  PreRepoMigration = 'PRE_REPO_MIGRATION',
  /** The Octoshift migration has been queued. */
  Queued = 'QUEUED',
  /** The Octoshift org migration is performing repository migrations. */
  RepoMigration = 'REPO_MIGRATION',
  /** The Octoshift migration has succeeded. */
  Succeeded = 'SUCCEEDED'
}

/** Used for argument of CreateProjectV2 mutation. */
export type OrganizationOrUser = Organization | User;

/** Ordering options for organization connections. */
export type OrganizationOrder = {
  /** The ordering direction. */
  direction: OrderDirection;
  /** The field to order organizations by. */
  field: OrganizationOrderField;
};

/** Properties by which organization connections can be ordered. */
export enum OrganizationOrderField {
  /** Order organizations by creation time */
  CreatedAt = 'CREATED_AT',
  /** Order organizations by login */
  Login = 'LOGIN'
}

/** Parameters to be used for the organization_property condition */
export type OrganizationPropertyConditionTarget = {
  __typename?: 'OrganizationPropertyConditionTarget';
  /** Array of organization properties that must not match. */
  exclude: Array<OrganizationPropertyTargetDefinition>;
  /** Array of organization properties that must match */
  include: Array<OrganizationPropertyTargetDefinition>;
};

/** Parameters to be used for the organization_property condition */
export type OrganizationPropertyConditionTargetInput = {
  /** Array of organization properties that must not match. */
  exclude: Array<OrganizationPropertyTargetDefinitionInput>;
  /** Array of organization properties that must match */
  include: Array<OrganizationPropertyTargetDefinitionInput>;
};

/** A property that must match */
export type OrganizationPropertyTargetDefinition = {
  __typename?: 'OrganizationPropertyTargetDefinition';
  /** The name of the property */
  name: Scalars['String']['output'];
  /** The values to match for */
  propertyValues: Array<Scalars['String']['output']>;
};

/** A property that must match */
export type OrganizationPropertyTargetDefinitionInput = {
  /** The name of the property */
  name: Scalars['String']['input'];
  /** The values to match for */
  propertyValues: Array<Scalars['String']['input']>;
};

/** An organization teams hovercard context */
export type OrganizationTeamsHovercardContext = HovercardContext & {
  __typename?: 'OrganizationTeamsHovercardContext';
  /** A string describing this context */
  message: Scalars['String']['output'];
  /** An octicon to accompany this context */
  octicon: Scalars['String']['output'];
  /** Teams in this organization the user is a member of that are relevant */
  relevantTeams: TeamConnection;
  /** The path for the full team list for this user */
  teamsResourcePath: Scalars['URI']['output'];
  /** The URL for the full team list for this user */
  teamsUrl: Scalars['URI']['output'];
  /** The total number of teams the user is on in the organization */
  totalTeamCount: Scalars['Int']['output'];
};


/** An organization teams hovercard context */
export type OrganizationTeamsHovercardContextRelevantTeamsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** An organization list hovercard context */
export type OrganizationsHovercardContext = HovercardContext & {
  __typename?: 'OrganizationsHovercardContext';
  /** A string describing this context */
  message: Scalars['String']['output'];
  /** An octicon to accompany this context */
  octicon: Scalars['String']['output'];
  /** Organizations this user is a member of that are relevant */
  relevantOrganizations: OrganizationConnection;
  /** The total number of organizations this user is in */
  totalOrganizationCount: Scalars['Int']['output'];
};


/** An organization list hovercard context */
export type OrganizationsHovercardContextRelevantOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrganizationOrder>;
};

/** Information for an uploaded package. */
export type Package = Node & {
  __typename?: 'Package';
  /** The Node ID of the Package object */
  id: Scalars['ID']['output'];
  /** Find the latest version for the package. */
  latestVersion?: Maybe<PackageVersion>;
  /** Identifies the name of the package. */
  name: Scalars['String']['output'];
  /** Identifies the type of the package. */
  packageType: PackageType;
  /** The repository this package belongs to. */
  repository?: Maybe<Repository>;
  /** Statistics about package activity. */
  statistics?: Maybe<PackageStatistics>;
  /** Find package version by version string. */
  version?: Maybe<PackageVersion>;
  /** list of versions for this package */
  versions: PackageVersionConnection;
};


/** Information for an uploaded package. */
export type PackageVersionArgs = {
  version: Scalars['String']['input'];
};


/** Information for an uploaded package. */
export type PackageVersionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PackageVersionOrder>;
};

/** The connection type for Package. */
export type PackageConnection = {
  __typename?: 'PackageConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PackageEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Package>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PackageEdge = {
  __typename?: 'PackageEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Package>;
};

/** A file in a package version. */
export type PackageFile = Node & {
  __typename?: 'PackageFile';
  /** The Node ID of the PackageFile object */
  id: Scalars['ID']['output'];
  /** MD5 hash of the file. */
  md5?: Maybe<Scalars['String']['output']>;
  /** Name of the file. */
  name: Scalars['String']['output'];
  /** The package version this file belongs to. */
  packageVersion?: Maybe<PackageVersion>;
  /** SHA1 hash of the file. */
  sha1?: Maybe<Scalars['String']['output']>;
  /** SHA256 hash of the file. */
  sha256?: Maybe<Scalars['String']['output']>;
  /** Size of the file in bytes. */
  size?: Maybe<Scalars['Int']['output']>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** URL to download the asset. */
  url?: Maybe<Scalars['URI']['output']>;
};

/** The connection type for PackageFile. */
export type PackageFileConnection = {
  __typename?: 'PackageFileConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PackageFileEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PackageFile>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PackageFileEdge = {
  __typename?: 'PackageFileEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PackageFile>;
};

/** Ways in which lists of package files can be ordered upon return. */
export type PackageFileOrder = {
  /** The direction in which to order package files by the specified field. */
  direction?: InputMaybe<OrderDirection>;
  /** The field in which to order package files by. */
  field?: InputMaybe<PackageFileOrderField>;
};

/** Properties by which package file connections can be ordered. */
export enum PackageFileOrderField {
  /** Order package files by creation time */
  CreatedAt = 'CREATED_AT'
}

/** Ways in which lists of packages can be ordered upon return. */
export type PackageOrder = {
  /** The direction in which to order packages by the specified field. */
  direction?: InputMaybe<OrderDirection>;
  /** The field in which to order packages by. */
  field?: InputMaybe<PackageOrderField>;
};

/** Properties by which package connections can be ordered. */
export enum PackageOrderField {
  /** Order packages by creation time */
  CreatedAt = 'CREATED_AT'
}

/** Represents an owner of a package. */
export type PackageOwner = {
  /** The Node ID of the PackageOwner object */
  id: Scalars['ID']['output'];
  /** A list of packages under the owner. */
  packages: PackageConnection;
};


/** Represents an owner of a package. */
export type PackageOwnerPackagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  names?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  orderBy?: InputMaybe<PackageOrder>;
  packageType?: InputMaybe<PackageType>;
  repositoryId?: InputMaybe<Scalars['ID']['input']>;
};

/** Represents a object that contains package activity statistics such as downloads. */
export type PackageStatistics = {
  __typename?: 'PackageStatistics';
  /** Number of times the package was downloaded since it was created. */
  downloadsTotalCount: Scalars['Int']['output'];
};

/** A version tag contains the mapping between a tag name and a version. */
export type PackageTag = Node & {
  __typename?: 'PackageTag';
  /** The Node ID of the PackageTag object */
  id: Scalars['ID']['output'];
  /** Identifies the tag name of the version. */
  name: Scalars['String']['output'];
  /** Version that the tag is associated with. */
  version?: Maybe<PackageVersion>;
};

/** The possible types of a package. */
export enum PackageType {
  /** A debian package. */
  Debian = 'DEBIAN',
  /**
   * A docker image.
   * @deprecated DOCKER will be removed from this enum as this type will be migrated to only be used by the Packages REST API. Removal on 2021-06-21 UTC.
   */
  Docker = 'DOCKER',
  /**
   * A maven package.
   * @deprecated MAVEN will be removed from this enum as this type will be migrated to only be used by the Packages REST API. Removal on 2023-02-10 UTC.
   */
  Maven = 'MAVEN',
  /**
   * An npm package.
   * @deprecated NPM will be removed from this enum as this type will be migrated to only be used by the Packages REST API. Removal on 2022-11-21 UTC.
   */
  Npm = 'NPM',
  /**
   * A nuget package.
   * @deprecated NUGET will be removed from this enum as this type will be migrated to only be used by the Packages REST API. Removal on 2022-11-21 UTC.
   */
  Nuget = 'NUGET',
  /** A python package. */
  Pypi = 'PYPI',
  /**
   * A rubygems package.
   * @deprecated RUBYGEMS will be removed from this enum as this type will be migrated to only be used by the Packages REST API. Removal on 2022-12-28 UTC.
   */
  Rubygems = 'RUBYGEMS'
}

/** Information about a specific package version. */
export type PackageVersion = Node & {
  __typename?: 'PackageVersion';
  /** List of files associated with this package version */
  files: PackageFileConnection;
  /** The Node ID of the PackageVersion object */
  id: Scalars['ID']['output'];
  /** The package associated with this version. */
  package?: Maybe<Package>;
  /** The platform this version was built for. */
  platform?: Maybe<Scalars['String']['output']>;
  /** Whether or not this version is a pre-release. */
  preRelease: Scalars['Boolean']['output'];
  /** The README of this package version. */
  readme?: Maybe<Scalars['String']['output']>;
  /** The release associated with this package version. */
  release?: Maybe<Release>;
  /** Statistics about package activity. */
  statistics?: Maybe<PackageVersionStatistics>;
  /** The package version summary. */
  summary?: Maybe<Scalars['String']['output']>;
  /** The version string. */
  version: Scalars['String']['output'];
};


/** Information about a specific package version. */
export type PackageVersionFilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PackageFileOrder>;
};

/** The connection type for PackageVersion. */
export type PackageVersionConnection = {
  __typename?: 'PackageVersionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PackageVersionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PackageVersion>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PackageVersionEdge = {
  __typename?: 'PackageVersionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PackageVersion>;
};

/** Ways in which lists of package versions can be ordered upon return. */
export type PackageVersionOrder = {
  /** The direction in which to order package versions by the specified field. */
  direction?: InputMaybe<OrderDirection>;
  /** The field in which to order package versions by. */
  field?: InputMaybe<PackageVersionOrderField>;
};

/** Properties by which package version connections can be ordered. */
export enum PackageVersionOrderField {
  /** Order package versions by creation time */
  CreatedAt = 'CREATED_AT'
}

/** Represents a object that contains package version activity statistics such as downloads. */
export type PackageVersionStatistics = {
  __typename?: 'PackageVersionStatistics';
  /** Number of times the package was downloaded since it was created. */
  downloadsTotalCount: Scalars['Int']['output'];
};

/** Information about pagination in a connection. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']['output']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean']['output'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean']['output'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']['output']>;
};

/** Represents a 'parent_issue_added' event on a given issue. */
export type ParentIssueAddedEvent = Node & {
  __typename?: 'ParentIssueAddedEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The Node ID of the ParentIssueAddedEvent object */
  id: Scalars['ID']['output'];
  /** The parent issue added. */
  parent?: Maybe<Issue>;
};

/** Represents a 'parent_issue_removed' event on a given issue. */
export type ParentIssueRemovedEvent = Node & {
  __typename?: 'ParentIssueRemovedEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The Node ID of the ParentIssueRemovedEvent object */
  id: Scalars['ID']['output'];
  /** The parent issue removed. */
  parent?: Maybe<Issue>;
};

/** The possible types of patch statuses. */
export enum PatchStatus {
  /** The file was added. Git status 'A'. */
  Added = 'ADDED',
  /** The file's type was changed. Git status 'T'. */
  Changed = 'CHANGED',
  /** The file was copied. Git status 'C'. */
  Copied = 'COPIED',
  /** The file was deleted. Git status 'D'. */
  Deleted = 'DELETED',
  /** The file's contents were changed. Git status 'M'. */
  Modified = 'MODIFIED',
  /** The file was renamed. Git status 'R'. */
  Renamed = 'RENAMED'
}

/** A pending suggestion to assign a user to an issue. */
export type PendingAssigneeSuggestion = Node & {
  __typename?: 'PendingAssigneeSuggestion';
  /** The actor who suggested the assignee. */
  actor?: Maybe<Actor>;
  /** The suggested assignee. */
  assignee?: Maybe<Assignee>;
  /** When the suggestion was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The Node ID of the PendingAssigneeSuggestion object */
  id: Scalars['ID']['output'];
  /** The rationale provided for suggesting this assignee. */
  rationale?: Maybe<Scalars['String']['output']>;
  /** When the suggestion was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** A pending suggestion to close an issue. */
export type PendingCloseSuggestion = Node & {
  __typename?: 'PendingCloseSuggestion';
  /** The actor who suggested closing the issue. */
  actor?: Maybe<Actor>;
  /** When the suggestion was created. */
  createdAt: Scalars['DateTime']['output'];
  /**
   * The issue or pull request the suggestion proposes marking this issue as a
   * duplicate of. Only set when `stateReason` is `DUPLICATE`.
   */
  duplicateOf?: Maybe<IssueOrPullRequest>;
  /** The Node ID of the PendingCloseSuggestion object */
  id: Scalars['ID']['output'];
  /** The rationale provided for suggesting this close. */
  rationale?: Maybe<Scalars['String']['output']>;
  /** The state reason the suggestion would apply when closing the issue. */
  stateReason?: Maybe<IssueStateReason>;
  /** When the suggestion was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** A pending suggestion to set an issue field's value. */
export type PendingFieldSuggestion = Node & {
  __typename?: 'PendingFieldSuggestion';
  /** The actor who suggested the field value. */
  actor?: Maybe<Actor>;
  /** When the suggestion was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The Node ID of the PendingFieldSuggestion object */
  id: Scalars['ID']['output'];
  /** The issue field the suggestion targets. */
  issueField?: Maybe<IssueFields>;
  /** The rationale provided for suggesting this field value. */
  rationale?: Maybe<Scalars['String']['output']>;
  /** The suggested value for the field, as a string representation of the value originally provided. */
  suggestedValue?: Maybe<Scalars['String']['output']>;
  /** When the suggestion was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** A pending suggestion for an issue. May target the issue's type, labels, field values, assignees, or close state. */
export type PendingIssueSuggestion = PendingAssigneeSuggestion | PendingCloseSuggestion | PendingFieldSuggestion | PendingLabelSuggestion | PendingTypeSuggestion;

/** The kind of pending issue suggestion being applied. */
export enum PendingIssueSuggestionKind {
  /** Add the suggested assignee to the issue. */
  Assignee = 'ASSIGNEE',
  /** Close the issue with the suggested state reason (and duplicate target, when applicable). */
  Close = 'CLOSE',
  /** Set the suggested issue field value on the issue. */
  Field = 'FIELD',
  /** Add the suggested label to the issue. */
  Label = 'LABEL',
  /** Set the issue's type to the suggested issue type. */
  Type = 'TYPE'
}

/** A reference to a single pending issue suggestion to apply. */
export type PendingIssueSuggestionRef = {
  /** The ID of the suggested assignee. Required when kind is ASSIGNEE. */
  assigneeId?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the suggested issue field. Required when kind is FIELD. */
  issueFieldId?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the suggested issue type. Required when kind is TYPE. */
  issueTypeId?: InputMaybe<Scalars['ID']['input']>;
  /** The kind of suggestion to apply. */
  kind: PendingIssueSuggestionKind;
  /** The ID of the suggested label. Required when kind is LABEL. */
  labelId?: InputMaybe<Scalars['ID']['input']>;
};

/** A pending suggestion to add a label to an issue. */
export type PendingLabelSuggestion = Node & {
  __typename?: 'PendingLabelSuggestion';
  /** The actor who suggested the label. */
  actor?: Maybe<Actor>;
  /** When the suggestion was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The Node ID of the PendingLabelSuggestion object */
  id: Scalars['ID']['output'];
  /** The suggested label. */
  label?: Maybe<Label>;
  /** The rationale provided for suggesting this label. */
  rationale?: Maybe<Scalars['String']['output']>;
  /** When the suggestion was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** A pending suggestion to change an issue's type. */
export type PendingTypeSuggestion = Node & {
  __typename?: 'PendingTypeSuggestion';
  /** The actor who suggested the type change. */
  actor?: Maybe<Actor>;
  /** When the suggestion was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The Node ID of the PendingTypeSuggestion object */
  id: Scalars['ID']['output'];
  /** The suggested issue type. */
  issueType?: Maybe<IssueType>;
  /** The rationale provided for suggesting this type change. */
  rationale?: Maybe<Scalars['String']['output']>;
  /** When the suggestion was last updated. */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** Types that can grant permissions on a repository to a user */
export type PermissionGranter = EnterpriseTeam | Organization | Repository | Team;

/** A level of permission and source for a user's access to a repository. */
export type PermissionSource = {
  __typename?: 'PermissionSource';
  /** The organization the repository belongs to. */
  organization: Organization;
  /** The level of access this source has granted to the user. */
  permission: DefaultRepositoryPermissionField;
  /** The name of the role this source has granted to the user. */
  roleName?: Maybe<Scalars['String']['output']>;
  /** The source of this permission. */
  source: PermissionGranter;
};

/** Autogenerated input type of PinEnvironment */
export type PinEnvironmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the environment to modify */
  environmentId: Scalars['ID']['input'];
  /** The desired state of the environment. If true, environment will be pinned. If false, it will be unpinned. */
  pinned: Scalars['Boolean']['input'];
};

/** Autogenerated return type of PinEnvironment. */
export type PinEnvironmentPayload = {
  __typename?: 'PinEnvironmentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The environment that was pinned */
  environment?: Maybe<Environment>;
  /** The pinned environment if we pinned */
  pinnedEnvironment?: Maybe<PinnedEnvironment>;
};

/** Autogenerated input type of PinIssueComment */
export type PinIssueCommentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the Issue Comment to pin. Comment pinning is not supported on Pull Requests. */
  issueCommentId: Scalars['ID']['input'];
};

/** Autogenerated return type of PinIssueComment. */
export type PinIssueCommentPayload = {
  __typename?: 'PinIssueCommentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The Issue Comment that was pinned */
  issueComment?: Maybe<IssueComment>;
};

/** Autogenerated input type of PinIssue */
export type PinIssueInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the issue to be pinned */
  issueId: Scalars['ID']['input'];
};

/** Autogenerated return type of PinIssue. */
export type PinIssuePayload = {
  __typename?: 'PinIssuePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The issue that was pinned */
  issue?: Maybe<Issue>;
};

/** Entities that can be pinned. */
export type Pinnable = {
  /** Indicates whether or not this entity is currently pinned. */
  isPinned?: Maybe<Scalars['Boolean']['output']>;
  /** Identifies the date and time when this entity was pinned. */
  pinnedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user who pinned this entity. */
  pinnedBy?: Maybe<User>;
  /** Check if the current viewer can pin this entity. */
  viewerCanPin: Scalars['Boolean']['output'];
  /** Check if the current viewer can unpin this entity. */
  viewerCanUnpin: Scalars['Boolean']['output'];
};

/** Types that can be pinned to a profile page. */
export type PinnableItem = Gist | Repository;

/** The connection type for PinnableItem. */
export type PinnableItemConnection = {
  __typename?: 'PinnableItemConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PinnableItemEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PinnableItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PinnableItemEdge = {
  __typename?: 'PinnableItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PinnableItem>;
};

/** Represents items that can be pinned to a profile page or dashboard. */
export enum PinnableItemType {
  /** A gist. */
  Gist = 'GIST',
  /** An issue. */
  Issue = 'ISSUE',
  /** An organization. */
  Organization = 'ORGANIZATION',
  /** A project. */
  Project = 'PROJECT',
  /** A pull request. */
  PullRequest = 'PULL_REQUEST',
  /** A repository. */
  Repository = 'REPOSITORY',
  /** A team. */
  Team = 'TEAM',
  /** A user. */
  User = 'USER'
}

/** A Pinned Discussion is a discussion pinned to a repository's index page. */
export type PinnedDiscussion = Node & RepositoryNode & {
  __typename?: 'PinnedDiscussion';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Identifies the primary key from the database. */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** The discussion that was pinned. */
  discussion: Discussion;
  /** Color stops of the chosen gradient */
  gradientStopColors: Array<Scalars['String']['output']>;
  /** The Node ID of the PinnedDiscussion object */
  id: Scalars['ID']['output'];
  /** Background texture pattern */
  pattern: PinnedDiscussionPattern;
  /** The actor that pinned this discussion. */
  pinnedBy: Actor;
  /** Preconfigured background gradient option */
  preconfiguredGradient?: Maybe<PinnedDiscussionGradient>;
  /** The repository associated with this node. */
  repository: Repository;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** The connection type for PinnedDiscussion. */
export type PinnedDiscussionConnection = {
  __typename?: 'PinnedDiscussionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PinnedDiscussionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PinnedDiscussion>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PinnedDiscussionEdge = {
  __typename?: 'PinnedDiscussionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PinnedDiscussion>;
};

/** Preconfigured gradients that may be used to style discussions pinned within a repository. */
export enum PinnedDiscussionGradient {
  /** A gradient of blue to mint */
  BlueMint = 'BLUE_MINT',
  /** A gradient of blue to purple */
  BluePurple = 'BLUE_PURPLE',
  /** A gradient of pink to blue */
  PinkBlue = 'PINK_BLUE',
  /** A gradient of purple to coral */
  PurpleCoral = 'PURPLE_CORAL',
  /** A gradient of red to orange */
  RedOrange = 'RED_ORANGE'
}

/** Preconfigured background patterns that may be used to style discussions pinned within a repository. */
export enum PinnedDiscussionPattern {
  /** An upward-facing chevron pattern */
  ChevronUp = 'CHEVRON_UP',
  /** A hollow dot pattern */
  Dot = 'DOT',
  /** A solid dot pattern */
  DotFill = 'DOT_FILL',
  /** A heart pattern */
  HeartFill = 'HEART_FILL',
  /** A plus sign pattern */
  Plus = 'PLUS',
  /** A lightning bolt pattern */
  Zap = 'ZAP'
}

/** Represents a pinned environment on a given repository */
export type PinnedEnvironment = Node & {
  __typename?: 'PinnedEnvironment';
  /** Identifies the date and time when the pinned environment was created */
  createdAt: Scalars['DateTime']['output'];
  /** Identifies the primary key from the database. */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** Identifies the environment associated. */
  environment: Environment;
  /** The Node ID of the PinnedEnvironment object */
  id: Scalars['ID']['output'];
  /** Identifies the position of the pinned environment. */
  position: Scalars['Int']['output'];
  /** The repository that this environment was pinned to. */
  repository: Repository;
};

/** The connection type for PinnedEnvironment. */
export type PinnedEnvironmentConnection = {
  __typename?: 'PinnedEnvironmentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PinnedEnvironmentEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PinnedEnvironment>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PinnedEnvironmentEdge = {
  __typename?: 'PinnedEnvironmentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PinnedEnvironment>;
};

/** Ordering options for pinned environments */
export type PinnedEnvironmentOrder = {
  /** The direction in which to order pinned environments by the specified field. */
  direction: OrderDirection;
  /** The field to order pinned environments by. */
  field: PinnedEnvironmentOrderField;
};

/** Properties by which pinned environments connections can be ordered */
export enum PinnedEnvironmentOrderField {
  /** Order pinned environments by position */
  Position = 'POSITION'
}

/** Represents a 'pinned' event on a given issue or pull request. */
export type PinnedEvent = Node & {
  __typename?: 'PinnedEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The Node ID of the PinnedEvent object */
  id: Scalars['ID']['output'];
  /** Identifies the issue associated with the event. */
  issue: Issue;
};

/** A Pinned Issue is a issue pinned to a repository's index page. */
export type PinnedIssue = Node & {
  __typename?: 'PinnedIssue';
  /** Identifies the primary key from the database. */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** Identifies the primary key from the database as a BigInt. */
  fullDatabaseId?: Maybe<Scalars['BigInt']['output']>;
  /** The Node ID of the PinnedIssue object */
  id: Scalars['ID']['output'];
  /** The issue that was pinned. */
  issue: Issue;
  /** The actor that pinned this issue. */
  pinnedBy: Actor;
  /** The repository that this issue was pinned to. */
  repository: Repository;
};

/** A comment pinned to an Issue. */
export type PinnedIssueComment = Node & {
  __typename?: 'PinnedIssueComment';
  /** Identifies the primary key from the database. */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** Identifies the primary key from the database as a BigInt. */
  fullDatabaseId?: Maybe<Scalars['BigInt']['output']>;
  /** The Node ID of the PinnedIssueComment object */
  id: Scalars['ID']['output'];
  /** The issue that this comment belongs to. */
  issue: Issue;
  /** The comment that was pinned. */
  issueComment: IssueComment;
  /** Identifies when the comment was pinned. */
  pinnedAt: Scalars['DateTime']['output'];
  /** The actor that pinned this comment. */
  pinnedBy: Actor;
};

/** The connection type for PinnedIssue. */
export type PinnedIssueConnection = {
  __typename?: 'PinnedIssueConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PinnedIssueEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PinnedIssue>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PinnedIssueEdge = {
  __typename?: 'PinnedIssueEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PinnedIssue>;
};

/** Audit log entry for a private_repository_forking.disable event. */
export type PrivateRepositoryForkingDisableAuditEntry = AuditEntry & EnterpriseAuditEntryData & Node & OrganizationAuditEntryData & RepositoryAuditEntryData & {
  __typename?: 'PrivateRepositoryForkingDisableAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /** The HTTP path for this enterprise. */
  enterpriseResourcePath?: Maybe<Scalars['URI']['output']>;
  /** The slug of the enterprise. */
  enterpriseSlug?: Maybe<Scalars['String']['output']>;
  /** The HTTP URL for this enterprise. */
  enterpriseUrl?: Maybe<Scalars['URI']['output']>;
  /** The Node ID of the PrivateRepositoryForkingDisableAuditEntry object */
  id: Scalars['ID']['output'];
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /** The repository associated with the action */
  repository?: Maybe<Repository>;
  /** The name of the repository */
  repositoryName?: Maybe<Scalars['String']['output']>;
  /** The HTTP path for the repository */
  repositoryResourcePath?: Maybe<Scalars['URI']['output']>;
  /** The HTTP URL for the repository */
  repositoryUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
};

/** Audit log entry for a private_repository_forking.enable event. */
export type PrivateRepositoryForkingEnableAuditEntry = AuditEntry & EnterpriseAuditEntryData & Node & OrganizationAuditEntryData & RepositoryAuditEntryData & {
  __typename?: 'PrivateRepositoryForkingEnableAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /** The HTTP path for this enterprise. */
  enterpriseResourcePath?: Maybe<Scalars['URI']['output']>;
  /** The slug of the enterprise. */
  enterpriseSlug?: Maybe<Scalars['String']['output']>;
  /** The HTTP URL for this enterprise. */
  enterpriseUrl?: Maybe<Scalars['URI']['output']>;
  /** The Node ID of the PrivateRepositoryForkingEnableAuditEntry object */
  id: Scalars['ID']['output'];
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /** The repository associated with the action */
  repository?: Maybe<Repository>;
  /** The name of the repository */
  repositoryName?: Maybe<Scalars['String']['output']>;
  /** The HTTP path for the repository */
  repositoryResourcePath?: Maybe<Scalars['URI']['output']>;
  /** The HTTP URL for the repository */
  repositoryUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
};

/**
 * A curatable list of repositories relating to a repository owner, which defaults
 * to showing the most popular repositories they own.
 */
export type ProfileItemShowcase = {
  __typename?: 'ProfileItemShowcase';
  /** Whether or not the owner has pinned any repositories or gists. */
  hasPinnedItems: Scalars['Boolean']['output'];
  /**
   * The repositories and gists in the showcase. If the profile owner has any
   * pinned items, those will be returned. Otherwise, the profile owner's popular
   * repositories will be returned.
   */
  items: PinnableItemConnection;
};


/**
 * A curatable list of repositories relating to a repository owner, which defaults
 * to showing the most popular repositories they own.
 */
export type ProfileItemShowcaseItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents any entity on GitHub that has a profile page. */
export type ProfileOwner = {
  /** Determine if this repository owner has any items that can be pinned to their profile. */
  anyPinnableItems: Scalars['Boolean']['output'];
  /** The public profile email. */
  email?: Maybe<Scalars['String']['output']>;
  /** The Node ID of the ProfileOwner object */
  id: Scalars['ID']['output'];
  /**
   * Showcases a selection of repositories and gists that the profile owner has
   * either curated or that have been selected automatically based on popularity.
   */
  itemShowcase: ProfileItemShowcase;
  /** The public profile location. */
  location?: Maybe<Scalars['String']['output']>;
  /** The username used to login. */
  login: Scalars['String']['output'];
  /** The public profile name. */
  name?: Maybe<Scalars['String']['output']>;
  /** A list of repositories and gists this profile owner can pin to their profile. */
  pinnableItems: PinnableItemConnection;
  /** A list of repositories and gists this profile owner has pinned to their profile */
  pinnedItems: PinnableItemConnection;
  /** Returns how many more items this profile owner can pin to their profile. */
  pinnedItemsRemaining: Scalars['Int']['output'];
  /** Can the viewer pin repositories and gists to the profile? */
  viewerCanChangePinnedItems: Scalars['Boolean']['output'];
  /** The public profile website URL. */
  websiteUrl?: Maybe<Scalars['URI']['output']>;
};


/** Represents any entity on GitHub that has a profile page. */
export type ProfileOwnerAnyPinnableItemsArgs = {
  type?: InputMaybe<PinnableItemType>;
};


/** Represents any entity on GitHub that has a profile page. */
export type ProfileOwnerPinnableItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  types?: InputMaybe<Array<PinnableItemType>>;
};


/** Represents any entity on GitHub that has a profile page. */
export type ProfileOwnerPinnedItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  types?: InputMaybe<Array<PinnableItemType>>;
};

/** Projects manage issues, pull requests and notes within a project owner. */
export type Project = Closable & Node & Updatable & {
  __typename?: 'Project';
  /**
   * The project's description body.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  body?: Maybe<Scalars['String']['output']>;
  /**
   * The projects description body rendered to HTML.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  bodyHTML: Scalars['HTML']['output'];
  /** Indicates if the object is closed (definition of closed may depend on type) */
  closed: Scalars['Boolean']['output'];
  /** Identifies the date and time when the object was closed. */
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * List of columns in the project
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  columns: ProjectColumnConnection;
  /**
   * Identifies the date and time when the object was created.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  createdAt: Scalars['DateTime']['output'];
  /**
   * The actor who originally created the project.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  creator?: Maybe<Actor>;
  /**
   * Identifies the primary key from the database.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /**
   * The Node ID of the Project object
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  id: Scalars['ID']['output'];
  /**
   * The project's name.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  name: Scalars['String']['output'];
  /**
   * The project's number.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  number: Scalars['Int']['output'];
  /**
   * The project's owner. Currently limited to repositories, organizations, and users.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  owner: ProjectOwner;
  /**
   * List of pending cards in this project
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  pendingCards: ProjectCardConnection;
  /**
   * Project progress details.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  progress: ProjectProgress;
  /**
   * The HTTP path for this project
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  resourcePath: Scalars['URI']['output'];
  /**
   * Whether the project is open or closed.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  state: ProjectState;
  /**
   * Identifies the date and time when the object was last updated.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * The HTTP URL for this project
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  url: Scalars['URI']['output'];
  /** Indicates if the object can be closed by the viewer. */
  viewerCanClose: Scalars['Boolean']['output'];
  /** Indicates if the object can be reopened by the viewer. */
  viewerCanReopen: Scalars['Boolean']['output'];
  /** Check if the current viewer can update this object. */
  viewerCanUpdate: Scalars['Boolean']['output'];
};


/** Projects manage issues, pull requests and notes within a project owner. */
export type ProjectColumnsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Projects manage issues, pull requests and notes within a project owner. */
export type ProjectPendingCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  archivedStates?: InputMaybe<Array<InputMaybe<ProjectCardArchivedState>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** A card in a project. */
export type ProjectCard = Node & {
  __typename?: 'ProjectCard';
  /**
   * The project column this card is associated under. A card may only belong to one
   * project column at a time. The column field will be null if the card is created
   * in a pending state and has yet to be associated with a column. Once cards are
   * associated with a column, they will not become pending in the future.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  column?: Maybe<ProjectColumn>;
  /**
   * The card content item
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  content?: Maybe<ProjectCardItem>;
  /**
   * Identifies the date and time when the object was created.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  createdAt: Scalars['DateTime']['output'];
  /**
   * The actor who created this card
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  creator?: Maybe<Actor>;
  /**
   * Identifies the primary key from the database.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /**
   * The Node ID of the ProjectCard object
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  id: Scalars['ID']['output'];
  /**
   * Whether the card is archived
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  isArchived: Scalars['Boolean']['output'];
  /**
   * The card note
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  note?: Maybe<Scalars['String']['output']>;
  /**
   * The project that contains this card.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  project: Project;
  /**
   * The HTTP path for this card
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  resourcePath: Scalars['URI']['output'];
  /**
   * The state of ProjectCard
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  state?: Maybe<ProjectCardState>;
  /**
   * Identifies the date and time when the object was last updated.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * The HTTP URL for this card
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  url: Scalars['URI']['output'];
};

/** The possible archived states of a project card. */
export enum ProjectCardArchivedState {
  /**
   * A project card that is archived
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  Archived = 'ARCHIVED',
  /**
   * A project card that is not archived
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  NotArchived = 'NOT_ARCHIVED'
}

/** The connection type for ProjectCard. */
export type ProjectCardConnection = {
  __typename?: 'ProjectCardConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProjectCardEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProjectCard>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProjectCardEdge = {
  __typename?: 'ProjectCardEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ProjectCard>;
};

/** An issue or PR and its owning repository to be used in a project card. */
export type ProjectCardImport = {
  /** The issue or pull request number. */
  number: Scalars['Int']['input'];
  /** Repository name with owner (owner/repository). */
  repository: Scalars['String']['input'];
};

/** Types that can be inside Project Cards. */
export type ProjectCardItem = Issue | PullRequest;

/** Various content states of a ProjectCard */
export enum ProjectCardState {
  /** The card has content only. */
  ContentOnly = 'CONTENT_ONLY',
  /** The card has a note only. */
  NoteOnly = 'NOTE_ONLY',
  /** The card is redacted. */
  Redacted = 'REDACTED'
}

/** A column inside a project. */
export type ProjectColumn = Node & {
  __typename?: 'ProjectColumn';
  /**
   * List of cards in the column
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  cards: ProjectCardConnection;
  /**
   * Identifies the date and time when the object was created.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  createdAt: Scalars['DateTime']['output'];
  /**
   * Identifies the primary key from the database.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /**
   * The Node ID of the ProjectColumn object
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  id: Scalars['ID']['output'];
  /**
   * The project column's name.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  name: Scalars['String']['output'];
  /**
   * The project that contains this column.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  project: Project;
  /**
   * The semantic purpose of the column
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  purpose?: Maybe<ProjectColumnPurpose>;
  /**
   * The HTTP path for this project column
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  resourcePath: Scalars['URI']['output'];
  /**
   * Identifies the date and time when the object was last updated.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * The HTTP URL for this project column
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  url: Scalars['URI']['output'];
};


/** A column inside a project. */
export type ProjectColumnCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  archivedStates?: InputMaybe<Array<InputMaybe<ProjectCardArchivedState>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for ProjectColumn. */
export type ProjectColumnConnection = {
  __typename?: 'ProjectColumnConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProjectColumnEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProjectColumn>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProjectColumnEdge = {
  __typename?: 'ProjectColumnEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ProjectColumn>;
};

/** A project column and a list of its issues and PRs. */
export type ProjectColumnImport = {
  /** The name of the column. */
  columnName: Scalars['String']['input'];
  /** A list of issues and pull requests in the column. */
  issues?: InputMaybe<Array<ProjectCardImport>>;
  /** The position of the column, starting from 0. */
  position: Scalars['Int']['input'];
};

/** The semantic purpose of the column - todo, in progress, or done. */
export enum ProjectColumnPurpose {
  /** The column contains cards which are complete */
  Done = 'DONE',
  /** The column contains cards which are currently being worked on */
  InProgress = 'IN_PROGRESS',
  /** The column contains cards still to be worked on */
  Todo = 'TODO'
}

/** A list of projects associated with the owner. */
export type ProjectConnection = {
  __typename?: 'ProjectConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProjectEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Project>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProjectEdge = {
  __typename?: 'ProjectEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Project>;
};

/** Ways in which lists of projects can be ordered upon return. */
export type ProjectOrder = {
  /** The direction in which to order projects by the specified field. */
  direction: OrderDirection;
  /** The field in which to order projects by. */
  field: ProjectOrderField;
};

/** Properties by which project connections can be ordered. */
export enum ProjectOrderField {
  /** Order projects by creation time */
  CreatedAt = 'CREATED_AT',
  /** Order projects by name */
  Name = 'NAME',
  /** Order projects by update time */
  UpdatedAt = 'UPDATED_AT'
}

/** Represents an owner of a Project. */
export type ProjectOwner = {
  /**
   * The Node ID of the ProjectOwner object
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  id: Scalars['ID']['output'];
  /**
   * Find project by number.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  project?: Maybe<Project>;
  /**
   * A list of projects under the owner.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  projects: ProjectConnection;
  /**
   * The HTTP path listing owners projects
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  projectsResourcePath: Scalars['URI']['output'];
  /**
   * The HTTP URL listing owners projects
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  projectsUrl: Scalars['URI']['output'];
  /**
   * Can the current viewer create new projects on this owner.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  viewerCanCreateProjects: Scalars['Boolean']['output'];
};


/** Represents an owner of a Project. */
export type ProjectOwnerProjectArgs = {
  number: Scalars['Int']['input'];
};


/** Represents an owner of a Project. */
export type ProjectOwnerProjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProjectOrder>;
  search?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Array<ProjectState>>;
};

/** Project progress stats. */
export type ProjectProgress = {
  __typename?: 'ProjectProgress';
  /**
   * The number of done cards.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  doneCount: Scalars['Int']['output'];
  /**
   * The percentage of done cards.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  donePercentage: Scalars['Float']['output'];
  /**
   * Whether progress tracking is enabled and cards with purpose exist for this project
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  enabled: Scalars['Boolean']['output'];
  /**
   * The number of in-progress cards.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  inProgressCount: Scalars['Int']['output'];
  /**
   * The percentage of in-progress cards.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  inProgressPercentage: Scalars['Float']['output'];
  /**
   * The number of to do cards.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  todoCount: Scalars['Int']['output'];
  /**
   * The percentage of to do cards.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  todoPercentage: Scalars['Float']['output'];
};

/** State of the project; either 'open' or 'closed' */
export enum ProjectState {
  /** The project is closed. */
  Closed = 'CLOSED',
  /** The project is open. */
  Open = 'OPEN'
}

/** GitHub-provided templates for Projects */
export enum ProjectTemplate {
  /** Create a board with v2 triggers to automatically move cards across To do, In progress and Done columns. */
  AutomatedKanbanV2 = 'AUTOMATED_KANBAN_V2',
  /** Create a board with triggers to automatically move cards across columns with review automation. */
  AutomatedReviewsKanban = 'AUTOMATED_REVIEWS_KANBAN',
  /** Create a board with columns for To do, In progress and Done. */
  BasicKanban = 'BASIC_KANBAN',
  /** Create a board to triage and prioritize bugs with To do, priority, and Done columns. */
  BugTriage = 'BUG_TRIAGE'
}

/** New projects that manage issues, pull requests and drafts using tables and boards. */
export type ProjectV2 = Closable & Node & Updatable & {
  __typename?: 'ProjectV2';
  /** Returns true if the project is closed. */
  closed: Scalars['Boolean']['output'];
  /** Identifies the date and time when the object was closed. */
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The actor who originally created the project. */
  creator?: Maybe<Actor>;
  /**
   * Identifies the primary key from the database.
   * @deprecated `databaseId` will be removed because it does not support 64-bit signed integer identifiers. Use `fullDatabaseId` instead. Removal on 2025-04-01 UTC.
   */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** A field of the project */
  field?: Maybe<ProjectV2FieldConfiguration>;
  /** List of fields and their constraints in the project */
  fields: ProjectV2FieldConfigurationConnection;
  /** Identifies the primary key from the database as a BigInt. */
  fullDatabaseId?: Maybe<Scalars['BigInt']['output']>;
  /** The Node ID of the ProjectV2 object */
  id: Scalars['ID']['output'];
  /** List of items in the project */
  items: ProjectV2ItemConnection;
  /** The project's number. */
  number: Scalars['Int']['output'];
  /** The project's owner. Currently limited to organizations and users. */
  owner: ProjectV2Owner;
  /** Returns true if the project is public. */
  public: Scalars['Boolean']['output'];
  /** The project's readme. */
  readme?: Maybe<Scalars['String']['output']>;
  /** The repositories the project is linked to. */
  repositories: RepositoryConnection;
  /** The HTTP path for this project */
  resourcePath: Scalars['URI']['output'];
  /** The project's short description. */
  shortDescription?: Maybe<Scalars['String']['output']>;
  /** List of the status updates in the project. */
  statusUpdates: ProjectV2StatusUpdateConnection;
  /** The teams the project is linked to. */
  teams: TeamConnection;
  /** Returns true if this project is a template. */
  template: Scalars['Boolean']['output'];
  /** The project's name. */
  title: Scalars['String']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The HTTP URL for this project */
  url: Scalars['URI']['output'];
  /** A view of the project */
  view?: Maybe<ProjectV2View>;
  /** Indicates if the object can be closed by the viewer. */
  viewerCanClose: Scalars['Boolean']['output'];
  /** Indicates if the object can be reopened by the viewer. */
  viewerCanReopen: Scalars['Boolean']['output'];
  /** Check if the current viewer can update this object. */
  viewerCanUpdate: Scalars['Boolean']['output'];
  /** List of views in the project */
  views: ProjectV2ViewConnection;
  /** A workflow of the project */
  workflow?: Maybe<ProjectV2Workflow>;
  /** List of the workflows in the project */
  workflows: ProjectV2WorkflowConnection;
};


/** New projects that manage issues, pull requests and drafts using tables and boards. */
export type ProjectV2FieldArgs = {
  name: Scalars['String']['input'];
};


/** New projects that manage issues, pull requests and drafts using tables and boards. */
export type ProjectV2FieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProjectV2FieldOrder>;
};


/** New projects that manage issues, pull requests and drafts using tables and boards. */
export type ProjectV2ItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  archivedStates?: InputMaybe<Array<ProjectV2ItemArchivedState>>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProjectV2ItemOrder>;
  query?: InputMaybe<Scalars['String']['input']>;
};


/** New projects that manage issues, pull requests and drafts using tables and boards. */
export type ProjectV2RepositoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<RepositoryOrder>;
};


/** New projects that manage issues, pull requests and drafts using tables and boards. */
export type ProjectV2StatusUpdatesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProjectV2StatusOrder>;
};


/** New projects that manage issues, pull requests and drafts using tables and boards. */
export type ProjectV2TeamsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TeamOrder>;
};


/** New projects that manage issues, pull requests and drafts using tables and boards. */
export type ProjectV2ViewArgs = {
  number: Scalars['Int']['input'];
};


/** New projects that manage issues, pull requests and drafts using tables and boards. */
export type ProjectV2ViewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProjectV2ViewOrder>;
};


/** New projects that manage issues, pull requests and drafts using tables and boards. */
export type ProjectV2WorkflowArgs = {
  number: Scalars['Int']['input'];
};


/** New projects that manage issues, pull requests and drafts using tables and boards. */
export type ProjectV2WorkflowsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProjectV2WorkflowOrder>;
};

/** Possible collaborators for a project. */
export type ProjectV2Actor = Team | User;

/** The connection type for ProjectV2Actor. */
export type ProjectV2ActorConnection = {
  __typename?: 'ProjectV2ActorConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProjectV2ActorEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProjectV2Actor>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProjectV2ActorEdge = {
  __typename?: 'ProjectV2ActorEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ProjectV2Actor>;
};

/** A collaborator to update on a project. Only one of the userId or teamId should be provided. */
export type ProjectV2Collaborator = {
  /** The role to grant the collaborator */
  role: ProjectV2Roles;
  /** The ID of the team as a collaborator. */
  teamId?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the user as a collaborator. */
  userId?: InputMaybe<Scalars['ID']['input']>;
};

/** The connection type for ProjectV2. */
export type ProjectV2Connection = {
  __typename?: 'ProjectV2Connection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProjectV2Edge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProjectV2>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** The type of a project field. */
export enum ProjectV2CustomFieldType {
  /** Date */
  Date = 'DATE',
  /** Iteration */
  Iteration = 'ITERATION',
  /** Multi Select */
  MultiSelect = 'MULTI_SELECT',
  /** Number */
  Number = 'NUMBER',
  /** Single Select */
  SingleSelect = 'SINGLE_SELECT',
  /** Text */
  Text = 'TEXT'
}

/** An edge in a connection. */
export type ProjectV2Edge = {
  __typename?: 'ProjectV2Edge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ProjectV2>;
};

/** Represents an event related to a project on the timeline of an issue or pull request. */
export type ProjectV2Event = {
  /** Project referenced by event. */
  project?: Maybe<ProjectV2>;
  /** Did this event result from workflow automation? */
  wasAutomated: Scalars['Boolean']['output'];
};

/** A field inside a project. */
export type ProjectV2Field = Node & ProjectV2FieldCommon & {
  __typename?: 'ProjectV2Field';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The field's type. */
  dataType: ProjectV2FieldType;
  /** Identifies the primary key from the database. */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** The Node ID of the ProjectV2Field object */
  id: Scalars['ID']['output'];
  /** Returns true if this field is associated with an organization issue field */
  isIssueField: Scalars['Boolean']['output'];
  /** The organization issue field associated with this project field, if any */
  issueField?: Maybe<IssueFields>;
  /** The project field's name. */
  name: Scalars['String']['output'];
  /** The project that contains this field. */
  project: ProjectV2;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Common fields across different project field types */
export type ProjectV2FieldCommon = {
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The field's type. */
  dataType: ProjectV2FieldType;
  /** Identifies the primary key from the database. */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** The Node ID of the ProjectV2FieldCommon object */
  id: Scalars['ID']['output'];
  /** Returns true if this field is associated with an organization issue field */
  isIssueField: Scalars['Boolean']['output'];
  /** The project field's name. */
  name: Scalars['String']['output'];
  /** The project that contains this field. */
  project: ProjectV2;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Configurations for project fields. */
export type ProjectV2FieldConfiguration = ProjectV2Field | ProjectV2IterationField | ProjectV2MultiSelectField | ProjectV2SingleSelectField;

/** The connection type for ProjectV2FieldConfiguration. */
export type ProjectV2FieldConfigurationConnection = {
  __typename?: 'ProjectV2FieldConfigurationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProjectV2FieldConfigurationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProjectV2FieldConfiguration>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProjectV2FieldConfigurationEdge = {
  __typename?: 'ProjectV2FieldConfigurationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ProjectV2FieldConfiguration>;
};

/** The connection type for ProjectV2Field. */
export type ProjectV2FieldConnection = {
  __typename?: 'ProjectV2FieldConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProjectV2FieldEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProjectV2Field>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProjectV2FieldEdge = {
  __typename?: 'ProjectV2FieldEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ProjectV2Field>;
};

/** Ordering options for project v2 field connections */
export type ProjectV2FieldOrder = {
  /** The ordering direction. */
  direction: OrderDirection;
  /** The field to order the project v2 fields by. */
  field: ProjectV2FieldOrderField;
};

/** Properties by which project v2 field connections can be ordered. */
export enum ProjectV2FieldOrderField {
  /** Order project v2 fields by creation time */
  CreatedAt = 'CREATED_AT',
  /** Order project v2 fields by name */
  Name = 'NAME',
  /** Order project v2 fields by position */
  Position = 'POSITION'
}

/** The type of a project field. */
export enum ProjectV2FieldType {
  /** Assignees */
  Assignees = 'ASSIGNEES',
  /** Closed */
  Closed = 'CLOSED',
  /** Created */
  Created = 'CREATED',
  /** Date */
  Date = 'DATE',
  /** Issue type */
  IssueType = 'ISSUE_TYPE',
  /** Iteration */
  Iteration = 'ITERATION',
  /** Labels */
  Labels = 'LABELS',
  /** Linked Pull Requests */
  LinkedPullRequests = 'LINKED_PULL_REQUESTS',
  /** Milestone */
  Milestone = 'MILESTONE',
  /** Multi Select */
  MultiSelect = 'MULTI_SELECT',
  /** Number */
  Number = 'NUMBER',
  /** Parent issue */
  ParentIssue = 'PARENT_ISSUE',
  /** Repository */
  Repository = 'REPOSITORY',
  /** Reviewers */
  Reviewers = 'REVIEWERS',
  /** Single Select */
  SingleSelect = 'SINGLE_SELECT',
  /** Sub-issues progress */
  SubIssuesProgress = 'SUB_ISSUES_PROGRESS',
  /** Text */
  Text = 'TEXT',
  /** Title */
  Title = 'TITLE',
  /** Tracked by */
  TrackedBy = 'TRACKED_BY',
  /** Tracks */
  Tracks = 'TRACKS',
  /** Updated */
  Updated = 'UPDATED'
}

/** The values that can be used to update a field of an item inside a Project. Only 1 value can be updated at a time. */
export type ProjectV2FieldValue = {
  /** The ISO 8601 date to set on the field. */
  date?: InputMaybe<Scalars['Date']['input']>;
  /** The id of the iteration to set on the field. */
  iterationId?: InputMaybe<Scalars['String']['input']>;
  /** The ids of the multi select options to set on the field. */
  multiSelectOptionIds?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The number to set on the field. */
  number?: InputMaybe<Scalars['Float']['input']>;
  /** The id of the single select option to set on the field. */
  singleSelectOptionId?: InputMaybe<Scalars['String']['input']>;
  /** The text to set on the field. */
  text?: InputMaybe<Scalars['String']['input']>;
};

/** Ways in which to filter lists of projects. */
export type ProjectV2Filters = {
  /** List project v2 filtered by the state given. */
  state?: InputMaybe<ProjectV2State>;
};

/** Possible issue field values for a Project item. */
export type ProjectV2IssueFieldValues = IssueFieldDateValue | IssueFieldMultiSelectValue | IssueFieldNumberValue | IssueFieldSingleSelectValue | IssueFieldTextValue;

/** An item within a Project. */
export type ProjectV2Item = Node & {
  __typename?: 'ProjectV2Item';
  /** The content of the referenced draft issue, issue, pull request */
  content?: Maybe<ProjectV2ItemContent>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The actor who created the item. */
  creator?: Maybe<Actor>;
  /**
   * Identifies the primary key from the database.
   * @deprecated `databaseId` will be removed because it does not support 64-bit signed integer identifiers. Use `fullDatabaseId` instead. Removal on 2025-04-01 UTC.
   */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** The field value of the first project field which matches the 'name' argument that is set on the item. */
  fieldValueByName?: Maybe<ProjectV2ItemFieldValue>;
  /** The field values that are set on the item. */
  fieldValues: ProjectV2ItemFieldValueConnection;
  /** Identifies the primary key from the database as a BigInt. */
  fullDatabaseId?: Maybe<Scalars['BigInt']['output']>;
  /** The Node ID of the ProjectV2Item object */
  id: Scalars['ID']['output'];
  /** Whether the item is archived. */
  isArchived: Scalars['Boolean']['output'];
  /** The project that contains this item. */
  project: ProjectV2;
  /** The type of the item. */
  type: ProjectV2ItemType;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};


/** An item within a Project. */
export type ProjectV2ItemFieldValueByNameArgs = {
  name: Scalars['String']['input'];
};


/** An item within a Project. */
export type ProjectV2ItemFieldValuesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProjectV2ItemFieldValueOrder>;
};

/** The possible archived states of a `ProjectV2Item`. */
export enum ProjectV2ItemArchivedState {
  /** A project item that is archived */
  Archived = 'ARCHIVED',
  /** A project item that is not archived */
  NotArchived = 'NOT_ARCHIVED'
}

/** The connection type for ProjectV2Item. */
export type ProjectV2ItemConnection = {
  __typename?: 'ProjectV2ItemConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProjectV2ItemEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProjectV2Item>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** Types that can be inside Project Items. */
export type ProjectV2ItemContent = DraftIssue | Issue | PullRequest;

/** An edge in a connection. */
export type ProjectV2ItemEdge = {
  __typename?: 'ProjectV2ItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ProjectV2Item>;
};

/** The value of a date field in a Project item. */
export type ProjectV2ItemFieldDateValue = Node & ProjectV2ItemFieldValueCommon & {
  __typename?: 'ProjectV2ItemFieldDateValue';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The actor who created the item. */
  creator?: Maybe<Actor>;
  /** Identifies the primary key from the database. */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** Date value for the field */
  date?: Maybe<Scalars['Date']['output']>;
  /** The project field that contains this value. */
  field: ProjectV2FieldConfiguration;
  /** The Node ID of the ProjectV2ItemFieldDateValue object */
  id: Scalars['ID']['output'];
  /** The project item that contains this value. */
  item: ProjectV2Item;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** The value of an iteration field in a Project item. */
export type ProjectV2ItemFieldIterationValue = Node & ProjectV2ItemFieldValueCommon & {
  __typename?: 'ProjectV2ItemFieldIterationValue';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The actor who created the item. */
  creator?: Maybe<Actor>;
  /** Identifies the primary key from the database. */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** The duration of the iteration in days. */
  duration: Scalars['Int']['output'];
  /** The project field that contains this value. */
  field: ProjectV2FieldConfiguration;
  /** The Node ID of the ProjectV2ItemFieldIterationValue object */
  id: Scalars['ID']['output'];
  /** The project item that contains this value. */
  item: ProjectV2Item;
  /** The ID of the iteration. */
  iterationId: Scalars['String']['output'];
  /** The start date of the iteration. */
  startDate: Scalars['Date']['output'];
  /** The title of the iteration. */
  title: Scalars['String']['output'];
  /** The title of the iteration, with HTML. */
  titleHTML: Scalars['String']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** The value of the labels field in a Project item. */
export type ProjectV2ItemFieldLabelValue = {
  __typename?: 'ProjectV2ItemFieldLabelValue';
  /** The field that contains this value. */
  field: ProjectV2FieldConfiguration;
  /** Labels value of a field */
  labels?: Maybe<LabelConnection>;
};


/** The value of the labels field in a Project item. */
export type ProjectV2ItemFieldLabelValueLabelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The value of a milestone field in a Project item. */
export type ProjectV2ItemFieldMilestoneValue = {
  __typename?: 'ProjectV2ItemFieldMilestoneValue';
  /** The field that contains this value. */
  field: ProjectV2FieldConfiguration;
  /** Milestone value of a field */
  milestone?: Maybe<Milestone>;
};

/** The value of a multi select field in a Project item. */
export type ProjectV2ItemFieldMultiSelectValue = Node & ProjectV2ItemFieldValueCommon & {
  __typename?: 'ProjectV2ItemFieldMultiSelectValue';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The actor who created the item. */
  creator?: Maybe<Actor>;
  /** Identifies the primary key from the database. */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** The project field that contains this value. */
  field: ProjectV2FieldConfiguration;
  /** The Node ID of the ProjectV2ItemFieldMultiSelectValue object */
  id: Scalars['ID']['output'];
  /** The project item that contains this value. */
  item: ProjectV2Item;
  /** The selected multi select options. */
  options?: Maybe<Array<ProjectV2MultiSelectFieldOption>>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** Comma-separated names of the selected multi select options. */
  value: Scalars['String']['output'];
};

/** The value of a number field in a Project item. */
export type ProjectV2ItemFieldNumberValue = Node & ProjectV2ItemFieldValueCommon & {
  __typename?: 'ProjectV2ItemFieldNumberValue';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The actor who created the item. */
  creator?: Maybe<Actor>;
  /** Identifies the primary key from the database. */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** The project field that contains this value. */
  field: ProjectV2FieldConfiguration;
  /** The Node ID of the ProjectV2ItemFieldNumberValue object */
  id: Scalars['ID']['output'];
  /** The project item that contains this value. */
  item: ProjectV2Item;
  /** Number as a float(8) */
  number?: Maybe<Scalars['Float']['output']>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** The value of a pull request field in a Project item. */
export type ProjectV2ItemFieldPullRequestValue = {
  __typename?: 'ProjectV2ItemFieldPullRequestValue';
  /** The field that contains this value. */
  field: ProjectV2FieldConfiguration;
  /** The pull requests for this field */
  pullRequests?: Maybe<PullRequestConnection>;
};


/** The value of a pull request field in a Project item. */
export type ProjectV2ItemFieldPullRequestValuePullRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PullRequestOrder>;
};

/** The value of a repository field in a Project item. */
export type ProjectV2ItemFieldRepositoryValue = {
  __typename?: 'ProjectV2ItemFieldRepositoryValue';
  /** The field that contains this value. */
  field: ProjectV2FieldConfiguration;
  /** The repository for this field. */
  repository?: Maybe<Repository>;
};

/** The value of a reviewers field in a Project item. */
export type ProjectV2ItemFieldReviewerValue = {
  __typename?: 'ProjectV2ItemFieldReviewerValue';
  /** The field that contains this value. */
  field: ProjectV2FieldConfiguration;
  /** The reviewers for this field. */
  reviewers?: Maybe<RequestedReviewerConnection>;
};


/** The value of a reviewers field in a Project item. */
export type ProjectV2ItemFieldReviewerValueReviewersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The value of a single select field in a Project item. */
export type ProjectV2ItemFieldSingleSelectValue = Node & ProjectV2ItemFieldValueCommon & {
  __typename?: 'ProjectV2ItemFieldSingleSelectValue';
  /** The color applied to the selected single-select option. */
  color: ProjectV2SingleSelectFieldOptionColor;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The actor who created the item. */
  creator?: Maybe<Actor>;
  /** Identifies the primary key from the database. */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** A plain-text description of the selected single-select option, such as what the option means. */
  description?: Maybe<Scalars['String']['output']>;
  /** The description of the selected single-select option, including HTML tags. */
  descriptionHTML?: Maybe<Scalars['String']['output']>;
  /** The project field that contains this value. */
  field: ProjectV2FieldConfiguration;
  /** The Node ID of the ProjectV2ItemFieldSingleSelectValue object */
  id: Scalars['ID']['output'];
  /** The project item that contains this value. */
  item: ProjectV2Item;
  /** The name of the selected single select option. */
  name?: Maybe<Scalars['String']['output']>;
  /** The html name of the selected single select option. */
  nameHTML?: Maybe<Scalars['String']['output']>;
  /** The id of the selected single select option. */
  optionId?: Maybe<Scalars['String']['output']>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** The value of a text field in a Project item. */
export type ProjectV2ItemFieldTextValue = Node & ProjectV2ItemFieldValueCommon & {
  __typename?: 'ProjectV2ItemFieldTextValue';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The actor who created the item. */
  creator?: Maybe<Actor>;
  /** Identifies the primary key from the database. */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** The project field that contains this value. */
  field: ProjectV2FieldConfiguration;
  /** The Node ID of the ProjectV2ItemFieldTextValue object */
  id: Scalars['ID']['output'];
  /** The project item that contains this value. */
  item: ProjectV2Item;
  /** Text value of a field */
  text?: Maybe<Scalars['String']['output']>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** The value of a user field in a Project item. */
export type ProjectV2ItemFieldUserValue = {
  __typename?: 'ProjectV2ItemFieldUserValue';
  /** The field that contains this value. */
  field: ProjectV2FieldConfiguration;
  /** The users for this field */
  users?: Maybe<UserConnection>;
};


/** The value of a user field in a Project item. */
export type ProjectV2ItemFieldUserValueUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Project field values */
export type ProjectV2ItemFieldValue = ProjectV2ItemFieldDateValue | ProjectV2ItemFieldIterationValue | ProjectV2ItemFieldLabelValue | ProjectV2ItemFieldMilestoneValue | ProjectV2ItemFieldMultiSelectValue | ProjectV2ItemFieldNumberValue | ProjectV2ItemFieldPullRequestValue | ProjectV2ItemFieldRepositoryValue | ProjectV2ItemFieldReviewerValue | ProjectV2ItemFieldSingleSelectValue | ProjectV2ItemFieldTextValue | ProjectV2ItemFieldUserValue | ProjectV2ItemIssueFieldValue;

/** Common fields across different project field value types */
export type ProjectV2ItemFieldValueCommon = {
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The actor who created the item. */
  creator?: Maybe<Actor>;
  /** Identifies the primary key from the database. */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** The project field that contains this value. */
  field: ProjectV2FieldConfiguration;
  /** The Node ID of the ProjectV2ItemFieldValueCommon object */
  id: Scalars['ID']['output'];
  /** The project item that contains this value. */
  item: ProjectV2Item;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** The connection type for ProjectV2ItemFieldValue. */
export type ProjectV2ItemFieldValueConnection = {
  __typename?: 'ProjectV2ItemFieldValueConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProjectV2ItemFieldValueEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProjectV2ItemFieldValue>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProjectV2ItemFieldValueEdge = {
  __typename?: 'ProjectV2ItemFieldValueEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ProjectV2ItemFieldValue>;
};

/** Ordering options for project v2 item field value connections */
export type ProjectV2ItemFieldValueOrder = {
  /** The ordering direction. */
  direction: OrderDirection;
  /** The field to order the project v2 item field values by. */
  field: ProjectV2ItemFieldValueOrderField;
};

/** Properties by which project v2 item field value connections can be ordered. */
export enum ProjectV2ItemFieldValueOrderField {
  /** Order project v2 item field values by the their position in the project */
  Position = 'POSITION'
}

/** The value of an issue field in a Project item. */
export type ProjectV2ItemIssueFieldValue = {
  __typename?: 'ProjectV2ItemIssueFieldValue';
  /** Field that contains this value. */
  field: ProjectV2FieldConfiguration;
  /** Value of the Issue Field */
  issueFieldValue?: Maybe<ProjectV2IssueFieldValues>;
};

/** Ordering options for project v2 item connections */
export type ProjectV2ItemOrder = {
  /** The ordering direction. */
  direction: OrderDirection;
  /** The field to order the project v2 items by. */
  field: ProjectV2ItemOrderField;
};

/** Properties by which project v2 item connections can be ordered. */
export enum ProjectV2ItemOrderField {
  /** Order project v2 items by the their position in the project */
  Position = 'POSITION'
}

/** Represents a 'project_v2_item_status_changed' event on a given issue or pull request. */
export type ProjectV2ItemStatusChangedEvent = Node & ProjectV2Event & {
  __typename?: 'ProjectV2ItemStatusChangedEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The Node ID of the ProjectV2ItemStatusChangedEvent object */
  id: Scalars['ID']['output'];
  /** The previous status of the project item. */
  previousStatus: Scalars['String']['output'];
  /** Project referenced by event. */
  project?: Maybe<ProjectV2>;
  /** The new status of the project item. */
  status: Scalars['String']['output'];
  /** Did this event result from workflow automation? */
  wasAutomated: Scalars['Boolean']['output'];
};

/** The type of a project item. */
export enum ProjectV2ItemType {
  /** Draft Issue */
  DraftIssue = 'DRAFT_ISSUE',
  /** Issue */
  Issue = 'ISSUE',
  /** Pull Request */
  PullRequest = 'PULL_REQUEST',
  /** Redacted Item */
  Redacted = 'REDACTED'
}

/** Represents an iteration */
export type ProjectV2Iteration = {
  /** The duration of the iteration, in days. */
  duration: Scalars['Int']['input'];
  /** The ID of an existing iteration. Include this to preserve the iteration's identity during replacement updates. */
  id?: InputMaybe<Scalars['String']['input']>;
  /** The start date for the iteration. */
  startDate: Scalars['Date']['input'];
  /** The title for the iteration. */
  title: Scalars['String']['input'];
};

/** An iteration field inside a project. */
export type ProjectV2IterationField = Node & ProjectV2FieldCommon & {
  __typename?: 'ProjectV2IterationField';
  /** Iteration configuration settings */
  configuration: ProjectV2IterationFieldConfiguration;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The field's type. */
  dataType: ProjectV2FieldType;
  /** Identifies the primary key from the database. */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** The Node ID of the ProjectV2IterationField object */
  id: Scalars['ID']['output'];
  /** Returns true if this field is associated with an organization issue field */
  isIssueField: Scalars['Boolean']['output'];
  /** The project field's name. */
  name: Scalars['String']['output'];
  /** The project that contains this field. */
  project: ProjectV2;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** Iteration field configuration for a project. */
export type ProjectV2IterationFieldConfiguration = {
  __typename?: 'ProjectV2IterationFieldConfiguration';
  /** The iteration's completed iterations */
  completedIterations: Array<ProjectV2IterationFieldIteration>;
  /** The iteration's duration in days */
  duration: Scalars['Int']['output'];
  /** The iteration's iterations */
  iterations: Array<ProjectV2IterationFieldIteration>;
  /** The iteration's start day of the week */
  startDay: Scalars['Int']['output'];
};

/** Represents an iteration field configuration. */
export type ProjectV2IterationFieldConfigurationInput = {
  /** The duration of each iteration, in days. */
  duration: Scalars['Int']['input'];
  /** Zero or more iterations for the field. */
  iterations: Array<ProjectV2Iteration>;
  /** The start date for the first iteration. */
  startDate: Scalars['Date']['input'];
};

/** Iteration field iteration settings for a project. */
export type ProjectV2IterationFieldIteration = {
  __typename?: 'ProjectV2IterationFieldIteration';
  /** The iteration's duration in days */
  duration: Scalars['Int']['output'];
  /** The iteration's ID. */
  id: Scalars['String']['output'];
  /** The iteration's start date */
  startDate: Scalars['Date']['output'];
  /** The iteration's title. */
  title: Scalars['String']['output'];
  /** The iteration's html title. */
  titleHTML: Scalars['String']['output'];
};

/** A multi select field inside a project. */
export type ProjectV2MultiSelectField = Node & ProjectV2FieldCommon & {
  __typename?: 'ProjectV2MultiSelectField';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The field's type. */
  dataType: ProjectV2FieldType;
  /** Identifies the primary key from the database. */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** The Node ID of the ProjectV2MultiSelectField object */
  id: Scalars['ID']['output'];
  /** Returns true if this field is associated with an organization issue field */
  isIssueField: Scalars['Boolean']['output'];
  /** The organization issue field associated with this project field, if any */
  issueField?: Maybe<IssueFields>;
  /** Options for the multi select field */
  multiSelectOptions: Array<ProjectV2MultiSelectFieldOption>;
  /** The project field's name. */
  name: Scalars['String']['output'];
  /** The project that contains this field. */
  project: ProjectV2;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};


/** A multi select field inside a project. */
export type ProjectV2MultiSelectFieldMultiSelectOptionsArgs = {
  names?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Multi select field option for a configuration for a project. */
export type ProjectV2MultiSelectFieldOption = {
  __typename?: 'ProjectV2MultiSelectFieldOption';
  /** The option's display color. */
  color: ProjectV2SingleSelectFieldOptionColor;
  /** The option's plain-text description. */
  description: Scalars['String']['output'];
  /** The option's description, possibly containing HTML. */
  descriptionHTML: Scalars['String']['output'];
  /** The option's ID. */
  id: Scalars['String']['output'];
  /** The option's name. */
  name: Scalars['String']['output'];
  /** The option's html name. */
  nameHTML: Scalars['String']['output'];
};

/** Represents a multi select field option */
export type ProjectV2MultiSelectFieldOptionInput = {
  /** The display color of the option */
  color: ProjectV2SingleSelectFieldOptionColor;
  /** The description text of the option */
  description: Scalars['String']['input'];
  /**
   * The ID of an existing multi select option. Include this to preserve the
   * option's identity during updates, preventing item field values from being cleared.
   */
  id?: InputMaybe<Scalars['String']['input']>;
  /** The name of the option */
  name: Scalars['String']['input'];
};

/** Ways in which lists of projects can be ordered upon return. */
export type ProjectV2Order = {
  /** The direction in which to order projects by the specified field. */
  direction: OrderDirection;
  /** The field in which to order projects by. */
  field: ProjectV2OrderField;
};

/** Properties by which projects can be ordered. */
export enum ProjectV2OrderField {
  /** The project's date and time of creation */
  CreatedAt = 'CREATED_AT',
  /** The project's number */
  Number = 'NUMBER',
  /** The project's title */
  Title = 'TITLE',
  /** The project's date and time of update */
  UpdatedAt = 'UPDATED_AT'
}

/** Represents an owner of a project. */
export type ProjectV2Owner = {
  /** The Node ID of the ProjectV2Owner object */
  id: Scalars['ID']['output'];
  /** Find a project by number. */
  projectV2?: Maybe<ProjectV2>;
  /** A list of projects under the owner. */
  projectsV2: ProjectV2Connection;
};


/** Represents an owner of a project. */
export type ProjectV2OwnerProjectV2Args = {
  number: Scalars['Int']['input'];
};


/** Represents an owner of a project. */
export type ProjectV2OwnerProjectsV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  minPermissionLevel?: InputMaybe<ProjectV2PermissionLevel>;
  orderBy?: InputMaybe<ProjectV2Order>;
  query?: InputMaybe<Scalars['String']['input']>;
};

/** The possible roles of a collaborator on a project. */
export enum ProjectV2PermissionLevel {
  /** The collaborator can view, edit, and maange the settings of the project */
  Admin = 'ADMIN',
  /** The collaborator can view the project */
  Read = 'READ',
  /** The collaborator can view and edit the project */
  Write = 'WRITE'
}

/** Recent projects for the owner. */
export type ProjectV2Recent = {
  /** Recent projects that this user has modified in the context of the owner. */
  recentProjects: ProjectV2Connection;
};


/** Recent projects for the owner. */
export type ProjectV2RecentRecentProjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The possible roles of a collaborator on a project. */
export enum ProjectV2Roles {
  /** The collaborator can view, edit, and maange the settings of the project */
  Admin = 'ADMIN',
  /** The collaborator has no direct access to the project */
  None = 'NONE',
  /** The collaborator can view the project */
  Reader = 'READER',
  /** The collaborator can view and edit the project */
  Writer = 'WRITER'
}

/** A single select field inside a project. */
export type ProjectV2SingleSelectField = Node & ProjectV2FieldCommon & {
  __typename?: 'ProjectV2SingleSelectField';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The field's type. */
  dataType: ProjectV2FieldType;
  /** Identifies the primary key from the database. */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** The Node ID of the ProjectV2SingleSelectField object */
  id: Scalars['ID']['output'];
  /** Returns true if this field is associated with an organization issue field */
  isIssueField: Scalars['Boolean']['output'];
  /** The organization issue field associated with this project field, if any */
  issueField?: Maybe<IssueFields>;
  /** The project field's name. */
  name: Scalars['String']['output'];
  /** Options for the single select field */
  options: Array<ProjectV2SingleSelectFieldOption>;
  /** The project that contains this field. */
  project: ProjectV2;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};


/** A single select field inside a project. */
export type ProjectV2SingleSelectFieldOptionsArgs = {
  names?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Single select field option for a configuration for a project. */
export type ProjectV2SingleSelectFieldOption = {
  __typename?: 'ProjectV2SingleSelectFieldOption';
  /** The option's display color. */
  color: ProjectV2SingleSelectFieldOptionColor;
  /** The option's plain-text description. */
  description: Scalars['String']['output'];
  /** The option's description, possibly containing HTML. */
  descriptionHTML: Scalars['String']['output'];
  /** The option's ID. */
  id: Scalars['String']['output'];
  /** The option's name. */
  name: Scalars['String']['output'];
  /** The option's html name. */
  nameHTML: Scalars['String']['output'];
};

/** The display color of a single-select field option. */
export enum ProjectV2SingleSelectFieldOptionColor {
  /** BLUE */
  Blue = 'BLUE',
  /** GRAY */
  Gray = 'GRAY',
  /** GREEN */
  Green = 'GREEN',
  /** ORANGE */
  Orange = 'ORANGE',
  /** PINK */
  Pink = 'PINK',
  /** PURPLE */
  Purple = 'PURPLE',
  /** RED */
  Red = 'RED',
  /** YELLOW */
  Yellow = 'YELLOW'
}

/** Represents a single select field option */
export type ProjectV2SingleSelectFieldOptionInput = {
  /** The display color of the option */
  color: ProjectV2SingleSelectFieldOptionColor;
  /** The description text of the option */
  description: Scalars['String']['input'];
  /**
   * The ID of an existing single select option. Include this to preserve the
   * option's identity during updates, preventing item field values from being cleared.
   */
  id?: InputMaybe<Scalars['String']['input']>;
  /** The name of the option */
  name: Scalars['String']['input'];
};

/** Represents a sort by field and direction. */
export type ProjectV2SortBy = {
  __typename?: 'ProjectV2SortBy';
  /** The direction of the sorting. Possible values are ASC and DESC. */
  direction: OrderDirection;
  /** The field by which items are sorted. */
  field: ProjectV2Field;
};

/** The connection type for ProjectV2SortBy. */
export type ProjectV2SortByConnection = {
  __typename?: 'ProjectV2SortByConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProjectV2SortByEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProjectV2SortBy>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProjectV2SortByEdge = {
  __typename?: 'ProjectV2SortByEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ProjectV2SortBy>;
};

/** Represents a sort by field and direction. */
export type ProjectV2SortByField = {
  __typename?: 'ProjectV2SortByField';
  /** The direction of the sorting. Possible values are ASC and DESC. */
  direction: OrderDirection;
  /** The field by which items are sorted. */
  field: ProjectV2FieldConfiguration;
};

/** The connection type for ProjectV2SortByField. */
export type ProjectV2SortByFieldConnection = {
  __typename?: 'ProjectV2SortByFieldConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProjectV2SortByFieldEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProjectV2SortByField>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProjectV2SortByFieldEdge = {
  __typename?: 'ProjectV2SortByFieldEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ProjectV2SortByField>;
};

/** The possible states of a project v2. */
export enum ProjectV2State {
  /** A project v2 that has been closed */
  Closed = 'CLOSED',
  /** A project v2 that is still open */
  Open = 'OPEN'
}

/** Ways in which project v2 status updates can be ordered. */
export type ProjectV2StatusOrder = {
  /** The direction in which to order nodes. */
  direction: OrderDirection;
  /** The field by which to order nodes. */
  field: ProjectV2StatusUpdateOrderField;
};

/** A status update within a project. */
export type ProjectV2StatusUpdate = Node & {
  __typename?: 'ProjectV2StatusUpdate';
  /** The body of the status update. */
  body?: Maybe<Scalars['String']['output']>;
  /** The body of the status update rendered to HTML. */
  bodyHTML?: Maybe<Scalars['HTML']['output']>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The actor who created the status update. */
  creator?: Maybe<Actor>;
  /**
   * Identifies the primary key from the database.
   * @deprecated `databaseId` will be removed because it does not support 64-bit signed integer identifiers. Use `fullDatabaseId` instead. Removal on 2025-04-01 UTC.
   */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** Identifies the primary key from the database as a BigInt. */
  fullDatabaseId?: Maybe<Scalars['BigInt']['output']>;
  /** The Node ID of the ProjectV2StatusUpdate object */
  id: Scalars['ID']['output'];
  /** The project that contains this status update. */
  project: ProjectV2;
  /** The start date of the status update. */
  startDate?: Maybe<Scalars['Date']['output']>;
  /** The status of the status update. */
  status?: Maybe<ProjectV2StatusUpdateStatus>;
  /** The target date of the status update. */
  targetDate?: Maybe<Scalars['Date']['output']>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** The connection type for ProjectV2StatusUpdate. */
export type ProjectV2StatusUpdateConnection = {
  __typename?: 'ProjectV2StatusUpdateConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProjectV2StatusUpdateEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProjectV2StatusUpdate>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProjectV2StatusUpdateEdge = {
  __typename?: 'ProjectV2StatusUpdateEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ProjectV2StatusUpdate>;
};

/** Properties by which project v2 status updates can be ordered. */
export enum ProjectV2StatusUpdateOrderField {
  /** Allows chronological ordering of project v2 status updates. */
  CreatedAt = 'CREATED_AT'
}

/** The possible statuses of a project v2. */
export enum ProjectV2StatusUpdateStatus {
  /** A project v2 that is at risk and encountering some challenges. */
  AtRisk = 'AT_RISK',
  /** A project v2 that is complete. */
  Complete = 'COMPLETE',
  /** A project v2 that is inactive. */
  Inactive = 'INACTIVE',
  /** A project v2 that is off track and needs attention. */
  OffTrack = 'OFF_TRACK',
  /** A project v2 that is on track with no risks. */
  OnTrack = 'ON_TRACK'
}

/** A view within a ProjectV2. */
export type ProjectV2View = Node & {
  __typename?: 'ProjectV2View';
  /** The view's configuration. */
  configuration: ProjectV2ViewConfiguration;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /**
   * Identifies the primary key from the database.
   * @deprecated `databaseId` will be removed because it does not support 64-bit signed integer identifiers. Use `fullDatabaseId` instead. Removal on 2025-04-01 UTC.
   */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** The view's visible fields. */
  fields?: Maybe<ProjectV2FieldConfigurationConnection>;
  /** The project view's filter. */
  filter?: Maybe<Scalars['String']['output']>;
  /** Identifies the primary key from the database as a BigInt. */
  fullDatabaseId?: Maybe<Scalars['BigInt']['output']>;
  /**
   * The view's group-by field.
   * @deprecated The `ProjectV2View#order_by` API is deprecated in favour of the more capable `ProjectV2View#group_by_field` API. Check out the `ProjectV2View#group_by_fields` API as an example for the more capable alternative. Removal on 2023-04-01 UTC.
   */
  groupBy?: Maybe<ProjectV2FieldConnection>;
  /** The view's group-by field. */
  groupByFields?: Maybe<ProjectV2FieldConfigurationConnection>;
  /** The Node ID of the ProjectV2View object */
  id: Scalars['ID']['output'];
  /** The project view's layout. */
  layout: ProjectV2ViewLayout;
  /** The project view's name. */
  name: Scalars['String']['output'];
  /** The project view's number. */
  number: Scalars['Int']['output'];
  /** The project that contains this view. */
  project: ProjectV2;
  /**
   * The view's sort-by config.
   * @deprecated The `ProjectV2View#sort_by` API is deprecated in favour of the more capable `ProjectV2View#sort_by_fields` API. Check out the `ProjectV2View#sort_by_fields` API as an example for the more capable alternative. Removal on 2023-04-01 UTC.
   */
  sortBy?: Maybe<ProjectV2SortByConnection>;
  /** The view's sort-by config. */
  sortByFields?: Maybe<ProjectV2SortByFieldConnection>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * The view's vertical-group-by field.
   * @deprecated The `ProjectV2View#vertical_group_by` API is deprecated in favour of the more capable `ProjectV2View#vertical_group_by_fields` API. Check out the `ProjectV2View#vertical_group_by_fields` API as an example for the more capable alternative. Removal on 2023-04-01 UTC.
   */
  verticalGroupBy?: Maybe<ProjectV2FieldConnection>;
  /** The view's vertical-group-by field. */
  verticalGroupByFields?: Maybe<ProjectV2FieldConfigurationConnection>;
  /**
   * The view's visible fields.
   * @deprecated The `ProjectV2View#visibleFields` API is deprecated in favour of the more capable `ProjectV2View#fields` API. Check out the `ProjectV2View#fields` API as an example for the more capable alternative. Removal on 2023-01-01 UTC.
   */
  visibleFields?: Maybe<ProjectV2FieldConnection>;
};


/** A view within a ProjectV2. */
export type ProjectV2ViewFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProjectV2FieldOrder>;
};


/** A view within a ProjectV2. */
export type ProjectV2ViewGroupByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProjectV2FieldOrder>;
};


/** A view within a ProjectV2. */
export type ProjectV2ViewGroupByFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProjectV2FieldOrder>;
};


/** A view within a ProjectV2. */
export type ProjectV2ViewSortByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A view within a ProjectV2. */
export type ProjectV2ViewSortByFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A view within a ProjectV2. */
export type ProjectV2ViewVerticalGroupByArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProjectV2FieldOrder>;
};


/** A view within a ProjectV2. */
export type ProjectV2ViewVerticalGroupByFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProjectV2FieldOrder>;
};


/** A view within a ProjectV2. */
export type ProjectV2ViewVisibleFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProjectV2FieldOrder>;
};

/** Configuration for a ProjectV2 view. */
export type ProjectV2ViewConfiguration = {
  __typename?: 'ProjectV2ViewConfiguration';
  /** The fields visible in the view, in configured order. */
  visibleFields: ProjectV2FieldConfigurationConnection;
};


/** Configuration for a ProjectV2 view. */
export type ProjectV2ViewConfigurationVisibleFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Configuration for a ProjectV2 view. */
export type ProjectV2ViewConfigurationInput = {
  /** The ordered IDs of the fields visible in the view. */
  visibleFieldIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** The connection type for ProjectV2View. */
export type ProjectV2ViewConnection = {
  __typename?: 'ProjectV2ViewConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProjectV2ViewEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProjectV2View>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProjectV2ViewEdge = {
  __typename?: 'ProjectV2ViewEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ProjectV2View>;
};

/** The layout of a project v2 view. */
export enum ProjectV2ViewLayout {
  /** Board layout */
  BoardLayout = 'BOARD_LAYOUT',
  /** Roadmap layout */
  RoadmapLayout = 'ROADMAP_LAYOUT',
  /** Table layout */
  TableLayout = 'TABLE_LAYOUT'
}

/** Ordering options for project v2 view connections */
export type ProjectV2ViewOrder = {
  /** The ordering direction. */
  direction: OrderDirection;
  /** The field to order the project v2 views by. */
  field: ProjectV2ViewOrderField;
};

/** Properties by which project v2 view connections can be ordered. */
export enum ProjectV2ViewOrderField {
  /** Order project v2 views by creation time */
  CreatedAt = 'CREATED_AT',
  /** Order project v2 views by name */
  Name = 'NAME',
  /** Order project v2 views by position */
  Position = 'POSITION'
}

/** A workflow inside a project. */
export type ProjectV2Workflow = Node & {
  __typename?: 'ProjectV2Workflow';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /**
   * Identifies the primary key from the database.
   * @deprecated `databaseId` will be removed because it does not support 64-bit signed integer identifiers. Use `fullDatabaseId` instead. Removal on 2025-04-01 UTC.
   */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** Whether the workflow is enabled. */
  enabled: Scalars['Boolean']['output'];
  /** Identifies the primary key from the database as a BigInt. */
  fullDatabaseId?: Maybe<Scalars['BigInt']['output']>;
  /** The Node ID of the ProjectV2Workflow object */
  id: Scalars['ID']['output'];
  /** The name of the workflow. */
  name: Scalars['String']['output'];
  /** The number of the workflow. */
  number: Scalars['Int']['output'];
  /** The project that contains this workflow. */
  project: ProjectV2;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** The connection type for ProjectV2Workflow. */
export type ProjectV2WorkflowConnection = {
  __typename?: 'ProjectV2WorkflowConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ProjectV2WorkflowEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ProjectV2Workflow>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ProjectV2WorkflowEdge = {
  __typename?: 'ProjectV2WorkflowEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ProjectV2Workflow>;
};

/** Ordering options for project v2 workflows connections */
export type ProjectV2WorkflowOrder = {
  /** The ordering direction. */
  direction: OrderDirection;
  /** The field to order the project v2 workflows by. */
  field: ProjectV2WorkflowsOrderField;
};

/** Properties by which project workflows can be ordered. */
export enum ProjectV2WorkflowsOrderField {
  /** The date and time of the workflow creation */
  CreatedAt = 'CREATED_AT',
  /** The name of the workflow */
  Name = 'NAME',
  /** The number of the workflow */
  Number = 'NUMBER',
  /** The date and time of the workflow update */
  UpdatedAt = 'UPDATED_AT'
}

/** Autogenerated input type of PromoteRepositoryCustomProperty */
export type PromoteRepositoryCustomPropertyInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the repository custom property to be promoted. */
  repositoryCustomPropertyId: Scalars['ID']['input'];
};

/** Autogenerated return type of PromoteRepositoryCustomProperty. */
export type PromoteRepositoryCustomPropertyPayload = {
  __typename?: 'PromoteRepositoryCustomPropertyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The repository custom property that has been promoted. */
  repositoryCustomProperty?: Maybe<RepositoryCustomProperty>;
};

/** A property that must match */
export type PropertyTargetDefinition = {
  __typename?: 'PropertyTargetDefinition';
  /** The name of the property */
  name: Scalars['String']['output'];
  /** The values to match for */
  propertyValues: Array<Scalars['String']['output']>;
  /** The source of the property. Choose 'custom' or 'system'. Defaults to 'custom' if not specified */
  source?: Maybe<Scalars['String']['output']>;
};

/** A property that must match */
export type PropertyTargetDefinitionInput = {
  /** The name of the property */
  name: Scalars['String']['input'];
  /** The values to match for */
  propertyValues: Array<Scalars['String']['input']>;
  /** The source of the property. Choose 'custom' or 'system'. Defaults to 'custom' if not specified */
  source?: InputMaybe<Scalars['String']['input']>;
};

/** A user's public key. */
export type PublicKey = Node & {
  __typename?: 'PublicKey';
  /** The last time this authorization was used to perform an action. Values will be null for keys not owned by the user. */
  accessedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Identifies the date and time when the key was created. Keys created before
   * March 5th, 2014 have inaccurate values. Values will be null for keys not owned by the user.
   */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** The fingerprint for this PublicKey. */
  fingerprint: Scalars['String']['output'];
  /** The Node ID of the PublicKey object */
  id: Scalars['ID']['output'];
  /** Whether this PublicKey is read-only or not. Values will be null for keys not owned by the user. */
  isReadOnly?: Maybe<Scalars['Boolean']['output']>;
  /** The public key string. */
  key: Scalars['String']['output'];
  /**
   * Identifies the date and time when the key was updated. Keys created before
   * March 5th, 2014 may have inaccurate values. Values will be null for keys not
   * owned by the user.
   */
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** The connection type for PublicKey. */
export type PublicKeyConnection = {
  __typename?: 'PublicKeyConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PublicKeyEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PublicKey>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PublicKeyEdge = {
  __typename?: 'PublicKeyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PublicKey>;
};

/** Autogenerated input type of PublishSponsorsTier */
export type PublishSponsorsTierInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the draft tier to publish. */
  tierId: Scalars['ID']['input'];
};

/** Autogenerated return type of PublishSponsorsTier. */
export type PublishSponsorsTierPayload = {
  __typename?: 'PublishSponsorsTierPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The tier that was published. */
  sponsorsTier?: Maybe<SponsorsTier>;
};

/** A repository pull request. */
export type PullRequest = Assignable & Closable & Comment & Labelable & Lockable & Node & ProjectV2Owner & Reactable & RepositoryNode & Subscribable & UniformResourceLocatable & Updatable & UpdatableComment & {
  __typename?: 'PullRequest';
  /** Reason that the conversation was locked. */
  activeLockReason?: Maybe<LockReason>;
  /** The number of additions in this pull request. */
  additions: Scalars['Int']['output'];
  /** A list of actors assigned to this object. */
  assignedActors: AssigneeConnection;
  /** A list of Users assigned to this object. */
  assignees: UserConnection;
  /** The actor who authored the comment. */
  author?: Maybe<Actor>;
  /** Author's association with the subject of the comment. */
  authorAssociation: CommentAuthorAssociation;
  /** Returns the auto-merge request object if one exists for this pull request. */
  autoMergeRequest?: Maybe<AutoMergeRequest>;
  /** Identifies the base Ref associated with the pull request. */
  baseRef?: Maybe<Ref>;
  /** Identifies the name of the base Ref associated with the pull request, even if the ref has been deleted. */
  baseRefName: Scalars['String']['output'];
  /** Identifies the oid of the base ref associated with the pull request, even if the ref has been deleted. */
  baseRefOid: Scalars['GitObjectID']['output'];
  /** The repository associated with this pull request's base Ref. */
  baseRepository?: Maybe<Repository>;
  /** The body as Markdown. */
  body: Scalars['String']['output'];
  /** The body rendered to HTML. */
  bodyHTML: Scalars['HTML']['output'];
  /** The body rendered to text. */
  bodyText: Scalars['String']['output'];
  /** Whether or not the pull request is rebaseable. */
  canBeRebased: Scalars['Boolean']['output'];
  /** The number of changed files in this pull request. */
  changedFiles: Scalars['Int']['output'];
  /** The HTTP path for the checks of this pull request. */
  checksResourcePath: Scalars['URI']['output'];
  /** The HTTP URL for the checks of this pull request. */
  checksUrl: Scalars['URI']['output'];
  /** `true` if the pull request is closed */
  closed: Scalars['Boolean']['output'];
  /** Identifies the date and time when the object was closed. */
  closedAt?: Maybe<Scalars['DateTime']['output']>;
  /** List of issues that may be closed by this pull request */
  closingIssuesReferences?: Maybe<IssueConnection>;
  /** A list of comments associated with the pull request. */
  comments: IssueCommentConnection;
  /** A list of commits present in this pull request's head branch not present in the base branch. */
  commits: PullRequestCommitConnection;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Check if this comment was created via an email reply. */
  createdViaEmail: Scalars['Boolean']['output'];
  /**
   * Identifies the primary key from the database.
   * @deprecated `databaseId` will be removed because it does not support 64-bit signed integer identifiers. Use `fullDatabaseId` instead. Removal on 2024-07-01 UTC.
   */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** The number of deletions in this pull request. */
  deletions: Scalars['Int']['output'];
  /** The actor who edited this pull request's body. */
  editor?: Maybe<Actor>;
  /** Lists the files changed within this pull request. */
  files?: Maybe<PullRequestChangedFileConnection>;
  /** Identifies the primary key from the database as a BigInt. */
  fullDatabaseId?: Maybe<Scalars['BigInt']['output']>;
  /** Identifies the head Ref associated with the pull request. */
  headRef?: Maybe<Ref>;
  /** Identifies the name of the head Ref associated with the pull request, even if the ref has been deleted. */
  headRefName: Scalars['String']['output'];
  /** Identifies the oid of the head ref associated with the pull request, even if the ref has been deleted. */
  headRefOid: Scalars['GitObjectID']['output'];
  /** The repository associated with this pull request's head Ref. */
  headRepository?: Maybe<Repository>;
  /** The owner of the repository associated with this pull request's head Ref. */
  headRepositoryOwner?: Maybe<RepositoryOwner>;
  /** The hovercard information for this issue */
  hovercard: Hovercard;
  /** The Node ID of the PullRequest object */
  id: Scalars['ID']['output'];
  /** Check if this comment was edited and includes an edit with the creation data */
  includesCreatedEdit: Scalars['Boolean']['output'];
  /** The head and base repositories are different. */
  isCrossRepository: Scalars['Boolean']['output'];
  /** Identifies if the pull request is a draft. */
  isDraft: Scalars['Boolean']['output'];
  /** Indicates whether the pull request is in a merge queue */
  isInMergeQueue: Scalars['Boolean']['output'];
  /** Indicates whether the pull request's base ref has a merge queue enabled. */
  isMergeQueueEnabled: Scalars['Boolean']['output'];
  /** Is this pull request read by the viewer */
  isReadByViewer?: Maybe<Scalars['Boolean']['output']>;
  /** A list of labels associated with the object. */
  labels?: Maybe<LabelConnection>;
  /** The moment the editor made the last edit */
  lastEditedAt?: Maybe<Scalars['DateTime']['output']>;
  /** A list of latest reviews per user associated with the pull request. */
  latestOpinionatedReviews?: Maybe<PullRequestReviewConnection>;
  /** A list of latest reviews per user associated with the pull request that are not also pending review. */
  latestReviews?: Maybe<PullRequestReviewConnection>;
  /** `true` if the pull request is locked */
  locked: Scalars['Boolean']['output'];
  /** Indicates whether maintainers can modify the pull request. */
  maintainerCanModify: Scalars['Boolean']['output'];
  /** The commit that was created when this pull request was merged. */
  mergeCommit?: Maybe<Commit>;
  /** The merge queue for the pull request's base branch */
  mergeQueue?: Maybe<MergeQueue>;
  /** The merge queue entry of the pull request in the base branch's merge queue */
  mergeQueueEntry?: Maybe<MergeQueueEntry>;
  /** Detailed information about the current pull request merge state status. */
  mergeStateStatus: MergeStateStatus;
  /** Whether or not the pull request can be merged based on the existence of merge conflicts. */
  mergeable: MergeableState;
  /** Whether or not the pull request was merged. */
  merged: Scalars['Boolean']['output'];
  /** The date and time that the pull request was merged. */
  mergedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The actor who merged the pull request. */
  mergedBy?: Maybe<Actor>;
  /** Identifies the milestone associated with the pull request. */
  milestone?: Maybe<Milestone>;
  /** Identifies the pull request number. */
  number: Scalars['Int']['output'];
  /** A list of Users that are participating in the Pull Request conversation. */
  participants: UserConnection;
  /** The permalink to the pull request. */
  permalink: Scalars['URI']['output'];
  /**
   * The commit that GitHub automatically generated to test if this pull request
   * could be merged. This field will not return a value if the pull request is
   * merged, or if the test merge commit is still being generated. See the
   * `mergeable` field for more details on the mergeability of the pull request.
   */
  potentialMergeCommit?: Maybe<Commit>;
  /**
   * List of project cards associated with this pull request.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  projectCards: ProjectCardConnection;
  /** List of project items associated with this pull request. */
  projectItems?: Maybe<ProjectV2ItemConnection>;
  /** Find a project by number. */
  projectV2?: Maybe<ProjectV2>;
  /** A list of projects under the owner. */
  projectsV2: ProjectV2Connection;
  /** Identifies when the comment was published at. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** A list of reactions grouped by content left on the subject. */
  reactionGroups?: Maybe<Array<ReactionGroup>>;
  /** A list of Reactions left on the Issue. */
  reactions: ReactionConnection;
  /** The repository associated with this node. */
  repository: Repository;
  /** The HTTP path for this pull request. */
  resourcePath: Scalars['URI']['output'];
  /** The HTTP path for reverting this pull request. */
  revertResourcePath: Scalars['URI']['output'];
  /** The HTTP URL for reverting this pull request. */
  revertUrl: Scalars['URI']['output'];
  /** The current status of this pull request with respect to code review. */
  reviewDecision?: Maybe<PullRequestReviewDecision>;
  /** A list of review requests associated with the pull request. */
  reviewRequests?: Maybe<ReviewRequestConnection>;
  /** The list of all review threads for this pull request. */
  reviewThreads: PullRequestReviewThreadConnection;
  /** A list of reviews associated with the pull request. */
  reviews?: Maybe<PullRequestReviewConnection>;
  /** The stack this Pull Request belongs to, or null if it is not part of a stack */
  stack?: Maybe<PullRequestStack>;
  /** The stack entry for this Pull Request, or null if it is not part of a stack */
  stackEntry?: Maybe<PullRequestStackEntry>;
  /** Identifies the state of the pull request. */
  state: PullRequestState;
  /** Check and Status rollup information for the PR's head ref. */
  statusCheckRollup?: Maybe<StatusCheckRollup>;
  /** A list of suggested actors to assign to this object */
  suggestedActors: AssigneeConnection;
  /** Reviewer actor suggestions based on commit history, past review comments, and integrations. */
  suggestedReviewerActors: SuggestedReviewerActorConnection;
  /** A list of reviewer suggestions based on commit history and past review comments. */
  suggestedReviewers: Array<Maybe<SuggestedReviewer>>;
  /**
   * A list of events, comments, commits, etc. associated with the pull request.
   * @deprecated `timeline` will be removed Use PullRequest.timelineItems instead. Removal on 2020-10-01 UTC.
   */
  timeline: PullRequestTimelineConnection;
  /** A list of events, comments, commits, etc. associated with the pull request. */
  timelineItems: PullRequestTimelineItemsConnection;
  /** Identifies the pull request title. */
  title: Scalars['String']['output'];
  /** Identifies the pull request title rendered to HTML. */
  titleHTML: Scalars['HTML']['output'];
  /** Returns a count of how many comments this pull request has received. */
  totalCommentsCount?: Maybe<Scalars['Int']['output']>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The HTTP URL for this pull request. */
  url: Scalars['URI']['output'];
  /** A list of edits to this content. */
  userContentEdits?: Maybe<UserContentEditConnection>;
  /** Whether or not the viewer can apply suggestion. */
  viewerCanApplySuggestion: Scalars['Boolean']['output'];
  /** Indicates if the viewer can edit assignees for this object. */
  viewerCanAssign: Scalars['Boolean']['output'];
  /** Indicates if the object can be closed by the viewer. */
  viewerCanClose: Scalars['Boolean']['output'];
  /** Check if the viewer can restore the deleted head ref. */
  viewerCanDeleteHeadRef: Scalars['Boolean']['output'];
  /** Whether or not the viewer can disable auto-merge */
  viewerCanDisableAutoMerge: Scalars['Boolean']['output'];
  /** Can the viewer edit files within this pull request. */
  viewerCanEditFiles: Scalars['Boolean']['output'];
  /** Whether or not the viewer can enable auto-merge */
  viewerCanEnableAutoMerge: Scalars['Boolean']['output'];
  /** Indicates if the viewer can edit labels for this object. */
  viewerCanLabel: Scalars['Boolean']['output'];
  /** Indicates whether the viewer can bypass branch protections and merge the pull request immediately */
  viewerCanMergeAsAdmin: Scalars['Boolean']['output'];
  /** Can user react to this subject */
  viewerCanReact: Scalars['Boolean']['output'];
  /** Indicates if the object can be reopened by the viewer. */
  viewerCanReopen: Scalars['Boolean']['output'];
  /** Check if the viewer is able to change their subscription status for the repository. */
  viewerCanSubscribe: Scalars['Boolean']['output'];
  /** Check if the current viewer can update this object. */
  viewerCanUpdate: Scalars['Boolean']['output'];
  /**
   * Whether or not the viewer can update the head ref of this PR, by merging or rebasing the base ref.
   * If the head ref is up to date or unable to be updated by this user, this will return false.
   */
  viewerCanUpdateBranch: Scalars['Boolean']['output'];
  /** Reasons why the current viewer can not update this comment. */
  viewerCannotUpdateReasons: Array<CommentCannotUpdateReason>;
  /** Did the viewer author this comment. */
  viewerDidAuthor: Scalars['Boolean']['output'];
  /** The latest review given from the viewer. */
  viewerLatestReview?: Maybe<PullRequestReview>;
  /** The person who has requested the viewer for review on this pull request. */
  viewerLatestReviewRequest?: Maybe<ReviewRequest>;
  /** The merge body text for the viewer and method. */
  viewerMergeBodyText: Scalars['String']['output'];
  /** The merge headline text for the viewer and method. */
  viewerMergeHeadlineText: Scalars['String']['output'];
  /** Identifies if the viewer is watching, not watching, or ignoring the subscribable entity. */
  viewerSubscription?: Maybe<SubscriptionState>;
};


/** A repository pull request. */
export type PullRequestAssignedActorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A repository pull request. */
export type PullRequestAssigneesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A repository pull request. */
export type PullRequestClosingIssuesReferencesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  excludeUserLinked?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<IssueOrder>;
  userLinkedOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A repository pull request. */
export type PullRequestCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<IssueCommentOrder>;
};


/** A repository pull request. */
export type PullRequestCommitsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A repository pull request. */
export type PullRequestFilesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A repository pull request. */
export type PullRequestHovercardArgs = {
  includeNotificationContexts?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A repository pull request. */
export type PullRequestLabelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LabelOrder>;
};


/** A repository pull request. */
export type PullRequestLatestOpinionatedReviewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  writersOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A repository pull request. */
export type PullRequestLatestReviewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A repository pull request. */
export type PullRequestParticipantsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A repository pull request. */
export type PullRequestProjectCardsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  archivedStates?: InputMaybe<Array<InputMaybe<ProjectCardArchivedState>>>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A repository pull request. */
export type PullRequestProjectItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeArchived?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A repository pull request. */
export type PullRequestProjectV2Args = {
  number: Scalars['Int']['input'];
};


/** A repository pull request. */
export type PullRequestProjectsV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  minPermissionLevel?: InputMaybe<ProjectV2PermissionLevel>;
  orderBy?: InputMaybe<ProjectV2Order>;
  query?: InputMaybe<Scalars['String']['input']>;
};


/** A repository pull request. */
export type PullRequestReactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<ReactionContent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ReactionOrder>;
};


/** A repository pull request. */
export type PullRequestReviewRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A repository pull request. */
export type PullRequestReviewThreadsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A repository pull request. */
export type PullRequestReviewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  author?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  states?: InputMaybe<Array<PullRequestReviewState>>;
};


/** A repository pull request. */
export type PullRequestSuggestedActorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


/** A repository pull request. */
export type PullRequestSuggestedReviewerActorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


/** A repository pull request. */
export type PullRequestTimelineArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  since?: InputMaybe<Scalars['DateTime']['input']>;
};


/** A repository pull request. */
export type PullRequestTimelineItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  itemTypes?: InputMaybe<Array<PullRequestTimelineItemsItemType>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  since?: InputMaybe<Scalars['DateTime']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};


/** A repository pull request. */
export type PullRequestUserContentEditsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A repository pull request. */
export type PullRequestViewerMergeBodyTextArgs = {
  mergeType?: InputMaybe<PullRequestMergeMethod>;
};


/** A repository pull request. */
export type PullRequestViewerMergeHeadlineTextArgs = {
  mergeType?: InputMaybe<PullRequestMergeMethod>;
};

/** Array of allowed merge methods. Allowed values include `merge`, `squash`, and `rebase`. At least one option must be enabled. */
export enum PullRequestAllowedMergeMethods {
  /** Add all commits from the head branch to the base branch with a merge commit. */
  Merge = 'MERGE',
  /** Add all commits from the head branch onto the base branch individually. */
  Rebase = 'REBASE',
  /** Combine all commits from the head branch into a single commit in the base branch. */
  Squash = 'SQUASH'
}

/** The possible methods for updating a pull request's head branch with the base branch. */
export enum PullRequestBranchUpdateMethod {
  /** Update branch via merge */
  Merge = 'MERGE',
  /** Update branch via rebase */
  Rebase = 'REBASE'
}

/** A file changed in a pull request. */
export type PullRequestChangedFile = {
  __typename?: 'PullRequestChangedFile';
  /** The number of additions to the file. */
  additions: Scalars['Int']['output'];
  /** How the file was changed in this PullRequest */
  changeType: PatchStatus;
  /** The number of deletions to the file. */
  deletions: Scalars['Int']['output'];
  /** The path of the file. */
  path: Scalars['String']['output'];
  /** The state of the file for the viewer. */
  viewerViewedState: FileViewedState;
};

/** The connection type for PullRequestChangedFile. */
export type PullRequestChangedFileConnection = {
  __typename?: 'PullRequestChangedFileConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PullRequestChangedFileEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PullRequestChangedFile>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PullRequestChangedFileEdge = {
  __typename?: 'PullRequestChangedFileEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PullRequestChangedFile>;
};

/** Represents a Git commit part of a pull request. */
export type PullRequestCommit = Node & UniformResourceLocatable & {
  __typename?: 'PullRequestCommit';
  /** The Git commit object */
  commit: Commit;
  /** The Node ID of the PullRequestCommit object */
  id: Scalars['ID']['output'];
  /** The pull request this commit belongs to */
  pullRequest: PullRequest;
  /** The HTTP path for this pull request commit */
  resourcePath: Scalars['URI']['output'];
  /** The HTTP URL for this pull request commit */
  url: Scalars['URI']['output'];
};

/** Represents a commit comment thread part of a pull request. */
export type PullRequestCommitCommentThread = Node & RepositoryNode & {
  __typename?: 'PullRequestCommitCommentThread';
  /** The comments that exist in this thread. */
  comments: CommitCommentConnection;
  /** The commit the comments were made on. */
  commit: Commit;
  /** The Node ID of the PullRequestCommitCommentThread object */
  id: Scalars['ID']['output'];
  /** The file the comments were made on. */
  path?: Maybe<Scalars['String']['output']>;
  /** The position in the diff for the commit that the comment was made on. */
  position?: Maybe<Scalars['Int']['output']>;
  /** The pull request this commit comment thread belongs to */
  pullRequest: PullRequest;
  /** The repository associated with this node. */
  repository: Repository;
};


/** Represents a commit comment thread part of a pull request. */
export type PullRequestCommitCommentThreadCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for PullRequestCommit. */
export type PullRequestCommitConnection = {
  __typename?: 'PullRequestCommitConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PullRequestCommitEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PullRequestCommit>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PullRequestCommitEdge = {
  __typename?: 'PullRequestCommitEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PullRequestCommit>;
};

/** The connection type for PullRequest. */
export type PullRequestConnection = {
  __typename?: 'PullRequestConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PullRequestEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PullRequest>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** This aggregates pull requests opened by a user within one repository. */
export type PullRequestContributionsByRepository = {
  __typename?: 'PullRequestContributionsByRepository';
  /** The pull request contributions. */
  contributions: CreatedPullRequestContributionConnection;
  /** The repository in which the pull requests were opened. */
  repository: Repository;
};


/** This aggregates pull requests opened by a user within one repository. */
export type PullRequestContributionsByRepositoryContributionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ContributionOrder>;
};

/** Users who are exempt from the pull request creation cap on a repository. */
export type PullRequestCreationCapConfig = {
  __typename?: 'PullRequestCreationCapConfig';
  /** Users who are exempt from the pull request creation cap. */
  bypassedUsers: UserConnection;
};


/** Users who are exempt from the pull request creation cap on a repository. */
export type PullRequestCreationCapConfigBypassedUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The policy controlling who can create pull requests in a repository. */
export enum PullRequestCreationPolicy {
  /** Anyone can create pull requests. */
  All = 'ALL',
  /** Only collaborators can create pull requests. */
  CollaboratorsOnly = 'COLLABORATORS_ONLY'
}

/** An edge in a connection. */
export type PullRequestEdge = {
  __typename?: 'PullRequestEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PullRequest>;
};

/** Represents available types of methods to use when merging a pull request. */
export enum PullRequestMergeMethod {
  /** Add all commits from the head branch to the base branch with a merge commit. */
  Merge = 'MERGE',
  /** Add all commits from the head branch onto the base branch individually. */
  Rebase = 'REBASE',
  /** Combine all commits from the head branch into a single commit in the base branch. */
  Squash = 'SQUASH'
}

/** Ways in which lists of issues can be ordered upon return. */
export type PullRequestOrder = {
  /** The direction in which to order pull requests by the specified field. */
  direction: OrderDirection;
  /** The field in which to order pull requests by. */
  field: PullRequestOrderField;
};

/** Properties by which pull_requests connections can be ordered. */
export enum PullRequestOrderField {
  /** Order pull_requests by creation time */
  CreatedAt = 'CREATED_AT',
  /** Order pull_requests by update time */
  UpdatedAt = 'UPDATED_AT'
}

/** Require all commits be made to a non-target branch and submitted via a pull request before they can be merged. */
export type PullRequestParameters = {
  __typename?: 'PullRequestParameters';
  /**
   * Array of allowed merge methods. Allowed values include `merge`, `squash`, and
   * `rebase`. At least one option must be enabled.
   */
  allowedMergeMethods?: Maybe<Array<PullRequestAllowedMergeMethods>>;
  /** New, reviewable commits pushed will dismiss previous pull request review approvals. */
  dismissStaleReviewsOnPush: Scalars['Boolean']['output'];
  /** Specify people, teams, or apps allowed to dismiss pull request reviews. */
  dismissalRestriction?: Maybe<DismissalRestriction>;
  /** Require an approving review in pull requests that modify files that have a designated code owner. */
  requireCodeOwnerReview: Scalars['Boolean']['output'];
  /** Whether the most recent reviewable push must be approved by someone other than the person who pushed it. */
  requireLastPushApproval: Scalars['Boolean']['output'];
  /** The number of approving reviews that are required before a pull request can be merged. */
  requiredApprovingReviewCount: Scalars['Int']['output'];
  /** All conversations on code must be resolved before a pull request can be merged. */
  requiredReviewThreadResolution: Scalars['Boolean']['output'];
  /**
   * This field is in beta and subject to change. A collection of reviewers and
   * associated file patterns. Each reviewer has a list of file patterns which
   * determine the files that reviewer is required to review.
   */
  requiredReviewers?: Maybe<Array<RequiredReviewerConfiguration>>;
};

/** Require all commits be made to a non-target branch and submitted via a pull request before they can be merged. */
export type PullRequestParametersInput = {
  /**
   * Array of allowed merge methods. Allowed values include `merge`, `squash`, and
   * `rebase`. At least one option must be enabled.
   */
  allowedMergeMethods?: InputMaybe<Array<PullRequestAllowedMergeMethods>>;
  /** New, reviewable commits pushed will dismiss previous pull request review approvals. */
  dismissStaleReviewsOnPush: Scalars['Boolean']['input'];
  /** Specify people, teams, or apps allowed to dismiss pull request reviews. */
  dismissalRestriction?: InputMaybe<DismissalRestrictionInput>;
  /** Require an approving review in pull requests that modify files that have a designated code owner. */
  requireCodeOwnerReview: Scalars['Boolean']['input'];
  /** Whether the most recent reviewable push must be approved by someone other than the person who pushed it. */
  requireLastPushApproval: Scalars['Boolean']['input'];
  /** The number of approving reviews that are required before a pull request can be merged. */
  requiredApprovingReviewCount: Scalars['Int']['input'];
  /** All conversations on code must be resolved before a pull request can be merged. */
  requiredReviewThreadResolution: Scalars['Boolean']['input'];
  /**
   * This argument is in beta and subject to change. A collection of reviewers and
   * associated file patterns. Each reviewer has a list of file patterns which
   * determine the files that reviewer is required to review.
   */
  requiredReviewers?: InputMaybe<Array<RequiredReviewerConfigurationInput>>;
};

/** A review object for a given pull request. */
export type PullRequestReview = Comment & Deletable & Minimizable & Node & Reactable & RepositoryNode & Updatable & UpdatableComment & {
  __typename?: 'PullRequestReview';
  /** The actor who authored the comment. */
  author?: Maybe<Actor>;
  /** Author's association with the subject of the comment. */
  authorAssociation: CommentAuthorAssociation;
  /** Indicates whether the author of this review has push access to the repository. */
  authorCanPushToRepository: Scalars['Boolean']['output'];
  /** Identifies the pull request review body. */
  body: Scalars['String']['output'];
  /** The body rendered to HTML. */
  bodyHTML: Scalars['HTML']['output'];
  /** The body of this review rendered as plain text. */
  bodyText: Scalars['String']['output'];
  /** A list of review comments for the current pull request review. */
  comments: PullRequestReviewCommentConnection;
  /** Identifies the commit associated with this pull request review. */
  commit?: Maybe<Commit>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Check if this comment was created via an email reply. */
  createdViaEmail: Scalars['Boolean']['output'];
  /**
   * Identifies the primary key from the database.
   * @deprecated `databaseId` will be removed because it does not support 64-bit signed integer identifiers. Use `fullDatabaseId` instead. Removal on 2024-07-01 UTC.
   */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** The actor who edited the comment. */
  editor?: Maybe<Actor>;
  /** Identifies the primary key from the database as a BigInt. */
  fullDatabaseId?: Maybe<Scalars['BigInt']['output']>;
  /** The Node ID of the PullRequestReview object */
  id: Scalars['ID']['output'];
  /** Check if this comment was edited and includes an edit with the creation data */
  includesCreatedEdit: Scalars['Boolean']['output'];
  /** Returns whether or not a comment has been minimized. */
  isMinimized: Scalars['Boolean']['output'];
  /** The moment the editor made the last edit */
  lastEditedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Returns why the comment was minimized. One of `abuse`, `off-topic`,
   * `outdated`, `resolved`, `duplicate`, `spam`, and `low-quality`. Note that the
   * case and formatting of these values differs from the inputs to the
   * `MinimizeComment` mutation.
   */
  minimizedReason?: Maybe<Scalars['String']['output']>;
  /** A list of teams that this review was made on behalf of. */
  onBehalfOf: TeamConnection;
  /** Identifies when the comment was published at. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Identifies the pull request associated with this pull request review. */
  pullRequest: PullRequest;
  /** A list of reactions grouped by content left on the subject. */
  reactionGroups?: Maybe<Array<ReactionGroup>>;
  /** A list of Reactions left on the Issue. */
  reactions: ReactionConnection;
  /** The repository associated with this node. */
  repository: Repository;
  /** The HTTP path permalink for this PullRequestReview. */
  resourcePath: Scalars['URI']['output'];
  /** Identifies the current state of the pull request review. */
  state: PullRequestReviewState;
  /** Identifies when the Pull Request Review was submitted */
  submittedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The HTTP URL permalink for this PullRequestReview. */
  url: Scalars['URI']['output'];
  /** A list of edits to this content. */
  userContentEdits?: Maybe<UserContentEditConnection>;
  /** Check if the current viewer can delete this object. */
  viewerCanDelete: Scalars['Boolean']['output'];
  /** Check if the current viewer can minimize this object. */
  viewerCanMinimize: Scalars['Boolean']['output'];
  /** Can user react to this subject */
  viewerCanReact: Scalars['Boolean']['output'];
  /** Check if the current viewer can unminimize this object. */
  viewerCanUnminimize: Scalars['Boolean']['output'];
  /** Check if the current viewer can update this object. */
  viewerCanUpdate: Scalars['Boolean']['output'];
  /** Reasons why the current viewer can not update this comment. */
  viewerCannotUpdateReasons: Array<CommentCannotUpdateReason>;
  /** Did the viewer author this comment. */
  viewerDidAuthor: Scalars['Boolean']['output'];
};


/** A review object for a given pull request. */
export type PullRequestReviewCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A review object for a given pull request. */
export type PullRequestReviewOnBehalfOfArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A review object for a given pull request. */
export type PullRequestReviewReactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<ReactionContent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ReactionOrder>;
};


/** A review object for a given pull request. */
export type PullRequestReviewUserContentEditsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** A review comment associated with a given repository pull request. */
export type PullRequestReviewComment = Comment & Deletable & Minimizable & Node & Reactable & RepositoryNode & Updatable & UpdatableComment & {
  __typename?: 'PullRequestReviewComment';
  /** The actor who authored the comment. */
  author?: Maybe<Actor>;
  /** Author's association with the subject of the comment. */
  authorAssociation: CommentAuthorAssociation;
  /** The comment body of this review comment. */
  body: Scalars['String']['output'];
  /** The body rendered to HTML. */
  bodyHTML: Scalars['HTML']['output'];
  /** The comment body of this review comment rendered as plain text. */
  bodyText: Scalars['String']['output'];
  /** Identifies the commit associated with the comment. */
  commit?: Maybe<Commit>;
  /** Identifies when the comment was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Check if this comment was created via an email reply. */
  createdViaEmail: Scalars['Boolean']['output'];
  /**
   * Identifies the primary key from the database.
   * @deprecated `databaseId` will be removed because it does not support 64-bit signed integer identifiers. Use `fullDatabaseId` instead. Removal on 2024-07-01 UTC.
   */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** The diff hunk to which the comment applies. */
  diffHunk: Scalars['String']['output'];
  /** Identifies when the comment was created in a draft state. */
  draftedAt: Scalars['DateTime']['output'];
  /** The actor who edited the comment. */
  editor?: Maybe<Actor>;
  /** Identifies the primary key from the database as a BigInt. */
  fullDatabaseId?: Maybe<Scalars['BigInt']['output']>;
  /** The Node ID of the PullRequestReviewComment object */
  id: Scalars['ID']['output'];
  /** Check if this comment was edited and includes an edit with the creation data */
  includesCreatedEdit: Scalars['Boolean']['output'];
  /** Returns whether or not a comment has been minimized. */
  isMinimized: Scalars['Boolean']['output'];
  /** The moment the editor made the last edit */
  lastEditedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The end line number on the file to which the comment applies */
  line?: Maybe<Scalars['Int']['output']>;
  /**
   * Returns why the comment was minimized. One of `abuse`, `off-topic`,
   * `outdated`, `resolved`, `duplicate`, `spam`, and `low-quality`. Note that the
   * case and formatting of these values differs from the inputs to the
   * `MinimizeComment` mutation.
   */
  minimizedReason?: Maybe<Scalars['String']['output']>;
  /** Identifies the original commit associated with the comment. */
  originalCommit?: Maybe<Commit>;
  /** The end line number on the file to which the comment applied when it was first created */
  originalLine?: Maybe<Scalars['Int']['output']>;
  /**
   * The original line index in the diff to which the comment applies.
   * @deprecated We are phasing out diff-relative positioning for PR comments Removal on 2023-10-01 UTC.
   */
  originalPosition: Scalars['Int']['output'];
  /** The start line number on the file to which the comment applied when it was first created */
  originalStartLine?: Maybe<Scalars['Int']['output']>;
  /** Identifies when the comment body is outdated */
  outdated: Scalars['Boolean']['output'];
  /** The path to which the comment applies. */
  path: Scalars['String']['output'];
  /**
   * The line index in the diff to which the comment applies.
   * @deprecated We are phasing out diff-relative positioning for PR comments Use the `line` and `startLine` fields instead, which are file line numbers instead of diff line numbers Removal on 2023-10-01 UTC.
   */
  position?: Maybe<Scalars['Int']['output']>;
  /** Identifies when the comment was published at. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The pull request associated with this review comment. */
  pullRequest: PullRequest;
  /** The pull request review associated with this review comment. */
  pullRequestReview?: Maybe<PullRequestReview>;
  /** A list of reactions grouped by content left on the subject. */
  reactionGroups?: Maybe<Array<ReactionGroup>>;
  /** A list of Reactions left on the Issue. */
  reactions: ReactionConnection;
  /** The comment this is a reply to. */
  replyTo?: Maybe<PullRequestReviewComment>;
  /** The repository associated with this node. */
  repository: Repository;
  /** The HTTP path permalink for this review comment. */
  resourcePath: Scalars['URI']['output'];
  /** The start line number on the file to which the comment applies */
  startLine?: Maybe<Scalars['Int']['output']>;
  /** Identifies the state of the comment. */
  state: PullRequestReviewCommentState;
  /** The level at which the comments in the corresponding thread are targeted, can be a diff line or a file */
  subjectType: PullRequestReviewThreadSubjectType;
  /** Identifies when the comment was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The HTTP URL permalink for this review comment. */
  url: Scalars['URI']['output'];
  /** A list of edits to this content. */
  userContentEdits?: Maybe<UserContentEditConnection>;
  /** Check if the current viewer can delete this object. */
  viewerCanDelete: Scalars['Boolean']['output'];
  /** Check if the current viewer can minimize this object. */
  viewerCanMinimize: Scalars['Boolean']['output'];
  /** Can user react to this subject */
  viewerCanReact: Scalars['Boolean']['output'];
  /** Check if the current viewer can unminimize this object. */
  viewerCanUnminimize: Scalars['Boolean']['output'];
  /** Check if the current viewer can update this object. */
  viewerCanUpdate: Scalars['Boolean']['output'];
  /** Reasons why the current viewer can not update this comment. */
  viewerCannotUpdateReasons: Array<CommentCannotUpdateReason>;
  /** Did the viewer author this comment. */
  viewerDidAuthor: Scalars['Boolean']['output'];
};


/** A review comment associated with a given repository pull request. */
export type PullRequestReviewCommentReactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<ReactionContent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ReactionOrder>;
};


/** A review comment associated with a given repository pull request. */
export type PullRequestReviewCommentUserContentEditsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for PullRequestReviewComment. */
export type PullRequestReviewCommentConnection = {
  __typename?: 'PullRequestReviewCommentConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PullRequestReviewCommentEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PullRequestReviewComment>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PullRequestReviewCommentEdge = {
  __typename?: 'PullRequestReviewCommentEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PullRequestReviewComment>;
};

/** The possible states of a pull request review comment. */
export enum PullRequestReviewCommentState {
  /** A comment that is part of a pending review */
  Pending = 'PENDING',
  /** A comment that is part of a submitted review */
  Submitted = 'SUBMITTED'
}

/** The connection type for PullRequestReview. */
export type PullRequestReviewConnection = {
  __typename?: 'PullRequestReviewConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PullRequestReviewEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PullRequestReview>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** This aggregates pull request reviews made by a user within one repository. */
export type PullRequestReviewContributionsByRepository = {
  __typename?: 'PullRequestReviewContributionsByRepository';
  /** The pull request review contributions. */
  contributions: CreatedPullRequestReviewContributionConnection;
  /** The repository in which the pull request reviews were made. */
  repository: Repository;
};


/** This aggregates pull request reviews made by a user within one repository. */
export type PullRequestReviewContributionsByRepositoryContributionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ContributionOrder>;
};

/** The review status of a pull request. */
export enum PullRequestReviewDecision {
  /** The pull request has received an approving review. */
  Approved = 'APPROVED',
  /** Changes have been requested on the pull request. */
  ChangesRequested = 'CHANGES_REQUESTED',
  /** A review is required before the pull request can be merged. */
  ReviewRequired = 'REVIEW_REQUIRED'
}

/** An edge in a connection. */
export type PullRequestReviewEdge = {
  __typename?: 'PullRequestReviewEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PullRequestReview>;
};

/** The possible events to perform on a pull request review. */
export enum PullRequestReviewEvent {
  /** Submit feedback and approve merging these changes. */
  Approve = 'APPROVE',
  /** Submit general feedback without explicit approval. */
  Comment = 'COMMENT',
  /** Dismiss review so it now longer effects merging. */
  Dismiss = 'DISMISS',
  /** Submit feedback that must be addressed before merging. */
  RequestChanges = 'REQUEST_CHANGES'
}

/** The possible states of a pull request review. */
export enum PullRequestReviewState {
  /** A review allowing the pull request to merge. */
  Approved = 'APPROVED',
  /** A review blocking the pull request from merging. */
  ChangesRequested = 'CHANGES_REQUESTED',
  /** An informational review. */
  Commented = 'COMMENTED',
  /** A review that has been dismissed. */
  Dismissed = 'DISMISSED',
  /** A review that has not yet been submitted. */
  Pending = 'PENDING'
}

/** A threaded list of comments for a given pull request. */
export type PullRequestReviewThread = Node & {
  __typename?: 'PullRequestReviewThread';
  /** A list of pull request comments associated with the thread. */
  comments: PullRequestReviewCommentConnection;
  /** The side of the diff on which this thread was placed. */
  diffSide: DiffSide;
  /** The Node ID of the PullRequestReviewThread object */
  id: Scalars['ID']['output'];
  /** Whether or not the thread has been collapsed (resolved) */
  isCollapsed: Scalars['Boolean']['output'];
  /** Indicates whether this thread was outdated by newer changes. */
  isOutdated: Scalars['Boolean']['output'];
  /** Whether this thread has been resolved */
  isResolved: Scalars['Boolean']['output'];
  /** The line in the file to which this thread refers */
  line?: Maybe<Scalars['Int']['output']>;
  /** The original line in the file to which this thread refers. */
  originalLine?: Maybe<Scalars['Int']['output']>;
  /** The original start line in the file to which this thread refers (multi-line only). */
  originalStartLine?: Maybe<Scalars['Int']['output']>;
  /** Identifies the file path of this thread. */
  path: Scalars['String']['output'];
  /** Identifies the pull request associated with this thread. */
  pullRequest: PullRequest;
  /** Identifies the repository associated with this thread. */
  repository: Repository;
  /** The user who resolved this thread */
  resolvedBy?: Maybe<User>;
  /** The side of the diff that the first line of the thread starts on (multi-line only) */
  startDiffSide?: Maybe<DiffSide>;
  /** The start line in the file to which this thread refers (multi-line only) */
  startLine?: Maybe<Scalars['Int']['output']>;
  /** The level at which the comments in the corresponding thread are targeted, can be a diff line or a file */
  subjectType: PullRequestReviewThreadSubjectType;
  /** Indicates whether the current viewer can reply to this thread. */
  viewerCanReply: Scalars['Boolean']['output'];
  /** Whether or not the viewer can resolve this thread */
  viewerCanResolve: Scalars['Boolean']['output'];
  /** Whether or not the viewer can unresolve this thread */
  viewerCanUnresolve: Scalars['Boolean']['output'];
};


/** A threaded list of comments for a given pull request. */
export type PullRequestReviewThreadCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

/** Review comment threads for a pull request review. */
export type PullRequestReviewThreadConnection = {
  __typename?: 'PullRequestReviewThreadConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PullRequestReviewThreadEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PullRequestReviewThread>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PullRequestReviewThreadEdge = {
  __typename?: 'PullRequestReviewThreadEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PullRequestReviewThread>;
};

/** The possible reasons a pull request review thread was resolved. */
export enum PullRequestReviewThreadResolutionReason {
  /** The review comment was addressed. */
  Addressed = 'ADDRESSED',
  /** The review comment is invalid. */
  Invalid = 'INVALID',
  /** The review comment will not be addressed. */
  WontFix = 'WONT_FIX'
}

/** The possible subject types of a pull request review comment. */
export enum PullRequestReviewThreadSubjectType {
  /** A comment that has been made against the file of a pull request */
  File = 'FILE',
  /** A comment that has been made against the line of a pull request */
  Line = 'LINE'
}

/** Represents the latest point in the pull request timeline for which the viewer has seen the pull request's commits. */
export type PullRequestRevisionMarker = {
  __typename?: 'PullRequestRevisionMarker';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The last commit the viewer has seen. */
  lastSeenCommit: Commit;
  /** The pull request to which the marker belongs. */
  pullRequest: PullRequest;
};

/** A stack of PullRequests */
export type PullRequestStack = Node & {
  __typename?: 'PullRequestStack';
  /** The branch that the stack's pull requests target */
  baseRefName: Scalars['String']['output'];
  /** The entries in the stack */
  entries: PullRequestStackEntryConnection;
  /** The Node ID of the PullRequestStack object */
  id: Scalars['ID']['output'];
  /** A number uniquely identifying the stack within its repository */
  number: Scalars['Int']['output'];
  /** The total number of pull requests in the stack */
  size: Scalars['Int']['output'];
};


/** A stack of PullRequests */
export type PullRequestStackEntriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** A member of a PullRequestStack */
export type PullRequestStackEntry = Node & {
  __typename?: 'PullRequestStackEntry';
  /** The Node ID of the PullRequestStackEntry object */
  id: Scalars['ID']['output'];
  /** This entry's position in the stack, where 1 is the closest to the base branch, 2 is stacked on top of 1, etc. */
  position: Scalars['Int']['output'];
  /** The pull request that occupies this position in the stack */
  pullRequest?: Maybe<PullRequest>;
  /** The stack that this entry is a part of */
  stack?: Maybe<PullRequestStack>;
};

/** Entries in a pull request stack */
export type PullRequestStackEntryConnection = {
  __typename?: 'PullRequestStackEntryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PullRequestStackEntryEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PullRequestStackEntry>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PullRequestStackEntryEdge = {
  __typename?: 'PullRequestStackEntryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PullRequestStackEntry>;
};

/** The possible states of a pull request. */
export enum PullRequestState {
  /** A pull request that has been closed without being merged. */
  Closed = 'CLOSED',
  /** A pull request that has been closed by being merged. */
  Merged = 'MERGED',
  /** A pull request that is still open. */
  Open = 'OPEN'
}

/** A repository pull request template. */
export type PullRequestTemplate = {
  __typename?: 'PullRequestTemplate';
  /** The body of the template */
  body?: Maybe<Scalars['String']['output']>;
  /** The filename of the template */
  filename?: Maybe<Scalars['String']['output']>;
  /** The repository the template belongs to */
  repository: Repository;
};

/** A threaded list of comments for a given pull request. */
export type PullRequestThread = Node & {
  __typename?: 'PullRequestThread';
  /** A list of pull request comments associated with the thread. */
  comments: PullRequestReviewCommentConnection;
  /** The side of the diff on which this thread was placed. */
  diffSide: DiffSide;
  /** The Node ID of the PullRequestThread object */
  id: Scalars['ID']['output'];
  /** Whether or not the thread has been collapsed (resolved) */
  isCollapsed: Scalars['Boolean']['output'];
  /** Indicates whether this thread was outdated by newer changes. */
  isOutdated: Scalars['Boolean']['output'];
  /** Whether this thread has been resolved */
  isResolved: Scalars['Boolean']['output'];
  /** The line in the file to which this thread refers */
  line?: Maybe<Scalars['Int']['output']>;
  /** Identifies the file path of this thread. */
  path: Scalars['String']['output'];
  /** Identifies the pull request associated with this thread. */
  pullRequest: PullRequest;
  /** Identifies the repository associated with this thread. */
  repository: Repository;
  /** The user who resolved this thread */
  resolvedBy?: Maybe<User>;
  /** The side of the diff that the first line of the thread starts on (multi-line only) */
  startDiffSide?: Maybe<DiffSide>;
  /** The line of the first file diff in the thread. */
  startLine?: Maybe<Scalars['Int']['output']>;
  /** The level at which the comments in the corresponding thread are targeted, can be a diff line or a file */
  subjectType: PullRequestReviewThreadSubjectType;
  /** Indicates whether the current viewer can reply to this thread. */
  viewerCanReply: Scalars['Boolean']['output'];
  /** Whether or not the viewer can resolve this thread */
  viewerCanResolve: Scalars['Boolean']['output'];
  /** Whether or not the viewer can unresolve this thread */
  viewerCanUnresolve: Scalars['Boolean']['output'];
};


/** A threaded list of comments for a given pull request. */
export type PullRequestThreadCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for PullRequestTimelineItem. */
export type PullRequestTimelineConnection = {
  __typename?: 'PullRequestTimelineConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PullRequestTimelineItemEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PullRequestTimelineItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An item in a pull request timeline */
export type PullRequestTimelineItem = AssignedEvent | BaseRefDeletedEvent | BaseRefForcePushedEvent | ClosedEvent | Commit | CommitCommentThread | CrossReferencedEvent | DemilestonedEvent | DeployedEvent | DeploymentEnvironmentChangedEvent | HeadRefDeletedEvent | HeadRefForcePushedEvent | HeadRefRestoredEvent | IssueComment | LabeledEvent | LockedEvent | MergedEvent | MilestonedEvent | PullRequestReview | PullRequestReviewComment | PullRequestReviewThread | ReferencedEvent | RenamedTitleEvent | ReopenedEvent | ReviewDismissedEvent | ReviewRequestRemovedEvent | ReviewRequestedEvent | SubscribedEvent | UnassignedEvent | UnlabeledEvent | UnlockedEvent | UnsubscribedEvent | UserBlockedEvent;

/** An edge in a connection. */
export type PullRequestTimelineItemEdge = {
  __typename?: 'PullRequestTimelineItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PullRequestTimelineItem>;
};

/** An item in a pull request timeline */
export type PullRequestTimelineItems = AddedToMergeQueueEvent | AddedToProjectEvent | AddedToProjectV2Event | AddedToStackEvent | AssignedEvent | AutoMergeDisabledEvent | AutoMergeEnabledEvent | AutoRebaseEnabledEvent | AutoSquashEnabledEvent | AutomaticBaseChangeFailedEvent | AutomaticBaseChangeSucceededEvent | BaseRefChangedEvent | BaseRefDeletedEvent | BaseRefForcePushedEvent | BlockedByAddedEvent | BlockedByRemovedEvent | BlockingAddedEvent | BlockingRemovedEvent | ClosedEvent | CommentDeletedEvent | ConnectedEvent | ConvertToDraftEvent | ConvertedFromDraftEvent | ConvertedNoteToIssueEvent | ConvertedToDiscussionEvent | CrossReferencedEvent | DemilestonedEvent | DeployedEvent | DeploymentEnvironmentChangedEvent | DisconnectedEvent | HeadRefDeletedEvent | HeadRefForcePushedEvent | HeadRefRestoredEvent | IssueComment | IssueCommentPinnedEvent | IssueCommentUnpinnedEvent | IssueFieldAddedEvent | IssueFieldChangedEvent | IssueFieldRemovedEvent | IssueTypeAddedEvent | IssueTypeChangedEvent | IssueTypeRemovedEvent | LabeledEvent | LockedEvent | MarkedAsDuplicateEvent | MentionedEvent | MergedEvent | MilestonedEvent | MovedColumnsInProjectEvent | ParentIssueAddedEvent | ParentIssueRemovedEvent | PinnedEvent | ProjectV2ItemStatusChangedEvent | PullRequestCommit | PullRequestCommitCommentThread | PullRequestReview | PullRequestReviewThread | PullRequestRevisionMarker | ReadyForReviewEvent | ReferencedEvent | RemovedFromMergeQueueEvent | RemovedFromProjectEvent | RemovedFromProjectV2Event | RemovedFromStackEvent | RenamedTitleEvent | ReopenedEvent | ReviewDismissedEvent | ReviewRequestRemovedEvent | ReviewRequestedEvent | SubIssueAddedEvent | SubIssueRemovedEvent | SubscribedEvent | TransferredEvent | UnassignedEvent | UnlabeledEvent | UnlockedEvent | UnmarkedAsDuplicateEvent | UnpinnedEvent | UnsubscribedEvent | UserBlockedEvent;

/** The connection type for PullRequestTimelineItems. */
export type PullRequestTimelineItemsConnection = {
  __typename?: 'PullRequestTimelineItemsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PullRequestTimelineItemsEdge>>>;
  /** Identifies the count of items after applying `before` and `after` filters. */
  filteredCount: Scalars['Int']['output'];
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PullRequestTimelineItems>>>;
  /** Identifies the count of items after applying `before`/`after` filters and `first`/`last`/`skip` slicing. */
  pageCount: Scalars['Int']['output'];
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
  /** Identifies the date and time when the timeline was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** An edge in a connection. */
export type PullRequestTimelineItemsEdge = {
  __typename?: 'PullRequestTimelineItemsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PullRequestTimelineItems>;
};

/** The possible item types found in a timeline. */
export enum PullRequestTimelineItemsItemType {
  /** Represents an 'added_to_merge_queue' event on a given pull request. */
  AddedToMergeQueueEvent = 'ADDED_TO_MERGE_QUEUE_EVENT',
  /** Represents a 'added_to_project' event on a given issue or pull request. */
  AddedToProjectEvent = 'ADDED_TO_PROJECT_EVENT',
  /** Represents a 'added_to_project_v2' event on a given issue or pull request. */
  AddedToProjectV2Event = 'ADDED_TO_PROJECT_V2_EVENT',
  /** Represents an 'added_to_stack' event on a given pull request. */
  AddedToStackEvent = 'ADDED_TO_STACK_EVENT',
  /** Represents an 'archived' event on a given pull request. */
  ArchivedEvent = 'ARCHIVED_EVENT',
  /** Represents an 'assigned' event on any assignable object. */
  AssignedEvent = 'ASSIGNED_EVENT',
  /** Represents a 'automatic_base_change_failed' event on a given pull request. */
  AutomaticBaseChangeFailedEvent = 'AUTOMATIC_BASE_CHANGE_FAILED_EVENT',
  /** Represents a 'automatic_base_change_succeeded' event on a given pull request. */
  AutomaticBaseChangeSucceededEvent = 'AUTOMATIC_BASE_CHANGE_SUCCEEDED_EVENT',
  /** Represents a 'auto_merge_disabled' event on a given pull request. */
  AutoMergeDisabledEvent = 'AUTO_MERGE_DISABLED_EVENT',
  /** Represents a 'auto_merge_enabled' event on a given pull request. */
  AutoMergeEnabledEvent = 'AUTO_MERGE_ENABLED_EVENT',
  /** Represents a 'auto_rebase_enabled' event on a given pull request. */
  AutoRebaseEnabledEvent = 'AUTO_REBASE_ENABLED_EVENT',
  /** Represents a 'auto_squash_enabled' event on a given pull request. */
  AutoSquashEnabledEvent = 'AUTO_SQUASH_ENABLED_EVENT',
  /** Represents a 'base_ref_changed' event on a given issue or pull request. */
  BaseRefChangedEvent = 'BASE_REF_CHANGED_EVENT',
  /** Represents a 'base_ref_deleted' event on a given pull request. */
  BaseRefDeletedEvent = 'BASE_REF_DELETED_EVENT',
  /** Represents a 'base_ref_force_pushed' event on a given pull request. */
  BaseRefForcePushedEvent = 'BASE_REF_FORCE_PUSHED_EVENT',
  /** Represents a 'blocked_by_added' event on a given issue. */
  BlockedByAddedEvent = 'BLOCKED_BY_ADDED_EVENT',
  /** Represents a 'blocked_by_removed' event on a given issue. */
  BlockedByRemovedEvent = 'BLOCKED_BY_REMOVED_EVENT',
  /** Represents a 'blocking_added' event on a given issue. */
  BlockingAddedEvent = 'BLOCKING_ADDED_EVENT',
  /** Represents a 'blocking_removed' event on a given issue. */
  BlockingRemovedEvent = 'BLOCKING_REMOVED_EVENT',
  /** Represents a 'closed' event on any `Closable`. */
  ClosedEvent = 'CLOSED_EVENT',
  /** Represents a 'comment_deleted' event on a given issue or pull request. */
  CommentDeletedEvent = 'COMMENT_DELETED_EVENT',
  /** Represents a 'connected' event on a given issue or pull request. */
  ConnectedEvent = 'CONNECTED_EVENT',
  /** Represents a 'converted_from_draft' event on a given issue or pull request. */
  ConvertedFromDraftEvent = 'CONVERTED_FROM_DRAFT_EVENT',
  /** Represents a 'converted_note_to_issue' event on a given issue or pull request. */
  ConvertedNoteToIssueEvent = 'CONVERTED_NOTE_TO_ISSUE_EVENT',
  /** Represents a 'converted_to_discussion' event on a given issue. */
  ConvertedToDiscussionEvent = 'CONVERTED_TO_DISCUSSION_EVENT',
  /** Represents a 'convert_to_draft' event on a given pull request. */
  ConvertToDraftEvent = 'CONVERT_TO_DRAFT_EVENT',
  /** Represents a mention made by one issue or pull request to another. */
  CrossReferencedEvent = 'CROSS_REFERENCED_EVENT',
  /** Represents a 'demilestoned' event on a given issue or pull request. */
  DemilestonedEvent = 'DEMILESTONED_EVENT',
  /** Represents a 'deployed' event on a given pull request. */
  DeployedEvent = 'DEPLOYED_EVENT',
  /** Represents a 'deployment_environment_changed' event on a given pull request. */
  DeploymentEnvironmentChangedEvent = 'DEPLOYMENT_ENVIRONMENT_CHANGED_EVENT',
  /** Represents a 'disconnected' event on a given issue or pull request. */
  DisconnectedEvent = 'DISCONNECTED_EVENT',
  /** Represents a 'head_ref_deleted' event on a given pull request. */
  HeadRefDeletedEvent = 'HEAD_REF_DELETED_EVENT',
  /** Represents a 'head_ref_force_pushed' event on a given pull request. */
  HeadRefForcePushedEvent = 'HEAD_REF_FORCE_PUSHED_EVENT',
  /** Represents a 'head_ref_restored' event on a given pull request. */
  HeadRefRestoredEvent = 'HEAD_REF_RESTORED_EVENT',
  /** Represents a comment on an Issue. */
  IssueComment = 'ISSUE_COMMENT',
  /** Represents a 'issue_comment_pinned' event on a given issue. */
  IssueCommentPinnedEvent = 'ISSUE_COMMENT_PINNED_EVENT',
  /** Represents a 'issue_comment_unpinned' event on a given issue. */
  IssueCommentUnpinnedEvent = 'ISSUE_COMMENT_UNPINNED_EVENT',
  /** Represents a 'issue_field_added' event on a given issue. */
  IssueFieldAddedEvent = 'ISSUE_FIELD_ADDED_EVENT',
  /** Represents a 'issue_field_changed' event on a given issue. */
  IssueFieldChangedEvent = 'ISSUE_FIELD_CHANGED_EVENT',
  /** Represents a 'issue_field_removed' event on a given issue. */
  IssueFieldRemovedEvent = 'ISSUE_FIELD_REMOVED_EVENT',
  /** Represents a 'issue_type_added' event on a given issue. */
  IssueTypeAddedEvent = 'ISSUE_TYPE_ADDED_EVENT',
  /** Represents a 'issue_type_changed' event on a given issue. */
  IssueTypeChangedEvent = 'ISSUE_TYPE_CHANGED_EVENT',
  /** Represents a 'issue_type_removed' event on a given issue. */
  IssueTypeRemovedEvent = 'ISSUE_TYPE_REMOVED_EVENT',
  /** Represents a 'labeled' event on a given issue or pull request. */
  LabeledEvent = 'LABELED_EVENT',
  /** Represents a 'locked' event on a given issue or pull request. */
  LockedEvent = 'LOCKED_EVENT',
  /** Represents a 'marked_as_duplicate' event on a given issue or pull request. */
  MarkedAsDuplicateEvent = 'MARKED_AS_DUPLICATE_EVENT',
  /** Represents a 'mentioned' event on a given issue or pull request. */
  MentionedEvent = 'MENTIONED_EVENT',
  /** Represents a 'merged' event on a given pull request. */
  MergedEvent = 'MERGED_EVENT',
  /** Represents a 'milestoned' event on a given issue or pull request. */
  MilestonedEvent = 'MILESTONED_EVENT',
  /** Represents a 'moved_columns_in_project' event on a given issue or pull request. */
  MovedColumnsInProjectEvent = 'MOVED_COLUMNS_IN_PROJECT_EVENT',
  /** Represents a 'parent_issue_added' event on a given issue. */
  ParentIssueAddedEvent = 'PARENT_ISSUE_ADDED_EVENT',
  /** Represents a 'parent_issue_removed' event on a given issue. */
  ParentIssueRemovedEvent = 'PARENT_ISSUE_REMOVED_EVENT',
  /** Represents a 'pinned' event on a given issue or pull request. */
  PinnedEvent = 'PINNED_EVENT',
  /** Represents a 'project_v2_item_status_changed' event on a given issue or pull request. */
  ProjectV2ItemStatusChangedEvent = 'PROJECT_V2_ITEM_STATUS_CHANGED_EVENT',
  /** Represents a Git commit part of a pull request. */
  PullRequestCommit = 'PULL_REQUEST_COMMIT',
  /** Represents a commit comment thread part of a pull request. */
  PullRequestCommitCommentThread = 'PULL_REQUEST_COMMIT_COMMENT_THREAD',
  /** A review object for a given pull request. */
  PullRequestReview = 'PULL_REQUEST_REVIEW',
  /** A threaded list of comments for a given pull request. */
  PullRequestReviewThread = 'PULL_REQUEST_REVIEW_THREAD',
  /** Represents the latest point in the pull request timeline for which the viewer has seen the pull request's commits. */
  PullRequestRevisionMarker = 'PULL_REQUEST_REVISION_MARKER',
  /** Represents a 'ready_for_review' event on a given pull request. */
  ReadyForReviewEvent = 'READY_FOR_REVIEW_EVENT',
  /** Represents a 'referenced' event on a given `ReferencedSubject`. */
  ReferencedEvent = 'REFERENCED_EVENT',
  /** Represents a 'removed_from_merge_queue' event on a given pull request. */
  RemovedFromMergeQueueEvent = 'REMOVED_FROM_MERGE_QUEUE_EVENT',
  /** Represents a 'removed_from_project' event on a given issue or pull request. */
  RemovedFromProjectEvent = 'REMOVED_FROM_PROJECT_EVENT',
  /** Represents a 'removed_from_project_v2' event on a given issue or pull request. */
  RemovedFromProjectV2Event = 'REMOVED_FROM_PROJECT_V2_EVENT',
  /** Represents a 'removed_from_stack' event on a given pull request. */
  RemovedFromStackEvent = 'REMOVED_FROM_STACK_EVENT',
  /** Represents a 'renamed' event on a given issue or pull request */
  RenamedTitleEvent = 'RENAMED_TITLE_EVENT',
  /** Represents a 'reopened' event on any `Closable`. */
  ReopenedEvent = 'REOPENED_EVENT',
  /** Represents a 'review_dismissed' event on a given issue or pull request. */
  ReviewDismissedEvent = 'REVIEW_DISMISSED_EVENT',
  /** Represents an 'review_requested' event on a given pull request. */
  ReviewRequestedEvent = 'REVIEW_REQUESTED_EVENT',
  /** Represents an 'review_request_removed' event on a given pull request. */
  ReviewRequestRemovedEvent = 'REVIEW_REQUEST_REMOVED_EVENT',
  /** Represents a 'subscribed' event on a given `Subscribable`. */
  SubscribedEvent = 'SUBSCRIBED_EVENT',
  /** Represents a 'sub_issue_added' event on a given issue. */
  SubIssueAddedEvent = 'SUB_ISSUE_ADDED_EVENT',
  /** Represents a 'sub_issue_removed' event on a given issue. */
  SubIssueRemovedEvent = 'SUB_ISSUE_REMOVED_EVENT',
  /** Represents a 'transferred' event on a given issue or pull request. */
  TransferredEvent = 'TRANSFERRED_EVENT',
  /** Represents an 'unarchived' event on a given pull request. */
  UnarchivedEvent = 'UNARCHIVED_EVENT',
  /** Represents an 'unassigned' event on any assignable object. */
  UnassignedEvent = 'UNASSIGNED_EVENT',
  /** Represents an 'unlabeled' event on a given issue or pull request. */
  UnlabeledEvent = 'UNLABELED_EVENT',
  /** Represents an 'unlocked' event on a given issue or pull request. */
  UnlockedEvent = 'UNLOCKED_EVENT',
  /** Represents an 'unmarked_as_duplicate' event on a given issue or pull request. */
  UnmarkedAsDuplicateEvent = 'UNMARKED_AS_DUPLICATE_EVENT',
  /** Represents an 'unpinned' event on a given issue or pull request. */
  UnpinnedEvent = 'UNPINNED_EVENT',
  /** Represents an 'unsubscribed' event on a given `Subscribable`. */
  UnsubscribedEvent = 'UNSUBSCRIBED_EVENT',
  /** Represents a 'user_blocked' event on a given user. */
  UserBlockedEvent = 'USER_BLOCKED_EVENT'
}

/** The possible target states when updating a pull request. */
export enum PullRequestUpdateState {
  /** A pull request that has been closed without being merged. */
  Closed = 'CLOSED',
  /** A pull request that is still open. */
  Open = 'OPEN'
}

/** A Git push. */
export type Push = Node & {
  __typename?: 'Push';
  /** The Node ID of the Push object */
  id: Scalars['ID']['output'];
  /** The SHA after the push */
  nextSha?: Maybe<Scalars['GitObjectID']['output']>;
  /** The permalink for this push. */
  permalink: Scalars['URI']['output'];
  /** The SHA before the push */
  previousSha?: Maybe<Scalars['GitObjectID']['output']>;
  /** The actor who pushed */
  pusher: Actor;
  /** The repository that was pushed to */
  repository: Repository;
};

/** A team, user, or app who has the ability to push to a protected branch. */
export type PushAllowance = Node & {
  __typename?: 'PushAllowance';
  /** The actor that can push. */
  actor?: Maybe<PushAllowanceActor>;
  /** Identifies the branch protection rule associated with the allowed user, team, or app. */
  branchProtectionRule?: Maybe<BranchProtectionRule>;
  /** The Node ID of the PushAllowance object */
  id: Scalars['ID']['output'];
};

/** Types that can be an actor. */
export type PushAllowanceActor = App | Team | User;

/** The connection type for PushAllowance. */
export type PushAllowanceConnection = {
  __typename?: 'PushAllowanceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<PushAllowanceEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<PushAllowance>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type PushAllowanceEdge = {
  __typename?: 'PushAllowanceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<PushAllowance>;
};

/** The query root of GitHub's GraphQL interface. */
export type Query = Node & {
  __typename?: 'Query';
  /** Look up a code of conduct by its key */
  codeOfConduct?: Maybe<CodeOfConduct>;
  /** Look up a code of conduct by its key */
  codesOfConduct?: Maybe<Array<Maybe<CodeOfConduct>>>;
  /** Look up an enterprise by URL slug. */
  enterprise?: Maybe<Enterprise>;
  /** Look up a pending enterprise administrator invitation by invitee, enterprise and role. */
  enterpriseAdministratorInvitation?: Maybe<EnterpriseAdministratorInvitation>;
  /**
   * Look up a pending enterprise administrator invitation by invitation token. If
   * the invitation was sent to an email address, the viewer must have verified
   * that email address, or otherwise be an administrator of the enterprise.
   */
  enterpriseAdministratorInvitationByToken?: Maybe<EnterpriseAdministratorInvitation>;
  /** Look up a pending enterprise unaffiliated member invitation by invitee and enterprise. */
  enterpriseMemberInvitation?: Maybe<EnterpriseMemberInvitation>;
  /**
   * Look up a pending enterprise unaffiliated member invitation by invitation
   * token. If the invitation was sent to an email address, the viewer must have
   * verified that email address, or otherwise be an administrator of the enterprise.
   */
  enterpriseMemberInvitationByToken?: Maybe<EnterpriseMemberInvitation>;
  /** ID of the object. */
  id: Scalars['ID']['output'];
  /** Look up an open source license by its key */
  license?: Maybe<License>;
  /** Return a list of known open source licenses */
  licenses: Array<Maybe<License>>;
  /** Get alphabetically sorted list of Marketplace categories */
  marketplaceCategories: Array<MarketplaceCategory>;
  /** Look up a Marketplace category by its slug. */
  marketplaceCategory?: Maybe<MarketplaceCategory>;
  /** Look up a single Marketplace listing */
  marketplaceListing?: Maybe<MarketplaceListing>;
  /** Look up Marketplace listings */
  marketplaceListings: MarketplaceListingConnection;
  /** Return information about the GitHub instance */
  meta: GitHubMetadata;
  /** Fetches an object given its ID. */
  node?: Maybe<Node>;
  /** Lookup nodes by a list of IDs. */
  nodes: Array<Maybe<Node>>;
  /** Lookup a organization by login. */
  organization?: Maybe<Organization>;
  /** The client's rate limit information. */
  rateLimit?: Maybe<RateLimit>;
  /**
   * Workaround for re-exposing the root query object. (Refer to
   * https://github.com/facebook/relay/issues/112 for more information.)
   */
  relay: Query;
  /** Lookup a given repository by the owner and repository name. */
  repository?: Maybe<Repository>;
  /** Lookup a repository owner (ie. either a User or an Organization) by login. */
  repositoryOwner?: Maybe<RepositoryOwner>;
  /** Lookup resource by a URL. */
  resource?: Maybe<UniformResourceLocatable>;
  /** Perform a search across resources, returning a maximum of 1,000 results. */
  search: SearchResultItemConnection;
  /** GitHub Security Advisories */
  securityAdvisories: SecurityAdvisoryConnection;
  /** Fetch a Security Advisory by its GHSA ID */
  securityAdvisory?: Maybe<SecurityAdvisory>;
  /** Software Vulnerabilities documented by GitHub Security Advisories */
  securityVulnerabilities: SecurityVulnerabilityConnection;
  /** Users and organizations who can be sponsored via GitHub Sponsors. */
  sponsorables: SponsorableItemConnection;
  /** Look up a topic by name. */
  topic?: Maybe<Topic>;
  /** Lookup a user by login. */
  user?: Maybe<User>;
  /** The currently authenticated user. */
  viewer: User;
};


/** The query root of GitHub's GraphQL interface. */
export type QueryCodeOfConductArgs = {
  key: Scalars['String']['input'];
};


/** The query root of GitHub's GraphQL interface. */
export type QueryEnterpriseArgs = {
  invitationToken?: InputMaybe<Scalars['String']['input']>;
  slug: Scalars['String']['input'];
};


/** The query root of GitHub's GraphQL interface. */
export type QueryEnterpriseAdministratorInvitationArgs = {
  enterpriseSlug: Scalars['String']['input'];
  role: EnterpriseAdministratorRole;
  userLogin: Scalars['String']['input'];
};


/** The query root of GitHub's GraphQL interface. */
export type QueryEnterpriseAdministratorInvitationByTokenArgs = {
  invitationToken: Scalars['String']['input'];
};


/** The query root of GitHub's GraphQL interface. */
export type QueryEnterpriseMemberInvitationArgs = {
  enterpriseSlug: Scalars['String']['input'];
  userLogin: Scalars['String']['input'];
};


/** The query root of GitHub's GraphQL interface. */
export type QueryEnterpriseMemberInvitationByTokenArgs = {
  invitationToken: Scalars['String']['input'];
};


/** The query root of GitHub's GraphQL interface. */
export type QueryLicenseArgs = {
  key: Scalars['String']['input'];
};


/** The query root of GitHub's GraphQL interface. */
export type QueryMarketplaceCategoriesArgs = {
  excludeEmpty?: InputMaybe<Scalars['Boolean']['input']>;
  excludeSubcategories?: InputMaybe<Scalars['Boolean']['input']>;
  includeCategories?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** The query root of GitHub's GraphQL interface. */
export type QueryMarketplaceCategoryArgs = {
  slug: Scalars['String']['input'];
  useTopicAliases?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The query root of GitHub's GraphQL interface. */
export type QueryMarketplaceListingArgs = {
  slug: Scalars['String']['input'];
};


/** The query root of GitHub's GraphQL interface. */
export type QueryMarketplaceListingsArgs = {
  adminId?: InputMaybe<Scalars['ID']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  allStates?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categorySlug?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  organizationId?: InputMaybe<Scalars['ID']['input']>;
  primaryCategoryOnly?: InputMaybe<Scalars['Boolean']['input']>;
  slugs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  useTopicAliases?: InputMaybe<Scalars['Boolean']['input']>;
  viewerCanAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  withFreeTrialsOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The query root of GitHub's GraphQL interface. */
export type QueryNodeArgs = {
  id: Scalars['ID']['input'];
};


/** The query root of GitHub's GraphQL interface. */
export type QueryNodesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/** The query root of GitHub's GraphQL interface. */
export type QueryOrganizationArgs = {
  login: Scalars['String']['input'];
};


/** The query root of GitHub's GraphQL interface. */
export type QueryRateLimitArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
};


/** The query root of GitHub's GraphQL interface. */
export type QueryRepositoryArgs = {
  followRenames?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  owner: Scalars['String']['input'];
};


/** The query root of GitHub's GraphQL interface. */
export type QueryRepositoryOwnerArgs = {
  login: Scalars['String']['input'];
};


/** The query root of GitHub's GraphQL interface. */
export type QueryResourceArgs = {
  url: Scalars['URI']['input'];
};


/** The query root of GitHub's GraphQL interface. */
export type QuerySearchArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query: Scalars['String']['input'];
  type: SearchType;
};


/** The query root of GitHub's GraphQL interface. */
export type QuerySecurityAdvisoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  classifications?: InputMaybe<Array<SecurityAdvisoryClassification>>;
  epssPercentage?: InputMaybe<Scalars['Float']['input']>;
  epssPercentile?: InputMaybe<Scalars['Float']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  identifier?: InputMaybe<SecurityAdvisoryIdentifierFilter>;
  isWithdrawn?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SecurityAdvisoryOrder>;
  publishedSince?: InputMaybe<Scalars['DateTime']['input']>;
  severities?: InputMaybe<Array<SecurityAdvisorySeverity>>;
  updatedSince?: InputMaybe<Scalars['DateTime']['input']>;
};


/** The query root of GitHub's GraphQL interface. */
export type QuerySecurityAdvisoryArgs = {
  ghsaId: Scalars['String']['input'];
};


/** The query root of GitHub's GraphQL interface. */
export type QuerySecurityVulnerabilitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  classifications?: InputMaybe<Array<SecurityAdvisoryClassification>>;
  ecosystem?: InputMaybe<SecurityAdvisoryEcosystem>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SecurityVulnerabilityOrder>;
  package?: InputMaybe<Scalars['String']['input']>;
  severities?: InputMaybe<Array<SecurityAdvisorySeverity>>;
};


/** The query root of GitHub's GraphQL interface. */
export type QuerySponsorablesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  dependencyEcosystem?: InputMaybe<SecurityAdvisoryEcosystem>;
  ecosystem?: InputMaybe<DependencyGraphEcosystem>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  onlyDependencies?: InputMaybe<Scalars['Boolean']['input']>;
  orderBy?: InputMaybe<SponsorableOrder>;
  orgLoginForDependencies?: InputMaybe<Scalars['String']['input']>;
};


/** The query root of GitHub's GraphQL interface. */
export type QueryTopicArgs = {
  name: Scalars['String']['input'];
};


/** The query root of GitHub's GraphQL interface. */
export type QueryUserArgs = {
  login: Scalars['String']['input'];
};

/** Represents the client's rate limit. */
export type RateLimit = {
  __typename?: 'RateLimit';
  /** The point cost for the current query counting against the rate limit. */
  cost: Scalars['Int']['output'];
  /** The maximum number of points the client is permitted to consume in a 60 minute window. */
  limit: Scalars['Int']['output'];
  /** The maximum number of nodes this query may return */
  nodeCount: Scalars['Int']['output'];
  /** The number of points remaining in the current rate limit window. */
  remaining: Scalars['Int']['output'];
  /** The time at which the current rate limit window resets in UTC epoch seconds. */
  resetAt: Scalars['DateTime']['output'];
  /** The number of points used in the current rate limit window. */
  used: Scalars['Int']['output'];
};

/** Represents a subject that can be reacted on. */
export type Reactable = {
  /** Identifies the primary key from the database. */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** The Node ID of the Reactable object */
  id: Scalars['ID']['output'];
  /** A list of reactions grouped by content left on the subject. */
  reactionGroups?: Maybe<Array<ReactionGroup>>;
  /** A list of Reactions left on the Issue. */
  reactions: ReactionConnection;
  /** Can user react to this subject */
  viewerCanReact: Scalars['Boolean']['output'];
};


/** Represents a subject that can be reacted on. */
export type ReactableReactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<ReactionContent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ReactionOrder>;
};

/** The connection type for User. */
export type ReactingUserConnection = {
  __typename?: 'ReactingUserConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ReactingUserEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<User>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** Represents a user that's made a reaction. */
export type ReactingUserEdge = {
  __typename?: 'ReactingUserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  node: User;
  /** The moment when the user made the reaction. */
  reactedAt: Scalars['DateTime']['output'];
};

/** An emoji reaction to a particular piece of content. */
export type Reaction = Node & {
  __typename?: 'Reaction';
  /** Identifies the emoji reaction. */
  content: ReactionContent;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Identifies the primary key from the database. */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** The Node ID of the Reaction object */
  id: Scalars['ID']['output'];
  /** The reactable piece of content */
  reactable: Reactable;
  /** Identifies the user who created this reaction. */
  user?: Maybe<User>;
};

/** A list of reactions that have been left on the subject. */
export type ReactionConnection = {
  __typename?: 'ReactionConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ReactionEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Reaction>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
  /** Whether or not the authenticated user has left a reaction on the subject. */
  viewerHasReacted: Scalars['Boolean']['output'];
};

/** Emojis that can be attached to Issues, Pull Requests and Comments. */
export enum ReactionContent {
  /** Represents the `:confused:` emoji. */
  Confused = 'CONFUSED',
  /** Represents the `:eyes:` emoji. */
  Eyes = 'EYES',
  /** Represents the `:heart:` emoji. */
  Heart = 'HEART',
  /** Represents the `:hooray:` emoji. */
  Hooray = 'HOORAY',
  /** Represents the `:laugh:` emoji. */
  Laugh = 'LAUGH',
  /** Represents the `:rocket:` emoji. */
  Rocket = 'ROCKET',
  /** Represents the `:-1:` emoji. */
  ThumbsDown = 'THUMBS_DOWN',
  /** Represents the `:+1:` emoji. */
  ThumbsUp = 'THUMBS_UP'
}

/** An edge in a connection. */
export type ReactionEdge = {
  __typename?: 'ReactionEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Reaction>;
};

/** A group of emoji reactions to a particular piece of content. */
export type ReactionGroup = {
  __typename?: 'ReactionGroup';
  /** Identifies the emoji reaction. */
  content: ReactionContent;
  /** Identifies when the reaction was created. */
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** Reactors to the reaction subject with the emotion represented by this reaction group. */
  reactors: ReactorConnection;
  /** The subject that was reacted to. */
  subject: Reactable;
  /**
   * Users who have reacted to the reaction subject with the emotion represented by this reaction group
   * @deprecated Reactors can now be mannequins, bots, and organizations. Use the `reactors` field instead. Removal on 2021-10-01 UTC.
   */
  users: ReactingUserConnection;
  /** Whether or not the authenticated user has left a reaction on the subject. */
  viewerHasReacted: Scalars['Boolean']['output'];
};


/** A group of emoji reactions to a particular piece of content. */
export type ReactionGroupReactorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A group of emoji reactions to a particular piece of content. */
export type ReactionGroupUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Ways in which lists of reactions can be ordered upon return. */
export type ReactionOrder = {
  /** The direction in which to order reactions by the specified field. */
  direction: OrderDirection;
  /** The field in which to order reactions by. */
  field: ReactionOrderField;
};

/** A list of fields that reactions can be ordered by. */
export enum ReactionOrderField {
  /** Allows ordering a list of reactions by when they were created. */
  CreatedAt = 'CREATED_AT'
}

/** Types that can be assigned to reactions. */
export type Reactor = Bot | Mannequin | Organization | User;

/** The connection type for Reactor. */
export type ReactorConnection = {
  __typename?: 'ReactorConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ReactorEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Reactor>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** Represents an author of a reaction. */
export type ReactorEdge = {
  __typename?: 'ReactorEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The author of the reaction. */
  node: Reactor;
  /** The moment when the user made the reaction. */
  reactedAt: Scalars['DateTime']['output'];
};

/** Represents a 'ready_for_review' event on a given pull request. */
export type ReadyForReviewEvent = Node & UniformResourceLocatable & {
  __typename?: 'ReadyForReviewEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The Node ID of the ReadyForReviewEvent object */
  id: Scalars['ID']['output'];
  /** PullRequest referenced by event. */
  pullRequest: PullRequest;
  /** The HTTP path for this ready for review event. */
  resourcePath: Scalars['URI']['output'];
  /** The HTTP URL for this ready for review event. */
  url: Scalars['URI']['output'];
};

/** Represents a Git reference. */
export type Ref = Node & {
  __typename?: 'Ref';
  /** A list of pull requests with this ref as the head ref. */
  associatedPullRequests: PullRequestConnection;
  /** Branch protection rules for this ref */
  branchProtectionRule?: Maybe<BranchProtectionRule>;
  /** Compares the current ref as a base ref to another head ref, if the comparison can be made. */
  compare?: Maybe<Comparison>;
  /** The Node ID of the Ref object */
  id: Scalars['ID']['output'];
  /** The ref name. */
  name: Scalars['String']['output'];
  /** The ref's prefix, such as `refs/heads/` or `refs/tags/`. */
  prefix: Scalars['String']['output'];
  /** Branch protection rules that are viewable by non-admins */
  refUpdateRule?: Maybe<RefUpdateRule>;
  /** The repository the ref belongs to. */
  repository: Repository;
  /** A list of rules from active Repository and Organization rulesets that apply to this ref. */
  rules?: Maybe<RepositoryRuleConnection>;
  /** The object the ref points to. Returns null when object does not exist. */
  target?: Maybe<GitObject>;
};


/** Represents a Git reference. */
export type RefAssociatedPullRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  baseRefName?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  headRefName?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<IssueOrder>;
  states?: InputMaybe<Array<PullRequestState>>;
};


/** Represents a Git reference. */
export type RefCompareArgs = {
  headRef: Scalars['String']['input'];
};


/** Represents a Git reference. */
export type RefRulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<RepositoryRuleOrder>;
};

/** The connection type for Ref. */
export type RefConnection = {
  __typename?: 'RefConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RefEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Ref>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type RefEdge = {
  __typename?: 'RefEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Ref>;
};

/** Parameters to be used for the ref_name condition */
export type RefNameConditionTarget = {
  __typename?: 'RefNameConditionTarget';
  /** Array of ref names or patterns to exclude. The condition will not pass if any of these patterns match. */
  exclude: Array<Scalars['String']['output']>;
  /**
   * Array of ref names or patterns to include. One of these patterns must match
   * for the condition to pass. Also accepts `~DEFAULT_BRANCH` to include the
   * default branch or `~ALL` to include all branches.
   */
  include: Array<Scalars['String']['output']>;
};

/** Parameters to be used for the ref_name condition */
export type RefNameConditionTargetInput = {
  /** Array of ref names or patterns to exclude. The condition will not pass if any of these patterns match. */
  exclude: Array<Scalars['String']['input']>;
  /**
   * Array of ref names or patterns to include. One of these patterns must match
   * for the condition to pass. Also accepts `~DEFAULT_BRANCH` to include the
   * default branch or `~ALL` to include all branches.
   */
  include: Array<Scalars['String']['input']>;
};

/** Ways in which lists of git refs can be ordered upon return. */
export type RefOrder = {
  /** The direction in which to order refs by the specified field. */
  direction: OrderDirection;
  /** The field in which to order refs by. */
  field: RefOrderField;
};

/** Properties by which ref connections can be ordered. */
export enum RefOrderField {
  /** Order refs by their alphanumeric name */
  Alphabetical = 'ALPHABETICAL',
  /** Order refs by underlying commit date if the ref prefix is refs/tags/ */
  TagCommitDate = 'TAG_COMMIT_DATE'
}

/** A ref update */
export type RefUpdate = {
  /** The value this ref should be updated to. */
  afterOid: Scalars['GitObjectID']['input'];
  /** The value this ref needs to point to before the update. */
  beforeOid?: InputMaybe<Scalars['GitObjectID']['input']>;
  /** Force a non fast-forward update. */
  force?: InputMaybe<Scalars['Boolean']['input']>;
  /** The fully qualified name of the ref to be update. For example `refs/heads/branch-name` */
  name: Scalars['GitRefname']['input'];
};

/** Branch protection rules that are enforced on the viewer. */
export type RefUpdateRule = {
  __typename?: 'RefUpdateRule';
  /** Can this branch be deleted. */
  allowsDeletions: Scalars['Boolean']['output'];
  /** Are force pushes allowed on this branch. */
  allowsForcePushes: Scalars['Boolean']['output'];
  /** Can matching branches be created. */
  blocksCreations: Scalars['Boolean']['output'];
  /** Identifies the protection rule pattern. */
  pattern: Scalars['String']['output'];
  /** Number of approving reviews required to update matching branches. */
  requiredApprovingReviewCount?: Maybe<Scalars['Int']['output']>;
  /** List of required status check contexts that must pass for commits to be accepted to matching branches. */
  requiredStatusCheckContexts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Are reviews from code owners required to update matching branches. */
  requiresCodeOwnerReviews: Scalars['Boolean']['output'];
  /** Are conversations required to be resolved before merging. */
  requiresConversationResolution: Scalars['Boolean']['output'];
  /** Are merge commits prohibited from being pushed to this branch. */
  requiresLinearHistory: Scalars['Boolean']['output'];
  /** Are commits required to be signed. */
  requiresSignatures: Scalars['Boolean']['output'];
  /** Is the viewer allowed to dismiss reviews. */
  viewerAllowedToDismissReviews: Scalars['Boolean']['output'];
  /** Can the viewer push to the branch */
  viewerCanPush: Scalars['Boolean']['output'];
};

/** Represents a 'referenced' event on a given `ReferencedSubject`. */
export type ReferencedEvent = Node & {
  __typename?: 'ReferencedEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the commit associated with the 'referenced' event. */
  commit?: Maybe<Commit>;
  /** Identifies the repository associated with the 'referenced' event. */
  commitRepository: Repository;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The Node ID of the ReferencedEvent object */
  id: Scalars['ID']['output'];
  /** Reference originated in a different repository. */
  isCrossRepository: Scalars['Boolean']['output'];
  /** Checks if the commit message itself references the subject. Can be false in the case of a commit comment reference. */
  isDirectReference: Scalars['Boolean']['output'];
  /** Object referenced by event. */
  subject: ReferencedSubject;
};

/** Any referencable object */
export type ReferencedSubject = Issue | PullRequest;

/** Autogenerated input type of RegenerateEnterpriseIdentityProviderRecoveryCodes */
export type RegenerateEnterpriseIdentityProviderRecoveryCodesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the enterprise on which to set an identity provider. */
  enterpriseId: Scalars['ID']['input'];
};

/** Autogenerated return type of RegenerateEnterpriseIdentityProviderRecoveryCodes. */
export type RegenerateEnterpriseIdentityProviderRecoveryCodesPayload = {
  __typename?: 'RegenerateEnterpriseIdentityProviderRecoveryCodesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The identity provider for the enterprise. */
  identityProvider?: Maybe<EnterpriseIdentityProvider>;
};

/** Autogenerated input type of RegenerateVerifiableDomainToken */
export type RegenerateVerifiableDomainTokenInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the verifiable domain to regenerate the verification token of. */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of RegenerateVerifiableDomainToken. */
export type RegenerateVerifiableDomainTokenPayload = {
  __typename?: 'RegenerateVerifiableDomainTokenPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The verification token that was generated. */
  verificationToken?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of RejectDeployments */
export type RejectDeploymentsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Optional comment for rejecting deployments */
  comment?: InputMaybe<Scalars['String']['input']>;
  /** The ids of environments to reject deployments */
  environmentIds: Array<Scalars['ID']['input']>;
  /** The node ID of the workflow run containing the pending deployments. */
  workflowRunId: Scalars['ID']['input'];
};

/** Autogenerated return type of RejectDeployments. */
export type RejectDeploymentsPayload = {
  __typename?: 'RejectDeploymentsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The affected deployments. */
  deployments?: Maybe<Array<Deployment>>;
};

/** Autogenerated input type of RejectPendingIssueSuggestions */
export type RejectPendingIssueSuggestionsInput = {
  /** The ID of the actor whose suggestions to reject. */
  actorId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the issue the suggestions apply to. */
  issueId: Scalars['ID']['input'];
  /** The pending suggestions to reject. All are rejected atomically; any failure rolls back the entire batch. */
  suggestions: Array<PendingIssueSuggestionRef>;
};

/** Autogenerated return type of RejectPendingIssueSuggestions. */
export type RejectPendingIssueSuggestionsPayload = {
  __typename?: 'RejectPendingIssueSuggestionsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The issue the suggestions were rejected from. */
  issue?: Maybe<Issue>;
};

/** A release contains the content for a release. */
export type Release = Node & Reactable & UniformResourceLocatable & {
  __typename?: 'Release';
  /** The author of the release */
  author?: Maybe<User>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Identifies the primary key from the database. */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** The description of the release. */
  description?: Maybe<Scalars['String']['output']>;
  /** The description of this release rendered to HTML. */
  descriptionHTML?: Maybe<Scalars['HTML']['output']>;
  /** The Node ID of the Release object */
  id: Scalars['ID']['output'];
  /** Whether or not the release is immutable */
  immutable: Scalars['Boolean']['output'];
  /** Whether or not the release is a draft */
  isDraft: Scalars['Boolean']['output'];
  /** Whether or not the release is the latest releast */
  isLatest: Scalars['Boolean']['output'];
  /** Whether or not the release is a prerelease */
  isPrerelease: Scalars['Boolean']['output'];
  /** A list of users mentioned in the release description */
  mentions?: Maybe<UserConnection>;
  /** The title of the release. */
  name?: Maybe<Scalars['String']['output']>;
  /** Identifies the date and time when the release was created. */
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** A list of reactions grouped by content left on the subject. */
  reactionGroups?: Maybe<Array<ReactionGroup>>;
  /** A list of Reactions left on the Issue. */
  reactions: ReactionConnection;
  /** List of releases assets which are dependent on this release. */
  releaseAssets: ReleaseAssetConnection;
  /** The repository that the release belongs to. */
  repository: Repository;
  /** The HTTP path for this issue */
  resourcePath: Scalars['URI']['output'];
  /** A description of the release, rendered to HTML without any links in it. */
  shortDescriptionHTML?: Maybe<Scalars['HTML']['output']>;
  /** The Git tag the release points to */
  tag?: Maybe<Ref>;
  /** The tag commit for this release. */
  tagCommit?: Maybe<Commit>;
  /** The name of the release's Git tag */
  tagName: Scalars['String']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The HTTP URL for this issue */
  url: Scalars['URI']['output'];
  /** Can user react to this subject */
  viewerCanReact: Scalars['Boolean']['output'];
};


/** A release contains the content for a release. */
export type ReleaseMentionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A release contains the content for a release. */
export type ReleaseReactionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  content?: InputMaybe<ReactionContent>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ReactionOrder>;
};


/** A release contains the content for a release. */
export type ReleaseReleaseAssetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};


/** A release contains the content for a release. */
export type ReleaseShortDescriptionHtmlArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** A release asset contains the content for a release asset. */
export type ReleaseAsset = Node & {
  __typename?: 'ReleaseAsset';
  /** The asset's content-type */
  contentType: Scalars['String']['output'];
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The SHA256 digest of the asset */
  digest?: Maybe<Scalars['String']['output']>;
  /** The number of times this asset was downloaded */
  downloadCount: Scalars['Int']['output'];
  /** Identifies the URL where you can download the release asset via the browser. */
  downloadUrl: Scalars['URI']['output'];
  /** The Node ID of the ReleaseAsset object */
  id: Scalars['ID']['output'];
  /** Identifies the title of the release asset. */
  name: Scalars['String']['output'];
  /** Release that the asset is associated with */
  release?: Maybe<Release>;
  /** The size (in bytes) of the asset */
  size: Scalars['Int']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The user that performed the upload */
  uploadedBy: User;
  /** Identifies the URL of the release asset. */
  url: Scalars['URI']['output'];
};

/** The connection type for ReleaseAsset. */
export type ReleaseAssetConnection = {
  __typename?: 'ReleaseAssetConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ReleaseAssetEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ReleaseAsset>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ReleaseAssetEdge = {
  __typename?: 'ReleaseAssetEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ReleaseAsset>;
};

/** The connection type for Release. */
export type ReleaseConnection = {
  __typename?: 'ReleaseConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ReleaseEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Release>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ReleaseEdge = {
  __typename?: 'ReleaseEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Release>;
};

/** Ways in which lists of releases can be ordered upon return. */
export type ReleaseOrder = {
  /** The direction in which to order releases by the specified field. */
  direction: OrderDirection;
  /** The field in which to order releases by. */
  field: ReleaseOrderField;
};

/** Properties by which release connections can be ordered. */
export enum ReleaseOrderField {
  /** Order releases by creation time */
  CreatedAt = 'CREATED_AT',
  /** Order releases alphabetically by name */
  Name = 'NAME'
}

/** Autogenerated input type of RemoveAssigneesFromAssignable */
export type RemoveAssigneesFromAssignableInput = {
  /** The id of the assignable object to remove assignees from. */
  assignableId: Scalars['ID']['input'];
  /** The ids of actors to remove as assignees. */
  assigneeIds: Array<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of RemoveAssigneesFromAssignable. */
export type RemoveAssigneesFromAssignablePayload = {
  __typename?: 'RemoveAssigneesFromAssignablePayload';
  /** The item that was unassigned. */
  assignable?: Maybe<Assignable>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of RemoveBlockedBy */
export type RemoveBlockedByInput = {
  /** The ID of the blocking issue. */
  blockingIssueId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the blocked issue. */
  issueId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveBlockedBy. */
export type RemoveBlockedByPayload = {
  __typename?: 'RemoveBlockedByPayload';
  /** The previously blocking issue. */
  blockingIssue?: Maybe<Issue>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The previously blocked issue. */
  issue?: Maybe<Issue>;
};

/** Autogenerated input type of RemoveCloseIssueReferences */
export type RemoveCloseIssueReferencesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the issue to remove closing references from. */
  issueId: Scalars['ID']['input'];
  /** IDs of manually linked pull requests to remove. Auto-detected closing references are left unchanged. Limit: 10. */
  pullRequestIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of RemoveCloseIssueReferences. */
export type RemoveCloseIssueReferencesPayload = {
  __typename?: 'RemoveCloseIssueReferencesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The issue the closing references were removed from. */
  issue?: Maybe<Issue>;
};

/** Autogenerated input type of RemoveEnterpriseAdmin */
export type RemoveEnterpriseAdminInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Enterprise ID from which to remove the administrator. */
  enterpriseId: Scalars['ID']['input'];
  /** The login of the user to remove as an administrator. */
  login: Scalars['String']['input'];
};

/** Autogenerated return type of RemoveEnterpriseAdmin. */
export type RemoveEnterpriseAdminPayload = {
  __typename?: 'RemoveEnterpriseAdminPayload';
  /** The user who was removed as an administrator. */
  admin?: Maybe<User>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated enterprise. */
  enterprise?: Maybe<Enterprise>;
  /** A message confirming the result of removing an administrator. */
  message?: Maybe<Scalars['String']['output']>;
  /** The viewer performing the mutation. */
  viewer?: Maybe<User>;
};

/** Autogenerated input type of RemoveEnterpriseIdentityProvider */
export type RemoveEnterpriseIdentityProviderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the enterprise from which to remove the identity provider. */
  enterpriseId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveEnterpriseIdentityProvider. */
export type RemoveEnterpriseIdentityProviderPayload = {
  __typename?: 'RemoveEnterpriseIdentityProviderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The identity provider that was removed from the enterprise. */
  identityProvider?: Maybe<EnterpriseIdentityProvider>;
};

/** Autogenerated input type of RemoveEnterpriseMember */
export type RemoveEnterpriseMemberInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the enterprise from which the user should be removed. */
  enterpriseId: Scalars['ID']['input'];
  /** The ID of the user to remove from the enterprise. */
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveEnterpriseMember. */
export type RemoveEnterpriseMemberPayload = {
  __typename?: 'RemoveEnterpriseMemberPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated enterprise. */
  enterprise?: Maybe<Enterprise>;
  /** The user that was removed from the enterprise. */
  user?: Maybe<User>;
  /** The viewer performing the mutation. */
  viewer?: Maybe<User>;
};

/** Autogenerated input type of RemoveEnterpriseOrganization */
export type RemoveEnterpriseOrganizationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the enterprise from which the organization should be removed. */
  enterpriseId: Scalars['ID']['input'];
  /** The ID of the organization to remove from the enterprise. */
  organizationId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveEnterpriseOrganization. */
export type RemoveEnterpriseOrganizationPayload = {
  __typename?: 'RemoveEnterpriseOrganizationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated enterprise. */
  enterprise?: Maybe<Enterprise>;
  /** The organization that was removed from the enterprise. */
  organization?: Maybe<Organization>;
  /** The viewer performing the mutation. */
  viewer?: Maybe<User>;
};

/** Autogenerated input type of RemoveEnterpriseSupportEntitlement */
export type RemoveEnterpriseSupportEntitlementInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the Enterprise which the admin belongs to. */
  enterpriseId: Scalars['ID']['input'];
  /** The login of a member who will lose the support entitlement. */
  login: Scalars['String']['input'];
};

/** Autogenerated return type of RemoveEnterpriseSupportEntitlement. */
export type RemoveEnterpriseSupportEntitlementPayload = {
  __typename?: 'RemoveEnterpriseSupportEntitlementPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** A message confirming the result of removing the support entitlement. */
  message?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of RemoveLabelsFromLabelable */
export type RemoveLabelsFromLabelableInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ids of labels to remove. */
  labelIds: Array<Scalars['ID']['input']>;
  /** The id of the Labelable to remove labels from. */
  labelableId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveLabelsFromLabelable. */
export type RemoveLabelsFromLabelablePayload = {
  __typename?: 'RemoveLabelsFromLabelablePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The Labelable the labels were removed from. */
  labelable?: Maybe<Labelable>;
};

/** Autogenerated input type of RemoveOutsideCollaborator */
export type RemoveOutsideCollaboratorInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the organization to remove the outside collaborator from. */
  organizationId: Scalars['ID']['input'];
  /** The ID of the outside collaborator to remove. */
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveOutsideCollaborator. */
export type RemoveOutsideCollaboratorPayload = {
  __typename?: 'RemoveOutsideCollaboratorPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The user that was removed as an outside collaborator. */
  removedUser?: Maybe<User>;
};

/** Autogenerated input type of RemovePullRequestCreationCapBypassUsers */
export type RemovePullRequestCreationCapBypassUsersInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Node ID of the repository. */
  repositoryId: Scalars['ID']['input'];
  /** The Node IDs of the users to remove from the bypass list. */
  userIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of RemovePullRequestCreationCapBypassUsers. */
export type RemovePullRequestCreationCapBypassUsersPayload = {
  __typename?: 'RemovePullRequestCreationCapBypassUsersPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The repository with the updated bypass list. */
  repository?: Maybe<Repository>;
};

/** Autogenerated input type of RemoveReaction */
export type RemoveReactionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The name of the emoji reaction to remove. */
  content: ReactionContent;
  /** The Node ID of the subject to modify. */
  subjectId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveReaction. */
export type RemoveReactionPayload = {
  __typename?: 'RemoveReactionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The reaction object. */
  reaction?: Maybe<Reaction>;
  /** The reaction groups for the subject. */
  reactionGroups?: Maybe<Array<ReactionGroup>>;
  /** The reactable subject. */
  subject?: Maybe<Reactable>;
};

/** Autogenerated input type of RemoveRelatesTo */
export type RemoveRelatesToInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the issue. */
  issueId: Scalars['ID']['input'];
  /** The ID of the previously related issue. */
  relatedIssueId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveRelatesTo. */
export type RemoveRelatesToPayload = {
  __typename?: 'RemoveRelatesToPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The previously targeted issue. */
  issue?: Maybe<Issue>;
  /** The previously related issue. */
  relatedIssue?: Maybe<Issue>;
};

/** Autogenerated input type of RemoveStar */
export type RemoveStarInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Starrable ID to unstar. */
  starrableId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveStar. */
export type RemoveStarPayload = {
  __typename?: 'RemoveStarPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The starrable. */
  starrable?: Maybe<Starrable>;
};

/** Autogenerated input type of RemoveSubIssue */
export type RemoveSubIssueInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the issue. */
  issueId: Scalars['ID']['input'];
  /** The id of the sub-issue. */
  subIssueId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveSubIssue. */
export type RemoveSubIssuePayload = {
  __typename?: 'RemoveSubIssuePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The parent of the sub-issue. */
  issue?: Maybe<Issue>;
  /** The sub-issue of the parent. */
  subIssue?: Maybe<Issue>;
};

/** Autogenerated input type of RemoveUpvote */
export type RemoveUpvoteInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Node ID of the discussion or comment to remove upvote. */
  subjectId: Scalars['ID']['input'];
};

/** Autogenerated return type of RemoveUpvote. */
export type RemoveUpvotePayload = {
  __typename?: 'RemoveUpvotePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The votable subject. */
  subject?: Maybe<Votable>;
};

/** Represents a 'removed_from_merge_queue' event on a given pull request. */
export type RemovedFromMergeQueueEvent = Node & {
  __typename?: 'RemovedFromMergeQueueEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the before commit SHA for the 'removed_from_merge_queue' event. */
  beforeCommit?: Maybe<Commit>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The user who removed this Pull Request from the merge queue */
  enqueuer?: Maybe<User>;
  /** The Node ID of the RemovedFromMergeQueueEvent object */
  id: Scalars['ID']['output'];
  /** The merge queue where this pull request was removed from. */
  mergeQueue?: Maybe<MergeQueue>;
  /** PullRequest referenced by event. */
  pullRequest?: Maybe<PullRequest>;
  /** The reason this pull request was removed from the queue. */
  reason?: Maybe<Scalars['String']['output']>;
};

/** Represents a 'removed_from_project' event on a given issue or pull request. */
export type RemovedFromProjectEvent = Node & {
  __typename?: 'RemovedFromProjectEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /**
   * Identifies the primary key from the database.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** The Node ID of the RemovedFromProjectEvent object */
  id: Scalars['ID']['output'];
  /**
   * Project referenced by event.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  project?: Maybe<Project>;
  /**
   * Column name referenced by this project event.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  projectColumnName: Scalars['String']['output'];
};

/** Represents a 'removed_from_project_v2' event on a given issue or pull request. */
export type RemovedFromProjectV2Event = Node & ProjectV2Event & {
  __typename?: 'RemovedFromProjectV2Event';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The Node ID of the RemovedFromProjectV2Event object */
  id: Scalars['ID']['output'];
  /** Project referenced by event. */
  project?: Maybe<ProjectV2>;
  /** Did this event result from workflow automation? */
  wasAutomated: Scalars['Boolean']['output'];
};

/** Represents a 'removed_from_stack' event on a given pull request. */
export type RemovedFromStackEvent = Node & {
  __typename?: 'RemovedFromStackEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The Node ID of the RemovedFromStackEvent object */
  id: Scalars['ID']['output'];
  /** Pull request removed from the stack. */
  pullRequest?: Maybe<PullRequest>;
  /** Database ID of the stack. */
  stackId?: Maybe<Scalars['BigInt']['output']>;
  /** Number of the stack in its repository. */
  stackNumber?: Maybe<Scalars['Int']['output']>;
};

/** Represents a 'renamed' event on a given issue or pull request */
export type RenamedTitleEvent = Node & {
  __typename?: 'RenamedTitleEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Identifies the current title of the issue or pull request. */
  currentTitle: Scalars['String']['output'];
  /** The Node ID of the RenamedTitleEvent object */
  id: Scalars['ID']['output'];
  /** Identifies the previous title of the issue or pull request. */
  previousTitle: Scalars['String']['output'];
  /** Subject that was renamed. */
  subject: RenamedTitleSubject;
};

/** An object which has a renamable title */
export type RenamedTitleSubject = Issue | PullRequest;

/** Autogenerated input type of ReopenDiscussion */
export type ReopenDiscussionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the discussion to be reopened. */
  discussionId: Scalars['ID']['input'];
};

/** Autogenerated return type of ReopenDiscussion. */
export type ReopenDiscussionPayload = {
  __typename?: 'ReopenDiscussionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The discussion that was reopened. */
  discussion?: Maybe<Discussion>;
};

/** Autogenerated input type of ReopenIssue */
export type ReopenIssueInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the issue to be opened. */
  issueId: Scalars['ID']['input'];
};

/** Autogenerated return type of ReopenIssue. */
export type ReopenIssuePayload = {
  __typename?: 'ReopenIssuePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The issue that was opened. */
  issue?: Maybe<Issue>;
};

/** Autogenerated input type of ReopenPullRequest */
export type ReopenPullRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the pull request to be reopened. */
  pullRequestId: Scalars['ID']['input'];
};

/** Autogenerated return type of ReopenPullRequest. */
export type ReopenPullRequestPayload = {
  __typename?: 'ReopenPullRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The pull request that was reopened. */
  pullRequest?: Maybe<PullRequest>;
};

/** Represents a 'reopened' event on any `Closable`. */
export type ReopenedEvent = Node & {
  __typename?: 'ReopenedEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Object that was reopened. */
  closable: Closable;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The Node ID of the ReopenedEvent object */
  id: Scalars['ID']['output'];
  /** The reason the issue state was changed to open. */
  stateReason?: Maybe<IssueStateReason>;
};

/** Autogenerated input type of ReorderEnvironment */
export type ReorderEnvironmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the environment to modify */
  environmentId: Scalars['ID']['input'];
  /** The desired position of the environment */
  position: Scalars['Int']['input'];
};

/** Autogenerated return type of ReorderEnvironment. */
export type ReorderEnvironmentPayload = {
  __typename?: 'ReorderEnvironmentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The environment that was reordered */
  environment?: Maybe<Environment>;
};

/** Autogenerated input type of ReplaceActorsForAssignable */
export type ReplaceActorsForAssignableInput = {
  /**
   * The ids of the actors to replace the existing assignees. May be used as an
   * alternative to or in conjunction with actorLogins.
   */
  actorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * The usernames of the actors to replace the existing assignees. May be used as
   * an alternative to or in conjunction with actorIds. For bots, use the login
   * format with [bot] suffix (e.g., 'my-app[bot]').
   */
  actorLogins?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Configuration for assigning an AI agent to this issue. */
  agentAssignment?: InputMaybe<AgentAssignmentInput>;
  /** The id of the assignable object to replace the assignees for. */
  assignableId: Scalars['ID']['input'];
  /**
   * An array of actors to set as assignees, each with optional rationale or
   * suggest flag. Mutually exclusive with `actorIds` and `actorLogins`.
   */
  assignees?: InputMaybe<Array<AssigneeUpdateInput>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of ReplaceActorsForAssignable. */
export type ReplaceActorsForAssignablePayload = {
  __typename?: 'ReplaceActorsForAssignablePayload';
  /** The item that was assigned. */
  assignable?: Maybe<Assignable>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Audit log entry for a repo.access event. */
export type RepoAccessAuditEntry = AuditEntry & Node & OrganizationAuditEntryData & RepositoryAuditEntryData & {
  __typename?: 'RepoAccessAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /** The Node ID of the RepoAccessAuditEntry object */
  id: Scalars['ID']['output'];
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /** The repository associated with the action */
  repository?: Maybe<Repository>;
  /** The name of the repository */
  repositoryName?: Maybe<Scalars['String']['output']>;
  /** The HTTP path for the repository */
  repositoryResourcePath?: Maybe<Scalars['URI']['output']>;
  /** The HTTP URL for the repository */
  repositoryUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The visibility of the repository
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  visibility?: Maybe<RepoAccessAuditEntryVisibility>;
};

/** The privacy of a repository */
export enum RepoAccessAuditEntryVisibility {
  /** The repository is visible only to users in the same enterprise. */
  Internal = 'INTERNAL',
  /** The repository is visible only to those with explicit access. */
  Private = 'PRIVATE',
  /** The repository is visible to everyone. */
  Public = 'PUBLIC'
}

/** Audit log entry for a repo.add_member event. */
export type RepoAddMemberAuditEntry = AuditEntry & Node & OrganizationAuditEntryData & RepositoryAuditEntryData & {
  __typename?: 'RepoAddMemberAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /** The Node ID of the RepoAddMemberAuditEntry object */
  id: Scalars['ID']['output'];
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /** The repository associated with the action */
  repository?: Maybe<Repository>;
  /** The name of the repository */
  repositoryName?: Maybe<Scalars['String']['output']>;
  /** The HTTP path for the repository */
  repositoryResourcePath?: Maybe<Scalars['URI']['output']>;
  /** The HTTP URL for the repository */
  repositoryUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The visibility of the repository
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  visibility?: Maybe<RepoAddMemberAuditEntryVisibility>;
};

/** The privacy of a repository */
export enum RepoAddMemberAuditEntryVisibility {
  /** The repository is visible only to users in the same enterprise. */
  Internal = 'INTERNAL',
  /** The repository is visible only to those with explicit access. */
  Private = 'PRIVATE',
  /** The repository is visible to everyone. */
  Public = 'PUBLIC'
}

/** Audit log entry for a repo.add_topic event. */
export type RepoAddTopicAuditEntry = AuditEntry & Node & OrganizationAuditEntryData & RepositoryAuditEntryData & TopicAuditEntryData & {
  __typename?: 'RepoAddTopicAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /** The Node ID of the RepoAddTopicAuditEntry object */
  id: Scalars['ID']['output'];
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /** The repository associated with the action */
  repository?: Maybe<Repository>;
  /** The name of the repository */
  repositoryName?: Maybe<Scalars['String']['output']>;
  /** The HTTP path for the repository */
  repositoryResourcePath?: Maybe<Scalars['URI']['output']>;
  /** The HTTP URL for the repository */
  repositoryUrl?: Maybe<Scalars['URI']['output']>;
  /** The name of the topic added to the repository */
  topic?: Maybe<Topic>;
  /** The name of the topic added to the repository */
  topicName?: Maybe<Scalars['String']['output']>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
};

/** Audit log entry for a repo.archived event. */
export type RepoArchivedAuditEntry = AuditEntry & Node & OrganizationAuditEntryData & RepositoryAuditEntryData & {
  __typename?: 'RepoArchivedAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /** The Node ID of the RepoArchivedAuditEntry object */
  id: Scalars['ID']['output'];
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /** The repository associated with the action */
  repository?: Maybe<Repository>;
  /** The name of the repository */
  repositoryName?: Maybe<Scalars['String']['output']>;
  /** The HTTP path for the repository */
  repositoryResourcePath?: Maybe<Scalars['URI']['output']>;
  /** The HTTP URL for the repository */
  repositoryUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The visibility of the repository
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  visibility?: Maybe<RepoArchivedAuditEntryVisibility>;
};

/** The privacy of a repository */
export enum RepoArchivedAuditEntryVisibility {
  /** The repository is visible only to users in the same enterprise. */
  Internal = 'INTERNAL',
  /** The repository is visible only to those with explicit access. */
  Private = 'PRIVATE',
  /** The repository is visible to everyone. */
  Public = 'PUBLIC'
}

/** Audit log entry for a repo.change_merge_setting event. */
export type RepoChangeMergeSettingAuditEntry = AuditEntry & Node & OrganizationAuditEntryData & RepositoryAuditEntryData & {
  __typename?: 'RepoChangeMergeSettingAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /** The Node ID of the RepoChangeMergeSettingAuditEntry object */
  id: Scalars['ID']['output'];
  /**
   * Whether the change was to enable (true) or disable (false) the merge type
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  isEnabled?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The merge method affected by the change
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  mergeType?: Maybe<RepoChangeMergeSettingAuditEntryMergeType>;
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /** The repository associated with the action */
  repository?: Maybe<Repository>;
  /** The name of the repository */
  repositoryName?: Maybe<Scalars['String']['output']>;
  /** The HTTP path for the repository */
  repositoryResourcePath?: Maybe<Scalars['URI']['output']>;
  /** The HTTP URL for the repository */
  repositoryUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
};

/** The merge options available for pull requests to this repository. */
export enum RepoChangeMergeSettingAuditEntryMergeType {
  /** The pull request is added to the base branch in a merge commit. */
  Merge = 'MERGE',
  /** Commits from the pull request are added onto the base branch individually without a merge commit. */
  Rebase = 'REBASE',
  /** The pull request's commits are squashed into a single commit before they are merged to the base branch. */
  Squash = 'SQUASH'
}

/** Audit log entry for a repo.config.disable_anonymous_git_access event. */
export type RepoConfigDisableAnonymousGitAccessAuditEntry = AuditEntry & Node & OrganizationAuditEntryData & RepositoryAuditEntryData & {
  __typename?: 'RepoConfigDisableAnonymousGitAccessAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /** The Node ID of the RepoConfigDisableAnonymousGitAccessAuditEntry object */
  id: Scalars['ID']['output'];
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /** The repository associated with the action */
  repository?: Maybe<Repository>;
  /** The name of the repository */
  repositoryName?: Maybe<Scalars['String']['output']>;
  /** The HTTP path for the repository */
  repositoryResourcePath?: Maybe<Scalars['URI']['output']>;
  /** The HTTP URL for the repository */
  repositoryUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
};

/** Audit log entry for a repo.config.disable_collaborators_only event. */
export type RepoConfigDisableCollaboratorsOnlyAuditEntry = AuditEntry & Node & OrganizationAuditEntryData & RepositoryAuditEntryData & {
  __typename?: 'RepoConfigDisableCollaboratorsOnlyAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /** The Node ID of the RepoConfigDisableCollaboratorsOnlyAuditEntry object */
  id: Scalars['ID']['output'];
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /** The repository associated with the action */
  repository?: Maybe<Repository>;
  /** The name of the repository */
  repositoryName?: Maybe<Scalars['String']['output']>;
  /** The HTTP path for the repository */
  repositoryResourcePath?: Maybe<Scalars['URI']['output']>;
  /** The HTTP URL for the repository */
  repositoryUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
};

/** Audit log entry for a repo.config.disable_contributors_only event. */
export type RepoConfigDisableContributorsOnlyAuditEntry = AuditEntry & Node & OrganizationAuditEntryData & RepositoryAuditEntryData & {
  __typename?: 'RepoConfigDisableContributorsOnlyAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /** The Node ID of the RepoConfigDisableContributorsOnlyAuditEntry object */
  id: Scalars['ID']['output'];
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /** The repository associated with the action */
  repository?: Maybe<Repository>;
  /** The name of the repository */
  repositoryName?: Maybe<Scalars['String']['output']>;
  /** The HTTP path for the repository */
  repositoryResourcePath?: Maybe<Scalars['URI']['output']>;
  /** The HTTP URL for the repository */
  repositoryUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
};

/** Audit log entry for a repo.config.disable_sockpuppet_disallowed event. */
export type RepoConfigDisableSockpuppetDisallowedAuditEntry = AuditEntry & Node & OrganizationAuditEntryData & RepositoryAuditEntryData & {
  __typename?: 'RepoConfigDisableSockpuppetDisallowedAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /** The Node ID of the RepoConfigDisableSockpuppetDisallowedAuditEntry object */
  id: Scalars['ID']['output'];
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /** The repository associated with the action */
  repository?: Maybe<Repository>;
  /** The name of the repository */
  repositoryName?: Maybe<Scalars['String']['output']>;
  /** The HTTP path for the repository */
  repositoryResourcePath?: Maybe<Scalars['URI']['output']>;
  /** The HTTP URL for the repository */
  repositoryUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
};

/** Audit log entry for a repo.config.enable_anonymous_git_access event. */
export type RepoConfigEnableAnonymousGitAccessAuditEntry = AuditEntry & Node & OrganizationAuditEntryData & RepositoryAuditEntryData & {
  __typename?: 'RepoConfigEnableAnonymousGitAccessAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /** The Node ID of the RepoConfigEnableAnonymousGitAccessAuditEntry object */
  id: Scalars['ID']['output'];
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /** The repository associated with the action */
  repository?: Maybe<Repository>;
  /** The name of the repository */
  repositoryName?: Maybe<Scalars['String']['output']>;
  /** The HTTP path for the repository */
  repositoryResourcePath?: Maybe<Scalars['URI']['output']>;
  /** The HTTP URL for the repository */
  repositoryUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
};

/** Audit log entry for a repo.config.enable_collaborators_only event. */
export type RepoConfigEnableCollaboratorsOnlyAuditEntry = AuditEntry & Node & OrganizationAuditEntryData & RepositoryAuditEntryData & {
  __typename?: 'RepoConfigEnableCollaboratorsOnlyAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /** The Node ID of the RepoConfigEnableCollaboratorsOnlyAuditEntry object */
  id: Scalars['ID']['output'];
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /** The repository associated with the action */
  repository?: Maybe<Repository>;
  /** The name of the repository */
  repositoryName?: Maybe<Scalars['String']['output']>;
  /** The HTTP path for the repository */
  repositoryResourcePath?: Maybe<Scalars['URI']['output']>;
  /** The HTTP URL for the repository */
  repositoryUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
};

/** Audit log entry for a repo.config.enable_contributors_only event. */
export type RepoConfigEnableContributorsOnlyAuditEntry = AuditEntry & Node & OrganizationAuditEntryData & RepositoryAuditEntryData & {
  __typename?: 'RepoConfigEnableContributorsOnlyAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /** The Node ID of the RepoConfigEnableContributorsOnlyAuditEntry object */
  id: Scalars['ID']['output'];
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /** The repository associated with the action */
  repository?: Maybe<Repository>;
  /** The name of the repository */
  repositoryName?: Maybe<Scalars['String']['output']>;
  /** The HTTP path for the repository */
  repositoryResourcePath?: Maybe<Scalars['URI']['output']>;
  /** The HTTP URL for the repository */
  repositoryUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
};

/** Audit log entry for a repo.config.enable_sockpuppet_disallowed event. */
export type RepoConfigEnableSockpuppetDisallowedAuditEntry = AuditEntry & Node & OrganizationAuditEntryData & RepositoryAuditEntryData & {
  __typename?: 'RepoConfigEnableSockpuppetDisallowedAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /** The Node ID of the RepoConfigEnableSockpuppetDisallowedAuditEntry object */
  id: Scalars['ID']['output'];
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /** The repository associated with the action */
  repository?: Maybe<Repository>;
  /** The name of the repository */
  repositoryName?: Maybe<Scalars['String']['output']>;
  /** The HTTP path for the repository */
  repositoryResourcePath?: Maybe<Scalars['URI']['output']>;
  /** The HTTP URL for the repository */
  repositoryUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
};

/** Audit log entry for a repo.config.lock_anonymous_git_access event. */
export type RepoConfigLockAnonymousGitAccessAuditEntry = AuditEntry & Node & OrganizationAuditEntryData & RepositoryAuditEntryData & {
  __typename?: 'RepoConfigLockAnonymousGitAccessAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /** The Node ID of the RepoConfigLockAnonymousGitAccessAuditEntry object */
  id: Scalars['ID']['output'];
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /** The repository associated with the action */
  repository?: Maybe<Repository>;
  /** The name of the repository */
  repositoryName?: Maybe<Scalars['String']['output']>;
  /** The HTTP path for the repository */
  repositoryResourcePath?: Maybe<Scalars['URI']['output']>;
  /** The HTTP URL for the repository */
  repositoryUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
};

/** Audit log entry for a repo.config.unlock_anonymous_git_access event. */
export type RepoConfigUnlockAnonymousGitAccessAuditEntry = AuditEntry & Node & OrganizationAuditEntryData & RepositoryAuditEntryData & {
  __typename?: 'RepoConfigUnlockAnonymousGitAccessAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /** The Node ID of the RepoConfigUnlockAnonymousGitAccessAuditEntry object */
  id: Scalars['ID']['output'];
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /** The repository associated with the action */
  repository?: Maybe<Repository>;
  /** The name of the repository */
  repositoryName?: Maybe<Scalars['String']['output']>;
  /** The HTTP path for the repository */
  repositoryResourcePath?: Maybe<Scalars['URI']['output']>;
  /** The HTTP URL for the repository */
  repositoryUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
};

/** Audit log entry for a repo.create event. */
export type RepoCreateAuditEntry = AuditEntry & Node & OrganizationAuditEntryData & RepositoryAuditEntryData & {
  __typename?: 'RepoCreateAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /**
   * The name of the parent repository for this forked repository.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  forkParentName?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the root repository for this network.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  forkSourceName?: Maybe<Scalars['String']['output']>;
  /** The Node ID of the RepoCreateAuditEntry object */
  id: Scalars['ID']['output'];
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /** The repository associated with the action */
  repository?: Maybe<Repository>;
  /** The name of the repository */
  repositoryName?: Maybe<Scalars['String']['output']>;
  /** The HTTP path for the repository */
  repositoryResourcePath?: Maybe<Scalars['URI']['output']>;
  /** The HTTP URL for the repository */
  repositoryUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The visibility of the repository
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  visibility?: Maybe<RepoCreateAuditEntryVisibility>;
};

/** The privacy of a repository */
export enum RepoCreateAuditEntryVisibility {
  /** The repository is visible only to users in the same enterprise. */
  Internal = 'INTERNAL',
  /** The repository is visible only to those with explicit access. */
  Private = 'PRIVATE',
  /** The repository is visible to everyone. */
  Public = 'PUBLIC'
}

/** Audit log entry for a repo.destroy event. */
export type RepoDestroyAuditEntry = AuditEntry & Node & OrganizationAuditEntryData & RepositoryAuditEntryData & {
  __typename?: 'RepoDestroyAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /** The Node ID of the RepoDestroyAuditEntry object */
  id: Scalars['ID']['output'];
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /** The repository associated with the action */
  repository?: Maybe<Repository>;
  /** The name of the repository */
  repositoryName?: Maybe<Scalars['String']['output']>;
  /** The HTTP path for the repository */
  repositoryResourcePath?: Maybe<Scalars['URI']['output']>;
  /** The HTTP URL for the repository */
  repositoryUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The visibility of the repository
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  visibility?: Maybe<RepoDestroyAuditEntryVisibility>;
};

/** The privacy of a repository */
export enum RepoDestroyAuditEntryVisibility {
  /** The repository is visible only to users in the same enterprise. */
  Internal = 'INTERNAL',
  /** The repository is visible only to those with explicit access. */
  Private = 'PRIVATE',
  /** The repository is visible to everyone. */
  Public = 'PUBLIC'
}

/** Audit log entry for a repo.remove_member event. */
export type RepoRemoveMemberAuditEntry = AuditEntry & Node & OrganizationAuditEntryData & RepositoryAuditEntryData & {
  __typename?: 'RepoRemoveMemberAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /** The Node ID of the RepoRemoveMemberAuditEntry object */
  id: Scalars['ID']['output'];
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /** The repository associated with the action */
  repository?: Maybe<Repository>;
  /** The name of the repository */
  repositoryName?: Maybe<Scalars['String']['output']>;
  /** The HTTP path for the repository */
  repositoryResourcePath?: Maybe<Scalars['URI']['output']>;
  /** The HTTP URL for the repository */
  repositoryUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The visibility of the repository
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  visibility?: Maybe<RepoRemoveMemberAuditEntryVisibility>;
};

/** The privacy of a repository */
export enum RepoRemoveMemberAuditEntryVisibility {
  /** The repository is visible only to users in the same enterprise. */
  Internal = 'INTERNAL',
  /** The repository is visible only to those with explicit access. */
  Private = 'PRIVATE',
  /** The repository is visible to everyone. */
  Public = 'PUBLIC'
}

/** Audit log entry for a repo.remove_topic event. */
export type RepoRemoveTopicAuditEntry = AuditEntry & Node & OrganizationAuditEntryData & RepositoryAuditEntryData & TopicAuditEntryData & {
  __typename?: 'RepoRemoveTopicAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /** The Node ID of the RepoRemoveTopicAuditEntry object */
  id: Scalars['ID']['output'];
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /** The repository associated with the action */
  repository?: Maybe<Repository>;
  /** The name of the repository */
  repositoryName?: Maybe<Scalars['String']['output']>;
  /** The HTTP path for the repository */
  repositoryResourcePath?: Maybe<Scalars['URI']['output']>;
  /** The HTTP URL for the repository */
  repositoryUrl?: Maybe<Scalars['URI']['output']>;
  /** The name of the topic added to the repository */
  topic?: Maybe<Topic>;
  /** The name of the topic added to the repository */
  topicName?: Maybe<Scalars['String']['output']>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
};

/** The reasons a piece of content can be reported or minimized. */
export enum ReportedContentClassifiers {
  /** An abusive or harassing piece of content */
  Abuse = 'ABUSE',
  /** A duplicated piece of content */
  Duplicate = 'DUPLICATE',
  /** A low quality piece of content */
  LowQuality = 'LOW_QUALITY',
  /** An irrelevant piece of content */
  OffTopic = 'OFF_TOPIC',
  /** An outdated piece of content */
  Outdated = 'OUTDATED',
  /** The content has been resolved */
  Resolved = 'RESOLVED',
  /** A spammy piece of content */
  Spam = 'SPAM'
}

/** A repository contains the content for a project. */
export type Repository = Node & PackageOwner & ProjectOwner & ProjectV2Recent & RepositoryInfo & Starrable & Subscribable & UniformResourceLocatable & {
  __typename?: 'Repository';
  /**
   * Whether or not a pull request head branch that is behind its base branch can
   * always be updated even if it is not required to be up to date before merging.
   */
  allowUpdateBranch: Scalars['Boolean']['output'];
  /** Identifies the date and time when the repository was archived. */
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  /** A list of users that can be assigned to issues in this repository. */
  assignableUsers: UserConnection;
  /** Whether or not Auto-merge can be enabled on pull requests in this repository. */
  autoMergeAllowed: Scalars['Boolean']['output'];
  /** A list of branch protection rules for this repository. */
  branchProtectionRules: BranchProtectionRuleConnection;
  /** Returns the code of conduct for this repository */
  codeOfConduct?: Maybe<CodeOfConduct>;
  /** Information extracted from the repository's `CODEOWNERS` file. */
  codeowners?: Maybe<RepositoryCodeowners>;
  /** A list of collaborators associated with the repository. */
  collaborators?: Maybe<RepositoryCollaboratorConnection>;
  /** A list of commit comments associated with the repository. */
  commitComments: CommitCommentConnection;
  /** Returns a list of contact links associated to the repository */
  contactLinks?: Maybe<Array<RepositoryContactLink>>;
  /** Returns the contributing guidelines for this repository. */
  contributingGuidelines?: Maybe<ContributingGuidelines>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Identifies the primary key from the database. */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** The Ref associated with the repository's default branch. */
  defaultBranchRef?: Maybe<Ref>;
  /** Whether or not branches are automatically deleted when merged in this repository. */
  deleteBranchOnMerge: Scalars['Boolean']['output'];
  /** A list of dependency manifests contained in the repository */
  dependencyGraphManifests?: Maybe<DependencyGraphManifestConnection>;
  /** A list of deploy keys that are on this repository. */
  deployKeys: DeployKeyConnection;
  /** Deployments associated with the repository */
  deployments: DeploymentConnection;
  /** The description of the repository. */
  description?: Maybe<Scalars['String']['output']>;
  /** The description of the repository rendered to HTML. */
  descriptionHTML: Scalars['HTML']['output'];
  /** Returns a single discussion from the current repository by number. */
  discussion?: Maybe<Discussion>;
  /** A list of discussion categories that are available in the repository. */
  discussionCategories: DiscussionCategoryConnection;
  /** A discussion category by slug. */
  discussionCategory?: Maybe<DiscussionCategory>;
  /** A list of discussions that have been opened in the repository. */
  discussions: DiscussionConnection;
  /** The number of kilobytes this repository occupies on disk. */
  diskUsage?: Maybe<Scalars['Int']['output']>;
  /** Returns a single active environment from the current repository by name. */
  environment?: Maybe<Environment>;
  /** A list of environments that are in this repository. */
  environments: EnvironmentConnection;
  /** Returns how many forks there are of this repository in the whole network. */
  forkCount: Scalars['Int']['output'];
  /** Whether this repository allows forks. */
  forkingAllowed: Scalars['Boolean']['output'];
  /** A list of direct forked repositories. */
  forks: RepositoryConnection;
  /** Identifies the primary key from the database as a BigInt. */
  fullDatabaseId?: Maybe<Scalars['BigInt']['output']>;
  /** The funding links for this repository */
  fundingLinks: Array<FundingLink>;
  /** Indicates if the repository has the Discussions feature enabled. */
  hasDiscussionsEnabled: Scalars['Boolean']['output'];
  /** Indicates if the repository has issues feature enabled. */
  hasIssuesEnabled: Scalars['Boolean']['output'];
  /** Indicates if the repository has the Projects feature enabled. */
  hasProjectsEnabled: Scalars['Boolean']['output'];
  /** Indicates if the repository has the pull requests feature enabled. */
  hasPullRequestsEnabled: Scalars['Boolean']['output'];
  /** Indicates if the repository displays a Sponsor button for financial contributions. */
  hasSponsorshipsEnabled: Scalars['Boolean']['output'];
  /** Whether vulnerability alerts are enabled for the repository. */
  hasVulnerabilityAlertsEnabled: Scalars['Boolean']['output'];
  /** Indicates if the repository has wiki feature enabled. */
  hasWikiEnabled: Scalars['Boolean']['output'];
  /** The repository's URL. */
  homepageUrl?: Maybe<Scalars['URI']['output']>;
  /** The Node ID of the Repository object */
  id: Scalars['ID']['output'];
  /** The interaction ability settings for this repository. */
  interactionAbility?: Maybe<RepositoryInteractionAbility>;
  /** Indicates if the repository is unmaintained. */
  isArchived: Scalars['Boolean']['output'];
  /** Returns true if the viewer can create a blank issue in this repository */
  isBlankIssuesEnabled: Scalars['Boolean']['output'];
  /** Returns whether or not this repository disabled. */
  isDisabled: Scalars['Boolean']['output'];
  /** Returns whether or not this repository is empty. */
  isEmpty: Scalars['Boolean']['output'];
  /** Identifies if the repository is a fork. */
  isFork: Scalars['Boolean']['output'];
  /** Indicates if a repository is either owned by an organization, or is a private fork of an organization repository. */
  isInOrganization: Scalars['Boolean']['output'];
  /** Indicates if the repository has been locked or not. */
  isLocked: Scalars['Boolean']['output'];
  /** Identifies if the repository is a mirror. */
  isMirror: Scalars['Boolean']['output'];
  /** Identifies if the repository is private or internal. */
  isPrivate: Scalars['Boolean']['output'];
  /** Returns true if this repository has a security policy */
  isSecurityPolicyEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Identifies if the repository is a template that can be used to generate new repositories. */
  isTemplate: Scalars['Boolean']['output'];
  /** Is this repository a user configuration repository? */
  isUserConfigurationRepository: Scalars['Boolean']['output'];
  /** Returns a single issue from the current repository by number. */
  issue?: Maybe<Issue>;
  /** The policy controlling who can create issues in this repository. */
  issueCreationPolicy?: Maybe<IssueCreationPolicy>;
  /** A list of the repository's issue fields, inherited from the organization */
  issueFields?: Maybe<IssueFieldsConnection>;
  /** Returns a single issue-like object from the current repository by number. */
  issueOrPullRequest?: Maybe<IssueOrPullRequest>;
  /** Returns a list of issue templates associated to the repository */
  issueTemplates?: Maybe<Array<IssueTemplate>>;
  /** Returns a single issue type by name */
  issueType?: Maybe<IssueType>;
  /** A list of the repository's issue types */
  issueTypes?: Maybe<IssueTypeConnection>;
  /** A list of issues that have been opened in the repository. */
  issues: IssueConnection;
  /** Returns a single label by name */
  label?: Maybe<Label>;
  /** A list of labels associated with the repository. */
  labels?: Maybe<LabelConnection>;
  /** A list containing a breakdown of the language composition of the repository. */
  languages?: Maybe<LanguageConnection>;
  /** Get the latest release for the repository if one exists. */
  latestRelease?: Maybe<Release>;
  /** The license associated with the repository */
  licenseInfo?: Maybe<License>;
  /** The reason the repository has been locked. */
  lockReason?: Maybe<RepositoryLockReason>;
  /** A list of Users that can be mentioned in the context of the repository. */
  mentionableUsers: UserConnection;
  /** Whether or not PRs are merged with a merge commit on this repository. */
  mergeCommitAllowed: Scalars['Boolean']['output'];
  /** How the default commit message will be generated when merging a pull request. */
  mergeCommitMessage: MergeCommitMessage;
  /** How the default commit title will be generated when merging a pull request. */
  mergeCommitTitle: MergeCommitTitle;
  /** The merge queue for a specified branch, otherwise the default branch if not provided. */
  mergeQueue?: Maybe<MergeQueue>;
  /** Returns a single milestone from the current repository by number. */
  milestone?: Maybe<Milestone>;
  /** A list of milestones associated with the repository. */
  milestones?: Maybe<MilestoneConnection>;
  /** The repository's original mirror URL. */
  mirrorUrl?: Maybe<Scalars['URI']['output']>;
  /** The name of the repository. */
  name: Scalars['String']['output'];
  /** The repository's name with owner. */
  nameWithOwner: Scalars['String']['output'];
  /** A Git object in the repository */
  object?: Maybe<GitObject>;
  /** The image used to represent this repository in Open Graph data. */
  openGraphImageUrl: Scalars['URI']['output'];
  /** The User owner of the repository. */
  owner: RepositoryOwner;
  /** A list of packages under the owner. */
  packages: PackageConnection;
  /** The repository parent, if this is a fork. */
  parent?: Maybe<Repository>;
  /** A list of discussions that have been pinned in this repository. */
  pinnedDiscussions: PinnedDiscussionConnection;
  /** A list of pinned environments for this repository. */
  pinnedEnvironments?: Maybe<PinnedEnvironmentConnection>;
  /** A list of pinned issues for this repository. */
  pinnedIssues?: Maybe<PinnedIssueConnection>;
  /** Returns information about the availability of certain features and limits based on the repository's billing plan. */
  planFeatures: RepositoryPlanFeatures;
  /** The primary language of the repository's code. */
  primaryLanguage?: Maybe<Language>;
  /**
   * Find project by number.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  project?: Maybe<Project>;
  /** Finds and returns the Project according to the provided Project number. */
  projectV2?: Maybe<ProjectV2>;
  /**
   * A list of projects under the owner.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  projects: ProjectConnection;
  /** The HTTP path listing the repository's projects */
  projectsResourcePath: Scalars['URI']['output'];
  /** The HTTP URL listing the repository's projects */
  projectsUrl: Scalars['URI']['output'];
  /** List of projects linked to this repository. */
  projectsV2: ProjectV2Connection;
  /** Returns a single pull request from the current repository by number. */
  pullRequest?: Maybe<PullRequest>;
  /**
   * The pull request creation cap configuration for this repository. Only visible
   * to repository maintainers and administrators.
   */
  pullRequestCreationCapConfig?: Maybe<PullRequestCreationCapConfig>;
  /** The policy controlling who can create pull requests in this repository. */
  pullRequestCreationPolicy?: Maybe<PullRequestCreationPolicy>;
  /** Returns a list of pull request templates associated to the repository */
  pullRequestTemplates?: Maybe<Array<PullRequestTemplate>>;
  /** A list of pull requests that have been opened in the repository. */
  pullRequests: PullRequestConnection;
  /** Identifies the date and time when the repository was last pushed to. */
  pushedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Whether or not rebase-merging is enabled on this repository. */
  rebaseMergeAllowed: Scalars['Boolean']['output'];
  /** Recent projects that this user has modified in the context of the owner. */
  recentProjects: ProjectV2Connection;
  /** Fetch a given ref from the repository */
  ref?: Maybe<Ref>;
  /** Fetch a list of refs from the repository */
  refs?: Maybe<RefConnection>;
  /** Lookup a single release given various criteria. */
  release?: Maybe<Release>;
  /** List of releases which are dependent on this repository. */
  releases: ReleaseConnection;
  /** A custom property value for the repository. */
  repositoryCustomPropertyValue?: Maybe<RepositoryCustomPropertyValue>;
  /** A list of custom properties and their associated values for a repository. */
  repositoryCustomPropertyValues?: Maybe<RepositoryCustomPropertyValueConnection>;
  /** A list of applied repository-topic associations for this repository. */
  repositoryTopics: RepositoryTopicConnection;
  /** The HTTP path for this repository */
  resourcePath: Scalars['URI']['output'];
  /** Returns a single ruleset from the current repository by ID. */
  ruleset?: Maybe<RepositoryRuleset>;
  /** A list of rulesets for this repository. */
  rulesets?: Maybe<RepositoryRulesetConnection>;
  /** The security policy URL. */
  securityPolicyUrl?: Maybe<Scalars['URI']['output']>;
  /** A description of the repository, rendered to HTML without any links in it. */
  shortDescriptionHTML: Scalars['HTML']['output'];
  /** Whether or not squash-merging is enabled on this repository. */
  squashMergeAllowed: Scalars['Boolean']['output'];
  /** How the default commit message will be generated when squash merging a pull request. */
  squashMergeCommitMessage: SquashMergeCommitMessage;
  /** How the default commit title will be generated when squash merging a pull request. */
  squashMergeCommitTitle: SquashMergeCommitTitle;
  /**
   * Whether a squash merge commit can use the pull request title as default.
   * @deprecated `squashPrTitleUsedAsDefault` will be removed. Use `Repository.squashMergeCommitTitle` instead. Removal on 2023-04-01 UTC.
   */
  squashPrTitleUsedAsDefault: Scalars['Boolean']['output'];
  /** The SSH URL to clone this repository */
  sshUrl: Scalars['GitSSHRemote']['output'];
  /** Returns a count of how many stargazers there are on this object */
  stargazerCount: Scalars['Int']['output'];
  /** A list of users who have starred this starrable. */
  stargazers: StargazerConnection;
  /**
   * Returns a list of all submodules in this repository parsed from the
   * .gitmodules file as of the default branch's HEAD commit.
   */
  submodules: SubmoduleConnection;
  /** A list of suggested actors that can be attributed to content in this repository. */
  suggestedActors: ActorConnection;
  /** Temporary authentication token for cloning this repository. */
  tempCloneToken?: Maybe<Scalars['String']['output']>;
  /** The repository from which this repository was generated, if any. */
  templateRepository?: Maybe<Repository>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The HTTP URL for this repository */
  url: Scalars['URI']['output'];
  /** Whether this repository has a custom image to use with Open Graph as opposed to being represented by the owner's avatar. */
  usesCustomOpenGraphImage: Scalars['Boolean']['output'];
  /** Indicates whether the viewer has admin permissions on this repository. */
  viewerCanAdminister: Scalars['Boolean']['output'];
  /** Indicates whether the current user can create issues in this repository. */
  viewerCanCreateIssues: Scalars['Boolean']['output'];
  /**
   * Can the current viewer create new projects on this owner.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  viewerCanCreateProjects: Scalars['Boolean']['output'];
  /** Indicates whether the current user can see issue fields in this repository */
  viewerCanSeeIssueFields: Scalars['Boolean']['output'];
  /** Check if the viewer is able to change their subscription status for the repository. */
  viewerCanSubscribe: Scalars['Boolean']['output'];
  /** Indicates whether the viewer can update the topics of this repository. */
  viewerCanUpdateTopics: Scalars['Boolean']['output'];
  /** The content warning for this repository for the viewer. */
  viewerContentWarning?: Maybe<ContentWarning>;
  /** The last commit email for the viewer. */
  viewerDefaultCommitEmail?: Maybe<Scalars['String']['output']>;
  /** The last used merge method by the viewer or the default for the repository. */
  viewerDefaultMergeMethod: PullRequestMergeMethod;
  /** Returns a boolean indicating whether the viewing user has starred this starrable. */
  viewerHasStarred: Scalars['Boolean']['output'];
  /** The users permission level on the repository. Will return null if authenticated as an GitHub App. */
  viewerPermission?: Maybe<RepositoryPermission>;
  /** A list of emails this viewer can commit with. */
  viewerPossibleCommitEmails?: Maybe<Array<Scalars['String']['output']>>;
  /** Identifies if the viewer is watching, not watching, or ignoring the subscribable entity. */
  viewerSubscription?: Maybe<SubscriptionState>;
  /** Indicates the repository's visibility level. */
  visibility: RepositoryVisibility;
  /** Returns a single vulnerability alert from the current repository by number. */
  vulnerabilityAlert?: Maybe<RepositoryVulnerabilityAlert>;
  /** A list of vulnerability alerts that are on this repository. */
  vulnerabilityAlerts?: Maybe<RepositoryVulnerabilityAlertConnection>;
  /** A list of users watching the repository. */
  watchers: UserConnection;
  /** Whether contributors are required to sign off on web-based commits in this repository. */
  webCommitSignoffRequired: Scalars['Boolean']['output'];
};


/** A repository contains the content for a project. */
export type RepositoryAssignableUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


/** A repository contains the content for a project. */
export type RepositoryBranchProtectionRulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A repository contains the content for a project. */
export type RepositoryCodeownersArgs = {
  refName?: InputMaybe<Scalars['String']['input']>;
};


/** A repository contains the content for a project. */
export type RepositoryCollaboratorsArgs = {
  affiliation?: InputMaybe<CollaboratorAffiliation>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  login?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


/** A repository contains the content for a project. */
export type RepositoryCommitCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A repository contains the content for a project. */
export type RepositoryDependencyGraphManifestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  dependenciesAfter?: InputMaybe<Scalars['String']['input']>;
  dependenciesFirst?: InputMaybe<Scalars['Int']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  withDependencies?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A repository contains the content for a project. */
export type RepositoryDeployKeysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A repository contains the content for a project. */
export type RepositoryDeploymentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  environments?: InputMaybe<Array<Scalars['String']['input']>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DeploymentOrder>;
};


/** A repository contains the content for a project. */
export type RepositoryDiscussionArgs = {
  number: Scalars['Int']['input'];
};


/** A repository contains the content for a project. */
export type RepositoryDiscussionCategoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterByAssignable?: InputMaybe<Scalars['Boolean']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A repository contains the content for a project. */
export type RepositoryDiscussionCategoryArgs = {
  slug: Scalars['String']['input'];
};


/** A repository contains the content for a project. */
export type RepositoryDiscussionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  answered?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DiscussionOrder>;
  states?: InputMaybe<Array<DiscussionState>>;
};


/** A repository contains the content for a project. */
export type RepositoryEnvironmentArgs = {
  name: Scalars['String']['input'];
};


/** A repository contains the content for a project. */
export type RepositoryEnvironmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  names?: InputMaybe<Array<Scalars['String']['input']>>;
  orderBy?: InputMaybe<Environments>;
  pinnedEnvironmentFilter?: InputMaybe<EnvironmentPinnedFilterField>;
};


/** A repository contains the content for a project. */
export type RepositoryForksArgs = {
  affiliations?: InputMaybe<Array<InputMaybe<RepositoryAffiliation>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasIssuesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<RepositoryOrder>;
  ownerAffiliations?: InputMaybe<Array<InputMaybe<RepositoryAffiliation>>>;
  privacy?: InputMaybe<RepositoryPrivacy>;
  visibility?: InputMaybe<RepositoryVisibility>;
};


/** A repository contains the content for a project. */
export type RepositoryIssueArgs = {
  number: Scalars['Int']['input'];
};


/** A repository contains the content for a project. */
export type RepositoryIssueFieldsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<IssueFieldOrder>;
};


/** A repository contains the content for a project. */
export type RepositoryIssueOrPullRequestArgs = {
  number: Scalars['Int']['input'];
};


/** A repository contains the content for a project. */
export type RepositoryIssueTypeArgs = {
  name: Scalars['String']['input'];
};


/** A repository contains the content for a project. */
export type RepositoryIssueTypesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<IssueTypeOrder>;
};


/** A repository contains the content for a project. */
export type RepositoryIssuesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<IssueFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<IssueOrder>;
  states?: InputMaybe<Array<IssueState>>;
};


/** A repository contains the content for a project. */
export type RepositoryLabelArgs = {
  name: Scalars['String']['input'];
};


/** A repository contains the content for a project. */
export type RepositoryLabelsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LabelOrder>;
  query?: InputMaybe<Scalars['String']['input']>;
};


/** A repository contains the content for a project. */
export type RepositoryLanguagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<LanguageOrder>;
};


/** A repository contains the content for a project. */
export type RepositoryMentionableUsersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


/** A repository contains the content for a project. */
export type RepositoryMergeQueueArgs = {
  branch?: InputMaybe<Scalars['String']['input']>;
};


/** A repository contains the content for a project. */
export type RepositoryMilestoneArgs = {
  number: Scalars['Int']['input'];
};


/** A repository contains the content for a project. */
export type RepositoryMilestonesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<MilestoneOrder>;
  query?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Array<MilestoneState>>;
};


/** A repository contains the content for a project. */
export type RepositoryObjectArgs = {
  expression?: InputMaybe<Scalars['String']['input']>;
  oid?: InputMaybe<Scalars['GitObjectID']['input']>;
};


/** A repository contains the content for a project. */
export type RepositoryPackagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  names?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  orderBy?: InputMaybe<PackageOrder>;
  packageType?: InputMaybe<PackageType>;
  repositoryId?: InputMaybe<Scalars['ID']['input']>;
};


/** A repository contains the content for a project. */
export type RepositoryPinnedDiscussionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A repository contains the content for a project. */
export type RepositoryPinnedEnvironmentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<PinnedEnvironmentOrder>;
};


/** A repository contains the content for a project. */
export type RepositoryPinnedIssuesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A repository contains the content for a project. */
export type RepositoryProjectArgs = {
  number: Scalars['Int']['input'];
};


/** A repository contains the content for a project. */
export type RepositoryProjectV2Args = {
  number: Scalars['Int']['input'];
};


/** A repository contains the content for a project. */
export type RepositoryProjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProjectOrder>;
  search?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Array<ProjectState>>;
};


/** A repository contains the content for a project. */
export type RepositoryProjectsV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  minPermissionLevel?: InputMaybe<ProjectV2PermissionLevel>;
  orderBy?: InputMaybe<ProjectV2Order>;
  query?: InputMaybe<Scalars['String']['input']>;
};


/** A repository contains the content for a project. */
export type RepositoryPullRequestArgs = {
  number: Scalars['Int']['input'];
};


/** A repository contains the content for a project. */
export type RepositoryPullRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  baseRefName?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  headRefName?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<IssueOrder>;
  states?: InputMaybe<Array<PullRequestState>>;
};


/** A repository contains the content for a project. */
export type RepositoryRecentProjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A repository contains the content for a project. */
export type RepositoryRefArgs = {
  qualifiedName: Scalars['String']['input'];
};


/** A repository contains the content for a project. */
export type RepositoryRefsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  direction?: InputMaybe<OrderDirection>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<RefOrder>;
  query?: InputMaybe<Scalars['String']['input']>;
  refPrefix: Scalars['String']['input'];
};


/** A repository contains the content for a project. */
export type RepositoryReleaseArgs = {
  tagName: Scalars['String']['input'];
};


/** A repository contains the content for a project. */
export type RepositoryReleasesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ReleaseOrder>;
};


/** A repository contains the content for a project. */
export type RepositoryRepositoryCustomPropertyValueArgs = {
  propertyName: Scalars['String']['input'];
};


/** A repository contains the content for a project. */
export type RepositoryRepositoryCustomPropertyValuesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A repository contains the content for a project. */
export type RepositoryRepositoryTopicsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A repository contains the content for a project. */
export type RepositoryRulesetArgs = {
  databaseId: Scalars['Int']['input'];
  includeParents?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A repository contains the content for a project. */
export type RepositoryRulesetsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeParents?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  targets?: InputMaybe<Array<RepositoryRulesetTarget>>;
};


/** A repository contains the content for a project. */
export type RepositoryShortDescriptionHtmlArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/** A repository contains the content for a project. */
export type RepositoryStargazersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<StarOrder>;
};


/** A repository contains the content for a project. */
export type RepositorySubmodulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A repository contains the content for a project. */
export type RepositorySuggestedActorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  capabilities: Array<RepositorySuggestedActorFilter>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  loginNames?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['String']['input']>;
};


/** A repository contains the content for a project. */
export type RepositoryVulnerabilityAlertArgs = {
  number: Scalars['Int']['input'];
};


/** A repository contains the content for a project. */
export type RepositoryVulnerabilityAlertsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  classifications?: InputMaybe<Array<SecurityAdvisoryClassification>>;
  dependencyScopes?: InputMaybe<Array<RepositoryVulnerabilityAlertDependencyScope>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  states?: InputMaybe<Array<RepositoryVulnerabilityAlertState>>;
};


/** A repository contains the content for a project. */
export type RepositoryWatchersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The affiliation of a user to a repository */
export enum RepositoryAffiliation {
  /** Repositories that the user has been added to as a collaborator. */
  Collaborator = 'COLLABORATOR',
  /**
   * Repositories that the user has access to through being a member of an
   * organization. This includes every repository on every team that the user is on.
   */
  OrganizationMember = 'ORGANIZATION_MEMBER',
  /** Repositories that are owned by the authenticated user. */
  Owner = 'OWNER'
}

/** Metadata for an audit entry with action repo.* */
export type RepositoryAuditEntryData = {
  /** The repository associated with the action */
  repository?: Maybe<Repository>;
  /** The name of the repository */
  repositoryName?: Maybe<Scalars['String']['output']>;
  /** The HTTP path for the repository */
  repositoryResourcePath?: Maybe<Scalars['URI']['output']>;
  /** The HTTP URL for the repository */
  repositoryUrl?: Maybe<Scalars['URI']['output']>;
};

/** Information extracted from a repository's `CODEOWNERS` file. */
export type RepositoryCodeowners = {
  __typename?: 'RepositoryCodeowners';
  /** Any problems that were encountered while parsing the `CODEOWNERS` file. */
  errors: Array<RepositoryCodeownersError>;
};

/** An error in a `CODEOWNERS` file. */
export type RepositoryCodeownersError = {
  __typename?: 'RepositoryCodeownersError';
  /** The column number where the error occurs. */
  column: Scalars['Int']['output'];
  /** A short string describing the type of error. */
  kind: Scalars['String']['output'];
  /** The line number where the error occurs. */
  line: Scalars['Int']['output'];
  /** A complete description of the error, combining information from other fields. */
  message: Scalars['String']['output'];
  /** The path to the file when the error occurs. */
  path: Scalars['String']['output'];
  /** The content of the line where the error occurs. */
  source: Scalars['String']['output'];
  /** A suggestion of how to fix the error. */
  suggestion?: Maybe<Scalars['String']['output']>;
};

/** The connection type for User. */
export type RepositoryCollaboratorConnection = {
  __typename?: 'RepositoryCollaboratorConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RepositoryCollaboratorEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<User>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** Represents a user who is a collaborator of a repository. */
export type RepositoryCollaboratorEdge = {
  __typename?: 'RepositoryCollaboratorEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  node: User;
  /** The permission the user has on the repository. */
  permission: RepositoryPermission;
  /** A list of sources for the user's access to the repository. */
  permissionSources?: Maybe<Array<PermissionSource>>;
};

/** A list of repositories owned by the subject. */
export type RepositoryConnection = {
  __typename?: 'RepositoryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RepositoryEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Repository>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
  /**
   * The total size in kilobytes of all repositories in the connection. Value will
   * never be larger than max 32-bit signed integer.
   */
  totalDiskUsage: Scalars['Int']['output'];
};

/** A repository contact link. */
export type RepositoryContactLink = {
  __typename?: 'RepositoryContactLink';
  /** The contact link purpose. */
  about: Scalars['String']['output'];
  /** The contact link name. */
  name: Scalars['String']['output'];
  /** The contact link URL. */
  url: Scalars['URI']['output'];
};

/** The reason a repository is listed as 'contributed'. */
export enum RepositoryContributionType {
  /** Created a commit */
  Commit = 'COMMIT',
  /** Created an issue */
  Issue = 'ISSUE',
  /** Created a pull request */
  PullRequest = 'PULL_REQUEST',
  /** Reviewed a pull request */
  PullRequestReview = 'PULL_REQUEST_REVIEW',
  /** Created the repository */
  Repository = 'REPOSITORY'
}

/** A repository custom property. */
export type RepositoryCustomProperty = Node & {
  __typename?: 'RepositoryCustomProperty';
  /** The allowed values for the custom property. Required if `value_type` is `single_select` or `multi_select`. */
  allowedValues?: Maybe<Array<Scalars['String']['output']>>;
  /** The default value of the custom property, if the property is `required`. */
  defaultValue?: Maybe<Scalars['CustomPropertyValue']['output']>;
  /** The description of the custom property. */
  description?: Maybe<Scalars['String']['output']>;
  /** The Node ID of the RepositoryCustomProperty object */
  id: Scalars['ID']['output'];
  /** The name of the custom property. */
  propertyName: Scalars['String']['output'];
  /** The regex pattern that the value of the custom property must match, if the `value_type` is `string`. */
  regex?: Maybe<Scalars['String']['output']>;
  /** Whether this repository custom property requires explicit values. */
  requireExplicitValues?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the custom property is required. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** The source type of the custom property. */
  source: CustomPropertySource;
  /** The value type of the custom property. */
  valueType: CustomPropertyValueType;
  /** Who can edit the values of this repository custom property. */
  valuesEditableBy: RepositoryCustomPropertyValuesEditableBy;
};

/** The connection type for RepositoryCustomProperty. */
export type RepositoryCustomPropertyConnection = {
  __typename?: 'RepositoryCustomPropertyConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RepositoryCustomPropertyEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<RepositoryCustomProperty>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type RepositoryCustomPropertyEdge = {
  __typename?: 'RepositoryCustomPropertyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<RepositoryCustomProperty>;
};

/** A value associated with a repository custom property. */
export type RepositoryCustomPropertyValue = {
  __typename?: 'RepositoryCustomPropertyValue';
  /** The name of the custom property. */
  propertyName: Scalars['String']['output'];
  /** The value of the custom property. */
  value: Scalars['CustomPropertyValue']['output'];
};

/** The connection type for RepositoryCustomPropertyValue. */
export type RepositoryCustomPropertyValueConnection = {
  __typename?: 'RepositoryCustomPropertyValueConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RepositoryCustomPropertyValueEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<RepositoryCustomPropertyValue>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type RepositoryCustomPropertyValueEdge = {
  __typename?: 'RepositoryCustomPropertyValueEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<RepositoryCustomPropertyValue>;
};

/** The allowed actors who can edit the values of a custom property. */
export enum RepositoryCustomPropertyValuesEditableBy {
  /** The organization actors. */
  OrgActors = 'ORG_ACTORS',
  /** The organization and repository actors. */
  OrgAndRepoActors = 'ORG_AND_REPO_ACTORS'
}

/** Represents an author of discussions in repositories. */
export type RepositoryDiscussionAuthor = {
  /** Discussions this user has started. */
  repositoryDiscussions: DiscussionConnection;
};


/** Represents an author of discussions in repositories. */
export type RepositoryDiscussionAuthorRepositoryDiscussionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  answered?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DiscussionOrder>;
  repositoryId?: InputMaybe<Scalars['ID']['input']>;
  states?: InputMaybe<Array<DiscussionState>>;
};

/** Represents an author of discussion comments in repositories. */
export type RepositoryDiscussionCommentAuthor = {
  /** Discussion comments this user has authored. */
  repositoryDiscussionComments: DiscussionCommentConnection;
};


/** Represents an author of discussion comments in repositories. */
export type RepositoryDiscussionCommentAuthorRepositoryDiscussionCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  onlyAnswers?: InputMaybe<Scalars['Boolean']['input']>;
  repositoryId?: InputMaybe<Scalars['ID']['input']>;
};

/** An edge in a connection. */
export type RepositoryEdge = {
  __typename?: 'RepositoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Repository>;
};

/** Parameters to be used for the repository_id condition */
export type RepositoryIdConditionTarget = {
  __typename?: 'RepositoryIdConditionTarget';
  /** One of these repo IDs must match the repo. */
  repositoryIds: Array<Scalars['ID']['output']>;
};

/** Parameters to be used for the repository_id condition */
export type RepositoryIdConditionTargetInput = {
  /** One of these repo IDs must match the repo. */
  repositoryIds: Array<Scalars['ID']['input']>;
};

/** A subset of repository info. */
export type RepositoryInfo = {
  /** Identifies the date and time when the repository was archived. */
  archivedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The description of the repository. */
  description?: Maybe<Scalars['String']['output']>;
  /** The description of the repository rendered to HTML. */
  descriptionHTML: Scalars['HTML']['output'];
  /** Returns how many forks there are of this repository in the whole network. */
  forkCount: Scalars['Int']['output'];
  /** Indicates if the repository has the Discussions feature enabled. */
  hasDiscussionsEnabled: Scalars['Boolean']['output'];
  /** Indicates if the repository has issues feature enabled. */
  hasIssuesEnabled: Scalars['Boolean']['output'];
  /** Indicates if the repository has the Projects feature enabled. */
  hasProjectsEnabled: Scalars['Boolean']['output'];
  /** Indicates if the repository has the pull requests feature enabled. */
  hasPullRequestsEnabled: Scalars['Boolean']['output'];
  /** Indicates if the repository displays a Sponsor button for financial contributions. */
  hasSponsorshipsEnabled: Scalars['Boolean']['output'];
  /** Indicates if the repository has wiki feature enabled. */
  hasWikiEnabled: Scalars['Boolean']['output'];
  /** The repository's URL. */
  homepageUrl?: Maybe<Scalars['URI']['output']>;
  /** Indicates if the repository is unmaintained. */
  isArchived: Scalars['Boolean']['output'];
  /** Identifies if the repository is a fork. */
  isFork: Scalars['Boolean']['output'];
  /** Indicates if a repository is either owned by an organization, or is a private fork of an organization repository. */
  isInOrganization: Scalars['Boolean']['output'];
  /** Indicates if the repository has been locked or not. */
  isLocked: Scalars['Boolean']['output'];
  /** Identifies if the repository is a mirror. */
  isMirror: Scalars['Boolean']['output'];
  /** Identifies if the repository is private or internal. */
  isPrivate: Scalars['Boolean']['output'];
  /** Identifies if the repository is a template that can be used to generate new repositories. */
  isTemplate: Scalars['Boolean']['output'];
  /** The policy controlling who can create issues in this repository. */
  issueCreationPolicy?: Maybe<IssueCreationPolicy>;
  /** The license associated with the repository */
  licenseInfo?: Maybe<License>;
  /** The reason the repository has been locked. */
  lockReason?: Maybe<RepositoryLockReason>;
  /** The repository's original mirror URL. */
  mirrorUrl?: Maybe<Scalars['URI']['output']>;
  /** The name of the repository. */
  name: Scalars['String']['output'];
  /** The repository's name with owner. */
  nameWithOwner: Scalars['String']['output'];
  /** The image used to represent this repository in Open Graph data. */
  openGraphImageUrl: Scalars['URI']['output'];
  /** The User owner of the repository. */
  owner: RepositoryOwner;
  /** The policy controlling who can create pull requests in this repository. */
  pullRequestCreationPolicy?: Maybe<PullRequestCreationPolicy>;
  /** Identifies the date and time when the repository was last pushed to. */
  pushedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The HTTP path for this repository */
  resourcePath: Scalars['URI']['output'];
  /** A description of the repository, rendered to HTML without any links in it. */
  shortDescriptionHTML: Scalars['HTML']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The HTTP URL for this repository */
  url: Scalars['URI']['output'];
  /** Whether this repository has a custom image to use with Open Graph as opposed to being represented by the owner's avatar. */
  usesCustomOpenGraphImage: Scalars['Boolean']['output'];
  /** Indicates the repository's visibility level. */
  visibility: RepositoryVisibility;
};


/** A subset of repository info. */
export type RepositoryInfoShortDescriptionHtmlArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Repository interaction limit that applies to this object. */
export type RepositoryInteractionAbility = {
  __typename?: 'RepositoryInteractionAbility';
  /** The time the currently active limit expires. */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** The current limit that is enabled on this object. */
  limit: RepositoryInteractionLimit;
  /** The origin of the currently active interaction limit. */
  origin: RepositoryInteractionLimitOrigin;
};

/** A repository interaction limit. */
export enum RepositoryInteractionLimit {
  /** Users that are not collaborators will not be able to interact with the repository. */
  CollaboratorsOnly = 'COLLABORATORS_ONLY',
  /** Users that have not previously committed to a repository’s default branch will be unable to interact with the repository. */
  ContributorsOnly = 'CONTRIBUTORS_ONLY',
  /** Users that have recently created their account will be unable to interact with the repository. */
  ExistingUsers = 'EXISTING_USERS',
  /** No interaction limits are enabled. */
  NoLimit = 'NO_LIMIT'
}

/** The length for a repository interaction limit to be enabled for. */
export enum RepositoryInteractionLimitExpiry {
  /** The interaction limit will expire after 1 day. */
  OneDay = 'ONE_DAY',
  /** The interaction limit will expire after 1 month. */
  OneMonth = 'ONE_MONTH',
  /** The interaction limit will expire after 1 week. */
  OneWeek = 'ONE_WEEK',
  /** The interaction limit will expire after 6 months. */
  SixMonths = 'SIX_MONTHS',
  /** The interaction limit will expire after 3 days. */
  ThreeDays = 'THREE_DAYS'
}

/** Indicates where an interaction limit is configured. */
export enum RepositoryInteractionLimitOrigin {
  /** A limit that is configured at the organization level. */
  Organization = 'ORGANIZATION',
  /** A limit that is configured at the repository level. */
  Repository = 'REPOSITORY',
  /** A limit that is configured at the user-wide level. */
  User = 'USER'
}

/** An invitation for a user to be added to a repository. */
export type RepositoryInvitation = Node & {
  __typename?: 'RepositoryInvitation';
  /** The email address that received the invitation. */
  email?: Maybe<Scalars['String']['output']>;
  /** The Node ID of the RepositoryInvitation object */
  id: Scalars['ID']['output'];
  /** The user who received the invitation. */
  invitee?: Maybe<User>;
  /** The user who created the invitation. */
  inviter: User;
  /** The permalink for this repository invitation. */
  permalink: Scalars['URI']['output'];
  /** The permission granted on this repository by this invitation. */
  permission: RepositoryPermission;
  /** The Repository the user is invited to. */
  repository?: Maybe<RepositoryInfo>;
};

/** A list of repository invitations. */
export type RepositoryInvitationConnection = {
  __typename?: 'RepositoryInvitationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RepositoryInvitationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<RepositoryInvitation>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type RepositoryInvitationEdge = {
  __typename?: 'RepositoryInvitationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<RepositoryInvitation>;
};

/** Ordering options for repository invitation connections. */
export type RepositoryInvitationOrder = {
  /** The ordering direction. */
  direction: OrderDirection;
  /** The field to order repository invitations by. */
  field: RepositoryInvitationOrderField;
};

/** Properties by which repository invitation connections can be ordered. */
export enum RepositoryInvitationOrderField {
  /** Order repository invitations by creation time */
  CreatedAt = 'CREATED_AT'
}

/** The possible reasons a given repository could be in a locked state. */
export enum RepositoryLockReason {
  /** The repository is locked due to a billing related reason. */
  Billing = 'BILLING',
  /** The repository is locked due to a migration. */
  Migrating = 'MIGRATING',
  /** The repository is locked due to a move. */
  Moving = 'MOVING',
  /** The repository is locked due to a rename. */
  Rename = 'RENAME',
  /** The repository is locked due to a trade controls related reason. */
  TradeRestriction = 'TRADE_RESTRICTION',
  /** The repository is locked due to an ownership transfer. */
  TransferringOwnership = 'TRANSFERRING_OWNERSHIP'
}

/** A GitHub Enterprise Importer (GEI) repository migration. */
export type RepositoryMigration = Migration & Node & {
  __typename?: 'RepositoryMigration';
  /** The migration flag to continue on error. */
  continueOnError: Scalars['Boolean']['output'];
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Identifies the primary key from the database. */
  databaseId?: Maybe<Scalars['String']['output']>;
  /** The reason the migration failed. */
  failureReason?: Maybe<Scalars['String']['output']>;
  /** The Node ID of the RepositoryMigration object */
  id: Scalars['ID']['output'];
  /** The URL for the migration log (expires 1 day after migration completes). */
  migrationLogUrl?: Maybe<Scalars['URI']['output']>;
  /** The migration source. */
  migrationSource: MigrationSource;
  /** The target repository name. */
  repositoryName: Scalars['String']['output'];
  /** The migration source URL, for example `https://github.com` or `https://monalisa.ghe.com`. */
  sourceUrl: Scalars['URI']['output'];
  /** The migration state. */
  state: MigrationState;
  /**
   * The number of warnings encountered for this migration. To review the warnings,
   * check the [Migration Log](https://docs.github.com/migrations/using-github-enterprise-importer/completing-your-migration-with-github-enterprise-importer/accessing-your-migration-logs-for-github-enterprise-importer).
   */
  warningsCount: Scalars['Int']['output'];
};

/** A list of migrations. */
export type RepositoryMigrationConnection = {
  __typename?: 'RepositoryMigrationConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RepositoryMigrationEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<RepositoryMigration>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** Represents a repository migration. */
export type RepositoryMigrationEdge = {
  __typename?: 'RepositoryMigrationEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<RepositoryMigration>;
};

/** Ordering options for repository migrations. */
export type RepositoryMigrationOrder = {
  /** The ordering direction. */
  direction: RepositoryMigrationOrderDirection;
  /** The field to order repository migrations by. */
  field: RepositoryMigrationOrderField;
};

/** Possible directions in which to order a list of repository migrations when provided an `orderBy` argument. */
export enum RepositoryMigrationOrderDirection {
  /** Specifies an ascending order for a given `orderBy` argument. */
  Asc = 'ASC',
  /** Specifies a descending order for a given `orderBy` argument. */
  Desc = 'DESC'
}

/** Properties by which repository migrations can be ordered. */
export enum RepositoryMigrationOrderField {
  /** Order mannequins why when they were created. */
  CreatedAt = 'CREATED_AT'
}

/** Parameters to be used for the repository_name condition */
export type RepositoryNameConditionTarget = {
  __typename?: 'RepositoryNameConditionTarget';
  /** Array of repository names or patterns to exclude. The condition will not pass if any of these patterns match. */
  exclude: Array<Scalars['String']['output']>;
  /**
   * Array of repository names or patterns to include. One of these patterns must
   * match for the condition to pass. Also accepts `~ALL` to include all repositories.
   */
  include: Array<Scalars['String']['output']>;
  /** Target changes that match these patterns will be prevented except by those with bypass permissions. */
  protected: Scalars['Boolean']['output'];
};

/** Parameters to be used for the repository_name condition */
export type RepositoryNameConditionTargetInput = {
  /** Array of repository names or patterns to exclude. The condition will not pass if any of these patterns match. */
  exclude: Array<Scalars['String']['input']>;
  /**
   * Array of repository names or patterns to include. One of these patterns must
   * match for the condition to pass. Also accepts `~ALL` to include all repositories.
   */
  include: Array<Scalars['String']['input']>;
  /** Target changes that match these patterns will be prevented except by those with bypass permissions. */
  protected?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Represents a object that belongs to a repository. */
export type RepositoryNode = {
  /** The repository associated with this node. */
  repository: Repository;
};

/** Ordering options for repository connections */
export type RepositoryOrder = {
  /** The ordering direction. */
  direction: OrderDirection;
  /** The field to order repositories by. */
  field: RepositoryOrderField;
};

/** Properties by which repository connections can be ordered. */
export enum RepositoryOrderField {
  /** Order repositories by creation time */
  CreatedAt = 'CREATED_AT',
  /** Order repositories by name */
  Name = 'NAME',
  /** Order repositories by push time */
  PushedAt = 'PUSHED_AT',
  /** Order repositories by number of stargazers */
  Stargazers = 'STARGAZERS',
  /** Order repositories by update time */
  UpdatedAt = 'UPDATED_AT'
}

/** Represents an owner of a Repository. */
export type RepositoryOwner = {
  /** A URL pointing to the owner's public avatar. */
  avatarUrl: Scalars['URI']['output'];
  /** The Node ID of the RepositoryOwner object */
  id: Scalars['ID']['output'];
  /** The username used to login. */
  login: Scalars['String']['output'];
  /** A list of repositories that the user owns. */
  repositories: RepositoryConnection;
  /** Find Repository. */
  repository?: Maybe<Repository>;
  /** The HTTP URL for the owner. */
  resourcePath: Scalars['URI']['output'];
  /** The HTTP URL for the owner. */
  url: Scalars['URI']['output'];
};


/** Represents an owner of a Repository. */
export type RepositoryOwnerAvatarUrlArgs = {
  size?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents an owner of a Repository. */
export type RepositoryOwnerRepositoriesArgs = {
  affiliations?: InputMaybe<Array<InputMaybe<RepositoryAffiliation>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasIssuesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isFork?: InputMaybe<Scalars['Boolean']['input']>;
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<RepositoryOrder>;
  ownerAffiliations?: InputMaybe<Array<InputMaybe<RepositoryAffiliation>>>;
  privacy?: InputMaybe<RepositoryPrivacy>;
  visibility?: InputMaybe<RepositoryVisibility>;
};


/** Represents an owner of a Repository. */
export type RepositoryOwnerRepositoryArgs = {
  followRenames?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};

/** The access level to a repository */
export enum RepositoryPermission {
  /**
   * Can read, clone, and push to this repository. Can also manage issues, pull
   * requests, and repository settings, including adding collaborators
   */
  Admin = 'ADMIN',
  /** Can read, clone, and push to this repository. They can also manage issues, pull requests, and some repository settings */
  Maintain = 'MAINTAIN',
  /** Can read and clone this repository. Can also open and comment on issues and pull requests */
  Read = 'READ',
  /** Can read and clone this repository. Can also manage issues and pull requests */
  Triage = 'TRIAGE',
  /** Can read and clone this repository. Can also manage issues and pull requests, plus additional triage abilities */
  TriagePlus = 'TRIAGE_PLUS',
  /** Can read, clone, and push to this repository. Can also manage issues and pull requests */
  Write = 'WRITE'
}

/** Information about the availability of features and limits for a repository based on its billing plan. */
export type RepositoryPlanFeatures = {
  __typename?: 'RepositoryPlanFeatures';
  /** Whether reviews can be automatically requested and enforced with a CODEOWNERS file */
  codeowners: Scalars['Boolean']['output'];
  /** Whether pull requests can be created as or converted to draft */
  draftPullRequests: Scalars['Boolean']['output'];
  /** Maximum number of users that can be assigned to an issue or pull request */
  maximumAssignees: Scalars['Int']['output'];
  /** Maximum number of manually-requested reviews on a pull request */
  maximumManualReviewRequests: Scalars['Int']['output'];
  /** Whether teams can be requested to review pull requests */
  teamReviewRequests: Scalars['Boolean']['output'];
};

/** The privacy of a repository */
export enum RepositoryPrivacy {
  /** Private */
  Private = 'PRIVATE',
  /** Public */
  Public = 'PUBLIC'
}

/** Parameters to be used for the repository_property condition */
export type RepositoryPropertyConditionTarget = {
  __typename?: 'RepositoryPropertyConditionTarget';
  /** Array of repository properties that must not match. */
  exclude: Array<PropertyTargetDefinition>;
  /** Array of repository properties that must match */
  include: Array<PropertyTargetDefinition>;
};

/** Parameters to be used for the repository_property condition */
export type RepositoryPropertyConditionTargetInput = {
  /** Array of repository properties that must not match. */
  exclude: Array<PropertyTargetDefinitionInput>;
  /** Array of repository properties that must match */
  include: Array<PropertyTargetDefinitionInput>;
};

/** A repository rule. */
export type RepositoryRule = Node & {
  __typename?: 'RepositoryRule';
  /** The Node ID of the RepositoryRule object */
  id: Scalars['ID']['output'];
  /** The parameters for this rule. */
  parameters?: Maybe<RuleParameters>;
  /** The repository ruleset associated with this rule configuration */
  repositoryRuleset?: Maybe<RepositoryRuleset>;
  /** The type of rule. */
  type: RepositoryRuleType;
};

/** Set of conditions that determine if a ruleset will evaluate */
export type RepositoryRuleConditions = {
  __typename?: 'RepositoryRuleConditions';
  /** Configuration for the organization_property condition */
  organizationProperty?: Maybe<OrganizationPropertyConditionTarget>;
  /** Configuration for the ref_name condition */
  refName?: Maybe<RefNameConditionTarget>;
  /** Configuration for the repository_id condition */
  repositoryId?: Maybe<RepositoryIdConditionTarget>;
  /** Configuration for the repository_name condition */
  repositoryName?: Maybe<RepositoryNameConditionTarget>;
  /** Configuration for the repository_property condition */
  repositoryProperty?: Maybe<RepositoryPropertyConditionTarget>;
};

/** Specifies the conditions required for a ruleset to evaluate */
export type RepositoryRuleConditionsInput = {
  /** Configuration for the organization_property condition */
  organizationProperty?: InputMaybe<OrganizationPropertyConditionTargetInput>;
  /** Configuration for the ref_name condition */
  refName?: InputMaybe<RefNameConditionTargetInput>;
  /** Configuration for the repository_id condition */
  repositoryId?: InputMaybe<RepositoryIdConditionTargetInput>;
  /** Configuration for the repository_name condition */
  repositoryName?: InputMaybe<RepositoryNameConditionTargetInput>;
  /** Configuration for the repository_property condition */
  repositoryProperty?: InputMaybe<RepositoryPropertyConditionTargetInput>;
};

/** The connection type for RepositoryRule. */
export type RepositoryRuleConnection = {
  __typename?: 'RepositoryRuleConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RepositoryRuleEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<RepositoryRule>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type RepositoryRuleEdge = {
  __typename?: 'RepositoryRuleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<RepositoryRule>;
};

/** Specifies the attributes for a new or updated rule. */
export type RepositoryRuleInput = {
  /** Optional ID of this rule when updating */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** The parameters for the rule. */
  parameters?: InputMaybe<RuleParametersInput>;
  /** The type of rule to create. */
  type: RepositoryRuleType;
};

/** Ordering options for repository rules. */
export type RepositoryRuleOrder = {
  /** The ordering direction. */
  direction: OrderDirection;
  /** The field to order repository rules by. */
  field: RepositoryRuleOrderField;
};

/** Properties by which repository rule connections can be ordered. */
export enum RepositoryRuleOrderField {
  /** Order repository rules by created time */
  CreatedAt = 'CREATED_AT',
  /** Order repository rules by type */
  Type = 'TYPE',
  /** Order repository rules by updated time */
  UpdatedAt = 'UPDATED_AT'
}

/** The rule types supported in rulesets */
export enum RepositoryRuleType {
  /** Authorization */
  Authorization = 'AUTHORIZATION',
  /** Branch name pattern */
  BranchNamePattern = 'BRANCH_NAME_PATTERN',
  /**
   * Enforce minimum line coverage thresholds on pull requests. This rule evaluates
   * uploaded coverage data but does not wait for coverage uploads. To ensure
   * coverage is evaluated before merging, make each status check associated with a
   * coverage upload a required status check.
   */
  CodeCoverage = 'CODE_COVERAGE',
  /**
   * Choose which severity levels of code quality results should block pull request
   * merges. When configured, a code quality analysis must be done on the pull
   * request before the changes can be merged.
   */
  CodeQuality = 'CODE_QUALITY',
  /**
   * Choose which tools must provide code scanning results before the reference is
   * updated. When configured, code scanning must be enabled and have results for
   * both the commit and the reference being updated.
   */
  CodeScanning = 'CODE_SCANNING',
  /** Committer email pattern */
  CommitterEmailPattern = 'COMMITTER_EMAIL_PATTERN',
  /** Commit author email pattern */
  CommitAuthorEmailPattern = 'COMMIT_AUTHOR_EMAIL_PATTERN',
  /** Commit message pattern */
  CommitMessagePattern = 'COMMIT_MESSAGE_PATTERN',
  /**
   * Request Copilot code review for new pull requests automatically if the author
   * has access to Copilot code review and AI credits.
   */
  CopilotCodeReview = 'COPILOT_CODE_REVIEW',
  /** Only allow users with bypass permission to create matching refs. */
  Creation = 'CREATION',
  /** Only allow users with bypass permissions to delete matching refs. */
  Deletion = 'DELETION',
  /** Prevent commits that include files with specified file extensions from being pushed to the commit graph. */
  FileExtensionRestriction = 'FILE_EXTENSION_RESTRICTION',
  /**
   * Prevent commits that include changes in specified file and folder paths from
   * being pushed to the commit graph. This includes absolute paths that contain file names.
   */
  FilePathRestriction = 'FILE_PATH_RESTRICTION',
  /** Enforce any added or changed dependencies to comply with the organization's license policy. */
  LicenseComplianceScanning = 'LICENSE_COMPLIANCE_SCANNING',
  /** Branch is read-only. Users cannot push to the branch. */
  LockBranch = 'LOCK_BRANCH',
  /** Prevent commits that include file paths that exceed the specified character limit from being pushed to the commit graph. */
  MaxFilePathLength = 'MAX_FILE_PATH_LENGTH',
  /** Prevent commits with individual files that exceed the specified limit from being pushed to the commit graph. */
  MaxFileSize = 'MAX_FILE_SIZE',
  /** Max ref updates */
  MaxRefUpdates = 'MAX_REF_UPDATES',
  /** Merges must be performed via a merge queue. */
  MergeQueue = 'MERGE_QUEUE',
  /** Merge queue locked ref */
  MergeQueueLockedRef = 'MERGE_QUEUE_LOCKED_REF',
  /** Prevent users with push access from force pushing to refs. */
  NonFastForward = 'NON_FAST_FORWARD',
  /** Require all commits be made to a non-target branch and submitted via a pull request before they can be merged. */
  PullRequest = 'PULL_REQUEST',
  /** Choose which environments must be successfully deployed to before refs can be pushed into a ref that matches this rule. */
  RequiredDeployments = 'REQUIRED_DEPLOYMENTS',
  /** Prevent merge commits from being pushed to matching refs. */
  RequiredLinearHistory = 'REQUIRED_LINEAR_HISTORY',
  /**
   * When enabled, all conversations on code must be resolved before a pull request
   * can be merged into a branch that matches this rule.
   */
  RequiredReviewThreadResolution = 'REQUIRED_REVIEW_THREAD_RESOLUTION',
  /** Commits pushed to matching refs must have verified signatures. */
  RequiredSignatures = 'REQUIRED_SIGNATURES',
  /**
   * Choose which status checks must pass before the ref is updated. When enabled,
   * commits must first be pushed to another ref where the checks pass.
   */
  RequiredStatusChecks = 'REQUIRED_STATUS_CHECKS',
  /**
   * Require all commits be made to a non-target branch and submitted via a pull
   * request and required workflow checks to pass before they can be merged.
   */
  RequiredWorkflowStatusChecks = 'REQUIRED_WORKFLOW_STATUS_CHECKS',
  /** Secret scanning */
  SecretScanning = 'SECRET_SCANNING',
  /** Tag */
  Tag = 'TAG',
  /** Tag name pattern */
  TagNamePattern = 'TAG_NAME_PATTERN',
  /** Only allow users with bypass permission to update matching refs. */
  Update = 'UPDATE',
  /** Require all changes made to a targeted branch to pass the specified workflows before they can be merged. */
  Workflows = 'WORKFLOWS',
  /** Workflow files cannot be modified. */
  WorkflowUpdates = 'WORKFLOW_UPDATES'
}

/** A repository ruleset. */
export type RepositoryRuleset = Node & {
  __typename?: 'RepositoryRuleset';
  /** The actors that can bypass this ruleset */
  bypassActors?: Maybe<RepositoryRulesetBypassActorConnection>;
  /** The set of conditions that must evaluate to true for this ruleset to apply */
  conditions: RepositoryRuleConditions;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Identifies the primary key from the database. */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** The enforcement level of this ruleset */
  enforcement: RuleEnforcement;
  /** The Node ID of the RepositoryRuleset object */
  id: Scalars['ID']['output'];
  /** Name of the ruleset. */
  name: Scalars['String']['output'];
  /** List of rules. */
  rules?: Maybe<RepositoryRuleConnection>;
  /** Source of ruleset. */
  source: RuleSource;
  /** Target of the ruleset. */
  target?: Maybe<RepositoryRulesetTarget>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};


/** A repository ruleset. */
export type RepositoryRulesetBypassActorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A repository ruleset. */
export type RepositoryRulesetRulesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<RepositoryRuleType>;
};

/** A team, app or user that has the ability to bypass rules defined on a ruleset */
export type RepositoryRulesetBypassActor = Node & {
  __typename?: 'RepositoryRulesetBypassActor';
  /** The actor that can bypass rules. */
  actor?: Maybe<BypassActor>;
  /** The mode for the bypass actor */
  bypassMode?: Maybe<RepositoryRulesetBypassActorBypassMode>;
  /** This actor represents the ability for a deploy key to bypass */
  deployKey: Scalars['Boolean']['output'];
  /** This actor represents the ability for an enterprise owner to bypass */
  enterpriseOwner: Scalars['Boolean']['output'];
  /** This actor represents the ability for an enterprise role to bypass */
  enterpriseRole: Scalars['Boolean']['output'];
  /** If the actor is an enterprise role, the enterprise role's ID that can bypass */
  enterpriseRoleDatabaseId?: Maybe<Scalars['BigInt']['output']>;
  /** The Node ID of the RepositoryRulesetBypassActor object */
  id: Scalars['ID']['output'];
  /** This actor represents the ability for an organization owner to bypass */
  organizationAdmin: Scalars['Boolean']['output'];
  /** If the actor is a repository role, the repository role's ID that can bypass */
  repositoryRoleDatabaseId?: Maybe<Scalars['Int']['output']>;
  /** If the actor is a repository role, the repository role's name that can bypass */
  repositoryRoleName?: Maybe<Scalars['String']['output']>;
  /** Identifies the ruleset associated with the allowed actor */
  repositoryRuleset?: Maybe<RepositoryRuleset>;
};

/** The bypass mode for a specific actor on a ruleset. */
export enum RepositoryRulesetBypassActorBypassMode {
  /** The actor can always bypass rules */
  Always = 'ALWAYS',
  /** The actor is exempt from rules without generating a pass / fail result */
  Exempt = 'EXEMPT',
  /** The actor can only bypass rules via a pull request */
  PullRequest = 'PULL_REQUEST'
}

/** The connection type for RepositoryRulesetBypassActor. */
export type RepositoryRulesetBypassActorConnection = {
  __typename?: 'RepositoryRulesetBypassActorConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RepositoryRulesetBypassActorEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<RepositoryRulesetBypassActor>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type RepositoryRulesetBypassActorEdge = {
  __typename?: 'RepositoryRulesetBypassActorEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<RepositoryRulesetBypassActor>;
};

/**
 * Specifies the attributes for a new or updated ruleset bypass actor. Exactly one
 * of `actor_id`, `repository_role_database_id`, `organization_admin`,
 * `enterprise_owner`, `enterprise_role_database_id`, or `deploy_key` should be specified.
 */
export type RepositoryRulesetBypassActorInput = {
  /** For Team, Integration and User bypasses, the Team, Integration, or User ID */
  actorId?: InputMaybe<Scalars['ID']['input']>;
  /** The bypass mode for this actor. */
  bypassMode: RepositoryRulesetBypassActorBypassMode;
  /** For deploy key bypasses, true. Can only use ALWAYS as the bypass mode */
  deployKey?: InputMaybe<Scalars['Boolean']['input']>;
  /** For enterprise owner bypasses, true */
  enterpriseOwner?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * For enterprise role bypasses, true. NOTE: This bypass actor is in beta.
   * @deprecated Use enterpriseRoleDatabaseId.
   */
  enterpriseRole?: InputMaybe<Scalars['Boolean']['input']>;
  /** For enterprise role bypasses, the enterprise role database ID. NOTE: This bypass actor is in beta. */
  enterpriseRoleDatabaseId?: InputMaybe<Scalars['BigInt']['input']>;
  /** For organization owner bypasses, true */
  organizationAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  /** For role bypasses, the role database ID */
  repositoryRoleDatabaseId?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for RepositoryRuleset. */
export type RepositoryRulesetConnection = {
  __typename?: 'RepositoryRulesetConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RepositoryRulesetEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<RepositoryRuleset>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type RepositoryRulesetEdge = {
  __typename?: 'RepositoryRulesetEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<RepositoryRuleset>;
};

/** The targets supported for rulesets. */
export enum RepositoryRulesetTarget {
  /** Branch */
  Branch = 'BRANCH',
  /** Push */
  Push = 'PUSH',
  /** repository */
  Repository = 'REPOSITORY',
  /** Tag */
  Tag = 'TAG'
}

/** The possible filters for suggested actors in a repository */
export enum RepositorySuggestedActorFilter {
  /** Actors that can be assigned to issues and pull requests */
  CanBeAssigned = 'CAN_BE_ASSIGNED',
  /** Actors that can be the author of issues and pull requests */
  CanBeAuthor = 'CAN_BE_AUTHOR'
}

/** A repository-topic connects a repository to a topic. */
export type RepositoryTopic = Node & UniformResourceLocatable & {
  __typename?: 'RepositoryTopic';
  /** The Node ID of the RepositoryTopic object */
  id: Scalars['ID']['output'];
  /** The HTTP path for this repository-topic. */
  resourcePath: Scalars['URI']['output'];
  /** The topic. */
  topic: Topic;
  /** The HTTP URL for this repository-topic. */
  url: Scalars['URI']['output'];
};

/** The connection type for RepositoryTopic. */
export type RepositoryTopicConnection = {
  __typename?: 'RepositoryTopicConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RepositoryTopicEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<RepositoryTopic>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type RepositoryTopicEdge = {
  __typename?: 'RepositoryTopicEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<RepositoryTopic>;
};

/** The repository's visibility level. */
export enum RepositoryVisibility {
  /** The repository is visible only to users in the same enterprise. */
  Internal = 'INTERNAL',
  /** The repository is visible only to those with explicit access. */
  Private = 'PRIVATE',
  /** The repository is visible to everyone. */
  Public = 'PUBLIC'
}

/** Audit log entry for a repository_visibility_change.disable event. */
export type RepositoryVisibilityChangeDisableAuditEntry = AuditEntry & EnterpriseAuditEntryData & Node & OrganizationAuditEntryData & {
  __typename?: 'RepositoryVisibilityChangeDisableAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /** The HTTP path for this enterprise. */
  enterpriseResourcePath?: Maybe<Scalars['URI']['output']>;
  /** The slug of the enterprise. */
  enterpriseSlug?: Maybe<Scalars['String']['output']>;
  /** The HTTP URL for this enterprise. */
  enterpriseUrl?: Maybe<Scalars['URI']['output']>;
  /** The Node ID of the RepositoryVisibilityChangeDisableAuditEntry object */
  id: Scalars['ID']['output'];
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
};

/** Audit log entry for a repository_visibility_change.enable event. */
export type RepositoryVisibilityChangeEnableAuditEntry = AuditEntry & EnterpriseAuditEntryData & Node & OrganizationAuditEntryData & {
  __typename?: 'RepositoryVisibilityChangeEnableAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /** The HTTP path for this enterprise. */
  enterpriseResourcePath?: Maybe<Scalars['URI']['output']>;
  /** The slug of the enterprise. */
  enterpriseSlug?: Maybe<Scalars['String']['output']>;
  /** The HTTP URL for this enterprise. */
  enterpriseUrl?: Maybe<Scalars['URI']['output']>;
  /** The Node ID of the RepositoryVisibilityChangeEnableAuditEntry object */
  id: Scalars['ID']['output'];
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
};

/** A Dependabot alert for a repository with a dependency affected by a security vulnerability. */
export type RepositoryVulnerabilityAlert = Node & RepositoryNode & {
  __typename?: 'RepositoryVulnerabilityAlert';
  /** When was the alert auto-dismissed? */
  autoDismissedAt?: Maybe<Scalars['DateTime']['output']>;
  /** When was the alert created? */
  createdAt: Scalars['DateTime']['output'];
  /** The associated Dependabot update */
  dependabotUpdate?: Maybe<DependabotUpdate>;
  /** The relationship of an alert's dependency. */
  dependencyRelationship?: Maybe<RepositoryVulnerabilityAlertDependencyRelationship>;
  /** The scope of an alert's dependency */
  dependencyScope?: Maybe<RepositoryVulnerabilityAlertDependencyScope>;
  /** Comment explaining the reason the alert was dismissed */
  dismissComment?: Maybe<Scalars['String']['output']>;
  /** The reason the alert was dismissed */
  dismissReason?: Maybe<Scalars['String']['output']>;
  /** When was the alert dismissed? */
  dismissedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The user who dismissed the alert */
  dismisser?: Maybe<User>;
  /** When was the alert fixed? */
  fixedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The Node ID of the RepositoryVulnerabilityAlert object */
  id: Scalars['ID']['output'];
  /** Identifies the alert number. */
  number: Scalars['Int']['output'];
  /** The associated repository */
  repository: Repository;
  /** The associated security advisory */
  securityAdvisory?: Maybe<SecurityAdvisory>;
  /** The associated security vulnerability */
  securityVulnerability?: Maybe<SecurityVulnerability>;
  /** Identifies the state of the alert. */
  state: RepositoryVulnerabilityAlertState;
  /** The vulnerable manifest filename */
  vulnerableManifestFilename: Scalars['String']['output'];
  /** The vulnerable manifest path */
  vulnerableManifestPath: Scalars['String']['output'];
  /** The vulnerable requirements */
  vulnerableRequirements?: Maybe<Scalars['String']['output']>;
};

/** The connection type for RepositoryVulnerabilityAlert. */
export type RepositoryVulnerabilityAlertConnection = {
  __typename?: 'RepositoryVulnerabilityAlertConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RepositoryVulnerabilityAlertEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<RepositoryVulnerabilityAlert>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** The possible relationships of an alert's dependency. */
export enum RepositoryVulnerabilityAlertDependencyRelationship {
  /** A direct dependency of your project */
  Direct = 'DIRECT',
  /** The relationship could not be determined */
  Inconclusive = 'INCONCLUSIVE',
  /** A transitive dependency of your project */
  Transitive = 'TRANSITIVE',
  /** The relationship is unknown */
  Unknown = 'UNKNOWN'
}

/** The possible scopes of an alert's dependency. */
export enum RepositoryVulnerabilityAlertDependencyScope {
  /** A dependency that is only used in development */
  Development = 'DEVELOPMENT',
  /** A dependency that is leveraged during application runtime */
  Runtime = 'RUNTIME'
}

/** An edge in a connection. */
export type RepositoryVulnerabilityAlertEdge = {
  __typename?: 'RepositoryVulnerabilityAlertEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<RepositoryVulnerabilityAlert>;
};

/** The possible states of an alert */
export enum RepositoryVulnerabilityAlertState {
  /** An alert that has been automatically closed by Dependabot. */
  AutoDismissed = 'AUTO_DISMISSED',
  /** An alert that has been manually closed by a user. */
  Dismissed = 'DISMISSED',
  /** An alert that has been resolved by a code change. */
  Fixed = 'FIXED',
  /** An alert that is still open. */
  Open = 'OPEN'
}

/** Autogenerated input type of ReprioritizeSubIssue */
export type ReprioritizeSubIssueInput = {
  /** The id of the sub-issue to be prioritized after (either positional argument after OR before should be specified). */
  afterId?: InputMaybe<Scalars['ID']['input']>;
  /** The id of the sub-issue to be prioritized before (either positional argument after OR before should be specified). */
  beforeId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the parent issue. */
  issueId: Scalars['ID']['input'];
  /** The id of the sub-issue to reprioritize. */
  subIssueId: Scalars['ID']['input'];
};

/** Autogenerated return type of ReprioritizeSubIssue. */
export type ReprioritizeSubIssuePayload = {
  __typename?: 'ReprioritizeSubIssuePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The parent issue that the sub-issue was reprioritized in. */
  issue?: Maybe<Issue>;
};

/** Autogenerated input type of RequestReviewsByLogin */
export type RequestReviewsByLoginInput = {
  /** The logins of the bots to request reviews from, including the [bot] suffix (e.g., 'copilot-pull-request-reviewer[bot]'). */
  botLogins?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Node ID of the pull request to modify. */
  pullRequestId: Scalars['ID']['input'];
  /** The slugs of the teams to request reviews from (format: 'org/team-slug'). */
  teamSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Add users to the set rather than replace. */
  union?: InputMaybe<Scalars['Boolean']['input']>;
  /** The login strings of the users to request reviews from. */
  userLogins?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Autogenerated return type of RequestReviewsByLogin. */
export type RequestReviewsByLoginPayload = {
  __typename?: 'RequestReviewsByLoginPayload';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The pull request that is getting requests. */
  pullRequest?: Maybe<PullRequest>;
  /** The edge from the pull request to the requested reviewers. */
  requestedReviewersEdge?: Maybe<UserEdge>;
};

/** Autogenerated input type of RequestReviews */
export type RequestReviewsInput = {
  /** The Node IDs of the bot to request. */
  botIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Node ID of the pull request to modify. */
  pullRequestId: Scalars['ID']['input'];
  /** The Node IDs of the team to request. */
  teamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Add users to the set rather than replace. */
  union?: InputMaybe<Scalars['Boolean']['input']>;
  /** The Node IDs of the user to request. */
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Autogenerated return type of RequestReviews. */
export type RequestReviewsPayload = {
  __typename?: 'RequestReviewsPayload';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The pull request that is getting requests. */
  pullRequest?: Maybe<PullRequest>;
  /** The edge from the pull request to the requested reviewers. */
  requestedReviewersEdge?: Maybe<UserEdge>;
};

/** The possible states that can be requested when creating a check run. */
export enum RequestableCheckStatusState {
  /** The check suite or run has been completed. */
  Completed = 'COMPLETED',
  /** The check suite or run is in progress. */
  InProgress = 'IN_PROGRESS',
  /** The check suite or run is in pending state. */
  Pending = 'PENDING',
  /** The check suite or run has been queued. */
  Queued = 'QUEUED',
  /** The check suite or run is in waiting state. */
  Waiting = 'WAITING'
}

/** Types that can be requested reviewers. */
export type RequestedReviewer = Bot | EnterpriseTeam | Mannequin | Team | User;

/** The connection type for RequestedReviewer. */
export type RequestedReviewerConnection = {
  __typename?: 'RequestedReviewerConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<RequestedReviewerEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<RequestedReviewer>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type RequestedReviewerEdge = {
  __typename?: 'RequestedReviewerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<RequestedReviewer>;
};

/** Represents a type that can be required by a pull request for merging. */
export type RequirableByPullRequest = {
  /** Whether this is required to pass before merging for a specific pull request. */
  isRequired: Scalars['Boolean']['output'];
};


/** Represents a type that can be required by a pull request for merging. */
export type RequirableByPullRequestIsRequiredArgs = {
  pullRequestId?: InputMaybe<Scalars['ID']['input']>;
  pullRequestNumber?: InputMaybe<Scalars['Int']['input']>;
};

/** Choose which environments must be successfully deployed to before refs can be pushed into a ref that matches this rule. */
export type RequiredDeploymentsParameters = {
  __typename?: 'RequiredDeploymentsParameters';
  /** The environments that must be successfully deployed to before branches can be merged. */
  requiredDeploymentEnvironments: Array<Scalars['String']['output']>;
};

/** Choose which environments must be successfully deployed to before refs can be pushed into a ref that matches this rule. */
export type RequiredDeploymentsParametersInput = {
  /** The environments that must be successfully deployed to before branches can be merged. */
  requiredDeploymentEnvironments: Array<Scalars['String']['input']>;
};

/** A reviewing team, and file patterns describing which files they must approve changes to. */
export type RequiredReviewerConfiguration = {
  __typename?: 'RequiredReviewerConfiguration';
  /**
   * Array of file patterns. Pull requests which change matching files must be
   * approved by the specified team. File patterns use fnmatch syntax.
   */
  filePatterns: Array<Scalars['String']['output']>;
  /**
   * Minimum number of approvals required from the specified team. If set to zero,
   * the team will be added to the pull request but approval is optional.
   */
  minimumApprovals: Scalars['Int']['output'];
  /** Node ID of the team which must review changes to matching files. */
  reviewerId: Scalars['ID']['output'];
};

/** A reviewing team, and file patterns describing which files they must approve changes to. */
export type RequiredReviewerConfigurationInput = {
  /**
   * Array of file patterns. Pull requests which change matching files must be
   * approved by the specified team. File patterns use fnmatch syntax.
   */
  filePatterns: Array<Scalars['String']['input']>;
  /**
   * Minimum number of approvals required from the specified team. If set to zero,
   * the team will be added to the pull request but approval is optional.
   */
  minimumApprovals: Scalars['Int']['input'];
  /** Node ID of the team which must review changes to matching files. */
  reviewerId: Scalars['ID']['input'];
};

/** Represents a required status check for a protected branch, but not any specific run of that check. */
export type RequiredStatusCheckDescription = {
  __typename?: 'RequiredStatusCheckDescription';
  /** The App that must provide this status in order for it to be accepted. */
  app?: Maybe<App>;
  /** The name of this status. */
  context: Scalars['String']['output'];
};

/** Specifies the attributes for a new or updated required status check. */
export type RequiredStatusCheckInput = {
  /**
   * The ID of the App that must set the status in order for it to be accepted.
   * Omit this value to use whichever app has recently been setting this status, or
   * use "any" to allow any app to set the status.
   */
  appId?: InputMaybe<Scalars['ID']['input']>;
  /** Status check context that must pass for commits to be accepted to the matching branch. */
  context: Scalars['String']['input'];
};

/**
 * Choose which status checks must pass before the ref is updated. When enabled,
 * commits must first be pushed to another ref where the checks pass.
 */
export type RequiredStatusChecksParameters = {
  __typename?: 'RequiredStatusChecksParameters';
  /** Allow repositories and branches to be created if a check would otherwise prohibit it. */
  doNotEnforceOnCreate: Scalars['Boolean']['output'];
  /** Status checks that are required. */
  requiredStatusChecks: Array<StatusCheckConfiguration>;
  /**
   * Whether pull requests targeting a matching branch must be tested with the
   * latest code. This setting will not take effect unless at least one status
   * check is enabled.
   */
  strictRequiredStatusChecksPolicy: Scalars['Boolean']['output'];
};

/**
 * Choose which status checks must pass before the ref is updated. When enabled,
 * commits must first be pushed to another ref where the checks pass.
 */
export type RequiredStatusChecksParametersInput = {
  /** Allow repositories and branches to be created if a check would otherwise prohibit it. */
  doNotEnforceOnCreate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Status checks that are required. */
  requiredStatusChecks: Array<StatusCheckConfigurationInput>;
  /**
   * Whether pull requests targeting a matching branch must be tested with the
   * latest code. This setting will not take effect unless at least one status
   * check is enabled.
   */
  strictRequiredStatusChecksPolicy: Scalars['Boolean']['input'];
};

/** Autogenerated input type of RerequestCheckSuite */
export type RerequestCheckSuiteInput = {
  /** The Node ID of the check suite. */
  checkSuiteId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Node ID of the repository. */
  repositoryId: Scalars['ID']['input'];
};

/** Autogenerated return type of RerequestCheckSuite. */
export type RerequestCheckSuitePayload = {
  __typename?: 'RerequestCheckSuitePayload';
  /** The requested check suite. */
  checkSuite?: Maybe<CheckSuite>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of RerequestReviews */
export type RerequestReviewsInput = {
  /** The Node IDs of the bots to rerequest. */
  botIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Node ID of the pull request to modify. */
  pullRequestId: Scalars['ID']['input'];
  /** The Node IDs of the teams to rerequest. */
  teamIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The Node IDs of the users to rerequest. */
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Autogenerated return type of RerequestReviews. */
export type RerequestReviewsPayload = {
  __typename?: 'RerequestReviewsPayload';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The pull request that is getting requests. */
  pullRequest?: Maybe<PullRequest>;
  /** The edge from the pull request to the requested reviewers. */
  requestedReviewersEdge?: Maybe<UserEdge>;
};

/** Autogenerated input type of ResolveReviewThread */
export type ResolveReviewThreadInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The reason a Copilot code review thread was resolved. */
  resolutionReason?: InputMaybe<PullRequestReviewThreadResolutionReason>;
  /** The ID of the thread to resolve */
  threadId: Scalars['ID']['input'];
};

/** Autogenerated return type of ResolveReviewThread. */
export type ResolveReviewThreadPayload = {
  __typename?: 'ResolveReviewThreadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The thread to resolve. */
  thread?: Maybe<PullRequestReviewThread>;
};

/** Represents a private contribution a user made on GitHub. */
export type RestrictedContribution = Contribution & {
  __typename?: 'RestrictedContribution';
  /**
   * Whether this contribution is associated with a record you do not have access to. For
   * example, your own 'first issue' contribution may have been made on a repository you can no
   * longer access.
   */
  isRestricted: Scalars['Boolean']['output'];
  /** When this contribution was made. */
  occurredAt: Scalars['DateTime']['output'];
  /** The HTTP path for this contribution. */
  resourcePath: Scalars['URI']['output'];
  /** The HTTP URL for this contribution. */
  url: Scalars['URI']['output'];
  /** The user who made this contribution. */
  user: User;
};

/** Autogenerated input type of RetireSponsorsTier */
export type RetireSponsorsTierInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the published tier to retire. */
  tierId: Scalars['ID']['input'];
};

/** Autogenerated return type of RetireSponsorsTier. */
export type RetireSponsorsTierPayload = {
  __typename?: 'RetireSponsorsTierPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The tier that was retired. */
  sponsorsTier?: Maybe<SponsorsTier>;
};

/** Autogenerated input type of RevertPullRequest */
export type RevertPullRequestInput = {
  /** The description of the revert pull request. */
  body?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Indicates whether the revert pull request should be a draft. */
  draft?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the pull request to revert. */
  pullRequestId: Scalars['ID']['input'];
  /** The title of the revert pull request. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of RevertPullRequest. */
export type RevertPullRequestPayload = {
  __typename?: 'RevertPullRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The pull request that was reverted. */
  pullRequest?: Maybe<PullRequest>;
  /** The new pull request that reverts the input pull request. */
  revertPullRequest?: Maybe<PullRequest>;
};

/** A user, team, or app who has the ability to dismiss a review on a protected branch. */
export type ReviewDismissalAllowance = Node & {
  __typename?: 'ReviewDismissalAllowance';
  /** The actor that can dismiss. */
  actor?: Maybe<ReviewDismissalAllowanceActor>;
  /** Identifies the branch protection rule associated with the allowed user, team, or app. */
  branchProtectionRule?: Maybe<BranchProtectionRule>;
  /** The Node ID of the ReviewDismissalAllowance object */
  id: Scalars['ID']['output'];
};

/** Types that can be an actor. */
export type ReviewDismissalAllowanceActor = App | Team | User;

/** The connection type for ReviewDismissalAllowance. */
export type ReviewDismissalAllowanceConnection = {
  __typename?: 'ReviewDismissalAllowanceConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ReviewDismissalAllowanceEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ReviewDismissalAllowance>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ReviewDismissalAllowanceEdge = {
  __typename?: 'ReviewDismissalAllowanceEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ReviewDismissalAllowance>;
};

/** Represents a 'review_dismissed' event on a given issue or pull request. */
export type ReviewDismissedEvent = Node & UniformResourceLocatable & {
  __typename?: 'ReviewDismissedEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Identifies the primary key from the database. */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** Identifies the optional message associated with the 'review_dismissed' event. */
  dismissalMessage?: Maybe<Scalars['String']['output']>;
  /** Identifies the optional message associated with the event, rendered to HTML. */
  dismissalMessageHTML?: Maybe<Scalars['String']['output']>;
  /** The Node ID of the ReviewDismissedEvent object */
  id: Scalars['ID']['output'];
  /** Identifies the previous state of the review with the 'review_dismissed' event. */
  previousReviewState: PullRequestReviewState;
  /** PullRequest referenced by event. */
  pullRequest: PullRequest;
  /** Identifies the commit which caused the review to become stale. */
  pullRequestCommit?: Maybe<PullRequestCommit>;
  /** The HTTP path for this review dismissed event. */
  resourcePath: Scalars['URI']['output'];
  /** Identifies the review associated with the 'review_dismissed' event. */
  review?: Maybe<PullRequestReview>;
  /** The HTTP URL for this review dismissed event. */
  url: Scalars['URI']['output'];
};

/** A request for a user to review a pull request. */
export type ReviewRequest = Node & {
  __typename?: 'ReviewRequest';
  /** Whether this request was created for a code owner */
  asCodeOwner: Scalars['Boolean']['output'];
  /** Identifies the primary key from the database. */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** The Node ID of the ReviewRequest object */
  id: Scalars['ID']['output'];
  /** Identifies the pull request associated with this review request. */
  pullRequest: PullRequest;
  /** The reviewer that is requested. */
  requestedReviewer?: Maybe<RequestedReviewer>;
};

/** The connection type for ReviewRequest. */
export type ReviewRequestConnection = {
  __typename?: 'ReviewRequestConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<ReviewRequestEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<ReviewRequest>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type ReviewRequestEdge = {
  __typename?: 'ReviewRequestEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<ReviewRequest>;
};

/** Represents an 'review_request_removed' event on a given pull request. */
export type ReviewRequestRemovedEvent = Node & {
  __typename?: 'ReviewRequestRemovedEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The Node ID of the ReviewRequestRemovedEvent object */
  id: Scalars['ID']['output'];
  /** PullRequest referenced by event. */
  pullRequest: PullRequest;
  /** Identifies the reviewer whose review request was removed. */
  requestedReviewer?: Maybe<RequestedReviewer>;
};

/** Represents an 'review_requested' event on a given pull request. */
export type ReviewRequestedEvent = Node & {
  __typename?: 'ReviewRequestedEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The Node ID of the ReviewRequestedEvent object */
  id: Scalars['ID']['output'];
  /** PullRequest referenced by event. */
  pullRequest: PullRequest;
  /** Identifies the reviewer whose review was requested. */
  requestedReviewer?: Maybe<RequestedReviewer>;
};

/**
 * A hovercard context with a message describing the current code review state of the pull
 * request.
 */
export type ReviewStatusHovercardContext = HovercardContext & {
  __typename?: 'ReviewStatusHovercardContext';
  /** A string describing this context */
  message: Scalars['String']['output'];
  /** An octicon to accompany this context */
  octicon: Scalars['String']['output'];
  /** The current status of the pull request with respect to code review. */
  reviewDecision?: Maybe<PullRequestReviewDecision>;
};

/** Autogenerated input type of RevokeEnterpriseOrganizationsMigratorRole */
export type RevokeEnterpriseOrganizationsMigratorRoleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the enterprise to which all organizations managed by it will be granted the migrator role. */
  enterpriseId: Scalars['ID']['input'];
  /** The login of the user to revoke the migrator role */
  login: Scalars['String']['input'];
};

/** Autogenerated return type of RevokeEnterpriseOrganizationsMigratorRole. */
export type RevokeEnterpriseOrganizationsMigratorRolePayload = {
  __typename?: 'RevokeEnterpriseOrganizationsMigratorRolePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The organizations that had the migrator role revoked for the given user. */
  organizations?: Maybe<OrganizationConnection>;
};


/** Autogenerated return type of RevokeEnterpriseOrganizationsMigratorRole. */
export type RevokeEnterpriseOrganizationsMigratorRolePayloadOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of RevokeMigratorRole */
export type RevokeMigratorRoleInput = {
  /** The user login or Team slug to revoke the migrator role from. */
  actor: Scalars['String']['input'];
  /** Specifies the type of the actor, can be either USER or TEAM. */
  actorType: ActorType;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the organization that the user/team belongs to. */
  organizationId: Scalars['ID']['input'];
};

/** Autogenerated return type of RevokeMigratorRole. */
export type RevokeMigratorRolePayload = {
  __typename?: 'RevokeMigratorRolePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Did the operation succeed? */
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Possible roles a user may have in relation to an organization. */
export enum RoleInOrganization {
  /** A user who is a direct member of the organization. */
  DirectMember = 'DIRECT_MEMBER',
  /** A user with full administrative access to the organization. */
  Owner = 'OWNER',
  /** A user who is unaffiliated with the organization. */
  Unaffiliated = 'UNAFFILIATED'
}

/** The level of enforcement for a rule or ruleset. */
export enum RuleEnforcement {
  /** Rules will be enforced */
  Active = 'ACTIVE',
  /** Do not evaluate or enforce rules */
  Disabled = 'DISABLED',
  /**
   * Allow admins to test rules before enforcing them. Admins can view insights on
   * the Rule Insights page (`evaluate` is only available with GitHub Enterprise).
   */
  Evaluate = 'EVALUATE'
}

/** Types which can be parameters for `RepositoryRule` objects. */
export type RuleParameters = BranchNamePatternParameters | CodeCoverageParameters | CodeQualityParameters | CodeScanningParameters | CommitAuthorEmailPatternParameters | CommitMessagePatternParameters | CommitterEmailPatternParameters | CopilotCodeReviewParameters | FileExtensionRestrictionParameters | FilePathRestrictionParameters | MaxFilePathLengthParameters | MaxFileSizeParameters | MergeQueueParameters | PullRequestParameters | RequiredDeploymentsParameters | RequiredStatusChecksParameters | TagNamePatternParameters | UpdateParameters | WorkflowsParameters;

/** Specifies the parameters for a `RepositoryRule` object. Only one of the fields should be specified. */
export type RuleParametersInput = {
  /** Parameters used for the `branch_name_pattern` rule type */
  branchNamePattern?: InputMaybe<BranchNamePatternParametersInput>;
  /** Parameters used for the `code_coverage` rule type */
  codeCoverage?: InputMaybe<CodeCoverageParametersInput>;
  /** Parameters used for the `code_quality` rule type */
  codeQuality?: InputMaybe<CodeQualityParametersInput>;
  /** Parameters used for the `code_scanning` rule type */
  codeScanning?: InputMaybe<CodeScanningParametersInput>;
  /** Parameters used for the `commit_author_email_pattern` rule type */
  commitAuthorEmailPattern?: InputMaybe<CommitAuthorEmailPatternParametersInput>;
  /** Parameters used for the `commit_message_pattern` rule type */
  commitMessagePattern?: InputMaybe<CommitMessagePatternParametersInput>;
  /** Parameters used for the `committer_email_pattern` rule type */
  committerEmailPattern?: InputMaybe<CommitterEmailPatternParametersInput>;
  /** Parameters used for the `copilot_code_review` rule type */
  copilotCodeReview?: InputMaybe<CopilotCodeReviewParametersInput>;
  /** Parameters used for the `file_extension_restriction` rule type */
  fileExtensionRestriction?: InputMaybe<FileExtensionRestrictionParametersInput>;
  /** Parameters used for the `file_path_restriction` rule type */
  filePathRestriction?: InputMaybe<FilePathRestrictionParametersInput>;
  /** Parameters used for the `max_file_path_length` rule type */
  maxFilePathLength?: InputMaybe<MaxFilePathLengthParametersInput>;
  /** Parameters used for the `max_file_size` rule type */
  maxFileSize?: InputMaybe<MaxFileSizeParametersInput>;
  /** Parameters used for the `merge_queue` rule type */
  mergeQueue?: InputMaybe<MergeQueueParametersInput>;
  /** Parameters used for the `pull_request` rule type */
  pullRequest?: InputMaybe<PullRequestParametersInput>;
  /** Parameters used for the `required_deployments` rule type */
  requiredDeployments?: InputMaybe<RequiredDeploymentsParametersInput>;
  /** Parameters used for the `required_status_checks` rule type */
  requiredStatusChecks?: InputMaybe<RequiredStatusChecksParametersInput>;
  /** Parameters used for the `tag_name_pattern` rule type */
  tagNamePattern?: InputMaybe<TagNamePatternParametersInput>;
  /** Parameters used for the `update` rule type */
  update?: InputMaybe<UpdateParametersInput>;
  /** Parameters used for the `workflows` rule type */
  workflows?: InputMaybe<WorkflowsParametersInput>;
};

/** Types which can have `RepositoryRule` objects. */
export type RuleSource = Enterprise | Organization | Repository;

/** The possible digest algorithms used to sign SAML requests for an identity provider. */
export enum SamlDigestAlgorithm {
  /** SHA1 */
  Sha1 = 'SHA1',
  /** SHA256 */
  Sha256 = 'SHA256',
  /** SHA384 */
  Sha384 = 'SHA384',
  /** SHA512 */
  Sha512 = 'SHA512'
}

/** The possible signature algorithms used to sign SAML requests for a Identity Provider. */
export enum SamlSignatureAlgorithm {
  /** RSA-SHA1 */
  RsaSha1 = 'RSA_SHA1',
  /** RSA-SHA256 */
  RsaSha256 = 'RSA_SHA256',
  /** RSA-SHA384 */
  RsaSha384 = 'RSA_SHA384',
  /** RSA-SHA512 */
  RsaSha512 = 'RSA_SHA512'
}

/** A Saved Reply is text a user can use to reply quickly. */
export type SavedReply = Node & {
  __typename?: 'SavedReply';
  /** The body of the saved reply. */
  body: Scalars['String']['output'];
  /** The saved reply body rendered to HTML. */
  bodyHTML: Scalars['HTML']['output'];
  /** Identifies the primary key from the database. */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** The Node ID of the SavedReply object */
  id: Scalars['ID']['output'];
  /** The title of the saved reply. */
  title: Scalars['String']['output'];
  /** The user that saved this reply. */
  user?: Maybe<Actor>;
};

/** The connection type for SavedReply. */
export type SavedReplyConnection = {
  __typename?: 'SavedReplyConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SavedReplyEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<SavedReply>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SavedReplyEdge = {
  __typename?: 'SavedReplyEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SavedReply>;
};

/** Ordering options for saved reply connections. */
export type SavedReplyOrder = {
  /** The ordering direction. */
  direction: OrderDirection;
  /** The field to order saved replies by. */
  field: SavedReplyOrderField;
};

/** Properties by which saved reply connections can be ordered. */
export enum SavedReplyOrderField {
  /** Order saved reply by when they were updated. */
  UpdatedAt = 'UPDATED_AT'
}

/** The results of a search. */
export type SearchResultItem = App | Discussion | Issue | MarketplaceListing | Organization | PullRequest | Repository | User;

/**
 * A list of results that matched against a search query. Regardless of the number
 * of matches, a maximum of 1,000 results will be available across all types,
 * potentially split across many pages.
 */
export type SearchResultItemConnection = {
  __typename?: 'SearchResultItemConnection';
  /**
   * The total number of pieces of code that matched the search query. Regardless
   * of the total number of matches, a maximum of 1,000 results will be available
   * across all types.
   */
  codeCount: Scalars['Int']['output'];
  /**
   * The total number of discussions that matched the search query. Regardless of
   * the total number of matches, a maximum of 1,000 results will be available
   * across all types.
   */
  discussionCount: Scalars['Int']['output'];
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SearchResultItemEdge>>>;
  /**
   * The total number of issues that matched the search query. Regardless of the
   * total number of matches, a maximum of 1,000 results will be available across all types.
   */
  issueCount: Scalars['Int']['output'];
  /** The type of search that was performed for issues (lexical, semantic, or hybrid) */
  issueSearchType?: Maybe<IssueSearchType>;
  /** When a semantic or hybrid search falls back to lexical, the reasons why the fallback occurred. */
  lexicalFallbackReason?: Maybe<Array<LexicalFallbackReason>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<SearchResultItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /**
   * The total number of repositories that matched the search query. Regardless of
   * the total number of matches, a maximum of 1,000 results will be available
   * across all types.
   */
  repositoryCount: Scalars['Int']['output'];
  /**
   * The total number of users that matched the search query. Regardless of the
   * total number of matches, a maximum of 1,000 results will be available across all types.
   */
  userCount: Scalars['Int']['output'];
  /**
   * The total number of wiki pages that matched the search query. Regardless of
   * the total number of matches, a maximum of 1,000 results will be available
   * across all types.
   */
  wikiCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SearchResultItemEdge = {
  __typename?: 'SearchResultItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SearchResultItem>;
  /** Text matches on the result found. */
  textMatches?: Maybe<Array<Maybe<TextMatch>>>;
};

/** Represents the individual results of a search. */
export enum SearchType {
  /** Returns matching discussions in repositories. */
  Discussion = 'DISCUSSION',
  /** Returns results matching issues in repositories. */
  Issue = 'ISSUE',
  /** Returns results matching issues in repositories. */
  IssueAdvanced = 'ISSUE_ADVANCED',
  /** Returns results matching issues using hybrid (lexical + semantic) search. */
  IssueHybrid = 'ISSUE_HYBRID',
  /** Returns results matching issues using semantic search. */
  IssueSemantic = 'ISSUE_SEMANTIC',
  /** Returns results matching repositories. */
  Repository = 'REPOSITORY',
  /** Returns results matching users and organizations on GitHub. */
  User = 'USER'
}

/** A GitHub Security Advisory */
export type SecurityAdvisory = Node & {
  __typename?: 'SecurityAdvisory';
  /** The classification of the advisory */
  classification: SecurityAdvisoryClassification;
  /** The Common Vulnerabilities and Exposures ID */
  cveId?: Maybe<Scalars['String']['output']>;
  /**
   * The CVSS associated with this advisory
   * @deprecated `cvss` will be removed. New `cvss_severities` field will now contain both `cvss_v3` and `cvss_v4` properties. Removal on 2025-10-01 UTC.
   */
  cvss: Cvss;
  /** The CVSS associated with this advisory */
  cvssSeverities: CvssSeverities;
  /** CWEs associated with this Advisory */
  cwes: CweConnection;
  /** Identifies the primary key from the database. */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** This is a long plaintext description of the advisory */
  description: Scalars['String']['output'];
  /** The Exploit Prediction Scoring System */
  epss?: Maybe<Epss>;
  /** The GitHub Security Advisory ID */
  ghsaId: Scalars['String']['output'];
  /** When the GitHub Security team reviewed this advisory, which may differ from when GitHub published it */
  githubReviewedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The Node ID of the SecurityAdvisory object */
  id: Scalars['ID']['output'];
  /** A list of identifiers for this advisory */
  identifiers: Array<SecurityAdvisoryIdentifier>;
  /** The permalink for the advisory's dependabot alerts page */
  notificationsPermalink?: Maybe<Scalars['URI']['output']>;
  /** When NVD published its advisory record, independent of GitHub's publishing timeline */
  nvdPublishedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The organization that originated the advisory */
  origin: Scalars['String']['output'];
  /** The permalink for the advisory */
  permalink?: Maybe<Scalars['URI']['output']>;
  /** When GitHub published this advisory */
  publishedAt: Scalars['DateTime']['output'];
  /** A list of references for this advisory */
  references: Array<SecurityAdvisoryReference>;
  /** The URL for the associated repository security advisory, if this global advisory is linked to a repository-level advisory. */
  repositoryAdvisoryUrl?: Maybe<Scalars['URI']['output']>;
  /** The severity of the advisory */
  severity: SecurityAdvisorySeverity;
  /** URL to the upstream source code relevant to the advisory */
  sourceCodeLocation?: Maybe<Scalars['URI']['output']>;
  /** A short plaintext summary of the advisory */
  summary: Scalars['String']['output'];
  /** When the advisory was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /** Vulnerabilities associated with this Advisory */
  vulnerabilities: SecurityVulnerabilityConnection;
  /** When the advisory was withdrawn, if it has been withdrawn */
  withdrawnAt?: Maybe<Scalars['DateTime']['output']>;
};


/** A GitHub Security Advisory */
export type SecurityAdvisoryCwesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A GitHub Security Advisory */
export type SecurityAdvisoryVulnerabilitiesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  classifications?: InputMaybe<Array<SecurityAdvisoryClassification>>;
  ecosystem?: InputMaybe<SecurityAdvisoryEcosystem>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SecurityVulnerabilityOrder>;
  package?: InputMaybe<Scalars['String']['input']>;
  severities?: InputMaybe<Array<SecurityAdvisorySeverity>>;
};

/** Classification of the advisory. */
export enum SecurityAdvisoryClassification {
  /** Classification of general advisories. */
  General = 'GENERAL',
  /** Classification of malware advisories. */
  Malware = 'MALWARE'
}

/** The connection type for SecurityAdvisory. */
export type SecurityAdvisoryConnection = {
  __typename?: 'SecurityAdvisoryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SecurityAdvisoryEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<SecurityAdvisory>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** The possible ecosystems of a security vulnerability's package. */
export enum SecurityAdvisoryEcosystem {
  /** GitHub Actions */
  Actions = 'ACTIONS',
  /** PHP packages hosted at packagist.org */
  Composer = 'COMPOSER',
  /** Erlang/Elixir packages hosted at hex.pm */
  Erlang = 'ERLANG',
  /** Go modules */
  Go = 'GO',
  /** Java artifacts hosted at the Maven central repository */
  Maven = 'MAVEN',
  /** JavaScript packages hosted at npmjs.com */
  Npm = 'NPM',
  /** .NET packages hosted at the NuGet Gallery */
  Nuget = 'NUGET',
  /** Python packages hosted at PyPI.org */
  Pip = 'PIP',
  /** Dart packages hosted at pub.dev */
  Pub = 'PUB',
  /** Ruby gems hosted at RubyGems.org */
  Rubygems = 'RUBYGEMS',
  /** Rust crates */
  Rust = 'RUST',
  /** Swift packages */
  Swift = 'SWIFT'
}

/** An edge in a connection. */
export type SecurityAdvisoryEdge = {
  __typename?: 'SecurityAdvisoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SecurityAdvisory>;
};

/** A GitHub Security Advisory Identifier */
export type SecurityAdvisoryIdentifier = {
  __typename?: 'SecurityAdvisoryIdentifier';
  /** The identifier type, e.g. GHSA, CVE */
  type: Scalars['String']['output'];
  /** The identifier */
  value: Scalars['String']['output'];
};

/** An advisory identifier to filter results on. */
export type SecurityAdvisoryIdentifierFilter = {
  /** The identifier type. */
  type: SecurityAdvisoryIdentifierType;
  /** The identifier string. Supports exact or partial matching. */
  value: Scalars['String']['input'];
};

/** Identifier formats available for advisories. */
export enum SecurityAdvisoryIdentifierType {
  /** Common Vulnerabilities and Exposures Identifier. */
  Cve = 'CVE',
  /** GitHub Security Advisory ID. */
  Ghsa = 'GHSA'
}

/** Ordering options for security advisory connections */
export type SecurityAdvisoryOrder = {
  /** The ordering direction. */
  direction: OrderDirection;
  /** The field to order security advisories by. */
  field: SecurityAdvisoryOrderField;
};

/** Properties by which security advisory connections can be ordered. */
export enum SecurityAdvisoryOrderField {
  /** Order advisories by EPSS percentage */
  EpssPercentage = 'EPSS_PERCENTAGE',
  /** Order advisories by EPSS percentile */
  EpssPercentile = 'EPSS_PERCENTILE',
  /** Order advisories by publication time */
  PublishedAt = 'PUBLISHED_AT',
  /** Order advisories by update time */
  UpdatedAt = 'UPDATED_AT'
}

/** An individual package */
export type SecurityAdvisoryPackage = {
  __typename?: 'SecurityAdvisoryPackage';
  /** The ecosystem the package belongs to, e.g. RUBYGEMS, NPM */
  ecosystem: SecurityAdvisoryEcosystem;
  /** The package name */
  name: Scalars['String']['output'];
};

/** An individual package version */
export type SecurityAdvisoryPackageVersion = {
  __typename?: 'SecurityAdvisoryPackageVersion';
  /** The package name or version */
  identifier: Scalars['String']['output'];
};

/** A GitHub Security Advisory Reference */
export type SecurityAdvisoryReference = {
  __typename?: 'SecurityAdvisoryReference';
  /** A publicly accessible reference */
  url: Scalars['URI']['output'];
};

/** Severity of the vulnerability. */
export enum SecurityAdvisorySeverity {
  /** Critical. */
  Critical = 'CRITICAL',
  /** High. */
  High = 'HIGH',
  /** Low. */
  Low = 'LOW',
  /** Moderate. */
  Moderate = 'MODERATE',
  /** Unknown. */
  Unknown = 'UNKNOWN'
}

/** An individual vulnerability within an Advisory */
export type SecurityVulnerability = {
  __typename?: 'SecurityVulnerability';
  /** The Advisory associated with this Vulnerability */
  advisory: SecurityAdvisory;
  /** The first version containing a fix for the vulnerability */
  firstPatchedVersion?: Maybe<SecurityAdvisoryPackageVersion>;
  /** A description of the vulnerable package */
  package: SecurityAdvisoryPackage;
  /** The severity of the vulnerability within this package */
  severity: SecurityAdvisorySeverity;
  /** When the vulnerability was last updated */
  updatedAt: Scalars['DateTime']['output'];
  /**
   * A string that describes the vulnerable package versions.
   * This string follows a basic syntax with a few forms.
   * + `= 0.2.0` denotes a single vulnerable version.
   * + `<= 1.0.8` denotes a version range up to and including the specified version
   * + `< 0.1.11` denotes a version range up to, but excluding, the specified version
   * + `>= 4.3.0, < 4.3.5` denotes a version range with a known minimum and maximum version.
   * + `>= 0.0.1` denotes a version range with a known minimum, but no known maximum
   */
  vulnerableVersionRange: Scalars['String']['output'];
};

/** The connection type for SecurityVulnerability. */
export type SecurityVulnerabilityConnection = {
  __typename?: 'SecurityVulnerabilityConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SecurityVulnerabilityEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<SecurityVulnerability>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SecurityVulnerabilityEdge = {
  __typename?: 'SecurityVulnerabilityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SecurityVulnerability>;
};

/** Ordering options for security vulnerability connections */
export type SecurityVulnerabilityOrder = {
  /** The ordering direction. */
  direction: OrderDirection;
  /** The field to order security vulnerabilities by. */
  field: SecurityVulnerabilityOrderField;
};

/** Properties by which security vulnerability connections can be ordered. */
export enum SecurityVulnerabilityOrderField {
  /** Order vulnerability by update time */
  UpdatedAt = 'UPDATED_AT'
}

/** Autogenerated input type of SetEnterpriseIdentityProvider */
export type SetEnterpriseIdentityProviderInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The digest algorithm used to sign SAML requests for the identity provider. */
  digestMethod: SamlDigestAlgorithm;
  /** The ID of the enterprise on which to set an identity provider. */
  enterpriseId: Scalars['ID']['input'];
  /** The x509 certificate used by the identity provider to sign assertions and responses. */
  idpCertificate: Scalars['String']['input'];
  /** The Issuer Entity ID for the SAML identity provider */
  issuer?: InputMaybe<Scalars['String']['input']>;
  /** The signature algorithm used to sign SAML requests for the identity provider. */
  signatureMethod: SamlSignatureAlgorithm;
  /** The URL endpoint for the identity provider's SAML SSO. */
  ssoUrl: Scalars['URI']['input'];
};

/** Autogenerated return type of SetEnterpriseIdentityProvider. */
export type SetEnterpriseIdentityProviderPayload = {
  __typename?: 'SetEnterpriseIdentityProviderPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The identity provider for the enterprise. */
  identityProvider?: Maybe<EnterpriseIdentityProvider>;
};

/** Autogenerated input type of SetIssueFieldValue */
export type SetIssueFieldValueInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The issue fields to set on the issue. */
  issueFields: Array<IssueFieldCreateOrUpdateInput>;
  /** The ID of the Issue to set the field value on. */
  issueId: Scalars['ID']['input'];
};

/** Autogenerated return type of SetIssueFieldValue. */
export type SetIssueFieldValuePayload = {
  __typename?: 'SetIssueFieldValuePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The issue where the field values were set. */
  issue?: Maybe<Issue>;
  /** The issue field values that were created or updated. */
  issueFieldValues?: Maybe<Array<IssueFieldValue>>;
};

/** Autogenerated input type of SetOrganizationInteractionLimit */
export type SetOrganizationInteractionLimitInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** When this limit should expire. */
  expiry?: InputMaybe<RepositoryInteractionLimitExpiry>;
  /** The limit to set. */
  limit: RepositoryInteractionLimit;
  /** The ID of the organization to set a limit for. */
  organizationId: Scalars['ID']['input'];
};

/** Autogenerated return type of SetOrganizationInteractionLimit. */
export type SetOrganizationInteractionLimitPayload = {
  __typename?: 'SetOrganizationInteractionLimitPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The organization that the interaction limit was set for. */
  organization?: Maybe<Organization>;
};

/** Autogenerated input type of SetRepositoryCustomPropertyValues */
export type SetRepositoryCustomPropertyValuesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** A list of custom property names and associated values to apply. */
  properties: Array<CustomPropertyValueInput>;
  /** The ID of the repository to set properties for. */
  repositoryId: Scalars['ID']['input'];
};

/** Autogenerated return type of SetRepositoryCustomPropertyValues. */
export type SetRepositoryCustomPropertyValuesPayload = {
  __typename?: 'SetRepositoryCustomPropertyValuesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The repository that the custom properties were set for. */
  repository?: Maybe<Repository>;
};

/** Autogenerated input type of SetRepositoryInteractionLimit */
export type SetRepositoryInteractionLimitInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** When this limit should expire. */
  expiry?: InputMaybe<RepositoryInteractionLimitExpiry>;
  /** The limit to set. */
  limit: RepositoryInteractionLimit;
  /** The ID of the repository to set a limit for. */
  repositoryId: Scalars['ID']['input'];
};

/** Autogenerated return type of SetRepositoryInteractionLimit. */
export type SetRepositoryInteractionLimitPayload = {
  __typename?: 'SetRepositoryInteractionLimitPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The repository that the interaction limit was set for. */
  repository?: Maybe<Repository>;
};

/** Autogenerated input type of SetUserInteractionLimit */
export type SetUserInteractionLimitInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** When this limit should expire. */
  expiry?: InputMaybe<RepositoryInteractionLimitExpiry>;
  /** The limit to set. */
  limit: RepositoryInteractionLimit;
  /** The ID of the user to set a limit for. */
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of SetUserInteractionLimit. */
export type SetUserInteractionLimitPayload = {
  __typename?: 'SetUserInteractionLimitPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The user that the interaction limit was set for. */
  user?: Maybe<User>;
};

/** Represents an S/MIME signature on a Commit or Tag. */
export type SmimeSignature = GitSignature & {
  __typename?: 'SmimeSignature';
  /** Email used to sign this object. */
  email: Scalars['String']['output'];
  /** True if the signature is valid and verified by GitHub. */
  isValid: Scalars['Boolean']['output'];
  /** Payload for GPG signing object. Raw ODB object without the signature header. */
  payload: Scalars['String']['output'];
  /** ASCII-armored signature header from object. */
  signature: Scalars['String']['output'];
  /** GitHub user corresponding to the email signing this commit. */
  signer?: Maybe<User>;
  /**
   * The state of this signature. `VALID` if signature is valid and verified by
   * GitHub, otherwise represents reason why signature is considered invalid.
   */
  state: GitSignatureState;
  /** The date the signature was verified, if valid */
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
  /** True if the signature was made with GitHub's signing key. */
  wasSignedByGitHub: Scalars['Boolean']['output'];
};

/** Social media profile associated with a user. */
export type SocialAccount = {
  __typename?: 'SocialAccount';
  /** Name of the social media account as it appears on the profile. */
  displayName: Scalars['String']['output'];
  /** Software or company that hosts the social media account. */
  provider: SocialAccountProvider;
  /** URL of the social media account. */
  url: Scalars['URI']['output'];
};

/** The connection type for SocialAccount. */
export type SocialAccountConnection = {
  __typename?: 'SocialAccountConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SocialAccountEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<SocialAccount>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SocialAccountEdge = {
  __typename?: 'SocialAccountEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SocialAccount>;
};

/** Software or company that hosts social media accounts. */
export enum SocialAccountProvider {
  /** Decentralized microblogging social platform. */
  Bluesky = 'BLUESKY',
  /** Social media and networking website. */
  Facebook = 'FACEBOOK',
  /** Catch-all for social media providers that do not yet have specific handling. */
  Generic = 'GENERIC',
  /** Fork of Mastodon with a greater focus on local posting. */
  Hometown = 'HOMETOWN',
  /** Social media website with a focus on photo and video sharing. */
  Instagram = 'INSTAGRAM',
  /** Professional networking website. */
  Linkedin = 'LINKEDIN',
  /** Open-source federated microblogging service. */
  Mastodon = 'MASTODON',
  /** JavaScript package registry. */
  Npm = 'NPM',
  /** Social news aggregation and discussion website. */
  Reddit = 'REDDIT',
  /** Microblogging social platform. */
  Threads = 'THREADS',
  /** Live-streaming service. */
  Twitch = 'TWITCH',
  /** Microblogging website. */
  Twitter = 'TWITTER',
  /** Online video platform. */
  Youtube = 'YOUTUBE'
}

/** Entities that can sponsor others via GitHub Sponsors */
export type Sponsor = Organization | User;

/**
 * A GitHub account and the total amount in USD they've paid for sponsorships to a
 * particular maintainer. Does not include payments made via Patreon.
 */
export type SponsorAndLifetimeValue = {
  __typename?: 'SponsorAndLifetimeValue';
  /** The amount in cents. */
  amountInCents: Scalars['Int']['output'];
  /** The amount in USD, formatted as a string. */
  formattedAmount: Scalars['String']['output'];
  /** The sponsor's GitHub account. */
  sponsor: Sponsorable;
  /** The maintainer's GitHub account. */
  sponsorable: Sponsorable;
};

/** The connection type for SponsorAndLifetimeValue. */
export type SponsorAndLifetimeValueConnection = {
  __typename?: 'SponsorAndLifetimeValueConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SponsorAndLifetimeValueEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<SponsorAndLifetimeValue>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SponsorAndLifetimeValueEdge = {
  __typename?: 'SponsorAndLifetimeValueEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SponsorAndLifetimeValue>;
};

/** Ordering options for connections to get sponsor entities and associated USD amounts for GitHub Sponsors. */
export type SponsorAndLifetimeValueOrder = {
  /** The ordering direction. */
  direction: OrderDirection;
  /** The field to order results by. */
  field: SponsorAndLifetimeValueOrderField;
};

/** Properties by which sponsor and lifetime value connections can be ordered. */
export enum SponsorAndLifetimeValueOrderField {
  /** Order results by how much money the sponsor has paid in total. */
  LifetimeValue = 'LIFETIME_VALUE',
  /** Order results by the sponsor's login (username). */
  SponsorLogin = 'SPONSOR_LOGIN',
  /** Order results by the sponsor's relevance to the viewer. */
  SponsorRelevance = 'SPONSOR_RELEVANCE'
}

/** A list of users and organizations sponsoring someone via GitHub Sponsors. */
export type SponsorConnection = {
  __typename?: 'SponsorConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SponsorEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Sponsor>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** Represents a user or organization who is sponsoring someone in GitHub Sponsors. */
export type SponsorEdge = {
  __typename?: 'SponsorEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Sponsor>;
};

/** Ordering options for connections to get sponsor entities for GitHub Sponsors. */
export type SponsorOrder = {
  /** The ordering direction. */
  direction: OrderDirection;
  /** The field to order sponsor entities by. */
  field: SponsorOrderField;
};

/** Properties by which sponsor connections can be ordered. */
export enum SponsorOrderField {
  /** Order sponsorable entities by login (username). */
  Login = 'LOGIN',
  /** Order sponsors by their relevance to the viewer. */
  Relevance = 'RELEVANCE'
}

/** Entities that can sponsor or be sponsored through GitHub Sponsors. */
export type Sponsorable = {
  /** The estimated next GitHub Sponsors payout for this user/organization in cents (USD). */
  estimatedNextSponsorsPayoutInCents: Scalars['Int']['output'];
  /** True if this user/organization has a GitHub Sponsors listing. */
  hasSponsorsListing: Scalars['Boolean']['output'];
  /** Whether the given account is sponsoring this user/organization. */
  isSponsoredBy: Scalars['Boolean']['output'];
  /** True if the viewer is sponsored by this user/organization. */
  isSponsoringViewer: Scalars['Boolean']['output'];
  /**
   * Calculate how much each sponsor has ever paid total to this maintainer via
   * GitHub Sponsors. Does not include sponsorships paid via Patreon.
   */
  lifetimeReceivedSponsorshipValues: SponsorAndLifetimeValueConnection;
  /** The estimated monthly GitHub Sponsors income for this user/organization in cents (USD). */
  monthlyEstimatedSponsorsIncomeInCents: Scalars['Int']['output'];
  /** List of users and organizations this entity is sponsoring. */
  sponsoring: SponsorConnection;
  /** List of sponsors for this user or organization. */
  sponsors: SponsorConnection;
  /** Events involving this sponsorable, such as new sponsorships. */
  sponsorsActivities: SponsorsActivityConnection;
  /** The GitHub Sponsors listing for this user or organization. */
  sponsorsListing?: Maybe<SponsorsListing>;
  /** The sponsorship from the viewer to this user/organization; that is, the sponsorship where you're the sponsor. */
  sponsorshipForViewerAsSponsor?: Maybe<Sponsorship>;
  /** The sponsorship from this user/organization to the viewer; that is, the sponsorship you're receiving. */
  sponsorshipForViewerAsSponsorable?: Maybe<Sponsorship>;
  /** List of sponsorship updates sent from this sponsorable to sponsors. */
  sponsorshipNewsletters: SponsorshipNewsletterConnection;
  /** The sponsorships where this user or organization is the maintainer receiving the funds. */
  sponsorshipsAsMaintainer: SponsorshipConnection;
  /** The sponsorships where this user or organization is the funder. */
  sponsorshipsAsSponsor: SponsorshipConnection;
  /**
   * The amount in United States cents (e.g., 500 = $5.00 USD) that this entity has
   * spent on GitHub to fund sponsorships. Only returns a value when viewed by the
   * user themselves or by a user who can manage sponsorships for the requested organization.
   */
  totalSponsorshipAmountAsSponsorInCents?: Maybe<Scalars['Int']['output']>;
  /** Whether or not the viewer is able to sponsor this user/organization. */
  viewerCanSponsor: Scalars['Boolean']['output'];
  /** True if the viewer is sponsoring this user/organization. */
  viewerIsSponsoring: Scalars['Boolean']['output'];
};


/** Entities that can sponsor or be sponsored through GitHub Sponsors. */
export type SponsorableIsSponsoredByArgs = {
  accountLogin: Scalars['String']['input'];
};


/** Entities that can sponsor or be sponsored through GitHub Sponsors. */
export type SponsorableLifetimeReceivedSponsorshipValuesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SponsorAndLifetimeValueOrder>;
};


/** Entities that can sponsor or be sponsored through GitHub Sponsors. */
export type SponsorableSponsoringArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SponsorOrder>;
};


/** Entities that can sponsor or be sponsored through GitHub Sponsors. */
export type SponsorableSponsorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SponsorOrder>;
  tierId?: InputMaybe<Scalars['ID']['input']>;
};


/** Entities that can sponsor or be sponsored through GitHub Sponsors. */
export type SponsorableSponsorsActivitiesArgs = {
  actions?: InputMaybe<Array<SponsorsActivityAction>>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeAsSponsor?: InputMaybe<Scalars['Boolean']['input']>;
  includePrivate?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SponsorsActivityOrder>;
  period?: InputMaybe<SponsorsActivityPeriod>;
  since?: InputMaybe<Scalars['DateTime']['input']>;
  until?: InputMaybe<Scalars['DateTime']['input']>;
};


/** Entities that can sponsor or be sponsored through GitHub Sponsors. */
export type SponsorableSponsorshipForViewerAsSponsorArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Entities that can sponsor or be sponsored through GitHub Sponsors. */
export type SponsorableSponsorshipForViewerAsSponsorableArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Entities that can sponsor or be sponsored through GitHub Sponsors. */
export type SponsorableSponsorshipNewslettersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SponsorshipNewsletterOrder>;
};


/** Entities that can sponsor or be sponsored through GitHub Sponsors. */
export type SponsorableSponsorshipsAsMaintainerArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includePrivate?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SponsorshipOrder>;
};


/** Entities that can sponsor or be sponsored through GitHub Sponsors. */
export type SponsorableSponsorshipsAsSponsorArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maintainerLogins?: InputMaybe<Array<Scalars['String']['input']>>;
  orderBy?: InputMaybe<SponsorshipOrder>;
};


/** Entities that can sponsor or be sponsored through GitHub Sponsors. */
export type SponsorableTotalSponsorshipAmountAsSponsorInCentsArgs = {
  since?: InputMaybe<Scalars['DateTime']['input']>;
  sponsorableLogins?: InputMaybe<Array<Scalars['String']['input']>>;
  until?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Entities that can be sponsored via GitHub Sponsors */
export type SponsorableItem = Organization | User;

/** The connection type for SponsorableItem. */
export type SponsorableItemConnection = {
  __typename?: 'SponsorableItemConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SponsorableItemEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<SponsorableItem>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SponsorableItemEdge = {
  __typename?: 'SponsorableItemEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SponsorableItem>;
};

/** Ordering options for connections to get sponsorable entities for GitHub Sponsors. */
export type SponsorableOrder = {
  /** The ordering direction. */
  direction: OrderDirection;
  /** The field to order sponsorable entities by. */
  field: SponsorableOrderField;
};

/** Properties by which sponsorable connections can be ordered. */
export enum SponsorableOrderField {
  /** Order sponsorable entities by login (username). */
  Login = 'LOGIN'
}

/** An event related to sponsorship activity. */
export type SponsorsActivity = Node & {
  __typename?: 'SponsorsActivity';
  /** What action this activity indicates took place. */
  action: SponsorsActivityAction;
  /** The sponsor's current privacy level. */
  currentPrivacyLevel?: Maybe<SponsorshipPrivacy>;
  /** The Node ID of the SponsorsActivity object */
  id: Scalars['ID']['output'];
  /** The platform that was used to pay for the sponsorship. */
  paymentSource?: Maybe<SponsorshipPaymentSource>;
  /** The tier that the sponsorship used to use, for tier change events. */
  previousSponsorsTier?: Maybe<SponsorsTier>;
  /** The user or organization who triggered this activity and was/is sponsoring the sponsorable. */
  sponsor?: Maybe<Sponsor>;
  /** The user or organization that is being sponsored, the maintainer. */
  sponsorable: Sponsorable;
  /** The associated sponsorship tier. */
  sponsorsTier?: Maybe<SponsorsTier>;
  /** The timestamp of this event. */
  timestamp?: Maybe<Scalars['DateTime']['output']>;
  /** Was this sponsorship made alongside other sponsorships at the same time from the same sponsor? */
  viaBulkSponsorship: Scalars['Boolean']['output'];
};

/** The possible actions that GitHub Sponsors activities can represent. */
export enum SponsorsActivityAction {
  /** The activity was cancelling a sponsorship. */
  CancelledSponsorship = 'CANCELLED_SPONSORSHIP',
  /** The activity was starting a sponsorship. */
  NewSponsorship = 'NEW_SPONSORSHIP',
  /** The activity was scheduling a downgrade or cancellation. */
  PendingChange = 'PENDING_CHANGE',
  /** The activity was funds being refunded to the sponsor or GitHub. */
  Refund = 'REFUND',
  /** The activity was disabling matching for a previously matched sponsorship. */
  SponsorMatchDisabled = 'SPONSOR_MATCH_DISABLED',
  /** The activity was changing the sponsorship tier, either directly by the sponsor or by a scheduled/pending change. */
  TierChange = 'TIER_CHANGE'
}

/** The connection type for SponsorsActivity. */
export type SponsorsActivityConnection = {
  __typename?: 'SponsorsActivityConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SponsorsActivityEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<SponsorsActivity>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SponsorsActivityEdge = {
  __typename?: 'SponsorsActivityEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SponsorsActivity>;
};

/** Ordering options for GitHub Sponsors activity connections. */
export type SponsorsActivityOrder = {
  /** The ordering direction. */
  direction: OrderDirection;
  /** The field to order activity by. */
  field: SponsorsActivityOrderField;
};

/** Properties by which GitHub Sponsors activity connections can be ordered. */
export enum SponsorsActivityOrderField {
  /** Order activities by when they happened. */
  Timestamp = 'TIMESTAMP'
}

/** The possible time periods for which Sponsors activities can be requested. */
export enum SponsorsActivityPeriod {
  /** Don't restrict the activity to any date range, include all activity. */
  All = 'ALL',
  /** The previous calendar day. */
  Day = 'DAY',
  /** The previous thirty days. */
  Month = 'MONTH',
  /** The previous seven days. */
  Week = 'WEEK'
}

/** Represents countries or regions for billing and residence for a GitHub Sponsors profile. */
export enum SponsorsCountryOrRegionCode {
  /** Andorra */
  Ad = 'AD',
  /** United Arab Emirates */
  Ae = 'AE',
  /** Afghanistan */
  Af = 'AF',
  /** Antigua and Barbuda */
  Ag = 'AG',
  /** Anguilla */
  Ai = 'AI',
  /** Albania */
  Al = 'AL',
  /** Armenia */
  Am = 'AM',
  /** Angola */
  Ao = 'AO',
  /** Antarctica */
  Aq = 'AQ',
  /** Argentina */
  Ar = 'AR',
  /** American Samoa */
  As = 'AS',
  /** Austria */
  At = 'AT',
  /** Australia */
  Au = 'AU',
  /** Aruba */
  Aw = 'AW',
  /** Åland */
  Ax = 'AX',
  /** Azerbaijan */
  Az = 'AZ',
  /** Bosnia and Herzegovina */
  Ba = 'BA',
  /** Barbados */
  Bb = 'BB',
  /** Bangladesh */
  Bd = 'BD',
  /** Belgium */
  Be = 'BE',
  /** Burkina Faso */
  Bf = 'BF',
  /** Bulgaria */
  Bg = 'BG',
  /** Bahrain */
  Bh = 'BH',
  /** Burundi */
  Bi = 'BI',
  /** Benin */
  Bj = 'BJ',
  /** Saint Barthélemy */
  Bl = 'BL',
  /** Bermuda */
  Bm = 'BM',
  /** Brunei Darussalam */
  Bn = 'BN',
  /** Bolivia */
  Bo = 'BO',
  /** Bonaire, Sint Eustatius and Saba */
  Bq = 'BQ',
  /** Brazil */
  Br = 'BR',
  /** Bahamas */
  Bs = 'BS',
  /** Bhutan */
  Bt = 'BT',
  /** Bouvet Island */
  Bv = 'BV',
  /** Botswana */
  Bw = 'BW',
  /** Belarus */
  By = 'BY',
  /** Belize */
  Bz = 'BZ',
  /** Canada */
  Ca = 'CA',
  /** Cocos (Keeling) Islands */
  Cc = 'CC',
  /** Congo (Kinshasa) */
  Cd = 'CD',
  /** Central African Republic */
  Cf = 'CF',
  /** Congo (Brazzaville) */
  Cg = 'CG',
  /** Switzerland */
  Ch = 'CH',
  /** Côte d'Ivoire */
  Ci = 'CI',
  /** Cook Islands */
  Ck = 'CK',
  /** Chile */
  Cl = 'CL',
  /** Cameroon */
  Cm = 'CM',
  /** China */
  Cn = 'CN',
  /** Colombia */
  Co = 'CO',
  /** Costa Rica */
  Cr = 'CR',
  /** Cape Verde */
  Cv = 'CV',
  /** Curaçao */
  Cw = 'CW',
  /** Christmas Island */
  Cx = 'CX',
  /** Cyprus */
  Cy = 'CY',
  /** Czech Republic */
  Cz = 'CZ',
  /** Germany */
  De = 'DE',
  /** Djibouti */
  Dj = 'DJ',
  /** Denmark */
  Dk = 'DK',
  /** Dominica */
  Dm = 'DM',
  /** Dominican Republic */
  Do = 'DO',
  /** Algeria */
  Dz = 'DZ',
  /** Ecuador */
  Ec = 'EC',
  /** Estonia */
  Ee = 'EE',
  /** Egypt */
  Eg = 'EG',
  /** Western Sahara */
  Eh = 'EH',
  /** Eritrea */
  Er = 'ER',
  /** Spain */
  Es = 'ES',
  /** Ethiopia */
  Et = 'ET',
  /** Finland */
  Fi = 'FI',
  /** Fiji */
  Fj = 'FJ',
  /** Falkland Islands */
  Fk = 'FK',
  /** Micronesia */
  Fm = 'FM',
  /** Faroe Islands */
  Fo = 'FO',
  /** France */
  Fr = 'FR',
  /** Gabon */
  Ga = 'GA',
  /** United Kingdom */
  Gb = 'GB',
  /** Grenada */
  Gd = 'GD',
  /** Georgia */
  Ge = 'GE',
  /** French Guiana */
  Gf = 'GF',
  /** Guernsey */
  Gg = 'GG',
  /** Ghana */
  Gh = 'GH',
  /** Gibraltar */
  Gi = 'GI',
  /** Greenland */
  Gl = 'GL',
  /** Gambia */
  Gm = 'GM',
  /** Guinea */
  Gn = 'GN',
  /** Guadeloupe */
  Gp = 'GP',
  /** Equatorial Guinea */
  Gq = 'GQ',
  /** Greece */
  Gr = 'GR',
  /** South Georgia and South Sandwich Islands */
  Gs = 'GS',
  /** Guatemala */
  Gt = 'GT',
  /** Guam */
  Gu = 'GU',
  /** Guinea-Bissau */
  Gw = 'GW',
  /** Guyana */
  Gy = 'GY',
  /** Hong Kong */
  Hk = 'HK',
  /** Heard and McDonald Islands */
  Hm = 'HM',
  /** Honduras */
  Hn = 'HN',
  /** Croatia */
  Hr = 'HR',
  /** Haiti */
  Ht = 'HT',
  /** Hungary */
  Hu = 'HU',
  /** Indonesia */
  Id = 'ID',
  /** Ireland */
  Ie = 'IE',
  /** Israel */
  Il = 'IL',
  /** Isle of Man */
  Im = 'IM',
  /** India */
  In = 'IN',
  /** British Indian Ocean Territory */
  Io = 'IO',
  /** Iraq */
  Iq = 'IQ',
  /** Iran */
  Ir = 'IR',
  /** Iceland */
  Is = 'IS',
  /** Italy */
  It = 'IT',
  /** Jersey */
  Je = 'JE',
  /** Jamaica */
  Jm = 'JM',
  /** Jordan */
  Jo = 'JO',
  /** Japan */
  Jp = 'JP',
  /** Kenya */
  Ke = 'KE',
  /** Kyrgyzstan */
  Kg = 'KG',
  /** Cambodia */
  Kh = 'KH',
  /** Kiribati */
  Ki = 'KI',
  /** Comoros */
  Km = 'KM',
  /** Saint Kitts and Nevis */
  Kn = 'KN',
  /** Korea, South */
  Kr = 'KR',
  /** Kuwait */
  Kw = 'KW',
  /** Cayman Islands */
  Ky = 'KY',
  /** Kazakhstan */
  Kz = 'KZ',
  /** Laos */
  La = 'LA',
  /** Lebanon */
  Lb = 'LB',
  /** Saint Lucia */
  Lc = 'LC',
  /** Liechtenstein */
  Li = 'LI',
  /** Sri Lanka */
  Lk = 'LK',
  /** Liberia */
  Lr = 'LR',
  /** Lesotho */
  Ls = 'LS',
  /** Lithuania */
  Lt = 'LT',
  /** Luxembourg */
  Lu = 'LU',
  /** Latvia */
  Lv = 'LV',
  /** Libya */
  Ly = 'LY',
  /** Morocco */
  Ma = 'MA',
  /** Monaco */
  Mc = 'MC',
  /** Moldova */
  Md = 'MD',
  /** Montenegro */
  Me = 'ME',
  /** Saint Martin (French part) */
  Mf = 'MF',
  /** Madagascar */
  Mg = 'MG',
  /** Marshall Islands */
  Mh = 'MH',
  /** Macedonia */
  Mk = 'MK',
  /** Mali */
  Ml = 'ML',
  /** Myanmar */
  Mm = 'MM',
  /** Mongolia */
  Mn = 'MN',
  /** Macau */
  Mo = 'MO',
  /** Northern Mariana Islands */
  Mp = 'MP',
  /** Martinique */
  Mq = 'MQ',
  /** Mauritania */
  Mr = 'MR',
  /** Montserrat */
  Ms = 'MS',
  /** Malta */
  Mt = 'MT',
  /** Mauritius */
  Mu = 'MU',
  /** Maldives */
  Mv = 'MV',
  /** Malawi */
  Mw = 'MW',
  /** Mexico */
  Mx = 'MX',
  /** Malaysia */
  My = 'MY',
  /** Mozambique */
  Mz = 'MZ',
  /** Namibia */
  Na = 'NA',
  /** New Caledonia */
  Nc = 'NC',
  /** Niger */
  Ne = 'NE',
  /** Norfolk Island */
  Nf = 'NF',
  /** Nigeria */
  Ng = 'NG',
  /** Nicaragua */
  Ni = 'NI',
  /** Netherlands */
  Nl = 'NL',
  /** Norway */
  No = 'NO',
  /** Nepal */
  Np = 'NP',
  /** Nauru */
  Nr = 'NR',
  /** Niue */
  Nu = 'NU',
  /** New Zealand */
  Nz = 'NZ',
  /** Oman */
  Om = 'OM',
  /** Panama */
  Pa = 'PA',
  /** Peru */
  Pe = 'PE',
  /** French Polynesia */
  Pf = 'PF',
  /** Papua New Guinea */
  Pg = 'PG',
  /** Philippines */
  Ph = 'PH',
  /** Pakistan */
  Pk = 'PK',
  /** Poland */
  Pl = 'PL',
  /** Saint Pierre and Miquelon */
  Pm = 'PM',
  /** Pitcairn */
  Pn = 'PN',
  /** Puerto Rico */
  Pr = 'PR',
  /** Palestine */
  Ps = 'PS',
  /** Portugal */
  Pt = 'PT',
  /** Palau */
  Pw = 'PW',
  /** Paraguay */
  Py = 'PY',
  /** Qatar */
  Qa = 'QA',
  /** Reunion */
  Re = 'RE',
  /** Romania */
  Ro = 'RO',
  /** Serbia */
  Rs = 'RS',
  /** Russian Federation */
  Ru = 'RU',
  /** Rwanda */
  Rw = 'RW',
  /** Saudi Arabia */
  Sa = 'SA',
  /** Solomon Islands */
  Sb = 'SB',
  /** Seychelles */
  Sc = 'SC',
  /** Sudan */
  Sd = 'SD',
  /** Sweden */
  Se = 'SE',
  /** Singapore */
  Sg = 'SG',
  /** Saint Helena */
  Sh = 'SH',
  /** Slovenia */
  Si = 'SI',
  /** Svalbard and Jan Mayen Islands */
  Sj = 'SJ',
  /** Slovakia */
  Sk = 'SK',
  /** Sierra Leone */
  Sl = 'SL',
  /** San Marino */
  Sm = 'SM',
  /** Senegal */
  Sn = 'SN',
  /** Somalia */
  So = 'SO',
  /** Suriname */
  Sr = 'SR',
  /** South Sudan */
  Ss = 'SS',
  /** Sao Tome and Principe */
  St = 'ST',
  /** El Salvador */
  Sv = 'SV',
  /** Sint Maarten (Dutch part) */
  Sx = 'SX',
  /** Syria */
  Sy = 'SY',
  /** Swaziland */
  Sz = 'SZ',
  /** Turks and Caicos Islands */
  Tc = 'TC',
  /** Chad */
  Td = 'TD',
  /** French Southern Lands */
  Tf = 'TF',
  /** Togo */
  Tg = 'TG',
  /** Thailand */
  Th = 'TH',
  /** Tajikistan */
  Tj = 'TJ',
  /** Tokelau */
  Tk = 'TK',
  /** Timor-Leste */
  Tl = 'TL',
  /** Turkmenistan */
  Tm = 'TM',
  /** Tunisia */
  Tn = 'TN',
  /** Tonga */
  To = 'TO',
  /** Türkiye */
  Tr = 'TR',
  /** Trinidad and Tobago */
  Tt = 'TT',
  /** Tuvalu */
  Tv = 'TV',
  /** Taiwan */
  Tw = 'TW',
  /** Tanzania */
  Tz = 'TZ',
  /** Ukraine */
  Ua = 'UA',
  /** Uganda */
  Ug = 'UG',
  /** United States Minor Outlying Islands */
  Um = 'UM',
  /** United States of America */
  Us = 'US',
  /** Uruguay */
  Uy = 'UY',
  /** Uzbekistan */
  Uz = 'UZ',
  /** Vatican City */
  Va = 'VA',
  /** Saint Vincent and the Grenadines */
  Vc = 'VC',
  /** Venezuela */
  Ve = 'VE',
  /** Virgin Islands, British */
  Vg = 'VG',
  /** Virgin Islands, U.S. */
  Vi = 'VI',
  /** Vietnam */
  Vn = 'VN',
  /** Vanuatu */
  Vu = 'VU',
  /** Wallis and Futuna Islands */
  Wf = 'WF',
  /** Samoa */
  Ws = 'WS',
  /** Yemen */
  Ye = 'YE',
  /** Mayotte */
  Yt = 'YT',
  /** South Africa */
  Za = 'ZA',
  /** Zambia */
  Zm = 'ZM',
  /** Zimbabwe */
  Zw = 'ZW'
}

/** A goal associated with a GitHub Sponsors listing, representing a target the sponsored maintainer would like to attain. */
export type SponsorsGoal = {
  __typename?: 'SponsorsGoal';
  /** A description of the goal from the maintainer. */
  description?: Maybe<Scalars['String']['output']>;
  /** What the objective of this goal is. */
  kind: SponsorsGoalKind;
  /** The percentage representing how complete this goal is, between 0-100. */
  percentComplete: Scalars['Int']['output'];
  /**
   * What the goal amount is. Represents an amount in USD for monthly sponsorship
   * amount goals. Represents a count of unique sponsors for total sponsors count goals.
   */
  targetValue: Scalars['Int']['output'];
  /** A brief summary of the kind and target value of this goal. */
  title: Scalars['String']['output'];
};

/** The different kinds of goals a GitHub Sponsors member can have. */
export enum SponsorsGoalKind {
  /** The goal is about getting a certain amount in USD from sponsorships each month. */
  MonthlySponsorshipAmount = 'MONTHLY_SPONSORSHIP_AMOUNT',
  /** The goal is about reaching a certain number of sponsors. */
  TotalSponsorsCount = 'TOTAL_SPONSORS_COUNT'
}

/** A GitHub Sponsors listing. */
export type SponsorsListing = Node & {
  __typename?: 'SponsorsListing';
  /** The current goal the maintainer is trying to reach with GitHub Sponsors, if any. */
  activeGoal?: Maybe<SponsorsGoal>;
  /**
   * The Stripe Connect account currently in use for payouts for this Sponsors
   * listing, if any. Will only return a value when queried by the maintainer
   * themselves, or by an admin of the sponsorable organization.
   */
  activeStripeConnectAccount?: Maybe<StripeConnectAccount>;
  /**
   * The name of the country or region with the maintainer's bank account or fiscal
   * host. Will only return a value when queried by the maintainer themselves, or
   * by an admin of the sponsorable organization.
   */
  billingCountryOrRegion?: Maybe<Scalars['String']['output']>;
  /**
   * The email address used by GitHub to contact the sponsorable about their GitHub
   * Sponsors profile. Will only return a value when queried by the maintainer
   * themselves, or by an admin of the sponsorable organization.
   */
  contactEmailAddress?: Maybe<Scalars['String']['output']>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The HTTP path for the Sponsors dashboard for this Sponsors listing. */
  dashboardResourcePath: Scalars['URI']['output'];
  /** The HTTP URL for the Sponsors dashboard for this Sponsors listing. */
  dashboardUrl: Scalars['URI']['output'];
  /** The records featured on the GitHub Sponsors profile. */
  featuredItems: Array<SponsorsListingFeaturedItem>;
  /**
   * The fiscal host used for payments, if any. Will only return a value when
   * queried by the maintainer themselves, or by an admin of the sponsorable organization.
   */
  fiscalHost?: Maybe<Organization>;
  /** The full description of the listing. */
  fullDescription: Scalars['String']['output'];
  /** The full description of the listing rendered to HTML. */
  fullDescriptionHTML: Scalars['HTML']['output'];
  /** The Node ID of the SponsorsListing object */
  id: Scalars['ID']['output'];
  /** Whether this listing is publicly visible. */
  isPublic: Scalars['Boolean']['output'];
  /** The listing's full name. */
  name: Scalars['String']['output'];
  /** A future date on which this listing is eligible to receive a payout. */
  nextPayoutDate?: Maybe<Scalars['Date']['output']>;
  /**
   * The name of the country or region where the maintainer resides. Will only
   * return a value when queried by the maintainer themselves, or by an admin of
   * the sponsorable organization.
   */
  residenceCountryOrRegion?: Maybe<Scalars['String']['output']>;
  /** The HTTP path for this Sponsors listing. */
  resourcePath: Scalars['URI']['output'];
  /** The short description of the listing. */
  shortDescription: Scalars['String']['output'];
  /** The short name of the listing. */
  slug: Scalars['String']['output'];
  /** The entity this listing represents who can be sponsored on GitHub Sponsors. */
  sponsorable: Sponsorable;
  /** The tiers for this GitHub Sponsors profile. */
  tiers?: Maybe<SponsorsTierConnection>;
  /** The HTTP URL for this Sponsors listing. */
  url: Scalars['URI']['output'];
};


/** A GitHub Sponsors listing. */
export type SponsorsListingFeaturedItemsArgs = {
  featureableTypes?: InputMaybe<Array<SponsorsListingFeaturedItemFeatureableType>>;
};


/** A GitHub Sponsors listing. */
export type SponsorsListingTiersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeUnpublished?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SponsorsTierOrder>;
};

/** A record that can be featured on a GitHub Sponsors profile. */
export type SponsorsListingFeatureableItem = Repository | User;

/** A record that is promoted on a GitHub Sponsors profile. */
export type SponsorsListingFeaturedItem = Node & {
  __typename?: 'SponsorsListingFeaturedItem';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /**
   * Will either be a description from the sponsorable maintainer about why they
   * featured this item, or the item's description itself, such as a user's bio
   * from their GitHub profile page.
   */
  description?: Maybe<Scalars['String']['output']>;
  /** The record that is featured on the GitHub Sponsors profile. */
  featureable: SponsorsListingFeatureableItem;
  /** The Node ID of the SponsorsListingFeaturedItem object */
  id: Scalars['ID']['output'];
  /**
   * The position of this featured item on the GitHub Sponsors profile with a lower
   * position indicating higher precedence. Starts at 1.
   */
  position: Scalars['Int']['output'];
  /** The GitHub Sponsors profile that features this record. */
  sponsorsListing: SponsorsListing;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** The different kinds of records that can be featured on a GitHub Sponsors profile page. */
export enum SponsorsListingFeaturedItemFeatureableType {
  /** A repository owned by the user or organization with the GitHub Sponsors profile. */
  Repository = 'REPOSITORY',
  /** A user who belongs to the organization with the GitHub Sponsors profile. */
  User = 'USER'
}

/** A GitHub Sponsors tier associated with a GitHub Sponsors listing. */
export type SponsorsTier = Node & {
  __typename?: 'SponsorsTier';
  /** SponsorsTier information only visible to users that can administer the associated Sponsors listing. */
  adminInfo?: Maybe<SponsorsTierAdminInfo>;
  /**
   * Get a different tier for this tier's maintainer that is at the same frequency
   * as this tier but with an equal or lesser cost. Returns the published tier with
   * the monthly price closest to this tier's without going over.
   */
  closestLesserValueTier?: Maybe<SponsorsTier>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The description of the tier. */
  description: Scalars['String']['output'];
  /** The tier description rendered to HTML */
  descriptionHTML: Scalars['HTML']['output'];
  /** The Node ID of the SponsorsTier object */
  id: Scalars['ID']['output'];
  /**
   * Whether this tier was chosen at checkout time by the sponsor rather than
   * defined ahead of time by the maintainer who manages the Sponsors listing.
   */
  isCustomAmount: Scalars['Boolean']['output'];
  /** Whether this tier is only for use with one-time sponsorships. */
  isOneTime: Scalars['Boolean']['output'];
  /** How much this tier costs per month in cents. */
  monthlyPriceInCents: Scalars['Int']['output'];
  /** How much this tier costs per month in USD. */
  monthlyPriceInDollars: Scalars['Int']['output'];
  /** The name of the tier. */
  name: Scalars['String']['output'];
  /** The sponsors listing that this tier belongs to. */
  sponsorsListing: SponsorsListing;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** SponsorsTier information only visible to users that can administer the associated Sponsors listing. */
export type SponsorsTierAdminInfo = {
  __typename?: 'SponsorsTierAdminInfo';
  /**
   * Indicates whether this tier is still a work in progress by the sponsorable and
   * not yet published to the associated GitHub Sponsors profile. Draft tiers
   * cannot be used for new sponsorships and will not be in use on existing
   * sponsorships. Draft tiers cannot be seen by anyone but the admins of the
   * GitHub Sponsors profile.
   */
  isDraft: Scalars['Boolean']['output'];
  /**
   * Indicates whether this tier is published to the associated GitHub Sponsors
   * profile. Published tiers are visible to anyone who can see the GitHub Sponsors
   * profile, and are available for use in sponsorships if the GitHub Sponsors
   * profile is publicly visible.
   */
  isPublished: Scalars['Boolean']['output'];
  /**
   * Indicates whether this tier has been retired from the associated GitHub
   * Sponsors profile. Retired tiers are no longer shown on the GitHub Sponsors
   * profile and cannot be chosen for new sponsorships. Existing sponsorships may
   * still use retired tiers if the sponsor selected the tier before it was retired.
   */
  isRetired: Scalars['Boolean']['output'];
  /** The sponsorships using this tier. */
  sponsorships: SponsorshipConnection;
};


/** SponsorsTier information only visible to users that can administer the associated Sponsors listing. */
export type SponsorsTierAdminInfoSponsorshipsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includePrivate?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SponsorshipOrder>;
};

/** The connection type for SponsorsTier. */
export type SponsorsTierConnection = {
  __typename?: 'SponsorsTierConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SponsorsTierEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<SponsorsTier>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SponsorsTierEdge = {
  __typename?: 'SponsorsTierEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SponsorsTier>;
};

/** Ordering options for Sponsors tiers connections. */
export type SponsorsTierOrder = {
  /** The ordering direction. */
  direction: OrderDirection;
  /** The field to order tiers by. */
  field: SponsorsTierOrderField;
};

/** Properties by which Sponsors tiers connections can be ordered. */
export enum SponsorsTierOrderField {
  /** Order tiers by creation time. */
  CreatedAt = 'CREATED_AT',
  /** Order tiers by their monthly price in cents */
  MonthlyPriceInCents = 'MONTHLY_PRICE_IN_CENTS'
}

/** A sponsorship relationship between a sponsor and a maintainer */
export type Sponsorship = Node & {
  __typename?: 'Sponsorship';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The Node ID of the Sponsorship object */
  id: Scalars['ID']['output'];
  /**
   * Whether the sponsorship is active. False implies the sponsor is a past sponsor
   * of the maintainer, while true implies they are a current sponsor.
   */
  isActive: Scalars['Boolean']['output'];
  /** Whether this sponsorship represents a one-time payment versus a recurring sponsorship. */
  isOneTimePayment: Scalars['Boolean']['output'];
  /**
   * Whether the sponsor has chosen to receive sponsorship update emails sent from
   * the sponsorable. Only returns a non-null value when the viewer has permission to know this.
   */
  isSponsorOptedIntoEmail?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The entity that is being sponsored
   * @deprecated `Sponsorship.maintainer` will be removed. Use `Sponsorship.sponsorable` instead. Removal on 2020-04-01 UTC.
   */
  maintainer: User;
  /** The platform that was most recently used to pay for the sponsorship. */
  paymentSource?: Maybe<SponsorshipPaymentSource>;
  /** The privacy level for this sponsorship. */
  privacyLevel: SponsorshipPrivacy;
  /**
   * The user that is sponsoring. Returns null if the sponsorship is private or if sponsor is not a user.
   * @deprecated `Sponsorship.sponsor` will be removed. Use `Sponsorship.sponsorEntity` instead. Removal on 2020-10-01 UTC.
   */
  sponsor?: Maybe<User>;
  /** The user or organization that is sponsoring, if you have permission to view them. */
  sponsorEntity?: Maybe<Sponsor>;
  /** The entity that is being sponsored */
  sponsorable: Sponsorable;
  /** The associated sponsorship tier */
  tier?: Maybe<SponsorsTier>;
  /** Identifies the date and time when the current tier was chosen for this sponsorship. */
  tierSelectedAt?: Maybe<Scalars['DateTime']['output']>;
};

/** A list of sponsorships either from the subject or received by the subject. */
export type SponsorshipConnection = {
  __typename?: 'SponsorshipConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SponsorshipEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Sponsorship>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
  /**
   * The total amount in cents of all recurring sponsorships in the connection
   * whose amount you can view. Does not include one-time sponsorships.
   */
  totalRecurringMonthlyPriceInCents: Scalars['Int']['output'];
  /**
   * The total amount in USD of all recurring sponsorships in the connection whose
   * amount you can view. Does not include one-time sponsorships.
   */
  totalRecurringMonthlyPriceInDollars: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SponsorshipEdge = {
  __typename?: 'SponsorshipEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Sponsorship>;
};

/** An update sent to sponsors of a user or organization on GitHub Sponsors. */
export type SponsorshipNewsletter = Node & {
  __typename?: 'SponsorshipNewsletter';
  /** The author of the newsletter. */
  author?: Maybe<User>;
  /** The contents of the newsletter, the message the sponsorable wanted to give. */
  body: Scalars['String']['output'];
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The Node ID of the SponsorshipNewsletter object */
  id: Scalars['ID']['output'];
  /** Indicates if the newsletter has been made available to sponsors. */
  isPublished: Scalars['Boolean']['output'];
  /** The user or organization this newsletter is from. */
  sponsorable: Sponsorable;
  /** The subject of the newsletter, what it's about. */
  subject: Scalars['String']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** The connection type for SponsorshipNewsletter. */
export type SponsorshipNewsletterConnection = {
  __typename?: 'SponsorshipNewsletterConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SponsorshipNewsletterEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<SponsorshipNewsletter>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SponsorshipNewsletterEdge = {
  __typename?: 'SponsorshipNewsletterEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SponsorshipNewsletter>;
};

/** Ordering options for sponsorship newsletter connections. */
export type SponsorshipNewsletterOrder = {
  /** The ordering direction. */
  direction: OrderDirection;
  /** The field to order sponsorship newsletters by. */
  field: SponsorshipNewsletterOrderField;
};

/** Properties by which sponsorship update connections can be ordered. */
export enum SponsorshipNewsletterOrderField {
  /** Order sponsorship newsletters by when they were created. */
  CreatedAt = 'CREATED_AT'
}

/** Ordering options for sponsorship connections. */
export type SponsorshipOrder = {
  /** The ordering direction. */
  direction: OrderDirection;
  /** The field to order sponsorship by. */
  field: SponsorshipOrderField;
};

/** Properties by which sponsorship connections can be ordered. */
export enum SponsorshipOrderField {
  /** Order sponsorship by creation time. */
  CreatedAt = 'CREATED_AT'
}

/** How payment was made for funding a GitHub Sponsors sponsorship. */
export enum SponsorshipPaymentSource {
  /** Payment was made through GitHub. */
  Github = 'GITHUB',
  /** Payment was made through Patreon. */
  Patreon = 'PATREON'
}

/** The privacy of a sponsorship */
export enum SponsorshipPrivacy {
  /** Private */
  Private = 'PRIVATE',
  /** Public */
  Public = 'PUBLIC'
}

/** The possible default commit messages for squash merges. */
export enum SquashMergeCommitMessage {
  /** Default to a blank commit message. */
  Blank = 'BLANK',
  /** Default to the branch's commit messages. */
  CommitMessages = 'COMMIT_MESSAGES',
  /** Default to the pull request's body. */
  PrBody = 'PR_BODY'
}

/** The possible default commit titles for squash merges. */
export enum SquashMergeCommitTitle {
  /** Default to the commit's title (if only one commit) or the pull request's title (when more than one commit). */
  CommitOrPrTitle = 'COMMIT_OR_PR_TITLE',
  /** Default to the pull request's title. */
  PrTitle = 'PR_TITLE'
}

/** Represents an SSH signature on a Commit or Tag. */
export type SshSignature = GitSignature & {
  __typename?: 'SshSignature';
  /** Email used to sign this object. */
  email: Scalars['String']['output'];
  /** True if the signature is valid and verified by GitHub. */
  isValid: Scalars['Boolean']['output'];
  /** Hex-encoded fingerprint of the key that signed this object. */
  keyFingerprint?: Maybe<Scalars['String']['output']>;
  /** Payload for GPG signing object. Raw ODB object without the signature header. */
  payload: Scalars['String']['output'];
  /** ASCII-armored signature header from object. */
  signature: Scalars['String']['output'];
  /** GitHub user corresponding to the email signing this commit. */
  signer?: Maybe<User>;
  /**
   * The state of this signature. `VALID` if signature is valid and verified by
   * GitHub, otherwise represents reason why signature is considered invalid.
   */
  state: GitSignatureState;
  /** The date the signature was verified, if valid */
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
  /** True if the signature was made with GitHub's signing key. */
  wasSignedByGitHub: Scalars['Boolean']['output'];
};

/** Ways in which star connections can be ordered. */
export type StarOrder = {
  /** The direction in which to order nodes. */
  direction: OrderDirection;
  /** The field in which to order nodes by. */
  field: StarOrderField;
};

/** Properties by which star connections can be ordered. */
export enum StarOrderField {
  /** Allows ordering a list of stars by when they were created. */
  StarredAt = 'STARRED_AT'
}

/** The connection type for User. */
export type StargazerConnection = {
  __typename?: 'StargazerConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<StargazerEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<User>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** Represents a user that's starred a repository. */
export type StargazerEdge = {
  __typename?: 'StargazerEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  node: User;
  /** Identifies when the item was starred. */
  starredAt: Scalars['DateTime']['output'];
};

/** Things that can be starred. */
export type Starrable = {
  /** The Node ID of the Starrable object */
  id: Scalars['ID']['output'];
  /** Returns a count of how many stargazers there are on this object */
  stargazerCount: Scalars['Int']['output'];
  /** A list of users who have starred this starrable. */
  stargazers: StargazerConnection;
  /** Returns a boolean indicating whether the viewing user has starred this starrable. */
  viewerHasStarred: Scalars['Boolean']['output'];
};


/** Things that can be starred. */
export type StarrableStargazersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<StarOrder>;
};

/** The connection type for Repository. */
export type StarredRepositoryConnection = {
  __typename?: 'StarredRepositoryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<StarredRepositoryEdge>>>;
  /** Is the list of stars for this user truncated? This is true for users that have many stars. */
  isOverLimit: Scalars['Boolean']['output'];
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Repository>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** Represents a starred repository. */
export type StarredRepositoryEdge = {
  __typename?: 'StarredRepositoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  node: Repository;
  /** Identifies when the item was starred. */
  starredAt: Scalars['DateTime']['output'];
};

/** Autogenerated input type of StartOrganizationMigration */
export type StartOrganizationMigrationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The migration source access token. */
  sourceAccessToken: Scalars['String']['input'];
  /** The URL of the organization to migrate. */
  sourceOrgUrl: Scalars['URI']['input'];
  /** The ID of the enterprise the target organization belongs to. */
  targetEnterpriseId: Scalars['ID']['input'];
  /** The name of the target organization. */
  targetOrgName: Scalars['String']['input'];
};

/** Autogenerated return type of StartOrganizationMigration. */
export type StartOrganizationMigrationPayload = {
  __typename?: 'StartOrganizationMigrationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The new organization migration. */
  orgMigration?: Maybe<OrganizationMigration>;
};

/** Autogenerated input type of StartRepositoryMigration */
export type StartRepositoryMigrationInput = {
  /** The migration source access token. */
  accessToken?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Whether to continue the migration on error. Defaults to `true`. */
  continueOnError?: InputMaybe<Scalars['Boolean']['input']>;
  /** The signed URL to access the user-uploaded git archive. */
  gitArchiveUrl?: InputMaybe<Scalars['String']['input']>;
  /** The GitHub personal access token of the user importing to the target repository. */
  githubPat?: InputMaybe<Scalars['String']['input']>;
  /** Whether to lock the source repository. */
  lockSource?: InputMaybe<Scalars['Boolean']['input']>;
  /** The signed URL to access the user-uploaded metadata archive. */
  metadataArchiveUrl?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the organization that will own the imported repository. */
  ownerId: Scalars['ID']['input'];
  /** The name of the imported repository. */
  repositoryName: Scalars['String']['input'];
  /** Whether to skip migrating releases for the repository. */
  skipReleases?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the migration source. */
  sourceId: Scalars['ID']['input'];
  /** The URL of the source repository. */
  sourceRepositoryUrl: Scalars['URI']['input'];
  /** The visibility of the imported repository. */
  targetRepoVisibility?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of StartRepositoryMigration. */
export type StartRepositoryMigrationPayload = {
  __typename?: 'StartRepositoryMigrationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The new repository migration. */
  repositoryMigration?: Maybe<RepositoryMigration>;
};

/** Represents a commit status. */
export type Status = Node & {
  __typename?: 'Status';
  /** A list of status contexts and check runs for this commit. */
  combinedContexts: StatusCheckRollupContextConnection;
  /** The commit this status is attached to. */
  commit?: Maybe<Commit>;
  /** Looks up an individual status context by context name. */
  context?: Maybe<StatusContext>;
  /** The individual status contexts for this commit. */
  contexts: Array<StatusContext>;
  /** The Node ID of the Status object */
  id: Scalars['ID']['output'];
  /** The combined commit status. */
  state: StatusState;
};


/** Represents a commit status. */
export type StatusCombinedContextsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents a commit status. */
export type StatusContextArgs = {
  name: Scalars['String']['input'];
};

/** Required status check */
export type StatusCheckConfiguration = {
  __typename?: 'StatusCheckConfiguration';
  /** The status check context name that must be present on the commit. */
  context: Scalars['String']['output'];
  /** The optional integration ID that this status check must originate from. */
  integrationId?: Maybe<Scalars['Int']['output']>;
};

/** Required status check */
export type StatusCheckConfigurationInput = {
  /** The status check context name that must be present on the commit. */
  context: Scalars['String']['input'];
  /** The optional integration ID that this status check must originate from. */
  integrationId?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents the rollup for both the check runs and status for a commit. */
export type StatusCheckRollup = Node & {
  __typename?: 'StatusCheckRollup';
  /** The commit the status and check runs are attached to. */
  commit?: Maybe<Commit>;
  /** A list of status contexts and check runs for this commit. */
  contexts: StatusCheckRollupContextConnection;
  /** The Node ID of the StatusCheckRollup object */
  id: Scalars['ID']['output'];
  /** The combined status for the commit. */
  state: StatusState;
};


/** Represents the rollup for both the check runs and status for a commit. */
export type StatusCheckRollupContextsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Types that can be inside a StatusCheckRollup context. */
export type StatusCheckRollupContext = CheckRun | StatusContext;

/** The connection type for StatusCheckRollupContext. */
export type StatusCheckRollupContextConnection = {
  __typename?: 'StatusCheckRollupContextConnection';
  /** The number of check runs in this rollup. */
  checkRunCount: Scalars['Int']['output'];
  /** Counts of check runs by state. */
  checkRunCountsByState?: Maybe<Array<CheckRunStateCount>>;
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<StatusCheckRollupContextEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<StatusCheckRollupContext>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** The number of status contexts in this rollup. */
  statusContextCount: Scalars['Int']['output'];
  /** Counts of status contexts by state. */
  statusContextCountsByState?: Maybe<Array<StatusContextStateCount>>;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type StatusCheckRollupContextEdge = {
  __typename?: 'StatusCheckRollupContextEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<StatusCheckRollupContext>;
};

/** Represents an individual commit status context */
export type StatusContext = Node & RequirableByPullRequest & {
  __typename?: 'StatusContext';
  /** The avatar of the OAuth application or the user that created the status */
  avatarUrl?: Maybe<Scalars['URI']['output']>;
  /** This commit this status context is attached to. */
  commit?: Maybe<Commit>;
  /** The name of this status context. */
  context: Scalars['String']['output'];
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The actor who created this status context. */
  creator?: Maybe<Actor>;
  /** The description for this status context. */
  description?: Maybe<Scalars['String']['output']>;
  /** The Node ID of the StatusContext object */
  id: Scalars['ID']['output'];
  /** Whether this is required to pass before merging for a specific pull request. */
  isRequired: Scalars['Boolean']['output'];
  /** The state of this status context. */
  state: StatusState;
  /** The URL for this status context. */
  targetUrl?: Maybe<Scalars['URI']['output']>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};


/** Represents an individual commit status context */
export type StatusContextAvatarUrlArgs = {
  size?: InputMaybe<Scalars['Int']['input']>;
};


/** Represents an individual commit status context */
export type StatusContextIsRequiredArgs = {
  pullRequestId?: InputMaybe<Scalars['ID']['input']>;
  pullRequestNumber?: InputMaybe<Scalars['Int']['input']>;
};

/** Represents a count of the state of a status context. */
export type StatusContextStateCount = {
  __typename?: 'StatusContextStateCount';
  /** The number of statuses with this state. */
  count: Scalars['Int']['output'];
  /** The state of a status context. */
  state: StatusState;
};

/** The possible commit status states. */
export enum StatusState {
  /** Status is errored. */
  Error = 'ERROR',
  /** Status is expected. */
  Expected = 'EXPECTED',
  /** Status is failing. */
  Failure = 'FAILURE',
  /** Status is pending. */
  Pending = 'PENDING',
  /** Status is successful. */
  Success = 'SUCCESS'
}

/** A Stripe Connect account for receiving sponsorship funds from GitHub Sponsors. */
export type StripeConnectAccount = {
  __typename?: 'StripeConnectAccount';
  /** The account number used to identify this Stripe Connect account. */
  accountId: Scalars['String']['output'];
  /**
   * The name of the country or region of an external account, such as a bank
   * account, tied to the Stripe Connect account. Will only return a value when
   * queried by the maintainer of the associated GitHub Sponsors profile
   * themselves, or by an admin of the sponsorable organization.
   */
  billingCountryOrRegion?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the country or region of the Stripe Connect account. Will only
   * return a value when queried by the maintainer of the associated GitHub
   * Sponsors profile themselves, or by an admin of the sponsorable organization.
   */
  countryOrRegion?: Maybe<Scalars['String']['output']>;
  /** Whether this Stripe Connect account is currently in use for the associated GitHub Sponsors profile. */
  isActive: Scalars['Boolean']['output'];
  /** The GitHub Sponsors profile associated with this Stripe Connect account. */
  sponsorsListing: SponsorsListing;
  /** The URL to access this Stripe Connect account on Stripe's website. */
  stripeDashboardUrl: Scalars['URI']['output'];
};

/** Represents a 'sub_issue_added' event on a given issue. */
export type SubIssueAddedEvent = Node & {
  __typename?: 'SubIssueAddedEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The Node ID of the SubIssueAddedEvent object */
  id: Scalars['ID']['output'];
  /** The sub-issue added. */
  subIssue?: Maybe<Issue>;
};

/** Represents a 'sub_issue_removed' event on a given issue. */
export type SubIssueRemovedEvent = Node & {
  __typename?: 'SubIssueRemovedEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The Node ID of the SubIssueRemovedEvent object */
  id: Scalars['ID']['output'];
  /** The sub-issue removed. */
  subIssue?: Maybe<Issue>;
};

/** Summary of the state of an issue's sub-issues */
export type SubIssuesSummary = {
  __typename?: 'SubIssuesSummary';
  /** Count of completed sub-issues */
  completed: Scalars['Int']['output'];
  /** Percent of sub-issues which are completed */
  percentCompleted: Scalars['Int']['output'];
  /** Count of total number of sub-issues */
  total: Scalars['Int']['output'];
};

/** Autogenerated input type of SubmitPullRequestReview */
export type SubmitPullRequestReviewInput = {
  /** The text field to set on the Pull Request Review. */
  body?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The event to send to the Pull Request Review. */
  event: PullRequestReviewEvent;
  /** The Pull Request ID to submit any pending reviews. */
  pullRequestId?: InputMaybe<Scalars['ID']['input']>;
  /** The Pull Request Review ID to submit. */
  pullRequestReviewId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of SubmitPullRequestReview. */
export type SubmitPullRequestReviewPayload = {
  __typename?: 'SubmitPullRequestReviewPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The submitted pull request review. */
  pullRequestReview?: Maybe<PullRequestReview>;
};

/** A pointer to a repository at a specific revision embedded inside another repository. */
export type Submodule = {
  __typename?: 'Submodule';
  /** The branch of the upstream submodule for tracking updates */
  branch?: Maybe<Scalars['String']['output']>;
  /** The git URL of the submodule repository */
  gitUrl: Scalars['URI']['output'];
  /** The name of the submodule in .gitmodules */
  name: Scalars['String']['output'];
  /** The name of the submodule in .gitmodules (Base64-encoded) */
  nameRaw: Scalars['Base64String']['output'];
  /** The path in the superproject that this submodule is located in */
  path: Scalars['String']['output'];
  /** The path in the superproject that this submodule is located in (Base64-encoded) */
  pathRaw: Scalars['Base64String']['output'];
  /** The commit revision of the subproject repository being tracked by the submodule */
  subprojectCommitOid?: Maybe<Scalars['GitObjectID']['output']>;
};

/** The connection type for Submodule. */
export type SubmoduleConnection = {
  __typename?: 'SubmoduleConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SubmoduleEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Submodule>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SubmoduleEdge = {
  __typename?: 'SubmoduleEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Submodule>;
};

/** Entities that can be subscribed to for web and email notifications. */
export type Subscribable = {
  /** The Node ID of the Subscribable object */
  id: Scalars['ID']['output'];
  /** Check if the viewer is able to change their subscription status for the repository. */
  viewerCanSubscribe: Scalars['Boolean']['output'];
  /** Identifies if the viewer is watching, not watching, or ignoring the subscribable entity. */
  viewerSubscription?: Maybe<SubscriptionState>;
};

/** Entities that can be subscribed to for web and email notifications. */
export type SubscribableThread = {
  /** The Node ID of the SubscribableThread object */
  id: Scalars['ID']['output'];
  /** Identifies the viewer's thread subscription form action. */
  viewerThreadSubscriptionFormAction?: Maybe<ThreadSubscriptionFormAction>;
  /** Identifies the viewer's thread subscription status. */
  viewerThreadSubscriptionStatus?: Maybe<ThreadSubscriptionState>;
};

/** Represents a 'subscribed' event on a given `Subscribable`. */
export type SubscribedEvent = Node & {
  __typename?: 'SubscribedEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The Node ID of the SubscribedEvent object */
  id: Scalars['ID']['output'];
  /** Object referenced by event. */
  subscribable: Subscribable;
};

/** The possible states of a subscription. */
export enum SubscriptionState {
  /** The User is never notified. */
  Ignored = 'IGNORED',
  /** The User is notified of all conversations. */
  Subscribed = 'SUBSCRIBED',
  /** The User is only notified when participating or @mentioned. */
  Unsubscribed = 'UNSUBSCRIBED'
}

/** A suggestion to review a pull request based on a user's commit history and review comments. */
export type SuggestedReviewer = {
  __typename?: 'SuggestedReviewer';
  /** Is this suggestion based on past commits? */
  isAuthor: Scalars['Boolean']['output'];
  /** Is this suggestion based on past review comments? */
  isCommenter: Scalars['Boolean']['output'];
  /** Identifies the user suggested to review the pull request. */
  reviewer: User;
};

/** A suggestion to review a pull request based on an actor's commit history, review comments, and integrations. */
export type SuggestedReviewerActor = {
  __typename?: 'SuggestedReviewerActor';
  /** Is this suggestion based on past commits? */
  isAuthor: Scalars['Boolean']['output'];
  /** Is this suggestion based on past review comments? */
  isCommenter: Scalars['Boolean']['output'];
  /** Identifies the actor suggested to review the pull request. */
  reviewer: Actor;
};

/** A suggestion to review a pull request based on an actor's commit history, review comments, and integrations. */
export type SuggestedReviewerActorConnection = {
  __typename?: 'SuggestedReviewerActorConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<SuggestedReviewerActorEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<SuggestedReviewerActor>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type SuggestedReviewerActorEdge = {
  __typename?: 'SuggestedReviewerActorEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<SuggestedReviewerActor>;
};

/** Represents a Git tag. */
export type Tag = GitObject & Node & {
  __typename?: 'Tag';
  /** An abbreviated version of the Git object ID */
  abbreviatedOid: Scalars['String']['output'];
  /** The HTTP path for this Git object */
  commitResourcePath: Scalars['URI']['output'];
  /** The HTTP URL for this Git object */
  commitUrl: Scalars['URI']['output'];
  /** The Node ID of the Tag object */
  id: Scalars['ID']['output'];
  /** The Git tag message. */
  message?: Maybe<Scalars['String']['output']>;
  /** The Git tag name. */
  name: Scalars['String']['output'];
  /** The Git object ID */
  oid: Scalars['GitObjectID']['output'];
  /** The Repository the Git object belongs to */
  repository: Repository;
  /** Details about the tag author. */
  tagger?: Maybe<GitActor>;
  /** The Git object the tag points to. */
  target: GitObject;
};

/** Parameters to be used for the tag_name_pattern rule */
export type TagNamePatternParameters = {
  __typename?: 'TagNamePatternParameters';
  /** How this rule appears when configuring it. */
  name?: Maybe<Scalars['String']['output']>;
  /** If true, the rule will fail if the pattern matches. */
  negate: Scalars['Boolean']['output'];
  /** The operator to use for matching. */
  operator: Scalars['String']['output'];
  /** The pattern to match with. */
  pattern: Scalars['String']['output'];
};

/** Parameters to be used for the tag_name_pattern rule */
export type TagNamePatternParametersInput = {
  /** How this rule appears when configuring it. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** If true, the rule will fail if the pattern matches. */
  negate?: InputMaybe<Scalars['Boolean']['input']>;
  /** The operator to use for matching. */
  operator: Scalars['String']['input'];
  /** The pattern to match with. */
  pattern: Scalars['String']['input'];
};

/** A team of users in an organization. */
export type Team = MemberStatusable & Node & Subscribable & TeamReviewRequestable & {
  __typename?: 'Team';
  /** A list of teams that are ancestors of this team. */
  ancestors: TeamConnection;
  /** A URL pointing to the team's avatar. */
  avatarUrl?: Maybe<Scalars['URI']['output']>;
  /** List of child teams belonging to this team */
  childTeams: TeamConnection;
  /** The slug corresponding to the organization and team. */
  combinedSlug: Scalars['String']['output'];
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Identifies the primary key from the database. */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** The description of the team. */
  description?: Maybe<Scalars['String']['output']>;
  /** The HTTP path for editing this team */
  editTeamResourcePath: Scalars['URI']['output'];
  /** The HTTP URL for editing this team */
  editTeamUrl: Scalars['URI']['output'];
  /** The Node ID of the Team object */
  id: Scalars['ID']['output'];
  /** A list of pending invitations for users to this team */
  invitations?: Maybe<OrganizationInvitationConnection>;
  /** Get the status messages members of this entity have set that are either public or visible only to the organization. */
  memberStatuses: UserStatusConnection;
  /** A list of users who are members of this team. */
  members: TeamMemberConnection;
  /** The HTTP path for the team' members */
  membersResourcePath: Scalars['URI']['output'];
  /** The HTTP URL for the team' members */
  membersUrl: Scalars['URI']['output'];
  /** The name of the team. */
  name: Scalars['String']['output'];
  /** The HTTP path creating a new team */
  newTeamResourcePath: Scalars['URI']['output'];
  /** The HTTP URL creating a new team */
  newTeamUrl: Scalars['URI']['output'];
  /** The notification setting that the team has set. */
  notificationSetting: TeamNotificationSetting;
  /** The organization that owns this team. */
  organization: Organization;
  /** The parent team of the team. */
  parentTeam?: Maybe<Team>;
  /** The level of privacy the team has. */
  privacy: TeamPrivacy;
  /** Finds and returns the project according to the provided project number. */
  projectV2?: Maybe<ProjectV2>;
  /** List of projects this team has collaborator access to. */
  projectsV2: ProjectV2Connection;
  /** A list of repositories this team has access to. */
  repositories: TeamRepositoryConnection;
  /** The HTTP path for this team's repositories */
  repositoriesResourcePath: Scalars['URI']['output'];
  /** The HTTP URL for this team's repositories */
  repositoriesUrl: Scalars['URI']['output'];
  /** The HTTP path for this team */
  resourcePath: Scalars['URI']['output'];
  /** What algorithm is used for review assignment for this team */
  reviewRequestDelegationAlgorithm?: Maybe<TeamReviewAssignmentAlgorithm>;
  /** True if review assignment is enabled for this team */
  reviewRequestDelegationEnabled: Scalars['Boolean']['output'];
  /** How many team members are required for review assignment for this team */
  reviewRequestDelegationMemberCount?: Maybe<Scalars['Int']['output']>;
  /** When assigning team members via delegation, whether the entire team should be notified as well. */
  reviewRequestDelegationNotifyTeam: Scalars['Boolean']['output'];
  /** The slug corresponding to the team. */
  slug: Scalars['String']['output'];
  /** The HTTP path for this team's teams */
  teamsResourcePath: Scalars['URI']['output'];
  /** The HTTP URL for this team's teams */
  teamsUrl: Scalars['URI']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The HTTP URL for this team */
  url: Scalars['URI']['output'];
  /** Team is adminable by the viewer. */
  viewerCanAdminister: Scalars['Boolean']['output'];
  /**
   * Check if the viewer is able to change their subscription status for the subscribable entity.
   * @deprecated `Team.viewerCanSubscribe` will be removed. Team notifications subscriptions are being deprecated. Removal on 2026-07-01 UTC.
   */
  viewerCanSubscribe: Scalars['Boolean']['output'];
  /**
   * Identifies if the viewer is watching, not watching, or ignoring the subscribable entity.
   * @deprecated `Team.viewerSubscription` will be removed. Team notifications subscriptions are being deprecated. Removal on 2026-07-01 UTC.
   */
  viewerSubscription?: Maybe<SubscriptionState>;
};


/** A team of users in an organization. */
export type TeamAncestorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A team of users in an organization. */
export type TeamAvatarUrlArgs = {
  size?: InputMaybe<Scalars['Int']['input']>;
};


/** A team of users in an organization. */
export type TeamChildTeamsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  immediateOnly?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TeamOrder>;
  userLogins?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** A team of users in an organization. */
export type TeamInvitationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A team of users in an organization. */
export type TeamMemberStatusesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<UserStatusOrder>;
};


/** A team of users in an organization. */
export type TeamMembersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  membership?: InputMaybe<TeamMembershipType>;
  orderBy?: InputMaybe<TeamMemberOrder>;
  query?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<TeamMemberRole>;
};


/** A team of users in an organization. */
export type TeamProjectV2Args = {
  number: Scalars['Int']['input'];
};


/** A team of users in an organization. */
export type TeamProjectsV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<ProjectV2Filters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  minPermissionLevel?: InputMaybe<ProjectV2PermissionLevel>;
  orderBy?: InputMaybe<ProjectV2Order>;
  query?: InputMaybe<Scalars['String']['input']>;
};


/** A team of users in an organization. */
export type TeamRepositoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<TeamRepositoryOrder>;
  query?: InputMaybe<Scalars['String']['input']>;
};

/** Audit log entry for a team.add_member event. */
export type TeamAddMemberAuditEntry = AuditEntry & Node & OrganizationAuditEntryData & TeamAuditEntryData & {
  __typename?: 'TeamAddMemberAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /** The Node ID of the TeamAddMemberAuditEntry object */
  id: Scalars['ID']['output'];
  /**
   * Whether the team was mapped to an LDAP Group.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  isLdapMapped?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /** The team associated with the action */
  team?: Maybe<Team>;
  /** The name of the team */
  teamName?: Maybe<Scalars['String']['output']>;
  /** The HTTP path for this team */
  teamResourcePath?: Maybe<Scalars['URI']['output']>;
  /** The HTTP URL for this team */
  teamUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
};

/** Audit log entry for a team.add_repository event. */
export type TeamAddRepositoryAuditEntry = AuditEntry & Node & OrganizationAuditEntryData & RepositoryAuditEntryData & TeamAuditEntryData & {
  __typename?: 'TeamAddRepositoryAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /** The Node ID of the TeamAddRepositoryAuditEntry object */
  id: Scalars['ID']['output'];
  /**
   * Whether the team was mapped to an LDAP Group.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  isLdapMapped?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /** The repository associated with the action */
  repository?: Maybe<Repository>;
  /** The name of the repository */
  repositoryName?: Maybe<Scalars['String']['output']>;
  /** The HTTP path for the repository */
  repositoryResourcePath?: Maybe<Scalars['URI']['output']>;
  /** The HTTP URL for the repository */
  repositoryUrl?: Maybe<Scalars['URI']['output']>;
  /** The team associated with the action */
  team?: Maybe<Team>;
  /** The name of the team */
  teamName?: Maybe<Scalars['String']['output']>;
  /** The HTTP path for this team */
  teamResourcePath?: Maybe<Scalars['URI']['output']>;
  /** The HTTP URL for this team */
  teamUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
};

/** Metadata for an audit entry with action team.* */
export type TeamAuditEntryData = {
  /** The team associated with the action */
  team?: Maybe<Team>;
  /** The name of the team */
  teamName?: Maybe<Scalars['String']['output']>;
  /** The HTTP path for this team */
  teamResourcePath?: Maybe<Scalars['URI']['output']>;
  /** The HTTP URL for this team */
  teamUrl?: Maybe<Scalars['URI']['output']>;
};

/** Audit log entry for a team.change_parent_team event. */
export type TeamChangeParentTeamAuditEntry = AuditEntry & Node & OrganizationAuditEntryData & TeamAuditEntryData & {
  __typename?: 'TeamChangeParentTeamAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /** The Node ID of the TeamChangeParentTeamAuditEntry object */
  id: Scalars['ID']['output'];
  /**
   * Whether the team was mapped to an LDAP Group.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  isLdapMapped?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The new parent team.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  parentTeam?: Maybe<Team>;
  /**
   * The name of the new parent team
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  parentTeamName?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the former parent team
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  parentTeamNameWas?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the parent team
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  parentTeamResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the parent team
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  parentTeamUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The former parent team.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  parentTeamWas?: Maybe<Team>;
  /**
   * The HTTP path for the previous parent team
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  parentTeamWasResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the previous parent team
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  parentTeamWasUrl?: Maybe<Scalars['URI']['output']>;
  /** The team associated with the action */
  team?: Maybe<Team>;
  /** The name of the team */
  teamName?: Maybe<Scalars['String']['output']>;
  /** The HTTP path for this team */
  teamResourcePath?: Maybe<Scalars['URI']['output']>;
  /** The HTTP URL for this team */
  teamUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
};

/** The connection type for Team. */
export type TeamConnection = {
  __typename?: 'TeamConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TeamEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Team>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type TeamEdge = {
  __typename?: 'TeamEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<Team>;
};

/** The connection type for User. */
export type TeamMemberConnection = {
  __typename?: 'TeamMemberConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TeamMemberEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<User>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** Represents a user who is a member of a team. */
export type TeamMemberEdge = {
  __typename?: 'TeamMemberEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The HTTP path to the organization's member access page. */
  memberAccessResourcePath: Scalars['URI']['output'];
  /** The HTTP URL to the organization's member access page. */
  memberAccessUrl: Scalars['URI']['output'];
  node: User;
  /** The role the member has on the team. */
  role: TeamMemberRole;
};

/** Ordering options for team member connections */
export type TeamMemberOrder = {
  /** The ordering direction. */
  direction: OrderDirection;
  /** The field to order team members by. */
  field: TeamMemberOrderField;
};

/** Properties by which team member connections can be ordered. */
export enum TeamMemberOrderField {
  /** Order team members by creation time */
  CreatedAt = 'CREATED_AT',
  /** Order team members by login */
  Login = 'LOGIN'
}

/** The possible team member roles; either 'maintainer' or 'member'. */
export enum TeamMemberRole {
  /** A team maintainer has permission to add and remove team members. */
  Maintainer = 'MAINTAINER',
  /** A team member has no administrative permissions on the team. */
  Member = 'MEMBER'
}

/** Defines which types of team members are included in the returned list. Can be one of IMMEDIATE, CHILD_TEAM or ALL. */
export enum TeamMembershipType {
  /** Includes immediate and child team members for the team. */
  All = 'ALL',
  /** Includes only child team members for the team. */
  ChildTeam = 'CHILD_TEAM',
  /** Includes only immediate members of the team. */
  Immediate = 'IMMEDIATE'
}

/** The possible team notification values. */
export enum TeamNotificationSetting {
  /** No one will receive notifications. */
  NotificationsDisabled = 'NOTIFICATIONS_DISABLED',
  /** Everyone will receive notifications when the team is @mentioned. */
  NotificationsEnabled = 'NOTIFICATIONS_ENABLED'
}

/** Ways in which team connections can be ordered. */
export type TeamOrder = {
  /** The direction in which to order nodes. */
  direction: OrderDirection;
  /** The field in which to order nodes by. */
  field: TeamOrderField;
};

/** Properties by which team connections can be ordered. */
export enum TeamOrderField {
  /** Allows ordering a list of teams by name. */
  Name = 'NAME'
}

/** The possible team privacy values. */
export enum TeamPrivacy {
  /** A secret team can only be seen by its members. */
  Secret = 'SECRET',
  /** A visible team can be seen and @mentioned by every member of the organization. */
  Visible = 'VISIBLE'
}

/** Audit log entry for a team.remove_member event. */
export type TeamRemoveMemberAuditEntry = AuditEntry & Node & OrganizationAuditEntryData & TeamAuditEntryData & {
  __typename?: 'TeamRemoveMemberAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /** The Node ID of the TeamRemoveMemberAuditEntry object */
  id: Scalars['ID']['output'];
  /**
   * Whether the team was mapped to an LDAP Group.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  isLdapMapped?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /** The team associated with the action */
  team?: Maybe<Team>;
  /** The name of the team */
  teamName?: Maybe<Scalars['String']['output']>;
  /** The HTTP path for this team */
  teamResourcePath?: Maybe<Scalars['URI']['output']>;
  /** The HTTP URL for this team */
  teamUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
};

/** Audit log entry for a team.remove_repository event. */
export type TeamRemoveRepositoryAuditEntry = AuditEntry & Node & OrganizationAuditEntryData & RepositoryAuditEntryData & TeamAuditEntryData & {
  __typename?: 'TeamRemoveRepositoryAuditEntry';
  /**
   * The action name
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  action: Scalars['String']['output'];
  /**
   * The user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actor?: Maybe<AuditEntryActor>;
  /**
   * The IP address of the actor
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorIp?: Maybe<Scalars['String']['output']>;
  /**
   * A readable representation of the actor's location
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLocation?: Maybe<ActorLocation>;
  /**
   * The username of the user who initiated the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the actor.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  actorUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The time the action was initiated
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  createdAt: Scalars['PreciseDateTime']['output'];
  /** The Node ID of the TeamRemoveRepositoryAuditEntry object */
  id: Scalars['ID']['output'];
  /**
   * Whether the team was mapped to an LDAP Group.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  isLdapMapped?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The corresponding operation type for the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  operationType?: Maybe<OperationType>;
  /**
   * The Organization associated with the Audit Entry.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organization?: Maybe<Organization>;
  /**
   * The name of the Organization.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationName?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the organization
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  organizationUrl?: Maybe<Scalars['URI']['output']>;
  /** The repository associated with the action */
  repository?: Maybe<Repository>;
  /** The name of the repository */
  repositoryName?: Maybe<Scalars['String']['output']>;
  /** The HTTP path for the repository */
  repositoryResourcePath?: Maybe<Scalars['URI']['output']>;
  /** The HTTP URL for the repository */
  repositoryUrl?: Maybe<Scalars['URI']['output']>;
  /** The team associated with the action */
  team?: Maybe<Team>;
  /** The name of the team */
  teamName?: Maybe<Scalars['String']['output']>;
  /** The HTTP path for this team */
  teamResourcePath?: Maybe<Scalars['URI']['output']>;
  /** The HTTP URL for this team */
  teamUrl?: Maybe<Scalars['URI']['output']>;
  /**
   * The user affected by the action
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  user?: Maybe<User>;
  /**
   * For actions involving two users, the actor is the initiator and the user is the affected user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userLogin?: Maybe<Scalars['String']['output']>;
  /**
   * The HTTP path for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userResourcePath?: Maybe<Scalars['URI']['output']>;
  /**
   * The HTTP URL for the user.
   * @deprecated The GraphQL audit-log is deprecated. Please use the REST API instead. Removal on 2026-04-01 UTC.
   */
  userUrl?: Maybe<Scalars['URI']['output']>;
};

/** The connection type for Repository. */
export type TeamRepositoryConnection = {
  __typename?: 'TeamRepositoryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<TeamRepositoryEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<Repository>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** Represents a team repository. */
export type TeamRepositoryEdge = {
  __typename?: 'TeamRepositoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  node: Repository;
  /** The permission level the team has on the repository */
  permission: RepositoryPermission;
};

/** Ordering options for team repository connections */
export type TeamRepositoryOrder = {
  /** The ordering direction. */
  direction: OrderDirection;
  /** The field to order repositories by. */
  field: TeamRepositoryOrderField;
};

/** Properties by which team repository connections can be ordered. */
export enum TeamRepositoryOrderField {
  /** Order repositories by creation time */
  CreatedAt = 'CREATED_AT',
  /** Order repositories by name */
  Name = 'NAME',
  /** Order repositories by permission */
  Permission = 'PERMISSION',
  /** Order repositories by push time */
  PushedAt = 'PUSHED_AT',
  /** Order repositories by number of stargazers */
  Stargazers = 'STARGAZERS',
  /** Order repositories by update time */
  UpdatedAt = 'UPDATED_AT'
}

/** The possible team review assignment algorithms */
export enum TeamReviewAssignmentAlgorithm {
  /** Balance review load across the entire team */
  LoadBalance = 'LOAD_BALANCE',
  /** Alternate reviews between each team member */
  RoundRobin = 'ROUND_ROBIN'
}

/** Represents a team that can be requested to review a pull request. */
export type TeamReviewRequestable = {
  /** The Node ID of the TeamReviewRequestable object */
  id: Scalars['ID']['output'];
  /** The name of the team. */
  name: Scalars['String']['output'];
  /** A unique, human-readable identifier for the team. */
  slug: Scalars['String']['output'];
};

/** The role of a user on a team. */
export enum TeamRole {
  /** User has admin rights on the team. */
  Admin = 'ADMIN',
  /** User is a member of the team. */
  Member = 'MEMBER'
}

/** A text match within a search result. */
export type TextMatch = {
  __typename?: 'TextMatch';
  /** The specific text fragment within the property matched on. */
  fragment: Scalars['String']['output'];
  /** Highlights within the matched fragment. */
  highlights: Array<TextMatchHighlight>;
  /** The property matched on. */
  property: Scalars['String']['output'];
};

/** Represents a single highlight in a search result match. */
export type TextMatchHighlight = {
  __typename?: 'TextMatchHighlight';
  /** The indice in the fragment where the matched text begins. */
  beginIndice: Scalars['Int']['output'];
  /** The indice in the fragment where the matched text ends. */
  endIndice: Scalars['Int']['output'];
  /** The text matched. */
  text: Scalars['String']['output'];
};

/** The possible states of a thread subscription form action */
export enum ThreadSubscriptionFormAction {
  /** The User cannot subscribe or unsubscribe to the thread */
  None = 'NONE',
  /** The User can subscribe to the thread */
  Subscribe = 'SUBSCRIBE',
  /** The User can unsubscribe to the thread */
  Unsubscribe = 'UNSUBSCRIBE'
}

/** The possible states of a subscription. */
export enum ThreadSubscriptionState {
  /** The subscription status is currently disabled. */
  Disabled = 'DISABLED',
  /** The User is never notified because they are ignoring the list */
  IgnoringList = 'IGNORING_LIST',
  /** The User is never notified because they are ignoring the thread */
  IgnoringThread = 'IGNORING_THREAD',
  /** The User is not recieving notifications from this thread */
  None = 'NONE',
  /** The User is notified becuase they are watching the list */
  SubscribedToList = 'SUBSCRIBED_TO_LIST',
  /** The User is notified because they are subscribed to the thread */
  SubscribedToThread = 'SUBSCRIBED_TO_THREAD',
  /** The User is notified because they chose custom settings for this thread. */
  SubscribedToThreadEvents = 'SUBSCRIBED_TO_THREAD_EVENTS',
  /** The User is notified because they chose custom settings for this thread. */
  SubscribedToThreadType = 'SUBSCRIBED_TO_THREAD_TYPE',
  /** The subscription status is currently unavailable. */
  Unavailable = 'UNAVAILABLE'
}

/** A topic aggregates entities that are related to a subject. */
export type Topic = Node & Starrable & {
  __typename?: 'Topic';
  /** The Node ID of the Topic object */
  id: Scalars['ID']['output'];
  /** The topic's name. */
  name: Scalars['String']['output'];
  /**
   * A list of related topics, including aliases of this topic, sorted with the most relevant
   * first. Returns up to 10 Topics.
   */
  relatedTopics: Array<Topic>;
  /** A list of repositories. */
  repositories: RepositoryConnection;
  /** Returns a count of how many stargazers there are on this object */
  stargazerCount: Scalars['Int']['output'];
  /** A list of users who have starred this starrable. */
  stargazers: StargazerConnection;
  /** Returns a boolean indicating whether the viewing user has starred this starrable. */
  viewerHasStarred: Scalars['Boolean']['output'];
};


/** A topic aggregates entities that are related to a subject. */
export type TopicRelatedTopicsArgs = {
  first?: InputMaybe<Scalars['Int']['input']>;
};


/** A topic aggregates entities that are related to a subject. */
export type TopicRepositoriesArgs = {
  affiliations?: InputMaybe<Array<InputMaybe<RepositoryAffiliation>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasIssuesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<RepositoryOrder>;
  ownerAffiliations?: InputMaybe<Array<InputMaybe<RepositoryAffiliation>>>;
  privacy?: InputMaybe<RepositoryPrivacy>;
  sponsorableOnly?: InputMaybe<Scalars['Boolean']['input']>;
  visibility?: InputMaybe<RepositoryVisibility>;
};


/** A topic aggregates entities that are related to a subject. */
export type TopicStargazersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<StarOrder>;
};

/** Metadata for an audit entry with a topic. */
export type TopicAuditEntryData = {
  /** The name of the topic added to the repository */
  topic?: Maybe<Topic>;
  /** The name of the topic added to the repository */
  topicName?: Maybe<Scalars['String']['output']>;
};

/** Reason that the suggested topic is declined. */
export enum TopicSuggestionDeclineReason {
  /**
   * The suggested topic is not relevant to the repository.
   * @deprecated Suggested topics are no longer supported Removal on 2024-04-01 UTC.
   */
  NotRelevant = 'NOT_RELEVANT',
  /**
   * The viewer does not like the suggested topic.
   * @deprecated Suggested topics are no longer supported Removal on 2024-04-01 UTC.
   */
  PersonalPreference = 'PERSONAL_PREFERENCE',
  /**
   * The suggested topic is too general for the repository.
   * @deprecated Suggested topics are no longer supported Removal on 2024-04-01 UTC.
   */
  TooGeneral = 'TOO_GENERAL',
  /**
   * The suggested topic is too specific for the repository (e.g. #ruby-on-rails-version-4-2-1).
   * @deprecated Suggested topics are no longer supported Removal on 2024-04-01 UTC.
   */
  TooSpecific = 'TOO_SPECIFIC'
}

/** The possible states of a tracked issue. */
export enum TrackedIssueStates {
  /** The tracked issue is closed */
  Closed = 'CLOSED',
  /** The tracked issue is open */
  Open = 'OPEN'
}

/** Autogenerated input type of TransferEnterpriseOrganization */
export type TransferEnterpriseOrganizationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the enterprise where the organization should be transferred. */
  destinationEnterpriseId: Scalars['ID']['input'];
  /** The ID of the organization to transfer. */
  organizationId: Scalars['ID']['input'];
};

/** Autogenerated return type of TransferEnterpriseOrganization. */
export type TransferEnterpriseOrganizationPayload = {
  __typename?: 'TransferEnterpriseOrganizationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The organization for which a transfer was initiated. */
  organization?: Maybe<Organization>;
};

/** Autogenerated input type of TransferIssue */
export type TransferIssueInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Whether to create labels if they don't exist in the target repository (matched by name) */
  createLabelsIfMissing?: InputMaybe<Scalars['Boolean']['input']>;
  /** The Node ID of the issue to be transferred */
  issueId: Scalars['ID']['input'];
  /** The Node ID of the repository the issue should be transferred to */
  repositoryId: Scalars['ID']['input'];
};

/** Autogenerated return type of TransferIssue. */
export type TransferIssuePayload = {
  __typename?: 'TransferIssuePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The issue that was transferred */
  issue?: Maybe<Issue>;
};

/** Represents a 'transferred' event on a given issue or pull request. */
export type TransferredEvent = Node & {
  __typename?: 'TransferredEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The repository this came from */
  fromRepository?: Maybe<Repository>;
  /** The Node ID of the TransferredEvent object */
  id: Scalars['ID']['output'];
  /** Identifies the issue associated with the event. */
  issue: Issue;
};

/** Represents a Git tree. */
export type Tree = GitObject & Node & {
  __typename?: 'Tree';
  /** An abbreviated version of the Git object ID */
  abbreviatedOid: Scalars['String']['output'];
  /** The HTTP path for this Git object */
  commitResourcePath: Scalars['URI']['output'];
  /** The HTTP URL for this Git object */
  commitUrl: Scalars['URI']['output'];
  /** A list of tree entries. */
  entries?: Maybe<Array<TreeEntry>>;
  /** The Node ID of the Tree object */
  id: Scalars['ID']['output'];
  /** The Git object ID */
  oid: Scalars['GitObjectID']['output'];
  /** The Repository the Git object belongs to */
  repository: Repository;
};

/** Represents a Git tree entry. */
export type TreeEntry = {
  __typename?: 'TreeEntry';
  /** The extension of the file */
  extension?: Maybe<Scalars['String']['output']>;
  /** Whether or not this tree entry is generated */
  isGenerated: Scalars['Boolean']['output'];
  /** The programming language this file is written in. */
  language?: Maybe<Language>;
  /** Number of lines in the file. */
  lineCount?: Maybe<Scalars['Int']['output']>;
  /** Entry file mode. */
  mode: Scalars['Int']['output'];
  /** Entry file name. */
  name: Scalars['String']['output'];
  /** Entry file name. (Base64-encoded) */
  nameRaw: Scalars['Base64String']['output'];
  /** Entry file object. */
  object?: Maybe<GitObject>;
  /** Entry file Git object ID. */
  oid: Scalars['GitObjectID']['output'];
  /** The full path of the file. */
  path?: Maybe<Scalars['String']['output']>;
  /** The full path of the file. (Base64-encoded) */
  pathRaw?: Maybe<Scalars['Base64String']['output']>;
  /** The Repository the tree entry belongs to */
  repository: Repository;
  /** Entry byte size */
  size: Scalars['Int']['output'];
  /** If the TreeEntry is for a directory occupied by a submodule project, this returns the corresponding submodule */
  submodule?: Maybe<Submodule>;
  /** Entry file type. */
  type: Scalars['String']['output'];
};

/** Filters by whether or not 2FA is enabled and if the method configured is considered secure or insecure. */
export enum TwoFactorCredentialSecurityType {
  /** No method of two-factor authentication. */
  Disabled = 'DISABLED',
  /** Has an insecure method of two-factor authentication. GitHub currently defines this as SMS two-factor authentication. */
  Insecure = 'INSECURE',
  /** Has only secure methods of two-factor authentication. */
  Secure = 'SECURE'
}

/** Autogenerated input type of UnarchiveProjectV2Item */
export type UnarchiveProjectV2ItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the ProjectV2Item to unarchive. */
  itemId: Scalars['ID']['input'];
  /** The ID of the Project to archive the item from. */
  projectId: Scalars['ID']['input'];
};

/** Autogenerated return type of UnarchiveProjectV2Item. */
export type UnarchiveProjectV2ItemPayload = {
  __typename?: 'UnarchiveProjectV2ItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The item unarchived from the project. */
  item?: Maybe<ProjectV2Item>;
};

/** Autogenerated input type of UnarchivePullRequest */
export type UnarchivePullRequestInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Node ID of the pull request to unarchive. */
  pullRequestId: Scalars['ID']['input'];
};

/** Autogenerated return type of UnarchivePullRequest. */
export type UnarchivePullRequestPayload = {
  __typename?: 'UnarchivePullRequestPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The pull request that was unarchived. */
  pullRequest?: Maybe<PullRequest>;
};

/** Autogenerated input type of UnarchiveRepository */
export type UnarchiveRepositoryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the repository to unarchive. */
  repositoryId: Scalars['ID']['input'];
};

/** Autogenerated return type of UnarchiveRepository. */
export type UnarchiveRepositoryPayload = {
  __typename?: 'UnarchiveRepositoryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The repository that was unarchived. */
  repository?: Maybe<Repository>;
};

/** Represents an 'unassigned' event on any assignable object. */
export type UnassignedEvent = Node & {
  __typename?: 'UnassignedEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the assignable associated with the event. */
  assignable: Assignable;
  /** Identifies the user or mannequin that was unassigned. */
  assignee?: Maybe<Assignee>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The Node ID of the UnassignedEvent object */
  id: Scalars['ID']['output'];
  /**
   * Identifies the subject (user) who was unassigned.
   * @deprecated Assignees can now be mannequins. Use the `assignee` field instead. Removal on 2020-01-01 UTC.
   */
  user?: Maybe<User>;
};

/** Autogenerated input type of UnfollowOrganization */
export type UnfollowOrganizationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the organization to unfollow. */
  organizationId: Scalars['ID']['input'];
};

/** Autogenerated return type of UnfollowOrganization. */
export type UnfollowOrganizationPayload = {
  __typename?: 'UnfollowOrganizationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The organization that was unfollowed. */
  organization?: Maybe<Organization>;
};

/** Autogenerated input type of UnfollowUser */
export type UnfollowUserInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the user to unfollow. */
  userId: Scalars['ID']['input'];
};

/** Autogenerated return type of UnfollowUser. */
export type UnfollowUserPayload = {
  __typename?: 'UnfollowUserPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The user that was unfollowed. */
  user?: Maybe<User>;
};

/** Represents a type that can be retrieved by a URL. */
export type UniformResourceLocatable = {
  /** The HTML path to this resource. */
  resourcePath: Scalars['URI']['output'];
  /** The URL to this resource. */
  url: Scalars['URI']['output'];
};

/** Represents an unknown signature on a Commit or Tag. */
export type UnknownSignature = GitSignature & {
  __typename?: 'UnknownSignature';
  /** Email used to sign this object. */
  email: Scalars['String']['output'];
  /** True if the signature is valid and verified by GitHub. */
  isValid: Scalars['Boolean']['output'];
  /** Payload for GPG signing object. Raw ODB object without the signature header. */
  payload: Scalars['String']['output'];
  /** ASCII-armored signature header from object. */
  signature: Scalars['String']['output'];
  /** GitHub user corresponding to the email signing this commit. */
  signer?: Maybe<User>;
  /**
   * The state of this signature. `VALID` if signature is valid and verified by
   * GitHub, otherwise represents reason why signature is considered invalid.
   */
  state: GitSignatureState;
  /** The date the signature was verified, if valid */
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
  /** True if the signature was made with GitHub's signing key. */
  wasSignedByGitHub: Scalars['Boolean']['output'];
};

/** Represents an 'unlabeled' event on a given issue or pull request. */
export type UnlabeledEvent = Node & {
  __typename?: 'UnlabeledEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The Node ID of the UnlabeledEvent object */
  id: Scalars['ID']['output'];
  /** The intent behind the agent's action, including rationale and confidence. */
  intent?: Maybe<IssueUpdateIntent>;
  /** Identifies the label associated with the 'unlabeled' event. */
  label: Label;
  /** Identifies the `Labelable` associated with the event. */
  labelable: Labelable;
};

/** Autogenerated input type of UnlinkProjectV2FromRepository */
export type UnlinkProjectV2FromRepositoryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the project to unlink from the repository. */
  projectId: Scalars['ID']['input'];
  /** The ID of the repository to unlink from the project. */
  repositoryId: Scalars['ID']['input'];
};

/** Autogenerated return type of UnlinkProjectV2FromRepository. */
export type UnlinkProjectV2FromRepositoryPayload = {
  __typename?: 'UnlinkProjectV2FromRepositoryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The repository the project is no longer linked to. */
  repository?: Maybe<Repository>;
};

/** Autogenerated input type of UnlinkProjectV2FromTeam */
export type UnlinkProjectV2FromTeamInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the project to unlink from the team. */
  projectId: Scalars['ID']['input'];
  /** The ID of the team to unlink from the project. */
  teamId: Scalars['ID']['input'];
};

/** Autogenerated return type of UnlinkProjectV2FromTeam. */
export type UnlinkProjectV2FromTeamPayload = {
  __typename?: 'UnlinkProjectV2FromTeamPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The team the project is unlinked from */
  team?: Maybe<Team>;
};

/** Autogenerated input type of UnlinkRepositoryFromProject */
export type UnlinkRepositoryFromProjectInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the Project linked to the Repository. */
  projectId: Scalars['ID']['input'];
  /** The ID of the Repository linked to the Project. */
  repositoryId: Scalars['ID']['input'];
};

/** Autogenerated return type of UnlinkRepositoryFromProject. */
export type UnlinkRepositoryFromProjectPayload = {
  __typename?: 'UnlinkRepositoryFromProjectPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The linked Project. */
  project?: Maybe<Project>;
  /** The linked Repository. */
  repository?: Maybe<Repository>;
};

/** Autogenerated input type of UnlockLockable */
export type UnlockLockableInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the item to be unlocked. */
  lockableId: Scalars['ID']['input'];
};

/** Autogenerated return type of UnlockLockable. */
export type UnlockLockablePayload = {
  __typename?: 'UnlockLockablePayload';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The item that was unlocked. */
  unlockedRecord?: Maybe<Lockable>;
};

/** Represents an 'unlocked' event on a given issue or pull request. */
export type UnlockedEvent = Node & {
  __typename?: 'UnlockedEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The Node ID of the UnlockedEvent object */
  id: Scalars['ID']['output'];
  /** Object that was unlocked. */
  lockable: Lockable;
};

/** Autogenerated input type of UnmarkDiscussionCommentAsAnswer */
export type UnmarkDiscussionCommentAsAnswerInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Node ID of the discussion comment to unmark as an answer. */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UnmarkDiscussionCommentAsAnswer. */
export type UnmarkDiscussionCommentAsAnswerPayload = {
  __typename?: 'UnmarkDiscussionCommentAsAnswerPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The discussion that includes the comment. */
  discussion?: Maybe<Discussion>;
};

/** Autogenerated input type of UnmarkFileAsViewed */
export type UnmarkFileAsViewedInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The path of the file to mark as unviewed */
  path: Scalars['String']['input'];
  /** The Node ID of the pull request. */
  pullRequestId: Scalars['ID']['input'];
};

/** Autogenerated return type of UnmarkFileAsViewed. */
export type UnmarkFileAsViewedPayload = {
  __typename?: 'UnmarkFileAsViewedPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated pull request. */
  pullRequest?: Maybe<PullRequest>;
};

/** Autogenerated input type of UnmarkIssueAsDuplicate */
export type UnmarkIssueAsDuplicateInput = {
  /** ID of the issue or pull request currently considered canonical/authoritative/original. */
  canonicalId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** ID of the issue or pull request currently marked as a duplicate. */
  duplicateId: Scalars['ID']['input'];
};

/** Autogenerated return type of UnmarkIssueAsDuplicate. */
export type UnmarkIssueAsDuplicatePayload = {
  __typename?: 'UnmarkIssueAsDuplicatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The issue or pull request that was marked as a duplicate. */
  duplicate?: Maybe<IssueOrPullRequest>;
};

/** Autogenerated input type of UnmarkProjectV2AsTemplate */
export type UnmarkProjectV2AsTemplateInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the Project to unmark as a template. */
  projectId: Scalars['ID']['input'];
};

/** Autogenerated return type of UnmarkProjectV2AsTemplate. */
export type UnmarkProjectV2AsTemplatePayload = {
  __typename?: 'UnmarkProjectV2AsTemplatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The project. */
  projectV2?: Maybe<ProjectV2>;
};

/** Represents an 'unmarked_as_duplicate' event on a given issue or pull request. */
export type UnmarkedAsDuplicateEvent = Node & {
  __typename?: 'UnmarkedAsDuplicateEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** The authoritative issue or pull request which has been duplicated by another. */
  canonical?: Maybe<IssueOrPullRequest>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The issue or pull request which has been marked as a duplicate of another. */
  duplicate?: Maybe<IssueOrPullRequest>;
  /** The Node ID of the UnmarkedAsDuplicateEvent object */
  id: Scalars['ID']['output'];
  /** Canonical and duplicate belong to different repositories. */
  isCrossRepository: Scalars['Boolean']['output'];
};

/** Autogenerated input type of UnminimizeComment */
export type UnminimizeCommentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Node ID of the subject to modify. */
  subjectId: Scalars['ID']['input'];
};

/** Autogenerated return type of UnminimizeComment. */
export type UnminimizeCommentPayload = {
  __typename?: 'UnminimizeCommentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The comment that was unminimized. */
  unminimizedComment?: Maybe<Minimizable>;
};

/** Autogenerated input type of UnpinIssueComment */
export type UnpinIssueCommentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the Issue Comment to unpin. Comment pinning is not supported on Pull Requests. */
  issueCommentId: Scalars['ID']['input'];
};

/** Autogenerated return type of UnpinIssueComment. */
export type UnpinIssueCommentPayload = {
  __typename?: 'UnpinIssueCommentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The Issue Comment that was unpinned */
  issueComment?: Maybe<IssueComment>;
};

/** Autogenerated input type of UnpinIssue */
export type UnpinIssueInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the issue to be unpinned */
  issueId: Scalars['ID']['input'];
};

/** Autogenerated return type of UnpinIssue. */
export type UnpinIssuePayload = {
  __typename?: 'UnpinIssuePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The id of the pinned issue that was unpinned */
  id?: Maybe<Scalars['ID']['output']>;
  /** The issue that was unpinned */
  issue?: Maybe<Issue>;
};

/** Represents an 'unpinned' event on a given issue or pull request. */
export type UnpinnedEvent = Node & {
  __typename?: 'UnpinnedEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The Node ID of the UnpinnedEvent object */
  id: Scalars['ID']['output'];
  /** Identifies the issue associated with the event. */
  issue: Issue;
};

/** Autogenerated input type of UnresolveReviewThread */
export type UnresolveReviewThreadInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the thread to unresolve */
  threadId: Scalars['ID']['input'];
};

/** Autogenerated return type of UnresolveReviewThread. */
export type UnresolveReviewThreadPayload = {
  __typename?: 'UnresolveReviewThreadPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The thread to resolve. */
  thread?: Maybe<PullRequestReviewThread>;
};

/** Represents an 'unsubscribed' event on a given `Subscribable`. */
export type UnsubscribedEvent = Node & {
  __typename?: 'UnsubscribedEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The Node ID of the UnsubscribedEvent object */
  id: Scalars['ID']['output'];
  /** Object referenced by event. */
  subscribable: Subscribable;
};

/** Entities that can be updated. */
export type Updatable = {
  /** Check if the current viewer can update this object. */
  viewerCanUpdate: Scalars['Boolean']['output'];
};

/** Comments that can be updated. */
export type UpdatableComment = {
  /** Reasons why the current viewer can not update this comment. */
  viewerCannotUpdateReasons: Array<CommentCannotUpdateReason>;
};

/** Autogenerated input type of UpdateBranchProtectionRule */
export type UpdateBranchProtectionRuleInput = {
  /** Can this branch be deleted. */
  allowsDeletions?: InputMaybe<Scalars['Boolean']['input']>;
  /** Are force pushes allowed on this branch. */
  allowsForcePushes?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is branch creation a protected operation. */
  blocksCreations?: InputMaybe<Scalars['Boolean']['input']>;
  /** The global relay id of the branch protection rule to be updated. */
  branchProtectionRuleId: Scalars['ID']['input'];
  /** A list of User, Team, or App IDs allowed to bypass force push targeting matching branches. */
  bypassForcePushActorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** A list of User, Team, or App IDs allowed to bypass pull requests targeting matching branches. */
  bypassPullRequestActorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Will new commits pushed to matching branches dismiss pull request review approvals. */
  dismissesStaleReviews?: InputMaybe<Scalars['Boolean']['input']>;
  /** Can admins override branch protection. */
  isAdminEnforced?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Whether users can pull changes from upstream when the branch is locked. Set to
   * `true` to allow fork syncing. Set to `false` to prevent fork syncing.
   */
  lockAllowsFetchAndMerge?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to set the branch as read-only. If this is true, users will not be able to push to the branch. */
  lockBranch?: InputMaybe<Scalars['Boolean']['input']>;
  /** The glob-like pattern used to determine matching branches. */
  pattern?: InputMaybe<Scalars['String']['input']>;
  /** A list of User, Team, or App IDs allowed to push to matching branches. */
  pushActorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Whether the most recent push must be approved by someone other than the person who pushed it */
  requireLastPushApproval?: InputMaybe<Scalars['Boolean']['input']>;
  /** Number of approving reviews required to update matching branches. */
  requiredApprovingReviewCount?: InputMaybe<Scalars['Int']['input']>;
  /** The list of required deployment environments */
  requiredDeploymentEnvironments?: InputMaybe<Array<Scalars['String']['input']>>;
  /** List of required status check contexts that must pass for commits to be accepted to matching branches. */
  requiredStatusCheckContexts?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The list of required status checks */
  requiredStatusChecks?: InputMaybe<Array<RequiredStatusCheckInput>>;
  /** Are approving reviews required to update matching branches. */
  requiresApprovingReviews?: InputMaybe<Scalars['Boolean']['input']>;
  /** Are reviews from code owners required to update matching branches. */
  requiresCodeOwnerReviews?: InputMaybe<Scalars['Boolean']['input']>;
  /** Are commits required to be signed. */
  requiresCommitSignatures?: InputMaybe<Scalars['Boolean']['input']>;
  /** Are conversations required to be resolved before merging. */
  requiresConversationResolution?: InputMaybe<Scalars['Boolean']['input']>;
  /** Are successful deployments required before merging. */
  requiresDeployments?: InputMaybe<Scalars['Boolean']['input']>;
  /** Are merge commits prohibited from being pushed to this branch. */
  requiresLinearHistory?: InputMaybe<Scalars['Boolean']['input']>;
  /** Are status checks required to update matching branches. */
  requiresStatusChecks?: InputMaybe<Scalars['Boolean']['input']>;
  /** Are branches required to be up to date before merging. */
  requiresStrictStatusChecks?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is pushing to matching branches restricted. */
  restrictsPushes?: InputMaybe<Scalars['Boolean']['input']>;
  /** Is dismissal of pull request reviews restricted. */
  restrictsReviewDismissals?: InputMaybe<Scalars['Boolean']['input']>;
  /** A list of User, Team, or App IDs allowed to dismiss reviews on pull requests targeting matching branches. */
  reviewDismissalActorIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Autogenerated return type of UpdateBranchProtectionRule. */
export type UpdateBranchProtectionRulePayload = {
  __typename?: 'UpdateBranchProtectionRulePayload';
  /** The newly created BranchProtectionRule. */
  branchProtectionRule?: Maybe<BranchProtectionRule>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateCheckRun */
export type UpdateCheckRunInput = {
  /** Possible further actions the integrator can perform, which a user may trigger. */
  actions?: InputMaybe<Array<CheckRunAction>>;
  /** The node of the check. */
  checkRunId: Scalars['ID']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The time that the check run finished. */
  completedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The final conclusion of the check. */
  conclusion?: InputMaybe<CheckConclusionState>;
  /** The URL of the integrator's site that has the full details of the check. */
  detailsUrl?: InputMaybe<Scalars['URI']['input']>;
  /** A reference for the run on the integrator's system. */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /** The name of the check. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Descriptive details about the run. */
  output?: InputMaybe<CheckRunOutput>;
  /** The node ID of the repository. */
  repositoryId: Scalars['ID']['input'];
  /** The time that the check run began. */
  startedAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The current status. */
  status?: InputMaybe<RequestableCheckStatusState>;
};

/** Autogenerated return type of UpdateCheckRun. */
export type UpdateCheckRunPayload = {
  __typename?: 'UpdateCheckRunPayload';
  /** The updated check run. */
  checkRun?: Maybe<CheckRun>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateCheckSuitePreferences */
export type UpdateCheckSuitePreferencesInput = {
  /** The check suite preferences to modify. */
  autoTriggerPreferences: Array<CheckSuiteAutoTriggerPreference>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Node ID of the repository. */
  repositoryId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateCheckSuitePreferences. */
export type UpdateCheckSuitePreferencesPayload = {
  __typename?: 'UpdateCheckSuitePreferencesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated repository. */
  repository?: Maybe<Repository>;
};

/** Autogenerated input type of UpdateDiscussionComment */
export type UpdateDiscussionCommentInput = {
  /** The new contents of the comment body. */
  body: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Node ID of the discussion comment to update. */
  commentId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateDiscussionComment. */
export type UpdateDiscussionCommentPayload = {
  __typename?: 'UpdateDiscussionCommentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The modified discussion comment. */
  comment?: Maybe<DiscussionComment>;
};

/** Autogenerated input type of UpdateDiscussion */
export type UpdateDiscussionInput = {
  /** The new contents of the discussion body. */
  body?: InputMaybe<Scalars['String']['input']>;
  /** The Node ID of a discussion category within the same repository to change this discussion to. */
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Node ID of the discussion to update. */
  discussionId: Scalars['ID']['input'];
  /** The new discussion title. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateDiscussion. */
export type UpdateDiscussionPayload = {
  __typename?: 'UpdateDiscussionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The modified discussion. */
  discussion?: Maybe<Discussion>;
};

/** Autogenerated input type of UpdateEnterpriseAdministratorRole */
export type UpdateEnterpriseAdministratorRoleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the Enterprise which the admin belongs to. */
  enterpriseId: Scalars['ID']['input'];
  /** The login of a administrator whose role is being changed. */
  login: Scalars['String']['input'];
  /** The new role for the Enterprise administrator. */
  role: EnterpriseAdministratorRole;
};

/** Autogenerated return type of UpdateEnterpriseAdministratorRole. */
export type UpdateEnterpriseAdministratorRolePayload = {
  __typename?: 'UpdateEnterpriseAdministratorRolePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** A message confirming the result of changing the administrator's role. */
  message?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateEnterpriseAllowPrivateRepositoryForkingSetting */
export type UpdateEnterpriseAllowPrivateRepositoryForkingSettingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the enterprise on which to set the allow private repository forking setting. */
  enterpriseId: Scalars['ID']['input'];
  /** The value for the allow private repository forking policy on the enterprise. */
  policyValue?: InputMaybe<EnterpriseAllowPrivateRepositoryForkingPolicyValue>;
  /** The value for the allow private repository forking setting on the enterprise. */
  settingValue: EnterpriseEnabledDisabledSettingValue;
};

/** Autogenerated return type of UpdateEnterpriseAllowPrivateRepositoryForkingSetting. */
export type UpdateEnterpriseAllowPrivateRepositoryForkingSettingPayload = {
  __typename?: 'UpdateEnterpriseAllowPrivateRepositoryForkingSettingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The enterprise with the updated allow private repository forking setting. */
  enterprise?: Maybe<Enterprise>;
  /** A message confirming the result of updating the allow private repository forking setting. */
  message?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateEnterpriseDefaultRepositoryPermissionSetting */
export type UpdateEnterpriseDefaultRepositoryPermissionSettingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the enterprise on which to set the base repository permission setting. */
  enterpriseId: Scalars['ID']['input'];
  /** The value for the base repository permission setting on the enterprise. */
  settingValue: EnterpriseDefaultRepositoryPermissionSettingValue;
};

/** Autogenerated return type of UpdateEnterpriseDefaultRepositoryPermissionSetting. */
export type UpdateEnterpriseDefaultRepositoryPermissionSettingPayload = {
  __typename?: 'UpdateEnterpriseDefaultRepositoryPermissionSettingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The enterprise with the updated base repository permission setting. */
  enterprise?: Maybe<Enterprise>;
  /** A message confirming the result of updating the base repository permission setting. */
  message?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateEnterpriseDeployKeySetting */
export type UpdateEnterpriseDeployKeySettingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the enterprise on which to set the deploy key setting. */
  enterpriseId: Scalars['ID']['input'];
  /** The value for the deploy key setting on the enterprise. */
  settingValue: EnterpriseEnabledDisabledSettingValue;
};

/** Autogenerated return type of UpdateEnterpriseDeployKeySetting. */
export type UpdateEnterpriseDeployKeySettingPayload = {
  __typename?: 'UpdateEnterpriseDeployKeySettingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The enterprise with the updated deploy key setting. */
  enterprise?: Maybe<Enterprise>;
  /** A message confirming the result of updating the deploy key setting. */
  message?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateEnterpriseMembersCanChangeRepositoryVisibilitySetting */
export type UpdateEnterpriseMembersCanChangeRepositoryVisibilitySettingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the enterprise on which to set the members can change repository visibility setting. */
  enterpriseId: Scalars['ID']['input'];
  /** The value for the members can change repository visibility setting on the enterprise. */
  settingValue: EnterpriseEnabledDisabledSettingValue;
};

/** Autogenerated return type of UpdateEnterpriseMembersCanChangeRepositoryVisibilitySetting. */
export type UpdateEnterpriseMembersCanChangeRepositoryVisibilitySettingPayload = {
  __typename?: 'UpdateEnterpriseMembersCanChangeRepositoryVisibilitySettingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The enterprise with the updated members can change repository visibility setting. */
  enterprise?: Maybe<Enterprise>;
  /** A message confirming the result of updating the members can change repository visibility setting. */
  message?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateEnterpriseMembersCanCreateRepositoriesSetting */
export type UpdateEnterpriseMembersCanCreateRepositoriesSettingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the enterprise on which to set the members can create repositories setting. */
  enterpriseId: Scalars['ID']['input'];
  /** Allow members to create internal repositories. Defaults to current value. */
  membersCanCreateInternalRepositories?: InputMaybe<Scalars['Boolean']['input']>;
  /** Allow members to create private repositories. Defaults to current value. */
  membersCanCreatePrivateRepositories?: InputMaybe<Scalars['Boolean']['input']>;
  /** Allow members to create public repositories. Defaults to current value. */
  membersCanCreatePublicRepositories?: InputMaybe<Scalars['Boolean']['input']>;
  /** When false, allow member organizations to set their own repository creation member privileges. */
  membersCanCreateRepositoriesPolicyEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Value for the members can create repositories setting on the enterprise. This
   * or the granular public/private/internal allowed fields (but not both) must be provided.
   */
  settingValue?: InputMaybe<EnterpriseMembersCanCreateRepositoriesSettingValue>;
};

/** Autogenerated return type of UpdateEnterpriseMembersCanCreateRepositoriesSetting. */
export type UpdateEnterpriseMembersCanCreateRepositoriesSettingPayload = {
  __typename?: 'UpdateEnterpriseMembersCanCreateRepositoriesSettingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The enterprise with the updated members can create repositories setting. */
  enterprise?: Maybe<Enterprise>;
  /** A message confirming the result of updating the members can create repositories setting. */
  message?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateEnterpriseMembersCanDeleteIssuesSetting */
export type UpdateEnterpriseMembersCanDeleteIssuesSettingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the enterprise on which to set the members can delete issues setting. */
  enterpriseId: Scalars['ID']['input'];
  /** The value for the members can delete issues setting on the enterprise. */
  settingValue: EnterpriseEnabledDisabledSettingValue;
};

/** Autogenerated return type of UpdateEnterpriseMembersCanDeleteIssuesSetting. */
export type UpdateEnterpriseMembersCanDeleteIssuesSettingPayload = {
  __typename?: 'UpdateEnterpriseMembersCanDeleteIssuesSettingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The enterprise with the updated members can delete issues setting. */
  enterprise?: Maybe<Enterprise>;
  /** A message confirming the result of updating the members can delete issues setting. */
  message?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateEnterpriseMembersCanDeleteRepositoriesSetting */
export type UpdateEnterpriseMembersCanDeleteRepositoriesSettingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the enterprise on which to set the members can delete repositories setting. */
  enterpriseId: Scalars['ID']['input'];
  /** The value for the members can delete repositories setting on the enterprise. */
  settingValue: EnterpriseEnabledDisabledSettingValue;
};

/** Autogenerated return type of UpdateEnterpriseMembersCanDeleteRepositoriesSetting. */
export type UpdateEnterpriseMembersCanDeleteRepositoriesSettingPayload = {
  __typename?: 'UpdateEnterpriseMembersCanDeleteRepositoriesSettingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The enterprise with the updated members can delete repositories setting. */
  enterprise?: Maybe<Enterprise>;
  /** A message confirming the result of updating the members can delete repositories setting. */
  message?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateEnterpriseMembersCanInviteCollaboratorsSetting */
export type UpdateEnterpriseMembersCanInviteCollaboratorsSettingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the enterprise on which to set the members can invite collaborators setting. */
  enterpriseId: Scalars['ID']['input'];
  /** The value for the members can invite collaborators setting on the enterprise. */
  settingValue: EnterpriseEnabledDisabledSettingValue;
};

/** Autogenerated return type of UpdateEnterpriseMembersCanInviteCollaboratorsSetting. */
export type UpdateEnterpriseMembersCanInviteCollaboratorsSettingPayload = {
  __typename?: 'UpdateEnterpriseMembersCanInviteCollaboratorsSettingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The enterprise with the updated members can invite collaborators setting. */
  enterprise?: Maybe<Enterprise>;
  /** A message confirming the result of updating the members can invite collaborators setting. */
  message?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateEnterpriseMembersCanMakePurchasesSetting */
export type UpdateEnterpriseMembersCanMakePurchasesSettingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the enterprise on which to set the members can make purchases setting. */
  enterpriseId: Scalars['ID']['input'];
  /** The value for the members can make purchases setting on the enterprise. */
  settingValue: EnterpriseMembersCanMakePurchasesSettingValue;
};

/** Autogenerated return type of UpdateEnterpriseMembersCanMakePurchasesSetting. */
export type UpdateEnterpriseMembersCanMakePurchasesSettingPayload = {
  __typename?: 'UpdateEnterpriseMembersCanMakePurchasesSettingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The enterprise with the updated members can make purchases setting. */
  enterprise?: Maybe<Enterprise>;
  /** A message confirming the result of updating the members can make purchases setting. */
  message?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateEnterpriseMembersCanUpdateProtectedBranchesSetting */
export type UpdateEnterpriseMembersCanUpdateProtectedBranchesSettingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the enterprise on which to set the members can update protected branches setting. */
  enterpriseId: Scalars['ID']['input'];
  /** The value for the members can update protected branches setting on the enterprise. */
  settingValue: EnterpriseEnabledDisabledSettingValue;
};

/** Autogenerated return type of UpdateEnterpriseMembersCanUpdateProtectedBranchesSetting. */
export type UpdateEnterpriseMembersCanUpdateProtectedBranchesSettingPayload = {
  __typename?: 'UpdateEnterpriseMembersCanUpdateProtectedBranchesSettingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The enterprise with the updated members can update protected branches setting. */
  enterprise?: Maybe<Enterprise>;
  /** A message confirming the result of updating the members can update protected branches setting. */
  message?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateEnterpriseMembersCanViewDependencyInsightsSetting */
export type UpdateEnterpriseMembersCanViewDependencyInsightsSettingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the enterprise on which to set the members can view dependency insights setting. */
  enterpriseId: Scalars['ID']['input'];
  /** The value for the members can view dependency insights setting on the enterprise. */
  settingValue: EnterpriseEnabledDisabledSettingValue;
};

/** Autogenerated return type of UpdateEnterpriseMembersCanViewDependencyInsightsSetting. */
export type UpdateEnterpriseMembersCanViewDependencyInsightsSettingPayload = {
  __typename?: 'UpdateEnterpriseMembersCanViewDependencyInsightsSettingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The enterprise with the updated members can view dependency insights setting. */
  enterprise?: Maybe<Enterprise>;
  /** A message confirming the result of updating the members can view dependency insights setting. */
  message?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateEnterpriseOrganizationProjectsSetting */
export type UpdateEnterpriseOrganizationProjectsSettingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the enterprise on which to set the organization projects setting. */
  enterpriseId: Scalars['ID']['input'];
  /** The value for the organization projects setting on the enterprise. */
  settingValue: EnterpriseEnabledDisabledSettingValue;
};

/** Autogenerated return type of UpdateEnterpriseOrganizationProjectsSetting. */
export type UpdateEnterpriseOrganizationProjectsSettingPayload = {
  __typename?: 'UpdateEnterpriseOrganizationProjectsSettingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The enterprise with the updated organization projects setting. */
  enterprise?: Maybe<Enterprise>;
  /** A message confirming the result of updating the organization projects setting. */
  message?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateEnterpriseOwnerOrganizationRole */
export type UpdateEnterpriseOwnerOrganizationRoleInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the Enterprise which the owner belongs to. */
  enterpriseId: Scalars['ID']['input'];
  /** The ID of the organization for membership change. */
  organizationId: Scalars['ID']['input'];
  /** The role to assume in the organization. */
  organizationRole: RoleInOrganization;
};

/** Autogenerated return type of UpdateEnterpriseOwnerOrganizationRole. */
export type UpdateEnterpriseOwnerOrganizationRolePayload = {
  __typename?: 'UpdateEnterpriseOwnerOrganizationRolePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** A message confirming the result of changing the owner's organization role. */
  message?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateEnterpriseProfile */
export type UpdateEnterpriseProfileInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The description of the enterprise. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The Enterprise ID to update. */
  enterpriseId: Scalars['ID']['input'];
  /** The location of the enterprise. */
  location?: InputMaybe<Scalars['String']['input']>;
  /** The name of the enterprise. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The security contact email address of the enterprise. */
  securityContactEmail?: InputMaybe<Scalars['String']['input']>;
  /** The URL of the enterprise's website. */
  websiteUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateEnterpriseProfile. */
export type UpdateEnterpriseProfilePayload = {
  __typename?: 'UpdateEnterpriseProfilePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated enterprise. */
  enterprise?: Maybe<Enterprise>;
};

/** Autogenerated input type of UpdateEnterpriseRepositoryProjectsSetting */
export type UpdateEnterpriseRepositoryProjectsSettingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the enterprise on which to set the repository projects setting. */
  enterpriseId: Scalars['ID']['input'];
  /** The value for the repository projects setting on the enterprise. */
  settingValue: EnterpriseEnabledDisabledSettingValue;
};

/** Autogenerated return type of UpdateEnterpriseRepositoryProjectsSetting. */
export type UpdateEnterpriseRepositoryProjectsSettingPayload = {
  __typename?: 'UpdateEnterpriseRepositoryProjectsSettingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The enterprise with the updated repository projects setting. */
  enterprise?: Maybe<Enterprise>;
  /** A message confirming the result of updating the repository projects setting. */
  message?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateEnterpriseTwoFactorAuthenticationDisallowedMethodsSetting */
export type UpdateEnterpriseTwoFactorAuthenticationDisallowedMethodsSettingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the enterprise on which to set the two-factor authentication disallowed methods setting. */
  enterpriseId: Scalars['ID']['input'];
  /** The value for the two-factor authentication disallowed methods setting on the enterprise. */
  settingValue: EnterpriseDisallowedMethodsSettingValue;
};

/** Autogenerated return type of UpdateEnterpriseTwoFactorAuthenticationDisallowedMethodsSetting. */
export type UpdateEnterpriseTwoFactorAuthenticationDisallowedMethodsSettingPayload = {
  __typename?: 'UpdateEnterpriseTwoFactorAuthenticationDisallowedMethodsSettingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The enterprise with the updated two-factor authentication disallowed methods setting. */
  enterprise?: Maybe<Enterprise>;
  /** A message confirming the result of updating the two-factor authentication disallowed methods setting. */
  message?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateEnterpriseTwoFactorAuthenticationRequiredSetting */
export type UpdateEnterpriseTwoFactorAuthenticationRequiredSettingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the enterprise on which to set the two factor authentication required setting. */
  enterpriseId: Scalars['ID']['input'];
  /** The value for the two factor authentication required setting on the enterprise. */
  settingValue: EnterpriseEnabledSettingValue;
};

/** Autogenerated return type of UpdateEnterpriseTwoFactorAuthenticationRequiredSetting. */
export type UpdateEnterpriseTwoFactorAuthenticationRequiredSettingPayload = {
  __typename?: 'UpdateEnterpriseTwoFactorAuthenticationRequiredSettingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The enterprise with the updated two factor authentication required setting. */
  enterprise?: Maybe<Enterprise>;
  /** A message confirming the result of updating the two factor authentication required setting. */
  message?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateEnvironment */
export type UpdateEnvironmentInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The node ID of the environment. */
  environmentId: Scalars['ID']['input'];
  /** Whether deployments to this environment can be approved by the user who created the deployment. */
  preventSelfReview?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ids of users or teams that can approve deployments to this environment */
  reviewers?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The wait timer in minutes. */
  waitTimer?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of UpdateEnvironment. */
export type UpdateEnvironmentPayload = {
  __typename?: 'UpdateEnvironmentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated environment. */
  environment?: Maybe<Environment>;
};

/** Autogenerated input type of UpdateIpAllowListEnabledSetting */
export type UpdateIpAllowListEnabledSettingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the owner on which to set the IP allow list enabled setting. */
  ownerId: Scalars['ID']['input'];
  /** The value for the IP allow list enabled setting. */
  settingValue: IpAllowListEnabledSettingValue;
};

/** Autogenerated return type of UpdateIpAllowListEnabledSetting. */
export type UpdateIpAllowListEnabledSettingPayload = {
  __typename?: 'UpdateIpAllowListEnabledSettingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The IP allow list owner on which the setting was updated. */
  owner?: Maybe<IpAllowListOwner>;
};

/** Autogenerated input type of UpdateIpAllowListEntry */
export type UpdateIpAllowListEntryInput = {
  /**
   * An IP address or range of addresses in CIDR notation. Ranges that cover the
   * entire address space, such as `0.0.0.0/0` or `::/0`, are not accepted for
   * organizations or enterprises.
   */
  allowListValue: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the IP allow list entry to update. */
  ipAllowListEntryId: Scalars['ID']['input'];
  /** Whether the IP allow list entry is active when an IP allow list is enabled. */
  isActive: Scalars['Boolean']['input'];
  /** An optional name for the IP allow list entry. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateIpAllowListEntry. */
export type UpdateIpAllowListEntryPayload = {
  __typename?: 'UpdateIpAllowListEntryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The IP allow list entry that was updated. */
  ipAllowListEntry?: Maybe<IpAllowListEntry>;
};

/** Autogenerated input type of UpdateIpAllowListForInstalledAppsEnabledSetting */
export type UpdateIpAllowListForInstalledAppsEnabledSettingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the owner. */
  ownerId: Scalars['ID']['input'];
  /** The value for the IP allow list configuration for installed GitHub Apps setting. */
  settingValue: IpAllowListForInstalledAppsEnabledSettingValue;
};

/** Autogenerated return type of UpdateIpAllowListForInstalledAppsEnabledSetting. */
export type UpdateIpAllowListForInstalledAppsEnabledSettingPayload = {
  __typename?: 'UpdateIpAllowListForInstalledAppsEnabledSettingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The IP allow list owner on which the setting was updated. */
  owner?: Maybe<IpAllowListOwner>;
};

/** Autogenerated input type of UpdateIpAllowListUserLevelEnforcementEnabledSetting */
export type UpdateIpAllowListUserLevelEnforcementEnabledSettingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the owner. */
  ownerId: Scalars['ID']['input'];
  /** The value for the IP allow list user-level enforcement enabled setting. */
  settingValue: IpAllowListUserLevelEnforcementEnabledSettingValue;
};

/** Autogenerated return type of UpdateIpAllowListUserLevelEnforcementEnabledSetting. */
export type UpdateIpAllowListUserLevelEnforcementEnabledSettingPayload = {
  __typename?: 'UpdateIpAllowListUserLevelEnforcementEnabledSettingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The IP allow list owner on which the setting was updated. */
  owner?: Maybe<IpAllowListOwner>;
};

/** Autogenerated input type of UpdateIssueComment */
export type UpdateIssueCommentInput = {
  /** The updated text of the comment. */
  body: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the IssueComment to modify. */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateIssueComment. */
export type UpdateIssueCommentPayload = {
  __typename?: 'UpdateIssueCommentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated comment. */
  issueComment?: Maybe<IssueComment>;
};

/** Autogenerated input type of UpdateIssueField */
export type UpdateIssueFieldInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** A description of the issue field. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the issue field to update. */
  id: Scalars['ID']['input'];
  /** The name of the issue field. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The options for the issue field if applicable. */
  options?: InputMaybe<Array<IssueFieldSingleSelectOptionInput>>;
  /** The visibility of the issue field. */
  visibility?: InputMaybe<IssueFieldVisibility>;
};

/** Autogenerated return type of UpdateIssueField. */
export type UpdateIssueFieldPayload = {
  __typename?: 'UpdateIssueFieldPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated issue field. */
  issueField?: Maybe<IssueFields>;
};

/** Autogenerated input type of UpdateIssueFieldValue */
export type UpdateIssueFieldValueInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * The field value to update. May include an optional `rationale` or be flagged
   * with `suggest: true` to be stored as a pending suggestion instead of being
   * applied directly.
   */
  issueField: IssueFieldCreateOrUpdateInput;
  /** The ID of the issue. */
  issueId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateIssueFieldValue. */
export type UpdateIssueFieldValuePayload = {
  __typename?: 'UpdateIssueFieldValuePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The issue object. */
  issue?: Maybe<Issue>;
  /** The updated issue field value. */
  issueFieldValue?: Maybe<IssueFieldValue>;
};

/** Autogenerated input type of UpdateIssue */
export type UpdateIssueInput = {
  /** Configuration for assigning an AI agent to this issue. */
  agentAssignment?: InputMaybe<AgentAssignmentInput>;
  /** An array of Node IDs of users or bots for this issue. */
  assigneeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * An array of actors to assign to this issue, each with optional rationale or
   * suggest flag. Mutually exclusive with `assigneeIds`.
   */
  assignees?: InputMaybe<Array<AssigneeUpdateInput>>;
  /** The body for the issue description. */
  body?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the Issue to modify. */
  id: Scalars['ID']['input'];
  /** Issue field updates resolved by field and option names. */
  issueFieldUpdates?: InputMaybe<Array<IssueFieldUpdateInput>>;
  /** The Issue Type to set on this issue, with optional rationale. Mutually exclusive with `issueTypeId`. */
  issueType?: InputMaybe<IssueTypeUpdateInput>;
  /** The ID of the Issue Type for this issue. */
  issueTypeId?: InputMaybe<Scalars['ID']['input']>;
  /** An array of Node IDs of labels for this issue. */
  labelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** An array of labels to set on this issue, each with optional rationale or suggest flag. Mutually exclusive with `labelIds`. */
  labels?: InputMaybe<Array<LabelUpdateInput>>;
  /** The Node ID of the milestone for this issue. */
  milestoneId?: InputMaybe<Scalars['ID']['input']>;
  /** An array of Node IDs for projects associated with this issue. */
  projectIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The desired issue state. */
  state?: InputMaybe<IssueState>;
  /** The desired issue state, with optional rationale, state reason, or duplicate reference. Mutually exclusive with `state`. */
  stateInput?: InputMaybe<IssueStateUpdateInput>;
  /** The title for the issue. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of UpdateIssueIssueType */
export type UpdateIssueIssueTypeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the issue to update */
  issueId: Scalars['ID']['input'];
  /** The ID of the issue type to update on the issue */
  issueTypeId?: InputMaybe<Scalars['ID']['input']>;
};

/** Autogenerated return type of UpdateIssueIssueType. */
export type UpdateIssueIssueTypePayload = {
  __typename?: 'UpdateIssueIssueTypePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated issue */
  issue?: Maybe<Issue>;
};

/** Autogenerated return type of UpdateIssue. */
export type UpdateIssuePayload = {
  __typename?: 'UpdateIssuePayload';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The issue. */
  issue?: Maybe<Issue>;
};

/** Autogenerated input type of UpdateIssueType */
export type UpdateIssueTypeInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Color for the issue type */
  color?: InputMaybe<IssueTypeColor>;
  /** The description of the issue type */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Whether or not the issue type is enabled for the organization */
  isEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the issue type to update */
  issueTypeId: Scalars['ID']['input'];
  /** The name of the issue type */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateIssueType. */
export type UpdateIssueTypePayload = {
  __typename?: 'UpdateIssueTypePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated issue type */
  issueType?: Maybe<IssueType>;
};

/** Autogenerated input type of UpdateLabel */
export type UpdateLabelInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** A 6 character hex code, without the leading #, identifying the updated color of the label. */
  color?: InputMaybe<Scalars['String']['input']>;
  /** A brief description of the label, such as its purpose. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The Node ID of the label to be updated. */
  id: Scalars['ID']['input'];
  /** The updated name of the label. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateLabel. */
export type UpdateLabelPayload = {
  __typename?: 'UpdateLabelPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated label. */
  label?: Maybe<Label>;
};

/** Autogenerated input type of UpdateNotificationRestrictionSetting */
export type UpdateNotificationRestrictionSettingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the owner on which to set the restrict notifications setting. */
  ownerId: Scalars['ID']['input'];
  /** The value for the restrict notifications setting. */
  settingValue: NotificationRestrictionSettingValue;
};

/** Autogenerated return type of UpdateNotificationRestrictionSetting. */
export type UpdateNotificationRestrictionSettingPayload = {
  __typename?: 'UpdateNotificationRestrictionSettingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The owner on which the setting was updated. */
  owner?: Maybe<VerifiableDomainOwner>;
};

/** Autogenerated input type of UpdateOrganizationAllowPrivateRepositoryForkingSetting */
export type UpdateOrganizationAllowPrivateRepositoryForkingSettingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Enable forking of private repositories in the organization? */
  forkingEnabled: Scalars['Boolean']['input'];
  /** The ID of the organization on which to set the allow private repository forking setting. */
  organizationId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateOrganizationAllowPrivateRepositoryForkingSetting. */
export type UpdateOrganizationAllowPrivateRepositoryForkingSettingPayload = {
  __typename?: 'UpdateOrganizationAllowPrivateRepositoryForkingSettingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** A message confirming the result of updating the allow private repository forking setting. */
  message?: Maybe<Scalars['String']['output']>;
  /** The organization with the updated allow private repository forking setting. */
  organization?: Maybe<Organization>;
};

/** Autogenerated input type of UpdateOrganizationWebCommitSignoffSetting */
export type UpdateOrganizationWebCommitSignoffSettingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the organization on which to set the web commit signoff setting. */
  organizationId: Scalars['ID']['input'];
  /** Enable signoff on web-based commits for repositories in the organization? */
  webCommitSignoffRequired: Scalars['Boolean']['input'];
};

/** Autogenerated return type of UpdateOrganizationWebCommitSignoffSetting. */
export type UpdateOrganizationWebCommitSignoffSettingPayload = {
  __typename?: 'UpdateOrganizationWebCommitSignoffSettingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** A message confirming the result of updating the web commit signoff setting. */
  message?: Maybe<Scalars['String']['output']>;
  /** The organization with the updated web commit signoff setting. */
  organization?: Maybe<Organization>;
};

/** Only allow users with bypass permission to update matching refs. */
export type UpdateParameters = {
  __typename?: 'UpdateParameters';
  /** Branch can pull changes from its upstream repository */
  updateAllowsFetchAndMerge: Scalars['Boolean']['output'];
};

/** Only allow users with bypass permission to update matching refs. */
export type UpdateParametersInput = {
  /** Branch can pull changes from its upstream repository */
  updateAllowsFetchAndMerge: Scalars['Boolean']['input'];
};

/** Autogenerated input type of UpdatePatreonSponsorability */
export type UpdatePatreonSponsorabilityInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Whether Patreon tiers should be shown on the GitHub Sponsors profile page,
   * allowing potential sponsors to make their payment through Patreon instead of GitHub.
   */
  enablePatreonSponsorships: Scalars['Boolean']['input'];
  /**
   * The username of the organization with the GitHub Sponsors profile, if any.
   * Defaults to the GitHub Sponsors profile for the authenticated user if omitted.
   */
  sponsorableLogin?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdatePatreonSponsorability. */
export type UpdatePatreonSponsorabilityPayload = {
  __typename?: 'UpdatePatreonSponsorabilityPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The GitHub Sponsors profile. */
  sponsorsListing?: Maybe<SponsorsListing>;
};

/** Autogenerated input type of UpdateProjectCard */
export type UpdateProjectCardInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Whether or not the ProjectCard should be archived */
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  /** The note of ProjectCard. */
  note?: InputMaybe<Scalars['String']['input']>;
  /** The ProjectCard ID to update. */
  projectCardId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateProjectCard. */
export type UpdateProjectCardPayload = {
  __typename?: 'UpdateProjectCardPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated ProjectCard. */
  projectCard?: Maybe<ProjectCard>;
};

/** Autogenerated input type of UpdateProjectColumn */
export type UpdateProjectColumnInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The name of project column. */
  name: Scalars['String']['input'];
  /** The ProjectColumn ID to update. */
  projectColumnId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateProjectColumn. */
export type UpdateProjectColumnPayload = {
  __typename?: 'UpdateProjectColumnPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated project column. */
  projectColumn?: Maybe<ProjectColumn>;
};

/** Autogenerated input type of UpdateProject */
export type UpdateProjectInput = {
  /** The description of project. */
  body?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The name of project. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The Project ID to update. */
  projectId: Scalars['ID']['input'];
  /** Whether the project is public or not. */
  public?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the project is open or closed. */
  state?: InputMaybe<ProjectState>;
};

/** Autogenerated return type of UpdateProject. */
export type UpdateProjectPayload = {
  __typename?: 'UpdateProjectPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated project. */
  project?: Maybe<Project>;
};

/** Autogenerated input type of UpdateProjectV2Collaborators */
export type UpdateProjectV2CollaboratorsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The collaborators to update. */
  collaborators: Array<ProjectV2Collaborator>;
  /** The ID of the project to update the collaborators for. */
  projectId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateProjectV2Collaborators. */
export type UpdateProjectV2CollaboratorsPayload = {
  __typename?: 'UpdateProjectV2CollaboratorsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The collaborators granted a role */
  collaborators?: Maybe<ProjectV2ActorConnection>;
};


/** Autogenerated return type of UpdateProjectV2Collaborators. */
export type UpdateProjectV2CollaboratorsPayloadCollaboratorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated input type of UpdateProjectV2DraftIssue */
export type UpdateProjectV2DraftIssueInput = {
  /** The IDs of the assignees of the draft issue. */
  assigneeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The body of the draft issue. */
  body?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the draft issue to update. */
  draftIssueId: Scalars['ID']['input'];
  /** The title of the draft issue. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateProjectV2DraftIssue. */
export type UpdateProjectV2DraftIssuePayload = {
  __typename?: 'UpdateProjectV2DraftIssuePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The draft issue updated in the project. */
  draftIssue?: Maybe<DraftIssue>;
};

/** Autogenerated input type of UpdateProjectV2Field */
export type UpdateProjectV2FieldInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the field to update. */
  fieldId: Scalars['ID']['input'];
  /**
   * Configuration for a field of type ITERATION. Empty input is ignored, provided
   * values overwrite the existing configuration, and existing configuration should
   * be fetched for partial updates.
   */
  iterationConfiguration?: InputMaybe<ProjectV2IterationFieldConfigurationInput>;
  /**
   * Options for a field of type MULTI_SELECT. Empty input is ignored, provided
   * values overwrite existing options, and existing options should be fetched for
   * partial updates.
   */
  multiSelectOptions?: InputMaybe<Array<ProjectV2MultiSelectFieldOptionInput>>;
  /** The name to update. */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Options for a field of type SINGLE_SELECT. Empty input is ignored, provided
   * values overwrite existing options, and existing options should be fetched for
   * partial updates.
   */
  singleSelectOptions?: InputMaybe<Array<ProjectV2SingleSelectFieldOptionInput>>;
};

/** Autogenerated return type of UpdateProjectV2Field. */
export type UpdateProjectV2FieldPayload = {
  __typename?: 'UpdateProjectV2FieldPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated field. */
  projectV2Field?: Maybe<ProjectV2FieldConfiguration>;
};

/** Autogenerated input type of UpdateProjectV2 */
export type UpdateProjectV2Input = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Set the project to closed or open. */
  closed?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the Project to update. */
  projectId: Scalars['ID']['input'];
  /** Set the project to public or private. */
  public?: InputMaybe<Scalars['Boolean']['input']>;
  /** Set the readme description of the project. */
  readme?: InputMaybe<Scalars['String']['input']>;
  /** Set the short description of the project. */
  shortDescription?: InputMaybe<Scalars['String']['input']>;
  /** Set the title of the project. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated input type of UpdateProjectV2ItemFieldValue */
export type UpdateProjectV2ItemFieldValueInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the field to be updated. */
  fieldId: Scalars['ID']['input'];
  /** The ID of the item to be updated. */
  itemId: Scalars['ID']['input'];
  /** The ID of the Project. */
  projectId: Scalars['ID']['input'];
  /** The value which will be set on the field. */
  value: ProjectV2FieldValue;
};

/** Autogenerated return type of UpdateProjectV2ItemFieldValue. */
export type UpdateProjectV2ItemFieldValuePayload = {
  __typename?: 'UpdateProjectV2ItemFieldValuePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated item. */
  projectV2Item?: Maybe<ProjectV2Item>;
};

/** Autogenerated input type of UpdateProjectV2ItemPosition */
export type UpdateProjectV2ItemPositionInput = {
  /** The ID of the item to position this item after. If omitted or set to null the item will be moved to top. */
  afterId?: InputMaybe<Scalars['ID']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the item to be moved. */
  itemId: Scalars['ID']['input'];
  /** The ID of the Project. */
  projectId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateProjectV2ItemPosition. */
export type UpdateProjectV2ItemPositionPayload = {
  __typename?: 'UpdateProjectV2ItemPositionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The items in the new order */
  items?: Maybe<ProjectV2ItemConnection>;
};


/** Autogenerated return type of UpdateProjectV2ItemPosition. */
export type UpdateProjectV2ItemPositionPayloadItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of UpdateProjectV2. */
export type UpdateProjectV2Payload = {
  __typename?: 'UpdateProjectV2Payload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated Project. */
  projectV2?: Maybe<ProjectV2>;
};

/** Autogenerated input type of UpdateProjectV2StatusUpdate */
export type UpdateProjectV2StatusUpdateInput = {
  /** The body of the status update. */
  body?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The start date of the status update. */
  startDate?: InputMaybe<Scalars['Date']['input']>;
  /** The status of the status update. */
  status?: InputMaybe<ProjectV2StatusUpdateStatus>;
  /** The ID of the status update to be updated. */
  statusUpdateId: Scalars['ID']['input'];
  /** The target date of the status update. */
  targetDate?: InputMaybe<Scalars['Date']['input']>;
};

/** Autogenerated return type of UpdateProjectV2StatusUpdate. */
export type UpdateProjectV2StatusUpdatePayload = {
  __typename?: 'UpdateProjectV2StatusUpdatePayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The status update updated in the project. */
  statusUpdate?: Maybe<ProjectV2StatusUpdate>;
};

/** Autogenerated input type of UpdateProjectV2View */
export type UpdateProjectV2ViewInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The new configuration for the view. */
  configuration?: InputMaybe<ProjectV2ViewConfigurationInput>;
  /** The new filter for the view. */
  filter?: InputMaybe<Scalars['String']['input']>;
  /** The new layout for the view. */
  layout?: InputMaybe<ProjectV2ViewLayout>;
  /** The new name for the view. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the view to update. */
  viewId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateProjectV2View. */
export type UpdateProjectV2ViewPayload = {
  __typename?: 'UpdateProjectV2ViewPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated view. */
  projectV2View?: Maybe<ProjectV2View>;
};

/** Autogenerated input type of UpdatePullRequestBranch */
export type UpdatePullRequestBranchInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The head ref oid for the upstream branch. */
  expectedHeadOid?: InputMaybe<Scalars['GitObjectID']['input']>;
  /** The Node ID of the pull request. */
  pullRequestId: Scalars['ID']['input'];
  /** The update branch method to use. If omitted, defaults to 'MERGE' */
  updateMethod?: InputMaybe<PullRequestBranchUpdateMethod>;
};

/** Autogenerated return type of UpdatePullRequestBranch. */
export type UpdatePullRequestBranchPayload = {
  __typename?: 'UpdatePullRequestBranchPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated pull request. */
  pullRequest?: Maybe<PullRequest>;
};

/** Autogenerated input type of UpdatePullRequest */
export type UpdatePullRequestInput = {
  /** An array of Node IDs of users for this pull request. */
  assigneeIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /**
   * The name of the branch you want your changes pulled into. This should be an existing branch
   * on the current repository.
   */
  baseRefName?: InputMaybe<Scalars['String']['input']>;
  /** The contents of the pull request. */
  body?: InputMaybe<Scalars['String']['input']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** An array of Node IDs of labels for this pull request. */
  labelIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Indicates whether maintainers can modify the pull request. */
  maintainerCanModify?: InputMaybe<Scalars['Boolean']['input']>;
  /** The Node ID of the milestone for this pull request. */
  milestoneId?: InputMaybe<Scalars['ID']['input']>;
  /** An array of Node IDs for projects associated with this pull request. */
  projectIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The Node ID of the pull request. */
  pullRequestId: Scalars['ID']['input'];
  /** The target state of the pull request. */
  state?: InputMaybe<PullRequestUpdateState>;
  /** The title of the pull request. */
  title?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdatePullRequest. */
export type UpdatePullRequestPayload = {
  __typename?: 'UpdatePullRequestPayload';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated pull request. */
  pullRequest?: Maybe<PullRequest>;
};

/** Autogenerated input type of UpdatePullRequestReviewComment */
export type UpdatePullRequestReviewCommentInput = {
  /** The text of the comment. */
  body: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Node ID of the comment to modify. */
  pullRequestReviewCommentId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdatePullRequestReviewComment. */
export type UpdatePullRequestReviewCommentPayload = {
  __typename?: 'UpdatePullRequestReviewCommentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated comment. */
  pullRequestReviewComment?: Maybe<PullRequestReviewComment>;
};

/** Autogenerated input type of UpdatePullRequestReview */
export type UpdatePullRequestReviewInput = {
  /** The contents of the pull request review body. */
  body: Scalars['String']['input'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Node ID of the pull request review to modify. */
  pullRequestReviewId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdatePullRequestReview. */
export type UpdatePullRequestReviewPayload = {
  __typename?: 'UpdatePullRequestReviewPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated pull request review. */
  pullRequestReview?: Maybe<PullRequestReview>;
};

/** Autogenerated input type of UpdateRef */
export type UpdateRefInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Permit updates of branch Refs that are not fast-forwards? */
  force?: InputMaybe<Scalars['Boolean']['input']>;
  /** The GitObjectID that the Ref shall be updated to target. */
  oid: Scalars['GitObjectID']['input'];
  /** The Node ID of the Ref to be updated. */
  refId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateRef. */
export type UpdateRefPayload = {
  __typename?: 'UpdateRefPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated Ref. */
  ref?: Maybe<Ref>;
};

/** Autogenerated input type of UpdateRefs */
export type UpdateRefsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** A list of ref updates. */
  refUpdates: Array<RefUpdate>;
  /** The Node ID of the repository. */
  repositoryId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateRefs. */
export type UpdateRefsPayload = {
  __typename?: 'UpdateRefsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
};

/** Autogenerated input type of UpdateRepositoryCustomProperty */
export type UpdateRepositoryCustomPropertyInput = {
  /** The updated allowed values for the custom property. */
  allowedValues?: InputMaybe<Array<Scalars['String']['input']>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The updated default value for the custom property if the property is required. */
  defaultValue?: InputMaybe<Scalars['String']['input']>;
  /** The updated description of the custom property. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The regex pattern that the value of the custom property must match, if the `value_type` is `string`. */
  regex?: InputMaybe<Scalars['String']['input']>;
  /** The global relay id of the source of the custom property. */
  repositoryCustomPropertyId: Scalars['ID']['input'];
  /** Whether this repository custom property requires explicit values. */
  requireExplicitValues?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether the updated custom property is required. */
  required?: InputMaybe<Scalars['Boolean']['input']>;
  /** The updated actors who can edit the values of the custom property. */
  valuesEditableBy?: InputMaybe<RepositoryCustomPropertyValuesEditableBy>;
};

/** Autogenerated return type of UpdateRepositoryCustomProperty. */
export type UpdateRepositoryCustomPropertyPayload = {
  __typename?: 'UpdateRepositoryCustomPropertyPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated repository custom property. */
  repositoryCustomProperty?: Maybe<RepositoryCustomProperty>;
};

/** Autogenerated input type of UpdateRepository */
export type UpdateRepositoryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** A new description for the repository. Pass an empty string to erase the existing description. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Indicates if the repository should have the discussions feature enabled. */
  hasDiscussionsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates if the repository should have the issues feature enabled. */
  hasIssuesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates if the repository should have the project boards feature enabled. */
  hasProjectsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates if the repository should have the pull requests feature enabled. */
  hasPullRequestsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates if the repository displays a Sponsor button for financial contributions. */
  hasSponsorshipsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** Indicates if the repository should have the wiki feature enabled. */
  hasWikiEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  /** The URL for a web page about this repository. Pass an empty string to erase the existing URL. */
  homepageUrl?: InputMaybe<Scalars['URI']['input']>;
  /** The policy controlling who can create issues in this repository. */
  issueCreationPolicy?: InputMaybe<IssueCreationPolicy>;
  /** The new name of the repository. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The policy controlling who can create pull requests in this repository. */
  pullRequestCreationPolicy?: InputMaybe<PullRequestCreationPolicy>;
  /** The ID of the repository to update. */
  repositoryId: Scalars['ID']['input'];
  /**
   * Whether this repository should be marked as a template such that anyone who
   * can access it can create new repositories with the same files and directory structure.
   */
  template?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Autogenerated return type of UpdateRepository. */
export type UpdateRepositoryPayload = {
  __typename?: 'UpdateRepositoryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The updated repository. */
  repository?: Maybe<Repository>;
};

/** Autogenerated input type of UpdateRepositoryRuleset */
export type UpdateRepositoryRulesetInput = {
  /** A list of actors that are allowed to bypass rules in this ruleset. */
  bypassActors?: InputMaybe<Array<RepositoryRulesetBypassActorInput>>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The list of conditions for this ruleset */
  conditions?: InputMaybe<RepositoryRuleConditionsInput>;
  /** The enforcement level for this ruleset */
  enforcement?: InputMaybe<RuleEnforcement>;
  /** The name of the ruleset. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The global relay id of the repository ruleset to be updated. */
  repositoryRulesetId: Scalars['ID']['input'];
  /** The list of rules for this ruleset */
  rules?: InputMaybe<Array<RepositoryRuleInput>>;
  /** The target of the ruleset. */
  target?: InputMaybe<RepositoryRulesetTarget>;
};

/** Autogenerated return type of UpdateRepositoryRuleset. */
export type UpdateRepositoryRulesetPayload = {
  __typename?: 'UpdateRepositoryRulesetPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The newly created Ruleset. */
  ruleset?: Maybe<RepositoryRuleset>;
};

/** Autogenerated input type of UpdateRepositoryWebCommitSignoffSetting */
export type UpdateRepositoryWebCommitSignoffSettingInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the repository to update. */
  repositoryId: Scalars['ID']['input'];
  /** Indicates if the repository should require signoff on web-based commits. */
  webCommitSignoffRequired: Scalars['Boolean']['input'];
};

/** Autogenerated return type of UpdateRepositoryWebCommitSignoffSetting. */
export type UpdateRepositoryWebCommitSignoffSettingPayload = {
  __typename?: 'UpdateRepositoryWebCommitSignoffSettingPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** A message confirming the result of updating the web commit signoff setting. */
  message?: Maybe<Scalars['String']['output']>;
  /** The updated repository. */
  repository?: Maybe<Repository>;
};

/** Autogenerated input type of UpdateSponsorshipPreferences */
export type UpdateSponsorshipPreferencesInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Specify whether others should be able to see that the sponsor is sponsoring
   * the sponsorable. Public visibility still does not reveal which tier is used.
   */
  privacyLevel?: InputMaybe<SponsorshipPrivacy>;
  /** Whether the sponsor should receive email updates from the sponsorable. */
  receiveEmails?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * The ID of the user or organization who is acting as the sponsor, paying for
   * the sponsorship. Required if sponsorLogin is not given.
   */
  sponsorId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * The username of the user or organization who is acting as the sponsor, paying
   * for the sponsorship. Required if sponsorId is not given.
   */
  sponsorLogin?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the user or organization who is receiving the sponsorship. Required if sponsorableLogin is not given. */
  sponsorableId?: InputMaybe<Scalars['ID']['input']>;
  /** The username of the user or organization who is receiving the sponsorship. Required if sponsorableId is not given. */
  sponsorableLogin?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateSponsorshipPreferences. */
export type UpdateSponsorshipPreferencesPayload = {
  __typename?: 'UpdateSponsorshipPreferencesPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The sponsorship that was updated. */
  sponsorship?: Maybe<Sponsorship>;
};

/** Autogenerated input type of UpdateSubscription */
export type UpdateSubscriptionInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The new state of the subscription. */
  state: SubscriptionState;
  /** The Node ID of the subscribable object to modify. */
  subscribableId: Scalars['ID']['input'];
};

/** Autogenerated return type of UpdateSubscription. */
export type UpdateSubscriptionPayload = {
  __typename?: 'UpdateSubscriptionPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The input subscribable entity. */
  subscribable?: Maybe<Subscribable>;
};

/** Autogenerated input type of UpdateTeamReviewAssignment */
export type UpdateTeamReviewAssignmentInput = {
  /** The algorithm to use for review assignment */
  algorithm?: InputMaybe<TeamReviewAssignmentAlgorithm>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Count any members whose review has already been requested against the required number of members assigned to review */
  countMembersAlreadyRequested?: InputMaybe<Scalars['Boolean']['input']>;
  /** Turn on or off review assignment */
  enabled: Scalars['Boolean']['input'];
  /** An array of team member IDs to exclude */
  excludedTeamMemberIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** The Node ID of the team to update review assignments of */
  id: Scalars['ID']['input'];
  /** Include the members of any child teams when assigning */
  includeChildTeamMembers?: InputMaybe<Scalars['Boolean']['input']>;
  /** Notify the entire team of the PR if it is delegated */
  notifyTeam?: InputMaybe<Scalars['Boolean']['input']>;
  /** Remove the team review request when assigning */
  removeTeamRequest?: InputMaybe<Scalars['Boolean']['input']>;
  /** The number of team members to assign */
  teamMemberCount?: InputMaybe<Scalars['Int']['input']>;
};

/** Autogenerated return type of UpdateTeamReviewAssignment. */
export type UpdateTeamReviewAssignmentPayload = {
  __typename?: 'UpdateTeamReviewAssignmentPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The team that was modified */
  team?: Maybe<Team>;
};

/** Autogenerated input type of UpdateTeamsRepository */
export type UpdateTeamsRepositoryInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** Permission that should be granted to the teams. */
  permission: RepositoryPermission;
  /** Repository ID being granted access to. */
  repositoryId: Scalars['ID']['input'];
  /** A list of teams being granted access. Limit: 10 */
  teamIds: Array<Scalars['ID']['input']>;
};

/** Autogenerated return type of UpdateTeamsRepository. */
export type UpdateTeamsRepositoryPayload = {
  __typename?: 'UpdateTeamsRepositoryPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The repository that was updated. */
  repository?: Maybe<Repository>;
  /** The teams granted permission on the repository. */
  teams?: Maybe<Array<Team>>;
};

/** Autogenerated input type of UpdateTopics */
export type UpdateTopicsInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The Node ID of the repository. */
  repositoryId: Scalars['ID']['input'];
  /** An array of topic names. */
  topicNames: Array<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateTopics. */
export type UpdateTopicsPayload = {
  __typename?: 'UpdateTopicsPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** Names of the provided topics that are not valid. */
  invalidTopicNames?: Maybe<Array<Scalars['String']['output']>>;
  /** The updated repository. */
  repository?: Maybe<Repository>;
};

/** Autogenerated input type of UpdateUserList */
export type UpdateUserListInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** A description of the list */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Whether or not the list is private */
  isPrivate?: InputMaybe<Scalars['Boolean']['input']>;
  /** The ID of the list to update. */
  listId: Scalars['ID']['input'];
  /** The name of the list */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Autogenerated return type of UpdateUserList. */
export type UpdateUserListPayload = {
  __typename?: 'UpdateUserListPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The list that was just updated */
  list?: Maybe<UserList>;
};

/** Autogenerated input type of UpdateUserListsForItem */
export type UpdateUserListsForItemInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The item to add to the list */
  itemId: Scalars['ID']['input'];
  /** The lists to which this item should belong */
  listIds: Array<Scalars['ID']['input']>;
  /** The suggested lists to create and add this item to */
  suggestedListIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Autogenerated return type of UpdateUserListsForItem. */
export type UpdateUserListsForItemPayload = {
  __typename?: 'UpdateUserListsForItemPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The item that was added */
  item?: Maybe<UserListItems>;
  /** The lists to which this item belongs */
  lists?: Maybe<Array<UserList>>;
  /** The user who owns the lists */
  user?: Maybe<User>;
};

/** A user is an individual's account on GitHub that owns repositories and can make new content. */
export type User = Actor & Agentic & Node & PackageOwner & ProfileOwner & ProjectOwner & ProjectV2Owner & ProjectV2Recent & RepositoryDiscussionAuthor & RepositoryDiscussionCommentAuthor & RepositoryOwner & Sponsorable & UniformResourceLocatable & {
  __typename?: 'User';
  /** Determine if this repository owner has any items that can be pinned to their profile. */
  anyPinnableItems: Scalars['Boolean']['output'];
  /** A URL pointing to the user's public avatar. */
  avatarUrl: Scalars['URI']['output'];
  /** The user's public profile bio. */
  bio?: Maybe<Scalars['String']['output']>;
  /** The user's public profile bio as HTML. */
  bioHTML: Scalars['HTML']['output'];
  /** Could this user receive email notifications, if the organization had notification restrictions enabled? */
  canReceiveOrganizationEmailsWhenNotificationsRestricted: Scalars['Boolean']['output'];
  /** A list of commit comments made by this user. */
  commitComments: CommitCommentConnection;
  /** The user's public profile company. */
  company?: Maybe<Scalars['String']['output']>;
  /** The user's public profile company as HTML. */
  companyHTML: Scalars['HTML']['output'];
  /** The collection of contributions this user has made to different repositories. */
  contributionsCollection: ContributionsCollection;
  /** The user's Copilot endpoint information */
  copilotEndpoints?: Maybe<CopilotEndpoints>;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Identifies the primary key from the database. */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** The user's publicly visible profile email. */
  email: Scalars['String']['output'];
  /** A list of enterprises that the user belongs to. */
  enterprises?: Maybe<EnterpriseConnection>;
  /** The estimated next GitHub Sponsors payout for this user/organization in cents (USD). */
  estimatedNextSponsorsPayoutInCents: Scalars['Int']['output'];
  /** A list of users the given user is followed by. */
  followers: FollowerConnection;
  /** A list of users the given user is following. */
  following: FollowingConnection;
  /** Find gist by repo name. */
  gist?: Maybe<Gist>;
  /** A list of gist comments made by this user. */
  gistComments: GistCommentConnection;
  /** A list of the Gists the user has created. */
  gists: GistConnection;
  /** True if this user/organization has a GitHub Sponsors listing. */
  hasSponsorsListing: Scalars['Boolean']['output'];
  /** The hovercard information for this user in a given context */
  hovercard: Hovercard;
  /** The Node ID of the User object */
  id: Scalars['ID']['output'];
  /** The interaction ability settings for this user. */
  interactionAbility?: Maybe<RepositoryInteractionAbility>;
  /** Whether or not this user is a participant in the GitHub Security Bug Bounty. */
  isBountyHunter: Scalars['Boolean']['output'];
  /** Whether or not this user is a participant in the GitHub Campus Experts Program. */
  isCampusExpert: Scalars['Boolean']['output'];
  /** Whether or not this user is a GitHub Developer Program member. */
  isDeveloperProgramMember: Scalars['Boolean']['output'];
  /** Whether or not this user is a GitHub employee. */
  isEmployee: Scalars['Boolean']['output'];
  /** Whether or not this user is following the viewer. Inverse of viewerIsFollowing */
  isFollowingViewer: Scalars['Boolean']['output'];
  /** Whether or not this user is a member of the GitHub Stars Program. */
  isGitHubStar: Scalars['Boolean']['output'];
  /** Whether or not the user has marked themselves as for hire. */
  isHireable: Scalars['Boolean']['output'];
  /** Whether or not this user is a site administrator. */
  isSiteAdmin: Scalars['Boolean']['output'];
  /** Whether the given account is sponsoring this user/organization. */
  isSponsoredBy: Scalars['Boolean']['output'];
  /** True if the viewer is sponsored by this user/organization. */
  isSponsoringViewer: Scalars['Boolean']['output'];
  /** Whether or not this user is the viewing user. */
  isViewer: Scalars['Boolean']['output'];
  /** A list of issue comments made by this user. */
  issueComments: IssueCommentConnection;
  /** A list of issues associated with this user. */
  issues: IssueConnection;
  /**
   * Showcases a selection of repositories and gists that the profile owner has
   * either curated or that have been selected automatically based on popularity.
   */
  itemShowcase: ProfileItemShowcase;
  /**
   * Calculate how much each sponsor has ever paid total to this maintainer via
   * GitHub Sponsors. Does not include sponsorships paid via Patreon.
   */
  lifetimeReceivedSponsorshipValues: SponsorAndLifetimeValueConnection;
  /** A user-curated list of repositories */
  lists: UserListConnection;
  /** The user's public profile location. */
  location?: Maybe<Scalars['String']['output']>;
  /** The username used to login. */
  login: Scalars['String']['output'];
  /** The estimated monthly GitHub Sponsors income for this user/organization in cents (USD). */
  monthlyEstimatedSponsorsIncomeInCents: Scalars['Int']['output'];
  /** The user's public profile name. */
  name?: Maybe<Scalars['String']['output']>;
  /** Find an organization by its login that the user belongs to. */
  organization?: Maybe<Organization>;
  /** Verified email addresses that match verified domains for a specified organization the user is a member of. */
  organizationVerifiedDomainEmails: Array<Scalars['String']['output']>;
  /** A list of organizations the user belongs to. */
  organizations: OrganizationConnection;
  /** A list of packages under the owner. */
  packages: PackageConnection;
  /** A list of repositories and gists this profile owner can pin to their profile. */
  pinnableItems: PinnableItemConnection;
  /** A list of repositories and gists this profile owner has pinned to their profile */
  pinnedItems: PinnableItemConnection;
  /** Returns how many more items this profile owner can pin to their profile. */
  pinnedItemsRemaining: Scalars['Int']['output'];
  /**
   * Find project by number.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  project?: Maybe<Project>;
  /** Find a project by number. */
  projectV2?: Maybe<ProjectV2>;
  /**
   * A list of projects under the owner.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  projects: ProjectConnection;
  /** The HTTP path listing user's projects */
  projectsResourcePath: Scalars['URI']['output'];
  /** The HTTP URL listing user's projects */
  projectsUrl: Scalars['URI']['output'];
  /** A list of projects under the owner. */
  projectsV2: ProjectV2Connection;
  /** The user's profile pronouns */
  pronouns?: Maybe<Scalars['String']['output']>;
  /** A list of public keys associated with this user. */
  publicKeys: PublicKeyConnection;
  /** A list of pull requests associated with this user. */
  pullRequests: PullRequestConnection;
  /** Recent projects that this user has modified in the context of the owner. */
  recentProjects: ProjectV2Connection;
  /** A list of repositories that the user owns. */
  repositories: RepositoryConnection;
  /** A list of repositories that the user recently contributed to. */
  repositoriesContributedTo: RepositoryConnection;
  /** Find Repository. */
  repository?: Maybe<Repository>;
  /** Discussion comments this user has authored. */
  repositoryDiscussionComments: DiscussionCommentConnection;
  /** Discussions this user has started. */
  repositoryDiscussions: DiscussionConnection;
  /** The HTTP path for this user */
  resourcePath: Scalars['URI']['output'];
  /** Replies this user has saved */
  savedReplies?: Maybe<SavedReplyConnection>;
  /** The user's social media accounts, ordered as they appear on the user's profile. */
  socialAccounts: SocialAccountConnection;
  /** List of users and organizations this entity is sponsoring. */
  sponsoring: SponsorConnection;
  /** List of sponsors for this user or organization. */
  sponsors: SponsorConnection;
  /** Events involving this sponsorable, such as new sponsorships. */
  sponsorsActivities: SponsorsActivityConnection;
  /** The GitHub Sponsors listing for this user or organization. */
  sponsorsListing?: Maybe<SponsorsListing>;
  /** The sponsorship from the viewer to this user/organization; that is, the sponsorship where you're the sponsor. */
  sponsorshipForViewerAsSponsor?: Maybe<Sponsorship>;
  /** The sponsorship from this user/organization to the viewer; that is, the sponsorship you're receiving. */
  sponsorshipForViewerAsSponsorable?: Maybe<Sponsorship>;
  /** List of sponsorship updates sent from this sponsorable to sponsors. */
  sponsorshipNewsletters: SponsorshipNewsletterConnection;
  /** The sponsorships where this user or organization is the maintainer receiving the funds. */
  sponsorshipsAsMaintainer: SponsorshipConnection;
  /** The sponsorships where this user or organization is the funder. */
  sponsorshipsAsSponsor: SponsorshipConnection;
  /** Repositories the user has starred. */
  starredRepositories: StarredRepositoryConnection;
  /** The user's description of what they're currently doing. */
  status?: Maybe<UserStatus>;
  /** Suggested names for user lists */
  suggestedListNames: Array<UserListSuggestion>;
  /** Repositories the user has contributed to, ordered by contribution rank, plus repositories the user has created */
  topRepositories: RepositoryConnection;
  /**
   * The amount in United States cents (e.g., 500 = $5.00 USD) that this entity has
   * spent on GitHub to fund sponsorships. Only returns a value when viewed by the
   * user themselves or by a user who can manage sponsorships for the requested organization.
   */
  totalSponsorshipAmountAsSponsorInCents?: Maybe<Scalars['Int']['output']>;
  /** The user's Twitter username. */
  twitterUsername?: Maybe<Scalars['String']['output']>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The HTTP URL for this user */
  url: Scalars['URI']['output'];
  /** Whether the request returns publicly visible information or privately visible information about the user */
  userViewType: UserViewType;
  /** Can the viewer pin repositories and gists to the profile? */
  viewerCanChangePinnedItems: Scalars['Boolean']['output'];
  /**
   * Can the current viewer create new projects on this owner.
   * @deprecated Projects (classic) is being deprecated in favor of the new Projects experience, see: https://github.blog/changelog/2024-05-23-sunset-notice-projects-classic/. Removal on 2025-04-01 UTC.
   */
  viewerCanCreateProjects: Scalars['Boolean']['output'];
  /** Whether or not the viewer is able to follow the user. */
  viewerCanFollow: Scalars['Boolean']['output'];
  /** Whether or not the viewer is able to sponsor this user/organization. */
  viewerCanSponsor: Scalars['Boolean']['output'];
  /** Channel value for subscribing to live updates for session creations. */
  viewerCopilotAgentCreatesChannel?: Maybe<Scalars['String']['output']>;
  /** Channel value for subscribing to live updates for session log updates. */
  viewerCopilotAgentLogUpdatesChannel?: Maybe<Scalars['String']['output']>;
  /** Channel value for subscribing to live updates for task updates. */
  viewerCopilotAgentTaskUpdatesChannel?: Maybe<Scalars['String']['output']>;
  /** Channel value for subscribing to live updates for session updates. */
  viewerCopilotAgentUpdatesChannel?: Maybe<Scalars['String']['output']>;
  /** Whether or not this user is followed by the viewer. Inverse of isFollowingViewer. */
  viewerIsFollowing: Scalars['Boolean']['output'];
  /** True if the viewer is sponsoring this user/organization. */
  viewerIsSponsoring: Scalars['Boolean']['output'];
  /** A list of repositories the given user is watching. */
  watching: RepositoryConnection;
  /** A URL pointing to the user's public website/blog. */
  websiteUrl?: Maybe<Scalars['URI']['output']>;
};


/** A user is an individual's account on GitHub that owns repositories and can make new content. */
export type UserAnyPinnableItemsArgs = {
  type?: InputMaybe<PinnableItemType>;
};


/** A user is an individual's account on GitHub that owns repositories and can make new content. */
export type UserAvatarUrlArgs = {
  size?: InputMaybe<Scalars['Int']['input']>;
};


/** A user is an individual's account on GitHub that owns repositories and can make new content. */
export type UserCanReceiveOrganizationEmailsWhenNotificationsRestrictedArgs = {
  login: Scalars['String']['input'];
};


/** A user is an individual's account on GitHub that owns repositories and can make new content. */
export type UserCommitCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A user is an individual's account on GitHub that owns repositories and can make new content. */
export type UserContributionsCollectionArgs = {
  from?: InputMaybe<Scalars['DateTime']['input']>;
  organizationID?: InputMaybe<Scalars['ID']['input']>;
  to?: InputMaybe<Scalars['DateTime']['input']>;
};


/** A user is an individual's account on GitHub that owns repositories and can make new content. */
export type UserEnterprisesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  membershipType?: InputMaybe<EnterpriseMembershipType>;
  orderBy?: InputMaybe<EnterpriseOrder>;
};


/** A user is an individual's account on GitHub that owns repositories and can make new content. */
export type UserFollowersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A user is an individual's account on GitHub that owns repositories and can make new content. */
export type UserFollowingArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A user is an individual's account on GitHub that owns repositories and can make new content. */
export type UserGistArgs = {
  name: Scalars['String']['input'];
};


/** A user is an individual's account on GitHub that owns repositories and can make new content. */
export type UserGistCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A user is an individual's account on GitHub that owns repositories and can make new content. */
export type UserGistsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<GistOrder>;
  privacy?: InputMaybe<GistPrivacy>;
};


/** A user is an individual's account on GitHub that owns repositories and can make new content. */
export type UserHovercardArgs = {
  primarySubjectId?: InputMaybe<Scalars['ID']['input']>;
};


/** A user is an individual's account on GitHub that owns repositories and can make new content. */
export type UserIsSponsoredByArgs = {
  accountLogin: Scalars['String']['input'];
};


/** A user is an individual's account on GitHub that owns repositories and can make new content. */
export type UserIssueCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<IssueCommentOrder>;
};


/** A user is an individual's account on GitHub that owns repositories and can make new content. */
export type UserIssuesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  filterBy?: InputMaybe<IssueFilters>;
  first?: InputMaybe<Scalars['Int']['input']>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<IssueOrder>;
  states?: InputMaybe<Array<IssueState>>;
};


/** A user is an individual's account on GitHub that owns repositories and can make new content. */
export type UserLifetimeReceivedSponsorshipValuesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SponsorAndLifetimeValueOrder>;
};


/** A user is an individual's account on GitHub that owns repositories and can make new content. */
export type UserListsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A user is an individual's account on GitHub that owns repositories and can make new content. */
export type UserOrganizationArgs = {
  login: Scalars['String']['input'];
};


/** A user is an individual's account on GitHub that owns repositories and can make new content. */
export type UserOrganizationVerifiedDomainEmailsArgs = {
  login: Scalars['String']['input'];
};


/** A user is an individual's account on GitHub that owns repositories and can make new content. */
export type UserOrganizationsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<OrganizationOrder>;
};


/** A user is an individual's account on GitHub that owns repositories and can make new content. */
export type UserPackagesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  names?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  orderBy?: InputMaybe<PackageOrder>;
  packageType?: InputMaybe<PackageType>;
  repositoryId?: InputMaybe<Scalars['ID']['input']>;
};


/** A user is an individual's account on GitHub that owns repositories and can make new content. */
export type UserPinnableItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  types?: InputMaybe<Array<PinnableItemType>>;
};


/** A user is an individual's account on GitHub that owns repositories and can make new content. */
export type UserPinnedItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  types?: InputMaybe<Array<PinnableItemType>>;
};


/** A user is an individual's account on GitHub that owns repositories and can make new content. */
export type UserProjectArgs = {
  number: Scalars['Int']['input'];
};


/** A user is an individual's account on GitHub that owns repositories and can make new content. */
export type UserProjectV2Args = {
  number: Scalars['Int']['input'];
};


/** A user is an individual's account on GitHub that owns repositories and can make new content. */
export type UserProjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<ProjectOrder>;
  search?: InputMaybe<Scalars['String']['input']>;
  states?: InputMaybe<Array<ProjectState>>;
};


/** A user is an individual's account on GitHub that owns repositories and can make new content. */
export type UserProjectsV2Args = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  minPermissionLevel?: InputMaybe<ProjectV2PermissionLevel>;
  orderBy?: InputMaybe<ProjectV2Order>;
  query?: InputMaybe<Scalars['String']['input']>;
};


/** A user is an individual's account on GitHub that owns repositories and can make new content. */
export type UserPublicKeysArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A user is an individual's account on GitHub that owns repositories and can make new content. */
export type UserPullRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  baseRefName?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  headRefName?: InputMaybe<Scalars['String']['input']>;
  labels?: InputMaybe<Array<Scalars['String']['input']>>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<IssueOrder>;
  states?: InputMaybe<Array<PullRequestState>>;
};


/** A user is an individual's account on GitHub that owns repositories and can make new content. */
export type UserRecentProjectsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A user is an individual's account on GitHub that owns repositories and can make new content. */
export type UserRepositoriesArgs = {
  affiliations?: InputMaybe<Array<InputMaybe<RepositoryAffiliation>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasIssuesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isFork?: InputMaybe<Scalars['Boolean']['input']>;
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<RepositoryOrder>;
  ownerAffiliations?: InputMaybe<Array<InputMaybe<RepositoryAffiliation>>>;
  privacy?: InputMaybe<RepositoryPrivacy>;
  visibility?: InputMaybe<RepositoryVisibility>;
};


/** A user is an individual's account on GitHub that owns repositories and can make new content. */
export type UserRepositoriesContributedToArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  contributionTypes?: InputMaybe<Array<InputMaybe<RepositoryContributionType>>>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasIssues?: InputMaybe<Scalars['Boolean']['input']>;
  includeUserRepositories?: InputMaybe<Scalars['Boolean']['input']>;
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<RepositoryOrder>;
  privacy?: InputMaybe<RepositoryPrivacy>;
};


/** A user is an individual's account on GitHub that owns repositories and can make new content. */
export type UserRepositoryArgs = {
  followRenames?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
};


/** A user is an individual's account on GitHub that owns repositories and can make new content. */
export type UserRepositoryDiscussionCommentsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  onlyAnswers?: InputMaybe<Scalars['Boolean']['input']>;
  repositoryId?: InputMaybe<Scalars['ID']['input']>;
};


/** A user is an individual's account on GitHub that owns repositories and can make new content. */
export type UserRepositoryDiscussionsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  answered?: InputMaybe<Scalars['Boolean']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<DiscussionOrder>;
  repositoryId?: InputMaybe<Scalars['ID']['input']>;
  states?: InputMaybe<Array<DiscussionState>>;
};


/** A user is an individual's account on GitHub that owns repositories and can make new content. */
export type UserSavedRepliesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SavedReplyOrder>;
};


/** A user is an individual's account on GitHub that owns repositories and can make new content. */
export type UserSocialAccountsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A user is an individual's account on GitHub that owns repositories and can make new content. */
export type UserSponsoringArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SponsorOrder>;
};


/** A user is an individual's account on GitHub that owns repositories and can make new content. */
export type UserSponsorsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SponsorOrder>;
  tierId?: InputMaybe<Scalars['ID']['input']>;
};


/** A user is an individual's account on GitHub that owns repositories and can make new content. */
export type UserSponsorsActivitiesArgs = {
  actions?: InputMaybe<Array<SponsorsActivityAction>>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includeAsSponsor?: InputMaybe<Scalars['Boolean']['input']>;
  includePrivate?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SponsorsActivityOrder>;
  period?: InputMaybe<SponsorsActivityPeriod>;
  since?: InputMaybe<Scalars['DateTime']['input']>;
  until?: InputMaybe<Scalars['DateTime']['input']>;
};


/** A user is an individual's account on GitHub that owns repositories and can make new content. */
export type UserSponsorshipForViewerAsSponsorArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A user is an individual's account on GitHub that owns repositories and can make new content. */
export type UserSponsorshipForViewerAsSponsorableArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A user is an individual's account on GitHub that owns repositories and can make new content. */
export type UserSponsorshipNewslettersArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SponsorshipNewsletterOrder>;
};


/** A user is an individual's account on GitHub that owns repositories and can make new content. */
export type UserSponsorshipsAsMaintainerArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  includePrivate?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<SponsorshipOrder>;
};


/** A user is an individual's account on GitHub that owns repositories and can make new content. */
export type UserSponsorshipsAsSponsorArgs = {
  activeOnly?: InputMaybe<Scalars['Boolean']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  maintainerLogins?: InputMaybe<Array<Scalars['String']['input']>>;
  orderBy?: InputMaybe<SponsorshipOrder>;
};


/** A user is an individual's account on GitHub that owns repositories and can make new content. */
export type UserStarredRepositoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<StarOrder>;
  ownedByViewer?: InputMaybe<Scalars['Boolean']['input']>;
};


/** A user is an individual's account on GitHub that owns repositories and can make new content. */
export type UserTopRepositoriesArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy: RepositoryOrder;
  since?: InputMaybe<Scalars['DateTime']['input']>;
};


/** A user is an individual's account on GitHub that owns repositories and can make new content. */
export type UserTotalSponsorshipAmountAsSponsorInCentsArgs = {
  since?: InputMaybe<Scalars['DateTime']['input']>;
  sponsorableLogins?: InputMaybe<Array<Scalars['String']['input']>>;
  until?: InputMaybe<Scalars['DateTime']['input']>;
};


/** A user is an individual's account on GitHub that owns repositories and can make new content. */
export type UserWatchingArgs = {
  affiliations?: InputMaybe<Array<InputMaybe<RepositoryAffiliation>>>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  hasIssuesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  isLocked?: InputMaybe<Scalars['Boolean']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<RepositoryOrder>;
  ownerAffiliations?: InputMaybe<Array<InputMaybe<RepositoryAffiliation>>>;
  privacy?: InputMaybe<RepositoryPrivacy>;
  visibility?: InputMaybe<RepositoryVisibility>;
};

/** The possible durations that a user can be blocked for. */
export enum UserBlockDuration {
  /** The user was blocked for 1 day */
  OneDay = 'ONE_DAY',
  /** The user was blocked for 30 days */
  OneMonth = 'ONE_MONTH',
  /** The user was blocked for 7 days */
  OneWeek = 'ONE_WEEK',
  /** The user was blocked permanently */
  Permanent = 'PERMANENT',
  /** The user was blocked for 3 days */
  ThreeDays = 'THREE_DAYS'
}

/** Represents a 'user_blocked' event on a given user. */
export type UserBlockedEvent = Node & {
  __typename?: 'UserBlockedEvent';
  /** Identifies the actor who performed the event. */
  actor?: Maybe<Actor>;
  /** Number of days that the user was blocked for. */
  blockDuration: UserBlockDuration;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The Node ID of the UserBlockedEvent object */
  id: Scalars['ID']['output'];
  /** The user who was blocked. */
  subject?: Maybe<User>;
};

/** A list of users. */
export type UserConnection = {
  __typename?: 'UserConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<User>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edit on user content */
export type UserContentEdit = Node & {
  __typename?: 'UserContentEdit';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Identifies the date and time when the object was deleted. */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The actor who deleted this content */
  deletedBy?: Maybe<Actor>;
  /** A summary of the changes for this edit */
  diff?: Maybe<Scalars['String']['output']>;
  /** When this content was edited */
  editedAt: Scalars['DateTime']['output'];
  /** The actor who edited this content */
  editor?: Maybe<Actor>;
  /** The Node ID of the UserContentEdit object */
  id: Scalars['ID']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
};

/** A list of edits to content. */
export type UserContentEditConnection = {
  __typename?: 'UserContentEditConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserContentEditEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<UserContentEdit>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UserContentEditEdge = {
  __typename?: 'UserContentEditEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<UserContentEdit>;
};

/** Represents a user. */
export type UserEdge = {
  __typename?: 'UserEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<User>;
};

/** Email attributes from External Identity */
export type UserEmailMetadata = {
  __typename?: 'UserEmailMetadata';
  /** Boolean to identify primary emails */
  primary?: Maybe<Scalars['Boolean']['output']>;
  /** Type of email */
  type?: Maybe<Scalars['String']['output']>;
  /** Email id */
  value: Scalars['String']['output'];
};

/** A user-curated list of repositories */
export type UserList = Node & {
  __typename?: 'UserList';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The description of this list */
  description?: Maybe<Scalars['String']['output']>;
  /** The Node ID of the UserList object */
  id: Scalars['ID']['output'];
  /** Whether or not this list is private */
  isPrivate: Scalars['Boolean']['output'];
  /** The items associated with this list */
  items: UserListItemsConnection;
  /** The date and time at which this list was created or last had items added to it */
  lastAddedAt: Scalars['DateTime']['output'];
  /** The name of this list */
  name: Scalars['String']['output'];
  /** The slug of this list */
  slug: Scalars['String']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The user to which this list belongs */
  user: User;
};


/** A user-curated list of repositories */
export type UserListItemsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for UserList. */
export type UserListConnection = {
  __typename?: 'UserListConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserListEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<UserList>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UserListEdge = {
  __typename?: 'UserListEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<UserList>;
};

/** Types that can be added to a user list. */
export type UserListItems = Repository;

/** The connection type for UserListItems. */
export type UserListItemsConnection = {
  __typename?: 'UserListItemsConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserListItemsEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<UserListItems>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UserListItemsEdge = {
  __typename?: 'UserListItemsEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<UserListItems>;
};

/** Represents a suggested user list. */
export type UserListSuggestion = {
  __typename?: 'UserListSuggestion';
  /** The ID of the suggested user list */
  id?: Maybe<Scalars['ID']['output']>;
  /** The name of the suggested user list */
  name?: Maybe<Scalars['String']['output']>;
};

/** A repository owned by an Enterprise Managed user. */
export type UserNamespaceRepository = Node & {
  __typename?: 'UserNamespaceRepository';
  /** The Node ID of the UserNamespaceRepository object */
  id: Scalars['ID']['output'];
  /** The name of the repository. */
  name: Scalars['String']['output'];
  /** The repository's name with owner. */
  nameWithOwner: Scalars['String']['output'];
  /** The user owner of the repository. */
  owner: RepositoryOwner;
};

/** A list of repositories owned by users in an enterprise with Enterprise Managed Users. */
export type UserNamespaceRepositoryConnection = {
  __typename?: 'UserNamespaceRepositoryConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserNamespaceRepositoryEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<UserNamespaceRepository>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UserNamespaceRepositoryEdge = {
  __typename?: 'UserNamespaceRepositoryEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<UserNamespaceRepository>;
};

/** The user's description of what they're currently doing. */
export type UserStatus = Node & {
  __typename?: 'UserStatus';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** An emoji summarizing the user's status. */
  emoji?: Maybe<Scalars['String']['output']>;
  /** The status emoji as HTML. */
  emojiHTML?: Maybe<Scalars['HTML']['output']>;
  /** If set, the status will not be shown after this date. */
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  /** The Node ID of the UserStatus object */
  id: Scalars['ID']['output'];
  /** Whether this status indicates the user is not fully available on GitHub. */
  indicatesLimitedAvailability: Scalars['Boolean']['output'];
  /** A brief message describing what the user is doing. */
  message?: Maybe<Scalars['String']['output']>;
  /** The organization whose members can see this status. If null, this status is publicly visible. */
  organization?: Maybe<Organization>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The user who has this status. */
  user: User;
};

/** The connection type for UserStatus. */
export type UserStatusConnection = {
  __typename?: 'UserStatusConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<UserStatusEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<UserStatus>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type UserStatusEdge = {
  __typename?: 'UserStatusEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<UserStatus>;
};

/** Ordering options for user status connections. */
export type UserStatusOrder = {
  /** The ordering direction. */
  direction: OrderDirection;
  /** The field to order user statuses by. */
  field: UserStatusOrderField;
};

/** Properties by which user status connections can be ordered. */
export enum UserStatusOrderField {
  /** Order user statuses by when they were updated. */
  UpdatedAt = 'UPDATED_AT'
}

/** Whether a user being viewed contains public or private information. */
export enum UserViewType {
  /** A user containing information only visible to the authenticated user. */
  Private = 'PRIVATE',
  /** A user that is publicly visible. */
  Public = 'PUBLIC'
}

/** A domain that can be verified or approved for an organization or an enterprise. */
export type VerifiableDomain = Node & {
  __typename?: 'VerifiableDomain';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Identifies the primary key from the database. */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** The DNS host name that should be used for verification. */
  dnsHostName?: Maybe<Scalars['URI']['output']>;
  /** The unicode encoded domain. */
  domain: Scalars['URI']['output'];
  /** Whether a TXT record for verification with the expected host name was found. */
  hasFoundHostName: Scalars['Boolean']['output'];
  /** Whether a TXT record for verification with the expected verification token was found. */
  hasFoundVerificationToken: Scalars['Boolean']['output'];
  /** The Node ID of the VerifiableDomain object */
  id: Scalars['ID']['output'];
  /** Whether or not the domain is approved. */
  isApproved: Scalars['Boolean']['output'];
  /** Whether this domain is required to exist for an organization or enterprise policy to be enforced. */
  isRequiredForPolicyEnforcement: Scalars['Boolean']['output'];
  /** Whether or not the domain is verified. */
  isVerified: Scalars['Boolean']['output'];
  /** The owner of the domain. */
  owner: VerifiableDomainOwner;
  /** The punycode encoded domain. */
  punycodeEncodedDomain: Scalars['URI']['output'];
  /** The time that the current verification token will expire. */
  tokenExpirationTime?: Maybe<Scalars['DateTime']['output']>;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The current verification token for the domain. */
  verificationToken?: Maybe<Scalars['String']['output']>;
};

/** The connection type for VerifiableDomain. */
export type VerifiableDomainConnection = {
  __typename?: 'VerifiableDomainConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<VerifiableDomainEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<VerifiableDomain>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type VerifiableDomainEdge = {
  __typename?: 'VerifiableDomainEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<VerifiableDomain>;
};

/** Ordering options for verifiable domain connections. */
export type VerifiableDomainOrder = {
  /** The ordering direction. */
  direction: OrderDirection;
  /** The field to order verifiable domains by. */
  field: VerifiableDomainOrderField;
};

/** Properties by which verifiable domain connections can be ordered. */
export enum VerifiableDomainOrderField {
  /** Order verifiable domains by their creation date. */
  CreatedAt = 'CREATED_AT',
  /** Order verifiable domains by the domain name. */
  Domain = 'DOMAIN'
}

/** Types that can own a verifiable domain. */
export type VerifiableDomainOwner = Enterprise | Organization;

/** Autogenerated input type of VerifyVerifiableDomain */
export type VerifyVerifiableDomainInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the verifiable domain to verify. */
  id: Scalars['ID']['input'];
};

/** Autogenerated return type of VerifyVerifiableDomain. */
export type VerifyVerifiableDomainPayload = {
  __typename?: 'VerifyVerifiableDomainPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']['output']>;
  /** The verifiable domain that was verified. */
  domain?: Maybe<VerifiableDomain>;
};

/** A hovercard context with a message describing how the viewer is related. */
export type ViewerHovercardContext = HovercardContext & {
  __typename?: 'ViewerHovercardContext';
  /** A string describing this context */
  message: Scalars['String']['output'];
  /** An octicon to accompany this context */
  octicon: Scalars['String']['output'];
  /** Identifies the user who is related to this context. */
  viewer: User;
};

/** A subject that may be upvoted. */
export type Votable = {
  /** Number of upvotes that this subject has received. */
  upvoteCount: Scalars['Int']['output'];
  /** Whether or not the current user can add or remove an upvote on this subject. */
  viewerCanUpvote: Scalars['Boolean']['output'];
  /** Whether or not the current user has already upvoted this subject. */
  viewerHasUpvoted: Scalars['Boolean']['output'];
};

/** A workflow contains meta information about an Actions workflow file. */
export type Workflow = Node & UniformResourceLocatable & {
  __typename?: 'Workflow';
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Identifies the primary key from the database. */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** The Node ID of the Workflow object */
  id: Scalars['ID']['output'];
  /** The name of the workflow. */
  name: Scalars['String']['output'];
  /** The HTTP path for this workflow */
  resourcePath: Scalars['URI']['output'];
  /** The runs of the workflow. */
  runs: WorkflowRunConnection;
  /** The state of the workflow. */
  state: WorkflowState;
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The HTTP URL for this workflow */
  url: Scalars['URI']['output'];
};


/** A workflow contains meta information about an Actions workflow file. */
export type WorkflowRunsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<WorkflowRunOrder>;
};

/** A workflow that must run for this rule to pass */
export type WorkflowFileReference = {
  __typename?: 'WorkflowFileReference';
  /** The path to the workflow file */
  path: Scalars['String']['output'];
  /** The ref (branch or tag) of the workflow file to use */
  ref?: Maybe<Scalars['String']['output']>;
  /** The ID of the repository where the workflow is defined */
  repositoryId: Scalars['Int']['output'];
  /** The commit SHA of the workflow file to use */
  sha?: Maybe<Scalars['String']['output']>;
};

/** A workflow that must run for this rule to pass */
export type WorkflowFileReferenceInput = {
  /** The path to the workflow file */
  path: Scalars['String']['input'];
  /** The ref (branch or tag) of the workflow file to use */
  ref?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the repository where the workflow is defined */
  repositoryId: Scalars['Int']['input'];
  /** The commit SHA of the workflow file to use */
  sha?: InputMaybe<Scalars['String']['input']>;
};

/** A workflow run. */
export type WorkflowRun = Node & UniformResourceLocatable & {
  __typename?: 'WorkflowRun';
  /** The check suite this workflow run belongs to. */
  checkSuite: CheckSuite;
  /** Identifies the date and time when the object was created. */
  createdAt: Scalars['DateTime']['output'];
  /** Identifies the primary key from the database. */
  databaseId?: Maybe<Scalars['Int']['output']>;
  /** The log of deployment reviews */
  deploymentReviews: DeploymentReviewConnection;
  /** The human-readable title of the workflow run. */
  displayTitle?: Maybe<Scalars['String']['output']>;
  /** The event that triggered the workflow run */
  event: Scalars['String']['output'];
  /** The workflow file */
  file?: Maybe<WorkflowRunFile>;
  /** The Node ID of the WorkflowRun object */
  id: Scalars['ID']['output'];
  /** The pending deployment requests of all check runs in this workflow run */
  pendingDeploymentRequests: DeploymentRequestConnection;
  /** The HTTP path for this workflow run */
  resourcePath: Scalars['URI']['output'];
  /** The attempt number of this workflow run. */
  runAttempt: Scalars['Int']['output'];
  /** A number that uniquely identifies this workflow run in its parent workflow. */
  runNumber: Scalars['Int']['output'];
  /** Identifies the date and time when the object was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The HTTP URL for this workflow run */
  url: Scalars['URI']['output'];
  /** The workflow executed in this workflow run. */
  workflow: Workflow;
};


/** A workflow run. */
export type WorkflowRunDeploymentReviewsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** A workflow run. */
export type WorkflowRunPendingDeploymentRequestsArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** The connection type for WorkflowRun. */
export type WorkflowRunConnection = {
  __typename?: 'WorkflowRunConnection';
  /** A list of edges. */
  edges?: Maybe<Array<Maybe<WorkflowRunEdge>>>;
  /** A list of nodes. */
  nodes?: Maybe<Array<Maybe<WorkflowRun>>>;
  /** Information to aid in pagination. */
  pageInfo: PageInfo;
  /** Identifies the total count of items in the connection. */
  totalCount: Scalars['Int']['output'];
};

/** An edge in a connection. */
export type WorkflowRunEdge = {
  __typename?: 'WorkflowRunEdge';
  /** A cursor for use in pagination. */
  cursor: Scalars['String']['output'];
  /** The item at the end of the edge. */
  node?: Maybe<WorkflowRun>;
};

/** An executed workflow file for a workflow run. */
export type WorkflowRunFile = Node & UniformResourceLocatable & {
  __typename?: 'WorkflowRunFile';
  /** The Node ID of the WorkflowRunFile object */
  id: Scalars['ID']['output'];
  /** The path of the workflow file relative to its repository. */
  path: Scalars['String']['output'];
  /** The direct link to the file in the repository which stores the workflow file. */
  repositoryFileUrl: Scalars['URI']['output'];
  /** The repository name and owner which stores the workflow file. */
  repositoryName: Scalars['URI']['output'];
  /** The HTTP path for this workflow run file */
  resourcePath: Scalars['URI']['output'];
  /** The parent workflow run execution for this file. */
  run: WorkflowRun;
  /** The HTTP URL for this workflow run file */
  url: Scalars['URI']['output'];
  /** If the viewer has permissions to push to the repository which stores the workflow. */
  viewerCanPushRepository: Scalars['Boolean']['output'];
  /** If the viewer has permissions to read the repository which stores the workflow. */
  viewerCanReadRepository: Scalars['Boolean']['output'];
};

/** Ways in which lists of workflow runs can be ordered upon return. */
export type WorkflowRunOrder = {
  /** The direction in which to order workflow runs by the specified field. */
  direction: OrderDirection;
  /** The field by which to order workflows. */
  field: WorkflowRunOrderField;
};

/** Properties by which workflow run connections can be ordered. */
export enum WorkflowRunOrderField {
  /** Order workflow runs by most recently created */
  CreatedAt = 'CREATED_AT'
}

/** The possible states for a workflow. */
export enum WorkflowState {
  /** The workflow is active. */
  Active = 'ACTIVE',
  /** The workflow was deleted from the git repository. */
  Deleted = 'DELETED',
  /** The workflow was disabled by default on a fork. */
  DisabledFork = 'DISABLED_FORK',
  /** The workflow was disabled for inactivity in the repository. */
  DisabledInactivity = 'DISABLED_INACTIVITY',
  /** The workflow was disabled manually. */
  DisabledManually = 'DISABLED_MANUALLY'
}

/** Require all changes made to a targeted branch to pass the specified workflows before they can be merged. */
export type WorkflowsParameters = {
  __typename?: 'WorkflowsParameters';
  /** Allow repositories and branches to be created if a check would otherwise prohibit it. */
  doNotEnforceOnCreate: Scalars['Boolean']['output'];
  /** Workflows that must pass for this rule to pass. */
  workflows: Array<WorkflowFileReference>;
};

/** Require all changes made to a targeted branch to pass the specified workflows before they can be merged. */
export type WorkflowsParametersInput = {
  /** Allow repositories and branches to be created if a check would otherwise prohibit it. */
  doNotEnforceOnCreate?: InputMaybe<Scalars['Boolean']['input']>;
  /** Workflows that must pass for this rule to pass. */
  workflows: Array<WorkflowFileReferenceInput>;
};

export type GetBasicRepositoryQueryVariables = Exact<{
  owner: Scalars['String']['input'];
  repo: Scalars['String']['input'];
}>;


export type GetBasicRepositoryQuery = { __typename?: 'Query', repositoryOwner?: { __typename?: 'Organization', repository?: { __typename?: 'Repository', nameWithOwner: string, url: string } | null } | { __typename?: 'User', repository?: { __typename?: 'Repository', nameWithOwner: string, url: string } | null } | null };

export type GetRepositoryActionsQueryVariables = Exact<{
  owner: Scalars['String']['input'];
  repo: Scalars['String']['input'];
}>;


export type GetRepositoryActionsQuery = { __typename?: 'Query', repository?: { __typename?: 'Repository', pullRequests: { __typename?: 'PullRequestConnection', edges?: Array<{ __typename?: 'PullRequestEdge', node?: { __typename?: 'PullRequest', title: string, url: string, commits: { __typename?: 'PullRequestCommitConnection', edges?: Array<{ __typename?: 'PullRequestCommitEdge', node?: { __typename?: 'PullRequestCommit', commit: { __typename?: 'Commit', status?: { __typename?: 'Status', id: string } | null, statusCheckRollup?: { __typename?: 'StatusCheckRollup', id: string } | null, checkSuites?: { __typename?: 'CheckSuiteConnection', nodes?: Array<{ __typename?: 'CheckSuite', id: string, checkRuns?: { __typename?: 'CheckRunConnection', nodes?: Array<{ __typename?: 'CheckRun', name: string, status: CheckStatusState } | null> | null } | null, app?: { __typename?: 'App', name: string } | null, workflowRun?: { __typename?: 'WorkflowRun', url: string, workflow: { __typename?: 'Workflow', name: string } } | null } | null> | null } | null } } | null } | null> | null } } | null } | null> | null } } | null };

export type GetUserRepoBranchesQueryVariables = Exact<{
  owner: Scalars['String']['input'];
  repo: Scalars['String']['input'];
}>;


export type GetUserRepoBranchesQuery = { __typename?: 'Query', user?: { __typename?: 'User', login: string, url: string, repository?: { __typename?: 'Repository', name: string, owner: { __typename?: 'Organization', login: string } | { __typename?: 'User', login: string }, defaultBranchRef?: { __typename?: 'Ref', name: string } | null, refs?: { __typename?: 'RefConnection', nodes?: Array<{ __typename?: 'Ref', name: string, associatedPullRequests: { __typename?: 'PullRequestConnection', totalCount: number } } | null> | null } | null } | null } | null };

export type GetUserRepoPullRequestsQueryVariables = Exact<{
  owner: Scalars['String']['input'];
  repo: Scalars['String']['input'];
  order: IssueOrder;
}>;


export type GetUserRepoPullRequestsQuery = { __typename?: 'Query', user?: { __typename?: 'User', login: string, url: string, repository?: { __typename?: 'Repository', name: string, owner: { __typename?: 'Organization', login: string } | { __typename?: 'User', login: string }, parent?: { __typename?: 'Repository', name: string, nameWithOwner: string, owner: { __typename?: 'Organization', login: string } | { __typename?: 'User', login: string } } | null, defaultBranchRef?: { __typename?: 'Ref', name: string } | null, pullRequests: { __typename?: 'PullRequestConnection', nodes?: Array<{ __typename?: 'PullRequest', number: number, resourcePath: string, permalink: string, title: string, body: string, headRef?: { __typename?: 'Ref', name: string, associatedPullRequests: { __typename?: 'PullRequestConnection', nodes?: Array<{ __typename?: 'PullRequest', permalink: string, baseRepository?: { __typename?: 'Repository', nameWithOwner: string } | null } | null> | null } } | null } | null> | null } } | null } | null };

export type PullRequestsFragment = { __typename?: 'Repository', pullRequest?: { __typename?: 'PullRequest', title: string, state: PullRequestState, permalink: string, commits: { __typename?: 'PullRequestCommitConnection', nodes?: Array<{ __typename?: 'PullRequestCommit', commit: { __typename?: 'Commit', checkSuites?: { __typename?: 'CheckSuiteConnection', nodes?: Array<{ __typename?: 'CheckSuite', conclusion?: CheckConclusionState | null, app?: { __typename?: 'App', name: string } | null, workflowRun?: { __typename?: 'WorkflowRun', workflow: { __typename?: 'Workflow', name: string } } | null, checkRuns?: { __typename?: 'CheckRunConnection', nodes?: Array<{ __typename?: 'CheckRun', name: string, conclusion?: CheckConclusionState | null, startedAt?: string | null, completedAt?: string | null, permalink: string, status: CheckStatusState, checkSuite: { __typename?: 'CheckSuite', workflowRun?: { __typename?: 'WorkflowRun', databaseId?: number | null } | null }, repository: { __typename?: 'Repository', nameWithOwner: string } } | null> | null } | null } | null> | null } | null } } | null> | null } } | null } & { ' $fragmentName'?: 'PullRequestsFragment' };

export type GetActionsForPullRequestQueryVariables = Exact<{
  owner: Scalars['String']['input'];
  repo: Scalars['String']['input'];
  prNumber: Scalars['Int']['input'];
}>;


export type GetActionsForPullRequestQuery = { __typename?: 'Query', repositoryOwner?: { __typename?: 'Organization', repository?: (
      { __typename?: 'Repository' }
      & { ' $fragmentRefs'?: { 'PullRequestsFragment': PullRequestsFragment } }
    ) | null } | { __typename?: 'User', repository?: (
      { __typename?: 'Repository' }
      & { ' $fragmentRefs'?: { 'PullRequestsFragment': PullRequestsFragment } }
    ) | null } | null };

export type PrDetailsFragment = { __typename?: 'PullRequest', title: string, number: number, mergeable: MergeableState, mergeStateStatus: MergeStateStatus, repository: { __typename?: 'Repository', nameWithOwner: string } } & { ' $fragmentName'?: 'PrDetailsFragment' };

export type StatusCheckRollupFragment = { __typename?: 'PullRequest', statusCheckRollup: { __typename?: 'PullRequestCommitConnection', nodes?: Array<{ __typename?: 'PullRequestCommit', commit: { __typename?: 'Commit', statusCheckRollup?: { __typename?: 'StatusCheckRollup', contexts: { __typename?: 'StatusCheckRollupContextConnection', nodes?: Array<{ __typename: 'CheckRun', name: string, status: CheckStatusState, conclusion?: CheckConclusionState | null, startedAt?: string | null, completedAt?: string | null, detailsUrl?: string | null, checkSuite: { __typename?: 'CheckSuite', workflowRun?: { __typename?: 'WorkflowRun', workflow: { __typename?: 'Workflow', name: string } } | null } } | { __typename: 'StatusContext', state: StatusState } | null> | null } } | null } } | null> | null } } & { ' $fragmentName'?: 'StatusCheckRollupFragment' };

export type PullRequestStatusQueryVariables = Exact<{
  owner: Scalars['String']['input'];
  repo: Scalars['String']['input'];
  per_page?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PullRequestStatusQuery = { __typename?: 'Query', repository?: { __typename?: 'Repository', name: string, url: string, parent?: { __typename?: 'Repository', name: string } | null, pullRequests: { __typename?: 'PullRequestConnection', totalCount: number, edges?: Array<{ __typename?: 'PullRequestEdge', node?: (
          { __typename?: 'PullRequest', url: string, isDraft: boolean, isCrossRepository: boolean, headRefName: string, resourcePath: string, author?: { __typename?: 'Bot', login: string, url: string } | { __typename?: 'EnterpriseUserAccount', login: string, url: string } | { __typename?: 'Mannequin', login: string, url: string } | { __typename?: 'Organization', login: string, url: string } | { __typename?: 'User', login: string, url: string } | null, headRepositoryOwner?: { __typename?: 'Organization', id: string, login: string } | { __typename?: 'User', name?: string | null, id: string, login: string } | null }
          & { ' $fragmentRefs'?: { 'PrDetailsFragment': PrDetailsFragment;'StatusCheckRollupFragment': StatusCheckRollupFragment } }
        ) | null } | null> | null } } | null };

export type GetUserPullRequestsQueryVariables = Exact<{
  owner: Scalars['String']['input'];
  order: IssueOrder;
}>;


export type GetUserPullRequestsQuery = { __typename?: 'Query', user?: { __typename?: 'User', login: string, url: string, pullRequests: { __typename?: 'PullRequestConnection', edges?: Array<{ __typename?: 'PullRequestEdge', node?: (
          { __typename?: 'PullRequest', url: string }
          & { ' $fragmentRefs'?: { 'StatusCheckRollupFragment': StatusCheckRollupFragment;'PrDetailsFragment': PrDetailsFragment } }
        ) | null } | null> | null } } | null };

type Repos_Organization_Fragment = { __typename?: 'Organization', login: string, avatarUrl: string, repositories: { __typename?: 'RepositoryConnection', nodes?: Array<{ __typename?: 'Repository', name: string } | null> | null } } & { ' $fragmentName'?: 'Repos_Organization_Fragment' };

type Repos_User_Fragment = { __typename?: 'User', login: string, avatarUrl: string, repositories: { __typename?: 'RepositoryConnection', nodes?: Array<{ __typename?: 'Repository', name: string } | null> | null } } & { ' $fragmentName'?: 'Repos_User_Fragment' };

export type ReposFragment = Repos_Organization_Fragment | Repos_User_Fragment;

export type GetAllReposQueryVariables = Exact<{
  orderBy: RepositoryOrder;
}>;


export type GetAllReposQuery = { __typename?: 'Query', viewer: (
    { __typename?: 'User' }
    & { ' $fragmentRefs'?: { 'Repos_User_Fragment': Repos_User_Fragment } }
  ), duckdb?: (
    { __typename?: 'Organization' }
    & { ' $fragmentRefs'?: { 'Repos_Organization_Fragment': Repos_Organization_Fragment } }
  ) | (
    { __typename?: 'User' }
    & { ' $fragmentRefs'?: { 'Repos_User_Fragment': Repos_User_Fragment } }
  ) | null, duckdblabs?: (
    { __typename?: 'Organization' }
    & { ' $fragmentRefs'?: { 'Repos_Organization_Fragment': Repos_Organization_Fragment } }
  ) | (
    { __typename?: 'User' }
    & { ' $fragmentRefs'?: { 'Repos_User_Fragment': Repos_User_Fragment } }
  ) | null };

export type IssueOverviewFragment = { __typename: 'Issue', id: string, number: number, title: string, url: string, updatedAt: string, repository: { __typename?: 'Repository', nameWithOwner: string, url: string } } & { ' $fragmentName'?: 'IssueOverviewFragment' };

export type GetOverviewThingsFragment = { __typename?: 'Repository', issues: { __typename?: 'IssueConnection', nodes?: Array<(
      { __typename?: 'Issue' }
      & { ' $fragmentRefs'?: { 'IssueOverviewFragment': IssueOverviewFragment } }
    ) | null> | null }, pullRequests: { __typename?: 'PullRequestConnection', nodes?: Array<{ __typename: 'PullRequest', id: string, number: number, title: string, url: string, updatedAt: string, repository: { __typename?: 'Repository', nameWithOwner: string, url: string } } | null> | null } } & { ' $fragmentName'?: 'GetOverviewThingsFragment' };

export type GetIssuesAndPullRequestsQueryVariables = Exact<{
  searchQuery: Scalars['String']['input'];
  order: IssueOrder;
}>;


export type GetIssuesAndPullRequestsQuery = { __typename?: 'Query', search: { __typename: 'SearchResultItemConnection', issueCount: number, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, endCursor?: string | null }, edges?: Array<{ __typename?: 'SearchResultItemEdge', node?: { __typename: 'App' } | { __typename: 'Discussion' } | (
        { __typename: 'Issue' }
        & { ' $fragmentRefs'?: { 'IssueOverviewFragment': IssueOverviewFragment } }
      ) | { __typename: 'MarketplaceListing' } | { __typename: 'Organization' } | { __typename: 'PullRequest' } | { __typename: 'Repository' } | { __typename: 'User' } | null } | null> | null }, java?: (
    { __typename: 'Repository' }
    & { ' $fragmentRefs'?: { 'GetOverviewThingsFragment': GetOverviewThingsFragment } }
  ) | null, nodejs?: (
    { __typename: 'Repository' }
    & { ' $fragmentRefs'?: { 'GetOverviewThingsFragment': GetOverviewThingsFragment } }
  ) | null, rust?: (
    { __typename: 'Repository' }
    & { ' $fragmentRefs'?: { 'GetOverviewThingsFragment': GetOverviewThingsFragment } }
  ) | null, engine?: (
    { __typename: 'Repository' }
    & { ' $fragmentRefs'?: { 'GetOverviewThingsFragment': GetOverviewThingsFragment } }
  ) | null };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: DocumentTypeDecoration<TResult, TVariables>['__apiType'];

  constructor(private value: string, public __meta__?: Record<string, any> | undefined) {
    super(value);
  }

  toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}
export const PullRequestsFragmentDoc = new TypedDocumentString(`
    fragment PullRequests on Repository {
  pullRequest(number: $prNumber) {
    title
    state
    permalink
    commits(last: 1) {
      nodes {
        commit {
          checkSuites(first: 100) {
            nodes {
              app {
                name
              }
              workflowRun {
                workflow {
                  name
                }
              }
              conclusion
              checkRuns(first: 100) {
                nodes {
                  checkSuite {
                    workflowRun {
                      databaseId
                    }
                  }
                  name
                  conclusion
                  startedAt
                  completedAt
                  permalink
                  repository {
                    nameWithOwner
                  }
                  status
                }
              }
            }
          }
        }
      }
    }
  }
}
    `, {"fragmentName":"PullRequests"}) as unknown as TypedDocumentString<PullRequestsFragment, unknown>;
export const PrDetailsFragmentDoc = new TypedDocumentString(`
    fragment PrDetails on PullRequest {
  title
  number
  repository {
    nameWithOwner
  }
  mergeable
  mergeStateStatus
}
    `, {"fragmentName":"PrDetails"}) as unknown as TypedDocumentString<PrDetailsFragment, unknown>;
export const StatusCheckRollupFragmentDoc = new TypedDocumentString(`
    fragment StatusCheckRollup on PullRequest {
  statusCheckRollup: commits(last: 1) {
    nodes {
      commit {
        statusCheckRollup {
          contexts(first: 100) {
            nodes {
              __typename
              ... on StatusContext {
                state
              }
              ... on CheckRun {
                name
                checkSuite {
                  workflowRun {
                    workflow {
                      name
                    }
                  }
                }
                status
                conclusion
                startedAt
                completedAt
                detailsUrl
              }
            }
          }
        }
      }
    }
  }
}
    `, {"fragmentName":"StatusCheckRollup"}) as unknown as TypedDocumentString<StatusCheckRollupFragment, unknown>;
export const ReposFragmentDoc = new TypedDocumentString(`
    fragment Repos on RepositoryOwner {
  login
  avatarUrl
  repositories(first: 15, orderBy: $orderBy) {
    nodes {
      name
    }
  }
}
    `, {"fragmentName":"Repos"}) as unknown as TypedDocumentString<ReposFragment, unknown>;
export const IssueOverviewFragmentDoc = new TypedDocumentString(`
    fragment IssueOverview on Issue {
  __typename
  id
  number
  title
  url
  updatedAt
  repository {
    nameWithOwner
    url
  }
}
    `, {"fragmentName":"IssueOverview"}) as unknown as TypedDocumentString<IssueOverviewFragment, unknown>;
export const GetOverviewThingsFragmentDoc = new TypedDocumentString(`
    fragment GetOverviewThings on Repository {
  issues(states: [OPEN], first: 10, orderBy: $order) {
    nodes {
      ...IssueOverview
    }
  }
  pullRequests(states: [OPEN], first: 10, orderBy: $order) {
    nodes {
      __typename
      id
      number
      title
      url
      updatedAt
      repository {
        nameWithOwner
        url
      }
    }
  }
}
    fragment IssueOverview on Issue {
  __typename
  id
  number
  title
  url
  updatedAt
  repository {
    nameWithOwner
    url
  }
}`, {"fragmentName":"GetOverviewThings"}) as unknown as TypedDocumentString<GetOverviewThingsFragment, unknown>;
export const GetBasicRepositoryDocument = new TypedDocumentString(`
    query GetBasicRepository($owner: String!, $repo: String!) {
  repositoryOwner(login: $owner) {
    repository(name: $repo) {
      nameWithOwner
      url
    }
  }
}
    `) as unknown as TypedDocumentString<GetBasicRepositoryQuery, GetBasicRepositoryQueryVariables>;
export const GetRepositoryActionsDocument = new TypedDocumentString(`
    query GetRepositoryActions($owner: String!, $repo: String!) {
  repository(owner: $owner, name: $repo) {
    pullRequests(
      first: 10
      states: OPEN
      orderBy: {field: UPDATED_AT, direction: DESC}
    ) {
      edges {
        node {
          title
          url
          commits(last: 5) {
            edges {
              node {
                commit {
                  status {
                    id
                  }
                  statusCheckRollup {
                    id
                  }
                  checkSuites(first: 5) {
                    nodes {
                      id
                      checkRuns(first: 5) {
                        nodes {
                          name
                          status
                        }
                      }
                      app {
                        name
                      }
                      workflowRun {
                        url
                        workflow {
                          name
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetRepositoryActionsQuery, GetRepositoryActionsQueryVariables>;
export const GetUserRepoBranchesDocument = new TypedDocumentString(`
    query GetUserRepoBranches($owner: String!, $repo: String!) {
  user(login: $owner) {
    login
    url
    repository(name: $repo) {
      name
      owner {
        login
      }
      defaultBranchRef {
        name
      }
      refs(refPrefix: "refs/heads/", first: 100) {
        nodes {
          name
          associatedPullRequests(states: OPEN) {
            totalCount
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetUserRepoBranchesQuery, GetUserRepoBranchesQueryVariables>;
export const GetUserRepoPullRequestsDocument = new TypedDocumentString(`
    query GetUserRepoPullRequests($owner: String!, $repo: String!, $order: IssueOrder!) {
  user(login: $owner) {
    login
    url
    repository(name: $repo) {
      name
      owner {
        login
      }
      parent {
        name
        owner {
          login
        }
        nameWithOwner
      }
      defaultBranchRef {
        name
      }
      pullRequests(first: 50, orderBy: $order, states: OPEN) {
        nodes {
          number
          resourcePath
          permalink
          title
          body
          headRef {
            name
            associatedPullRequests(first: 5, states: OPEN) {
              nodes {
                baseRepository {
                  nameWithOwner
                }
                permalink
              }
            }
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<GetUserRepoPullRequestsQuery, GetUserRepoPullRequestsQueryVariables>;
export const GetActionsForPullRequestDocument = new TypedDocumentString(`
    query GetActionsForPullRequest($owner: String!, $repo: String!, $prNumber: Int!) {
  repositoryOwner(login: $owner) {
    repository(name: $repo) {
      ...PullRequests
    }
  }
}
    fragment PullRequests on Repository {
  pullRequest(number: $prNumber) {
    title
    state
    permalink
    commits(last: 1) {
      nodes {
        commit {
          checkSuites(first: 100) {
            nodes {
              app {
                name
              }
              workflowRun {
                workflow {
                  name
                }
              }
              conclusion
              checkRuns(first: 100) {
                nodes {
                  checkSuite {
                    workflowRun {
                      databaseId
                    }
                  }
                  name
                  conclusion
                  startedAt
                  completedAt
                  permalink
                  repository {
                    nameWithOwner
                  }
                  status
                }
              }
            }
          }
        }
      }
    }
  }
}`) as unknown as TypedDocumentString<GetActionsForPullRequestQuery, GetActionsForPullRequestQueryVariables>;
export const PullRequestStatusDocument = new TypedDocumentString(`
    query PullRequestStatus($owner: String!, $repo: String!, $per_page: Int = 100) {
  repository(owner: $owner, name: $repo) {
    name
    url
    parent {
      name
    }
    pullRequests(
      first: $per_page
      orderBy: {field: CREATED_AT, direction: DESC}
      states: OPEN
    ) {
      totalCount
      edges {
        node {
          url
          isDraft
          isCrossRepository
          headRefName
          resourcePath
          ...PrDetails
          author {
            login
            url
          }
          headRepositoryOwner {
            id
            login
            ... on User {
              name
            }
          }
          ...StatusCheckRollup
        }
      }
    }
  }
}
    fragment PrDetails on PullRequest {
  title
  number
  repository {
    nameWithOwner
  }
  mergeable
  mergeStateStatus
}
fragment StatusCheckRollup on PullRequest {
  statusCheckRollup: commits(last: 1) {
    nodes {
      commit {
        statusCheckRollup {
          contexts(first: 100) {
            nodes {
              __typename
              ... on StatusContext {
                state
              }
              ... on CheckRun {
                name
                checkSuite {
                  workflowRun {
                    workflow {
                      name
                    }
                  }
                }
                status
                conclusion
                startedAt
                completedAt
                detailsUrl
              }
            }
          }
        }
      }
    }
  }
}`) as unknown as TypedDocumentString<PullRequestStatusQuery, PullRequestStatusQueryVariables>;
export const GetUserPullRequestsDocument = new TypedDocumentString(`
    query GetUserPullRequests($owner: String!, $order: IssueOrder!) {
  user(login: $owner) {
    login
    url
    pullRequests(first: 10, orderBy: $order, states: OPEN) {
      edges {
        node {
          url
          ...StatusCheckRollup
          ...PrDetails
        }
      }
    }
  }
}
    fragment PrDetails on PullRequest {
  title
  number
  repository {
    nameWithOwner
  }
  mergeable
  mergeStateStatus
}
fragment StatusCheckRollup on PullRequest {
  statusCheckRollup: commits(last: 1) {
    nodes {
      commit {
        statusCheckRollup {
          contexts(first: 100) {
            nodes {
              __typename
              ... on StatusContext {
                state
              }
              ... on CheckRun {
                name
                checkSuite {
                  workflowRun {
                    workflow {
                      name
                    }
                  }
                }
                status
                conclusion
                startedAt
                completedAt
                detailsUrl
              }
            }
          }
        }
      }
    }
  }
}`) as unknown as TypedDocumentString<GetUserPullRequestsQuery, GetUserPullRequestsQueryVariables>;
export const GetAllReposDocument = new TypedDocumentString(`
    query GetAllRepos($orderBy: RepositoryOrder!) {
  viewer {
    ...Repos
  }
  duckdb: repositoryOwner(login: "duckdb") {
    ...Repos
  }
  duckdblabs: repositoryOwner(login: "duckdblabs") {
    ...Repos
  }
}
    fragment Repos on RepositoryOwner {
  login
  avatarUrl
  repositories(first: 15, orderBy: $orderBy) {
    nodes {
      name
    }
  }
}`) as unknown as TypedDocumentString<GetAllReposQuery, GetAllReposQueryVariables>;
export const GetIssuesAndPullRequestsDocument = new TypedDocumentString(`
    query GetIssuesAndPullRequests($searchQuery: String!, $order: IssueOrder!) {
  search(first: 100, type: ISSUE, query: $searchQuery) {
    __typename
    issueCount
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        __typename
        ...IssueOverview
      }
    }
  }
  java: repository(owner: "duckdb", name: "duckdb-java") {
    __typename
    ...GetOverviewThings
  }
  nodejs: repository(owner: "duckdb", name: "duckdb-node") {
    __typename
    ...GetOverviewThings
  }
  rust: repository(owner: "duckdb", name: "duckdb-rs") {
    __typename
    ...GetOverviewThings
  }
  engine: repository(owner: "Mause", name: "duckdb_engine") {
    __typename
    ...GetOverviewThings
  }
}
    fragment IssueOverview on Issue {
  __typename
  id
  number
  title
  url
  updatedAt
  repository {
    nameWithOwner
    url
  }
}
fragment GetOverviewThings on Repository {
  issues(states: [OPEN], first: 10, orderBy: $order) {
    nodes {
      ...IssueOverview
    }
  }
  pullRequests(states: [OPEN], first: 10, orderBy: $order) {
    nodes {
      __typename
      id
      number
      title
      url
      updatedAt
      repository {
        nameWithOwner
        url
      }
    }
  }
}`) as unknown as TypedDocumentString<GetIssuesAndPullRequestsQuery, GetIssuesAndPullRequestsQueryVariables>;